'use strict';

(function(window, document) {

    window.lmsAppPreload = appPreload;
    window.initHashString = initHashString;

    function appPreload() {
        // Fix window.location.origin for old IE
        // alert('j')
        var a = document.cookie
        // var a = "NG_TRANSLATE_LANG_KEY=ru; LMS_AUTH=e.mendeleeva%3A1629318974876%3Aa6aa2c14a1855bb18be94fa83bdf255d91b90c1de7e23c3610e79e30ac7623fc%3Afalse"
        var b = a.indexOf('LMS_AUTH')
        if(b>-1){
            var c = a.indexOf(';',b)
            var token
            console.log(c)
            function generateTokenForLocalStorage(tokenFromCookie) {
                var temp = "{\"token\""+":" + tokenFromCookie + ",\"expires\":0}"
                return temp
            }
            if (c>0){
                token = a.substring(b+9,c)
            } else {
                token = a.substr(b+9)
            }
            var s = token
            s = s.replaceAll('%3A',':')
            console.log(s)
            var q = {
                token: s,
                expires: 0
            }
            q = JSON.stringify(q)

            localStorage.setItem('ls.token',q)
        } else {
            console.log('no auth')
        }

        // s = JSON.stringify(s)

        // var aw = cookies.get('NG_TRANSLATE_LANG_KEY')
        // console.log(aw)
        // if (localStorage.getItem('ls.token')){
        //
        // } else {
        //
        //     localStorage.setItem('ls.token',
        //         generateTokenForLocalStorage(token)
        //     )
        // }
        console.log(document.cookie)

        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
        }
    }

    function initHashString() {
        String.prototype.hashCode = function(){
            var i, char, hash = 0;
            if (this.length === 0) return hash;
            for (i = 0; i < this.length; i++) {
                char = this.charCodeAt(i);
                hash = ((hash<<5)-hash)+char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        };
    }
})(window, document);

"use strict";

/**
 *
 * @namespace lmsClientApp
 * @name lmsClientApp
 * @description
 * # lmsClientApp
 *
 * Main module of the application.
 */
window.lmsAppPreload();
window.initHashString();

var app = angular.module('lmsClientApp', [
    'LocalStorageModule',
    'ipCookie',
    'ngSanitize',
    'ui.router',
    'ngResource',
    'ngMaterial',
    'ngMdIcons',
    'ng-token-auth',
    'angularSpinner',
    'uuid',
    'cfp.hotkeys',
    'ngOnload',
    'ncy-angular-breadcrumb',
    'lite.accordion',
    'twygmbh.auto-height',
    'monospaced.elastic',
    'ngFileUpload',
    'materialCalendar',
    'mdPickers',
    'ui.mask',
    'ui.bootstrap',
    'ngScrollbars',
    'angularModalService',
    'rt.debounce',
    'angular-carousel',
    'react'
]);

app.config([
    '$authProvider',
    '$locationProvider',
    '$httpProvider',
    '$resourceProvider',
    '$stateProvider',
    '$urlRouterProvider',
    '$breadcrumbProvider',
    'lmsConfig',
    '$mdDateLocaleProvider',
    function (
        $authProvider,
        $locationProvider,
        $httpProvider,
        $resourceProvider,
        $stateProvider,
        $urlRouterProvider,
        $breadcrumbProvider,
        lmsConfig,
        $mdDateLocaleProvider,
        localStorageService,
        ipCookie
    ) {
        $resourceProvider.defaults.stripTrailingSlashes = false;

        //Enable cross domain calls
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.useXDomain = true;

        $urlRouterProvider.otherwise("/");

        $breadcrumbProvider.setOptions({
            templateUrl: lmsConfig.modulesPath + "course/views/_courseBreadcrumbs.html",
        });

        moment.locale('ru');
        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, 'L', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('L');
        };

        $stateProvider
            .state("site-without-navbar", {
                abstract: true,
            })
            .state("site", {
                abstract: true,
                parent: "site-without-navbar",
                views: {
                    'topbar@': {
                        templateUrl: lmsConfig.modulesPath + 'site/views/_topBar.html',
                        controller: 'TopBarCtrl'
                    },
                    'bottombar@': {
                        templateUrl: lmsConfig.modulesPath + 'site/views/_bottomBar.html',
                        controller: 'BottomBarCtrl'
                    }
                },
                ncyBreadcrumb: {
                    label: "Home page",
                },
                onEnter: function(ipCookie, localStorageService) {
                    localStorageService.remove('token');
                    var authCookie = ipCookie('LMS_AUTH');
                    var lsToken = localStorageService.get('token');
                    if (!!authCookie && !lsToken) {
                        var token = {
                            token: authCookie,
                            expires: 0
                        }
                        localStorageService.set('token', token);
                    }
                }
            })
            .state("404", {
                parent: "site-without-navbar",
                views: {
                    "content@": {
                        templateUrl: lmsConfig.modulesPath + "site/views/404.html",
                        controller: "DefaultCtrl",
                    },
                },
            })
            .state("accessdenied", {
                parent: "site-without-navbar",
                views: {
                    'content@': {
                        templateUrl: lmsConfig.modulesPath +
                            'site/views/403.html',
                        controller: 'DefaultCtrl'
                    }
                }
            });

        $stateProvider.state('login', {
            parent: 'site-without-navbar',
            url: '/login',
            params: {
                oauth: null
            },
            data: {
                roles: [],
                noLogin: true,
            },
            views: {
                'content@': {
                    templateUrl: lmsConfig.modulesPath + 'account/views/login.html',
                    controller: 'LoginCtrl'
                }
            }
        });
        $stateProvider.state('oauth', {
            parent: 'site-without-navbar',
            url: '/oauth?:code&:state&:redirect_url',
            data: {
                roles: [],
                noLogin: true,
            },
            views: {
                'content@': {
                    controller: 'OAuthCtrl'
                }
            }
        });
        $authProvider.configure({
            apiUrl: lmsConfig.apiUrl,
            authDataFormat: {
                token: "token",
                uid: "user_id",
                expiry: "expires",
            },
            authHeadersFormat: {
                token: "x-auth-token",
                uid: "user_id",
            },
            emailSignInPath: "/authenticate",
            handleLoginResponse: function (response) {
                var rocketChatToken = response.rcToken;
                var rocketChatUserid = response.rcUserid;
                // localStorage.setItem("rcToken", rocketChatToken);
                // localStorage.setItem("rcUserId", rocketChatUserid);
                if (rocketChatToken) {
                    localStorage.setItem("Meteor.loginToken:/:/rc-server", rocketChatToken);
                    localStorage.setItem("Meteor.userId:/:/rc-server", rocketChatUserid);
                }
                else {
                    localStorage.removeItem("Meteor.loginToken:/:/rc-server");
                    localStorage.removeItem("Meteor.userId:/:/rc-server");
                }
                return response;
            },
            handleTokenValidationResponse: function (response) {
                return response.data;
            },
            parseExpiry: function (headers) {
                return parseInt(headers.expires, 10) || null;
            },
            parseToken: function (headers) {
                return headers.token || null;
            },
            storage: "localStorage",
            tokenFormat: {
                expires: "{{ expiry }}",
                "x-auth-token": "{{ token }}",
            },
            tokenValidationPath: lmsConfig.versionUrl + "user/validate_token",
        });
    },
]); /**
 *
 * @memberof lmsClientApp
 * @ngdoc config
 * @name $mdThemingProvider
 * @description
 * # $mdThemingProvider
 *
 * Material theme configuration
 */
app.config([
    '$mdThemingProvider',
    function ($mdThemingProvider) {
        $mdThemingProvider
            .theme('default')
            .primaryPalette('blue')
            .accentPalette('green', {
                default: '300'
            });
    }
]);
app.config([
    '$animateProvider',
    function ($animateProvider) {
        $animateProvider.classNameFilter(/^((?!(not-animate)).)*$/);
    },
]);
app.constant("lmsConfig", {
    apiUrl: "/api",
    apiUrlPath: window.location.origin + "/api",
    versionUrl: "/",
    modulesPath: "modules/",
    bowerPath: "../bower_components/",
    coursesPath: "upload/courses/",
    componentsPath: "scripts/components/",
    appPrefix: window.location.origin + "/ui/#",
    mainDomain: window.location.origin,
    rocketChatUrl: "/rc-server",
});
app.constant("lmsEntity", {
    journal: {
        title: "Электронный журнал",
        state: "Journal",
    },
    statistics: {
        title: "Статистика",
        state: "Statistics",
    },
});
app.constant("adaptedProgramList", [
    {
        id: "C_DEFAULT",
        name: "Основная программа",
    },
    {
        id: "C_AQUA",
        name: "Адаптированная программа №1 (для детей с нарушениями речи)",
    },
    {
        id: "C_BLUE",
        name: "Адаптированная программа №2 (для детей с тяжёлыми нарушениями речи)",
    },
    {
        id: "C_YELLOW",
        name: "Адаптированная программа №3 (для детей с задержкой психического развития - темповое временное отставание)",
    },
    {
        id: "C_ORANGE",
        name: "Адаптированная программа №4 (для детей с задержкой психического развития церебрально-органического генеза)",
    },
    {
        id: "C_RED",
        name: "Адаптированная программа №5 (для детей с умственной отсталостью)",
    },
    {
        id: "C_GREEN",
        name: "Адаптированная программа №6 (для детей с нарушениями речи)",
    },
    {
        id: "C_PURPLE",
        name: "Адаптированная программа №7 (для детей с задержкой психического развития)",
    },
    {
        id: "C_GREY",
        name: "Адаптированная программа №8 (для детей с умственной отсталостью)",
    },
]);
app.run([
    '$rootScope',
    '$auth',
    '$state',
    '$stateParams',
    '$mdDialog',
    'ENV',
    '$http',
    'LmsSystemInfoResource',
    function ($rootScope, $auth, $state, $stateParams, $mdDialog, ENV, $http, LmsSystemInfoResource) {
        $rootScope.ENV = ENV;
        $rootScope.allIsVisible = true;
        $rootScope.isIOS = !!navigator.platform &&
            /iPad|iPhone|iPod/.test(navigator.platform);
        $rootScope.$on(
            '$stateChangeStart',
            function (event, toState, toStateParams) {
                $rootScope.state = {
                    toState: toState,
                    toStateParams: toStateParams
                };
                $mdDialog.hide();
                if (
                    (toState.name !== 'login' && toState.name !== 'oauth' &&
                        toState.name !== 'openBookshelf' && toState.name !== 'navigateU2035' &&
                        toState.name !== 'navigateEpos') ||
                    (toState.data && !toState.data.noLogin) ||
                    ($auth.tokenExists() && toState.name === 'openBookshelf')
                ) {
                    $auth.authorize().then(function () {
                        $http({
                            method: 'post',
                            url: '/api/audits/userActivity'
                        });
                        if ($auth.isInRole('ROLE_PARENT')) {
                            var relatedStudentId = JSON.parse(
                                sessionStorage.getItem('relatedStudentId')
                            );
                            if (relatedStudentId) {
                                $auth.user.relatedStudentId = relatedStudentId;
                            }
                        }
                    });
                    if ($auth.isInRole("ROLE_PARENT")) {
                        var relatedStudentId = JSON.parse(
                            sessionStorage.getItem("relatedStudentId")
                        );
                        if (relatedStudentId) {
                            $auth.user.relatedStudentId = relatedStudentId;
                        }
                    }
                };
            }
        );

        /* clientCode */
        /**
         * return asi | meo | school_109 | NOT_CONFIGURED
         */
        function getClientCode() {
            return LmsSystemInfoResource.getAllLmsSystemInfoByClientCode().$promise.then(function (res) {
                console.log('dlokib')
                console.log(res)

                var customLoginScreen = !!res.customLoginScreen;
                if (customLoginScreen) {
                    if (res.clientCode) {
                        return res.clientCode;
                    }
                }
                return 'NOT_CONFIGURED';
            });
        }

        /* asi | meo | school_109 | NOT_CONFIGURED | null */
        $rootScope.clientCode = null;
        getClientCode().then(function (clientCode) {
            // console.log('clientCode: ', clientCode);
            // $rootScope.clientCode = 'asi';
            $rootScope.clientCode = clientCode;
        });
        /* /clientCode */
    }
]);

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('lmsClientApp')
        .constant('VERSION', "1.4.1")
        .constant('GIT', {
	"message": "fix: styles",
	"commit": "adafcda0c3621bdbb2618d019e4d762b24517136",
	"branch": "integration",
	"date": "2022-07-26T07:53:43.000Z"
})
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ENV', "prod")
        .constant('API', {
	"clientApi": "/cli",
	"supportApi": "/sup"
})
        .constant('innopolis', undefined)
        .constant('epos', undefined)
        .constant('u2035', undefined)
;
})();

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = 'ng-token-auth';
}

'use strict';

angular.module('ng-token-auth', ['ipCookie']).provider('$auth', function () {
    var config;

    return {
        configure: function configure(params) {
            if (params instanceof Object) {
                config = params;
            } else {
                throw "Invalid argument: ng-token-auth config should be an Object.";
            }
            return config;
        },
        $get: ['$http', '$q', '$location', 'ipCookie', '$window', '$timeout', '$rootScope', 'Account', '$state', function (_this) {
            return function ($http, $q, $location, ipCookie, $window, $timeout, $rootScope, Account, $state) {
                return {
                    dfd: null,
                    user: {},
                    mustResetPassword: false,
                    initialize: function initialize() {
                        $rootScope.user = this.user;
                        $rootScope.signOut = angular.bind(this, this.signOut);
                        $rootScope.submitLogin = angular.bind(this, this.submitLogin);
                        $rootScope.oauth = angular.bind(this, this.oauth);
                    },
                    oauth: function oauth(resp) {
                        var _this2 = this;
                        this.initDfd();
                        var authData = {};
                        authData.token = decodeURIComponent(resp.headers['lms_auth']);
                        // authData.expires = +resp.headers.end;
                        authData = _this2.getConfig().handleLoginResponse(authData, _this2);
                        // console.log(this)
                        _this2.handleValidAuth(authData, true);
                        // // set cookie, so a user has access to static resources (images, docs etc)
                        // var token = resp.headers('Cookie').slice(9)
                        ipCookie('LMS_AUTH', authData.token, {
                            path: '/',
                            expires: 7
                        });
                        $rootScope.$broadcast('auth:login-success', _this2.user);
                        return this.dfd.promise;

                    },
                    submitLogin: function submitLogin(params) {
                        var _this2 = this;

                        this.initDfd();
                        var data = "";
                        // for (var key in params) {
                        //     if (data.length > 0) data += "&";
                        //     data += encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
                        // }

                        $http.post(this.apiUrl() + this.getConfig().emailSignInPath, params, {
                            // headers: {
                            //     "Content-Type": "application/x-www-form-urlencoded",
                            //     "Accept": "application/json"
                            // }
                        }).then(function (resp) {

                            var authData = {};
                            authData.token = decodeURIComponent(resp.headers('Cookie').slice(9));

                            authData.expires = +resp.headers('end');
                            authData.rcToken = resp.headers('rctoken');
                            authData.rcUserid = resp.headers('rcuserid');
                            authData = _this2.getConfig().handleLoginResponse(authData, _this2);

                            // console.log(this)
                            _this2.handleValidAuth(authData, true);
                            // // set cookie, so a user has access to static resources (images, docs etc)
                            // var token = resp.headers('Cookie').slice(9)
                            ipCookie('LMS_AUTH', authData.token, {
                                path: '/',
                                expires: 7
                            });
                            return $rootScope.$broadcast('auth:login-success', _this2.user);
                        }).catch(function (resp) {
                            var _errorResp = {
                                reason: 'unauthorized'
                            };

                            switch (resp.headers('Failure')) {
                                case 'Too many users active':
                                    _errorResp.errors = ['Too many users active'];
                                    break;
                                case 'This user is deactivated':
                                    _errorResp.errors = ['This user is deactivated'];
                                    break;
                                default:
                                    _errorResp.errors = ['Invalid credentials'];
                                    break;
                            };
                            _this2.rejectDfd(_errorResp);
                            return $rootScope.$broadcast('auth:login-error', _errorResp.errors);
                        });

                        return this.dfd.promise;
                    },
                    tokenExists: function tokenExists() {
                        return this.retrieveData('ls.token') && this.getConfig().parseToken(this.retrieveData('ls.token') || {});
                    },
                    setAuthTokens: function setAuthToken(lmsToken) {
                        this.persistData(
                            'ls.token',
                            {
                                token: lmsToken,
                                expires: 0
                            });
                        ipCookie(
                            'LMS_AUTH',
                            lmsToken,
                            {
                                path: '/',
                                expires: 7
                            }
                        );
                    },
                    userIsAuthenticated: function userIsAuthenticated() {
                        return this.retrieveData('ls.token') && this.user.signedIn && !this.tokenHasExpired();
                    },
                    resolveDfd: function resolveDfd() {
                        this.dfd.resolve(this.user);
                        return $timeout(function (_this) {
                            return function () {
                                _this.dfd = null;
                                if (!$rootScope.$$phase) {
                                    return $rootScope.$digest();
                                }
                            };
                        }(this), 0);
                    },
                    validateUser: function validateUser() {
                        var clientId, expiry, token, uid, storedToken;

                        if (this.dfd == null) {
                            this.initDfd();
                            if (this.userIsAuthenticated()) {
                                this.resolveDfd();
                            } else {
                                if ($location.search().token !== void 0) {
                                    token = $location.search().token;
                                    clientId = $location.search().client_id;
                                    uid = $location.search().uid;
                                    expiry = $location.search().expiry;
                                    this.mustResetPassword = $location.search().reset_password;
                                    this.firstTimeLogin = $location.search().account_confirmation_success;
                                    this.setAuthHeaders(this.buildAuthHeaders({
                                        token: token,
                                        clientId: clientId,
                                        uid: uid,
                                        expiry: expiry
                                    }));
                                    $location.url($location.path() || '/');
                                }
                                storedToken = this.retrieveData('ls.token');
                                if (!isEmpty(storedToken)) {
                                    if (storedToken.token.indexOf('true') === -1) {
                                        if (this.tokenHasExpired()) {
                                            $rootScope.$broadcast('auth:session-expired');
                                            this.rejectDfd({
                                                reason: 'unauthorized',
                                                errors: ['Session expired.']
                                            });
                                            $state.go('login');
                                        } else {
                                            this.validateToken();
                                            this.resolveDfd();
                                        }
                                    }
                                } else {
                                    this.rejectDfd({
                                        reason: 'unauthorized',
                                        errors: ['No credentials']
                                    });
                                    $rootScope.$broadcast('auth:invalid');
                                }
                            }
                        }
                        return this.dfd.promise;
                    },
                    loadAccountInfo: function loadAccountInfo(update) {
                        var deferred = $q.defer();

                        if (!update && angular.isDefined($rootScope.user) && $rootScope.user.id && $rootScope.user.signedIn) {
                            deferred.resolve($rootScope.user);
                            return deferred.promise;
                        }

                        Account.getAccount().then(function (_this) {
                            return function (response) {
                                _this.user.signedIn = true;
                                angular.extend(_this.user, response);
                                deferred.resolve(response);
                            };
                        }(this), function (_this) {
                            return function () {
                                _this.user.signedIn = false;
                                deferred.reject();
                            };
                        }(this));
                        return deferred.promise;
                    },
                    authorize: function authorize() {
                        return this.loadAccountInfo().then(function (_this) {
                            return function () {
                                if ($rootScope.state.toState.data && $rootScope.state.toState.data.roles && $rootScope.state.toState.data.roles.length > 0 && !_this.isInAnyRole($rootScope.state.toState.data.roles)) {
                                    if (_this.userIsAuthenticated()) {
                                        // user is signed in but not authorized for desired state
                                        $state.go('accessdenied');
                                    } else {
                                        // user is not authenticated. stow the state they wanted before you
                                        // send them to the signin state, so you can return them when you're done
                                        $rootScope.state = {
                                            returnToState: $rootScope.state.toState,
                                            returnToStateParams: $rootScope.state.toStateParams
                                        };
                                        // now, send them to the signin state so they can log in
                                        $state.go('login');
                                    }
                                }
                            };
                        }(this), function (_this) {
                            return function () {
                                if (!_this.userIsAuthenticated()) _this.invalidateTokens();
                                $state.go('login');
                            };
                        }(this));
                    },
                    isInRole: function isInRole(role) {
                        if (!this.userIsAuthenticated() || !this.user.roles) {
                            return false;
                        }

                        return this.user.roles.indexOf(role) !== -1;
                    },
                    isInAnyRole: function isInAnyRole(roles) {
                        if (!this.userIsAuthenticated()) {
                            return false;
                        }

                        for (var i = 0; i < roles.length; i++) {
                            if (this.isInRole(roles[i])) {
                                return true;
                            }
                        }

                        return false;
                    },
                    validateToken: function validateToken() {
                        if (!this.tokenHasExpired()) {
                            return $http.get(this.apiUrl() + this.getConfig().tokenValidationPath).success(function (_this) {
                                return function (resp) {
                                    var authData = _this.getConfig().handleTokenValidationResponse(resp);

                                    _this.handleValidAuth(authData);
                                    if (_this.firstTimeLogin) {
                                        $rootScope.$broadcast('auth:email-confirmation-success', _this.user);
                                    }
                                    if (_this.mustResetPassword) {
                                        $rootScope.$broadcast('auth:password-reset-confirm-success', _this.user);
                                    }

                                    return $rootScope.$broadcast('auth:validation-success', _this.user);
                                };
                            }(this)).error(function (_this) {
                                return function (data) {
                                    if (_this.firstTimeLogin) {
                                        $rootScope.$broadcast('auth:email-confirmation-error', data);
                                    }
                                    if (_this.mustResetPassword) {
                                        $rootScope.$broadcast('auth:password-reset-confirm-error', data);
                                    }
                                    $rootScope.$broadcast('auth:validation-error', data);

                                    return _this.rejectDfd({
                                        reason: 'unauthorized',
                                        errors: data.errors
                                    });
                                };
                            }(this));
                        } else {
                            return this.rejectDfd({
                                reason: 'unauthorized',
                                errors: ['Expired credentials']
                            });
                        }
                    },
                    tokenHasExpired: function tokenHasExpired() {
                        var expiry, now, tokenData;

                        tokenData = this.retrieveData('ls.token');
                        expiry = this.getExpiry();
                        now = new Date().getTime();
                        if (tokenData && tokenData.token.indexOf('true') > -1) {
                            return false;
                        }
                        return expiry && expiry < now;
                    },
                    getExpiry: function getExpiry() {
                        return this.getConfig().parseExpiry(this.retrieveData('ls.token') || {});
                    },
                    invalidateTokens: function invalidateTokens() {
                        var key, val, _ref;
                        _ref = this.user;
                        for (key in _ref) {
                            val = _ref[key];
                            delete this.user[key];
                        }
                        if (this.timer != null) {
                            $timeout.cancel(this.timer);
                        }

                        return this.deleteData('ls.token');
                    },
                    signOut: function signOut() {
                        ipCookie.remove('LMS_AUTH', {
                            path: '/'
                        });
                        this.invalidateTokens();
                        $rootScope.$broadcast('auth:logout-success');
                        $state.go('login');

                        return $q.defer().promise;
                    },
                    handleValidAuth: function handleValidAuth(user, setHeader) {
                        if (setHeader == null) {
                            setHeader = false;
                        }
                        if (this.t != null) {
                            $timeout.cancel(this.t);
                        }
                        this.user.signedIn = true;
                        if (setHeader) {
                            this.setAuthHeaders(this.buildAuthHeaders(user));
                        }
                        return this.resolveDfd();
                    },
                    buildAuthHeaders: function buildAuthHeaders(ctx) {
                        var headers, key, val, _ref;
                        headers = {};
                        _ref = this.getConfig().authDataFormat;
                        for (key in _ref) {
                            val = _ref[key];
                            if (ctx[val] !== void 0) headers[val] = ctx[val];
                        }
                        return headers;
                    },
                    persistData: function persistData(key, val) {
                        var expiry;
                        switch (this.getConfig().storage) {
                            case 'localStorage':
                                return $window.localStorage.setItem(key, JSON.stringify(val));
                            default:
                                expiry = this.getConfig().parseExpiry(val || {});
                                return ipCookie(key, val, {
                                    path: '/',
                                    expires: expiry,
                                    expirationUnit: 'milliseconds'
                                });
                        }
                    },
                    retrieveData: function retrieveData(key) {
                        switch (this.getConfig().storage) {
                            case 'localStorage':
                                return JSON.parse($window.localStorage.getItem(key));
                            default:
                                return ipCookie(key);
                        }
                    },
                    deleteData: function deleteData(key) {
                        switch (this.getConfig().storage) {
                            case 'localStorage':
                                return $window.localStorage.removeItem(key);
                            default:
                                return ipCookie.remove(key, {
                                    path: '/'
                                });
                        }
                    },
                    setAuthHeaders: function setAuthHeaders(h) {
                        var expiry, newHeaders, now, result;
                        newHeaders = angular.extend(this.retrieveData('ls.token') || {}, h);
                        result = this.persistData('ls.token', newHeaders);
                        expiry = this.getExpiry();
                        now = new Date().getTime();
                        if (expiry > now) {
                            if (this.timer != null) {
                                $timeout.cancel(this.timer);
                            }
                            this.timer = $timeout(function (_this) {
                                return function () {
                                    return _this.validateUser();
                                };
                            }(this), parseInt(expiry - now) * 2);
                        }
                        return result;
                    },
                    initDfd: function initDfd() {
                        return this.dfd = $q.defer();
                    },
                    rejectDfd: function rejectDfd(reason) {
                        this.invalidateTokens();
                        if (this.dfd != null) {
                            this.dfd.reject(reason);
                            return $timeout(function (_this) {
                                return function () {
                                    return _this.dfd = null;
                                };
                            }(this), 0);
                        }
                    },
                    apiUrl: function apiUrl() {
                        return this.getConfig().apiUrl;
                    },
                    getConfig: function getConfig() {
                        return config;
                    }
                };
            };
        }(this)]
    };
}).config(['$httpProvider', function ($httpProvider) {
    var httpMethods, tokenIsCurrent, updateHeadersFromResponse;
    tokenIsCurrent = function ($auth, headers) {
        var newTokenExpiry, oldTokenExpiry;
        oldTokenExpiry = Number($auth.getExpiry());
        newTokenExpiry = Number($auth.getConfig().parseExpiry(headers || {}));
        return newTokenExpiry >= oldTokenExpiry;
    };
    updateHeadersFromResponse = function ($auth, resp) {
        var key, newHeaders, val, _ref;
        newHeaders = {};
        _ref = $auth.getConfig().tokenFormat;
        for (key in _ref) {
            val = _ref[key];
            if (resp.headers(key)) {
                newHeaders[key] = resp.headers(key);
            }
        }
        if (tokenIsCurrent($auth, newHeaders)) {
            return $auth.setAuthHeaders(newHeaders);
        }
    };
    $httpProvider.interceptors.push(['$injector', function ($injector) {
        return {
            request: function (req) {
                $injector.invoke(['$http', '$auth', function ($http, $auth) {
                    var key, val, _ref, _results, _authHF, _authDF;

                    if (req.url.match($auth.apiUrl)) {
                        _ref = $auth.retrieveData('ls.token');
                        _authHF = $auth.getConfig().authHeadersFormat;
                        _authDF = $auth.getConfig().authDataFormat;
                        _results = [];
                        if (_ref) {
                            for (key in _authHF) {
                                val = _authDF[key];
                                if (val !== null && val !== void 0 && _ref[val] !== null && _ref[val] !== void 0) {
                                    _results.push(req.headers[_authHF[key]] = _ref[val]);
                                }
                            }
                        }
                        return _results;
                    }
                }]);
                return req;
            },
            response: function (resp) {
                $injector.invoke(['$http', '$auth', function ($http, $auth) {
                    if (resp.config.url.match($auth.apiUrl)) {
                        return updateHeadersFromResponse($auth, resp);
                    }
                }]);
                return resp;
            },
            responseError: function (resp) {
                var response = $injector.invoke(['$http', '$auth', '$state', 'ipCookie', function ($http, $auth, $state, ipCookie) {
                    if (resp.status === 401 && resp.config.url.match($auth.apiUrl)) {
                        var headers = resp.headers();
                        if (headers['x-auth-recreate'] && headers['x-auth-recreate'].indexOf('true') > -1) {
                            // save new token and recover the request
                            $auth.setAuthHeaders(resp.data);
                            // the cookie is used to authorize access to static resources (images, docs etc)
                            ipCookie('LMS_AUTH', resp.data.token, {
                                path: '/',
                                expires: 7
                            });
                            return $http(resp.config);
                        }

                        $state.go('login');
                        return null;
                    }
                }]);
                if (response) {
                    return response;
                }

                return $injector.get('$q').reject(resp);
            }
        };
    }]);
    httpMethods = ['get', 'post', 'put', 'patch', 'delete'];
    return angular.forEach(httpMethods, function (method) {
        var _base;
        if ((_base = $httpProvider.defaults.headers)[method] == null) {
            _base[method] = {};
        }
        return $httpProvider.defaults.headers[method]['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    });
}]).run(['$auth', '$window', '$rootScope', function ($auth, $window, $rootScope) {
    return $auth.initialize();
}]);

window.isEmpty = function (obj) {
    var key, val;
    if (!obj) {
        return true;
    }
    if (obj.length > 0) {
        return false;
    }
    if (obj.length === 0) {
        return true;
    }
    for (key in obj) {
        val = obj[key];
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
};

angular
  .module("materialCalendar", ["ngMaterial", "ngSanitize"])
  .filter("dateToGmt", function() {
    return function(date) {
      date = date || new Date();
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    };
  })
  .service("Calendar", ["$filter", function($filter) {

    function Calendar(year, month, options) {

      var self = this;
      var now = $filter("dateToGmt")();

      this.getNumDays = function() {
        return $filter("dateToGmt")(new Date(
          this.start.getYear(),
          this.start.getMonth(),
          0
        )).getDate();
      };

      this.setWeekStartsOn = function(i) {
        var d = parseInt(i || 0, 10);
        if (!isNaN(d) && d >= 0 && d <= 6) {
          this.weekStartsOn = d;
        } else {
          this.weekStartsOn = 0;
        }
        return this.weekStartsOn;
      };

      this.options = angular.isObject(options) ? options : {};
      this.year = now.getFullYear();
      this.month = now.getMonth();
      this.dates = [];
      this.weekStartsOn = this.setWeekStartsOn(this.options.weekStartsOn);

      this.getFirstDayOfCalendar = function() {

        // Get first date of month.
        var date = this.start;
        var first = new Date(date.getFullYear(), date.getMonth(), 1);

        if (first.getDay() !== this.weekStartsOn) {

          // Set the first day of the month.
          first.setDate(first.getDate() - first.getDay() + (this.weekStartsOn));

          // Sanity check to prevent first/last week from being out of month.
          if (first.getDate() > 1 && first.getDate() < 7) {
            first.setDate(first.getDate() - 7);
          }

        }

        return first;

      };

      this.next = function() {
        this.init(this.year, this.month + 1);

      };

      this.prev = function() {        
        this.init(this.year, this.month - 1);
      };

      this._isFirstDayOfWeek = function(date) {
        return !date.getDay();
      };

      this.init = function(year, month) {

        if (year) {
          if (month > -1) {
            this.year = year;
            this.month = month;
          } else {
            this.year = year - 1;
            this.month = 11;
          }
        }

        // Set up the new date.
        this.start = $filter("dateToGmt")(new Date(this.year, this.month, 1, 0, 0));
        this.title = moment(this.start).format(this.options.titleFormat);
        this.dates = [];
        this.weeks = [];

        // Reset the month and year to handle the case of many
        // prev/next calls across years.
        this.year = this.start.getFullYear();
        this.month = this.start.getMonth();

        var date;
        var first = this.getFirstDayOfCalendar();

        // @todo Need to fix for up to 6 weeks.
        var _i = first.getDate() == 1 && this.getNumDays() == 28 ? 28 : 42;

        for (var i = 0; i < _i; i++) {

          date = $filter("dateToGmt")(new Date(first.valueOf() + (i * 86400000)));

          // Let's start a new week.
          // @todo If timezone changes, this goes haywire.
          if (i % 7 === 0) {
            this.weeks.push([]);
          }

          // Sanity check to prevent first day of week from being in next month.
          if (this.weeks.length > 1 && !this.weeks[this.weeks.length - 1].length) {
            if (date.getMonth() !== this.month) {
              break;
            }
          }

          this.dates.push(date);
          this.weeks[this.weeks.length - 1].push(date);

        }

        return this.dates;

      };

      this.init(year, month);

    }

    return Calendar;

  }])
  .directive("calendarMd", ["$compile", "$parse", "$http", "$q", "$filter", "Calendar", function($compile, $parse, $http, $q, $filter, Calendar) {

    var hasCss;
    var defaultTemplate = "/* angular-material-calendar.html */";

    var injectCss = function() {
      if (!hasCss) {
        var head = document.getElementsByTagName("head")[0];
        var css = document.createElement("style");
        css.type = "text/css";
        css.id="calendarMdCss";
        css.innerHTML = "/* angular-material-calendar.css */";
        head.insertBefore(css, head.firstChild);
        hasCss = true;
      }
    };

    return {
      restrict: "E",
      scope: {
        ngModel: "=?",
        template: "&",
        templateUrl: "=?",
        onDayClick: "=?",
        onPrevMonth: "=?",
        onNextMonth: "=?",
        calendarDirection: "=?",
        dayContent: "=?",
        timezone: "=?",
        titleFormat: "=?",
        dayFormat: "=?",
        dayLabelFormat: "=?",
        dayLabelTooltipFormat: "=?",
        dayTooltipFormat: "=?",
        weekStartsOn: "=?"
      },

      link: function($scope, $element, $attrs, $ngModel) {

        // Add the CSS here.
        injectCss();

        var date = new Date();
        var month = parseInt($attrs.startMonth || date.getMonth());
        var year = parseInt($attrs.startYear || date.getFullYear());

        $scope.columnWeekLayout = "column";
        $scope.weekLayout = "row";
        $scope.timezone = $scope.timezone || null;

        // Set the defaults here.
        $scope.titleFormat = $scope.titleFormat || "MMMM yyyy";
        $scope.dayLabelFormat = $scope.dayLabelFormat || "EEE";
        $scope.dayLabelTooltipFormat = $scope.dayLabelTooltipFormat || "EEEE";
        $scope.dayFormat = $scope.dayFormat || "d";
        $scope.dayTooltipFormat = $scope.dayTooltipFormat || "fullDate";
        $scope.getDayContent = $scope.dayContent || function() { };

        $scope.sameMonth = function(date) {
          var d = $filter("dateToGmt")(date);
          return d.getFullYear() === $scope.calendar.year &&
            d.getMonth() === $scope.calendar.month;
        };

        $scope.currentDate = function(calendDate) {
            var d = $filter("dateToGmt")(calendDate);
            return d.getFullYear() === date.getFullYear() &&
                d.getMonth() === date.getMonth() &&
                d.getDate() === date.getDate();
        };

        $scope.calendarDirection = $scope.calendarDirection || "horizontal";
        $scope.$watch("calendarDirection", function(val) {
          $scope.weekLayout = val === "horizontal" ? "row" : "column";
        });

        var handleCb =  function(cb, data) {
          (cb || angular.noop)(data);
        };

        $scope.prev = function() {
          $scope.calendar.prev();
          var data = {
            year: $scope.calendar.year,
            month: $scope.calendar.month + 1
          };
          handleCb($scope.onPrevMonth, data);
        };

        $scope.next = function() {
          $scope.calendar.next();
          var data = {
            year: $scope.calendar.year,
            month: $scope.calendar.month + 1
          };
          handleCb($scope.onNextMonth, data);
        };

        $scope.handleDayClick = function(date) {
          $scope.active = date;
          if ($attrs.ngModel) {
            $parse($attrs.ngModel).assign($scope.$parent, date);
          }
          handleCb($scope.onDayClick, date);
        };

        // Small helper function to set the contents of the template.
        var setTemplate = function(contents) {
            $element.html(contents);
            $compile($element.contents())($scope);
        };

        var init = function() {

          $scope.calendar = new Calendar(year, month, {
            weekStartsOn: $scope.weekStartsOn || 0,
            titleFormat: $scope.titleFormat
          });

          var deferred = $q.defer();
          // Allows fetching of dynamic templates via $http.
          if ($scope.templateUrl) {
            $http
              .get($scope.templateUrl)
              .success(deferred.resolve)
              .error(deferred.reject);
          } else {
            deferred.resolve($scope.template() || defaultTemplate);
          }

          return deferred.promise;

        };

        $scope.$watch("weekStartsOn", init);

        init().then(setTemplate);

      }
    };

  }]);

(function() {
"use strict";
var module = angular.module("mdPickers", [
	"ngMaterial",
	"ngAnimate",
	"ngAria"
]);

module.controller('DatePickerCtrl', ['$scope', '$mdDialog', 'currentDate', '$mdMedia', function($scope, $mdDialog, currentDate, $mdMedia) {
    var self = this;

    this.currentDate = currentDate;
    this.currentMoment = moment(self.currentDate);
    this.weekDays = moment.weekdaysMin();

    $scope.$mdMedia = $mdMedia;
    $scope.yearsOptions = [];
    for(var i = 1900; i <= moment(Date.now()).year(); i++) {
        $scope.yearsOptions.push(i);
    }
    $scope.year = this.currentMoment.year();

	this.setYear = function() {
		self.currentMoment.year($scope.year);
    };

    this.selectDate = function(dom) {
        self.currentMoment.date(dom);
    };

    this.cancel = function() {
        $mdDialog.cancel();
    };

    this.confirm = function() {
        $mdDialog.hide(this.currentMoment.toDate());
    };

    this.getDaysInMonth = function() {
        var days = self.currentMoment.daysInMonth(),
            firstDay = moment(self.currentMoment).date(1).day();

        var arr = [];
        for(var i = 1; i <= (firstDay + days); i++)
            arr.push(i > firstDay ? (i - firstDay) : false);

        return arr;
    };

    this.nextMonth = function() {
        self.currentMoment.add(1, 'months');
      	$scope.year = self.currentMoment.year();
    };

    this.prevMonth = function() {
        self.currentMoment.subtract(1, 'months');
      	$scope.year = self.currentMoment.year();
    };
}]);

module.factory("$mdDatePicker", ["$mdDialog", function($mdDialog) {
    var datePicker = function(targetEvent, currentDate) {
        if(!angular.isDate(currentDate)) currentDate = Date.now();

        return $mdDialog.show({
            controller: 'DatePickerCtrl',
            controllerAs: 'datepicker',
            template: '<md-dialog aria-label="" class="mdpickers-datepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-md\') }">' +
                          '<md-dialog-content layout="row" layout-wrap>' +
                            '<div layout="column" layout-align="start center">' +
                              '<md-toolbar layout-align="center center" class="mdpickers-datepicker-dow md-primary"><span>{{ datepicker.currentMoment.format("dddd") }}</span></md-toolbar>' +
                              '<md-toolbar layout-align="center center" class="mdpickers-datepicker-date md-hue-1 md-primary" layout="column">' +
                                '<div class="mdpickers-datepicker-month">{{ datepicker.currentMoment.format("MMM") }}</div>' +
                                '<div class="mdpickers-datepicker-day">{{ datepicker.currentMoment.format("DD") }}</div>' +
                                '<md-select class="mdpickers-datepicker-year" placeholder="{{ datepicker.currentMoment.format(\'YYYY\') }}" ng-model="year" ng-change="datepicker.setYear()">' +
                                  '<md-option ng-value="year" ng-repeat="year in yearsOptions">{{ year }}</md-option>' +
                                '</md-select>' +
                              '</md-toolbar>' +
                            '</div>' +
                            '<div layout="column" layout-align="start center" class="mdpickers-datepicker-calendar">' +
                              '<div layout="row" layout-align="space-between center" class="mdpickers-datepicker-monthyear">' +
                                '<md-button aria-label="mese precedente" class="md-icon-button" ng-click="datepicker.prevMonth()"><ng-md-icon icon="keyboard_arrow_left"></ng-md-icon></md-button>' +
                                '{{ datepicker.currentMoment.format("MMMM YYYY") }}' +
                                '<md-button aria-label="mese successivo" class="md-icon-button" ng-click="datepicker.nextMonth()"><ng-md-icon icon="keyboard_arrow_right"></ng-md-icon></md-button>' +
                              '</div>' +
                              '<div layout="row" layout-align="space-around center" class="mdpickers-datepicker-week-days">' +
                                '<div layout layout-align="center center" ng-repeat="d in datepicker.weekDays track by $index">{{ d }}</div>' +
                              '</div>' +
                              '<div layout="row" layout-wrap class="mdpickers-datepicker-days">' +
                                '<div layout layout-align="center center" ng-repeat-start="n in datepicker.getDaysInMonth() track by $index">' +
                                  '<md-button aria-label="seleziona giorno" ng-if="n !== false" ng-class="{\'md-accent\': datepicker.currentMoment.date() == n}" ng-click="datepicker.selectDate(n)">{{ n }}</md-button>' +
                                '</div>' +
                                '<div flex ng-if="($index + 1) % 7 == 0" ng-repeat-end></div>' +
                              '</div>' +
                            '</div>' +
                          '</md-dialog-content>' +
                          '<md-dialog-actions layout="row">' +
                            '<md-button ng-click="datepicker.cancel()" aria-label="annulla">Отмена</md-button>' +
                            '<md-button ng-click="datepicker.confirm()" aria-label="ok">OK</md-button>' +
                          '</md-dialog-actions>' +
                        '</md-dialog>',
            targetEvent: targetEvent,
            clickOutsideToClose: true,
            escapeToClose: true,
            locals: {
                currentDate: currentDate
            }
        });
    }

    return datePicker;
}]);

module.directive("mdDatePicker", ["$mdDatePicker", "$timeout", function($mdDatePicker, $timeout) {
    return  {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
            // if ('undefined' !== typeof attrs.type && 'date' === attrs.type && ngModel) {
            if (ngModel) {
                angular.element(element).on("click", function(ev) {
                  		ev.preventDefault();
                      $mdDatePicker(ev, ngModel.$modelValue).then(function(selectedDate) {
                          $timeout(function() {
                            	ngModel.$setViewValue(moment(selectedDate).format("YYYY-MM-DD"));
                            	ngModel.$render();
                          });
                      });
                });
            }
        }
    }
}]);
})();

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.4 - 2015-09-03
 * License: MIT
 */
angular.module("ui.bootstrap",["ui.bootstrap.timepicker"]),angular.module("ui.bootstrap.timepicker",[]).constant("timepickerConfig",{hourStep:1,minuteStep:1,showMeridian:!0,meridians:null,readonlyInput:!1,mousewheel:!0,arrowkeys:!0,showSpinners:!0}).controller("TimepickerController",["$scope","$attrs","$parse","$log","$locale","timepickerConfig",function(e,n,t,i,r,u){function a(){var n=parseInt(e.hours,10),t=e.showMeridian?n>0&&13>n:n>=0&&24>n;return t?(e.showMeridian&&(12===n&&(n=0),e.meridian===h[1]&&(n+=12)),n):void 0}function o(){var n=parseInt(e.minutes,10);return n>=0&&60>n?n:void 0}function s(e){return angular.isDefined(e)&&e.toString().length<2?"0"+e:e.toString()}function l(e){c(),v.$setViewValue(new Date(f)),p(e)}function c(){v.$setValidity("time",!0),e.invalidHours=!1,e.invalidMinutes=!1}function p(n){var t=f.getHours(),i=f.getMinutes();e.showMeridian&&(t=0===t||12===t?12:t%12),e.hours="h"===n?t:s(t),"m"!==n&&(e.minutes=s(i)),e.meridian=f.getHours()<12?h[0]:h[1]}function d(e,n){var t=new Date(e.getTime()+6e4*n),i=new Date(e);return i.setHours(t.getHours(),t.getMinutes()),i}function m(e){f=d(f,e),l()}var f=new Date,v={$setViewValue:angular.noop},h=angular.isDefined(n.meridians)?e.$parent.$eval(n.meridians):u.meridians||r.DATETIME_FORMATS.AMPMS;this.init=function(t,i){v=t,v.$render=this.render,v.$formatters.unshift(function(e){return e?new Date(e):null});var r=i.eq(0),a=i.eq(1),o=angular.isDefined(n.mousewheel)?e.$parent.$eval(n.mousewheel):u.mousewheel;o&&this.setupMousewheelEvents(r,a);var s=angular.isDefined(n.arrowkeys)?e.$parent.$eval(n.arrowkeys):u.arrowkeys;s&&this.setupArrowkeyEvents(r,a),e.readonlyInput=angular.isDefined(n.readonlyInput)?e.$parent.$eval(n.readonlyInput):u.readonlyInput,this.setupInputEvents(r,a)};var w=u.hourStep;n.hourStep&&e.$parent.$watch(t(n.hourStep),function(e){w=parseInt(e,10)});var g=u.minuteStep;n.minuteStep&&e.$parent.$watch(t(n.minuteStep),function(e){g=parseInt(e,10)});var $;e.$parent.$watch(t(n.min),function(e){var n=new Date(e);$=isNaN(n)?void 0:n});var M;e.$parent.$watch(t(n.max),function(e){var n=new Date(e);M=isNaN(n)?void 0:n}),e.noIncrementHours=function(){var e=d(f,60*w);return e>M||f>e&&$>e},e.noDecrementHours=function(){var e=d(f,60*-w);return $>e||e>f&&e>M},e.noIncrementMinutes=function(){var e=d(f,g);return e>M||f>e&&$>e},e.noDecrementMinutes=function(){var e=d(f,-g);return $>e||e>f&&e>M},e.noToggleMeridian=function(){return f.getHours()<13?d(f,720)>M:d(f,-720)<$},e.showMeridian=u.showMeridian,n.showMeridian&&e.$parent.$watch(t(n.showMeridian),function(n){if(e.showMeridian=!!n,v.$error.time){var t=a(),i=o();angular.isDefined(t)&&angular.isDefined(i)&&(f.setHours(t),l())}else p()}),this.setupMousewheelEvents=function(n,t){var i=function(e){e.originalEvent&&(e=e.originalEvent);var n=e.wheelDelta?e.wheelDelta:-e.deltaY;return e.detail||n>0};n.bind("mousewheel wheel",function(n){e.$apply(i(n)?e.incrementHours():e.decrementHours()),n.preventDefault()}),t.bind("mousewheel wheel",function(n){e.$apply(i(n)?e.incrementMinutes():e.decrementMinutes()),n.preventDefault()})},this.setupArrowkeyEvents=function(n,t){n.bind("keydown",function(n){38===n.which?(n.preventDefault(),e.incrementHours(),e.$apply()):40===n.which&&(n.preventDefault(),e.decrementHours(),e.$apply())}),t.bind("keydown",function(n){38===n.which?(n.preventDefault(),e.incrementMinutes(),e.$apply()):40===n.which&&(n.preventDefault(),e.decrementMinutes(),e.$apply())})},this.setupInputEvents=function(n,t){if(e.readonlyInput)return e.updateHours=angular.noop,void(e.updateMinutes=angular.noop);var i=function(n,t){v.$setViewValue(null),v.$setValidity("time",!1),angular.isDefined(n)&&(e.invalidHours=n),angular.isDefined(t)&&(e.invalidMinutes=t)};e.updateHours=function(){var e=a(),n=o();angular.isDefined(e)&&angular.isDefined(n)?(f.setHours(e),$>f||f>M?i(!0):l("h")):i(!0)},n.bind("blur",function(){!e.invalidHours&&e.hours<10&&e.$apply(function(){e.hours=s(e.hours)})}),e.updateMinutes=function(){var e=o(),n=a();angular.isDefined(e)&&angular.isDefined(n)?(f.setMinutes(e),$>f||f>M?i(void 0,!0):l("m")):i(void 0,!0)},t.bind("blur",function(){!e.invalidMinutes&&e.minutes<10&&e.$apply(function(){e.minutes=s(e.minutes)})})},this.render=function(){var n=v.$viewValue;isNaN(n)?(v.$setValidity("time",!1),i.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')):(n&&(f=n),$>f||f>M?(v.$setValidity("time",!1),e.invalidHours=!0,e.invalidMinutes=!0):c(),p())},e.showSpinners=angular.isDefined(n.showSpinners)?e.$parent.$eval(n.showSpinners):u.showSpinners,e.incrementHours=function(){e.noIncrementHours()||m(60*w)},e.decrementHours=function(){e.noDecrementHours()||m(60*-w)},e.incrementMinutes=function(){e.noIncrementMinutes()||m(g)},e.decrementMinutes=function(){e.noDecrementMinutes()||m(-g)},e.toggleMeridian=function(){e.noToggleMeridian()||m(720*(f.getHours()<12?1:-1))}}]).directive("timepicker",function(){return{restrict:"EA",require:["timepicker","?^ngModel"],controller:"TimepickerController",controllerAs:"timepicker",replace:!0,scope:{},templateUrl:function(e,n){return n.templateUrl||"template/timepicker/timepicker.html"},link:function(e,n,t,i){var r=i[0],u=i[1];u&&r.init(u,n.find("input"))}}});
(function($) {
    if(!$)
        return false;

    var pathMaxWidth, pathsSelector;

    $(document).on({
        mouseenter: mouseEnter,
        mouseleave: mouseLeave
    }, "#breadcrumbs .path");

    function mouseEnter() {

        pathsSelector = $("#breadcrumbs .path");

        var childWidth = $(this).find("p a, span").width(),
            pathWidth = parseInt($(this).css("width")),
            countPaths = pathsSelector.length,
            difference = 0,
            self = $(this);

        if(!pathMaxWidth)
            pathMaxWidth = parseInt($(this).css("max-width"));

        if(childWidth > pathMaxWidth || (childWidth - pathWidth) > 1) {
            self.css("max-width", "none");
            difference = childWidth - pathWidth;
            if(countPaths > 0) {
                pathsSelector.not(self).each(function(index, el) {
                    var curWidth = parseInt($(el).css("width"));
                    $(el).css("width", curWidth - Math.round(difference/(countPaths-1)));
                });
            }
        }
    }

    function mouseLeave() {
        $(this).css("max-width", pathMaxWidth);
        pathsSelector.each(function() {
            $(this).css("width", "auto");
        })
    }
})(jQuery);

'use strict';

app.service('rest', ['$http', '$location', '$stateParams', 'lmsConfig', function ($http, $location, $stateParams, lmsConfig) {

    return {

        baseUrl: lmsConfig.apiUrlPath,
        path: undefined,
        expand: undefined,
        studentIds: undefined,

        models: function () {
            return $http.get(this.baseUrl + lmsConfig.versionUrl + this.path + location.search);
        },
        model: function () {
            if ($routeParams.expand != null) {
                return $http.get(this.baseUrl + lmsConfig.versionUrl + this.path + "/" + $routeParams.id + '?expand=' + $routeParams.expand);
            }
            return $http.get(this.baseUrl + lmsConfig.versionUrl + paththis.path + "/" + $routeParams.id);
        },
        get: function () {
            var promise;

            if (this.expand && this.expand.length > 0) {
                promise = $http.get(this.baseUrl + lmsConfig.versionUrl + this.path + '?expand=' + this.expand.join(","));
                this.expand = undefined;
                return promise;
            } else if (this.studentIds && this.studentIds.length > 0) {
                promise = $http.get(this.baseUrl + lmsConfig.versionUrl + this.path + '?studentIds=' + this.studentIds.join(","));
                this.studentIds = undefined;
                return promise;
            }
            return $http.get(this.baseUrl + lmsConfig.versionUrl + this.path);
        },
        postModel: function (model, config) {
            config = (config !== void 0) ? config : {};
            return $http.post(this.baseUrl + lmsConfig.versionUrl + this.path, model);
        },
        putModel: function (model) {
            return $http.put(this.baseUrl + lmsConfig.versionUrl + this.path, model);
        },
        deleteModel: function () {
            return $http.delete(this.baseUrl + lmsConfig.versionUrl + this.path);
        }
    };

}]);

'use strict';

app.service('User', [
    'lmsConfig',
    'rest',
    '$http',
    function(lmsConfig, rest, $http) {
        this.getUser = getUser;
        this.getVKGroupId = getVKGroupId;

        function getUser(username) {
            if (username !== void 0) {
                rest.path = 'users/' + username;
                return rest.get().success(function(response) {
                    return response;
                });
            }
        }

        function getVKGroupId() {
            rest.path = 'social/vk/applicationId';
            return rest.get();
        }
    }
]);

"use strict";

app.service("StatisticActivity", [
    "$http",
    function($http) {

        var baseUrl = window.location.origin + "/statistics/activity";
        this.sendWatch = sendWatch;
        this.sendVisitLogin = sendVisitLogin;
        this.sendVisitLogout = sendVisitLogout;

        function sendWatch(lessonId, userId) {
            var watchUri = "/watch/lesson";
            var data = {
                statisticsTypeId: 2,
                externalId: lessonId,
                createdAt: new Date(),
                externalUserId: userId
            }
            $http.post(baseUrl + watchUri, data);
        }

        function sendVisitLogin(userId) {
            var watchUri = "/visit/login";
            var data = {
                statisticsTypeId: 0,
                // externalId: 0,
                createdAt: new Date(),
                externalUserId: userId
            }
            $http.post(baseUrl + watchUri, data);
        }

        function sendVisitLogout(userId) {
            var watchUri = "/visit/logout";
            var data = {
                statisticsTypeId: 1,
                // externalId: lessonId,
                createdAt: new Date(),
                externalUserId: userId
            }
            $http.post(baseUrl + watchUri, data);
        }
    }
]);
'use strict';

angular.module('lmsClientApp')
    .service('ModalStack', function() {

        // Variables
        var self = this;
        var stack = [];

        // Methods
        this.add = addToStack;
        this.pop = pop;
        this.getStack = getStack;
        this.callLast = callLast;
        this.clearStack = clearStack;

        function addToStack(func, params, context) {
            if(func !== void 0 && params !== void 0 && context !== void 0) {
                stack.push({
                    'func' : func,
                    'params' : params,
                    'context' : context
                });
            } else {
                return false;
            }
        }

        function pop() {
            stack.pop();
            return this;
        }

        function callLast() {
            if(stack.length > 0) {
                var params = Array.prototype.slice.call(stack[stack.length-1].params);
                params.push(true); // push flashback param
                stack[stack.length-1].func.apply(stack[stack.length-1].context, params);
            }
        }

        function getStack() {
            return stack;
        }

        function clearStack() {
            stack = [];
        }
    });

'use strict';

angular.module('lmsClientApp')
    .directive('hasAnyRole', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('ng-hide');
                    },
                    setHidden = function () {
                        element.addClass('ng-hide');
                        element.css({ 'display': 'none', 'visibility': 'hidden' });
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = $auth.isInAnyRole(roles);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    roles = attrs.hasAnyRole.replace(/\s+/g, '').split(',');

                if (roles.length > 0) {
                    scope.$watch(function () {
                        return $auth.user.id;
                    }, function (v) {
                        if (v) {
                            defineVisibility(true);
                        }
                    });
                }
            }
        };
    }])
    .directive('hasRole', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var setVisible = function () {
                        element.removeClass('ng-hide');
                    },
                    setHidden = function () {
                        element.addClass('ng-hide');
                        element.css({ 'display': 'none', 'visibility': 'hidden' });
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = $auth.isInRole(role);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    role = attrs.hasRole.replace(/\s+/g, '');

                if (role.length > 0) {
                    scope.$watch(function () {
                        return $auth.user.id;
                    }, function (v) {
                        if (v) {
                            defineVisibility(true);
                        }
                    });
                }

            }
        };
    }])
    .directive('currentRole', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return $auth.user.userRoles;
                }, function (userRoles) {
                    if (userRoles) {
                        if (userRoles[0] === attrs.currentRole) {
                            element.removeClass('ng-hide');
                        } else {
                            element.addClass('ng-hide');
                        }
                    }
                });
            }
        };
    }])
    .directive('notCurrentRole', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return $auth.user.userRoles;
                }, function (userRoles) {
                    if (userRoles) {
                        if (userRoles[0] === attrs.notCurrentRole) {
                            element.addClass('ng-hide');
                        } else {
                            element.removeClass('ng-hide');
                        }
                    }
                });
            }
        };
    }])
    .directive('currentAnyRole', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var roles = attrs.currentAnyRole.replace(/\s+/g, '').split(',');

                scope.$watch(function () {
                    return $auth.user.userRoles;
                }, function (userRoles) {
                    if (userRoles) {
                        roles.some(function (role) {
                            if (userRoles[0] === role) {
                                element.removeClass('ng-hide');
                                return true;
                            } else {
                                element.addClass('ng-hide');
                            }
                        });
                    }
                });
            }
        };
    }])
    .directive('loggedIn', ['$auth', function ($auth) {
        return {
            restrict: 'A',
            scope: {
                loggedIn:'@',
            },
            link: function (scope, element, attrs) {
                var value = (scope.loggedIn === 'false') ? false : true;
                scope.$watch(function () {
                    return !(!($auth.user && $auth.userIsAuthenticated()) ^ !value);
                }, function (v) {
                    if (!v) {
                        element.addClass('ng-hide');
                    } else {
                        element.removeClass('ng-hide');
                    }

                });
            }
        };
    }])
    .directive('disableIfRole', ['$auth', function($auth) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return $auth.user.userRoles;
                }, function (userRoles) {
                    if (userRoles) {
                        if (userRoles[0] === attrs.disableIfRole) {
                            element.attr('disabled', true);
                        } else {
                            element.attr('disabled', false);
                        }
                    }
                });
            }
        };
    }])

;

angular.module('twygmbh.auto-height', []).directive('autoHeight', [
    '$window', '$timeout', function($window, $timeout) {
        return {
            scope: {
                withHeightOf:'@',
                additionalPadding:'@'
            },
            link: function($scope, $element, $attrs) {
                var combineHeights, siblings;                                                     
            
                combineHeights = function(collection) {
                    var heights, i, len, node;
                    heights = 0;
                    for (i = 0, len = collection.length; i < len; i++) {
                        node = collection[i];
                        heights += node.offsetHeight;
                    }
                    return heights;
                };
                siblings = function($elm) {
                    var elm, i, len, ref, results;
                    ref = $elm.parent().children();
                    results = [];
                    for (i = 0, len = ref.length; i < len; i++) {
                        elm = ref[i];
                        if (elm !== $elm[0]) {
                            results.push(elm);
                        }
                    }                    
                    return results;
                };
                angular.element($window).bind('resize', function() {                    
                    var additionalHeight, parentHeight, parentEl;
                    var heightOf = 0;
                    var additionalPadding = ($scope.additionalPadding) ? $scope.additionalPadding : 0;
                    if($scope.withHeightOf) {
                        var heightOfElemets = document.querySelectorAll($scope.withHeightOf);                        
                        for(var i=0; i<heightOfElemets.length;i++) {
                            heightOf += heightOfElemets[0].offsetHeight;
                        }                        
                    }
                    additionalHeight = $attrs.additionalHeight || 0;
                    parentEl = $element.parent()[0];
                    if (!parentEl) {
                      return;
                    }
                    parentHeight = $window.innerHeight - parentEl.getBoundingClientRect().top - parseInt(window.getComputedStyle(parentEl).getPropertyValue('padding-top')) - parseInt(window.getComputedStyle(parentEl).getPropertyValue('padding-bottom')) - heightOf - additionalPadding;
                    return $element.css('max-height', (parentHeight - combineHeights(siblings($element)) - additionalHeight) + "px");
                });
                return $timeout(function() {
                    return angular.element($window).triggerHandler('resize');
                }, 1000);
                
                
            }
        };
    }
]);
app.directive('iframeSetDimensionsOnload', ['$interval', function($interval){
return {
    restrict: 'A',
    link: function(scope, element, attrs){
        var resizeInterval;
        var iFramePadding;

        element.on('load', function(){
            var iFrameHeight = element[0].contentWindow.document.body.scrollHeight;
            var iFrameWidth = element[0].contentWindow.document.body.scrollWidth + 'px'; //'100%';
            if (element[0].contentWindow.document.body) {
              element[0].contentWindow.document.body.style.paddingTop = '1px';
              element[0].contentWindow.document.body.style.paddingBottom = '1px';
              element[0].contentWindow.document.body.style.margin = '0';
            }
            iFramePadding = parseInt(window.getComputedStyle(element[0].parentNode).paddingTop);
            iFramePadding = 0;
            element.css('width', '100%');
            element.css('height', (iFrameHeight + iFramePadding) + 'px');
            element.css('min-width', '240px');
            element[0].contentWindow.document.getElementsByTagName('html')[0].style['overflow'] = 'hidden';

            $interval.cancel(resizeInterval);
            resizeInterval = $interval(function() {
                if (!element[0].contentWindow.document.body) {
                    return;
                }
                if(element[0].contentWindow.document.body.offsetHeight !== iFrameHeight) {
                    iFrameHeight = element[0].contentWindow.document.body.offsetHeight;
                    element.css('height', (iFrameHeight + iFramePadding) + 'px');
                }
            }, 50);
        });

        element.on('$destroy', function(){
            $interval.cancel(resizeInterval);
        });
    }
}}]);

app.directive('iframeSetOpenSansFont', [function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('load', function () {
                var iFrameDocument = element[0].contentWindow.document;
                var head = iFrameDocument.head || iFrameDocument.getElementsByTagName('head')[0];
                var css = "body { font-family: 'Open Sans', sans-serif; }";
                var style = iFrameDocument.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(iFrameDocument.createTextNode(css));
                }
                head.appendChild(style);
            });
        }
    }
}]);

app.directive('includeReplace', function () {
    return {
        require: 'ngInclude',
        restrict: 'A', /* optional */        
        link: function (scope, el, attrs) {
            el.replaceWith(el.children());
        }
    };
});

// angular.module("lmsClientApp").directive('includeReplace', function () {
//     return {
//         require: 'ngInclude',
//         restrict: 'A',
//         compile: function (tElement, tAttrs) {
//             tElement.replaceWith(tElement.children());
//             return {
//                 post: angular.noop
//             };
//         }
//     };
// });
app.directive('sgLogin', ['$rootScope', '$mdDialog', 'lmsConfig', '$auth', function ($rootScope, $mdDialog, lmsConfig, $auth) {
    'use strict';

    return {
        restrict: 'EA',        
        scope: {},
        replace: true,
        transclude: false,
        template: '<button class="lms-login-container" ng-click="signInOut($event)">{{buttonText}}</button>',
        link: function (scope, element, attrs, ctrl) {                                    
            
            scope.$watch(function() {
                return $rootScope.user.signedIn;
            }, function(value) {
                scope.buttonText = value ? "Выйти" : "Войти";
            })
            
            scope.signInOut = function(ev) {
                if($rootScope.user.signedIn) {
                    scope.logOut();
                } else {
                    scope.showLoginDialog(ev);
                }
            };
            
            scope.showLoginDialog = function(ev) {                 

                $mdDialog.show({
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controller: function($scope, $mdDialog, $auth) {
                        $scope.user = {
                            login: '',
                            pass: ''
                        };
                        
                        $scope.hide = function() {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function() {
                            $mdDialog.cancel();
                        };
                        $scope.answer = function(answer) {
                            $mdDialog.hide(answer);
                        };

                        $scope.signIn = function(form) {
                            $auth.submitLogin(form).then(function(resp) {
                                $scope.hide();
                                console.log("login success: ", resp);
                            }).catch(function(resp) {
                                console.log("login failed: ", resp);
                            });
                        };           
                    },
                    templateUrl: 'views/login.html',
                    targetEvent: ev,
                })
                .then(function(answer) {}, function() {});
            };
            
            scope.logOut = function() {                
                $auth.signOut().then(function(){}).catch(function(){});
            };            
        }
    }
}]);
app.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$eval(attr.onFinishRender);
                });
            }
        }
    }
});
'use strict';

angular.module('lmsClientApp')
.directive('showTail', function () {
    return function (scope, elem, attr) {
        scope.$watch(function () {
            return elem[0].scrollHeight;
        }, function (v) {
            if (!attr.showTail || attr.showTail === 'true') {
                elem[0].scrollTop = v;
            }
        });
    };
});

app.directive('lmsCompile', ['$compile', '$parse', function ($compile, $parse) {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        link: function(scope, element, attr) {
            scope.$watch(attr.content, function() {
                element.html($parse(attr.content)(scope));
                $compile(element.contents())(scope);
            }, true);
        }
    }
}]);

/* globals $ */
'use strict';

angular.module('lmsClientApp')
    .directive('passwordStrengthBar', function () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            link: function (scope, iElement, attr) {
                var strength = {
                    colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                    mesureStrength: function (p) {

                        var _force = 0;
                        var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                        var _lowerLetters = /[a-z]+/.test(p);
                        var _upperLetters = /[A-Z]+/.test(p);
                        var _numbers = /[0-9]+/.test(p);
                        var _symbols = _regex.test(p);

                        var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                        var _passedMatches = $.grep(_flags, function (el) {
                            return el === true;
                        }).length;

                        _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                        _force += _passedMatches * 10;

                        // penality (short password)
                        _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                        // penality (poor variety of characters)
                        _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                        _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                        _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                        return _force;

                    },
                    getColor: function (s) {

                        var idx = 0;
                        if (s <= 10) {
                            idx = 0;
                        }
                        else if (s <= 20) {
                            idx = 1;
                        }
                        else if (s <= 30) {
                            idx = 2;
                        }
                        else if (s <= 40) {
                            idx = 3;
                        }
                        else {
                            idx = 4;
                        }

                        return { idx: idx + 1, col: this.colors[idx] };
                    }
                };
                scope.$watch(attr.passwordToCheck, function (password) {
                    if (password) {
                        var c = strength.getColor(strength.mesureStrength(password));
                        iElement.removeClass('ng-hide');
                        iElement.find('ul').children('li')
                            .css({ 'background': '#DDD' })
                            .slice(0, c.idx)
                            .css({ 'background': c.col });
                    }
                });
            }
        };
    });

'use strict';

angular.module('lmsClientApp')
    .directive('watchWidth', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                'watchWidth' : "="
            },
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return parseInt(window.getComputedStyle(element[0]).getPropertyValue('width'));
                }, function(newVal, oldVal) {
                    $timeout(function() {
                        scope.$apply(function() {
                            scope.watchWidth(newVal)
                        });
                    })
                });
            }
        };
    }]);

'use strict';

app.directive('lmsDateTime', [
  'lmsConfig',
  '$timeout',
  '$rootScope',
  function(lmsConfig, $timeout, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        dtDateTime: '=?',
        dtReadonly: '=?',
        dtHourStep: '=?',
        dtMinuteStep: '=?',
        dtShowMeridian: '=?',
        dtMinDate: '=?'
      },
      // templateUrl: lmsConfig.componentsPath + 'views/_dateTime.html',
      template: '<form>' +
        '<div class="form-group">' +
        '<div layout="row" layout-align="start center" class="lms-date-time-picker" layout-wrap>' +
        '<div>' +
        '<md-datepicker ng-model="dtDateTime.date" ng-disabled="dtReadonly" md-min-date="dtMinDate"></md-datepicker>' +
        '<md-tooltip md-direction="down">Дата</md-tooltip>' +
        '</div>' +
        '<div>' +
        '<md-icon class="md-icon-button">' +
        '<svg style="width:24px;height:24px;padding-bottom:3px;" viewBox="0 0 24 24">' +
        '<path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>' +
        '</svg>' +
        '</md-icon>' +
        '<select ng-model="selectedHour" ng-options="hour for hour in hours" class="video-conf-time"></select>' +
        '<select ng-model="selectedMinute" ng-options="minute for minute in minutes" class="video-conf-time"></select>' +
        '</div>' +
        '</div>' +
        '</form>',
      link: function(scope, element, attrs) {
        var defaultHourStep = 1, defaultMinuteStep = 10, defaultShowMeridian = false;
        scope.dtHourStep = scope.dtHourStep ? scope.dtHourStep : defaultHourStep;
        scope.dtMinuteStep = scope.dtMinuteStep ? scope.dtMinuteStep : defaultMinuteStep;
        scope.dtShowMeridian = scope.dtShowMeridian !== void 0 && scope.dtShowMeridian !== null
          ? scope.dtShowMeridian
          : defaultShowMeridian; /*** Получаем время начала конференции ***/
        (scope.hours = []), (scope.minutes = []);
        var now = new Date();
        for (var i = 0; i < 24; i++) {
          if (i < 10) {
            i = '0' + i;
          }
          scope.hours.push(i);
        }
        for (var i = 0; i < 60; i++) {
          if (i < 10) {
            i = '0' + i;
          }
          scope.minutes.push(i);
        } // Устанавливанем дефолтные значения времени
        scope.selectedHour = scope.hours[0];
        scope.selectedMinute = scope.minutes[0]; // Наблюдаем за изменением времени
        scope.$watch(
          function() {
            return scope.selectedHour;
          },
          function() {
            scope.dtDateTime.time.setHours(scope.selectedHour);
            scope.dtDateTime.time.setMinutes(scope.selectedMinute);
          }
        );
        scope.$watch(
          function() {
            return scope.selectedMinute;
          },
          function() {
            scope.dtDateTime.time.setHours(scope.selectedHour);
            scope.dtDateTime.time.setMinutes(scope.selectedMinute);
          }
        ); /*** ***/
        $timeout(function() {
          var timeInput = document.getElementsByClassName('dialog-time')[0];
          if (timeInput && timeInput.type !== 'time') {
            $('.dialog-time').addClass('dialog-time-fix');
          }
        });
        var input = element.children()[0],
          datePicker = input.children[0],
          dateContainer = datePicker.children[
            1
          ]; /* При выборе даты пользователь имеет возможность вбить её в ручную.
            * В этом случае директива ng-change не срабатывает, поэтому мы
            * используем вотчер, чтобы засечь класс, характерный для неверной даты
            */
        scope.$watch(
          function() {
            return dateContainer.className;
          },
          function(data) {
            if (/md-datepicker-invalid/.test(data)) {
              $rootScope.invalidDate = true;
            } else
              $rootScope.invalidDate = false;
          }
        );
      }
    };
  }
]);

'use strict';

app
    .directive('mathjaxBind', ['$sce', function ($sce) {
        return {
            restrict: "A",
            controller: ["$scope", "$element", "$attrs", function ($scope, $element, $attrs) {
                var $script = angular.element("<script type='math/tex'>")
                    .html($attrs.mathjaxBind == undefined ? "" : $attrs.mathjaxBind);
                $element.html("");
                $element.append($script);
                MathJax.Hub.Queue(["Reprocess", MathJax.Hub, $element[0]]);
            }]
        };
    }]);

'use strict';

function collapsingRowLink(scope, element, attrs) {
    var collectionHas,
        findParentBySelector;

    collectionHas = function (a, b) {
        for (var i = 0, len = a.length; i < len; i++) {
            if (a[i] == b) return true;
        }
        return false;
    };

    findParentBySelector = function (elm, selector) {
        var all = document.querySelectorAll(selector);
        var cur = elm.parentNode;
        while (cur && !collectionHas(all, cur)) {
            cur = cur.parentNode;
        }
        return cur;
    };

    element[0].addEventListener('click', function (e) {
        var target = e.target,
            isText = target.classList.contains('toggle-collapse-text'),
            collapseBlock,
            collapseItems,
            collapseItem,
            toggle,
            i;

        if (target.classList.contains('toggle-collapse') || isText) {
            collapseBlock = findParentBySelector(target, '.collapse-block');
            collapseItems = collapseBlock.querySelectorAll('.collapse');

            for (i = 0; i < collapseItems.length; i++) {
                collapseItem = collapseItems[i];
                if (collapseItem.parentElement === collapseBlock) {
                    collapseItem.classList.toggle('hidden');
                }
            }

            if (isText) {
                toggle = findParentBySelector(target, '.tb-row').querySelector('.toggle-collapse');
            } else {
                toggle = target;
            }

            toggle.innerHTML = (toggle.innerHTML === '+' ? '-' : '+');
        }
    });
}

app.directive('studentCollapsingRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'journal/views/_studentCollapsingRow.html',
            link: collapsingRowLink
        }
    }])
    .directive('teacherCollapsingRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'journal/views/_teacherCollapsingRow.html',
            link: collapsingRowLink
        }
    }])
    .directive('studentCollapsingOlymicRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'journal/views/_studentCollapsingOlymicRow.html',
            link: collapsingRowLink
        }
    }])
    .directive('distanceEducationCoordinatorJournalCollapsingRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'journal/views/_distanceEducationCoordinatorCollapsingRow.html',
            link: collapsingRowLink
        }
    }])
    .directive('managerStatisticsCollapsingRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'statistics/views/_managerCollapsingRow.html',
            link: collapsingRowLink
        }
    }])
    .directive('methodologistStatisticsCollapsingRow', ['lmsConfig', function (lmsConfig) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'statistics/views/_methodologistCollapsingRow.html',
            link: collapsingRowLink
        }
    }]);

app.directive('toggleAllCollapsingRows', ['$auth', function ($auth) {
        return {
            restrict: 'E',
            replace: false,
            template: '<md-button class="ButtonDarkBlue" ng-click="toggleAllRows()">{{allOpened ? "Свернуть все" : "Развернуть все"}}</md-button>',
            link: function (scope, element, attrs) {

                scope.allOpened = true;

                scope.toggleAllRows = function() {
                    scope.allOpened = !scope.allOpened;
                    run();
                };

                function run() {
                    var c = document.querySelectorAll('.collapse'), i;
                    if(!c || c.length === 0) {
                        setTimeout(function() {
                            run();
                            scope.$apply();
                        }, 500);
                        return false;
                    }
                    for (i = 0; i < c.length; i++) {
                        if(scope.allOpened) {
                            c[i].classList.remove('hidden');
                        } else {
                            c[i].classList.add('hidden');
                        }
                        $(c[i]).parent(".collapse-block").find(".toggle-collapse").html(c[i].classList.contains("hidden") ? "+" : "-");
                    }
                }

                function init() {
                    var rolesForCloseInStart = [
                        'ROLE_HEAD_TEACHER',
                        'ROLE_DEPUTY_HEAD_TEACHER',
                        'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                        'ROLE_LOCATION_COORDINATOR'
                    ];
                    if($auth.isInAnyRole(rolesForCloseInStart)) {
                        scope.allOpened = false;
                    }
                    run();
                }

                init();
            }
        }
    }]);

'use strict';

app.directive('lmsLoadingSpinner', ['$http', function ($http) {
    return {
        restrict: 'A',
        transclude: true,
        replace: true,
        template: '<div>' +
            '<div ng-hide="loaded" class="lms-loading-spinner-container"></div>' +
            '<div ng-show="loaded" ng-transclude></div>' +
            '</div>',
        scope: {
            loaded: '=lmsLoadingSpinner'
        },
        link: function (scope, element, attrs) {
            var spinner = new Spinner().spin(),
                loadingContainer = element.find('.lms-loading-spinner-container')[0];

            loadingContainer.appendChild(spinner.el);
            if (!attrs.lmsLoadingSpinner) {
                scope.loaded = true;
            }
        }
    };
}]);

angular.module('lmsClientApp')
    .filter('nl2br', function() {
        return function(input) {
            return input ? input.replace(/\n/g, '<br>') : input;
        };
    });

angular.module('lmsClientApp')
    .filter('trustHtml', ['$sce', function($sce) {
            return function(value, type) {
                // Defaults to treating trusted text as `html`
                return $sce.trustAs(type || 'html', value);
            }
        }
    ])

angular.module('lmsClientApp')
    .filter('htmlToPlaintext', function() {
        return function(text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : text;
        };
    });

angular.module('lmsClientApp')
    .filter('setDecimal', function () {
        return function (input, places) {
            if (isNaN(input)) return input;
            // If we want 1 decimal place, we want to mult/div by 10
            // If we want 2 decimal places, we want to mult/div by 100, etc
            // So use the following to create that factor
            var factor = "1" + Array(+(places > 0 && places + 1)).join("0");
            return Math.round(input * factor) / factor;
        };
    });

angular.module('lmsClientApp')
    .filter('phone', function() {
        return function(text) {

            if(!text)
                return '';

            var value = text.toString().trim().replace(/^\+/, '').replace(/[^0-9]+/g, '');

            var country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = "7";
            }

            number = number.slice(0, 3) + '-' + number.slice(3,5) + '-' + number.slice(5);

            return ('+' + country + " (" + city + ") " + number).trim();
        };
    });

"use strict";

/**
 * @ngdoc controller
 * @name lmsClientApp.LoginCtrl
 * @description
 * # LoginCtrl
 * Controller for login page
 */
angular.module("lmsClientApp").controller("LoginCtrl", [
    "$scope",
    "rest",
    "$auth",
    "lmsConfig",
    "StatisticActivity",
    "$state",
    "Account",
    "$window",
    "CruduserResource",
    "UserSettingsResource",
    "Users",
    "OAuthResource",
    "LmsSystemInfoResource",
    'usSpinnerService',
    '$timeout',
    '$rootScope',
    '$http',
    'u2035',
    "U2035Service",
    function (
        $scope,
        rest,
        $auth,
        lmsConfig,
        StatisticActivity,
        $state,
        Account,
        $window,
        CruduserResource,
        UserSettingsResource,
        Users,
        OAuthResource,
        LmsSystemInfoResource,
        usSpinnerService,
        $timeout,
        $rootScope,
        $http,
        u2035,
        U2035Service
    ) {

        // For ChatStart
        $scope.integration = null;

        init();
        function init() {
            if (u2035) {
                $scope.integration = 'u2035';
            }
        }


        $scope.chatIsOpen = false
        $scope.dataFront = {
            1: { id:1, type: "ChatConsultant", text: 'Какой у вас вопрос?', nextId: 11},
            // 2: { id:222, type: "ChatConsultantPicture", url: 'Уточните, что относительно курсов вас интересует?', nextId: 211},
            11: { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

            111: { id:111, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно электронного журнала?', nextId: 1111},
            1111: { id:1111, type: 'v', options: [
                    {
                        text: "Как выставить отметку за урок",
                        nextId: 11111
                    },
                    {
                        text: "Как посмотреть результаты всего класса по уроку?",
                        nextId: 11112
                    },
                    {
                        text: "Как перейти к проверке выполненных заданий из электронного журнала?",
                        nextId: 11113
                    }
                ] },
            11111:  { id:11111, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. В графе 'Отметка' за урок есть возможность выставить отметку вручную с помощью ниспадающего меню. В эту графу можно выставить отметку за работу ученика на онлайн-уроке или иной вид работы. Обратите внимание, что выставленную отметку можно исправить в любое время.", nextId: 111111},
            111111: { id:111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111111},
            1111111: { id:1111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11111111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11112:  { id:11112, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. На странице со списком учеников нажмите кнопку 'Перейти к результатам класса по уроку'. У вас откроется нужная страница.",
                nextId: 111121},
            111121: { id:111121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111211},
            1111211: { id:1111211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11112111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            111121111: { id:111121111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},
            11113:  { id:11113, type: "ChatConsultant", text: "Перейдите в меню “Электронный журнал”, выберите нужную группу. На странице со списком ученик нажмите на ФИО ученика. Далее наведите курсором мыши на ячейку “ЗОО” или “Домашнее задание” и кликните по ячейке. У вас откроется список заданий, назначенных выбранному ученику.\n",
                nextId: 111131},
            111131: { id:111131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111311},
            1111311: { id:1111311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11113111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11113111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            112: { id:112, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно доступа к системе?', nextId: 1121},
            1121: { id:1121, type: 'v', options: [
                    {
                        text: "Как изменить/сбросить свой пароль",
                        nextId: 11211
                    },
                    {
                        text: "Не могу войти в систему, что делать?",
                        nextId: 11212
                    },
                    {
                        text: "Как получить доступ к системе?",
                        nextId: 11213
                    },
                    {
                        text: "Как восстановить доступ?",
                        nextId: 11214
                    }
                ] },
            11211: { id:11211, type: "ChatConsultant", text: 'Чтобы изменить свой пароль, нажмите на кнопку в правом верхнем углу экрана и выберите пункт “Сменить пароль”:', nextId: 112111},
            112111: { id:112111, type: "ChatConsultantPicture", url: "images/chathelp/password.png", nextId: 1121111},
            1121111: { id:1121111, type: "ChatConsultant", text: "В окне 'Смена пароля' в поле 'Новый пароль' укажите свой новый пароль. Не менее 6 знаков. Подтвердите пароль в поле ниже и нажмите 'Сохранить'. Для отмены и закрытия окна нажмите 'Отмена' или крестик в верхнем правом углу окна.\n", nextId: 11211111},
            11211111: { id:11211111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112111111 },
            112111111: { id:112111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1121111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    },
                ] },
            1121111111: { id:1121111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            11212: { id:11212, type: "ChatConsultant", text: 'Сначала проверьте правильность ссылки в адресной строке браузера по которой вы хотите зайти в систему. ',
                nextId: 112121},
            112121: { id:112121, type: "ChatConsultantPicture", url: "images/chathelp/112121.png", nextId: 1121211},
            1121211: { id:1121211, type: "ChatConsultant", text: 'Далее проверьте правильность ввода логина и пароля. Если вы уверены в правильности ссылки, логина и пароля, но не можете войти в систему, напишите в службу поддержки или системному администратору.',
                nextId: 11212111},
            11212111: { id:11212111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112121111},
            112121111: { id:112121111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 112121111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1121211111: { id:1121211111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11213: { id:11213, type: "ChatConsultant", text: 'Для получения логина и пароля от системы обратитесь к вашему администратору школы. Если вы ученик, то обратитесь к своему учителю.',
                nextId: 112131},
            112131: { id:112131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121311},
            1121311: { id:1121311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11213111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11213111: { id:11213111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11214: { id:11214, type: "ChatConsultant", text: 'Если вы потеряли свой логин и пароль от системы МЭО, напишите обращение в техподдержку с помощью кнопки “Помощь” в нижнем правом углу.',
                nextId: 112141},
            112141: { id:112141, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121411},
            1121411: { id:1121411, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11214111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11214111: { id:11214111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            113: { id:113, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1131},
            1131: { id:1131, type: 'v', options: [
                    {
                        text: "Как посмотреть список доступных мне курсов",
                        nextId: 11311
                    },
                    {
                        text: "Я не вижу свои курсы, как мне их подключить",
                        nextId: 11312
                    },
                    {
                        text: "Как посмотреть тематическое планирование курса",
                        nextId: 11313
                    },
                    {
                        text: "Как посмотреть оглавление курса",
                        nextId: 11314
                    },
                    {
                        text: "Как перейти к просмотру задания к занятию",
                        nextId: 11315
                    },
                    {
                        text: "Как посмотреть список всех заданий в уроке",
                        nextId: 11316
                    },
                    {
                        text: "Как выполнить задание с открытым ответом",
                        nextId: 11317
                    }
                ] },
            11311: { id:11311, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. На странице у вас отобразится список доступных вам курсов. Для подключения дополнительных курсов по другим предметам и классам обратитесь к своему администратору школы.',
                nextId: 113111},
            113111: { id:113111, type: "ChatConsultantPicture", url: "images/chathelp/113111.png", nextId: 1131111},
            1131111: { id:1131111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11311111},
            11311111: { id:11311111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113111111: { id:113111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11312: { id:11312, type: "ChatConsultant", text: 'Если в Библиотеке курсов не отображаются нужные вам учебники, то для подключения необходимо обратится к своему учителю или администратору системы.',
                nextId: 113121},
            113121: { id:113121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131211},
            1131211: { id:1131211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11312111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113121111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11313: { id:11313, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на иконку с восклицательным знаком в нижнем правом углу обложки курса. У вас откроется окно с описанием курса и тематическим планом.',
                nextId: 113131},
            113131: { id:113131, type: "ChatConsultantPicture", url: "images/chathelp/113131.png", nextId: 1131311},

            1131311: { id:1131311, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11313111},
            11313111: { id:11313111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113131111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113131111: { id:113131111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11314: { id:11314, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков.',
                nextId: 113141},
            113141: { id:113141, type: "ChatConsultantPicture", url: "images/chathelp/113141.png", nextId: 1131411},

            1131411: { id:1131411, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11314111},
            11314111: { id:11314111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113141111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113141111: { id:113141111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11315: { id:11315, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'.Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков. Нажмите на название занятия. У вас откроется страница с оглавлением занятия. Выберите пункт \'Задание к занятию\'.',
                nextId: 113151},
            113151: { id:113151, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131511},
            1131511: { id:1131511, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11315111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11315111: { id:11315111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11316: { id:11316, type: "ChatConsultant", text: 'Нажмите на кнопку \'Итоговая страница урока\'.',
                nextId: 113161},
            113161: { id:113161, type: "ChatConsultantPicture", url: "images/chathelp/113161.png", nextId: 1131611},

            1131611: { id:1131611, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11316111},
            11316111: { id:11316111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113161111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113161111: { id:113161111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11317: { id:11317, type: "ChatConsultant", text: 'Чтобы выполнить задание с открытым ответом, нужно воспользоваться формой, которая открывается при нажатии на ссылку «Приступить к выполнению». ',
                nextId: 113171},
            113171: { id:113171, type: "ChatConsultantPicture", url: "images/chathelp/113171.png", nextId: 1131711},
            1131711: { id:1131711, type: "ChatConsultant", text: 'Чтобы ответить на задание, нужно ввести свой ответ в поле для ввода ответа. Для прикрепления файла к сообщению, нужно воспользоваться кнопкой «Прикрепить». Для прикрепления голосового сообщения нужно воспользоваться кнопкой «Записать голосовое сообщение». Для прикрепления рисунка нужно воспользоваться кнопкой «Нарисовать», далее с помощью графического редактора нарисовать изображение и сохранить рисунок. При нажатии кнопки «Сохранить» ответ сохраняется, но остаётся доступным только учащемуся. В него можно вносить любые изменения: исправлять текст, прикреплять и удалять файлы. При нажатии кнопки «Отправить», происходит отправка ответа на задание учителю.', nextId: 11317111},
            11317111: { id:11317111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 113171111},
            113171111: { id:113171111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1131711111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1131711111: { id:1131711111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            115: { id:115, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1151},
            1151: { id:1151, type: 'v', options: [
                    {
                        text: "Как назначить домашнее задание ученику?",
                        nextId: 11511
                    },
                    {
                        text: "Как установить срок выполнения заданий по уроку для всех учеников?",
                        nextId: 11512
                    }
                ] },
            11511: { id:11511, type: "ChatConsultant", text: 'Существует две возможности назначения заданий. Во-первых, задание можно назначить для выполнения на уроке. Для этого щелкните на ячейку таблицы и выберите в меню строку «Назначить». Во-вторых, задание можно назначить в качестве домашнего задания. Для этого щелкните по ячейке матрицы и выберите в меню строку «Назначить как ДЗ».\n',
                nextId: 115111},
            115111: { id:115111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151111},
            1151111: { id:1151111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1151111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11511111: { id:11511111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11512: { id:11512, type: "ChatConsultant", text: 'В Матрице назначения заданий можно установить срок выполнения назначенных заданий для всего класса. Для этого нажмите кнопку “Установить срок выполнения заданий”, далее выберите дату и время сдачи заданий и нажмите “Установить”. Установленный срок выполнения заданий отобразиться у всех учащихся в подсистеме “Органайзер и в подсистеме “Индивидуальная образовательная траектория”.',
                nextId: 115121},
            115121: { id:115121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151211},
            1151211: { id:1151211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11512111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11512111: { id:11512111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            118: { id:118, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1181},
            1181: { id:1181, type: 'v', options: [
                    {
                        text: "Как создать конференцию?",
                        nextId: 11811
                    },
                    {
                        text: "Как войти в конференцию/подключить к конференции?",
                        nextId: 11812
                    }
                ] },
            11811: { id:11811, type: "ChatConsultant", text: 'Чтобы создать видеоконференцию, нажмите кнопку «Создать видеоконференцию». После этого откроется форма для создания видеоконференции. В верхней строке введите название видеоконференции, укажите дату и время еѐ проведения, добавьте участников, выбрав их из списка пользователей системы. После этого нажмите кнопку «Создать видеоконференцию».',
                nextId: 118111},
            118111: { id:118111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181111},
            1181111: { id:1181111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11811111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11811111: { id:11811111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11812: { id:11812, type: "ChatConsultant", text: 'Чтобы войти в видеоконференцию, нажмите кнопку «Начать», если конференция не начата и кнопку «Подключиться», если конференция уже началась.\n',
                nextId: 118121},
            118121: { id:118121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181211},
            1181211: { id:1181211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11812111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11812111: { id:11812111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            110: { id:110, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1101},
            1101: { id:1101, type: 'v', options: [
                    {
                        text: "Как изменить фотографию личного профиля?",
                        nextId: 11011
                    },

                ] },
            11011: { id:11011, type: "ChatConsultant", text: 'Нажмите на ФИО в верхнем правом углу системы. ',
                nextId: 110111},
            110111: { id:110111, type: "ChatConsultantPicture", url: "images/chathelp/110111.png", nextId: 1101111},
            1101111: { id:1101111, type: "ChatConsultant", text: ' На странице личного профиля нажмите кнопку “Изменить” рядом с фото. Выберите фото на своем устройстве. Рекомендованный размер фото не менее 500Х500px. Далее нажмите кнопку “Сохранить”, чтобы сохранить внесенные изменения.\n',
                nextId: 11011111},
            11011111: { id:11011111, type: "ChatConsultantPicture", url: "images/chathelp/11011111.png", nextId: 110111111},

            110111111: { id:110111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1101111111},
            1101111111: { id:1101111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11011111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11011111111: { id:11011111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

        }


        $scope.imgUrl = "images/chathelp/password.png"
        $scope.currentIdForStepBack
        // $scope.goToNextId = function (nextId) {
        //     $scope.currentId = nextId
        //     console.log( $scope.currentId)
        //     console.log($scope.dataFront[nextId])
        //     var a = $scope.dataFront[nextId].nextId
        //     $scope.printedChatElements.push($scope.dataFront[nextId])
        //
        //     var b = $scope.dataFront[nextId].nextId
        //     console.log(b)
        //     var c = $scope.dataFront[b]
        //     console.log(c)
        //     // if (c.type == "v"){
        //     //     alert("v")
        //     // } else {
        //     //     $scope.goToNextId(a)
        //     // }
        //     // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
        //     //
        //     // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
        //     //
        //     // }
        //     // $scope.goToNextId($scope.dataFront[nextId].nextId)
        //     $scope.goToNextId(a)
        // }

        $scope.goToNextId = function (nextId) {
            console.log(nextId)
            if ($scope.dataFront[nextId].type == "ChatConsultant"){
                // alert("b")
                $scope.addConsultantMessage(nextId)
            } else if ($scope.dataFront[nextId].type == "v"){
                // alert("a")
                $scope.addBtnGroup(nextId)
            } else if ($scope.dataFront[nextId].type == 'ChatConsultantPicture'){
                $scope.addConsultantMessage(nextId)
            }

            // if (c.type == "v"){
            //     alert("v")
            // } else {
            //     $scope.goToNextId(a)
            // }
            // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
            //
            // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
            //
            // }
            // $scope.goToNextId($scope.dataFront[nextId].nextId)

        }

        $scope.addConsultantMessage = function (nextId) {

            $scope.currentIdForStepBack = nextId
            var a = $scope.dataFront[nextId].nextId
            $scope.printedChatElements.push($scope.dataFront[nextId])
            $scope.goToNextId(a)
        }

        $scope.addBtnGroup = function (nextId) {
            var a = $scope.dataFront[nextId].nextId
            $scope.printedChatElements.push($scope.dataFront[nextId])
            $scope.goToNextId(a)
        }


        $scope.stepBackBase = function () {

            $scope.stepBack($scope.currentIdForStepBack)
        }
        $scope.stepBack = function (id1) {
            var id = id1
            console.log(id)
            var stringId = id.toString()
            var a =  stringId.slice(0, -1);
            var b = $scope.dataFront[a]
            console.log(b)
            if (b.type == 'v'){
                // alert('aa')
                var newStringId = b.id.toString()
                console.log(newStringId)
                var c =  newStringId.slice(0, -1);
                console.log(c)
                var d = $scope.dataFront[c]
                console.log(d)
                $scope.currentIdForStepBack = d.id
                $scope.printedChatElements.push(d)

                $scope.printedChatElements.push(b)


            } else {
                $scope.stepBack(a)
            }
        }




        $scope.printedChatElements = [
            { id:1, type: "ChatConsultant", text: 'Относительно какой из подсистем у вас вопрос?', nextId: 11},
            { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

        ]

        $scope.addElementToPrintedElements = function (option) {
            var b = {
                minutes: new Date().getMinutes(),
                hours: new Date().getHours()
            }
            var a =  { type: "ChatVisitor", text: option.text, time: b }
            $scope.printedChatElements.push(a)
        }
        $scope.deleteQuestionBlock = function (id) {
            $scope.printedChatElements =  $scope.printedChatElements.filter(function (el) {
                return el.id !== id
            })
        }

        $scope.date ={
            minutes: new Date().getMinutes(),
            hours: new Date().getHours()
        }



        $scope.processChoosing = function (option){

            if (option.nextId == 0){
                $scope.showHelpForm()
            } else {
                console.log(option)
                var a = option.nextId.toString()
                var b = a.slice(0, -1)
                var c = parseInt(b)
                $scope.deleteQuestionBlock(c)
                $scope.addElementToPrintedElements(option)
                $scope.goToNextId(option.nextId)
                console.log(option.nextId)
                console.log($scope.dataFront[option.nextId])
                var d = $scope.dataFront[option.nextId]
                console.log(d)
                console.log(d.nextId)
                $scope.goToNextId(d.nextId)
            }


        }



        $scope.switchChatShowind = function () {
            $scope.chatIsOpen = ! $scope.chatIsOpen
        }

        // $scope.goToNextId(1)
        // for chatEnd






        /* /clientCode */
        // $scope.clientCodeLoading = true;
        // $scope.clientCodeLoading = false;
        // $scope.clientCode = ''; // asi | meo | school_109; edu3
        // $scope.clientCode = 'edu3';

        $timeout(function () {
            // usSpinnerService.spin('spinLoginPage');
        }, 100);
        $rootScope.$watch(
            function () {
                return $rootScope.clientCode;
            },
            function (clientCode) {
                if (clientCode !== null) {
                    $scope.clientCode = clientCode;
                    $scope.clientCodeLoading = false;
                    // usSpinnerService.stop('spinLoginPage');
                }
            }
        );
        /* /clientCode */

        // Variables
        /**
         * @property {Object} auth error object
        */
        $scope.authError = [];

        if ($state.params && $state.params.oauth) {
            $scope.oAuthError = $state.params.oauth
        }
        // Methods
        $scope.signIn = signIn;

        // NotificationsService.getAll(function (result) {
        //     console.log(result);
        //     $scope.notifications = result;
        // })
        function authEljur() {
            OAuthResource.getOauthEJClientId().$promise.then(function (res) {
                var client_id = res.value;
                OAuthResource.getOauthEJRedirectUrl().$promise.then(function (res) {
                    var ej_redirect_uri = res.value;
                    if (client_id && ej_redirect_uri) {
                        $window.location.href = "https://cop.admhmao.ru/auth/mob-edu?client_id=" +
                            client_id +
                            "&response_type=code&redirect_uri=" +
                            ej_redirect_uri +
                            "&state=EJ";
                    }
                });
            });
        }
        $scope.authEljur = authEljur;

        function authTat() {
            OAuthResource.getOauthTATClientId().$promise.then(function (res) {
                var client_id = res.value;
                var ej_redirect_uri = res.value;
                if (client_id && ej_redirect_uri) {
                    $window.location.href = "https://edu.tatar.ru/oauth/authorize?client_id=" +
                        client_id +
                        "&response_type=code&state=TAT";
                }
            });
        }
        $scope.authTat = authTat;
        $scope.auth2035 = U2035Service.redirectToAuthPage;

        /**
            * @memberof LoginCtrl
            * @function signIn
            * @param form {Object} login form
            * @description send login form to server
        */
        function signIn(form) {

            $scope.clientCodeLoading2 = true
            if (!form) {
                return;
            }
            $scope.authError = [];

            if (!(
                !!form.username
                && !!form.password
            )) {
                $scope.authError = [
                    'loginOrErrorEmpty'
                ];
                return;
            }

            $scope.clientCodeLoading = true
            $timeout(function () {
                usSpinnerService.spin('spinLoginPage');
            }, 100);

            if (form.username === void 0 || form.password === void 0) {
                form.username = document.getElementById("login").username.value;
                form.password = document.getElementById("login").password.value;
                if (form.username === "" || form.password === "") {
                    throw new Error("Form doesn't contain valid fields");
                }
            }

            $auth
                .submitLogin(form)
                .then(function (resp) {
                    $auth.loadAccountInfo().then(function (result) {
                        // 1. Отправка после авторизации
                        StatisticActivity.sendVisitLogin($auth.user.id);

                        Users.getProfile(function (res) { });
                        if (result.userRoles && result.userRoles.length > 0) {
                            if (result.userRoles.indexOf("ROLE_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $state.go("dashboard");
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_LOCAL_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_LOCAL_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $state.go("dashboard");
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_SCHOOL_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_SCHOOL_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $state.go("dashboard");
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_COURSE_DEVELOPER") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_COURSE_DEVELOPER" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $window.location.href = lmsConfig.mainDomain;
                                    }
                                });
                            } else {
                                $state.go("dashboard");
                            }
                        } else {
                            $state.go("login");
                        }
                    });
                })
                .catch(function (resp) {
                    $scope.clientCodeLoading = false
                    $scope.clientCodeLoading2 = false
                    $scope.authError = resp.errors;
                });
        }
    }
]);

"use strict";

angular.module("lmsClientApp").controller("OAuthCtrl", [
    "$scope",
    "rest",
    "$auth",
    "lmsConfig",
    "$state",
    "Account",
    "$window",
    "CruduserResource",
    "UserSettingsResource",
    "Users",
    "OAuthResource",
    function (
        $scope,
        rest,
        $auth,
        lmsConfig,
        $state,
        Account,
        $window,
        CruduserResource,
        UserSettingsResource,
        Users,
        OAuthResource
    ) {
        $scope.authError = {};

        if ($state.params.code) {
            var redirect_url = $state.params.redirect_url;

            OAuthResource.getOAuthToken({ code: $state.params.code, state: $state.params.state }).$promise.then(function (res) {
                $auth.oauth(res).then(function (resp) {
                    $auth.loadAccountInfo().then(function (result) {
                        Users.getProfile(function (res) { });
                        if (result.userRoles && result.userRoles.length > 0) {
                            if (result.userRoles.indexOf("ROLE_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $window.location.href = lmsConfig.mainDomain;
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_LOCAL_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_LOCAL_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $window.location.href = lmsConfig.mainDomain;
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_SCHOOL_ADMIN") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_SCHOOL_ADMIN" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $window.location.href = lmsConfig.mainDomain;
                                    }
                                });
                            } else if (result.userRoles.indexOf("ROLE_COURSE_DEVELOPER") > -1) {
                                UserSettingsResource.putRole(
                                    { role: "ROLE_COURSE_DEVELOPER" },
                                    {}
                                ).$promise.then(function () {
                                    if (localStorage.getItem("adminPrevLocation")) {
                                        $window.location.href = localStorage.getItem(
                                            "adminPrevLocation"
                                        );
                                    } else {
                                        $window.location.href = lmsConfig.mainDomain;
                                    }
                                });
                            } else {
                                if (!!redirect_url) {
                                    $window.location.href = redirect_url;
                                } else {
                                    $state.go("dashboard");
                                }
                            }
                        } else {
                            $scope.authError = resp.errors;
                            $state.go("login");
                        }
                    });

                })
                    .catch(function (err) {
                        $scope.authError = err.errors;
                    });
            }).catch(function (err) {
                $state.go("login",
                    { oauth: err.data && err.data.headers }
                );
            })
        } else {
            $state.go("login", { oauth: { failure: "failed" } });
        }
    }
]);

'use strict';


/**
* @memberof lmsClientApp
* @ngdoc service
* @name Account
* @param {constant} lmsConfig main app config constant
* @param {service} $mdDialog modal windows service
* @param {service} LmsUtils app helpers
* @param {factory} AccountResource
* @description service for operations with account
*
*/
angular.module('lmsClientApp')
.service('Account', ['lmsConfig', '$mdDialog', 'LmsUtils', 'AccountResource', function (lmsConfig, $mdDialog, LmsUtils, AccountResource) {

    this.getAccount = getAccount;
    this.changePassDialog = changePassDialog;
    this.changePassword = changePassword;

    /**
     * @memberof Account
     * @function getAccount
     * @description get account from resource
     * @returns {Promise} resource promise object
     *
    */
    function getAccount() {
        return AccountResource.get(function(response) {
            makeRandomProfileUrl(response);
        }).$promise;
    }

    /**
     * @memberof Account
     * @function changePassDialog
     * @description call change password dialog
     *
    */
    function changePassDialog() {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'Account', '$state', ChangePassCtrl],
            templateUrl: lmsConfig.modulesPath + 'account/views/_changePassword.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
        })
        .then(function(answer) {
        }, function() {
        });
    }

    /**
     * @memberof Account
     * @function changePassword
     * @param {String} password string
     * @description Check if param exists and call resource method
     * @returns {Boolean|Promise}
     *
    */
    function changePassword(newPass) {
        if(newPass && newPass !== '' && !(/^\s+$/.test(newPass))) {
            return AccountResource.changePassword({}, newPass).$promise;
        }
    }

    /**
     * @memberof lmsClientApp
     * @ngdoc controller
     * @name lmsClientApp.ChangePassCtrl
     * @param $scope
     * @param $mdDialog provider
     * @param Account service
     * @param $state provider
     * @description Change password dialog controller
     *
    */
    function ChangePassCtrl($scope, $mdDialog, Account, $state) {
        $scope.password = null;
        $scope.confirmPassword = null;

        /**
         * @memberof lmsClientApp.ChangePassCtrl
         * @function save
         * @description save new account password function
         *
        */
        $scope.save = function () {
            if($scope.password !== $scope.confirmPassword) {
                LmsUtils.showSimpleToast("Пароли не совпадают");
            } else if($scope.password.length < 5) {
              LmsUtils.showSimpleToast("Пароль слишком короткий");
            } else {
                Account.changePassword($scope.password).then(function(response) {
                    LmsUtils.showSimpleToast("Пароль успешно изменен");
                    $state.go("login");
                }, function() {
                    LmsUtils.showSimpleToast("Ошибка! Пароль не изменен");
                });
            }
        };
        /**
         * @memberof lmsClientApp.ChangePassCtrl
         * @function hide
         * @description hide password dialog
         *
        */
        $scope.hide = function () {
            $mdDialog.hide();
        };
        /**
         * @memberof lmsClientApp.ChangePassCtrl
         * @function cancel
         * @description cancel changing password
         *
        */
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }

    /**
     * @memberof Account
     * @function makeRandomProfileUrl
     * @param {Object} object should contains profilePhotoPath string
     * @description append random number to image url to protect from caching
     *
    */
    function makeRandomProfileUrl(obj) {
        if(obj.profilePhotoPath) {
            obj.profilePhotoPath += "?random=" + new Date().getTime();
        }
    }
}]);

'use strict';

angular.module('lmsClientApp')
    .factory('AccountResource', function ($resource) {
        return $resource('/api/account/', {}, {
            'changePassword': {
                method: 'POST',
                url: '/admin/users/change_password'
            }
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('LmsSystemInfoResource', function ($resource) {
        return $resource('/api/lms-system-info', {}, {
            getAllLmsSystemInfoByClientCode: {
                method: 'GET',
                url: '/api/lms-system-info'
            }
        });
    });

"use strict";

angular.module("lmsClientApp").factory("OAuthResource", function($resource) {
    return $resource(
        "/auth/",
        {},
        {
            getOauthEJClientId: {
                method: "GET",
                url: "/auth/oauthEJClientId",
            },
            getOauthEJRedirectUrl: {
                method: "GET",
                url: "/auth/oauthEJRedirectUrl",
            },
            getOauthTATClientId: {
                method: "GET",
                url: "/auth/oauthTATClientId",
            },
            getOAuthToken: {
                method: "GET",
                url: "/auth/oauthAuthenticate?code=:code&state=:state",
                transformResponse: function (data, headers, status) {
                    return {headers: headers()}
                }
            }
        }
    );
});

'use strict';

angular
    .module('lmsClientApp')
    .factory('AssignmentProgressResource', function($resource) {
        return $resource(
            '/api/assignmentProgresses/',
            {},
            {
                getAllByCourseIdTopicIdAndStudentIds: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/course/:courseId/topic/:topicId?studentsIds=:studentsIds',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                    isArray: true
                },
                getAllStatisticForAssignment: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/stat/course/:courseId/topic/:topicId/group/:groupId',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                    isArray: true
                },
                getAllByCourseIdAndStudentIdsFromLesson: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/course/:courseId/lesson',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                    isArray: true
                },
                getAllByGroupIdAndCourseIdFromTopic: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/group/:groupId/course/:courseId/topic/:topicId',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                    isArray: true
                },
                getAllByCourseIdAndStudentIdsFromTopic: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/course/:courseId/topic',
                    transformResponse: function(data) {
                        data = angular.fromJson(data);
                        return data;
                    },
                    isArray: true
                },
                updateRequireAndHomeAssignmentById: {
                    method: 'PUT',
                    url: '/api/assignmentProgresses/:id/require/:require/home/:home'
                },
                updateGroupRequiresAssignment: {
                    method: 'PUT',
                    url: '/api/assignmentProgresses/listRequires'
                    // params: {
                    //     id: '@id',
                    //     require: '@require',
                    //     home: '@home'
                    // }
                },
                updateRequireForUserGroup: {
                    method: 'PUT',
                    url: '/api/assignmentProgresses/updateRequireForUserGroup'
                },
                getAllByAssignmentIdAndTeacherId: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/courses/:courseId/assignments/:imsccId/teacher',
                    isArray: true
                },
                getStatus: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/status/courses/:courseId/assignments/:imsccId/students/:userId'
                },
                getByAssignmentIdAndStudentId: {
                    method: 'GET',
                    url: '/api/assignmentProgresses/courses/:courseId/assignments/:imsccId/students/:userId'
                },
                setMark: {
                    method: 'PUT',
                    url: '/api/assignmentProgresses/mark/courses/:courseId/assignments/:imsccId/students/:userId'
                },
                publishMark: {
                    method: 'PUT',
                    url: '/api/assignmentProgresses/:id/mark/published'
                }
            }
        );
    });

'use strict';

angular.module('lmsClientApp')
    .factory('AssignmentCommentResource', function ($resource) {
        return $resource('/api/assignmentComments/courses/:courseId/assignments/:imsccId/students/:userId', {}, {
            /**
             * Get all by imsccId and current or specified user id
             */
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                url: '/api/assignmentComments/:id'
            },
            'update': {method: 'PUT'},
            'create': {method: 'POST'},
            'getUnpublished': {
                method: 'GET',
                url: '/api/assignmentComments/courses/:courseId/assignments/:imsccId/unpublished/students/:userId'

            },
            removeFile: {
                method: 'DELETE',
                url: '/api/assignmentComments/:id/files/:fileId'
            }
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('EducationalStructureResource', function ($resource) {
        return $resource('/api/educationalStructures/', {}, {
            'getSchoolsByTerritory': {
                method: 'GET',
                url: '/journal/educationalStructures/schools/territory/:territoryId',
                isArray: true
            },
            'getTerritoriesByRegion': {
                method: 'GET',
                url: '/journal/educationalStructures/territories/region/:regionId',
                isArray: true
            },
            'getEducationalTreeBySchool': {
                method: 'GET',
                url: '/journal/educationalStructures/tree/school/:schoolId?studyYear=:year',
                isArray: true
            }
        });
    });

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseCtrl
 * @description
 * # CourseCtrl
 * Controller of the lmsClientApp
 */
app.controller('CourseCtrl', [
  '$scope',
  'Course',
  '$auth',
  '$stateParams',
  'Breadcrumbs',
  function($scope, Course, $auth, $stateParams, Breadcrumbs) {
    // Variables
    $scope.activeTopic = null;
    $scope.prevTopic = null;
    $scope.nextTopic = null;
    $scope.activeLesson = null;
    $scope.prevLesson = null;
    $scope.nextLesson = null;
    $scope.course = Course.course;
    $scope.lockSidenavLeft = true;

    // Methods
    $scope.setActiveTopic = setActiveTopic;
    $scope.setActiveLesson = setActiveLesson;
    $scope.toggleSidenavLeft = toggleSidenavLeft;
    $scope.isFromBookshelf = isFromBookshelf;
    $scope.getCourseParent = getCourseParent;

    $scope.$on('activeTopic', function(event, data) {
      $scope.prevTopic = data.prev;
      $scope.activeTopic = data.cur;
      $scope.nextTopic = data.next;
    });

    $scope.$on('activeLesson', function(event, data) {
      $scope.prevLesson = data.prev;
      $scope.activeLesson = data.cur;
      $scope.nextLesson = data.next;
    });

    var JournalRoles1 = $auth.isInAnyRole(['ROLE_DEPUTY_HEAD_TEACHER', 'ROLE_DISTANCE_EDUCATION_COORDINATOR', 'ROLE_HEAD_TEACHER']); // add COORDINATOR -> MASH-373 add ROLE_HEAD_TEACHER MASH-636
    if (JournalRoles1) {
      $scope.JournalRoles1 = true;
    }

    function getCourseParent() {
      if ($scope.isFromBookshelf()) {
        return 'bookContents';
      } else if (
        $auth.isInAnyRole([
          'ROLE_REGIONAL_COORDINATOR',
          'ROLE_LOCATION_COORDINATOR',
          'ROLE_TERRITORY_COORDINATOR',
          'ROLE_DISTANCE_EDUCATION_COORDINATOR',
          'ROLE_PSYCHOLOGIST',
          'ROLE_METHODOLOGIST',
          'ROLE_HEAD_TEACHER',
          'ROLE_DEPUTY_HEAD_TEACHER',
          'ROLE_TUTOR',
          'ROLE_TEACHER'
        ])
      ) {
        return 'detailsJournalTeacher';
      } else if ($auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT'])) {
        return 'detailsJournal';
      }
      return 'dashboard';
    }

    function setActiveTopic(topic) {
      if (topic !== void 0) {
        $scope.activeTopic = topic;
      }
    }

    function setActiveLesson(lesson) {
      if (lesson !== void 0) {
        $scope.activeLesson = lesson;
      }
    }

    function toggleSidenavLeft() {
      $scope.lockSidenavLeft = !$scope.lockSidenavLeft;
    }

    function isFromBookshelf() {
      return Course.fromBookshelf;
    }

    function getBreadcrumbs() {
      // Сначала получаем роль юзера, потом загружаем хлебные крошки
      $scope.$watch(
        function() {
          return $auth.user.userRoles;
        },
        function(userRoles) {
          if (userRoles) {
            var currentRole = $auth.user.userRoles[0],
              bcsParents = Breadcrumbs.getParents(currentRole, 'Journal');
            $scope.territoryParent = bcsParents.territoryParent;
            $scope.schoolParent = bcsParents.schoolParent;
            $scope.userGroupParent = bcsParents.userGroupParent;
            $scope.courseParent = bcsParents.courseParent;
            $scope.studentParent = bcsParents.studentParent;
            $scope.detailsParent = bcsParents.detailsParent;
            $scope.managerParent = bcsParents.managerParent;
            Breadcrumbs.getNames(currentRole, 'Электронный журнал', {
              users: $stateParams.studentId,
              topic: $stateParams.tid,
              course: $stateParams.courseId,
              group: $stateParams.groupId,
              school: $stateParams.schoolId,
              territory: $stateParams.territoryId,
              region: $stateParams.regionId
            }).then(function(result) {
              $scope.regionName = result.regionName;
              $scope.territoryName = result.territoryName;
              $scope.schoolName = result.schoolName;
              $scope.userGroupName = result.userGroupName;
              $scope.courseName = result.courseName;
              $scope.studentName = result.studentName;
              $scope.topic = result.topic;
            });
          }
        }
      );
    }
    $scope.$watch(
      function() {
        return $stateParams.tid;
      },
      function(v) {
        if (v) {
          getBreadcrumbs();
        }
      },
      true
    );
    $scope.$on('needBreadcrumbsReload', function() {
      getBreadcrumbs();
    });
  }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseBarCtrl
 * @description
 * # CourseBarCtrl
 * Controller of the lmsClientApp
 */
app.controller('CourseBarCtrl', [
    '$rootScope',
    '$scope',
    '$q',
    'Course',
    'lmsConfig',
    '$state',
    '$auth',
    'CourseSectionResource',
    'ProgressResource',
    'LmsUtils',
    'UserGroupResource',
    'adaptedProgramList',
    'usSpinnerService',
    '$timeout',
    '$window',
    function(
        $rootScope,
        $scope,
        $q,
        Course,
        lmsConfig,
        $state,
        $auth,
        CourseSectionResource,
        ProgressResource,
        LmsUtils,
        UserGroupResource,
        adaptedProgramList,
        usSpinnerService,
        $timeout,
        $window
    ) {
        var canSeeOpenTaskTable = [
            'ROLE_TUTOR',
            'ROLE_TEACHER',
            'ROLE_PARENT',
            'ROLE_STUDENT',
            'ROLE_DISTANCE_EDUCATION_COORDINATOR',
            'ROLE_TERRITORY_COORDINATOR',
            'ROLE_REGIONAL_COORDINATOR',
            'ROLE_LOCATION_COORDINATOR',
            'ROLE_PSYCHOLOGIST',
            'ROLE_METHODOLOGIST',
            'ROLE_HEAD_TEACHER',
            'ROLE_DEPUTY_HEAD_TEACHER'
        ];

        // Variables
        $scope.ncyBreadcrumbIgnore = true;
        $scope.course = null;
        $scope.dropDownNav = null;
        $scope.pageTo = null;
        $scope.userId = $auth.user.id;
        $scope.state = $state;
        $scope.courseShow = true;

        // Methods
        $scope.goToPage = goToPage;
        $scope.rightNavGoToPage = rightNavGoToPage;
        $scope.studentId = $auth.user.relatedStudentId ||
            $state.params.studentId;
        $scope.toggleCourseShow = toggleCourseShow;
        /*** Сначала ждем, пока будут получены данные курса и определен activeTopic...***/
        $scope.$watch(
            function() {
                return Course.course;
            },
            function(course) {
                if (
                    course.id !== void 0 &&
                    course.topics !== void 0 &&
                    course.topics !== null &&
                    course.topics.length > 0
                ) {
                    $scope.course = course;
                    $scope.coueseWithoutZKZ = course.courseType.id === 2 || course.courseType.id === 12
                        ? true
                        : false;
                        initApp();
                }
            },
            true
        );
        // Если такой пользователь то дизаблим кнопку перехода в матрицу назначения MASH-381
        $scope.disabledMatrix = $auth.isInAnyRole([
            'ROLE_DISTANCE_EDUCATION_COORDINATOR'
        ]);
        $scope.$watch(
            function() {
                return $scope.activeTopic;
            },
            function(activeTopic) {
                if (activeTopic) {
                    initApp();
                }
            },
            true
        );
        // initApp
        usSpinnerService.spin('spinnerControlBar');
        function initApp() {
          // Ждём когда отработаю все вочеры, запускается каждый раз когда будут новые данные
          if ($scope.activeTopic && $scope.course) {
              buildDropDownNav();
              $scope.spinnerCurtain = false;
              usSpinnerService.stop('spinnerControlBar');
              initSelectBoxCategoryChange();
          }
        }
         // .initApp

        function initSelectBoxCategoryChange() {
            // Здесь код для селектбокса выбора адаптивной программы
            $scope.sCategoryChangeUser = false;
            var sCategoryChangeUser = $auth.isInAnyRole([
                'ROLE_STUDENT',
                'ROLE_PARENT'
            ]);

            adaptedProgramList.forEach(function (program) {
                if (program.id === 'C_DEFAULT') {
                    $rootScope.sCategorySelect = program;
                }
            });

            // Если зашли через электронный журнал то не показываем выбор адаптивной программы
            if (!!$state.params.studentId) {
                return;
            } // Показываем всем кроме ученика и родителя
            if (sCategoryChangeUser) {
                return;
            }
            // Показываем только если курс адаптирован для детей с ОВЗ
            if (!$scope.course.adapted) {
                return;
            } // Показываем
            if (!$scope.course.categoryInfo) {
                $scope.course.categoryInfo = [];
            }
            var category = ['C_DEFAULT'];
            $scope.course.categoryInfo.forEach(function(item) {
                category.push(item['s_category']);
            });
            $scope.sCategoryChangeUser = true; // Добавляем в слектбокс только те программы которые указаны для курса
            $scope.sCategory = adaptedProgramList.filter(function(program) {
                if (category.indexOf(program.id) !== -1) {
                    return true;
                }
                return false;
            });
            var sCategorySelect = sessionStorage.getItem('sCategorySelect');
            if (!!sCategorySelect) {
                var sCategorySelectParse = JSON.parse(sCategorySelect);
                // Проверяем есть ли такая адаптивная программ в списке
                var someCategory = $scope.sCategory.some(function(category, index, array) {
                    if (category.id === sCategorySelectParse.id) {
                        return true;
                    }
                    return false;
                });
                // Если нету берём первую из списка
                if (someCategory) {
                    $timeout(function() {
                        $scope.sCategorySelect = sCategorySelectParse;
                        $rootScope.sCategorySelect = sCategorySelectParse;
                    });
                } else {
                    $scope.sCategorySelect = $scope.sCategory[0];
                    $rootScope.sCategorySelect = $scope.sCategorySelect;
                }
            } else {
                $scope.sCategorySelect = $scope.sCategory[0];
                $rootScope.sCategorySelect = $scope.sCategorySelect;
            }
            $scope.sCategoryChange = function() {
                var sCategorySelect = $scope.sCategorySelect;
                sessionStorage.setItem('sCategorySelect', JSON.stringify(sCategorySelect));
                $rootScope.sCategorySelect = sCategorySelect;
            };
        }
        function rightNavGoToPage(button) {
            if (
                button === 'openTaskTable' &&
                $auth.isInAnyRole(canSeeOpenTaskTable)
            ) {
                $state.go('courseSectionOpenTaskTable', {
                    courseId: $scope.course.id,
                    tid: $scope.activeTopic.id,
                    lid: $state.params.lid,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId
                });
            } else if (button === 'journal') {
                if ($auth.isInRole('ROLE_TEACHER')) {
                    if ($scope.isFromBookshelf()) {
                        $state.go('teacherJournal');
                    } else {
                        // Если все данные есть, сразу переходим в журнал
                        if ($state.params.courseId && $state.params.groupId) {
                          $state.go('courseSectionJournal', {
                              courseId: $state.params.courseId,
                              groupId: $state.params.groupId,
                          });
                          return;
                        }
                        CourseSectionResource.getAllByTeacherId(
                            {
                                id: $scope.userId
                            },
                            function(result) {
                                // Перекидываем на текущий курс в журнале
                                if (result.length > 0) {
                                    for (var i in result) {
                                        if (
                                            +$state.params.courseId ===
                                                +result[i].course.id &&
                                            result[i].userGroup
                                        ) {
                                            $state.go('courseSectionJournal', {
                                                courseId: $state.params.courseId,
                                                groupId: result[i].userGroup.id
                                            });
                                            return;
                                        }
                                    }
                                    $state.go('teacherJournal');
                                } else {
                                    $state.go('teacherJournal');
                                }
                            }
                        );
                    }
                } else if ($auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT'])) {
                    var studentId;
                    if ($auth.isInRole('ROLE_STUDENT')) {
                        studentId = $scope.userId;
                    } else {
                        studentId = $state.params.studentId
                            ? $state.params.studentId
                            : $auth.user.relatedStudentId;
                    }
                    if (!studentId) return;
                    ProgressResource.getAllForStudent(
                        {
                            studentId: studentId
                        },
                        function(result) {
                            if (result.length > 0) {
                                for (var i in result) {
                                    if (
                                        +$state.params.courseId ===
                                        +result[i].id
                                    ) {
                                        $state.go('detailsJournal', {
                                            studentId: studentId,
                                            courseId: result[i].id
                                        });
                                        return;
                                    }
                                }
                                $state.go('studentJournal', {
                                    studentId: studentId
                                });
                            } else {
                                $state.go('studentJournal', {
                                    studentId: studentId
                                });
                            }
                        }
                    );
                } else if ($auth.isInRole('ROLE_TUTOR')) {
                    if ($scope.isFromBookshelf() || !$state.params.studentId) {
                        $state.go('tutorJournal');
                    } else {
                        // Получаем группы студентов для тьютора и ищем нужного нам. После перекидываем на текущий курс в его журнале
                        UserGroupResource.getAllForTutor(
                            {
                                tutorId: $scope.userId
                            },
                            function(result) {
                                if (result.length > 0) {
                                    for (var i in result) {
                                        if (result[i].users.length > 0) {
                                            for (var j in result[i].users) {
                                                if (
                                                    +result[i].users[j].id ===
                                                    +$state.params.studentId
                                                ) {
                                                    $state.go(
                                                        'detailsJournal',
                                                        {
                                                            groupId: result[
                                                                i
                                                            ].id,
                                                            courseId: $state.params.courseId,
                                                            studentId: $state.params.studentId
                                                        }
                                                    );
                                                    return;
                                                }
                                            }
                                            $state.go('tutorJournal');
                                        } else {
                                            $state.go('tutorJournal');
                                            return;
                                        }
                                    }
                                } else {
                                    $state.go('tutorJournal');
                                }
                            }
                        );
                    }
                }
            } else {
                LmsUtils.showActionToast('Доступ запрещен', 'Ok');
            }
        }
        function goToPage() {
            console.log('111111111111111111111')
            console.log($scope.pageTo.state.name)
            console.log($scope.pageTo.state.params)
            if ($scope.pageTo !== void 0)
                $state.go($scope.pageTo.state.name, $scope.pageTo.state.params);
        }
        function buildDropDownNav() {
            //if ($scope.course.courseType.id === 1) { //}
            if ($scope.course.courseType.id === 2) {
                // Если олимпиадный сборник
                var titleWork = 'Задание №';
                var titleLesson = 'Задание ';
            } else if (
                $scope.course.courseType.id === 9 ||
                $scope.course.courseType.id === 4
            ) {
                // Если методический сборник или дошкольный курс
                titleMain = 'Методическая страничка педагога';
                titleWork = 'Тема №';
                titleLesson = 'Занятие ';
            } else if (
                $scope.course.courseType.id === 12
            ) {
                // Ранхигс курс
                var titleWork = 'Занятие №';
                var titleLesson = 'Интернет-урок ';
            }
            else {
                var titleMain = 'Задание к занятию';
                var titleWork = 'Занятие №';
                var titleLesson = 'Интернет-урок ';
            }
            $scope.$parent.$broadcast('subType', $scope.activeTopic.subType);
            var i; // Push start and exercise pages to dropdown
            $scope.dropDownNav = [
                {
                    title: titleWork +
                        $scope.activeTopic.number +
                        '. ' +
                        $scope.activeTopic.name,
                    state: {
                        name: 'courseTopic',
                        params: {
                            courseId: $scope.course.id,
                            tid: $scope.activeTopic.id
                        }
                    }
                }
            ]; // if subType is TKR
            if ($scope.activeTopic.subType !== 1) {
                // Если олимпиадный сборник или ранхигс - заданий к занятию нет
                if ($scope.course.courseType.id !== 2 && $scope.course.courseType.id !== 12) {
                    $scope.dropDownNav.push({
                        title: titleMain,
                        state: {
                            name: 'courseTopicExercise',
                            params: {
                                courseId: $scope.course.id,
                                tid: $scope.activeTopic.id
                            }
                        }
                    });
                }
                // Push lessons to dropdown
                for (i = 0; i < $scope.activeTopic.lessons.length; i++) {
                    $scope.dropDownNav.push({
                        title: titleLesson +
                            $scope.activeTopic.lessons[i].number +
                            '. ' +
                            $scope.activeTopic.lessons[i].name,
                        state: {
                            name: 'courseLesson',
                            nested: 'courseLessonTotal',
                            params: {
                                courseId: $scope.course.id,
                                tid: $scope.activeTopic.id,
                                lid: $scope.activeTopic.lessons[i].id
                            }
                        }
                    });
                }
            } // Push total page to dropdown
            if ($scope.course.courseType.id !== 2 && $scope.course.courseType.id !== 12) {
                $scope.dropDownNav.push({
                    title: 'Итоговая страница',
                    state: {
                        name: 'courseTopicTotal',
                        params: {
                            courseId: $scope.course.id,
                            tid: $scope.activeTopic.id
                        }
                    }
                });
            }
            var current = false;
            for (i = 0; i < $scope.dropDownNav.length; i++) {
                if (
                    $state.current.name === $scope.dropDownNav[i].state.name ||
                    ($scope.dropDownNav[i].state.nested &&
                        $scope.dropDownNav[i].state.nested ===
                            $state.current.name)
                ) {
                    for (var key in $scope.dropDownNav[i].state.params) {
                        current = $state.params[key] &&
                            $scope.dropDownNav[i].state.params[key] ==
                                $state.params[key]
                            ? true
                            : false;
                    }
                    if (current) {
                        $scope.pageTo = $scope.dropDownNav[i];
                        return;
                    }
                }
            }
        }
        function toggleCourseShow() {
            $scope.courseShow = !$scope.courseShow;
            $timeout(
                function() {
                    angular.element($window).trigger('resize');
                },
                100
            );
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseIndexCtrl
 * @description
 * # CourseIndexCtrl
 * Controller of the lmsClientApp
 */
app
.controller('CourseIndexCtrl', ['$scope', 'CourseResource', '$mdDialog', 'lmsConfig', function ($scope, CourseResource, $mdDialog, lmsConfig) {

    $scope.courses = null;
    $scope.getCourses = getCourses;

    $scope.getCourses();

    function getCourses() {
        CourseResource.query(function(val) {
            $scope.courses = val;
            console.log(val)
        });
    }
}]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseLessonCtrl
 * @description
 * # CourseLessonCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp').controller('CourseLessonCtrl', [
    'StatisticActivity',
    '$scope',
    '$auth',
    'Course',
    '$mdDialog',
    'lmsConfig',
    '$state',
    '$window',
    '$rootScope',
    'Quiz',
    'CourseTask',
    'LmsUtils',
    'uuid4',
    'CourseResource',
    'ProgressResource',
    'UserResource',
    '$q',
    'Olympiad',
    '$compile',
    'usSpinnerService',
    '$http',
    function(
        StatisticActivity,
        $scope,
        $auth,
        Course,
        $mdDialog,
        lmsConfig,
        $state,
        $window,
        $rootScope,
        Quiz,
        CourseTask,
        LmsUtils,
        uuid4,
        CourseResource,
        ProgressResource,
        UserResource,
        $q,
        Olympiad,
        $compile,
        usSpinnerService,
        $http
    ) {
        // Variables
        $rootScope.$on('$stateChangeStart', function() {
            if (!$rootScope.allIsVisible) {
                $scope.stopLesson();
            }
        });
        var prevTopic, nextTopic, prevLesson, nextLesson, iframeWindow;
        $scope.startLesson = function() {
            if (!$scope.lessonPath) {
                return;
            }
            var iframeElem = '<div id="iframeWrapper" style="height:100%;position: relative; width: 100%;">' +
                '<button class="iframe-container-button--close" ng-show="!$root.allIsVisible" ng-click="stopLesson()">Завершить</button>' +
                '<iframe style="position: absolute; height: 100%;" class="iframe-scroll-fix__iframe" ng-class="{' +
                "'iframe-blur' :" +
                '$root.allIsVisible }" id="file_content" style="height:100%" flex ng-show={{!!docPath}} ng-src={{lessonPath}}' +
                '></iframe>' +
                '<olympiad/>' +
                '</div>';
            var connectedIframe = $compile(iframeElem)($scope);

            $('body').append(connectedIframe);
            $rootScope.allIsVisible = false;
        };
        $scope.stopLesson = function() {
            $('#iframeWrapper').remove();
            $rootScope.allIsVisible = true;
        };
        $scope.$watch(
            function() {
                return $auth.user.userRoles;
            },
            function(userRoles) {
                if (userRoles) {
                    init();
                }
            }
        );
        function sendOlympAnswer() {
            var cid = $state.params.courseId;
            var sid = $scope.studentId;
            if (!$scope.topic) {
                return;
            }
            var assignments = $scope.topic.assignments;
            if (!assignments) {
                return;
            }
            var imsccId = null;
            var defaultImsccId = null;
            if ($auth.isInAnyRole(['ROLE_STUDENT'])) {
                var userScategory = $auth.user.s_category;
                assignments.map(function(item) {
                    if (item.s_category === userScategory) {
                        imsccId = item.imsccId;
                    }
                    if (item.s_category === 'C_DEFAULT') {
                        defaultImsccId = item.imsccId;
                    }
                }); // Если не нашлось, ставим дефолтную
                if (!imsccId) {
                    imsccId = defaultImsccId;
                }

                Olympiad.sendOlympAnswer(cid, imsccId, sid);
            }
        }
        function removeFile() {
            Olympiad.removeFile();
        }
        function init() {
            // 3. Отправка об ознакомлении с материалом
            StatisticActivity.sendWatch($state.params.lid, $auth.user.id)

            $scope.ncyBreadcrumbIgnore = true;
            $scope.course = Course.course;
            // Для крошек если олимпиада
            $scope.breadcrumbLabelStart = '';
            $scope.$watch(function() {
                return $scope.course.courseType;
            }, function(courseType) {
                if (courseType) {
                    if ($scope.course.courseType.id === 2) {
                      $scope.breadcrumbLabelStart = 'Задание';
                    } else {
                      $scope.breadcrumbLabelStart = 'Занятие';
                    }
                }
            });
            // /Для крошек
            $scope.olympiad = Olympiad;
            $scope.sendOlympAnswer = sendOlympAnswer;
            $scope.removeFile = removeFile;
            $scope.topic = null;
            $scope.lesson = null;
            $scope.docPath = null;
            $scope.lessonPath = null;
            $scope.activePage = null;
            $scope.isTeacher = $auth.isInRole('ROLE_TEACHER');
            $scope.isStudent = $auth.isInRole('ROLE_STUDENT');
            $scope.studentId = $auth.user.relatedStudentId ||
                $state.params.studentId;
            $scope.fromBookshelf = Course.fromBookshelf;
            // Methods
            $scope.load = load;
            $scope.openTask = openTask;
            $scope.openResource = openResource;
            $scope.openQuiz = openQuiz;
            $scope.load();
            $scope.$watch(
                'lesson',
                function(lesson) {
                    if (lesson && $scope.course) {
                        $scope.docPath = lmsConfig.coursesPath +
                            $scope.course.id +
                            '/files/';
                        $scope.activePage = lesson.lessonPages[0];
                        if ($state.params.page) {
                            for (
                                var i = 0;
                                i < lesson.lessonPages.length;
                                i++
                            ) {
                                if (
                                    lesson.lessonPages[i].pageNumber ===
                                    +$state.params.page
                                ) {
                                    $scope.activePage = lesson.lessonPages[i];
                                    break;
                                }
                            }
                        }
                        lesson._activePage = $scope.activePage; // Адаптивные программы C_DEFAULT|C_AQUA|C_BLUE|C_YELLOW|C_ORANGE|C_RED|C_GREEN|C_PURPLE|C_GREY // Если ученик
                        var roleStudent = $auth.isInAnyRole(['ROLE_STUDENT']);
                        if (roleStudent) {
                            var parcePath = sCategoryParce(
                                $scope.activePage.path,
                                $auth.user.s_category
                            );
                            var fullPath = $scope.docPath +
                                parcePath +
                                '?cacheBuster=' +
                                uuid4.generate();
                            testFilePath(fullPath)
                                .then(function() {
                                    $scope.lessonPath = fullPath;
                                })
                                .catch(function() {
                                    $scope.lessonPath = $scope.docPath +
                                        $scope.activePage.path +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                });
                            return;
                        }
                        // Если родитель
                        var roleParent = $auth.isInAnyRole(['ROLE_PARENT']); // TODO Получаем адаптивную прогрмму ученика // $scope.studentId
                        if (roleParent) {
                            UserResource.getById(
                                {
                                    userId: $state.params.studentId
                                },
                                function(response) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        response.s_category
                                    );
                                    var fullPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function() {
                                            $scope.lessonPath = fullPath;
                                        })
                                        .catch(function() {
                                            $scope.lessonPath = $scope.docPath +
                                                $scope.activePage.path +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );

                            return;
                        }
                        // Если зашли через журнал
                        if ($state.params.studentId) {
                            UserResource.getById(
                                {
                                    userId: $state.params.studentId
                                },
                                function(response) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        response.s_category
                                    );
                                    var fullPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function() {
                                            $scope.lessonPath = fullPath;
                                        })
                                        .catch(function() {
                                            $scope.lessonPath = $scope.docPath +
                                                $scope.activePage.path +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );

                            return;
                        }
                        // При смене в селектбоксе адаптивной программы меняем файл в ифрейме
                        $scope.lessonPath = $scope.docPath +
                            $scope.activePage.path +
                            '?cacheBuster=' +
                            uuid4.generate();
                        // Слушаем что нам вещают с '_controlBar'
                        $rootScope.$watch(
                            function() {
                                return $rootScope.sCategorySelect;
                            },
                            function(category) {
                                if (!!category) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        category.id
                                    );
                                    $scope.lessonPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                }
                            }
                        );
                    }
                },
                true
            );
            $scope.$on('$stateChangeStart', function() {
                if ($window.removeEventListener) {
                    $window.removeEventListener(
                        'message',
                        LessonListener,
                        false
                    );
                }
            });
            $scope.$watch('lesson', function(v) {
                $scope.$emit('activeTopic', {
                    prev: prevTopic,
                    cur: $scope.topic,
                    next: nextTopic
                });
                $scope.$emit('activeLesson', {
                    prev: prevLesson,
                    cur: $scope.lesson,
                    next: nextLesson
                });
            });
        }
        function load() {
            if (
                $state.params.courseId !== void 0 &&
                $state.params.tid !== void 0 &&
                $state.params.lid !== void 0
            ) {
                if (
                    !$scope.course || $scope.course.id != $state.params.courseId
                ) {
                    Course.getCourse(
                        $state.params.courseId
                    ).then(function(response) {
                        $scope.course = response;
                        $scope.isOlympic = $scope.course.courseType.id === 2
                            ? true
                            : false;
                    });
                } else {
                    if (
                        $scope.course.topics && $scope.course.topics.length > 0
                    ) {
                        $scope.topics = $scope.course.topics;
                        $scope.isOlympic = $scope.course.courseType.id === 2
                            ? true
                            : false;
                    }
                }
                // iframeWindow = (iframeWindow = document.getElementById(
                //     'file_content'
                // ).contentWindow);
                if ($window.addEventListener) {
                    $window.addEventListener('message', LessonListener, false);
                }
                if ($scope.topics && $scope.topics.length > 0) {
                    $scope.lesson = getLesson($scope.topics, $state.params);
                    return;
                }
                Course.getDynamicSyllabus(
                    $state.params.courseId
                ).then(function(response) {
                    $scope.topics = response;
                    $scope.lesson = getLesson($scope.topics, $state.params);
                });
            }
        }
        function getLesson(topics, params) {
            var lesson = topics
                .map(function(topic, i, topics) {
                    if (topic.id === +params.tid) {
                        prevTopic = i !== 0 ? topics[i - 1] : null;
                        nextTopic = i !== topics.length - 1
                            ? topics[i + 1]
                            : null;
                        if (topic.subType === 1) {
                            $state.go("courseTopicTotal");
                        }
                        $scope.topic = topic;
                        return topic.lessons;
                    } else {
                        return null;
                    }
                })
                .filter(function(a) {
                    return a;
                })
                .reduce(function(a, b) {
                    // flatten an array of lessons
                    return a.concat(b);
                }, []);
            for (var i = 0; i < lesson.length; i++) {
                if (lesson[i].id == params.lid) {
                    prevLesson = i !== 0 ? lesson[i - 1] : null;
                    nextLesson = i !== lesson.length - 1 ? lesson[i + 1] : null;
                    return lesson[i];
                }
            }
            return null;
        }
        function getTopic(topics, params) {
            for (var i = 0; i < topics.length; i++) {
                if (topics[i].id == params.tid) {
                    prevTopic = i !== 0 ? topics[i - 1] : null;
                    nextTopic = i !== topics.length - 1 ? topics[i + 1] : null;
                    return topics[i];
                }
            }
            return null;
        }
        function LessonListener(e) {
            switch (e.data.method) {
                case 'getTask':
                    CourseResource.getOpenTask(
                        {
                            id: $scope.course.id,
                            taskImsccId: e.data.params.id
                        },
                        function(response) {
                            sendTask(e.data.params.id, response);
                        }
                    );
                    // }); // Course.getCourseTask($scope.course.id, e.data.params.id).then(function(response) { //     sendTask(e.data.params.id, response);
                    break;
                case 'openTask':
                    openTask(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'showWiki':
                    openResource(e.data.params.url);
                    break;
                case 'openQuizz':
                    $scope.openQuiz(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'open1C':
                    open1C(e.data.params.id);
                    break;
                default:
                    break;
            }
        }
        function openTask(cid, tid, sid) {
            if ($scope.isStudent) {
                sid = undefined;
            }
            CourseTask.open(cid, tid, sid);
        }
        function open1C(quid) {
            Quiz.open1C(quid);
        }
        function openQuiz(cid, qid, sid) {
            Quiz.open(cid, qid, sid);
        }
        function openResource(url) {
            url = $scope.docPath + url + '?cacheBuster=' + uuid4.generate();
            CourseTask.openResource(url);
        }
        function sendTask(taskId, taskObj) {
            iframeWindow.postMessage(
                {
                    method: 'getTask',
                    id: taskId,
                    obj: taskObj
                },
                '*'
            );
        }
        function sendTaskResult(taskId, taskObj) {
            iframeWindow.postMessage(
                {
                    method: 'taskResult',
                    id: taskId,
                    obj: taskObj
                },
                '*'
            );
        }
        function sCategoryParce(path, category) {
            var parceCategory = '';
            var parcePath = '';
            if (!category || category === 'C_DEFAULT') {
                return path;
            }
            parceCategory = category.replace(/^C_/, '');
            parcePath = path.replace(
                /\.html$/,
                '_' + parceCategory.toLowerCase() + '.html'
            );
            return parcePath;
        }
        function testFilePath(fullPath) {
            return $q(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.open('HEAD', fullPath, false);
                request.send();
                if (request.status == 200) {
                    resolve();
                } else {
                    reject();
                }
            });
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseLessonTotalCtrl
 * @description
 * # CourseLessonTotalCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp').controller('CourseLessonTotalCtrl', [
    '$scope',
    '$auth',
    'Course',
    '$mdDialog',
    'lmsConfig',
    '$state',
    '$window',
    '$rootScope',
    'Quiz',
    'CourseTask',
    'LmsUtils',
    'uuid4',
    'CourseResource',
    'ProgressResource',
    'UserResource',
    '$q',
    '$timeout',
    function(
        $scope,
        $auth,
        Course,
        $mdDialog,
        lmsConfig,
        $state,
        $window,
        $rootScope,
        Quiz,
        CourseTask,
        LmsUtils,
        uuid4,
        CourseResource,
        ProgressResource,
        UserResource,
        $q,
        $timeout
    ) {
        // Variables

        $scope.currentCategory = 'C_DEFAULT';

        var prevTopic, nextTopic, prevLesson, nextLesson, iframeWindow;
        // Чтоб запоминать позицию скролла при обновлении дерева заданий
        var scrollTop = 0;
        $scope.$watch(
            function() {
                return $auth.user.userRoles;
            },
            function(userRoles) {
                if (userRoles) {
                    init();
                }
            }
        );
        function init() {
            $scope.ncyBreadcrumbIgnore = true;
            // $scope.loaded = false;
            $scope.course = Course.course;
            $scope.topic = null;
            $scope.lesson = null;
            $scope.docPath = null;
            $scope.lessonPath = null;
            $scope.activePage = null;
            $scope.lessonProgressExists = false; // Прогрессы, отображающиеся в аккордионе
            $scope.lessonProgresses = [
                {
                    name: 'assignmentsOpenTask',
                    type: 'assignment',
                    title: 'ЗОО',
                    data: [],
                    checked: true,
                    _accordionOpened: true
                },
                {
                    name: 'quizzesRequired',
                    type: 'quiz',
                    title: 'Проверь себя',
                    data: [],
                    checked: true,
                    _accordionOpened: true
                },
                {
                    name: 'assignmentsKeyQuestion',
                    type: 'assignment',
                    title: 'Ключевой вопрос',
                    data: [],
                    checked: true,
                    _accordionOpened: true
                },
                {
                    name: 'assignmentsHome',
                    type: 'assignment',
                    title: 'ДЗ',
                    data: [],
                    checked: true,
                    _accordionOpened: true
                },
                {
                    name: 'assignmentsUnmarked',
                    type: 'assignment',
                    title: 'Рабочая тетрадь',
                    checked: true,
                    _accordionOpened: true
                }
            ];
            $scope.isTeacher = !$auth.isInAnyRole([
                'ROLE_STUDENT',
                'ROLE_PARENT',
                'ROLE_ADMIN',
                'ROLE_COURSE_DEVELOPER'
            ]);
            $scope.isStudent = $auth.isInRole('ROLE_STUDENT');
            $scope.studentId = $auth.user.relatedStudentId ||
                $state.params.studentId;
            $scope.fromBookshelf = Course.fromBookshelf; // Methods
            $scope.load = load;
            $scope.openTask = openTask;
            $scope.openResource = openResource;
            $scope.openQuiz = openQuiz;
            $scope.getLessonProgress = getLessonProgress;
            $scope.checkAll = checkAll;
            $scope.allFilterChecked = allFilterChecked;
            $scope.accordionExpandAll = accordionExpandAll;
            $scope.allExpanded = allExpanded;

            // Подписываемся на select с категориями в courseBar ctrl
            $rootScope.$watch(
                function() {
                    return $rootScope.sCategorySelect;
                },
                function(category) {
                    if (!!category) {
                        $scope.currentCategory = category.id;
                        if (
                            !$scope.isStudent &&
                            !$scope.isParent &&
                            $scope.fromBookshelf
                        ) {
                            getLessonProgress();
                        }
                    }
                }
            );
            // --------
            $scope.load();
            $scope.$watch(
                'lesson',
                function(lesson) {
                    if (lesson && $scope.course) {
                        $scope.docPath = lmsConfig.coursesPath +
                            $scope.course.id +
                            '/files/';
                        $scope.activePage = lesson.lessonPages[0];
                        if ($state.params.page) {
                            for (
                                var i = 0;
                                i < lesson.lessonPages.length;
                                i++
                            ) {
                                if (
                                    lesson.lessonPages[i].pageNumber ===
                                    +$state.params.page
                                ) {
                                    $scope.activePage = lesson.lessonPages[i];
                                    break;
                                }
                            }
                        }
                        lesson._activePage = $scope.activePage; // Адаптивные программы C_DEFAULT|C_AQUA|C_BLUE|C_YELLOW|C_ORANGE|C_RED|C_GREEN|C_PURPLE|C_GREY // Если ученик
                        var roleStudent = $auth.isInAnyRole(['ROLE_STUDENT']);
                        if (roleStudent) {
                            var parcePath = sCategoryParce(
                                $scope.activePage.path,
                                $auth.user.s_category
                            );
                            var fullPath = $scope.docPath +
                                parcePath +
                                '?cacheBuster=' +
                                uuid4.generate();
                            testFilePath(fullPath)
                                .then(function() {
                                    $scope.lessonPath = fullPath;
                                })
                                .catch(function() {
                                    $scope.lessonPath = $scope.docPath +
                                        $scope.activePage.path +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                });
                            return;
                        } // Если родитель
                        var roleParent = $auth.isInAnyRole(['ROLE_PARENT']);
                        if (roleParent) {
                            UserResource.getById(
                                { userId: $state.params.studentId },
                                function(response) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        response.s_category
                                    );
                                    var fullPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function() {
                                            $scope.lessonPath = fullPath;
                                        })
                                        .catch(function() {
                                            $scope.lessonPath = $scope.docPath +
                                                $scope.activePage.path +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );
                            return;
                        } // Если зашли через журнал
                        if ($state.params.studentId) {
                            UserResource.getById(
                                {
                                    userId: $state.params.studentId
                                },
                                function(response) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        response.s_category
                                    );
                                    var fullPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function() {
                                            $scope.lessonPath = fullPath;
                                        })
                                        .catch(function() {
                                            $scope.lessonPath = $scope.docPath +
                                                $scope.activePage.path +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );
                            return;
                        }
                        // При смене в селектбоксе адаптивной программы меняем файл в ифрейме
                        $scope.lessonPath = $scope.docPath +
                            $scope.activePage.path +
                            '?cacheBuster=' +
                            uuid4.generate();
                        // Слушаем что нам вещают с '_controlBar'
                        $rootScope.$watch(
                            function() {
                                return $rootScope.sCategorySelect;
                            },
                            function(category) {
                                if (!!category) {
                                    var parcePath = sCategoryParce(
                                        $scope.activePage.path,
                                        category.id
                                    );
                                    $scope.lessonPath = $scope.docPath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                }
                            }
                        );
                    }
                },
                true
            );
            $scope.$on('$stateChangeStart', function() {
                if ($window.removeEventListener) {
                    $window.removeEventListener(
                        'message',
                        LessonListener,
                        false
                    );
                }
            });
            $scope.$watch('lesson', function(v) {
                $scope.$emit('activeTopic', {
                    prev: prevTopic,
                    cur: $scope.topic,
                    next: nextTopic
                });
                $scope.$emit('activeLesson', {
                    prev: prevLesson,
                    cur: $scope.lesson,
                    next: nextLesson
                });
            });
        }
        function load() {
            $scope.lessonProgress = $scope.lessonProgresses.concat([]);
            if (
                $state.params.courseId !== void 0 &&
                $state.params.tid !== void 0 &&
                $state.params.lid !== void 0
            ) {
                if (
                    !$scope.course || $scope.course.id != $state.params.courseId
                ) {
                    Course.getCourse(
                        $state.params.courseId
                    ).then(function(response) {
                        $scope.course = response;

                        $scope.isOlympiad = response.courseType.id === 2
                            ? true
                            : false;
                    });
                } else {
                    if (
                        $scope.course.topics && $scope.course.topics.length > 0
                    ) {
                        $scope.topics = $scope.course.topics;
                        $scope.isOlympiad = $scope.course.courseType.id === 2
                            ? true
                            : false;
                    }
                }
                $scope.$watch(
                    // Отслеживание состояния выбранных фильтров
                    function() {
                        return $scope.lessonProgress.filter(function(lp) {
                            return lp.checked;
                        });
                    },
                    function(v) {
                        $scope.getLessonProgress();
                    },
                    true
                );
                $scope.$on('quizPassed', function() {
                    getLessonProgress();
                });
                $scope.$on('markRated', function() {
                    getLessonProgress();
                });
                $scope.$on('answerPassed', function() {
                    getLessonProgress();
                });
                if ($window.addEventListener) {
                    $window.addEventListener('message', LessonListener, false);
                }
                if ($scope.topics && $scope.topics.length > 0) {
                    $scope.lesson = getLesson($scope.topics, $state.params);
                    return;
                }
                Course.getDynamicSyllabus(
                    $state.params.courseId
                ).then(function(response) {
                    $scope.topics = response;
                    $scope.lesson = getLesson($scope.topics, $state.params);
                });
            }
        }
        function getLessonProgress() {
            // Запоминаем позицию скролла
            $timeout(function() {
                var $totalPageContent = angular.element('.total-page-content');
                if ($totalPageContent.size()) {
                    scrollTop = $totalPageContent.scrollTop();
                }
            });
            // Ждем урока и курса
            var waitForLessonCourse = $scope.$watch(
                function() {
                    return $scope.lesson && $scope.course;
                },
                function(v) {
                    if ($auth.isInRole('ROLE_STUDENT')) {
                        $scope.classParallel = $auth.user.additionalUserInfoDTO.studentGroups[
                            0
                        ].classParallel;
                    } else if ($auth.isInRole('ROLE_PARENT')) {
                        $scope.classParallel = $scope.course.parallel;
                    }
                    if (v) {
                        var studentId = !$scope.fromBookshelf
                            ? $scope.studentId
                                  ? $scope.studentId
                                  : $auth.user.id
                            : void 0,
                            params = {
                                courseId: $scope.course.id,
                                lessonId: $scope.lesson.id,
                                studentId: studentId
                            };
                        if (studentId) {
                            ProgressResource.getLessonProgress(
                                params
                            ).$promise.then(
                                parseLessonProgress,
                                handleLessonProgressError
                            );
                        } else {
                            ProgressResource.getLessonProgressWithoutStudent(
                                params
                            ).$promise.then(
                                parseLessonProgress,
                                handleLessonProgressError
                            );
                        } // Убиваем listener
                        waitForLessonCourse();
                    }
                },
                true
            );
        }
        function handleLessonProgressError(response) {
            for (var i = 0; i < $scope.lessonProgress.length; i++) {
                $scope.lessonProgress[i].data = [];
            }
            $scope.lessonProgressExists = false;
            LmsUtils.showActionToast('Прогресс не доступен', 'Ok');
        }
        function parseLessonProgress(response) {
            var lessonData = response;
            // Фильтруем по категориям
            if (!$scope.isStudent && !$scope.isParent && $scope.fromBookshelf) {
                for (var lessonType in lessonData) {
                    if (
                        lessonData[lessonType] &&
                        lessonData[lessonType] instanceof Array
                    ) {
                        lessonData[lessonType] = lessonData[
                            lessonType
                        ].filter(function(l) {
                            return l.s_category === $scope.currentCategory;
                        });
                    }
                }
            } // Проверка, по каким из фильтров в уроке есть задания. Показывать только эти фильтры
            $scope.lessonProgress = $scope.lessonProgresses.filter(
                function(tf, index) {
                    return lessonData[tf.name].length > 0;
                }
            );
            var appendRubricsToHome = function(rubrics, array) {
                rubrics.forEach(function(rubric) {
                    rubric.isRubric = true;
                    array.push(rubric);
                });
            }; // Получаем массив названий выбранных фильтров
            var checkedFilters = $scope.lessonProgress
                .filter(function(lp) {
                    return lp.checked;
                })
                .map(function(lp) {
                    return lp.name;
                });
            // Проход по прогрессам, разбиение по типам
            for (var i = 0; i < $scope.lessonProgress.length; i++) {
                if (
                    response[$scope.lessonProgress[i].name] &&
                    checkedFilters.indexOf($scope.lessonProgress[i].name) > -1
                ) {
                    $scope.lessonProgress[i].data = response[
                        $scope.lessonProgress[i].name
                    ]; // Открываем запрошенный тип в аккордионе
                    if (
                        $state.params.togglePane &&
                        $state.params.togglePane ===
                            $scope.lessonProgress[i].name &&
                        checkedFilters.indexOf($scope.lessonProgress[i].name) >
                            -1
                    ) {
                        $scope.lessonProgress[i]._accordionOpened = true;
                    }
                } else {
                    $scope.lessonProgress[i].data = [];
                } // Если вызов был с книжной полки, то статистика не нужна
                if (!$scope.fromBookshelf) {
                    if (response.stat[$scope.lessonProgress[i].name]) {
                        $scope.lessonProgress[i].stat = response.stat[
                            $scope.lessonProgress[i].name
                        ];
                    }
                }
                $scope.lessonProgressExists = true; // Восстанавливаем позицию скролла
                $timeout(function() {
                    angular.element('.total-page-content').scrollTop(scrollTop);
                });
            }
            var isTKR = $scope.topic.subType === 1;
            $scope.lessonProgress.map(function(progres) {
                progres.data.map(function(data) {
                    var requiredUniversal = null;
                    if (progres.type === 'quiz') {
                        requiredUniversal = data.required ||
                            data.requiredByDefault;
                    }
                    if (progres.type === 'assignment') {
                        requiredUniversal = data.required;
                    }
                    data.requiredUniversal = requiredUniversal;
                    var showProgressFilter = null;
                    showProgressFilter = data.required ||
                        data.requiredByDefault;
                    if (!isTKR) {
                        showProgressFilter = true;
                    }
                    if (!$scope.isStudent && !$scope.isParent) {
                        showProgressFilter = true;
                    }
                    data.showProgressFilter = showProgressFilter;
                });
            });
        }
        function getLesson(topics, params) {
            var lesson = topics
                .map(function(topic, i, topics) {
                    if (topic.id === +params.tid) {
                        prevTopic = i !== 0 ? topics[i - 1] : null;
                        nextTopic = i !== topics.length - 1
                            ? topics[i + 1]
                            : null;
                        $scope.topic = topic;
                        return topic.lessons;
                    } else {
                        return null;
                    }
                })
                .filter(function(a) {
                    return a;
                })
                .reduce(function(a, b) {
                    // flatten an array of lessons
                    return a.concat(b);
                });
            for (var i = 0; i < lesson.length; i++) {
                if (lesson[i].id == params.lid) {
                    prevLesson = i !== 0 ? lesson[i - 1] : null;
                    nextLesson = i !== lesson.length - 1 ? lesson[i + 1] : null;
                    return lesson[i];
                }
            }
            return null;
        }
        function getTopic(topics, params) {
            for (var i = 0; i < topics.length; i++) {
                if (topics[i].id == params.tid) {
                    prevTopic = i !== 0 ? topics[i - 1] : null;
                    nextTopic = i !== topics.length - 1 ? topics[i + 1] : null;
                    return topics[i];
                }
            }
            return null;
        }
        function LessonListener(e) {
            switch (e.data.method) {
                case 'getTask':
                    CourseResource.getOpenTask(
                        {
                            id: $scope.course.id,
                            taskImsccId: e.data.params.id
                        },
                        function(response) {
                            sendTask(e.data.params.id, response);
                        }
                    );
                    // }); // Course.getCourseTask($scope.course.id, e.data.params.id).then(function(response) { //     sendTask(e.data.params.id, response);
                    break;
                case 'openTask':
                    openTask(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'showWiki':
                    openResource(e.data.params.url);
                    break;
                case 'openQuizz':
                    $scope.openQuiz(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'open1C':
                    open1C(e.data.params.id);
                    break;
                default:
                    break;
            }
        }
        function openTask(cid, tid, sid, data) {
            if ($scope.isStudent) {
                sid = undefined;
            }
            if ($scope.course.courseType.id === 2) {
                //убираем теги, костыль для Олимпиад
                openResource(data.olympiadPath);
                return;
            }
            CourseTask.open(cid, tid, sid);
            data.unreadComments = 0;
        }
        function open1C(quid) {
            Quiz.open1C(quid);
        }
        function openQuiz(cid, qid, sid) {
            Quiz.open(cid, qid, sid);
        }
        function openResource(url) {
            url = $scope.docPath + url + '?cacheBuster=' + uuid4.generate();
            CourseTask.openResource(url);
        }
        function sendTask(taskId, taskObj) {
            iframeWindow.postMessage(
                {
                    method: 'getTask',
                    id: taskId,
                    obj: taskObj
                },
                '*'
            );
        }
        function sendTaskResult(taskId, taskObj) {
            iframeWindow.postMessage(
                {
                    method: 'taskResult',
                    id: taskId,
                    obj: taskObj
                },
                '*'
            );
        }
        function accordionExpandAll() {
            var t = $scope.allExpanded();
            angular.forEach($scope.lessonProgress, function(val, key) {
                val._accordionOpened = t ? false : true;
            });
        }
        function allExpanded() {
            var _expanded = 0;
            var _items = 0;
            for (var i = 0; i < $scope.lessonProgress.length; i++) {
                _items += $scope.lessonProgress[i].data.length === 0 ? 0 : 1;
                _expanded += $scope.lessonProgress[i].data.length !== 0 &
                    $scope.lessonProgress[i]._accordionOpened
                    ? 1
                    : 0;
            }
            return _expanded === _items;
        }
        function checkAll() {
            var t = $scope.allFilterChecked();
            for (var i = 0; i < $scope.lessonProgress.length; i++) {
                $scope.lessonProgress[i].checked = t ? false : true;
            }
        }
        function allFilterChecked() {
            var _checked = 0;
            var _filters = 0;
            for (var i = 0; i < $scope.lessonProgress.length; i++) {
                _filters++;
                _checked += $scope.lessonProgress[i].checked ? 1 : 0;
            }
            return _checked === _filters;
        }
        function sCategoryParce(path, category) {
            var parceCategory = '';
            var parcePath = '';
            if (!category || category === 'C_DEFAULT') {
                return path;
            }
            parceCategory = category.replace(/^C_/, '');
            parcePath = path.replace(
                /\.html$/,
                '_' + parceCategory.toLowerCase() + '.html'
            );
            return parcePath;
        }
        function testFilePath(fullPath) {
            return $q(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.open('HEAD', fullPath, false);
                request.send();
                if (request.status == 200) {
                    resolve();
                } else {
                    reject();
                }
            });
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseSidebarLeftCtrl
 * @description
 * # CourseSidebarLeftCtrl
 * Controller of the lmsClientApp
 */
app.controller('CourseSidebarLeftCtrl', [
  '$scope',
  'Course',
  'lmsConfig',
  '$state',
  '$rootScope',
  '$q',
  function($scope, Course, lmsConfig, $state, $rootScope, $q) {
    // Variables
    $scope.menu = {};
    $scope.course = null;

    $scope.$watch(
      function() {
        return Course.course;
      },
      function(course) {
        if (course.topics != void 0 && course.topics.length > 0) {
          $scope.course = course;
          if ($scope.course.courseType.id === 2) {
            // Если олимпиадный сборник
            $scope.typeCourse = 'Задание';
          } else {
            $scope.typeCourse = 'Занятие';
          }
          $scope.$watch(
            function() {
              return $scope.activeTopic;
            },
            function(v) {
              if (v) {
                $scope.menu.prev = $scope.activeTopic.number !== 1
                  ? $scope.course.topics[$scope.activeTopic.number - 2]
                  : null;
                $scope.menu.next = $scope.activeTopic.number < $scope.course.topics.length
                  ? $scope.course.topics[$scope.activeTopic.number]
                  : null;
              }
            }
          );
        }
      },
      true
    );
  }
]);

"use strict";

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseTaskCtrl
 * @description
 * # CourseTaskCtrl
 * Controller of the lmsClientApp
 */
angular.module("lmsClientApp").controller("CourseTaskCtrl", [
    "$scope",
    "$mdDialog",
    "Course",
    "lmsConfig",
    "$breadcrumb",
    "$auth",
    "CourseTask",
    "Upload",
    "LmsUtils",
    "$rootScope",
    "$sce",
    "$q",
    "AssignmentProgressResource",
    "CourseResource",
    "AssignmentCommentResource",
    "debounce",
    '$timeout',
    "EposService",
    "epos",
    function (
        $scope,
        $mdDialog,
        Course,
        lmsConfig,
        $breadcrumb,
        $auth,
        CourseTask,
        Upload,
        LmsUtils,
        $rootScope,
        $sce,
        $q,
        AssignmentProgressResource,
        CourseResource,
        AssignmentCommentResource,
        debounce,
        $timeout,
        EposService,
        epos
    ) {
        // Variables
        var _statusList = {
            NOT_STARTED: "Не начато",
            SAVED: "Сохранено",
            PUBLISHED: "Опубликовано",
            ASSESSED: "Отметка"
        };
        $scope.data = {};
        $scope.answer = {};
        $scope._isStudent = null;

        $scope.clearAnswer = {
            note: null,
            commentDate: null,
            published: false
        };
        $scope.uploading = true;
        $scope.courseId = null;
        $scope.htmlText = null;
        $scope.taskMark = null
        $scope.taskMarkIsShown = false

        $scope.readyToRecording = true
        $scope.recordingIsNow = false
        $scope.recordingIsDone = false
        $scope.startTime = null;
        $scope.timer = 0;
        $scope.recorder = null;
        $scope.microphone = null;
        $scope.startRecording = startRecording;
        $scope.stopRecording = stopRecording;
        $scope.printAudio = printAudio;
        $scope.cancelAudio = cancelAudio;
        $scope.scrollToEnd = scrollToEnd;

        $scope.mediaRecorder;
        $scope.now;
        $scope.addFileMobile = false



        $scope.taskId = null;
        $scope.studentId = null;
        $scope.filesToUpload = [];
        $scope.curPath = $breadcrumb.getStatesChain();
        $scope.fromBookshelf = Course.fromBookshelf;
        $scope.docPath = ""; // Methods
        $scope.isFileSupported = isFileSupported;
        $scope.isFlashInstalled = isFlashInstalled;
        $scope.changeMark = changeMark
        $scope.sendAnswer = sendAnswer;
        $scope.removeFromUploadList = removeFromUploadList;
        $scope.getFileName = getFileName;
        $scope.getFileName2 = getFileName2;
        $scope.removeFile = removeFile;
        $scope.putMark = putMark;
        $scope.putChangedMark = putChangedMark
        $scope.publishMark = publishMark; /*$scope.checkStudentAnswersExist = checkStudentAnswersExist;*/
        $scope.taskStatusName = taskStatusName;
        $scope.addToUploadList = addToUploadList;
        $scope.showResource = showResource;
        $scope.answerHeigh = 70;
        $scope.showAudio = showAudio;
        $scope.sendMarkMessage = sendMarkMessage

        $scope.showDraw = showDraw;
        $scope.editDraw = editDraw;
        $scope.answerFocus = function () {
            $scope.answerHeigh = 130;
        };
        $scope.answerBlur = function () {
            $scope.answerHeigh = 70;
        }; // Спинер
        $scope.loaded = false;

        // init loading
        $scope.loadedInit = false;
        var initProms = [];
        // /init loading

        init();


        var isEdge = navigator.userAgent.indexOf('Edge') !== -1 &&
            (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
        var isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
        );


        function startRecording2 (){
            console.log('aaaaaaaaaaa');



            navigator.mediaDevices
                .getUserMedia({
                    audio: isEdge
                        ? true
                        : {
                            echoCancellation: false
                        }
                })
                .then(function(mic) {
                    // callback(mic);
                    goodF(mic)
                    function goodF(mic) {
                        $scope.microphone = mic;


                        recorder = RecordRTC(microphone, options);
                        recorder.startRecording();



                        if (isSafari) {
                            // audio.muted = true;
                            // setSrcObject($scope.microphone, audio);
                            // audio.play();
                            // alert(
                            //     'Please click startRecording button again. First time we tried to access your microphone. Now we will record it.'
                            // );
                            return;
                        }
                        // function click(el) {
                        //     // el.disabled = false; // make sure that element is not disabled
                        //     var evt = document.createEvent('Event');
                        //     evt.initEvent('click', true, true);
                        //     el.dispatchEvent(evt);
                        // }
                        // click(btnStartRecording);
                    }
                })
                .catch(function(error) {
                    alert(
                        'Unable to capture your microphone. Please check console logs.'
                    );
                    console.error(error);
                });


        }

        function startRecording (){
            console.log('aaaaa');

            $scope.readyToRecording = false
            $scope.recordingIsNow = true

            var constraints = {
                audio: true
            }
            navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream){
                // document.getElementById('audio').srcObject = mediaStream
                // var mediaRecorder = new MediaRecorder(mediaStream);
                if ( document.getElementById('test123')){
                    document.getElementById('test123').remove()
                }


                $scope.mediaRecorder = new MediaRecorder(mediaStream);
                $scope.chunks = [];
                $scope.mediaRecorder.start()
                console.log($scope.mediaRecorder.state)

                $scope.mediaRecorder.ondataavailable = function (e){
                    $scope.chunks.push(e.data)
                }



                // $scope.timer = 0;

                // $scope.timerId = setInterval(function (){
                //     $scope.timer=$scope.timer+1;
                //     console.log($scope.timer)
                // },1000)

                // $scope.timer2 = $timeout(function (){
                //     $scope.timer=$scope.timer+1;
                //     console.log($scope.timer)
                //     $scope.timer2()
                //
                // }, 1000);



                $scope.mediaRecorder.onstop = function (e){

                    var blob = new Blob($scope.chunks, { type: "audio/mp3"})
                    //
                    // var file = new File([blob], getFileName('аудиозапись'), {
                    //     type: 'audio/mp3'
                    // });
                    // var files = [];
                    // files.push(file);
                    // $scope.addToUploadList(files);

                    // $scope.answer();




                    var videoURL = window.URL.createObjectURL(blob)

                    document.getElementById('test123').src = videoURL;
                }




                // var newAudio = document.createElement('audio');
                // newAudio.style.setProperty('display', 'Block');
                // newAudio.style.setProperty('margin', 'auto');
                // newAudio.id = 'test123'
                // newAudio.controls = true;
                // document.getElementById('audio_parent').appendChild(newAudio);
                //
                //
                // setTimeout(function (){
                //     mediaRecorder.stop()
                // },500)



            })


        }



        function stopRecording (){
            console.log('bbbbbbbbb');

            $scope.recordingIsNow = false
            $scope.recordingIsDone = true
            $scope.readyToRecording = true

            // $scope.mediaRecorder

            var newAudio = document.createElement('audio');
            newAudio.style.setProperty('display', 'Block');
            newAudio.style.setProperty('margin', 'auto');
            newAudio.id = 'test123'
            newAudio.controls = true;
            newAudio.setAttribute("ng-if","recordingIsDone")

            document.getElementById('audio_parent').appendChild(newAudio);


            setTimeout(function (){
                $scope.mediaRecorder.stop()
            },500)

            // clearInterval($scope.timerId)

            // this.disabled = true;
            // if (!recorder || !recorder.getBlob()) return;
            // // if(isSafari) {
            // //     recorder.getDataURL(function(dataURL) {
            // //         SaveToDisk(dataURL, getFileName('mp3'));
            // //     });
            // //     return;
            // // }
            // var blob = recorder.getBlob();
            // var file = new File([blob], getFileName('mp3'), {
            //     type: 'audio/mp3'
            // });
            // var files = [];
            // files.push(file);
            // scope.addToUploadList(files);
            // scope.answer();



            // newAudio.src = src;

                // newAudio.controls = stopRecording ? true : false;


            document.getElementById('audio_parent').appendChild(newAudio)

            // URL.createObjectURL(recorder.getBlob()),

            console.log( document.getElementById('audioRecord'));

        }

        function printAudio (){

            var blob = new Blob($scope.chunks, { type: "audio/mp3"})

            var file = new File([blob], getFileName2('mp3'), {
                type: 'audio/mp3'
            });
            console.log(file)
            var files = [];
            files.push(file);
            $scope.addToUploadList(files);

            $scope.recordingIsDone = false;

            document.getElementById('test123').remove()

            // var file = new File([blob], getFileName('mp3'), {
            //     type: 'audio/mp3'
            // });
            // var files = [];
            // files.push(file);
            // scope.addToUploadList(files);
            // scope.answer();
        }

        function getFileName2(fileExtension) {
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var date = d.getDate();
            return 'audio-' +
                year +
                month +
                date +
                '-' +
                getRandomString() +
                '.' +
                fileExtension;
        }
        function changeMark() {

            console.log($scope.data.progress.tempMark)
            console.log($scope.answer)
            $scope.markIsSet = true
        }

        $scope.markIsSet = false
        $scope.markIsSetFinal = false
        $scope.markHasBeenSet = false
        // $scope.markMessageToSend = "Выставлена отметка" + $scope.data.progress.tempMark
        // $scope.changedMarkMessageToSend = "Отметка изменена на " + $scope.data.progress.tempMark

        function getRandomString() {
            if (
                window.crypto &&
                window.crypto.getRandomValues &&
                navigator.userAgent.indexOf('Safari') === -1
            ) {
                var a = window.crypto.getRandomValues(
                    new Uint32Array(3)
                ),
                    token = '';
                for (var i = 0, l = a.length; i < l; i++) {
                    token += a[i].toString(36);
                }
                return token;
            } else {
                return (Math.random() * new Date().getTime())
                    .toString(36)
                    .replace(/\./g, '');
            }
        }

        function cancelAudio (){
            $scope.recordingIsDone = false
            document.getElementById('test123').remove()
        }


        function showAudio() {
            $mdDialog
                .show({
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    hasBackdrop: false,
                    template: '<div style=""><audio-record ng-if="show"></audio-record></div>',
                    controller: function ($scope, $mdDialog, $auth) {
                        $scope.hide = function () {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.answer = function (answer) {
                            $mdDialog.hide(answer);
                        };
                        $scope.show = true;
                        $scope.addToUploadList = addToUploadList;
                        $scope.recording = false;
                    }
                })
                .then(function (answer) { }, function () { });
        }

        function getDateFileName() {
            var nowDate = new Date();
            var year = nowDate.getFullYear();
            var month = nowDate.getMonth();
            var date = nowDate.getDate();
            var minutes = nowDate.getMinutes();
            var seconds = nowDate.getSeconds();
            var str = '' +
                '_' + year +
                '_' + month +
                '_' + date +
                '_' + minutes +
                '__' + seconds;
            return str;
        }

        function createDrawFile(blob) {
            var fileName = 'draw_' + getDateFileName() + '.png';
            var file = new File([blob], fileName, {
                type: blob.type
            });
            return file;
        }

        function drawDialog(imgFileUrl, showOnly) {
            $mdDialog.show({
                template: '<md-dialog style="height: 100%;"><react-component name="DrawImg" props="drawImgProps" watch-depth="collection" style="height: 100%;width: 100%;"></react-component></md-dialog>',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                multiple: true,
                controller: function ($scope, $mdDialog) {
                    $scope.drawImgProps = {
                        showOnly: showOnly,
                        imgFileUrl: imgFileUrl,
                        submit: function (blobData) {
                            var file = createDrawFile(blobData);
                            addToUploadList([file]);
                            $mdDialog.hide('cancel');
                        },
                        cancel: function () {
                            $mdDialog.hide('cancel');
                        }
                    };
                }
            });
        }

        function showDraw() {
            drawDialog(undefined, undefined);
        }

        function editDraw(imgFileUrl) {
            var isTeacher = $auth.isInRole("ROLE_TEACHER");
            var showOnly = !isTeacher;
            drawDialog(imgFileUrl, showOnly);
        }

        /**
             * Whether or not HTML5 File API is supported.
             *
             * @returns {Boolean} true if supported or false otherwise
             */ function isFileSupported() {
            return typeof File !== "undefined" &&
                typeof FileReader !== "undefined";
        }
        function isFlashInstalled() {
            var hasFlash = false;
            try {
                var fo = new window.ActiveXObject(
                    "ShockwaveFlash.ShockwaveFlash"
                );
                if (fo) {
                    hasFlash = true;
                }
            } catch (e) {
                if (
                    navigator.mimeTypes &&
                    navigator.mimeTypes["application/x-shockwave-flash"] !==
                    undefined &&
                    navigator.mimeTypes[
                        "application/x-shockwave-flash"
                    ].enabledPlugin
                ) {
                    hasFlash = true;
                }
            }
            return hasFlash;
        }
        var saveAssignmentCommentDebounce = debounce(300, function () {
            saveAssignmentComment();
        });
        function sendAnswer(publish) {
            if (publish !== void 0 && typeof publish === "boolean") {
                $scope.answer.published = publish;
            } // Если нет сообщения и нет файлов прикреплённых или сохранённых
            if (!$scope.answer.files) {
                $scope.answer.files = [];
            }
            if (
                !$scope.answer.note &&
                ($scope.filesToUpload.length === 0 &&
                    $scope.answer.files.length === 0)
            ) {
                return alert(
                    "Невозможно отправить пустое сообщение. Пожалуйста, введите ответ."
                );
            } // Если есть файлы то проверяем соответствует ли прикрепляемый файл требованиям
            if ($scope.filesToUpload.length !== 0) {
                var result = testFilesToUpload();
                if (result.error) {
                    var text = "";
                    if (result.names.length > 1) {
                        text = 'файлы: "' + result.names.join(", ") + '"';
                    } else {
                        text = 'файл: "' + result.names[0] + '"';
                    }
                    return alert(
                        "Извините, " +
                        text +
                        " не соответствует требованиям к форматам. Размер прикрепляемого файла не должен быть более 100 мб."
                    );
                }
            }
            // Всё в порядке отправляем
            $scope.answer.commentDate = Date.now();
            saveAssignmentCommentDebounce();
            scrollToEnd()
        }
        function sendMarkMessage() {
          $scope.answer.note = 'Выставлена отметка ' + $scope.data.progress.tempMark
            $scope.sendAnswer(true)
        }

        function testFilesToUpload() {
            var result = {
                error: false,
                names: []
            };
            $scope.filesToUpload.forEach(function (file) {
                if (file.size > 104857600) {
                    result.error = true;
                    result.names.push(file.name);
                }
            });
            return result;
        }
        function removeFromUploadList(fileName) {
            for (var i = 0; i < $scope.filesToUpload.length; i++) {
                if ($scope.filesToUpload[i].name === fileName) {
                    $scope.filesToUpload.splice(i, 1);
                    break;
                }
            }
        }
        function getFileName(filePath) {
            var pathParts = filePath.split("/");
            return pathParts[pathParts.length - 1];
        }
        function removeFile(fileId) {
            for (var i = 0; i < $scope.answer.files.length; i++) {
                if ($scope.answer.files[i].id === fileId) {
                    $scope.answer.files.splice(i, 1);
                    break;
                }
            }
            AssignmentCommentResource.removeFile({
                id: $scope.answer.id,
                fileId: fileId
            });
        }

        function scrollToEnd (){
            console.log(document.querySelector('.scroller'))
            document.querySelector('.scroller').scrollTo(
                {
                    top: 99999,
                    behavior: "smooth"
                }
            )
        }

        function putMark() {
            if ($scope.data.progress.tempMark) {
                $scope.data.progress.mark = $scope.data.progress.tempMark;
                setAssignmentMark();
                $scope.markIsSetFinal = true
            }
            $scope.sendMarkMessage()
            $scope.taskMarkIsShown = true
        }

        $scope.sendChangedMarkMessage = function () {
            $scope.answer.note = 'Отметка изменена на ' + $scope.data.progress.tempMark
            $scope.sendAnswer(true)
        }

        function putChangedMark() {
            if ($scope.data.progress.tempMark) {
                $scope.data.progress.mark = $scope.data.progress.tempMark;
                setAssignmentMark();
                $scope.markIsSetFinal = true
            }
            $scope.sendChangedMarkMessage()
        }



        function clearMessageForm() {
            angular.copy($scope.clearAnswer, $scope.answer);
        }
        function addToUploadList(files) {
            console.log('aa')
            console.log(files)
            if (files === null || files.length === 0) {
                return;
            }
            skipFile: for (var i in files) {
                for (var j in $scope.filesToUpload) {
                    if (files[i].name === $scope.filesToUpload[j].name) {
                        continue skipFile;
                    }
                }
                if (undefined === files[i].type) {
                    continue skipFile;
                }
                if ("application/x-msdownload" === files[i].type) {
                    continue skipFile;
                }
                $scope.filesToUpload.push(files[i]);
                console.log($scope.filesToUpload)
            }
            $scope.answerFocus();
        }
        function getCommentId(locationStr) {
            var locationParts = locationStr.split("/");
            return locationParts[
                locationParts.indexOf("assignmentComments") + 1
            ];
        }
        function uploadFiles(msgId) {
            var deferred = $q.defer();
            if ($scope.filesToUpload.length > 0) {
                var uploadsProms = [];
                for (var i = 0; i < $scope.filesToUpload.length; i++) {
                    var prom = doUpload($scope.filesToUpload[i], msgId);
                    uploadsProms.push(prom);
                }
                $q.all(uploadsProms).then(function (res) {
                    // Ждут false
                    deferred.resolve(false);
                });
            } else {
                deferred.resolve(false);
            }
            return deferred.promise;
        }
        function doUpload(file, id) {
            var deferred = $q.defer();
            Upload.upload({
                url: lmsConfig.apiUrlPath +
                    "/assignmentComments/" +
                    id +
                    "/file",
                file: file
            })
                .progress(function (evt) {
                    file.uploadProgress = parseInt(
                        100.0 * evt.loaded / evt.total
                    );
                })
                .success(function (data, status, headers) {
                    file.uploadSuccessful = true;
                    $scope.answer.published = true;
                    $scope.removeFromUploadList(file.name);
                    deferred.resolve(false);
                })
                .error(function (data, status, headers) {
                    file.uploadError = true;
                    $scope.answer.published = false;
                    $scope.removeFromUploadList(file.name);
                    deferred.resolve(false);
                });
            return deferred.promise;
        }

        function templateReplace(str) {
            var templateReplace = '';
            if (!!str) {
                var strForReplace = '' + str;
                var re = /(<a [^>]*ng-click=[^>]*)href="#"([^>]*>)/gi;
                templateReplace = strForReplace.replace(re, function (str, $1, $2) {
                    return $1 + ' href="javascript:void(0)" ' + $2;
                });
            }
            return templateReplace;
        }

        function init() {
            console.log(window.innerWidth)
            if (window.innerWidth < 600) {
                $scope.addFileMobile = true
            }
            console.log($scope.htmlText)
            var audio = document.getElementById('audioRecord');
            console.log(document.getElementById('audioRecord'))
            if (
                !CourseTask.openQueryParams ||
                !CourseTask.openQueryParams.courseId ||
                !CourseTask.openQueryParams.taskId
            ) {
                return false;
            }
            // init loading
            $scope.loadedInit = true;
            initProms = [];
            // /init loading
            $scope.courseId = CourseTask.openQueryParams.courseId;
            $scope.taskId = CourseTask.openQueryParams.taskId;
            $scope.studentId = CourseTask.openQueryParams.studentId;
            var promGetOpenTaskByUserCategory = CourseResource.getOpenTaskByUserCategory(
                {
                    id: $scope.courseId,
                    imsccId: $scope.taskId
                },
                function (courseTask) {
                    if ($auth.isInRole("ROLE_STUDENT")) {
                        $scope.classParallel = $auth.user.additionalUserInfoDTO.studentGroups[
                            0
                        ].classParallel;
                    } else if ($auth.isInRole("ROLE_PARENT")) {
                        Course.getCourse(
                            $scope.courseId
                        ).then(function (course) {
                            $scope.classParallel = course.parallel;
                        });
                    }
                    angular.extend($scope.data, courseTask);

                    // var aa = "<div style=\"background-color: red\" >"
                    // var bb = "</div>"

                    // console.log('aaaaaaaaaaaaaaaaaaaaa')
                    // console.log(courseTask.text)
                    // var numberOfSymbols = 96;
                    // var textLength = courseTask.text.length
                    // var numberOfLines = textLength/numberOfSymbols
                    // // var lineHeight = 32;
                    // var lineHeight = 26;
                    // var elementHeigh = numberOfLines*lineHeight;
                    // if (elementHeigh>300){
                    //     document.getElementById('taskContainer').style.height=elementHeigh+'px'
                    //     // document.getElementById('taskContainer2').style.marginTop='-120px'
                    // }



                    // if (courseTask.text.includes('img')) {
                    //     var testText = courseTask.text;
                    //     console.log(testText.indexOf('img'))
                    //     var num = testText.indexOf('img')
                    //     var anotnerString = testText.slice(num,testText.length);
                    //     console.log(anotnerString)
                    //     var a = anotnerString.indexOf('height=')
                    //     var b = anotnerString.indexOf('0"',a)
                    //     console.log(a)
                    //     console.log(b)
                    //     var c = anotnerString.slice(a+8,b+1);
                    //     console.log(c)
                    //     var summ = Math.floor(elementHeigh) +Number.parseInt(c)
                    //     console.log(elementHeigh)
                    //     console.log(summ)
                    //     // document.getElementById('taskContainer').style.height=1200+'px'
                    //
                    // }

                    if (courseTask.text && courseTask.text.includes('table')){
                        var newTestText = courseTask.text;
                        var num = newTestText.indexOf('table')
                        var firstPart = newTestText.slice(0,num+6)
                        var secondPart = newTestText.slice(num+7,newTestText.length)
                        var thirdPart = "style=\"border: 1px solid #999;\" "
                        var forthPart = "class=\"tableInTask2\""
                        var allParts = firstPart+forthPart+secondPart;
                        // console.log(firstPart)
                        // console.log(secondPart)
                        // console.log(forthPart)
                        // console.log(allParts)
                        var twoparts = firstPart + secondPart
                        // console.log(twoparts)
                        // console.log(newTestText)
                        // courseTask.text = allParts
                        courseTask.text = newTestText
                        $scope.htmlText = templateReplace(courseTask.text);

                    }

                    // if (courseTask.text.includes('img')){
                    //     var testText = courseTask.text;
                    //     console.log(testText.indexOf('img'))
                    //     var num = testText.indexOf('img')
                    //     var goodNum = num + 3;
                    //     var firstPart = testText.slice(0,goodNum)
                    //     var secondPart = testText.slice(goodNum+1,testText.length)
                    //     var thirdPart = " id=\'imageTest\' "
                    //     console.log(firstPart)
                    //     console.log(secondPart)
                    //     var AllParts = firstPart + thirdPart + secondPart
                    //     console.log(AllParts)
                    //     courseTask.text = AllParts
                    //
                    // }
                    // console.log(courseTask.text.includes('img'))
                    // var numberOfSymbols = 96;
                    // var textLength = courseTask.text.length
                    // var numberOfLines = textLength/numberOfSymbols
                    // // var lineHeight = 32;
                    // var lineHeight = 26;
                    // var elementHeigh = numberOfLines*lineHeight;
                    // if (elementHeigh>300){
                    //     document.getElementById('taskContainer').style.height=elementHeigh+'px'
                    //     // document.getElementById('taskContainer2').style.marginTop='-120px'
                    // }

                    $scope.htmlText = templateReplace(courseTask.text);
                    // console.log(document.getElementById('imageTest'))
                    // console.log($scope.htmlText)
                    // console.log(aa+courseTask.text+bb)
                }
            ).$promise;
            initProms.push(promGetOpenTaskByUserCategory);
            // console.log(document.getElementById('imageTest'))

            $scope._isStudent = $auth.isInRole("ROLE_STUDENT");
            if (!$scope.fromBookshelf) {
                var promGetAssignmentProgressStatus = getAssignmentProgressStatus();
                initProms.push(promGetAssignmentProgressStatus);
                var promGetAssignmentComments = getAssignmentComments();
                initProms.push(promGetAssignmentComments);
                var promGetAssignmentProgress = getAssignmentProgress();
                initProms.push(promGetAssignmentProgress);
                var promGetUnpublishedComment = getUnpublishedComment();
                initProms.push(promGetUnpublishedComment);
                // $scope.$watch('data.savedComment', function(v) {
                //   angular.extend($scope.answer, v);
                // });
            }
            clearMessageForm();
            $scope.docPath = lmsConfig.coursesPath +
                $scope.courseId +
                "/files/";

            // init loading
            $q.all(initProms).then(function () {
                $scope.loadedInit = false;
            });
            // /init loading
        }
        function getAssignmentComments() {
            var promise = AssignmentCommentResource.query(
                {
                    courseId: $scope.courseId,
                    imsccId: $scope.taskId,
                    userId: $scope.studentId
                },
                function (responce) {
                    // console.log(responce);
                    var r = responce.map(function (comment) {
                        comment.files.map(function (file) {
                            var isAudio = file.path.slice(-3) === "mp3";
                            if (isAudio) {
                                file.viewType = 'isAudio';
                                return file;
                            }

                            var isDraw = file.path.indexOf('draw_') !== -1;
                            if (isDraw) {
                                file.viewType = 'isDraw';
                                return file;
                            }

                            file.viewType = 'any';
                            return file;
                        });
                        console.log('comment.files', comment.files);
                        return comment;
                    });
                    // console.log(r);
                    $scope.data.comments = r;
                    // console.log($scope.data.comments);
                }
            ).$promise;
            return promise;
        }
        function getAssignmentProgress() {
            var promise = AssignmentProgressResource.getByAssignmentIdAndStudentId(
                {
                    courseId: $scope.courseId,
                    imsccId: $scope.taskId,
                    userId: $scope.studentId ? $scope.studentId : ""
                },
                function (r) {
                    console.log(r)
                    $scope.taskMark = r.mark
                    if(r.mark == null){
                        $scope.taskMarkIsShown = false

                    } else {
                        $scope.taskMarkIsShown = true
                    }

                    $scope.data.progress = r;
                    if (
                        $scope.data &&
                        $scope.data.progress &&
                        $scope.data.progress.mark
                    ) {
                        $scope.data.progress.tempMark = $scope.data.progress.mark;
                    }
                }
            ).$promise;
            return promise;
        }
        function getUnpublishedComment() {
            var promise = AssignmentCommentResource.getUnpublished(
                {
                    courseId: $scope.courseId,
                    imsccId: $scope.taskId,
                    userId: $scope.studentId
                },
                function (r) {
                    $scope.data.savedComment = r;
                    angular.extend($scope.answer, r);
                }
            ).$promise;
            return promise;
        }
        function getAssignmentProgressStatus() {
            var promise = AssignmentProgressResource.getStatus(
                {
                    courseId: $scope.courseId,
                    imsccId: $scope.taskId,
                    userId: $scope.studentId ? $scope.studentId : ""
                },
                function (r) {
                    $scope.data.progressStatus = r.status;
                }
            ).$promise;
            return promise;
        }
        function saveAssignmentComment() {
            // Включаем спинер
            $scope.loaded = true;
            var _commentCallback = function (response, headers) {
                uploadFiles(
                    getCommentId(headers().location)
                ).then(function (responce) {
                    $scope.loaded = false;
                    if (responce !== true) {
                        if ($scope.answer.published) {
                            clearMessageForm();
                            getAssignmentComments();
                            $rootScope.$broadcast("answerPassed");
                        } else {
                            $scope.data.savedComment = response;
                        }
                        getAssignmentProgressStatus();
                        getUnpublishedComment();
                    }
                });
            };
            $scope.answer.assignmentProgress = null;
            if ($scope.answer.id) {
                AssignmentCommentResource.update(
                    {
                        courseId: $scope.courseId,
                        imsccId: $scope.taskId
                    },
                    $scope.answer,
                    _commentCallback
                );
            } else {
                AssignmentCommentResource.create(
                    {
                        courseId: $scope.courseId,
                        imsccId: $scope.taskId,
                        userId: $scope.studentId ? $scope.studentId : ""
                    },
                    $scope.answer,
                    _commentCallback
                );
            }
        }
        function setAssignmentMark() {
            AssignmentProgressResource.setMark(
                {
                    courseId: $scope.courseId,
                    imsccId: $scope.taskId,
                    userId: $scope.studentId
                },
                { mark: $scope.data.progress.mark },
                function () {
                    LmsUtils.showActionToast("Отметка поставлена", "Ok");
                    getAssignmentProgressStatus();
                    $rootScope.$broadcast("markRated");
                    if (epos) {
                        var eposUniqueKey = localStorage.getItem("newUniqueKey");
                        EposService.sendZooResult(
                            $scope.studentId, 
                            $scope.data.title, 
                            $scope.taskId, 
                            $scope.data.progress.mark, 
                            eposUniqueKey
                        );
                    }
                }
            ); // CourseTask.setAssignmentMark($scope.courseId, $scope.taskId, $scope.studentId, {mark: $scope.data.progress.mark}).then(function () { //     LmsUtils.showActionToast("Отметка поставлена", "Ok"); //     getAssignmentProgressStatus(); //     $rootScope.$broadcast("markRated"); // });
        }
        function publishMark() {
            AssignmentProgressResource.publishMark(
                { id: $scope.data.progress.id },
                { published: $scope.data.progress.markPublished },
                function () {
                    LmsUtils.showActionToast(
                        $scope.data.progress.markPublished
                            ? "Отметка учтена"
                            : "Отметка не учтена",
                        "Ok"
                    );
                }
            ); // CourseTask.setAssignmentMarkPublished($scope.data.progress.id, {published: $scope.data.progress.markPublished}).then(function () { //     LmsUtils.showActionToast((($scope.data.progress.markPublished) ? "Отметка учтена" : "Отметка не учтена"), "Ok"); // });
        }
        /*function checkStudentAnswersExist() {
             if($scope.data && $scope.data.comments && $scope.data.comments.length > 0) {
             for(var i=0; i<$scope.data.comments.length; i++) {
             if($scope.data.comments[i].commentAuthor.id === +$scope.studentId
             && $scope.data.comments[i].note !== ''
             && !(/^\s+$/.test($scope.data.comments[i].note))) {
             return true;
             }
             }
             }
             return false;
             }*/ function taskStatusName(
            status
        ) {
            return _statusList[status];
        }
        function showResource(url) {
            url = $scope.docPath + url;
            CourseTask.openResource(url);
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseTopicCtrl
 * @description
 * # CourseTopicCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp').controller('CourseTopicCtrl', [
    '$scope',
    '$auth',
    'Course',
    '$mdDialog',
    'lmsConfig',
    '$state',
    '$window',
    '$rootScope',
    '$sce',
    'CourseTask',
    'uuid4',
    '$q',
    'UserResource',
    'TopicResource',
    'Olympiad',
    '$compile',
    function (
        $scope,
        $auth,
        Course,
        $mdDialog,
        lmsConfig,
        $state,
        $window,
        $rootScope,
        $sce,
        CourseTask,
        uuid4,
        $q,
        UserResource,
        TopicResource,
        Olympiad,
        $compile
    ) {
        // Variables
        $rootScope.$on('$stateChangeStart', function () {
            if (!$rootScope.allIsVisible) {
                $scope.stopLesson();
            }
        });
        var prevTopic, nextTopic, iframeWindow;
        $scope.startLesson = function () {
            if (!$scope.exercisePath) {
                return;
            }
            var iframeElem = '<div id="iframeWrapper" style="height:100%;position: relative; width: 100%; margin-bottom: 20px">' +
                '<button class="iframe-container-button--close" ng-show="!$root.allIsVisible" ng-click="stopLesson()">Завершить</button>' +
                '<iframe style="position: absolute; height: 100%" class="iframe-scroll-fix__iframe" ng-class="{' +
                "'iframe-blur' :" +
                '$root.allIsVisible }" id="file_content" style="height:100%" flex ng-show={{!!exercisePath}} ng-src={{exercisePath}}' +
                '></iframe>' +
                '<div ng-if="openTaskButtonClickShow()" style="position: fixed; bottom: 5px; width: 100%">' +
                '<div flex layout="row" layout-align="center center">' +
                '<button class="iframe-scroll-fix__open-task-button" ng-click="openTaskButtonClick()">Выполнить задание</button>' +
                '</div>' +
                '</div>' +
                '<olympiad/>' +
                '</div>';
            var connectedIframe = $compile(iframeElem)($scope);

            $('body').append(connectedIframe);
            $rootScope.allIsVisible = false;
        };
        $scope.stopLesson = function () {
            $('#iframeWrapper').remove();
            $rootScope.allIsVisible = true;
        };
        $scope.$watch(
            function () {
                return $auth.user.id;
            },
            function (userId) {
                if (userId) {
                    init();
                }
            }
        );

        function sendOlympAnswer() {
            var cid = $state.params.courseId;
            var sid = $scope.studentId;
            if (!$scope.topic) {
                return;
            }
            var assignments = $scope.topic.assignments;
            if (!assignments) {
                return;
            }
            var imsccId = null;
            var defaultImsccId = null;
            if ($auth.isInAnyRole(['ROLE_STUDENT'])) {
                var userScategory = $auth.user.s_category;
                assignments.map(function (item) {
                    if (item.s_category === userScategory) {
                        imsccId = item.imsccId;
                    }
                    if (item.s_category === 'C_DEFAULT') {
                        defaultImsccId = item.imsccId;
                    }
                }); // Если не нашлось, ставим дефолтную
                if (!imsccId) {
                    imsccId = defaultImsccId;
                }

                Olympiad.sendOlympAnswer(cid, imsccId, sid);
            }
        }
        function removeFile() {
            Olympiad.removeFile();
        }

        $scope.openTaskButtonClickShow = openTaskButtonClickShow;

        /**
         * Показывать или нет кнопку "Выполнить задание"
        */
        function openTaskButtonClickShow() {
            var isShow = false;
            try {
                // ---
                var isStudent = !!$auth.isInRole('ROLE_STUDENT');
                var isOlympic = !!$scope.isOlympic;
                // ---
                var courseTypeId = null;
                if ($scope.course) {
                    if ($scope.course.courseType) {
                        courseTypeId = $scope.course.courseType.id;
                    }
                }
                // Для дошкольных курсов
                var isPreschool = courseTypeId === 4;
                // ---
                if (isStudent && !isOlympic) {
                    isShow = true;
                }
                // Для дошкольных курсов не показываем
                if (isPreschool) {
                    isShow = false;
                }
                // ---
                // console.log({
                //     isStudent,
                //     isOlympic,
                //     isShow,
                //     isPreschool
                // });
            } catch (error) {
                console.error(error.message);
            }
            return isShow;
        }

        function init() {
            $scope.course = Course.course;
            $scope.olympiad = Olympiad;
            $scope.sendOlympAnswer = sendOlympAnswer;
            $scope.removeFile = removeFile;
            $scope.topic = null;
            $scope.exercisePath = null;
            $scope.docPath = '';
            $scope.config = {
                axis: 'y',
                autoHideScrollbar: false,
                theme: 'dark',
                setHeight: '100%',
                scrollInertia: 0,
                scrollButtons: {
                    scrollAmount: 'auto',
                    enable: true
                },
                advanced: {
                    updateOnContentResize: true
                }
            };

            // Methods
            $scope.load = load;

            $scope.isTeacher = $auth.isInRole('ROLE_TEACHER');
            $scope.isStudent = $auth.isInRole('ROLE_STUDENT');

            $scope.studentId = $auth.user.relatedStudentId ||
                $state.params.studentId;

            $scope.openTaskButtonClick = openTaskButtonClick;

            // $scope.openTaskButtonClickShow = $scope.isStudent;
            // Показывать или нет кнопку 'Выполнить задание'
            // $scope.openTaskButtonClickShow = false;

            // console.log('$scope.course', $scope.course);
            // console.log('$scope.openTaskButtonClickShow', $scope.openTaskButtonClickShow);

            $scope.load();

            $scope.$watch('topic', function (topic) {
                if (topic) {
                    $scope.courseType = 'default';
                    if ($scope.course.courseType.id === 2) {
                        // Если олимпиадный сборник
                        $scope.courseType = 'olympiad';
                        $scope.typeCourse = 'Задание ' +
                            topic.number +
                            '. ' +
                            topic.name;
                        $scope.typeCourseLabel = 'Задание ';
                        $scope.typeLesson = topic.name;
                        $scope.isOlympic = true;
                    } else {
                        $scope.typeCourse = 'Задание к Занятию';
                        $scope.typeCourseLabel = 'Занятие ';
                        $scope.typeLesson = 'Интернет-урок';
                    }
                    if (!!$scope.course.courseType) {
                        // Для дошкольных курсов другие заголовки
                        if ($scope.course.courseType.id === 4) {
                            $scope.courseType = 'preschoolCourses';
                        }
                        if ($scope.course.courseType.id === 12) {
                            $scope.courseType = 'RANHIGS';
                        }
                    }
                    $scope.$emit('activeTopic', {
                        prev: prevTopic,
                        cur: topic,
                        next: nextTopic
                    });
                    if (topic.assignments && topic.assignments.length > 0) {
                        // Адаптивные программы C_DEFAULT|C_AQUA|C_BLUE|C_YELLOW|C_ORANGE|C_RED|C_GREEN|C_PURPLE|C_GREY
                        var topicPath = _.find(topic.assignments, function (a) {
                            return a.s_category === 'C_DEFAULT';
                        }).path;
                        var filePath = $scope.course._filePath;
                        // Если учиник
                        if ($auth.isInAnyRole(['ROLE_STUDENT'])) {
                            if (testDefaultCategory($auth.user.s_category)) {
                                $scope.exercisePath = filePath +
                                    topicPath +
                                    '?cacheBuster=' +
                                    uuid4.generate();
                                return;
                            }
                            var parcePath = sCategoryParce(
                                topicPath,
                                $auth.user.s_category
                            );
                            var fullPath = filePath +
                                parcePath +
                                '?cacheBuster=' +
                                uuid4.generate();
                            testFilePath(fullPath)
                                .then(function () {
                                    $scope.exercisePath = fullPath;
                                })
                                .catch(function () {
                                    $scope.exercisePath = filePath +
                                        topicPath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                });
                            return;
                        } // Если родитель
                        if ($auth.isInAnyRole(['ROLE_PARENT'])) {
                            // Получаем адаптивную прогрмму ученика
                            UserResource.getById(
                                { userId: $scope.studentId },
                                function (user) {
                                    if (testDefaultCategory(user.s_category)) {
                                        $scope.exercisePath = filePath +
                                            topicPath +
                                            '?cacheBuster=' +
                                            uuid4.generate();
                                        return;
                                    }
                                    var parcePath = sCategoryParce(
                                        topicPath,
                                        user.s_category
                                    );
                                    var fullPath = filePath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function () {
                                            $scope.exercisePath = fullPath;
                                        })
                                        .catch(function () {
                                            $scope.exercisePath = filePath +
                                                topicPath +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );
                            return;
                        }
                        // Если зашли через журнал
                        if ($state.params.studentId) {
                            // Получаем адаптивную прогрмму ученика
                            UserResource.getById(
                                {
                                    userId: $scope.studentId
                                },
                                function (user) {
                                    if (testDefaultCategory(user.s_category)) {
                                        $scope.exercisePath = filePath +
                                            topicPath +
                                            '?cacheBuster=' +
                                            uuid4.generate();
                                        return;
                                    }
                                    var parcePath = sCategoryParce(
                                        topicPath,
                                        user.s_category
                                    );
                                    var fullPath = filePath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                    testFilePath(fullPath)
                                        .then(function () {
                                            $scope.exercisePath = fullPath;
                                        })
                                        .catch(function () {
                                            $scope.exercisePath = filePath +
                                                topicPath +
                                                '?cacheBuster=' +
                                                uuid4.generate();
                                        });
                                }
                            );
                            return;
                        } // При смене в селектбоксе адаптивной программы меняем файл в ифрейме
                        $scope.exercisePath = filePath +
                            topicPath +
                            '?cacheBuster=' +
                            uuid4.generate();
                        // Слушаем что нам вещают с '_controlBar'
                        $rootScope.$watch(
                            function () {
                                return $rootScope.sCategorySelect;
                            },
                            function (category) {
                                if (!!category) {
                                    var parcePath = sCategoryParce(
                                        topicPath,
                                        category.id
                                    );
                                    $scope.exercisePath = filePath +
                                        parcePath +
                                        '?cacheBuster=' +
                                        uuid4.generate();
                                }
                            }
                        );
                    }
                    $scope.docPath = lmsConfig.coursesPath +
                        $scope.course.id +
                        '/files/';
                }
            });
        }
        function load() {
            if (
                $state.params.courseId !== void 0 &&
                $state.params.tid !== void 0
            ) {
                if (
                    !$scope.course || $scope.course.id != $state.params.courseId
                ) {
                    Course.getCourse(
                        $state.params.courseId
                    ).then(function (response) {
                        $scope.course = response;
                        // console.log($scope.course);
                    });
                } else {
                    if (
                        $scope.course.topics && $scope.course.topics.length > 0
                    ) {
                        $scope.topics = $scope.course.topics;
                    }
                }
                if ($state.is('courseTopicExercise')) {
                    // iframeWindow = (iframeWindow = document.getElementById(
                    //     'file_content'
                    // ).contentWindow);
                    $scope.$on('$stateChangeStart', function () {
                        if ($window.removeEventListener) {
                            $window.removeEventListener(
                                'message',
                                ExerciseListener,
                                false
                            );
                        }
                    });
                    if ($window.addEventListener) {
                        $window.addEventListener(
                            'message',
                            ExerciseListener,
                            false
                        );
                    }
                }
                if ($scope.topics && $scope.topics.length > 0) {
                    $scope.topic = getTopic($scope.topics, $state.params);
                    return;
                }

                TopicResource.getAllTopicsWithLPagesByCourseId(
                    { courseId: $state.params.courseId },
                    function (topics) {
                        $scope.topics = topics;
                        $scope.course.topics = topics;
                        $scope.topic = getTopic($scope.topics, $state.params);
                    }
                );
            }
        }
        function getTopic(topics, params) {
            for (var i = 0; i < topics.length; i++) {
                if (topics[i].id == params.tid) {
                    prevTopic = i !== 0 ? topics[i - 1] : null;
                    nextTopic = i !== topics.length - 1 ? topics[i + 1] : null;
                    return topics[i];
                }
            }
            return null;
        }
        function ExerciseListener(e) {
            switch (e.data.method) {
                case 'openTask':
                    openTask($state.params.courseId, e.data.params.id, null);
                    break;
                case 'showWiki':
                    openResource(e.data.params.url);
                    break;
                case 'open1C':
                    open1C($state.params.id);
                    break;
                default:
                    break;
            }
        }
        function openTask(cid, tid, sid) {
            if ($scope.isStudent) sid = undefined;
            CourseTask.open(cid, tid, sid);
        }
        function open1C(quid) {
            console.log(quid);
        }
        function openTaskButtonClick() {
            var cid = $state.params.courseId;
            var sid = $scope.studentId;
            if (!$scope.topic) {
                return;
            }
            var assignments = $scope.topic.assignments;
            if (!assignments) {
                return;
            }
            var imsccId = null;
            var defaultImsccId = null;
            if ($auth.isInAnyRole(['ROLE_STUDENT'])) {
                var userScategory = $auth.user.s_category;
                assignments.map(function (item) {
                    if (item.s_category === userScategory) {
                        imsccId = item.imsccId;
                    }
                    if (item.s_category === 'C_DEFAULT') {
                        defaultImsccId = item.imsccId;
                    }
                }); // Если не нашлось, ставим дефолтную
                if (!imsccId) {
                    imsccId = defaultImsccId;
                }
                openTask(cid, imsccId, sid);
            }
        }
        function openResource(url) {
            if (!$scope.isTeacher) {
                // Так как студент и родитель не успевают получить $scope.docPath
                $scope.docPath = lmsConfig.coursesPath +
                    $scope.course.id +
                    '/files/';
            }
            if (url && $scope.docPath) {
                url = $scope.docPath + url + '?cacheBuster=' + uuid4.generate();
                CourseTask.openResource(url);
            }
        } // Проверяет надо ли парсить адаптивную программу
        function testDefaultCategory(category) {
            return !category || category === 'C_DEFAULT';
        }
        function sCategoryParce(path, category) {
            var parceCategory = '';
            var parcePath = '';
            if (!category || category === 'C_DEFAULT') {
                return path;
            }
            parceCategory = category.replace(/^C_/, '');
            parcePath = path.replace(
                /\.html$/,
                '_' + parceCategory.toLowerCase() + '.html'
            );
            return parcePath;
        }
        function testFilePath(fullPath) {
            return $q(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.open('HEAD', fullPath, false);
                request.send();
                if (request.status == 200) {
                    resolve();
                } else {
                    reject();
                }
            });
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseTopicTotalCtrl
 * @description
 * # CourseTopicTotalCtrl
 * Controller of the lmsClientApp
 */
app.controller('CourseTopicTotalCtrl', [
    '$scope',
    '$auth',
    'Course',
    '$mdDialog',
    'lmsConfig',
    '$state',
    '$window',
    '$rootScope',
    'Quiz',
    'CourseTask',
    'LmsUtils',
    'ProgressResource',
    '$timeout',
    function(
        $scope,
        $auth,
        Course,
        $mdDialog,
        lmsConfig,
        $state,
        $window,
        $rootScope,
        Quiz,
        CourseTask,
        LmsUtils,
        ProgressResource,
        $timeout
    ) {
        // Variables
        var prevTopic, nextTopic;
        $scope.currentCategory = 'C_DEFAULT';
        // Чтоб запоминать позицию скролла при обновлении дерева заданий
        var scrollTop = 0;
        $scope.$watch(
            function() {
                return $auth.user.userRoles;
            },
            function(userRoles) {
                if (userRoles) {
                    init();
                }
            }
        );
        function init() {
            $scope.comeFromBookShelf = $state.params.studentId === void 0;
            $scope.course = {};
            $scope.topic = null;
            $scope.isTeacher = !$auth.isInAnyRole([
                'ROLE_STUDENT',
                'ROLE_PARENT',
                'ROLE_ADMIN',
                'ROLE_COURSE_DEVELOPER'
            ]);
            $scope.isStudent = $auth.isInRole('ROLE_STUDENT');
            $scope.isParent = $auth.isInRole('ROLE_PARENT');
            $scope.topicProgressExists = false;
            $scope.topicProgress = [];
            $scope.filterTopicProgresses = [
                {
                    name: 'assignmentsOpenTask',
                    expand: 'openTask',
                    type: 'assignment',
                    checked: true,
                    title: 'ЗОО'
                },
                {
                    name: 'quizzesRequired',
                    type: 'quiz',
                    checked: true,
                    title: 'Проверь себя'
                },
                {
                    name: 'assignmentsKeyQuestion',
                    expand: 'keyQuestion',
                    type: 'assignment',
                    checked: true,
                    title: 'Ключевой вопрос'
                },
                {
                    name: 'assignmentsHome',
                    expand: 'home',
                    type: 'assignment',
                    checked: true,
                    title: 'ДЗ'
                },
                {
                    name: 'assignmentsUnmarked',
                    expand: 'nonAssessableOpenTask',
                    type: 'assignment',
                    checked: true,
                    title: 'Рабочая тетрадь'
                }
            ];
            $scope.requiredChecked = false;
            $scope.studentId = $scope.isTeacher
                ? $state.params.studentId
                : $auth.user.relatedStudentId || $state.params.studentId;
            $scope.accordionOpenedStore = [];
            $scope.fromBookshelf = false;
            $scope.$watch(
                function() {
                    return Course.fromBookshelf;
                },
                function(fromBookshelf) {
                    if (fromBookshelf) {
                        $scope.fromBookshelf = fromBookshelf;
                    }
                }
            );
            $scope.load = load;
            $scope.openTask = openTask;
            $scope.openResource = openResource;
            $scope.getTopicProgress = getTopicProgress;
            $scope.checkAll = checkAll;
            $scope.allFilterChecked = allFilterChecked;
            $scope.accordionExpandAll = accordionExpandAll;
            $scope.allExpanded = allExpanded;
            $scope.openQuiz = openQuiz;
            $scope.isTopicLessonsProgress = isTopicLessonsProgress;
            // Подписываемся на select с категориями в courseBar ctrl
            $rootScope.$watch(
                function() {
                    return $rootScope.sCategorySelect;
                },
                function(category) {
                    if (!!category) {
                        $scope.currentCategory = category.id || 'C_DEFAULT';
                        getTopicProgress();
                    }
                }
            );
            // ------
            $scope.load();
            $scope.openQuizOneTry = function(cid, qid, sid) {
                Quiz.openOneTry(cid, qid, sid);
            };
            $scope.$on('quizPassed', function() {
                getTopicProgress();
            });
            $scope.$on('markRated', function() {
                getTopicProgress();
            });
            $scope.$on('answerPassed', function() {
                getTopicProgress();
            });
            $scope.requiredTasks = function() {
                $scope.requiredChecked = !$scope.requiredChecked;
                parseTopicProgress($scope.topicProgress); // accordionExpandAll();
            };
            $scope.$watch('topic', function(v) {
                if (v) {
                    $scope.$emit('activeTopic', {
                        prev: prevTopic,
                        cur: v,
                        next: nextTopic
                    });
                }
            });
            $scope.$watch(
                'topicProgress.lessons',
                function(lessons) {
                    if (lessons) {
                        lessons.forEach(function(lesson, i, lessons) {
                            $scope.accordionOpenedStore[i] = {
                                id: lesson.id,
                                _accordionOpened: lesson._accordionOpened ===
                                    void 0
                                    ? true
                                    : lesson._accordionOpened
                            };
                            var progresses = lesson.progress;
                            if (progresses) {
                                $scope.accordionOpenedStore[i].progress = [];
                            }
                            progresses.forEach(
                                function(progress, j, progresses) {
                                    $scope.accordionOpenedStore[i].progress[
                                        j
                                    ] = {
                                        name: progress.name,
                                        _accordionOpened: progress._accordionOpened ===
                                            void 0
                                            ? true
                                            : progress._accordionOpened
                                    };
                                }
                            );
                        });
                    }
                },
                true
            );
            $scope.$on('$stateChangeStart', function() {
                if ($window.removeEventListener) {
                    $window.removeEventListener(
                        'message',
                        CourseEventListener,
                        false
                    );
                }
            });
        }
        function load() {
            if (
                $state.params.courseId !== void 0 &&
                $state.params.tid !== void 0
            ) {
                if (
                    !$scope.course ||
                    !$scope.course.id ||
                    $scope.course.id != $state.params.courseId
                ) {
                    Course.getCourse(
                        $state.params.courseId
                    ).then(function(response) {
                        $scope.course = response;
                        if ($auth.isInRole('ROLE_STUDENT')) {
                            $scope.classParallel = $auth.user.additionalUserInfoDTO.studentGroups[
                                0
                            ].classParallel;
                        } else if ($auth.isInRole('ROLE_PARENT')) {
                            $scope.classParallel = $scope.course.parallel;
                        }
                    });
                } else {
                    if (
                        $scope.course.topics && $scope.course.topics.length > 0
                    ) {
                        $scope.topics = $scope.course.topics;
                    }
                }
                if ($state.params.task !== void 0) {
                    var waitForCourse = $scope.$watch('course', function(v) {
                        if (v.id) {
                            openTask(
                                v.id,
                                $state.params.task,
                                $scope.studentId
                            );
                            waitForCourse();
                        }
                    });
                }
                if ($window.addEventListener) {
                    $window.addEventListener(
                        'message',
                        CourseEventListener,
                        false
                    );
                }
                if ($scope.topics && $scope.topics.length > 0) {
                    $scope.topic = getTopic($scope.topics, $state.params);
                    return;
                }
                Course.getDynamicSyllabus(
                    $state.params.courseId
                ).then(function(response) {
                    $scope.topics = response;
                    $scope.topic = getTopic($scope.topics, $state.params);
                });
                $rootScope.$on('$stateChangeStart', function() {
                    if ($window.removeEventListener) {
                        $window.removeEventListener(
                            'message',
                            CourseEventListener,
                            false
                        );
                    }
                });
                if ($window.addEventListener) {
                    $window.addEventListener(
                        'message',
                        CourseEventListener,
                        false
                    );
                }
                $scope.getTopicProgress(); // загружаем все прогрессы один раз, при загрузке страницы
            }
        }
        function getTopicProgress() {
            // Запоминаем позицию скролла
            $timeout(function() {
                var $totalPageContent = angular.element('.total-page-content');
                if ($totalPageContent.size()) {
                    scrollTop = $totalPageContent.scrollTop();
                }
            });
            var studentId = $scope.studentId;
            var params;
            if (!studentId && $scope.isStudent) {
                studentId = $state.params.studentId || $auth.user.id;
            }
            else if (!studentId) {
                studentId = $state.params.studentId || void 0;
            } // for (var i = 0; i < $scope.filterTopicProgress.length; i++) { //   if ($scope.filterTopicProgress[i].checked) { //     if (expand.indexOf($scope.filterTopicProgress[i].type) < 0) //       expand.push($scope.filterTopicProgress[i].type); //   } // }
            params = {
                courseId: $state.params.courseId,
                topicId: $state.params.tid,
                studentId: studentId
                // expand: expand, // assignment: assignment, // rubric: rubric
            };
            if (studentId) {
                ProgressResource.getTopicProgress(params)
                    .$promise.then(parseTopicProgress)
                    .then(returnWatcher)
                    .catch(function(response) {
                        handleTopicProgressError(response);
                    });
            } else {
                ProgressResource.getTopicProgressWithoutStudent(params)
                    .$promise.then(categoryFilter)
                    .then(parseTopicProgress)
                    .then(returnWatcher)
                    .catch(function(response) {
                        handleTopicProgressError(response);
                    });
            }
            // accordionExpandAll();
        } // Фильтруем по категориям
        function categoryFilter(topic) {
            if (
                !$scope.isStudent &&
                !$scope.isParent &&
                $scope.fromBookshelf &&
                topic.subType !== 1
            ) {
                topic.assignments = topic.assignments.filter(function(a) {
                    return a.s_category === $scope.currentCategory;
                });
                for (var i = 0; i <= topic.lessons.length; i++) {
                    for (var lessonType in topic.lessons[i]) {
                        if (
                            topic.lessons[i][lessonType] &&
                            topic.lessons[i][lessonType] instanceof Array
                        ) {
                            topic.lessons[i][lessonType] = topic.lessons[i][
                                lessonType
                            ].filter(function(l) {
                                return l.s_category === $scope.currentCategory;
                            });
                        }
                    }
                }
                return topic;
            } else {
                return topic;
            }
        }
        function handleTopicProgressError(response) {
            $scope.topicProgressExists = false;
            LmsUtils.showActionToast('Прогресс недоступен', 'OК');
        }
        function parseTopicProgress(response) {
            //копируем список фильтров
            $scope.filterTopicProgress = $scope.filterTopicProgresses.concat([
            ]);
            $scope.topicProgress = response; // Проверка на наличие любого filterTopicProgress
            function checkTopicFilters() {
                var assignmentFlag,
                    lessons = $scope.topicProgress.lessons,
                    topicFilters = $scope.filterTopicProgress;
                topicFilters.forEach(function(tf) {
                    assignmentFlag = false;
                    lessons.some(function(lesson) {
                        if (lesson[tf.name].length > 0) {
                            assignmentFlag = true;
                            return;
                        }
                    });
                    if (!assignmentFlag) {
                        topicFilters.forEach(function(filter, index) {
                            if (filter.name === tf.name) {
                                topicFilters.splice(index, 1);
                            }
                        });
                    }
                });
            }
            checkTopicFilters();
            buildLessonsProgresses(
                $scope.topicProgress.lessons,
                $scope.topicProgress
            );
            if ($scope.topicProgress.subType === 1) {
                // Т.к. в ТКР-е может быть только один урок.
                var progressByVariant = parseVariation(
                    $scope.topicProgress.lessons[0]
                );
                $scope.topicProgressExists = true; // restoreAccordionOpened(progressByVariant); // accordionExpandAll();
            } else {
                // restoreAccordionOpened($scope.topicProgress.lessons);
                $scope.topicProgressExists = true; // accordionExpandAll();
            }
        } // Парсинг топика если это ТКР
        function parseVariation(lesson) {
            return lesson.variations.map(function(variant) {
                variant.progress = lesson.progress.map(function(pgrs) {
                    var filteredData = pgrs.data.filter(function(data) {
                        if ($scope.isTeacher) {
                            return data.variation.id === variant.id &&
                                showRequired(pgrs, data);
                        } else {
                            return data.variation.id === variant.id;
                        }
                    });
                    return {
                        name: pgrs.name,
                        title: pgrs.title,
                        type: pgrs.type,
                        checked: pgrs.checked,
                        data: filteredData,
                        _accordionOpened: true
                    };
                });
                variant._accordionOpened = true;
                return variant;
            });
        }
        function showRequired(pgrs, data) {
            if ($scope.requiredChecked) {
                return (pgrs.type === 'assignment' &&
                    (data.required || data.mark !== null)) ||
                    (pgrs.type === 'quiz' &&
                        (data.requiredByDefault || data.percentages !== null));
            } else {
                return true;
            }
            // accordionExpandAll(); // allExpanded();
            restoreAccordionOpened($scope.topicProgress.lessons[0]);
        }
        function isTopicLessonsProgress() {
            for (var i = 0; i < $scope.topicProgress.lessons.length; i++) {
                if ($scope.topicProgress.lessons[i].progress.length > 0)
                    return true;
            }
            return false;
        }
        function getTopic(topics, params) {
            for (var i = 0; i < topics.length; i++) {
                if (topics[i].id == params.tid) {
                    prevTopic = i !== 0 ? topics[i - 1] : null;
                    nextTopic = i !== topics.length - 1 ? topics[i + 1] : null;
                    return topics[i];
                }
            }
            return null;
        }
        function openTask(cid, tid, sid, data) {
            if ($scope.isStudent) {
                sid = undefined;
            }
            //если курс олимпиадный
            if ($scope.course.courseType.id === 2) {
                //убираем теги, костыль для Олимпиад
                openResource(data.olympiadPath);
                return;
            }
            CourseTask.open(cid, tid, sid);
            data.unreadComments = 0;
        }
        function openResource(url) {
            url = lmsConfig.coursesPath + $scope.course.id + '/files/' + url;
            CourseTask.openResource(url);
        }
        function buildLessonsProgresses(lessons, topicProgress) {
            var tp = $scope.filterTopicProgress, hasOpenedInnerAccordion;
            for (var j = 0; j < lessons.length; j++) {
                lessons[j].progress = [];
                hasOpenedInnerAccordion = false;
                for (var i = 0; i < tp.length; i++) {
                    tp[i].data = null;
                    if (
                        lessons[j][tp[i].name] &&
                        lessons[j][tp[i].name].length > 0
                    ) {
                        if (tp[i].name == 'assignmentsHome' && tp[i].data) {
                            tp[i].data = lessons[j][tp[i].name].concat(
                                tp[i].data
                            );
                        } else {
                            tp[i].data = lessons[j][tp[i].name];
                        }
                    }
                    if (tp[i].data) {
                        // Открываем запрошенный тип в аккордионе
                        if (
                            $state.params.togglePane &&
                            $state.params.togglePane === tp[i].name &&
                            $scope.topicProgress.subType !== 1
                        ) {
                            tp[i]._accordionOpened = true;
                            hasOpenedInnerAccordion = true;
                        }
                        lessons[j].progress.push(angular.copy(tp[i]));
                    }
                }
                if (hasOpenedInnerAccordion) {
                    lessons[j]._accordionOpened = true;
                }
            } // для 'quiz' - 'requiredByDefault' для 'assignment' - 'required' // requiredUniversal для всех!
            var isTKR = topicProgress.subType === 1;
            lessons.map(function(lesson) {
                var progresList = lesson.progress;
                progresList.map(function(progres) {
                    var dataList = progres.data;
                    dataList.map(function(data) {
                        var requiredUniversal = null;
                        if (progres.type === 'quiz') {
                            requiredUniversal = data.required ||
                                data.requiredByDefault;
                        }
                        if (progres.type === 'assignment') {
                            requiredUniversal = data.required;
                        }
                        data.requiredUniversal = requiredUniversal;
                        var showProgressFilter = null;
                        showProgressFilter = data.required ||
                            data.requiredByDefault;
                        if (!isTKR) {
                            showProgressFilter = true;
                        }
                        if (!$scope.isStudent && !$scope.isParent) {
                            showProgressFilter = true;
                        }
                        data.showProgressFilter = showProgressFilter;
                    });
                }); // Выстраить по алфавиту названия
                lesson.progress.map(function(progress) {
                    var data = progress.data;
                    data.sort(function(data1, data2) {
                        if (data1.title > data2.title) {
                            return 1;
                        }
                        return -1;
                    });
                });
            });
        } // Показать или скрыть все
        function accordionExpandAll() {
            var t = $scope.allExpanded();
            if (
                $scope.topicProgress.subType === 1 &&
                !$scope.isStudent &&
                !$scope.isParent
            ) {
                // ТКР = 1 урок
                var lesson = $scope.topicProgress.lessons[0];
                lesson._accordionOpened = t ? false : true;
                lesson.variations.forEach(function(variant) {
                    variant._accordionOpened = t ? false : true;
                    variant.progress.forEach(function(prgs) {
                        prgs._accordionOpened = t ? false : true;
                    });
                });
            } else {
                angular.forEach(
                    $scope.topicProgress.lessons,
                    function(val, key) {
                        val._accordionOpened = t ? false : true;
                        angular.forEach(val.progress, function(v, k) {
                            v._accordionOpened = t ? false : true;
                        });
                    }
                );
            }
        }
        function allExpanded() {
            var _expanded = 0;
            var _items = 0;
            angular.forEach($scope.topicProgress.lessons, function(val, key) {
                _items++;
                _expanded += val._accordionOpened ? 1 : 0;
                if ($scope.topicProgress.subType !== 1) {
                    val.progress.forEach(function(v, k) {
                        _items++;
                        _expanded += v._accordionOpened ? 1 : 0;
                    });
                } else {
                    val.variations.forEach(function(v, k) {
                        _items++;
                        _expanded += v._accordionOpened ? 1 : 0;
                    });
                }
            });
            return _expanded === _items;
        }
        function checkAll() {
            var t = $scope.allFilterChecked();
            for (var i = 0; i < $scope.filterTopicProgress.length; i++) {
                $scope.filterTopicProgress[i].checked = t ? false : true;
            }
            // Открываем аккордион заданий, если открыт аккордион урока
            $scope.$watch(
                'topicProgress.lessons',
                function(lessons) {
                    lessons.forEach(function(lesson) {
                        lesson.progress.forEach(function(progress) {
                            if (lesson._accordionOpened === true) {
                                progress._accordionOpened = true;
                            }
                        });
                    });
                },
                true
            );
        }
        function allFilterChecked() {
            var _checked = 0;
            var _filters = 0;
            for (var i = 0; i < $scope.filterTopicProgress.length; i++) {
                _filters++;
                _checked += $scope.filterTopicProgress[i].checked ? 1 : 0;
            }
            return _checked === _filters;
        }
        function openQuiz(cid, qid, sid) {
            Quiz.open(cid, qid, sid);
        }
        function restoreAccordionOpened(lessons) {
            lessons.forEach(function(lesson, i, lessons) {
                var aos = $scope.accordionOpenedStore;
                aos.forEach(function(item, j, aos) {
                    if (lesson.id === item.id) {
                        lesson._accordionOpened = item._accordionOpened;
                        angular.forEach(lesson.progress, function(lp, lpKey) {
                            angular.forEach(item.progress, function(ip, ipKey) {
                                if (ip.name === lp.name)
                                    lp._accordionOpened = ip._accordionOpened;
                            });
                        });
                    }
                });
            }); // Восстанавливаем позицию скролла
            $timeout(function() {
                angular.element('.total-page-content').scrollTop(scrollTop);
            });
        }
        function CourseEventListener(e) {
            switch (e.data.method) {
                case 'openTask':
                    $scope.openTask(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'showWiki':
                    $scope.openResource(e.data.params.url);
                    break;
                case 'openQuizz':
                    $scope.openQuiz(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                default:
                    break;
            }
        }
        //  Слушает изменения в состоянии фильтров: "галочка" поставлена / снята
        function returnWatcher() {
            $scope.$watch(
                function() {
                    return $scope.filterTopicProgress.map(function(obj) {
                        return obj.checked;
                    });
                },
                function(v) {
                    var topicFilters,
                        checkedFilters,
                        filteredLessons = [],
                        lessons = $scope.topicProgress.lessons; // Проверка, какие фильтры выбраны
                    checkedFilters = $scope.filterTopicProgress
                        .filter(function(item) {
                            return item.checked;
                        })
                        .map(function(item) {
                            return item.name;
                        }); // Если количество прогрессов меньше, чем выбранных фильтров - заново построить дерево прогрессов
                    if (
                        $scope.topicProgress.lessons[0].progress.length <
                            checkedFilters.length && checkedFilters.length >= 1
                    ) {
                        buildLessonsProgresses(
                            $scope.topicProgress.lessons,
                            $scope.topicProgress
                        );
                    } // Показать только те прогрессы, которые совпадают с выбранными фильтрами
                    topicFilters = $scope.filterTopicProgress.map(
                        function(item) {
                            return item.name;
                        }
                    );
                    // Отфильтровать уроки: убрать из них все прогрессы, которые не выбраны (не совпадают с фильтрами)
                    filteredLessons = lessons.map(function(lesson) {
                        lesson.progress = lesson.progress.filter(
                            function(progress) {
                                return checkedFilters.indexOf(progress.name) >
                                    -1;
                            }
                        );
                        return lesson;
                    });
                    $scope.topicProgress.lessons = filteredLessons;
                    // Открыть аккордионы на всех уровнях
                    if ($scope.topicProgress.subType !== 1) {
                        // Не применять, если урок = ТКР
                        accordionExpandAll();
                    }
                    allExpanded();
                    restoreAccordionOpened($scope.topicProgress.lessons);
                },
                true
            );
        }
    }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.CourseViewCtrl
 * @description
 * # CourseViewCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp')
    .controller('CourseViewCtrl', [
        '$scope', 'Course', '$mdDialog', 'lmsConfig', '$state', '$window', '$rootScope', 'Quiz',
        function ($scope, Course, $mdDialog, lmsConfig, $state, $window, $rootScope, Quiz) {

            // Variables
            $scope.course = {};
            $scope.activeTopic = null;
            $scope.activeLesson = null;
            $scope.activeLessonPage = null;
            $scope.docPath = null;

            // Methods
            $scope.getCourse = getCourse;

            initCourseView();

            function initCourseView() {
                if($state.params.courseId !== void 0) {
                    $scope.getCourse($state.params.courseId);
                } else {
                    $state.go("index");
                }
            }

            function getCourse(id) {
                Course.getCourse(id, ['topics']).then(function(course) {
                    $scope.course = course;
                    $scope.docPath = lmsConfig.coursesPath + $scope.course.id + "/files/";
                    $scope.activeTopic = $scope.course.topics[0];
                    $scope.activeLesson = $scope.activeTopic.lessons[0];

                });
            }
    }]);

'use strict';
app.config([
  '$stateProvider',
  'lmsConfig',
  function($stateProvider, lmsConfig) {
    $stateProvider
      .state('course', {
        abstract: true,
        parent: 'dashboard',
        views: {
          'content@': {
            templateUrl: lmsConfig.modulesPath + 'course/views/default.html'
          }
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          }
        }
      })
      .state('courseIndex', {
        parent: 'course',
        url: 'courses',
        views: {
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/index.html',
            controller: 'CourseIndexCtrl'
          }
        }
      })
      .state('courseView', {
        parent: 'course',
        url: ':coursePath/course/:courseId?studentId&groupId&regionId&territoryId&schoolId',
        params: {
          coursePath: {
            value: '',
            squash: true
          }
        },
        views: {
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/view.html',
            controller: 'CourseViewCtrl'
          }
        },
        ncyBreadcrumb: {
          label: '{{course.name}}',
          skip: true,
          parent: function($scope) {
            return $scope.getCourseParent();
          }
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
      })
      .state('courseTopic', {
        parent: 'courseView',
        url: '/topic/:tid',
        views: {
          'courseBar@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/_controlBar.html'
          },
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/topic.html',
            controller: 'CourseTopicCtrl'
          }
        },
        ncyBreadcrumb: {
          label: '{{typeCourseLabel}} {{topic.number}}. {{topic.name}}',
          parent: function($scope) {
            if ($scope.JournalRoles1) {
              return 'JournalRoles1/schoolJournal/student/details';
            }
          }
        }
      })
      .state('courseTopicExercise', {
        parent: 'courseTopic',
        url: '/exercise',
        views: {
          'courseBar@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/_controlBar.html'
          },
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/exercise.html',
            controller: 'CourseTopicCtrl'
          }
        },
        ncyBreadcrumb: {
          skip: true,
          parent: function($scope) {
            if ($scope.JournalRoles1) {
              return 'JournalRoles1/schoolJournal/student/details';
            }
          }
        }
      })
      .state('courseTopicTotal', {
        parent: 'courseTopic',
        url: '/total?task',
        params: {
          togglePane: null
        },
        views: {
          'courseBar@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/_controlBar.html'
          },
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/topicTotal.html',
            controller: 'CourseTopicTotalCtrl'
          }
        },
        ncyBreadcrumb: {
          label: 'Занятие {{topic.number}}. {{topic.name}}',
          skip: true,
          parent: function($scope) {
            if ($scope.JournalRoles1) {
              return 'JournalRoles1/schoolJournal/student/details';
            }
          }
        }
      })
      .state('courseLesson', {
        parent: 'courseTopic',
        url: '/lesson/:lid?page',
        views: {
          'courseBar@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/_controlBar.html'
          },
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/lesson.html',
            controller: 'CourseLessonCtrl'
          }
        },
        ncyBreadcrumb: {
          label: '{{breadcrumbLabelStart}} {{topic.number}}. {{topic.name}}',
          parent: function($scope) {
            if ($scope.JournalRoles1) {
              return 'JournalRoles1/schoolJournal/student/details';
            }
            return 'courseView';
          }
        }
      })
      .state('courseLessonTotal', {
        parent: 'courseLesson',
        url: '/total',
        params: {
          togglePane: null
        },
        views: {
          'courseBar@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/_controlBar.html'
          },
          'courseContent@course': {
            templateUrl: lmsConfig.modulesPath + 'course/views/lessonTotal.html',
            controller: 'CourseLessonTotalCtrl'
          }
        },
        ncyBreadcrumb: {
          label: 'Занятие {{topic.number}}. {{topic.name}}',
          parent: 'courseView'
        }
      });
  }
]);
app.run([
  '$rootScope',
  '$state',
  'Course',
  '$auth',
  function($rootScope, $state, Course, $auth) {
    $rootScope.$on(
      '$stateChangeSuccess',
      function(event, toState, toParams, fromState, fromParams) {
        if ($auth.isInRole('ROLE_TEACHER') && !toParams.studentId) {
          toParams.coursePath = 'bookshelf';
          $state.go(toState.name, toParams);
        }

        if ($state.includes('courseView')) {
          Course.fromBookshelf = $state.params.coursePath.length > 0 ? true : false;
          if ($state.params.courseId && $rootScope.user.id) {
            Course.saveCourseBookmark(
              +$state.params.courseId,
              $rootScope.user.id,
              $state.href($state.current.name, $state.params)
            ).then(function() {
              $rootScope.$broadcast('courseBookmarkSaved');
            });
          }
        }
      }
    );
  }
]);

'use strict';

angular.module("lmsClientApp")
    .directive('lmsPagination', ['$compile', 'lmsConfig', '$state', '$interval', '$auth', function ($compile, lmsConfig, $state, $interval, $auth) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath + 'course/views/_pagination.html',
            link: function (scope, element, attrs) {
                var paginationPagesWidth = 300;
                //scope.studentId = $auth.user.relatedStudentId || $state.params.studentId;
                scope.studentId = $state.params.studentId;
                scope.pagesReady = false;
                scope.lessonsLeft = 0;
                scope.showArrowRight = false;

                function init() {

                    var lessonPagesContainer = document.getElementById('lesson-pages');
                    var activeGroup = document.querySelectorAll('.lesson-pages-group.active-group');

                    if(activeGroup.length > 0) {
                        var activePosRight = parseInt(activeGroup[0].offsetLeft) + parseInt(activeGroup[0].scrollWidth) + parseInt(window.getComputedStyle(activeGroup[0]).getPropertyValue('margin-left'));
                        if(activePosRight > paginationPagesWidth) {
                            scope.lessonsLeft = -(activePosRight - paginationPagesWidth);
                            angular.element(lessonPagesContainer).css('left', scope.lessonsLeft + "px");
                        }
                    }
                    scope.showArrowRight = checkArrowRightVisibility();
                    pagMoveInit();
                }

                function pagMoveInit() {
                    var leftArrow = document.getElementById('lessonsMoveLeft');
                    var rightArrow = document.getElementById('lessonsMoveRight');
                    var mouseDownId = -1;

                    var moveLeft = function() {
                        lessonPagesMove('left');
                       if(mouseDownId == -1) {
                           mouseDownId = $interval(moveLeft, 100);
                       }
                    };

                    var moveRight = function() {
                       lessonPagesMove('right');
                       if(mouseDownId == -1) {
                           mouseDownId = $interval(moveRight, 100);
                       }
                    };

                    function mouseup(event) {
                        $interval.cancel(mouseDownId);
                        mouseDownId = -1;
                    }

                    leftArrow.removeEventListener('mousedown', moveLeft);
                    rightArrow.removeEventListener('mousedown', moveRight);
                    leftArrow.addEventListener('mousedown', moveLeft);
                    rightArrow.addEventListener('mousedown', moveRight);
                    leftArrow.addEventListener('mouseup', mouseup);
                    leftArrow.addEventListener('mouseout', mouseup);
                    rightArrow.addEventListener('mouseup', mouseup);
                    rightArrow.addEventListener('mouseout', mouseup);
                }

                scope.$watch('pagesReady', function(v) {
                    if(v) {
                        init();
                    }
                });

                scope.setPagesReady = function() {
                    scope.pagesReady = true;
                };

                scope.resizeLessonGroups = function() {
                    var MAX_GROUPS_SHOW = 2;

                    var lessonPagesContainer = document.getElementById('lesson-pages');
                    var lessonPagesGroup =  lessonPagesContainer.querySelectorAll('.lesson-pages-group');
                    var lessonPagesGroupActive = lessonPagesContainer.querySelectorAll('.lesson-pages-group.active-group');
                    var _width, _items;
                    _width = _items = 0;

                    _items = (MAX_GROUPS_SHOW > lessonPagesGroup.length) ? lessonPagesGroup.length : MAX_GROUPS_SHOW;
                    for(var i=0; i<_items; i++) {
                        _width += parseInt(lessonPagesGroup[i].scrollWidth) + parseInt(window.getComputedStyle(lessonPagesGroup[i]).getPropertyValue('margin-left')) + parseInt(window.getComputedStyle(lessonPagesGroup[i]).getPropertyValue('margin-right'));
                    }

                    angular.element(lessonPagesContainer).css('width', _width + 'px');
                };

                function lessonPagesMove(direction) {
                    var moveStep = 20;
                    var elem = document.getElementById('lesson-pages');
                    scope.lessonsLeft = parseInt(window.getComputedStyle(elem).getPropertyValue('left'));

                    switch(direction) {
                        case 'left':
                            if(parseInt(scope.lessonsLeft) < 0) {
                                scope.lessonsLeft += moveStep;
                                angular.element(elem).css('left', scope.lessonsLeft + 'px');
                                scope.showArrowRight = true;
                            }
                            break;
                        case 'right':
                            var groups = elem.querySelectorAll(".lesson-pages-group"),
                                lastElem = groups[groups.length-1],
                                k = parseInt(lastElem.offsetLeft) - (parseInt(window.getComputedStyle(lastElem).getPropertyValue('margin-left')))*2,
                                l = paginationPagesWidth - (parseInt(lastElem.scrollWidth) + (parseInt(window.getComputedStyle(lastElem).getPropertyValue('margin-left')))*2);
                            if(Math.abs(scope.lessonsLeft) < k - l) {
                                scope.lessonsLeft -= moveStep;
                                angular.element(elem).css('left', scope.lessonsLeft + 'px');
                                scope.showArrowRight = true;
                            } else {
                                scope.showArrowRight = false;
                            }
                            break;
                        default:
                            break;
                    }
                }

                scope.prevTopic = function() {
                    var topic = (scope.activeTopic.number !== 1) ?
                        scope.course.topics[scope.activeTopic.number-2] :
                        scope.course.topics[0];

                    $state.go("courseTopic", {
                        id: scope.course.id,
                        tid: topic.id
                    });
                };

                scope.nextTopic = function() {
                    var topic = (scope.activeTopic.number < scope.course.topics.length) ?
                        scope.course.topics[scope.activeTopic.number] :
                        scope.course.topics[scope.course.topics.length-1];

                    $state.go("courseTopic", {
                        id: scope.course.id,
                        tid: topic.id
                    });
                };

                scope.prevPath = function() {
                    var lesson, page;
                    if($state.is('courseTopic')) {
                        return;
                    } else if($state.is('courseTopicExercise')) {
                        $state.go("courseTopic", {
                            id: scope.course.id,
                            tid: scope.activeTopic.id
                        });
                    } else if($state.is('courseLesson')) {

                        if(scope.activeLesson._activePage.pageNumber === 1) {
                            if(scope.activeLesson.number !== 1) {
                                lesson = scope.activeTopic.lessons[scope.activeLesson.number-2];
                                $state.go("courseLessonTotal", {
                                    id: scope.course.id,
                                    tid: scope.activeTopic.id,
                                    lid: lesson.id,
                                });
                            } else {
                                $state.go("courseTopicExercise", {
                                    id: scope.course.id,
                                    tid: scope.activeTopic.id
                                });
                            }
                        } else {
                            page = scope.activeLesson.lessonPages[scope.activeLesson.lessonPages.length-1];
                            $state.go("courseLesson", {
                                id: scope.course.id,
                                tid: scope.activeTopic.id,
                                lid: scope.activeLesson.id,
                                page: scope.activeLesson._activePage.pageNumber-1
                            });
                        }
                    } else if($state.is('courseLessonTotal')) {
                        page = scope.activeLesson.lessonPages[scope.activeLesson.lessonPages.length-1];
                        $state.go("courseLesson", {
                            id: scope.course.id,
                            tid: scope.activeTopic.id,
                            lid: scope.activeLesson.id,
                            page: page.pageNumber
                        });
                    } else if($state.is('courseTopicTotal')) {
                        lesson = scope.activeTopic.lessons[scope.activeTopic.lessons.length-1];
                        $state.go("courseLessonTotal", {
                            id: scope.course.id,
                            tid: scope.activeTopic.id,
                            lid: lesson.id,
                        });
                    }
                };

                scope.nextPath = function() {
                    var lesson, page;
                    if($state.is('courseTopic')) {
                        $state.go("courseTopicExercise", {
                            id: scope.course.id,
                            tid: scope.activeTopic.id
                        });
                    } else if($state.is('courseTopicExercise')) {
                        lesson = scope.activeTopic.lessons[0];
                        page = lesson.lessonPages[0];
                        $state.go("courseLesson", {
                            id: scope.course.id,
                            tid: scope.activeTopic.id,
                            lid: lesson.id,
                            page: page.pageNumber
                        });
                    } else if($state.is('courseLessonTotal')) {
                        // check if we at last lesson
                        if(scope.activeLesson.number == scope.activeTopic.lessons.length) {
                            $state.go("courseTopicTotal", {
                                id: scope.course.id,
                                tid: scope.activeTopic.id
                            });
                        } else {
                            lesson = scope.activeTopic.lessons[scope.activeLesson.number];
                            page = lesson.lessonPages[0];
                            $state.go("courseLesson", {
                                id: scope.course.id,
                                tid: scope.activeTopic.id,
                                lid: lesson.id,
                                page: page.pageNumber
                            });
                        }

                    } else if($state.is('courseLesson')) {
                        // check if we at last page
                        if(scope.activeLesson._activePage.pageNumber === scope.activeLesson.lessonPages.length) {
                            $state.go("courseLessonTotal", {
                                id: scope.course.id,
                                tid: scope.activeTopic.id,
                                lid: scope.activeLesson.id,
                            });
                        } else {
                            page = scope.activeLesson.lessonPages[scope.activeLesson._activePage.pageNumber];
                            $state.go("courseLesson", {
                                id: scope.course.id,
                                tid: scope.activeTopic.id,
                                lid: scope.activeLesson.id,
                                page: page.pageNumber
                            });
                        }
                    } else if($state.is('courseTopicTotal')) {
                        return;
                    }
                };

                function checkArrowRightVisibility() {
                    var groups = document.querySelectorAll('.lesson-pages-group');
                    if(groups.length <= 0)
                        return false;
                    var lastGroup = groups[groups.length-1];
                    return (document.getElementById('lesson-pages').scrollWidth > paginationPagesWidth) && ((parseInt(lastGroup.offsetLeft) + parseInt(lastGroup.scrollWidth) + scope.lessonsLeft) > paginationPagesWidth);
                }

                scope.$watch(function() {
                    return scope.activeLesson;
                }, function(v) {
                    if(!!v) {
                        scope.$parent.activeLessonPage = v.lessonPages[0];
                    }
                });

                scope.$watch(function() {
                    return scope.course.topics;
                }, function(v) {
                    if(v !== null) {
                        angular.forEach(v, function(topic, tkey) {
                            if(topic.lessons && topic.lessons.length > 0) {
                                var num = 0, lastNum = 0;
                                angular.forEach(topic.lessons, function(lesson, lkey) {
                                    angular.forEach(lesson.lessonPages, function(lp, lpkey) {
                                        lp._pageNum = lp.pageNumber + num;
                                        lastNum = lp._pageNum;
                                    });
                                    num = lastNum;
                                });
                            }
                        });
                    }
                });
            }
        };
    }]);

'use strict';

angular.module('lmsClientApp').directive('audioRecord', [
    'lmsConfig',
    '$timeout',
    function(lmsConfig, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: lmsConfig.modulesPath +
                'course/directives/audioRecord/audioRecord.html',
            link: function(scope, element, attrs) {
                var audio = document.getElementById('audioRecord');

                var isEdge = navigator.userAgent.indexOf('Edge') !== -1 &&
                    (!!navigator.msSaveOrOpenBlob || !!navigator.msSaveBlob);
                var isSafari = /^((?!chrome|android).)*safari/i.test(
                    navigator.userAgent
                );
                var recorder; // globally accessible
                var microphone;
                var btnStartRecording = document.getElementById(
                    'btn-start-recording'
                );
                // var btnStopRecording = document.getElementById(
                //     'btn-stop-recording'
                // );

                var btnDownloadRecording = document.getElementById(
                    'btn-download-add'
                );
                var btnPopupCancel = document.getElementById(
                    'btn-popup-cancel'
                );
                var startTime;
                var timer;

                scope.stopCounter = function() {
                    $timeout.cancel(timer);
                };
                scope.updateCounter = function() {
                    var now = new Date();
                    var dif = now - startTime;
                    var timeObj = msConvert(dif);
                    var h = timePart(timeObj.h);
                    var m = timePart(timeObj.m);
                    var s = timePart(timeObj.s);

                    scope.now = h + ':' + m + ':' + s;
                    timer = $timeout(scope.updateCounter, 1000);
                };
                btnStartRecording.onclick = onBtnStartRecordingClick;

                btnDownloadRecording.onclick = function() {
                    this.disabled = true;
                    if (!recorder || !recorder.getBlob()) return;
                    // if(isSafari) {
                    //     recorder.getDataURL(function(dataURL) {
                    //         SaveToDisk(dataURL, getFileName('mp3'));
                    //     });
                    //     return;
                    // }
                    var blob = recorder.getBlob();
                    var file = new File([blob], getFileName('mp3'), {
                        type: 'audio/mp3'
                    });
                    var files = [];
                    files.push(file);
                    scope.addToUploadList(files);
                    scope.answer();
                };

                btnPopupCancel.onclick = function() {
                    if (recorder) {
                        recorder.stopRecording(stopRecordingCallback);
                        recorder.destroy();
                        recorder = null;
                    }
                    scope.cancel();
                };

                // начинаем запись автоматически при открытии окна
                onBtnStartRecordingClick();

                function timePart(part) {
                    var result = part;

                    return result < 10 ? '0' + result : result;
                }
                function captureMicrophone(callback) {
                    if (microphone) {
                        callback(microphone);
                        return;
                    }
                    if (
                        typeof navigator.mediaDevices === 'undefined' ||
                        !navigator.mediaDevices.getUserMedia
                    ) {
                        alert(
                            'This browser does not supports WebRTC getUserMedia API.'
                        );
                        if (!!navigator.getUserMedia) {
                            alert(
                                'This browser seems supporting deprecated getUserMedia API.'
                            );
                        }
                    }
                    // navigator.mediaDevices
                    //     .getUserMedia({
                    //         audio: isEdge
                    //             ? true
                    //             : {
                    //                   echoCancellation: false
                    //               }
                    //     })
                    //     .then(function(mic) {
                    //         callback(mic);
                    //     })
                    //     .catch(function(error) {
                    //         alert(
                    //             'Unable to capture your microphone. Please check console logs.'
                    //         );
                    //         console.error(error);
                    //     });
                }
                // function replaceAudio(src, stopRecording) {
                //     var newAudio = document.createElement('audio');
                //     newAudio.style.setProperty('display', 'Block');
                //     newAudio.style.setProperty('margin', 'auto');
                //     newAudio.controls = stopRecording ? true : false;
                //     if (src) {
                //         newAudio.src = src;
                //     }
                //
                //     var parentNode = audio.parentNode;
                //     parentNode.style.setProperty('display', 'Block');
                //     parentNode.innerHTML = '';
                //     parentNode.appendChild(newAudio);
                //     audio = newAudio;
                // }

                function onBtnStartRecordingClick() {
                    // если запись включена
                    if (scope.recording) {
                        recorder.stopRecording(stopRecordingCallback);
                        scope.recording = !scope.recording;
                        scope.$apply();
                        return;
                    }
                    replaceAudio(null, scope.recording);

                    // если запись выключена

                    if (!microphone) {
                        captureMicrophone(function(mic) {
                            microphone = mic;
                            if (isSafari) {
                                audio.muted = true;
                                setSrcObject(microphone, audio);
                                audio.play();
                                alert(
                                    'Please click startRecording button again. First time we tried to access your microphone. Now we will record it.'
                                );
                                return;
                            }
                            click(btnStartRecording);
                        });
                        return;
                    }
                    audio.muted = true;
                    setSrcObject(microphone, audio);
                    audio.play();
                    var options = {
                        type: 'audio',
                        numberOfAudioChannels: isEdge ? 1 : 2,
                        checkForInactiveTracks: true,
                        bufferSize: 16384
                    };
                    if (
                        navigator.platform &&
                        navigator.platform
                            .toString()
                            .toLowerCase()
                            .indexOf('win') === -1
                    ) {
                        options.sampleRate = 48000; // or 44100 or remove this line for default
                    }
                    if (recorder) {
                        recorder.destroy();
                        recorder = null;
                    }
                    recorder = RecordRTC(microphone, options);
                    recorder.startRecording();
                    // btnStopRecording.disabled = false;
                    btnDownloadRecording.disabled = true;
                    scope.recordEnded = false;
                    scope.recording = !scope.recording;
                    // запускаем таймер
                    startTime = new Date();
                    scope.updateCounter();
                    scope.$apply();
                }

                function stopRecordingCallback() {
                    scope.stopCounter();
                    if (recorder) {
                        replaceAudio(
                            URL.createObjectURL(recorder.getBlob()),
                            true
                        );

                        // setTimeout(
                        //     function() {
                        //         if (!audio.paused) return;
                        //         setTimeout(
                        //             function() {
                        //                 if (!audio.paused) return;
                        //                 audio.play();
                        //             },
                        //             1000
                        //         );

                        //         audio.play();
                        //     },
                        //     300
                        // );
                        // audio.play();
                    }
                    btnDownloadRecording.disabled = false;
                    if (isSafari) {
                    }
                    scope.recordEnded = true;
                    scope.$apply();
                }

                // function click(el) {
                //     // el.disabled = false; // make sure that element is not disabled
                //     var evt = document.createEvent('Event');
                //     evt.initEvent('click', true, true);
                //     el.dispatchEvent(evt);
                // }

                // function getRandomString() {
                //     if (
                //         window.crypto &&
                //         window.crypto.getRandomValues &&
                //         navigator.userAgent.indexOf('Safari') === -1
                //     ) {
                //         var a = window.crypto.getRandomValues(
                //             new Uint32Array(3)
                //         ),
                //             token = '';
                //         for (var i = 0, l = a.length; i < l; i++) {
                //             token += a[i].toString(36);
                //         }
                //         return token;
                //     } else {
                //         return (Math.random() * new Date().getTime())
                //             .toString(36)
                //             .replace(/\./g, '');
                //     }
                // }
                // function getFileName(fileExtension) {
                //     var d = new Date();
                //     var year = d.getFullYear();
                //     var month = d.getMonth();
                //     var date = d.getDate();
                //     return 'audio-' +
                //         year +
                //         month +
                //         date +
                //         '-' +
                //         getRandomString() +
                //         '.' +
                //         fileExtension;
                // }

                // function msConvert(miliseconds, format) {
                //     var days,
                //         hours,
                //         minutes,
                //         seconds,
                //         total_hours,
                //         total_minutes,
                //         total_seconds;
                //
                //     total_seconds = parseInt(Math.floor(miliseconds / 1000));
                //     total_minutes = parseInt(Math.floor(total_seconds / 60));
                //     total_hours = parseInt(Math.floor(total_minutes / 60));
                //     days = parseInt(Math.floor(total_hours / 24));
                //
                //     seconds = parseInt(total_seconds % 60);
                //     minutes = parseInt(total_minutes % 60);
                //     hours = parseInt(total_hours % 24);
                //
                //     switch (format) {
                //         case 's':
                //             return total_seconds;
                //             break;
                //         case 'm':
                //             return total_minutes;
                //             break;
                //         case 'h':
                //             return total_hours;
                //             break;
                //         case 'd':
                //             return days;
                //             break;
                //         default:
                //             return {
                //                 d: days,
                //                 h: hours,
                //                 m: minutes,
                //                 s: seconds
                //             };
                //
                //     }
                // }

                // function SaveToDisk(fileURL, fileName) {
                //     // for non-IE
                //     if (!window.ActiveXObject) {
                //         var save = document.createElement('a');
                //         save.href = fileURL;
                //         save.download = fileName || 'unknown';
                //         save.style = 'display:none;opacity:0;color:transparent;';
                //         (document.body || document.documentElement).appendChild(save);
                //         if (typeof save.click === 'function') {
                //             save.click();
                //         } else {
                //             save.target = '_blank';
                //             var event = document.createEvent('Event');
                //             event.initEvent('click', true, true);
                //             save.dispatchEvent(event);
                //         }
                //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
                //     }
                //     // for IE
                //     else if (!!window.ActiveXObject && document.execCommand) {
                //         var _window = window.open(fileURL, '_blank');
                //         _window.document.close();
                //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
                //         _window.close();
                //     }
                // }
            }
        };
    }
]);

'use strict';

angular.module('lmsClientApp').directive('progressStat', [
  'lmsConfig',
  function(lmsConfig) {
    return {
      restrict: 'AE',
      scope: {
        all: '=',
        typeRequired: '=',
        performed: '=',
        requiredPerformed: '=',
        assignedQuizzes: '=',
        done: '=',
        progressType: '=',
        doHide: '='
      },
      replace: true,
      // templateUrl: lmsConfig.modulesPath + 'course/views/_progressStat.html'
      template: '<span>' +
        '<span class="progress-stat" ng-if="!doHide">' +
        '<span ng-switch="progressType">' +
        // Если "Проверь себя" в обычном уроке
        '<span ng-switch-when="quiz" ng-show="assignedQuizzes === 0"> {{typeRequired}} / </span>' + // Если ТКР
        '<span ng-switch-when="quiz" ng-show="assignedQuizzes > 0">{{assignedQuizzes}} / </span>' +
        '<span ng-switch-when="quiz"> {{performed}}</span>' +
        '<span ng-switch-default>{{typeRequired}} / {{performed}} / {{done}}</span>' +
        '</span>' +
        '<md-tooltip md-direction="left">' +
        '<span ng-switch="progressType">' +
        '<span ng-switch-when="quiz">Всего/Выполнено</span>' +
        '<span ng-switch-default>Назначено/Выполнено/Проверено</span>' +
        '</span></md-tooltip></span></span>'
    };
  }
]);

'use strict';

angular.module('lmsClientApp').directive('answerComments', [
  function() {
    return {
      restrict: 'AE',
      scope: {
        commentsCount: '='
      },
      replace: true,
      // templateUrl: lmsConfig.modulesPath + 'course/views/_progressStat.html'
      template: '<div style="display: inline-block">' +
        '<ng-md-icon icon="message">' +
        '</ng-md-icon>' +
        '<span>' +
        '<sup>{{commentsCount}}</sup>' +
        ' </span>' +
        '</div>',
      link: function(scope, element, attrs) {}
    };
  }
]);

'use strict';

angular.module('lmsClientApp').directive('olympiad', [
    'lmsConfig',
    function(lmsConfig) {
        return {
            restrict: 'E',

            replace: true,

            templateUrl: lmsConfig.modulesPath + 'course/views/_olympiad.html',
            link: function(scope, element, attrs) {}
        };
    }
]);

'use strict';


angular.module('lmsClientApp').service('Course', ['rest', 'lmsConfig', '$q', '$mdDialog', 'CourseResource', 'TopicResource', function (rest, lmsConfig, $q, $mdDialog, CourseResource, TopicResource) {
    // Variables
    var self = this;
    this.course = {};
    this.task = {};
    this.fromBookshelf = false;

    // Methods
    this.getCourse = getCourse;
    this.getDynamicSyllabus = getDynamicSyllabus;
    this.saveCourseBookmark = saveCourseBookmark;
    this.openCourseList = openCourseList;
    this.openCourseTopicList = openCourseTopicList;

    function openCourseList(courses, callback, modalOptions) {
        if (courses) {
            $mdDialog.show({
                    controller: function ($scope, $mdDialog) {
                        $scope.courses = courses;
                        console.log()
                        $scope.modalOptions = modalOptions;
                        $scope.hide = function () {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.courseClick = function (cid) {
                            callback.call(this, cid);
                        };
                    },
                    templateUrl: lmsConfig.modulesPath + 'course/views/_courseList.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                })
                .then(function (answer) {}, function () {});
        }
    }

    function openCourseTopicList(courses, callback) {
        if (courses) {
            $mdDialog.show({
                    controller: function ($scope, $mdDialog, Course) {
                        $scope.courses = courses;
                        $scope.course = null;
                        $scope.topics = [];
                        $scope.hide = function () {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.topicClick = function (cid, tid) {
                            callback.call(this, cid, tid);
                        };

                        $scope.$watch('course', function (v) {
                            if (v) {
                                TopicResource.getAllTopicsByCourseId({'courseId' : v.id}, function(response){
                                    $scope.topics = response;
                                });
                            }
                        });
                    },
                    templateUrl: lmsConfig.modulesPath + 'course/views/_courseTopicList.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                })
                .then(function (answer) {}, function () {});
        }
    }

    function getCourse(id, expand) {
        if (id !== void 0) {
            return CourseResource.get({
                'id': id,
                'expand': expand
            }, function (response) {
                self.course = response;
                self.course._filePath = lmsConfig.coursesPath + self.course.id + "/files/";
            }).$promise;
        }
    }

    function getDynamicSyllabus(id) {
        if (id !== void 0) {
            return CourseResource.getDynamicSyllabus({
                'id': id
            }, function (response) {
                self.course.topics = response;
            }).$promise;
        }
    }

    function saveCourseBookmark(cid, sid, url) {
        var deferred = $q.defer();
        if (cid !== void 0 || sid !== void 0 || (url !== void 0 && url !== '' && !(/^\s+$/.test(url)))) {
            url = url.replace(/^#\//, '');
            CourseResource.saveCourseBookmark({
                'id': cid,
                'studentId': sid
            }, url, function () {
                deferred.resolve();
            });
        } else {
            deferred.reject("missing url param");
        }
        return deferred.promise;
    }
}]);

angular.module('lmsClientApp').service('Olympiad', [
    'rest',
    'lmsConfig',
    '$q',
    'Upload',
    'AssignmentCommentResource',
    function(rest, lmsConfig, $q, Upload, AssignmentCommentResource) {
        var files = [];
        this.files = files;
        this.sendOlympAnswer = sendOlympAnswer;
        this.addToUploadList = addToUploadList;
        this.removeFile = removeFile;

        function sendOlympAnswer(courseId, taskId) {
            var files = this.files;

            assignmentComment(courseId, taskId).then(function(result) {
                Upload.upload({
                    url: lmsConfig.apiUrlPath +
                        '/assignmentComments/' +
                        result.id +
                        '/file',
                    file: files
                }).then(function() {
                    files.pop();
                });
            });
        }

        function assignmentComment(courseId, taskId) {
            return AssignmentCommentResource.create(
                {
                    courseId: courseId,
                    imsccId: taskId
                },
                {
                    files: [],
                    published: true,
                    commentDate: Date.now()
                }
            ).$promise.then(
                function(res) {
                    return res;
                },
                function(err) {
                    //Если есть сохраненный ответ происходит ошибка при сохранении. получаем Id сохраненного.
                    return AssignmentCommentResource.getUnpublished({
                        courseId: courseId,
                        imsccId: taskId
                    });
                }
            );
        }

        function addToUploadList(file) {
            if (file === null || file.length === 0) {
                return;
            }
            this.file = file.pop();
            this.files.push(this.file);
        }
        function isFileSupported() {
            return typeof File !== 'undefined' &&
                typeof FileReader !== 'undefined';
        }
        function removeFile() {
            this.file = null;
            this.files = [];
        }
    }
]);

'use strict';

angular.module('lmsClientApp').factory('CourseResource', function($resource) {
    return $resource(
        '/api/courses/:id',
        {},
        {
            query: { method: 'GET', isArray: true },
            get: {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            update: { method: 'PUT' },
            create: { method: 'POST' },
            getStatFile: {
                method: 'GET',
                url: '/report/journal?course=295&groupID=3688594',
            },
            getCoursesWithTeacher: {
                method: 'GET',
                url: '/api/courses/school/:schoolId/level/:level',
                isArray: true
            },
            getAllRelatedToUser: {
                method: 'GET',
                url: '/api/courses/withSections/currentUser',
                isArray: true,
                params: {
                    classId: '@learningClassId'
                }
            },
            getOpenTasks: {
                method: 'GET',
                url: '/api/courses/:id/openTasks',
                isArray: true
            },
            getOpenTask: {
                method: 'GET',
                url: '/api/courses/:id/openTasks/:taskImsccId'
            },
            getPublished: {
                method: 'GET',
                url: '/api/courses/published',
                isArray: true
            },
            getDynamicSyllabus: {
                method: 'GET',
                url: '/api/courses/:id/dynamicSyllabus',
                isArray: true
            },
            getQuizzes: {
                method: 'GET',
                url: '/api/courses/:id/quizzes',
                isArray: true
            },
            getRubrics: {
                method: 'GET',
                url: '/api/courses/:id/rubrics',
                isArray: true
            },
            getQuiz: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId'
            },
            getOpenTaskByUserCategory: {
                method: 'GET',
                url: '/api/courses/:id/getOpenTaskByUserCategory/:imsccId'
            },
            getQuizProgress: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/quiz'
            },
            getQuizAttempt: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/attempts/:attempt'
            },
            getQuestionAttempt: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/attempts/:attempt'
            },
            getQuestionAttempts: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/attempts',
                isArray: true
            },
            getQuizAllAttempts: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/attempts',
                isArray: true
            },
            getQuizDraft: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/draft'
            },
            saveQuizDraft: {
                method: 'PUT',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/draft'
            },
            saveQuizQuestionDraft: {
                method: 'POST',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId'
            },
            answerQuiz: {
                method: 'POST',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId'
            },
            answerQuizQuestion: {
                method: 'POST',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId'
            },
            isQuestionAvailable: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/available'
            },
            isLastAttempt: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/lastAttempt'
            },
            isCorrectAnswer: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/correct'
            },
            isQuizAvailable: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:imsccId/questions/:questionImsccId/student/:studentId/available'
            },
            getAllByCourseGroupId: {
                method: 'GET',
                url: '/api/courses/courseGroup/:id',
                isArray: true
            },
            getCourseName: {
                method: 'GET',
                url: '/api/courses/currentCourse/:courseId/name'
            },
            getDraftAttempt: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/draftAttempt'
            },
            getQuestionStats: {
                method: 'GET',
                url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId/questions'
            },
            saveCourseBookmark: {
                method: 'PUT',
                url: '/api/courseBookmarks/:id/student/:studentId'
            },
            getCourseFilters: {
                method: 'GET',
                url: '/api/courses/filters'
            }
        }
    );
});

'use strict';

var app = angular.module('lmsClientApp');

app.service('CourseTask', ['$state', 'StatisticActivity', 'Course', 'rest', 'lmsConfig', '$mdDialog', '$auth', '$breadcrumb', '$q', 'ModalStack', function($state, StatisticActivity, Course, rest, lmsConfig, $mdDialog, $auth, $breadcrumb, $q, ModalStack) {

    // Variables
    var self = this;
    var courseId = null;
    var studentId = null;
    var _isStudent;
    var modalStack = [];
    this.openQueryParams = null;

    // Methods
    this.openResource = openResource;

    this.open = function (cid, tid, sid, flashBack) {

        if(cid === void 0 || tid === void 0)
            return false;

        /*jshint validthis:true */
        this.openQueryParams = {
            courseId : cid,
            taskId : tid,
            studentId : sid,
        };

        if(!flashBack) {
            ModalStack.add(this.open, arguments, this);
        }

        StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

        $mdDialog.show({
            controller: function($scope, $mdDialog) {
                $scope.hide = function () {
                    $mdDialog.hide();
                };
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
            },
            templateUrl: lmsConfig.modulesPath + 'course/views/_showTask.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true
        })
        // .then(function(answer) {
        // }, function() {
        //     ModalStack.pop().callLast();
        // });
    };

    function openResource(url, flashBack) {

        if(url === void 0)
            return false;

        if(!flashBack) {
            /*jshint validthis:true */
            ModalStack.add(this.openResource, arguments, this);
        }

        StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

        $mdDialog.show({
            controller: function($scope, $mdDialog, url) {
                $scope.url = url;
                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
            },
            templateUrl: lmsConfig.modulesPath + 'course/views/_showWiki.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            locals: {
                url: url
            }
        })
        /*.then(function(answer) {
        }, function() {
           ModalStack.pop().callLast();
        });*/
    }
}]);

'use strict';

angular
    .module('lmsClientApp')
    .factory('CourseGroupResource', function($resource) {
        return $resource(
            '/api/courseGroups/:id',
            {},
            {
                getAllForTeacher: {
                    method: 'GET',
                    url: '/journal/progresses/courseGroups/tree/teacher/:teacherId?studyYear=:year',
                    // url: '/api/quizProgresses/course/:courseId/topic/:topicId?studentsIds=:studentsIds',
                    isArray: true
                }
            }
        );
    });

'use strict';

angular.module('lmsClientApp')
    .factory('CourseProgressResource', function ($resource) {
        return $resource('/api/courseProgresses', {}, {            
            'setAttestationMark': {
                method: 'PUT',
                url: '/api/courseProgresses/:id/attestationMark'                
            }            
        });
    });

'use strict';

app.controller('CourseSectionOpenTaskTableCtrl', [
    '$scope',
    '$auth',
    'CourseSectionResource',
    'UserResource',
    'LmsUtils',
    'lmsConfig',
    '$state',
    '$window',
    'AssignmentProgressResource',
    'MatrixVariationResource',
    'CourseService',
    'Course',
    'CourseTask',
    'uuid4',
    'QuizProgressResource',
    '$timeout',
    'adaptedProgramList',
    'usSpinnerService',
    '$q',
    '$http',
    function(
        $scope,
        $auth,
        CourseSectionResource,
        UserResource,
        LmsUtils,
        lmsConfig,
        $state,
        $window,
        AssignmentProgressResource,
        MatrixVariationResource,
        CourseService,
        Course,
        CourseTask,
        uuid4,
        QuizProgressResource,
        $timeout,
        adaptedProgramList,
        usSpinnerService,
        $q,
        $http
    ) {

        var allAssignmentProgress = [], allQuizProgress = [];

        // Ждём пока не будет готов сервис $auth
        $timeout(function() {
            startSpin();
        });
        var unbindAuthWatcher = $scope.$watch(
            function() {
                return $auth.user.id;
            },
            function(id) {
                if (id) {
                    mainInit();
                    unbindAuthWatcher();
                    $timeout(function() {
                        stopSpin();
                    });
                }
            }
        ); // ----------
        function mainInit() {
            $scope.ncyBreadcrumbIgnore = true;
            $scope.students = [];
            $scope.userAccess = false;
            $scope.assignments = [];
            $scope.quizzes = [];
            $scope.progressTitle = '';
            $scope.courseId = $state.params.courseId;
            $scope.variation;
            $scope.userId = $auth.user.id;
            $scope.studentsCount;
            $scope.testNumber = 1;
            $scope.variationCount = {};
            $scope.variations = [];
            $scope.lesson;
            $scope.calendarIsOpen = false
            $scope.minDate = new Date();
            $scope.taskDeadlineDate;
            $scope.taskDeadlineDateYear = new Date($scope.taskDeadlineDate).getFullYear()
            $scope.taskDeadlineMinutes = 59;
            $scope.taskDeadlineHours = 23;
            $scope.taskDeadlineYear;
            $scope.taskDeadlineDay;
            $scope.taskDeadlineMonth;
            $scope.taskDeadlineTimeStamp;
            $scope.timeStampToSend;
            $scope.deadLineErrorBlock = false;
            $scope.deadLineErrorMessage;
            // $scope.taskDeadlineToSend = $scope.taskDeadline.getTime();
            $scope.taskDeadlineSetUpButtonIsShown = true;
            $scope.taskDeadlineSetUpBlockIsOpen = false;
            $scope.taskDeadlineResultBlockIsOpen = false;
            $scope.quizzesOn = false;
            $scope.assignOn = true;
            $scope.choseStudents = [];
            $scope.lastChose;
            $scope.listOfIndexes = [];
            $scope.allChose = false;
            $scope.resultOfAllStatistic = {};
            $scope.subType;
            $scope.subTypeShow = false;
            $scope.isTeacher = $auth.isInRole('ROLE_TEACHER');
            $scope.isStudent = $auth.isInAnyRole([
                'ROLE_STUDENT',
                'ROLE_PARENT'
            ]);

            // console.log("!",$http.get('https://jsonplaceholder.typicode.com/todos/1'))
            $window.addEventListener('message', LessonListener, false);
            $scope.$watch(
                function () {
                    return $scope.quizzes
                },
                function () {
                    $scope.getCurrentDeadLine()
                }
            )
            $scope.$watch(
                function() {
                    return CourseService.getFast('lesson');
                },
                function(newVal, oldVal) {
                    if (newVal !== undefined) {
                        $scope.lesson = newVal;
                        startSpin();
                        $timeout(
                            function() {
                                stopSpin();
                            },
                            1000
                        );
                        $scope.quizzProg = sortedProgressByLessons(
                            allQuizProgress
                        );
                        $scope.assignProg = sortedProgressByLessons(
                            allAssignmentProgress
                        ); // console.log($scope.quizzProg, allQuizProgress)
                        if ($scope.assignOn) {
                            initialate($scope.assignProg, true);
                            $timeout(
                                function() {
                                    initialate($scope.quizzProg, false);
                                },
                                150
                            );
                        }
                        if ($scope.quizzesOn) {
                            initialate($scope.quizzProg, false);
                            $timeout(
                                function() {
                                    initialate($scope.assignProg, true);
                                },
                                150
                            );
                        } // console.log($scope.students)
                    }
                }
            );
            $scope.$on('quizzes', function(e, data) {
                $scope.$apply(function() {
                    $scope.quizzesOn = data;
                    $scope.assignOn = false;
                });
            });
            $scope.$on('assigns', function(e, data) {
                $scope.$apply(function() {
                    $scope.quizzesOn = false;
                    $scope.assignOn = data;
                });
            });
            $scope.$on('progressTitle', function(e, data) {
                $scope.$apply(function() {
                    $scope.progressTitle = data;
                });
            });
            $scope.$on('chooseStudent', function(e, data) {
                $scope.$apply(function() {
                    var index = data.index,
                        studentEditCond = $scope.students[index],
                        editToggle = studentEditCond.edit,
                        choseStudents = $scope.choseStudents;
                    if (editToggle === undefined) {
                        studentEditCond.edit = (editToggle = true);
                        choseStudents[index] = studentEditCond;
                        $scope.lastChose = index;
                        $scope.listOfIndexes.push(index);
                    } else {
                        studentEditCond.edit = !editToggle;
                        if (!editToggle === true) {
                            choseStudents[index] = studentEditCond;
                            $scope.lastChose = index;
                            $scope.listOfIndexes.push(index);
                        } else {
                            delete choseStudents[index];
                            if ($scope.lastChose === index) {
                                $scope.listOfIndexes.pop();
                                var i = $scope.listOfIndexes.length;
                                $scope.lastChose = $scope.listOfIndexes[i - 1];
                            } else {
                                _.remove($scope.listOfIndexes, function(i) {
                                    return i === index;
                                });
                            }
                        }
                    } // console.log(choseStudents, $scope.lastChose, $scope.listOfIndexes)
                });
            });
            $scope.$on('setAsHome', function(e, data) {
                $scope.$apply(function() {
                    updateStudentProgress(data, 'home');
                });
            });
            $scope.$on('setAsRequire', function(e, data) {
                $scope.$apply(function() {
                    updateStudentProgress(data, 'require');
                });
            });
            $scope.$on('setAsNone', function(e, data) {
                $scope.$apply(function() {
                    /*  // Если по умолчанию выбран вариант, то зафиксировано минимальное количество заданий, обязательных для выполнения.
                      if (preventDeleteRequire(data)) {
                          updateStudentProgress(data, '');
                      }
                  */ updateStudentProgress(
                        data,
                        ''
                    );
                });
            });
            $scope.$on('setForGroup', function(e, data) {
                $scope.$apply(function() {
                    updateGroupProgress(data);
                });
            });
            $scope.$on('setStudent', function(e, studentId) {
                getProgresses(studentId);
            });
            $scope.$on('markRated', function() {
                init();
            });
            $scope.$on('answerPassed', function() {
                init();
            });
            $scope.$on('quizPassed', function(e) {
                init();
            });
            $scope.$on('lessonNumber', function(event, data) {
                startSpin();
                $scope.lesson = data;
                init();
                stopSpin();
            });
            $scope.$on('subType', function(event, data) {
                if (data === 0 || data === null) {
                    $scope.subType = 'Проверь себя';
                } else if (data === 1) {
                    $scope.subType = 'Тесты';
                    $scope.subTypeShow = true;
                }
            });
            $scope.assignmentsMaxCount = [];
            $scope.getVariation = function(student) {
                updateIfChangeVariation(student);
                requestUpdateUserVariation(student);
                calculateDefaultRequireAssigns(student, 'statisticAssignment');
                countResultofStatistic('statisticAssignment');
                calculateDefaultRequireAssigns(student, 'statisticQuizz');
                countResultofStatistic('statisticQuizz');
            };
            $scope.resetRequire = function(student) {
                var studentId = student.id, requireList = [], currentStudent;
                currentStudent = _.find($scope.students, function(student) {
                    return student.id === studentId;
                });
                setChoseRequirement(currentStudent);
            };
            $scope.checkedAllStudents = function() {
                // $scope.allChose = !$scope.allChose;


                $scope.choseStudents = [];
                $scope.listOfIndexes = [];
                $scope.lastChose = undefined;
                if ($scope.allChose) {
                    $scope.students.forEach(function(student, i) {
                        student.edit = true;
                        $scope.choseStudents.push(student);
                        $scope.listOfIndexes.push(i);
                    });
                } else {
                    $scope.students.forEach(function(student) {
                        student.edit = false;
                    });
                    $scope.choseStudents = [];
                    $scope.listOfIndexes = [];
                }
            };
            $scope.resetListOfRequires = function() {
                $scope.choseStudents.forEach(function(student) {
                    if (student !== undefined) {
                        setChoseRequirement(student);
                    }
                });
                $timeout(
                    function() {
                        AssignmentProgressResource.getAllByGroupIdAndCourseIdFromTopic(
                            {
                                courseId: $scope.courseId,
                                topicId: $state.params.tid,
                                groupId: $scope.groupId,
                                mark: true
                            },
                            function(progresses) {
                                allAssignmentProgress = progresses;
                                var assignProg = sortedProgressByLessons(
                                    progresses
                                );
                                $scope.assignProg = assignProg;
                                initialate($scope.assignProg, true);
                            }
                        );
                    },
                    500
                );
            };
          //   $scope.getTestRequest = function () {
          //     $http({
          //       method: 'GET',
          //       url: '/api/lessonCompletions/course/'+ $scope.courseId +
          //         '/topic/' + $state.params.tid + '/lesson/' + $scope.lesson.id +
          //         '/group/' + $scope.groupId
          //     }).then(
          //       function successCallback(response) {
          //         console.log(response);
          //         $scope.getDate = response.data[0].completions;
          //       },
          //
          //       function errorCallback(response) {
          //         console.log('Bad Request');
          //     });
          //
          // };


            $scope.getCurrentDeadLine = function () {
                $http({
                    method: 'GET',
                    url: '/api/lessonCompletions/course/'+ $scope.courseId +
                        '/topic/' + $state.params.tid + '/lesson/' + $scope.lesson.id +
                        '/group/' + $scope.groupId
                }).then(
                    function successCallback(response) {
                        console.log(response)
                        // Конвертируем TimeStamp с сервера в локальный часовой пояс в милисекундах

                        var timeStampFromServer = response.data[0].completions;

                        console.log(timeStampFromServer)
                        console.log(timeStampFromServer*1000)
                        console.log(new Date(timeStampFromServer*1000))
                        if (timeStampFromServer == 0 || timeStampFromServer == null){
                            $scope.taskDeadlineSetUpButtonIsShown = true
                            $scope.taskDeadlineResultBlockIsOpen = false;
                        } else {
                            var timeStampFromServerInMillisecond = timeStampFromServer*1000
                            // console.log(new Date(timeStampFromServerInMillisecond))
                            var differenceBetweenVisitorTimeAndGMTInMilliseconds = Math.abs(new Date().getTimezoneOffset()*60000);
                            differenceBetweenVisitorTimeAndGMTInMilliseconds = Math.abs(differenceBetweenVisitorTimeAndGMTInMilliseconds)
                            var differenceBetweenMoscowTimeAndGMTInMilliseconds = 10800000;
                            var differenceBetweenVisitorTimeAndMoscowTimeInMilliseconds = differenceBetweenVisitorTimeAndGMTInMilliseconds - differenceBetweenMoscowTimeAndGMTInMilliseconds;

                            var timeStampConvertedInLocalFormat = timeStampFromServerInMillisecond + differenceBetweenVisitorTimeAndMoscowTimeInMilliseconds

                            var date = new Date(timeStampConvertedInLocalFormat)
                            console.log(date)
                            var day = date.getDate()
                            console.log(day)
                            $scope.taskDeadlineDay = day;
                            var month = date.getMonth()+1
                            console.log(month)
                            var monthInWords;
                            switch (month) {
                            case 1:
                                monthInWords = "января"
                                break;
                            case 2:
                                monthInWords = "февраля"
                                break;
                            case 3:
                                monthInWords = "марта"
                                break;
                            case 4:
                                monthInWords = "апреля"
                                break;
                            case 5:
                                monthInWords = "мая"
                                break;
                            case 6:
                                monthInWords = "июня"
                                break;
                            case 7:
                                monthInWords = "июля"
                                break;
                            case 8:
                                monthInWords = "августа"
                                break;
                            case 9:
                                monthInWords = "сентября"
                                break;
                            case 10:
                                monthInWords = "октября"
                                break;
                            case 11:
                                monthInWords = "ноября"
                                break;
                            case 12:
                                monthInWords = "декабря"
                                break;

                            }
                            $scope.taskDeadlineMonth = monthInWords;
                            var year = date.getFullYear();
                            console.log(year)
                            $scope.taskDeadlineYear = year
                            var hours = date.getHours()
                            console.log(hours)
                            $scope.taskDeadlineHours = hours
                            var minutes = date.getMinutes()
                            console.log(minutes)
                            $scope.taskDeadlineMinutes = minutes;

                            $scope.taskDeadlineSetUpBlockIsOpen = false;
                            $scope.taskDeadlineResultBlockIsOpen = true;
                            $scope.taskDeadlineSetUpButtonIsShown = false;
                        }

                    },

                    function errorCallback(response) {
                        console.log('Bad Request');
                    });

            };
          $scope.postDeadlineRequest = function () {
              $http({
                  method: 'POST',
                  url: '/api/lessonCompletions/course/'+ $scope.courseId +
                      '/topic/' + $state.params.tid + '/lesson/' + $scope.lesson.id +
                      '/group/' + $scope.groupId + '?datetime=' + $scope.timeStampToSend
              }).then(
                  function successCallback(response) {
                      console.log(response);
                  },

                  function errorCallback(response) {
                      console.log('Bad Request');
                  });
          }
        }
        function LessonListener(e) {
            switch (e.data.method) {
                case 'getTask':
                    CourseResource.getOpenTask(
                        {
                            id: $scope.course.id,
                            taskImsccId: e.data.params.id
                        },
                        function(response) {
                            sendTask(e.data.params.id, response);
                        }
                    );
                    // }); // Course.getCourseTask($scope.course.id, e.data.params.id).then(function(response) { //     sendTask(e.data.params.id, response);
                    break;
                case 'openTask':
                    openTask(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'showWiki':
                    openResource(e.data.params.url);
                    break;
                case 'openQuizz':
                    $scope.openQuiz(
                        $scope.course.id,
                        e.data.params.id,
                        $scope.studentId
                    );
                    break;
                case 'open1C':
                    open1C(e.data.params.id);
                    break;
                default:
                    break;
            }
        }
        function openResource(url) {
            $scope.docPath = lmsConfig.coursesPath +
                $state.params.courseId +
                '/files/';
            url = $scope.docPath + url + '?cacheBuster=' + uuid4.generate();
            CourseTask.openResource(url);
        }
        function startSpin() {
            usSpinnerService.spin('spinner-1');
        }
        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        }
        function init() {
            if ($auth.isInRole('ROLE_STUDENT')) {
                $scope.classParallel = $auth.user.additionalUserInfoDTO.studentGroups[
                    0
                ].classParallel;
            } else if ($auth.isInRole('ROLE_PARENT')) {
                Course.getCourse($scope.courseId).then(function(course) {
                    $scope.classParallel = course.parallel;
                });
            }
            var canSeeUserGroups = [
                'ROLE_TEACHER',
                'ROLE_TUTOR',
                'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                'ROLE_TERRITORY_COORDINATOR',
                'ROLE_REGIONAL_COORDINATOR',
                'ROLE_PSYCHOLOGIST',
                'ROLE_METHODOLOGIST',
                'ROLE_HEAD_TEACHER',
                'ROLE_DEPUTY_HEAD_TEACHER'
            ];
            if ($auth.isInAnyRole(canSeeUserGroups)) {
                $scope.userAccess = true;
                if ($state.params.groupId) {
                    getCourseSection($state.params.groupId);
                } else {
                    $scope.$on('userGroupId', function(event, data) {
                        getCourseSection(data);
                        $scope.groupId = data;
                    });
                }
            } else {
                $scope.$watch(
                    function() {
                        return $auth.user.id;
                    },
                    function(userId) {
                        if (userId) {
                            $scope.userId = userId;
                            getProgresses(userId);
                        }
                    }
                );
            }
        }
        function getProgresses(studentId) {
            var studentIds = [];
            if ($auth.isInRole('ROLE_STUDENT')) {
                Course.getCourse(
                    $state.params.courseId
                ).then(function(response) {

                    $scope.course = response;
                    $scope.isOlympic = $scope.course.courseType.id === 2
                        ? true
                        : false;

                    $scope.userAccess = false;
                    $scope.students = [];
                    $scope.students.push($auth.user); // simply fetch assignment list for the current student (assessable only)
                    AssignmentProgressResource.getAllByCourseIdTopicIdAndStudentIds(
                        {
                            courseId: $scope.courseId,
                            topicId: $state.params.tid,
                            studentsIds: studentId
                        },
                        function(progresses) {
                            allAssignmentProgress = $scope.isOlympic
                                ? progresses.filter(function(p) {
                                      return p.value === 'require';
                                  })
                                : progresses;
                            var assignProg = sortedProgressByLessons(
                                allAssignmentProgress
                            );
                            $scope.assignProg = assignProg;
                            initialate(assignProg, true);
                            QuizProgressResource.getAllByCourseIdTopicIdAndStudentIds(
                                {
                                    courseId: $scope.courseId,
                                    topicId: $state.params.tid,
                                    studentsIds: studentId
                                },
                                function(quizzProgress) {
                                    allQuizProgress = quizzProgress;
                                    var quizzProg = quizzProgress;
                                    $scope.quizzProg = quizzProg;
                                    initialate(quizzProg, false);
                                }
                            );
                        }
                    );
                });
            } else if ($auth.isInRole('ROLE_PARENT')) {
                var unregisterWatch = $scope.$watch(
                    function() {
                        return $auth.user.relatedStudentId;
                    },
                    function(relatedStudentId) {
                        if (relatedStudentId) {
                            unregisterWatch();
                            UserResource.getChildren(
                                {
                                    parentId: $auth.user.id
                                },
                                function(students) {
                                    $scope.students = [];
                                    if (students.length === 0) {
                                        LmsUtils.showActionToast(
                                            'Данные детей не найдены',
                                            'Ok'
                                        );
                                        return;
                                    }
                                    for (var item in students) {
                                        if (
                                            students[item].id ===
                                            relatedStudentId
                                        ) {
                                            $scope.students.push(
                                                students[item]
                                            );
                                        }
                                    }
                                    Course.getCourse(
                                        $state.params.courseId
                                    ).then(function(response) {
                                        $scope.course = response;
                                        $scope.isOlympic = $scope.course.courseType.id ===
                                            2
                                            ? true
                                            : false;

                                        AssignmentProgressResource.getAllByCourseIdTopicIdAndStudentIds(
                                            {
                                                courseId: $scope.courseId,
                                                topicId: $state.params.tid,
                                                studentsIds: [relatedStudentId]
                                            },
                                            function(progresses) {
                                                allAssignmentProgress = $scope.isOlympic
                                                    ? progresses.filter(
                                                          function(p) {
                                                              return p.value ===
                                                                  'require';
                                                          }
                                                      )
                                                    : progresses;
                                                var assignProg = sortedProgressByLessons(
                                                    allAssignmentProgress
                                                );
                                                $scope.assignProg = assignProg;
                                                initialate(assignProg, true);
                                                QuizProgressResource.getAllByCourseIdTopicIdAndStudentIds(
                                                    {
                                                        courseId: $scope.courseId,
                                                        topicId: $state.params.tid,
                                                        studentsIds: [
                                                            relatedStudentId
                                                        ]
                                                    },
                                                    function(quizzProgress) {
                                                        allQuizProgress = quizzProgress;
                                                        var quizzProg = quizzProgress;
                                                        $scope.quizzProg = quizzProg;
                                                        initialate(
                                                            quizzProg,
                                                            false
                                                        );
                                                    }
                                                );
                                            }
                                        );
                                    });
                                }
                            );
                        }
                    }
                );
            } else {
                LmsUtils.showActionToast('Нет прав для просмотра данных', 'Ok');
            }
        }
        function getSCategory(testSCategory) {
            return testSCategory || 'C_DEFAULT';
        }
        function getCourseSection(gId) {
            $scope.groupId = gId;
            CourseSectionResource.getByCourseIdAndUserGroupId(
                {
                    courseId: $scope.courseId,
                    groupId: gId
                },
                function(result) {
                    $scope.isOlympic = result.course.courseType.id === 2
                        ? true
                        : false;

                    ($scope.students = result.userGroup.users.filter(
                        function(user) {
                            return user.status === 'ACTIVE';
                        }
                    )), ($scope.studentsCount = $scope.students.length); // for (i in sp) { //     $scope.students.push(i) //     studentIds.push(i.user.id); // } // sortByField($scope.students, 'id') // Добавляем поле sCategory если s_category то по умолчанию 'C_DEFAULT' // Сортируем по фамили + имени
                    $scope.students.sort(function(a, b) {
                        var fullName1 = a.lastName + ' ' + a.firstName;
                        var fullName2 = b.lastName + ' ' + b.firstName;
                        if (fullName1 < fullName2) {
                            return -1;
                        }
                        return 1;
                    }); // ------------------------
                    $scope.students.forEach(function(student) {
                        student.sCategory = getSCategory(student.s_category);
                        adaptedProgramList.forEach(function(program) {
                            if (student.sCategory === program.id) {
                                student.sCategoryTitle = program.name;
                            }
                        });
                    });
                    getUniqVariations(gId);
                    QuizProgressResource.getAllByGroupIdAndCourseIdFromTopic(
                        {
                            courseId: $scope.courseId,
                            topicId: $state.params.tid,
                            groupId: gId
                        },
                        function(quizzProgress) {
                            allQuizProgress = quizzProgress;
                            var quizzProg = sortedProgressByLessons(
                                quizzProgress
                            );
                            $scope.quizzProg = quizzProg;
                            initialate(quizzProg, false);
                            // console.log($scope.quizzes)
                            quizzStatistic(gId);
                        }
                    );
                    AssignmentProgressResource.getAllByGroupIdAndCourseIdFromTopic(
                        {
                            courseId: $scope.courseId,
                            topicId: $state.params.tid,
                            groupId: gId,
                            mark: true
                        },
                        function(progresses) {
                            allAssignmentProgress = progresses;
                            var assignProg = sortedProgressByLessons(
                                progresses
                            );
                            $scope.assignProg = assignProg;
                            initialate(assignProg, true);
                            $scope.variationCount = _.groupBy(
                                $scope.assignments,
                                'variation.name'
                            );
                            assignmentStatistic(gId);
                        }
                    );
                },
                function(result) {
                    if (result.status === 404) {
                        LmsUtils.showActionToast(
                            'Нет данных для данного курса и группы',
                            'Ok'
                        );
                    } else {
                        LmsUtils.showActionToast('Произошла ошибка', 'Ok');
                    }
                    clearMatrix();
                }
            );
        }
        function initialate(sortedProgress, boolVal) {
            if (boolVal) {
                initProgresses(sortedProgress, boolVal);
                initAssignmentProgressForStudents(sortedProgress);
            } else {
                initProgresses(sortedProgress, boolVal);
                initQuizzesProgressForStudents(sortedProgress);
            }
        }
        function sortedProgressByLessons(progresses) {
            var prog;
            prog = progresses.filter(function(progres) {
                if ($scope.lesson) {
                    return progres.lessonId === $scope.lesson.id || progres.taskForTopic === true;
                }
                return false;
            });
            return prog;
        }
        function getSudentsVariation(gId) {
            MatrixVariationResource.getAllStudentsVariationInTopic(
                {
                    topicId: $state.params.tid,
                    groupId: gId
                },
                function(studentVariation) {
                    studentVariation.forEach(function(studentVar) {
                        var a = _.find($scope.students, function(v) {
                            return v.id === studentVar.studentId;
                        });
                        if (a) {
                            a.variation = studentVar.variation;
                        }
                    });
                    setDefaultStudentVariation();
                }
            );
        }
        function setDefaultStudentVariation() {
            // Variation 'Не назначено'
            var defaultVariation = _.find($scope.variations, {
                id: 2
            });
            $scope.students.forEach(function(student) {
                if (
                    student.variation === undefined ||
                    student.variation === null
                ) {
                    student.variation = defaultVariation;
                    requestUpdateUserVariation(student);
                    return;
                }
            });
        }
        function getUniqVariations(gId) {
            MatrixVariationResource.getUniqVariations(
                {
                    topicId: $state.params.tid
                },
                function(uniqVariations) {
                    $scope.variations = uniqVariations;
                    $scope.defaultVariation = _.find($scope.variations, {
                        id: 2
                    });
                    getSudentsVariation(gId);
                }
            );
        }
        function updateStudentProgress(data, value) {
            var progressArray, progress, i;
            if (data.isAssignment) {
                $scope.assignProg.some(function(ap) {
                    if (ap.id == data.id) {
                        progress = ap;
                        return true;
                    }
                });
                progress.value = value;
                var _progressToUpdate = calculateOutputObject(progress);
                AssignmentProgressResource.updateRequireAndHomeAssignmentById(
                    {
                        id: _progressToUpdate.id,
                        require: _progressToUpdate.require,
                        home: _progressToUpdate.home
                    },
                    _progressToUpdate
                );
                $scope.students.forEach(function(student) {
                    student.assignmentsProgress.some(function(ap) {
                        if (ap.id == progress.id) {
                            // if(student.variation !== null) {
                            //     student.variation = null
                            // }
                            ap.value = progress.value;
                            calculateDefaultRequireAssigns(
                                student,
                                'statisticAssignment'
                            );
                            return true;
                        }
                    });
                });
                countResultofStatistic('statisticAssignment');
            } else {
                allQuizProgress.some(function(qp) {
                    if (qp.id == data.id) {
                        progress = qp;
                        return true;
                    }
                });
                progress.value = value;
                var _quizProgressUpdate = calculateOutputObject(progress); // delete _quizProgressUpdate.home;
                QuizProgressResource.updateRequireAndHomeAssignmentById(
                    {
                        id: _quizProgressUpdate.id,
                        require: _quizProgressUpdate.require
                    },
                    _quizProgressUpdate
                );
                $scope.students.forEach(function(student) {
                    student.quizzesProgress.some(function(rp) {
                        if (rp.id == progress.id) {
                            rp.value = progress.value;
                            rp.required = rp.value === 'require' ? true : false;
                            calculateDefaultRequireAssigns(
                                student,
                                'statisticQuizz'
                            );
                            return true;
                        }
                    });
                });
                countResultofStatistic('statisticQuizz');
            }
        }
        function calculateOutputObject(entity) {
            var output = {
                id: entity.id,
                require: false,
                home: false
            };
            if (entity.value !== '') {
                output.require = true;
            }
            if (entity.value === 'home') {
                output.home = true;
                output.require = false;
            }
            return output;
        }
        function calculateDefaultRequireAssigns(student, kindeOfStatistic) {
            if (kindeOfStatistic === 'statisticQuizz') {
                $timeout(
                    function() {
                        quizzStatistic($scope.groupId);
                    },
                    100
                );
            } else {
                $timeout(
                    function() {
                        assignmentStatistic($scope.groupId);
                    },
                    100
                );
            }
        }
        function countResultofStatistic(statistic) {
            var result;
            result = {
                all: 0,
                required: 0,
                requiredByDefault: 0,
                solved: 0,
                markPublished: 0,
                studentCount: 0
            };
            $scope.students.forEach(function(student) {
                if (student[statistic]) {
                    result.all += student[statistic].all;
                    result.required += student[statistic].required;
                    result.requiredByDefault += student[
                        statistic
                    ].requiredByDefault;
                    if (student[statistic].solved) {
                        result.solved += student[statistic].solved;
                    }
                    result.markPublished += student[statistic].markPublished;
                } else {
                    result = {
                        all: 0,
                        markPublished: 0,
                        required: 0,
                        requiredByDefault: 2,
                        solved: 0
                    };
                }
            });
            $scope.resultOfAllStatistic[
                statistic
            ] = _.mapValues(result, function(value) {
                return (value / $scope.studentsCount).toFixed(1);
            }); // console.log( $scope.resultOfAllStatistic[statistic])
        }
        function initAssignmentProgressForStudents(progresses) {
            if (!$scope.students.length) {
                return;
            }
            $scope.students.map(function(student) {
                var ap = progresses.filter(function(progress) {
                    return student.id === progress.studentId;
                });
                return (student.assignmentsProgress = ap.map(function(p) {
                    return {
                        id: p.id,
                        sCategory: p.s_category,
                        olympiadPath: p.olympiadPath,
                        value: calculateInputValueAndDisabledForAssignment(p),
                        isDisabled: p.isDisabled,
                        imsccId: p.imsccId,
                        imsccParentId: p.imsccParentId
                            ? p.imsccParentId
                            : p.imsccId,
                        solved: p.solved,
                        marked: !p.mark ? false : true,
                        topicNumber: p.topicNumber,
                        lessonNumber: p.lessonNumber,
                        index: p.index,
                        keyQuestion: p.keyQuestion,
                        taskForTopic: p.taskForTopic,
                        mark: p.mark,
                        title: p.name,
                        requiredByDefault: p.requiredByDefault,
                        variation: p.variation !== null ? p.variation.name : '',
                        variationId: p.variation !== null
                            ? p.variation.id
                            : null,
                        variationName: p.variation !== null
                            ? p.variation.name
                            : null,
                        subType: p.subType
                    };
                }));
            });
        }
        function initQuizzesProgressForStudents(progresses) {
            if (!$scope.students.length) {
                return;
            }
            $scope.students.map(function(student) {
                var qp = progresses.filter(function(progress) {
                    return student.id === progress.studentId;
                });
                return (student.quizzesProgress = qp.map(function(p) {
                    return {
                        id: p.id,
                        sCategory: p.s_category,
                        required: p.required,
                        value: calculateInputValueAndForQuizz(p),
                        imsccId: p.imscc,
                        topicNumber: p.topicNumber,
                        lessonNumber: p.lessonNumber,
                        mark: p.mark,
                        title: p.name,
                        variation: p.variation !== null ? p.variation.name : '',
                        variationId: p.variation.id,
                        variationName: p.variation !== null
                            ? p.variation.name
                            : null,
                        subType: p.subType,
                        requiredByDefault: p.requiredByDefault,
                        shuffleAnswers: p.shuffleAnswers
                    };
                }));
            });
        }
        function calculateInputValueAndDisabledForAssignment(
            assignmentProgress
        ) {
            assignmentProgress.isDisabled = false;
            if (
                assignmentProgress.topicProgressId != null ||
                // assignmentProgress.keyQuestion === true ||
                assignmentProgress.mark !== null ||
                // assignmentProgress.taskForTopic === true ||
                assignmentProgress.solved === true
            ) {
                assignmentProgress.isDisabled = true;
            }
            if (assignmentProgress.value === '') {
                return '';
            }
            if (assignmentProgress.value === 'require') {
                return 'require';
            }
            if (assignmentProgress.value === 'home') {
                return 'home';
            } // if (assignmentProgress.required === true && assignmentProgress.homeAssignment === false) { //     return 'require'; // } // if (assignmentProgress.required === true && assignmentProgress.homeAssignment === true) { //     return 'home'; // }
        }
        function calculateInputValueAndForQuizz(quizProgres) {
            if (quizProgres.value === undefined && quizProgres.required) {
                return 'require';
            }
            if (quizProgres.value === '') {
                return '';
            }
            if (quizProgres.value === 'require') {
                return 'require';
            }
            if (quizProgres.value === 'home') {
                return 'home';
            }
        }
        function initProgresses(progresses, isAssignment) {
            var result = [], BreakException = {};
            sortByField(progresses, 'studentId');
            try {
                /*jshint validthis:true */ progresses.forEach(
                    function(item, index, arr) {
                        if (
                            index !== 0 &&
                            item.studentId !== arr[index - 1].studentId
                        ) {
                            throw BreakException;
                        }
                        if (isAssignment) {
                            // item.assignment.topicNumber = item.topicNumber;
                            // item.assignment.lessonNumber = item.lessonNumber;
                            result.push(item);
                        } else {
                            result.push(item);
                        }
                    },
                    this
                );
            } catch (e) {
                if (e !== BreakException) throw e;
            }
            if (isAssignment) {
                $scope.assignments = result.map(function(res) {
                    res.title = res.name;
                    res.imsccParentId = res.imsccParentId
                        ? res.imsccParentId
                        : res.imsccId;
                    return res;
                });
            } else {
                $scope.quizzes = result.map(function(res) {
                    res.title = res.name;
                    res.imsccParentId = res.imsccParentId
                        ? res.imsccParentId
                        : res.imsccId;
                    return res;
                });
            }
        }
        function sortByField(result, field) {
            result.sort(function(a, b) {
                if (a[field] > b[field]) {
                    return 1;
                } else if (a[field] < b[field]) {
                    return -1;
                } else {
                    return 0;
                }
            });
        }
        function clearMatrix() {
            allAssignmentProgress = [];
            $scope.students = [];
            $scope.assignments = [];
        }
        function updateIfChangeVariation(student) {
            var requireGroup = [];
            student.assignmentsProgress.forEach(function(assignmentsProgres) {
                if (
                    student.variation === null ||
                    student.variation === undefined
                ) {
                    return;
                } else {
                    if (
                        student.variation.name ===
                            assignmentsProgres.variation ||
                        assignmentsProgres.taskForTopic === true
                    ) {
                        var assignmentProgres = {
                            id: assignmentsProgres.id,
                            require: true,
                            home: false
                        };
                        requireGroup.push(assignmentProgres);
                        assignmentsProgres.value = 'require';
                    } else {
                        if (assignmentsProgres.keyQuestion === false) {
                            assignmentsProgres.value = '';
                        }
                    }
                    if (
                        student.variation.name !== assignmentsProgres.variation
                    ) {
                        var assignmentProgres = {
                            id: assignmentsProgres.id,
                            require: false,
                            home: false
                        };
                        requireGroup.push(assignmentProgres);
                    }
                }
            });
            function updateGroupRequireQuizProgresFire() {
                student.quizzesProgress.forEach(function(quizzesProgres) {
                    if (
                        student.variation === null ||
                        student.variation === undefined
                    ) {
                        return;
                    } else {
                        if (
                            student.variation.name ===
                                quizzesProgres.variation ||
                            quizzesProgres.taskForTopic === true
                        ) {
                            var quizProgres = {
                                id: quizzesProgres.id,
                                require: true
                            };
                            requireGroup.push(quizProgres);
                            quizzesProgres.value = 'require';
                        } else {
                            quizzesProgres.value = '';
                        }
                        if (
                            student.variation.name !== quizzesProgres.variation
                        ) {
                            var quizProgres = {
                                id: quizzesProgres.id,
                                require: false
                            };
                            requireGroup.push(quizProgres);
                        }
                    }
                });
                updateGroupRequireQuizProgres(requireGroup);
                requireGroup = [];
            }
            if (requireGroup.length > 1) {
                updateGroupRequireAssigmentProgres(
                    requireGroup
                ).then(function() {
                    updateGroupRequireQuizProgresFire();
                });
                requireGroup = [];
            } else {
                $timeout(
                    function() {
                        updateGroupRequireQuizProgresFire();
                    },
                    10
                );
            }
        }
        function requestUpdateUserVariation(user) {
            if (user.variation !== undefined) {
                var _user = {
                    tid: Number($state.params.tid),
                    id: user.id,
                    variationId: user.variation.id
                };
                MatrixVariationResource.updateUserVariationInTopic(
                    {
                        topicId: Number(_user.tid),
                        userId: _user.id,
                        variationId: _user.variationId
                    },
                    _user
                );
            }
        }
        function updateGroupRequireAssigmentProgres(
            arrayOfRequires,
            currentStudent
        ) {
            return AssignmentProgressResource.updateGroupRequiresAssignment(
                arrayOfRequires
            ).$promise.then(function() {
                // После обновления вычисляем статистику
                calculateDefaultRequireAssigns(
                    currentStudent,
                    'statisticAssignment'
                );
            });
        }
        function updateGroupRequireQuizProgres(
            arrayOfRequires,
            currentStudent
        ) {
            QuizProgressResource.updateGroupRequiresQuiz(
                arrayOfRequires
            ).$promise.then(function() {
                // После обновления вычисляем статистику
                calculateDefaultRequireAssigns(
                    currentStudent,
                    'statisticQuizz'
                );
            });
        }
        function quizzStatistic(gId) {
            QuizProgressResource.getAllQuizzStatisticFromTopic(
                {
                    courseId: $scope.courseId,
                    topicId: $state.params.tid,
                    groupId: gId
                },
                function(statistic) {
                    $scope.students.map(function(student) {
                        statistic.forEach(function(stats) {
                            if (student.id === stats.userId) {
                                student.statisticQuizz = stats;
                            }
                        });
                    });
                    countResultofStatistic('statisticQuizz');
                }
            );
        }
        function assignmentStatistic(gId) {
            AssignmentProgressResource.getAllStatisticForAssignment(
                {
                    courseId: $scope.courseId,
                    topicId: $state.params.tid,
                    groupId: gId
                },
                function(statistic) {
                    $scope.students.map(function(student) {
                        statistic.forEach(function(stats) {
                            if (student.id === stats.userId) {
                                student.statisticAssignment = stats;
                            }
                        });
                    });
                    countResultofStatistic('statisticAssignment');
                }
            );
        }
        function preventDeleteRequire(data) {
            var fd, len, variant, dataId = data.id;
            if (data.isAssignment) {
                $scope.students.some(function(student) {
                    var st = student.assignmentsProgress;
                    variant = student.variation.name;
                    var dd = _.find(st, {
                        id: dataId
                    });
                    if (dd !== undefined) {
                        fd = _.filter(st, function(s) {
                            return s.value === 'require' || s.value === 'home';
                        });
                        len = fd.length;
                        return true;
                    }
                });
            } else {
                $scope.students.some(function(student) {
                    var st = student.quizzesProgress;
                    variant = student.variation.name;
                    var dd = _.find(st, {
                        id: dataId
                    });
                    if (dd !== undefined) {
                        fd = _.filter(st, function(s) {
                            return s.value === 'require' || s.value === 'home';
                        });
                        len = fd.length;
                        return true;
                    }
                });
            } // временное решение
            if (variant === 'Не назначен') {
                return true;
            } else if ($scope.variationCount[variant].length < len) {
                return true;
            }
        }
        function updateGroupProgress(data) {
            startSpin();
            data.userIds = $scope.students.map(function(st) {
                return st.id;
            });
            data.courseId = $scope.courseId;
            AssignmentProgressResource.updateRequireForUserGroup(data)
                .$promise.then(function(res) {
                    init();
                    stopSpin();
                })
                .catch(function(err) {
                    stopSpin();
                });
        }

        function setChoseRequirement(currentStudent) {
            var requireList = [];
            if ($scope.assignOn) {
                currentStudent.assignmentsProgress.forEach(
                    function(assignment) {
                        if (
                            !assignment.taskForTopic &&
                            !assignment.keyQuestion &&
                            !assignment.marked &&
                            !assignment.solved &&
                            assignment.value !== 'home'
                        ) {
                            assignment.value = '';
                            var assignmentProgres = {
                                id: assignment.id,
                                require: false,
                                home: false
                            };
                            requireList.push(assignmentProgres);
                        }
                    }
                );
                currentStudent.edit = false;
                $scope.choseStudents = $scope.choseStudents.filter(
                    function(choseStudent) {
                        return choseStudent !== currentStudent.id;
                    }
                );
                $scope.listOfIndexes.pop();
                updateGroupRequireAssigmentProgres(requireList, currentStudent);
            } else {
                currentStudent.quizzesProgress.forEach(function(quiz) {
                    if (
                        !quiz.taskForTopic &&
                        !quiz.keyQuestion &&
                        !quiz.marked &&
                        !quiz.solved
                    ) {
                        quiz.value = '';
                        var quizProgres = {
                            id: quiz.id,
                            require: false
                        };
                        requireList.push(quizProgres);
                    }
                });
                currentStudent.edit = false;
                $scope.choseStudents = $scope.choseStudents.filter(
                    function(choseStudent) {
                        return choseStudent !== currentStudent.id;
                    }
                );
                $scope.listOfIndexes.pop();
                // console.log($scope.choseStudents, $scope.listOfIndexes)
                currentStudent.variation = $scope.defaultVariation;
                updateGroupRequireQuizProgres(requireList, currentStudent);
            }
            currentStudent.variation = $scope.defaultVariation;
            requestUpdateUserVariation(currentStudent);
            $scope.allChose = false;
            $scope.choseStudents = [];
        }
    }
]);

'use strict';

app.controller('CourseSectionOpenTaskTableBarCtrl', ['$scope', '$auth', 'CourseService', 'CourseResource', 'UserGroupResource', 'SchoolResource', 'TerritoryResource', '$state', 'TopicResource', function ($scope, $auth, CourseService, CourseResource, UserGroupResource, SchoolResource, TerritoryResource, $state, TopicResource) {
    var unbindAuthWatcher;

    $scope.topics = [];
    $scope.topic = null;
    $scope.userGroups = [];
    $scope.userGroup = null;
    $scope.schools = [];
    $scope.school = null;
    $scope.territories = [];
    $scope.territory = null;
    $scope.lessons = [];
    $scope.lesson = null;


    unbindAuthWatcher = $scope.$watch(function () {
        return $auth.user.userRoles;
    }, function (userRoles) {
        if (userRoles) {
            init(userRoles);
            unbindAuthWatcher();
        }
    });
    // $scope.$watch('lesson', function (newVal, oldVal) {
    //     console.log('newVal', newVal);
    //     return CourseService.store('lesson', newVal);
    // })
    $scope.changeState = function (entity) {
        // console.log('entity', entity);
        var params = {
            territoryId: $scope.territory ? $scope.territory.id : null,
            schoolId: $scope.school ? $scope.school.id : null,
            groupId: $scope.userGroup ? $scope.userGroup.id : null,
            tid: $scope.topic.id,
            // lid: $scope.topic.lessons.length < 1 ? null : $scope.topic.lessons[0].id,
            lid: $scope.lesson ? $scope.lesson.id : null
        };
        if (entity === 'territory') {
            params.schoolId = null;
            params.groupId = null;
        } else if (entity === 'school') {
            params.groupId = null;
        }
        console.log('params', JSON.parse(JSON.stringify(params)));
        $state.go('courseSectionOpenTaskTable', params);
    };

    $scope.changeStateTopic = function (entity) {
        // console.log('entity', entity);
        var params = {
            territoryId: $scope.territory ? $scope.territory.id : null,
            schoolId: $scope.school ? $scope.school.id : null,
            groupId: $scope.userGroup ? $scope.userGroup.id : null,
            tid: $scope.topic.id,
            // lid: $scope.topic.lessons.length < 1 ? null : $scope.topic.lessons[0].id,
            lid: $scope.lesson ? $scope.lesson.id : null
        };
        if (entity === 'territory') {
            params.schoolId = null;
            params.groupId = null;
        } else if (entity === 'school') {
            params.groupId = null;
        }
        //console.log('params', JSON.parse(JSON.stringify(params)));
        getLessons($scope.topic.lessons);
        //console.log('lessons', $scope.lessons);
        //$state.go('courseSectionOpenTaskTable', params);
    };

    function init(userRoles) {
        var currentRole = userRoles[0],
            isTutor = (currentRole === 'ROLE_TUTOR'),
            isTeacher = (currentRole === 'ROLE_TEACHER'),
            isDEC = (currentRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'),
            isPsy = (currentRole === 'ROLE_PSYCHOLOGIST'),
            isMeth = (currentRole === 'ROLE_METHODOLOGIST'),
            isDir = (currentRole === 'ROLE_HEAD_TEACHER'),
            isZamDir = (currentRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
            isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
            isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR');

        getTopics();

        if (isTerritoryCoordinator || isRegionalCoordinator) {
            getTerritories();
        } else if (isDir || isZamDir || isPsy) {
            getUserGroups();
            getSchools();
        } else if (isTutor || isTeacher) {
            getUserGroups();
        } else if (isDEC || isMeth) {
            getSchools();
        }
    }

    function getTopics() {
        CourseResource.getCourseName({ 'courseId': $state.params.courseId }, function (course) {
            $scope.courseName = course.name;
        })
        TopicResource.getAllTopicsByCourseId({ 'courseId': $state.params.courseId }, function (response) {
            $scope.topics = response;

            $scope.topics.sort(function(a, b) {
              if(a.number < b.number) return -1;
              if(a.number > b.number) return 1;

              return 0;
            });

            $scope.topics.some(function (topic) {
                if (topic.id == $state.params.tid) {
                    $scope.topic = topic;
                    $scope.subType = topic.subType;
                    getLessons(topic.lessons)
                    return true;
                }
            });

            $scope.$parent.$broadcast('lessonNumber', $scope.lesson);
            $scope.$parent.$broadcast('subType', $scope.subType);
        });
    }
    function getLessons(lessons) {
        $scope.lessons = lessons;
        if ($state.params.lid !== undefined || $state.params.lid === null) {
            $scope.lesson = _.find($scope.lessons, function (lsn) {
                return lsn.id === +$state.params.lid;
            })
        } else {
            $scope.lesson = _.find($scope.lessons, function (lsn) {
                return lsn.number === 1;
            });
        }

        $scope.lessons.sort(function(a,b) {
          if(a.number < b.number) return -1;
          if(a.number > b.number) return 1;

          return 0;
        });

        // Если нет лесона выбираем первый из лесонов если он есть и редиректим туда
        if (!$scope.lesson) {
            if ($scope.lessons) {
                if ($scope.lessons.length > 0) {
                    $scope.lesson = $scope.lessons[0];
                    $scope.changeState();
                    return;
                }
            }
        }

        CourseService.store('lesson', $scope.lesson);
    }

    function getUserGroups() {
        var sId = ($scope.school) ? $scope.school.id : void 0;

        if (sId) {
            UserGroupResource.getBySchoolCourseAndCurrentCoordinatorId({
                'schoolId': sId,
                'courseId': $state.params.courseId
            }).$promise.then(initUserGroups);
        } else {
            UserGroupResource.getByCourseIdAndCurrentUserId({'courseId': $state.params.courseId }).$promise.then(initUserGroups);
        }
    }

    function initUserGroups(result) {
        var gId = $state.params.groupId;
        $scope.userGroups = result.filter(function (uGroup) {
            return uGroup.users.length && uGroup.users.filter(function (user) {
                return user.status != 'DISABLED'
            }).length
        });

        if ($scope.userGroups.length === 0) {
            userGroupsNotFound();
            return;
        }

        $scope.userGroups.sort(function(a,b) {
          return ('' + a.name).localeCompare(b.name);
        });

        if (gId) {
            $scope.userGroups.some(function (group) {
                if (group.id == gId) {
                    $scope.userGroup = group;
                    return true;
                }
            });
        } else {
            $scope.userGroup = $scope.userGroups[0];
            $state.params.groupId = $scope.userGroup.id;
            if (!!$scope.$parent) {
                $scope.$parent.$broadcast('userGroupId', $scope.userGroup.id);
            }
        }
    }

    function userGroupsNotFound() {
        $scope.userGroups = [{
            id: 0,
            name: 'Группы не найдены'
        }];
        $scope.userGroup = $scope.userGroups[0];
    }

    function getSchools() {
        var tId = $scope.territory ? $scope.territory.id : null;

        if (tId) {
            //SchoolResource.getAllByTerritoryCourseAndCurrentCoordinator(tId, $state.params.courseId).then(initSchools);
            SchoolResource.getByTerritoryCourseAndCurrentCoordinator({
                'territoryId': sId,
                'courseId': $state.params.courseId
            }).then(initSchools);
        } else {
            //SchoolResource.getAllByCourseAndCurrentCoordinator($state.params.courseId).then(initSchools);
            SchoolResource.getByCourseIdAndCurrentCoordinator({'courseId': $state.params.courseId}).then(initSchools);
        }
    }

    function initSchools(result) {
        console.log('dlokib');
        var sId = $state.params.schoolId;

        $scope.schools = result;

        if ($scope.schools.length === 0) {
            $scope.schools.push({
                id: 0,
                name: 'Школы не найдены'
            });
            $scope.school = $scope.schools[0];
            userGroupsNotFound();
            return;
        }

        if (sId) {
            $scope.schools.some(function (school) {
                if (school.id == sId) {
                    $scope.school = school;
                    return true;
                }
            });
        } else {
            $scope.school = $scope.schools[0];
        }

        getUserGroups();
    }

    function getTerritories() {
        var tId = $state.params.territoryId;

        TerritoryResource.getAllByCoordinator(function (result) {
            $scope.territories = result;

            if ($scope.territories.length === 0) {
                $scope.territories.push({
                    id: 0,
                    name: 'Территории не найдены'
                });
                $scope.territory = $scope.territories[0];
                return;
            }

            if (tId) {
                $scope.territories.some(function (territory) {
                    if (territory.id == tId) {
                        $scope.territory = territory;
                        return true;
                    }
                });
            } else {
                $scope.territory = $scope.territories[0];
            }

            getSchools();
        });
    };
    return
}]);

'use strict';

app.config(['$stateProvider', 'lmsConfig', function ($stateProvider, lmsConfig) {
    $stateProvider
        .state('courseSectionOpenTaskTable', {
            parent: 'dashboard',
            url: 'openTaskTable?courseId&tid&groupId&schoolId&territoryId&lid',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "courseSection/views/_openTaskTableBar.html",
                    controller: 'CourseSectionOpenTaskTableBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "courseSection/views/openTaskTable.html",
                    controller: 'CourseSectionOpenTaskTableCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Матрица назначения заданий'
            }
        });
    }]);

'use strict';

angular.module('lmsClientApp').directive('openTaskTable', [
    'lmsConfig',
    'CourseTask',
    'Quiz',
    '$auth',
    '$timeout',
    "$state",
    function(lmsConfig, CourseTask, Quiz, $auth, $timeout,$http,$state) {
        return {
            restrict: 'E',
            replace: true,
            // scope: {
            //     dtDateTime: '=?',
            //     dtHourStep: '=?',
            //     dtMinuteStep: '=?',
            //     dtShowMeridian: '=?',
            // },
            templateUrl: lmsConfig.modulesPath +
                'courseSection/views/_openTaskTable.html',
            link: function(scope, element, attrs) {
                // var defaultHourStep = 1, defaultMinuteStep = 10, defaultShowMeridian = false;
                // scope.dtHourStep = scope.dtHourStep ? scope.dtHourStep : defaultHourStep;
                // scope.dtMinuteStep = scope.dtMinuteStep ? scope.dtMinuteStep : defaultMinuteStep;
                // scope.dtShowMeridian = scope.dtShowMeridian !== void 0 && scope.dtShowMeridian !== null
                //     ? scope.dtShowMeridian
                //     : defaultShowMeridian; /*** Получаем время начала конференции ***/
                (scope.hours = []), (scope.minutes = []);
                var now = new Date();
                for (var i = 0; i < 24; i++) {
                    if (i < 10) {
                        i = '0' + i;
                    }
                    scope.hours.push(i);
                }
                for (var i = 0; i < 60; i++) {
                    if (i < 10) {
                        i = '0' + i;
                    }
                    scope.minutes.push(i);
                } // Устанавливанем дефолтные значения времени
                scope.selectedHour = scope.hours[23];
                scope.selectedMinute = scope.minutes[59]; // Наблюдаем за изменением времени
                // scope.$watch(
                //     function() {
                //         return scope.selectedHour;
                //     },
                //     function() {
                //         scope.dtDateTime.time.setHours(scope.selectedHour);
                //         scope.dtDateTime.time.setMinutes(scope.selectedMinute);
                //     }
                // );
                // scope.$watch(
                //     function() {
                //         return scope.selectedMinute;
                //     },
                //     function() {
                //         scope.dtDateTime.time.setHours(scope.selectedHour);
                //         scope.dtDateTime.time.setMinutes(scope.selectedMinute);
                //     }
                // ); /*** ***/



                var contextMenu = $('#context-menu'),
                    editMenu = $('#edit-menu'),
                    changeAll = false,
                    progressesToUpdate = [],
                    openTaskTable = document.querySelector('.open-task-table'),
                    unbindStudentWatcher;

                if (openTaskTable) {
                    //fix for chrome scrollbar overlapping
                    // console.log(scope.isOlympic);
                    setTimeout(
                        function() {
                            openTaskTable.style.padding = 0;
                        },
                        0
                    );

                    $timeout(function() {
                        unbindStudentWatcher = scope.$watch(
                            function() {
                                if (
                                    scope.students && scope.students.length > 0
                                ) {
                                    return scope.students[
                                        0
                                    ].assignmentsProgress;
                                }
                            },
                            function(ap) {
                                var width = 0, cells;

                                if (ap) {
                                    //get real width of the table.
                                    cells = openTaskTable.firstElementChild.lastElementChild.children;
                                    if (
                                        cells.length > 4 &&
                                        cells[2].clientWidth < 31
                                    ) {
                                        [
                                        ].forEach.call(
                                            cells,
                                            function(cell, i) {
                                                if (
                                                    i >= 2 &&
                                                    i < cells.length - 1
                                                ) {
                                                    width += cell.clientWidth +
                                                        1;
                                                }
                                            }
                                        );
                                        openTaskTable.classList.add(
                                            'non-responsive'
                                        );
                                        // openTaskTable.querySelector('.tb-cell.flex-60').style.minWidth = width + 'px';
                                        [
                                        ].forEach.call(
                                            openTaskTable.children,
                                            function(tbItem) {
                                                tbItem.style.minWidth = width +
                                                    400 +
                                                    'px';
                                            }
                                        );
                                    } else {
                                        openTaskTable.classList.remove(
                                            'non-responsive'
                                        );
                                    }
                                    unbindStudentWatcher();
                                }
                            }
                        );
                    });
                }

                scope.openTask = function(cid, tid, sid) {
                    if (cid !== void 0 && tid !== void 0) {
                        CourseTask.open(cid, tid, sid);
                    }
                };
                scope.openOlymp = function(url) {
                    var resUrl = '/ui/upload/courses/' +
                        scope.courseId +
                        '/files/' +
                        url;
                    CourseTask.openResource(resUrl);
                };

                scope.openCalendar = function (){
                    scope.calendarIsOpen = t
                },
                scope.sendDeadLine = function (hours,minutes,date){

                    if (date == undefined) {
                        console.log("Выберите дату")
                        scope.deadLineErrorBlock = true
                        scope.deadLineErrorMessage = "Выберите дату"
                    } else {
                        scope.deadLineErrorBlock = false
                        if ( hours < 24) {

                            if (minutes < 60) {

                                scope.taskDeadlineSetUpBlockIsOpen = false;
                                scope.taskDeadlineResultBlockIsOpen = true;
                                scope.taskDeadlineHours = hours;
                                scope.taskDeadlineMinutes = minutes;
                                scope.taskDeadlineDate = date;
                                console.log(date)
                                scope.taskDeadlineYear = date.getFullYear();
                                scope.taskDeadlineDay = date.getDate();
                                var month = date.getMonth()+1;
                                var monthInWords;
                                switch (month) {
                                case 1:
                                    monthInWords = "января"
                                    break;
                                case 2:
                                    monthInWords = "февраля"
                                    break;
                                case 3:
                                    monthInWords = "марта"
                                    break;
                                case 4:
                                    monthInWords = "апреля"
                                    break;
                                case 5:
                                    monthInWords = "мая"
                                    break;
                                case 6:
                                    monthInWords = "июня"
                                    break;
                                case 7:
                                    monthInWords = "июля"
                                    break;
                                case 8:
                                    monthInWords = "августа"
                                    break;
                                case 9:
                                    monthInWords = "сентября"
                                    break;
                                case 10:
                                    monthInWords = "октября"
                                    break;
                                case 11:
                                    monthInWords = "ноября"
                                    break;
                                case 12:
                                    monthInWords = "декабря"
                                    break;

                                }
                                scope.taskDeadlineMonth = monthInWords;
                                scope.taskDeadlineTimeStamp = date.getTime()
                                console.log( scope.taskDeadlineTimeStamp)
                                var hoursInMilliSeconds = hours*3600000
                                var minutesInMilliSeconds = minutes*60000
                                scope.taskDeadlineTimeStamp = scope.taskDeadlineTimeStamp+hoursInMilliSeconds+minutesInMilliSeconds
                                console.log( scope.taskDeadlineTimeStamp)
                                // scope.taskDeadlineTimeStamp = scope.taskDeadlineTimeStamp/1000
                                // console.log( scope.taskDeadlineTimeStamp)

                                // Конвертируем TimeStamp в Московский формат в секундах для отправки
                                var differenceBetweenVisitorTimeAndGMTInMilliseconds = Math.abs(new Date().getTimezoneOffset()*60000);
                                differenceBetweenVisitorTimeAndGMTInMilliseconds = Math.abs(differenceBetweenVisitorTimeAndGMTInMilliseconds)
                                var differenceBetweenMoscowTimeAndGMTInMilliseconds = 10800000;
                                var differenceBetweenVisitorTimeAndMoscowTimeInMilliseconds = differenceBetweenVisitorTimeAndGMTInMilliseconds - differenceBetweenMoscowTimeAndGMTInMilliseconds;
                                var timeStampConvertedInMoscowFormat =  scope.taskDeadlineTimeStamp-differenceBetweenVisitorTimeAndMoscowTimeInMilliseconds;
                                timeStampConvertedInMoscowFormat = timeStampConvertedInMoscowFormat/1000
                                scope.timeStampToSend = timeStampConvertedInMoscowFormat;
                                console.log(scope.timeStampToSend)
                                scope.postDeadlineRequest()

                            } else {
                                scope.deadLineErrorBlock = true
                                scope.deadLineErrorMessage = "Введите время и дату в корректном формате"
                            }
                        } else {
                            scope.deadLineErrorBlock = true
                            scope.deadLineErrorMessage = "Введите время и дату в корректном формате"
                        }
                    }

                }
                scope.editDeadLine = function(){
                    scope.taskDeadlineSetUpBlockIsOpen = true;
                    scope.taskDeadlineResultBlockIsOpen = false;
                   scope.taskDeadlineSetUpButtonIsShown = false;

                }
                scope.deleteDeadLine = function (){
                    scope.timeStampToSend = 0;
                    scope.postDeadlineRequest()
                    scope.taskDeadlineSetUpButtonIsShown = true
                    scope.taskDeadlineResultBlockIsOpen = false;
                }
                scope.openQuiz = function(cid, tid, sid, isSubType1, isReady) {
                    if (cid !== void 0 && tid !== void 0) {
                        // Если это ткр и это учитель и квиз выполнен то открыаем результат
                        if (
                            isSubType1 &&
                            $auth.isInAnyRole(['ROLE_TEACHER']) &&
                            isReady
                        ) {
                            Quiz.openReady(cid, tid, sid);
                            return;
                        }
                        if (isSubType1) {
                            Quiz.openOneTry(cid, tid, sid);
                        } else {
                            Quiz.open(cid, tid, sid);
                        }
                    }
                };
                scope.changeStatus = function($event, imsccId, subType) {
                    var scp = $(this);
                    if (
                        !$auth.isInAnyRole([
                            'ROLE_TEACHER',
                            'ROLE_METHODOLOGIST'
                        ])
                    ) {
                        return;
                    } // toggle menu visibility
                    if (
                        contextMenu.is(':visible') &&
                        contextMenu.data('imscc-id') == imsccId
                    ) {
                        contextMenu
                            .offset({
                                top: 0,
                                left: 0
                            })
                            .hide();
                        return;
                    }
                    changeAll = true;
                    progressesToUpdate = [];
                    contextMenu.data('imscc-id', imsccId); // get assignment progress list
                    $('.studentProgress')
                        .filter(function() {
                            return $(this).data('imscc-id') === imsccId &&
                                !$(this).hasClass('done') &&
                                !$(this).hasClass('disabled');
                        })
                        .each(function() {
                            progressesToUpdate.push(
                                $(this).data('progress-id')
                            );
                        });
                    contextMenu.children('#set-home').show();
                    if (progressesToUpdate.length > 0) {
                        contextMenu.children('#task-link').hide();
                        if (scope.assignOn) {
                            contextMenu
                                .children('#set-require, #set-home, #set-none')
                                .show();
                        } else {
                            contextMenu.children('#set-home').hide();
                            contextMenu
                                .children('#set-require, #set-none')
                                .show();
                        }
                    } else {
                        contextMenu.children('#task-link').hide();
                        contextMenu
                            .children('#set-require, #set-home, #set-none')
                            .hide();
                    }
                    if (subType === 1) {
                        contextMenu.children('#set-home').hide();
                        if (scp[0].quiz && scp[0].quiz.mark) {
                            contextMenu.children('#set-require').hide();
                        }
                    }
                    // Выставляем позицию на месте клика мышки
                    var offset = {
                        top: $event.target.offsetTop,
                        left: $event.clientX - 6
                    };
                    contextMenu.offset(offset).show();
                };
                // /scope.changeStatus
                element.delegate(
                    '.tb-body .clickable',
                    'mouseenter',
                    function(e) {
                        var currentIndex = $(this).index();
                        var dataIndex = +$(this).data('index');
                        element
                            .find('.tb-row, .tb-cell')
                            .removeClass('highlighted')
                            .removeClass('clicked');
                        contextMenu
                            .offset({
                                top: 0,
                                left: 0
                            })
                            .hide();
                        $(this).addClass('clicked');
                        $(this).siblings().addClass('highlighted');
                        $('.tb-header .tb-row:last-child .tb-cell')
                            .filter(function(i) {
                                var cellIndex = +$(this).data('index');
                                return cellIndex === dataIndex;
                            })
                            .addClass('highlighted');
                        $('.tb-body .tb-row').each(function() {
                            $(this)
                                .children('.tb-cell')
                                .filter(function(i) {
                                    return i === currentIndex;
                                })
                                .addClass('highlighted');
                        }); // updateProgressTitle(angular.element(this)); // e.stopPropagation();
                    }
                );
                element.delegate('.clickable', 'mouseenter', function(e) {
                    var currentNode = $(this);
                    var currentIndex = $(this).index();
                    if (currentNode.data('imscc-id')) {
                        updateProgressTitle(angular.element(currentNode));
                        e.stopPropagation();
                    } else {
                        updateProgressTitle(
                            angular.element(currentNode.parent())
                        );
                        e.stopPropagation();
                    }
                });
                element.delegate(
                    '.tb-header .clickable',
                    'mouseenter',
                    function(e) {
                        var currentIndex = $(this).index();
                        var dataIndex = +$(this).data('index');
                        element
                            .find('.tb-row, .tb-cell')
                            .removeClass('highlighted')
                            .removeClass('clicked');
                        contextMenu
                            .offset({
                                top: 0,
                                left: 0
                            })
                            .hide();
                        $(this).addClass('clicked');
                        $(this).siblings().addClass('highlighted');
                        $('.tb-header .tb-row:last-child .tb-cell')
                            .eq(currentIndex)
                            .addClass('highlighted');
                        $('.tb-body .tb-row').each(function() {
                            $(this)
                                .children('.tb-cell')
                                .filter(function(i) {
                                    var cellIndex = +$(this).data('index');
                                    return cellIndex === dataIndex;
                                })
                                .addClass('highlighted');
                        });
                        updateProgressTitle(angular.element(this));
                        e.stopPropagation();
                    }
                );
                element.delegate('.tb-header .clickable', 'click', function(e) {
                    var elem = $(this),
                        maxWidthForNarrowCells = 70,
                        elemWidth = elem.outerWidth(),
                        offset = elem.offset(),
                        isAssignment = elem.data('is-assignment'),
                        isQuiz = elem.data('is-quiz');
                    contextMenu.data('progress-id', elem.data('progress-id'));
                    contextMenu.data('imscc-id', elem.data('imscc-id'));
                    contextMenu.data('is-assignment', isAssignment);
                    contextMenu.data('is-quiz', isQuiz);
                    contextMenu.data('path', elem.data('path'));
                    contextMenu.data('student-id', elem.data('student-id'));
                    contextMenu.data('is-subtype1', !!elem.data('is-subtype1'));
                    contextMenu.data('is-ready', !!elem.data('is-ready'));

                    if (elem.hasClass('assignment-header') && (elem.hasClass('assignment-taskfortopic') || elem.hasClass('assignment-keyquestion'))) {
                        contextMenu
                            .children('#set-require, #set-home, #set-none')
                            .hide();}
                });
                element.delegate('.tb-body .clickable', 'click', function(e) {
                    var elem = $(this),
                        maxWidthForNarrowCells = 70,
                        elemWidth = elem.outerWidth(),
                        offset = elem.offset(),
                        isAssignment = elem.data('is-assignment'),
                        isQuiz = elem.data('is-quiz'),
                        isSubType1 = elem.data('is-subtype1'),
                        isTFT = elem.data('is-tft'),
                        olympUrl = elem.data('olymp-url');
                    contextMenu.data('progress-id', elem.data('progress-id'));
                    contextMenu.data('imscc-id', elem.data('imscc-id'));
                    contextMenu.data('olymp-url', olympUrl);
                    contextMenu.data('is-assignment', isAssignment);
                    contextMenu.data('is-quiz', isQuiz);
                    contextMenu.data('is-tft', isTFT);
                    contextMenu.data('path', elem.data('path'));
                    contextMenu.data('student-id', elem.data('student-id'));
                    contextMenu.data('is-subtype1', !!elem.data('is-subtype1'));
                    contextMenu.data('is-ready', !!elem.data('is-ready'));
                    contextMenu.children('#set-none-for').hide();
                    contextMenu.children('#set-home').show();

                    if (elem.hasClass('disabled') || elem.hasClass('done')) {
                        contextMenu
                            .children('#set-require, #set-home, #set-none')
                            .hide();
                    } else if (
                        elem.children('.checked:visible').length > 0 && (elem.hasClass('keyquestion') || elem.hasClass('taskfortopic'))
                    ) {
                        contextMenu.children('#set-require').hide();
                        contextMenu.children('#set-home').hide();
                        contextMenu.children('#set-none').show();
                    } else if (
                        elem.children('.checked:visible').length === 0 && (elem.hasClass('keyquestion') || elem.hasClass('taskfortopic'))
                    ) {
                        contextMenu.children('#set-require').show();
                        contextMenu.children('#set-home').hide();
                        contextMenu.children('#set-none').hide();
                    } else if (
                        elem.children('.checked:visible').length > 0 && !isQuiz
                    ) {
                        contextMenu.children('#set-require').hide();
                        contextMenu.children('#set-home').show();
                        contextMenu.children('#set-none').show();
                    } else if (elem.children('.home:visible').length > 0) {
                        contextMenu.children('#set-require').show();
                        contextMenu.children('#set-home').hide();
                        contextMenu.children('#set-none').show();
                    } else if (!elem.children('div').hasClass('ng-hide')) {
                        contextMenu.children('#set-home').hide();
                        contextMenu.children('#set-require').show();
                        contextMenu.children('#set-none').show();
                    } else if (
                        elem.children('div').hasClass('ng-hide') &&
                        elem.children('.checked:visible').length === 0 &&
                        !isQuiz
                    ) {
                        contextMenu.children('#set-none').hide();
                        contextMenu.children('#set-require').show();
                        contextMenu.children('#set-home').show();
                    } else if (
                        elem.children('div').hasClass('ng-hide') &&
                        elem.children('.checked:visible').length === 0 &&
                        isQuiz
                    ) {
                        contextMenu.children('#set-none').hide();
                        contextMenu.children('#set-require').show();
                        contextMenu.children('#set-home').hide();
                    } else if (
                        elem.children('.checked:visible').length > 0 && isQuiz
                    ) {
                        contextMenu.children('#set-require').hide();
                        contextMenu.children('#set-home').hide();
                        contextMenu.children('#set-none').show();
                    } else {
                        contextMenu
                            .children('#set-require, #set-home, #set-none')
                            .show();
                    }
                    if (isAssignment) {
                        if (elemWidth > maxWidthForNarrowCells) {
                            offset.left = e.pageX + 1;
                        } else {
                            offset.left += elemWidth / 2;
                        }
                        contextMenu.children('#task-link').show();
                    } else {
                        if (elemWidth > maxWidthForNarrowCells) {
                            offset.left = e.pageX -
                                contextMenu.outerWidth() -
                                1;
                        } else {
                            offset.left -= contextMenu.outerWidth();
                        }
                        contextMenu.children('#task-link').hide();
                    } // Есил subType === 1 Убираем возможность назначения как домашнего задания
                    if (isSubType1 || scope.isOlympic) {
                        contextMenu.children('#set-home').hide();
                    } // Если задание не назначено ученику скрываем возможность на него перейти
                    if ($auth.isInRole('ROLE_STUDENT')) {
                        if (elem.data('is-assignment-to-user')) {
                            contextMenu.children('#task-link').hide();
                        }
                    }
                    // Показываем #task-link поле если есть флаг
                    if (elem.data('show-task-link')) {
                        contextMenu.children('#task-link').show();
                    }
                    // /Показываем #task-link поле
                    contextMenu.offset(offset).show();
                });
                element.delegate('.editable', 'click', function(e) {
                    var elem = $(this),
                        maxWidthForNarrowCells = 70,
                        offset = elem.offset(),
                        elemWidth = elem.outerWidth(),
                        studentIndex = elem.data('index');
                    if (studentIndex === undefined) {
                        return;
                    }
                    if (
                        !$auth.isInAnyRole([
                            'ROLE_TEACHER',
                            'ROLE_METHODOLOGIST'
                        ])
                    ) {
                        return;
                    }
                    editingStudentTasks(studentIndex);
                });
                document.addEventListener('click', function(e) {
                    var target = angular.element(e.target);
                    //Если не является тем элементом, на который был произведен клик
                    if (
                        !target.hasClass('clickable') &&
                        !target.parent().hasClass('clickable')
                    ) {
                        element
                            .find('.tb-row, .tb-cell')
                            .removeClass('highlighted');
                        contextMenu
                            .offset({
                                top: 0,
                                left: 0
                            })
                            .hide();
                        scope.$emit('assignmentTitle', '');
                    }
                });
                document.getElementById('set-home').onclick = function(e) {
                    updateProgressValue(angular.element(this), 'setAsHome');
                };
                document.getElementById('set-require').onclick = function(e) {
                    updateProgressValue(angular.element(this), 'setAsRequire');
                };
                document.getElementById('set-none').onclick = function(e) {
                    updateProgressValue(angular.element(this), 'setAsNone');
                }; // document.getElementById('matrix-lesson').onchange = function(e) { //     scope.$emit('lessonChange', {});   // };
                angular.element('body').on('click', '#quizz', function(e) {
                    $('#assign').removeClass('mtx-selected');
                    $(this).addClass('mtx-selected');
                    scope.$emit('quizzes', true);
                });
                document.getElementById('assign').onclick = function(e) {
                    $('#quizz').removeClass('mtx-selected');
                    $(this).addClass('mtx-selected');
                    scope.$emit('assigns', true);
                };
                document.getElementById('task-link').onclick = function(e) {
                    var asId = contextMenu.data('imscc-id');
                    var stId = contextMenu.data('student-id');
                    var quiz = contextMenu.data('is-quiz');
                    var isTFT = contextMenu.data('is-tft');
                    var olympUrl = contextMenu.data('olymp-url');

                    var isSubType1 = !!contextMenu.data('is-subtype1');
                    var isReady = !!contextMenu.data('is-ready');
                    if ($auth.isInRole('ROLE_STUDENT') || changeAll) {
                        changeAll = false;
                        if (quiz) {
                            scope.openQuiz(
                                scope.courseId,
                                asId,
                                undefined,
                                isSubType1
                            );
                        } else if (scope.isOlympic && !isTFT) {
                            scope.openOlymp(olympUrl);
                        } else {
                            scope.openTask(scope.courseId, asId);
                        }
                    } else {
                        if (quiz) {
                            scope.openQuiz(
                                scope.courseId,
                                asId,
                                stId,
                                isSubType1,
                                isReady
                            );
                        } else if (scope.isOlympic && !isTFT) {
                            scope.openOlymp(olympUrl);
                        } else {
                            scope.openTask(
                                scope.courseId,
                                asId,
                                stId,
                                isSubType1,
                                isReady
                            );
                        }
                    }
                };
                function updateProgressValue(elem, value) {
                    var parent = elem.parent(),
                        isQuiz = parent.data('is-quiz'),
                        isAssignment = parent.data('is-assignment'),
                        imsccId = parent.data('imscc-id');
                    if (changeAll) {
                        changeAll = false;
                        var emitObj = {
                            require: false,
                            home: false,
                            assigmnentImsccId: imsccId
                        };
                        switch (value) {
                            case 'setAsHome':
                                emitObj.home = true;
                                break;
                            case 'setAsRequire':
                                emitObj.require = true;
                                break;
                        }
                        scope.$emit('setForGroup', emitObj);
                        return;
                    }
                    if (isQuiz) {
                        scope.$emit(value, {
                            id: parent.data('progress-id'),
                            isAssignment: !isAssignment,
                            isQuiz: isQuiz
                        });
                    } else {
                        scope.$emit(value, {
                            id: parent.data('progress-id'),
                            isAssignment: isAssignment,
                            isQuiz: isQuiz
                        });
                    }
                }
                function editingStudentTasks(studentIndex) {
                    scope.$emit('chooseStudent', {
                        index: studentIndex
                    });
                }
                function updateProgressTitle(elem) {
                    var title = elem.data('title');
                    scope.$emit('progressTitle', title);
                }
            }
        };
    }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('CourseSectionResource', function ($resource) {
        return $resource('/api/courseSections/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getAllByTeacherId': {
                method: 'GET',
                url: '/api/courseSections/teacher/:id',
                isArray: true
            },
            'getAllAvailableForTeacherByGroupId': {
                method: 'GET',
                url: '/journal/teacher/group/:groupId/section',
                isArray: true
            },
            'updateTeacherInSection': {
                method: 'PUT',
                url: '/journal/teacher/section'
            },
            'getAllByUserGroupId': {
                method: 'GET',
                url: '/api/courseSections/userGroup/:id',
                isArray: true
            },
            'getByCourseIdAndUserGroupId': {
                method: 'GET',
                url: '/api/courseSections/course/:courseId/userGroup/:groupId'
            },
            'getAllByTutorId': {
                method: 'GET',
                url: '/api/courseSections/tutor/:id',
                isArray: true
            }
        });
    });

angular.module('lmsClientApp')
  .factory('CourseService', function ($q, $timeout) {
    var mem = {};
    var get = function(key) {
        var deferred = $q.defer();

        $timeout(function() {
          deferred.resolve(mem[key])
        }, 200);

        return deferred.promise;
      };
    return {
        store: function(key, value){
            mem[key] = value;
        },
        getFast: function(key){
            return mem[key];
        },        
        get: get
        }
  });


'use strict';

angular.module('lmsClientApp')
    .factory('CruduserResource', function ($resource) {
        return $resource('/api/crudusers/:id', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
        });
    });

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.DashboardCtrl
 * @description
 * # DashboardCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp').controller('DashboardCtrl', [
    '$scope',
    '$auth',
    'ProgressResource',
    '$state',
    'User',
    '$mdDialog',
    'lmsConfig',
    'CourseGroupResource',
    '$q',
    'Course',
    'SchoolResource',
    'RegionResource',
    'TerritoryResource',
    'LmsUtils',
    'DialogsResource',
    'usSpinnerService',
    'innopolis',
    function (
        $scope,
        $auth,
        ProgressResource,
        $state,
        User,
        $mdDialog,
        lmsConfig,
        CourseGroupResource,
        $q,
        Course,
        SchoolResource,
        RegionResource,
        TerritoryResource,
        LmsUtils,
        DialogsResource,
        usSpinnerService,
        innopolis
    ) {
        // Variables
        var rcToken = 'rcToken'
        $scope.user = null;
        $scope.unreadMessages;
        // $scope.sidebarHidden = true
        $scope.shortSidebarIsShown = false
        $scope.fullSidebarIsShown = true
        // show messenger if user has rcToken
        $scope.hasRcToken = localStorage.getItem(rcToken) === 'null' ? false : true
        $scope.showMessenger = !innopolis

        // Methods
        $scope.leftNavGoToPage = leftNavGoToPage;
        $scope.chooseCourseDialog = chooseCourseDialog;
        $scope.chooseCourseMatrix = chooseCourseMatrix;
        $scope.canSeeDashBar = canSeeDashBar;
        $scope.toogleSideBar = toogleSideBar;

        spinnerShow();
        $scope.$watch(
            function () {
                return $auth.user.userRoles;
            },
            function (userRoles) {
                if (userRoles) {
                    init();
                }
            }
        );
        // init();

        function init() {
            var hasAnySchoolRole = $auth.isInAnyRole([
                'ROLE_SCHOOL_ADMIN',
                'ROLE_HEAD_TEACHER',
                'ROLE_DEPUTY_HEAD_TEACHER',
                'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                'ROLE_METHODOLOGIST',
                'ROLE_PSYCHOLOGIST',
                'ROLE_TUTOR',
                'ROLE_STUDENT',
                'ROLE_PARENT',
                'ROLE_STUDENT',
                'ROLE_TEACHER'
            ]);

            if (!hasAnySchoolRole) {
                return;
            }

            SchoolResource.gettUserSchools()
                .$promise.then(function (response) {
                    var link = 'https://vk.com/club';
                    var userSchool = response[0] || {};
                    if (userSchool.vkGroupId) {
                        $scope.vkLink = link + userSchool.vkGroupId;
                    }
                    $scope.partnerProgram = userSchool.partnerProgram;
                })
                .catch(function (err) {
                    console.log(err.statusText, err.status);
                });
        }

        // function getVKgroupId() {
        //     User.getVKGroupId()
        //         .then(function(response) {
        //             console.log(response);

        //             if (
        //                 response.data.schoolSocialInfo.length &&
        //                 response.data.schoolSocialInfo[0].groupId
        //             ) {
        //                 $scope.vkLink = link +
        //                     response.data.schoolSocialInfo[0].groupId;
        //             }
        //         })
        //         .catch(function(err) {
        //             console.log(err);
        //         });
        // }

        // Получить количество непрочитанных сообщений
        function getUnreadMessages() {
            DialogsResource.getUnreadMessages().$promise.then(
                function (response) {
                    $scope.unreadMessages = response.unreadMessages;
                }
            );
        }
        getUnreadMessages();
        $scope.$on('openedDialog', function () {
            getUnreadMessages();
        });
        $scope.$on('needDialogsListUpdate', function () {
            getUnreadMessages();
        });
        function leftNavGoToPage(button) {
            var stateRoles1 = $auth.isInAnyRole([
                'ROLE_DEPUTY_HEAD_TEACHER',
                'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                'ROLE_HEAD_TEACHER'
            ]); // add COORDINATOR -> MASH-373 add ROLE_HEAD_TEACHER MASH-636
            if (button === 'Journal' && stateRoles1) {
                var schoolId;
                SchoolResource.getByCoordinator(function (result) {
                    if (result.length > 0) {
                        schoolId = result[0].id;
                        $state.go('JournalRoles1', {
                            schoolId: schoolId
                        });
                    }
                });
                return;
            }
            if (button === 'dialogs') {
                $state.go(button, {});
            } else if (button === 'messenger') {
                $state.go(button, {});
            } else if (button === 'Journal' || button === 'Statistics') {
                openJournalOrStatistics(button);
            } else if (button === 'ctp') {
                openCtp(button);
            } else if (button === 'diagnostic'){
                $state.go('diagnostic');
            }
        }
        $scope.goToDiagnostic = function () {

            $state.go('diagnostic');
        }
        $scope.goToSections = function () {

            $state.go('sections');
        }

        function openCtp(button) {
            if (
                $auth.isInRole('ROLE_TEACHER') ||
                $auth.isInRole('ROLE_DISTANCE_EDUCATION_COORDINATOR')
            ) {
                $state.go('ctp');
            }
        }

        function toogleSideBar (){

            $scope.shortSidebarIsShown = !$scope.shortSidebarIsShown
            $scope.fullSidebarIsShown = !$scope.fullSidebarIsShown

        }


        // $scope.showHelpForm = showHelpForm;
        //
        //
        // function showHelpForm() {
        //     // console.log('showHelpForm');
        //     $mdDialog.show({
        //         width: 1024,
        //         controller: ShowHelpFormController,
        //         templateUrl: lmsConfig.modulesPath + "site/views/_helpForm.html",
        //         parent: angular.element(document.body),
        //         clickOutsideToClose: false,
        //         escapeToClose: true
        //     }).then(function () {
        //         //
        //     });
        // }

        function openJournalOrStatistics(button) {
            if ($auth.isInRole('ROLE_TEACHER')) {
                if (button === 'Journal') {
                    $state.go('teacherJournal');
                } else if (button === 'Statistics') {
                    $state.go('teacherStatistics');
                }
            } else if ($auth.isInRole('ROLE_TUTOR')) {
                if (button === 'Journal') {
                    $state.go('tutorJournal');
                } else if (button === 'Statistics') {
                    $state.go('tutorStatistics');
                }
            } else if ($auth.isInRole('ROLE_STUDENT')) {
                ProgressResource.getAllForStudent(
                    {
                        studentId: $scope.user.id
                    },
                    function (result) {
                        if (result.length > 0 && button === 'Journal') {
                            $state.go('studentDiary', {
                                studentId: $scope.user.id
                            });
                        }
                    }
                );
            } else if ($auth.isInRole('ROLE_PARENT')) {
                if (button === 'Journal' && $auth.user.relatedStudentId) {
                    $state.go('studentDiary', {
                        studentId: $auth.user.relatedStudentId
                    });
                }
            } else if ($auth.isInRole('ROLE_PSYCHOLOGIST')) {
                if (button === 'Journal') {
                    SchoolResource.getByCoordinator(function (result) {
                        if (result.length > 0) {
                            $state.go('schoolJournal', {
                                schoolId: result[0].id
                            });
                        }
                    });
                } else if (button === 'Statistics') {
                    $state.go('psychologistStatistics');
                }
            } else if (
                $auth.isInAnyRole([
                    'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                    'ROLE_HEAD_TEACHER',
                    'ROLE_DEPUTY_HEAD_TEACHER',
                    'ROLE_METHODOLOGIST'
                ])
            ) {
                SchoolResource.getByCoordinator(function (result) {
                    if (result.length > 0) {
                        if (
                            $auth.isInRole('ROLE_METHODOLOGIST') &&
                            button === 'Statistics'
                        ) {
                            $state.go('methodologistStatistics', {
                                schoolId: result[0].id
                            });
                        } else {
                            $state.go('school' + button, {
                                schoolId: result[0].id
                            });
                        }
                    }
                });
            } else if ($auth.isInRole('ROLE_TERRITORY_COORDINATOR')) {
                TerritoryResource.getAllByCoordinator(function (result) {
                    if (result.length > 0) {
                        $state.go('territory' + button, {
                            territoryId: result[0].id
                        });
                    }
                });
            } else if ($auth.isInRole('ROLE_REGIONAL_COORDINATOR')) {
                RegionResource.getRegionsByCoordinator(function (result) {
                    if (result.length > 0) {
                        $state.go('region' + button, {
                            regionId: result[0].id
                        });
                    }
                });
            } else if ($auth.isInRole('ROLE_LOCATION_COORDINATOR')) {
                // Временное решение !!! костыль!
                RegionResource.getRegionsByCoordinator(
                    function (result) {
                        if (result.length > 0) {
                            $state.go('region' + button, {
                                regionId: result[0].id
                            });
                        } else {
                            TerritoryResource.getAllByCoordinator(
                                function (result) {
                                    if (result.length > 0) {
                                        $state.go('territory' + button, {
                                            territoryId: result[0].id
                                        });
                                    }
                                }
                            );
                        }
                    },
                    function (err) {
                        TerritoryResource.getAllByCoordinator(function (result) {
                            if (result.length > 0) {
                                $state.go('territory' + button, {
                                    territoryId: result[0].id
                                });
                            }
                        });
                    }
                );
            }
        }

        $scope.goToCourse = goToCourse;
        function goToCourse() {
            Course.openCourseTopicList(
                $scope.courses,
                function (cid, tid) {
                    $state.go('courseSectionOpenTaskTable', {
                        courseId: cid,
                        tid: tid
                    });
                }
            );
        }

        function chooseCourseDialog() {
            if ($auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT'])) {
                $scope.courses = null;
                $scope.childs = null;
                $scope.child = null;
                $scope.sid = null;
                if ($auth.isInRole('ROLE_STUDENT')) {
                    $scope.sid = $auth.user.id;
                    ProgressResource.getAllForStudent(
                        {
                            studentId: $auth.user.id
                        },
                        function (result) {
                            $scope.courses = result;
                            if ($scope.courses.length < 1) {
                                LmsUtils.showSimpleToast(
                                    'Нет доступных курсов'
                                );
                                $scope.cancel();
                            }
                            goToCourse();
                        }
                    );
                } else if ($auth.isInRole('ROLE_PARENT')) {
                    if ($auth.user.relatedStudentId) {
                        $scope.sid = $auth.user.relatedStudentId;
                        ProgressResource.getAllForStudent(
                            {
                                studentId: $auth.user.relatedStudentId
                            },
                            function (result) {
                                $scope.courses = result;
                                if ($scope.courses.length < 1) {
                                    LmsUtils.showSimpleToast(
                                        'Нет доступных курсов'
                                    );
                                    $scope.cancel();
                                }
                                goToCourse();
                            }
                        );
                    } else {
                        LmsUtils.showSimpleToast('Не выбран ребенок!');
                    }
                }
            }
        }
        function chooseCourseMatrix() {
            var initialYear = 2021;
            CourseGroupResource.getAllForTeacher(
                {
                    teacherId: $auth.user.id,
                    year: initialYear

                },
                function (response) {
                    var courses = {};
                    for (var cg in response) {
                        for (var c in response[cg].course) {
                            courses[response[cg].course[c].id] = response[
                                cg
                            ].course[c];
                        }
                    }
                    Course.openCourseTopicList(courses, function (cid, tid) {
                        $state.go('courseSectionOpenTaskTable', {
                            courseId: cid,
                            tid: tid
                        });
                    });
                }
            );
        }
        function canSeeDashBar() {
            var canSee = $auth.user && $auth.userIsAuthenticated();
            if (canSee) {
                spinnerHide();
            }
            return canSee;
        }

        function spinnerShow() {
            $scope.loaded = false;
            usSpinnerService.spin('spinnerNewDialog');
        }

        function spinnerHide() {
            $scope.loaded = true;
            usSpinnerService.stop('spinnerNewDialog');
        }

        $scope.$watch(
            function () {
                return $auth.user;
            },
            function (v) {
                if (v) {
                    $scope.user = v;
                }
            }
        );
    }
]);



function ShowHelpFormController($scope, $mdDialog, $auth, Role, $http, LmsUtils, API) {

    $scope.$watch(function () {
        return $auth.user.id;
    }, function (id) {
        if (id) {
            init($auth.user);
        }
    });

    function init(user) {
        $scope.formData = {
            support: 'TechnicalSupport', // MethodicalSupport
            email: '',
            phone: '',
            msg: '',
            files: []
        };

        $scope.close = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.hide();
        };

        $scope.getPhotoPath = function () {
            var photoPath = user.profilePhotoPath ? user.profilePhotoPath : 'images/avatar_placeholder.png';
            return photoPath;
        }

        $scope.name1Name2 = function () {
            return user.firstName + ' ' + user.lastName;
        };

        $scope.userRole = function () {
            var roleNames = Role.getRoles();
            var listRoleNames = [];
            user.roles.forEach(function (role) {
                var str = roleNames[role];
                if (str) {
                    listRoleNames.push(str);
                }
            });
            var roleName = listRoleNames.join(' ,');
            return roleName;
        };

        $scope.fileAdd = function (target) {
            var formDataFiles = $scope.formData.files;
            var files = target.files;
            if (!!files) {
                var file = files[0];
                if (file) {
                    formDataFiles.push(file);
                }
            }
            $scope.formData.files = formDataFiles;
            $scope.$apply();
        }

        $scope.deleteFile = function (file) {
            var files = $scope.formData.files;
            var newFiles = files.filter(function (item) {
                if (item === file) {
                    return false;
                }
                return true;
            });
            $scope.formData.files = newFiles;
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        $scope.submit = function () {
            // console.log($scope.formData);
            var scopeFormData = $scope.formData;
            // Проверяем правильность данных
            if (!(!!scopeFormData.email || !!scopeFormData.phone)) {
                LmsUtils.showSimpleToast('Email или телефон, обязательно!');
                return;
            }

            if (!validateEmail(scopeFormData.email)) {
                LmsUtils.showSimpleToast('Email не валидный!');
                return;
            }

            if (!scopeFormData.msg) {
                LmsUtils.showSimpleToast('Сообщение, обязательно!');
                return;
            }

            var formData = new FormData();
            formData.append("support", scopeFormData.support);
            formData.append("email", scopeFormData.email);
            formData.append("phone", scopeFormData.phone);
            formData.append("msg", scopeFormData.msg);

            var files = scopeFormData.files;
            // Проверяем что
            // 1) Кол-во файлов (не более 3)
            if (files.length > 3) {
                LmsUtils.showSimpleToast('Кол-во файлов не более 3 !');
                return;
            }
            // 2) Макс размер одного файла (не более 10 мб)
            var KB = 1024;
            var MB = 1024 * KB;
            var tst = files.some(function (item) {
                // console.log('item.size', item.size);
                if (item.size > 10 * MB) {
                    LmsUtils.showSimpleToast('Макс размер одного файла не более 10 мб !');
                    return true;
                }
                return false;
            });

            if (tst) {
                return;
            }
            // 3) Суммарный размер всех файлов (не более 20 мб)
            var total = 0;
            files.forEach(function (item) {
                total = total + item.size;
            });
            if (total > 20 * MB) {
                LmsUtils.showSimpleToast('Суммарный размер всех файлов не более 20 мб !');
                return;
            }
            // -----

            files.forEach(function (item) {
                formData.append("files[]", item);
            });

            var supportApi = API.supportApi + '/emails/support';

            var request = {
                method: 'POST',
                url: supportApi,
                data: formData,
                headers: {
                    'Content-Type': undefined
                }
            };

            $http(request).success(function () {
                LmsUtils.showSimpleToast('Успешно!');
                $mdDialog.hide();
            }).error(function (data, status, headers, config) {
                LmsUtils.showSimpleToast('Ошибка!');
                $mdDialog.hide();
            });
        };
    }
}

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.DashboardIndexCtrl
 * @description
 * # DashboardIndexCtrl
 * Controller of the lmsClientApp
 */
app.controller('DashboardIndexCtrl', ['$scope', '$state', 'UserResource', '$mdDialog', 'lmsConfig', 'Dialogs', 'DialogsResource', 'Account', 'Users',
    function ($scope, $state, UserResource, $mdDialog, lmsConfig, Dialogs, DialogsResource, Account, Users) {

    // Methods
    $scope.openStatDialog = openStatDialog;
    $scope.openQuestionOfTheDayDialog = openQuestionOfTheDayDialog;

    function openQuestionOfTheDayDialog() {
        console.log('aaaaaaa')
        Users.getMessage({id: 0}, (function (users) {
            Dialogs.createDialog(false, users, {dialogTheme:'Вопрос дня'}).then(function (dialog) {
                if (dialog && dialog.id) {
                    Dialogs.openDialog(dialog.id);
                }
            });
        }))
    }

    function openStatDialog() {
        UserResource.getUsersByRoles({
            'roles':  ['ROLE_STATISTICS_MANAGER'].join(' ')
        }, function (response) {
            var ownerId,
                dialog = {
                    name: 'Запрос на статистику',
                    owner: {
                        id: ownerId
                    },
                    participants: [],
                    distrib: false,
                    message: 'Укажите параметры, по которым нужно собрать статистическую информацию. Ваш запрос будет обработан. Ответ будет сформирован и выслан вам в течение 7 дней.'
                };
            for (var i in response) {
                dialog.participants.push(response[i]);
            }
            Account.getAccount().then(function(response) {
                ownerId = response.id;
                Dialogs.openDialog(null, dialog);
            });
        });
    }
}]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.DashboardBarCtrl
 * @description
 * # DashboardBarCtrl
 * Controller of the lmsClientApp
 */
app
.controller('DashboardBarCtrl', ['$scope', '$auth', '$state', 'User', '$mdDialog',
    'lmsConfig', '$q', '$breadcrumb',
    function ($scope, $auth, $state, User, $mdDialog, lmsConfig, $q, $breadcrumb) {

        $scope.curPath = $breadcrumb.getLastStep();
}]);

'use strict';

// https://asi-futurestaff.mob-edu.ru/asi/portfolio/14319
app.factory('AsiPortfolio', function ($resource) {
    return $resource('/asi/portfolio/', {}, {
        get: {
            method: 'GET',
            url: '/asi/portfolio/:userId',
            isObject: true
        }
    });
});

app.controller('DigitalProfileCtrl', ['$scope', '$auth', 'AsiPortfolio', '$sce', 'Role',
    function ($scope, $auth, AsiPortfolio, $sce, Role) {
        $scope.data = null;
        $scope.incomingIframe = null;
        $scope.outgoingIframe = null;
        // ----------
        $scope.getUserRole = getUserRole;
        $scope.getPhotoPath = getPhotoPath;
        $scope.getUserName = getUserName;
        $scope.getRoleNames = getRoleNames;
        $scope.getInternshipName = getInternshipName;
        $scope.resultPrint = resultPrint;
        // ----------
        var roleNames = Role.getRoles();
        // console.log({ roleNames });
        // ----------
        var unbindAuthWatcher = $scope.$watch(function () {
            return $auth.user.id;
        }, function (id) {
            if (id) {
                unbindAuthWatcher();
                init(id);
            }
        });
        // ----------
        $scope.trustSrc = function (src) {
            return $sce.trustAsResourceUrl(src);
        };
        // ----------
        function init(userId) {
            // console.log({ userId });
            getData(userId).then(function (data) {
                data.internships.forEach(function (internship) {
                    try {
                        var date = internship.date;
                        var arr = date.split(' ');
                        internship.date = arr[0];
                    } catch (error) {
                        //
                    }
                });
                $scope.data = data;
                // iframe1
                if (data.skillfolio.incoming.passed) {
                    $scope.incomingIframe = data.skillfolio.incoming.URI;
                }
                // iframe2
                if (data.skillfolio.outgoing.passed) {
                    $scope.outgoingIframe = data.skillfolio.outgoing.URI;
                }
            });
        }

        function getUserRole(user) {
            var roleName = roleNames[user.role];
            return roleName;
        }

        function getRoleNames(user) {
            var listRoleNames = [];
            user.roles.forEach(function (role) {
                listRoleNames.push(roleNames[role]);
            });
            var roleName = listRoleNames.join(' ,');
            return roleName;
        }

        function getPhotoPath(user) {
            var photoPath = user.avatar ? user.avatar : 'images/avatar_placeholder.png';
            return photoPath;
        }

        function getUserName(user) {
            var userName = '';
            if (!!user.first_name) {
                userName = userName + ' ' + user.first_name;
            }
            if (!!user.last_name) {
                userName = userName + ' ' + user.last_name;
            }
            if (!!user.middle_name) {
                userName = userName + ' ' + user.middle_name;
            }
            return userName;
        }

        function getInternshipName(internship) {
            var internshipName = '';
            if (!!internship.name) {
                internshipName = internship.name;
            } else {
                var list = internship.path.split('/');
                if (list.length > 0) {
                    internshipName = list[list.length - 1];
                }
            }
            return internshipName;
        }

        function getData(userId) {
            return AsiPortfolio.get({
                userId: userId
            }, function (response) {
                return response;
            }).$promise;
        }

        function resultPrint() {
            window.print();
        }
    }
]);

'use strict';

/**
 * @ngdoc function
 * @name lmsClientApp.controller:ProfileControllerCtrl
 * @description
 * # ProfileControllerCtrl
 * Controller of the lmsClientApp
 */
app
    .controller('ProfileCtrl', ['$scope', 'User', '$auth', 'Role', 'UserSettingsResource', 'Upload', 'lmsConfig',
    'UserGroupResource', 'TerritoryResource', 'SchoolResource', '$q', '$rootScope', 'LmsUtils', 'usSpinnerService',
    '$timeout',
        function ($scope, User, $auth, Role, UserSettingsResource, Upload, lmsConfig,
          UserGroupResource, TerritoryResource, SchoolResource, $q, $rootScope, LmsUtils, usSpinnerService,
          $timeout) {

            // Variables
            $scope.user = null;
            $scope.userGroups = [];
            $scope.userSchools = [];
            $scope.territories = [];
            $scope.userEdit = {};
            $scope.editMode = false;

            // Methods
            $scope.toggleEditMode = toggleEditMode;
            $scope.initUserEdit = initUserEdit;
            $scope.saveProfile = saveProfile;
            $scope.cancelEdit = cancelEdit;
            $scope.changeUserpic = changeUserpic;
            // $scope.getUserGroups = getUserGroups;
            // $scope.getUserSchools = getUserSchools;
            $scope.copyRegAddress = copyRegAddress;
            $scope.validateBirthDate = validateBirthDate;


            $scope.spinnerCurtain = true;
            $timeout(function() {
               usSpinnerService.spin('spinnerProfile');
            });

            $scope.$watch(function () {
              return $auth.user.id;
            }, function (id) {
              if (id) {
                init();
              }
            });

            function init() {
              getUserSettings($auth.user.id).then(function() {
                $scope.spinnerCurtain = false;
                usSpinnerService.stop('spinnerProfile');
              });
              if ($auth.isInRole('ROLE_STUDENT')) {
                getUserGroups();
                getUserSchools();
              }
              $scope.$watch('editMode', function (v) {
                if (v) {
                  $scope.initUserEdit();
                }
              });
            }

            function getUserSettings(id) {
                return UserSettingsResource.get({'id': id}, function (response) {
                    $scope.user = response;

                    if ($auth.user.roleViews && $auth.user.roleViews[$auth.user.userRoles[0]]) {
                        $scope.user.roleName = $auth.user.roleViews[$auth.user.userRoles[0]];
                    } else {
                        $scope.user.roleName = Role.getRoleTranslate($auth.user.userRoles[0]);
                    }
                    $scope.user.birthDate = formatDate(response.birthDate);
                    randomUserpicId();
                }).$promise;
            }

            function validateBirthDate(date) {
                return moment(date).isBetween(moment().subtract(100, 'years'),  moment().subtract(5, 'years'));
            }


            function toggleEditMode() {
                $scope.editMode = !$scope.editMode;
            }

            function initUserEdit() {
                angular.copy($scope.user, $scope.userEdit);
                getAllTerritories();
            }

            function saveProfile() {
                if ($scope.userEdit.id) {
                    $scope.userEdit.birthDate = formatDate($scope.userEdit.birthDate);
                }
                UserSettingsResource.update({}, $scope.userEdit, function (response) {
                    $scope.editMode = false;
                    getUserSettings($auth.user.id);
                });
            }

            function formatDate(date) {
                return new Date(date);
            }

            function cancelEdit() {
                $scope.editMode = false;
                $scope.userEdit = {};
            }

            function changeUserpic(file) {
                if (file) {
                    Upload.upload({
                        // url: lmsConfig.apiUrl + '/account/profile_photo',
                        url: '/admin/user/settings/profile_photo',
                        // fields: {'username': $scope.username},
                        file: file
                    }).progress(function (evt) {
                        // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (data, status, headers, config) {
                        getUserSettings($auth.user.id);
                    }).error(function (data, status, headers, config) {
                        if (headers('failure') === 'Uploaded file is heavier then 500KB.') {
                            LmsUtils.showSimpleToast('Загруженный файл весит больше 500KB.');
                        } else if (headers('failure') === 'Uploaded file is larger then 500x500.') {
                            LmsUtils.showSimpleToast('Загруженный файл по ширине или высоте больше допустимого размера 500x500.');
                        } else if (headers('failure') === 'Uploaded file is not a supported picture.') {
                            LmsUtils.showSimpleToast('Загруженный файл не является поддерживаемым изображением.');
                        } else if (headers('failure') === "Uploaded file's content type is not allowed.") {
                            LmsUtils.showSimpleToast('Тип содержимого загруженного файла не разрешён.');
                        }
                    });
                }
            }

            function randomUserpicId() {
                if ($scope.user.user.profilePhotoPath) {
                    $scope.user.user.profilePhotoPath += "?random=" + new Date().getTime();
                    $rootScope.$broadcast("userpicChanged", {'url': $scope.user.user.profilePhotoPath});
                }
            }

            function getUserGroups() {
                UserGroupResource.getCurrent(function (response) {
                    $scope.userGroups = response;
                });
            }

            function getUserSchools() {
                SchoolResource.getCurrentUserSchools(function (response) {
                    $scope.userSchools = response;
                });
            }

            function getAllTerritories() {
                TerritoryResource.query({
                    type: 'TERRITORY'
                }, function (response) {
                    var registrationAddress, currentAddress, registrationAddressKey, currentAddressKey;
                    $scope.territories = response;
                    if (!$scope.user.registrationAddress) {
                      $scope.user.registrationAddress = {};
                    }
                    if (!$scope.user.currentAddress) {
                      $scope.user.currentAddress = {};
                    }
                    if (!$scope.userEdit.registrationAddress) {
                      $scope.userEdit.registrationAddress = {};
                    }
                    if (!$scope.userEdit.currentAddress) {
                      $scope.userEdit.currentAddress = {};
                    }

                    registrationAddress = $scope.user.registrationAddress;
                    currentAddress = $scope.user.currentAddress;
                    registrationAddressKey = registrationAddress.location ? _.findKey($scope.territories, {id: registrationAddress.location.id}) : 0;
                    currentAddressKey = currentAddress.location ? _.findKey($scope.territories, {id: currentAddress.location.id}) : 0;
                    $scope.userEdit.registrationAddress.location = $scope.territories[registrationAddressKey];
                    $scope.userEdit.currentAddress.location = $scope.territories[currentAddressKey];
                });
            }

            function copyRegAddress() {
                if ($scope.editMode &&
                    $scope.userEdit &&
                    $scope.userEdit.registrationAddress &&
                    ($scope.userEdit.registrationAddress.settlementName ||
                    $scope.userEdit.registrationAddress.territory.name)) {
                    var curId;
                    if ($scope.userEdit.currentAddress === null) {
                        $scope.userEdit.currentAddress = {};
                        curId = null;
                    } else {
                        curId = $scope.userEdit.currentAddress.id;
                    }
                    angular.copy($scope.userEdit.registrationAddress, $scope.userEdit.currentAddress);
                    $scope.userEdit.currentAddress.location = $scope.userEdit.registrationAddress.location;
                    // $scope.userEdit.currentAddress.id = curId;
                    // for (var i = 0; i < $scope.territories.length; i++) {
                    //     if ($scope.userEdit.registrationAddress !== null &&
                    //         $scope.userEdit.registrationAddress.territory !== null &&
                    //         $scope.userEdit.registrationAddress.territory.id == $scope.territories[i].id) {
                    //         $scope.userEdit.currentAddress.territory = $scope.territories[i];
                    //     }
                    // }
                }
            }
        }]);

'use strict';

// MyProfileCtrl
app.controller('MyProfileCtrl', [
    '$scope', 'User', '$auth', 'Role', 'UserSettingsResource', 'Upload', 'lmsConfig',
    'UserGroupResource', 'TerritoryResource', 'SchoolResource', '$q',
    '$rootScope', 'LmsUtils', 'usSpinnerService',
    '$timeout', function ($scope, User, $auth, Role, UserSettingsResource, Upload, lmsConfig,
        UserGroupResource, TerritoryResource, SchoolResource, $q,
        $rootScope, LmsUtils, usSpinnerService,
        $timeout,$compileProvider) {
        // Variables
        $scope.userSettings = null;
        // ----
        $scope.userData = null;
        $scope.formData = null;
        $scope.fileForPreviewKey = false;
        $scope.fileForPreviewSrc = '';
        $scope.maxDate = null;
        $scope.currentDate = null;
        $scope.phoneExist = false;
        $scope.phoneCode = '+7'
        $scope.showListBox = showListBox;
        $scope.chooseCountry = chooseCountry;
        $scope.allCountries = [ [ "Afghanistan (‫افغانستان‬‎)", "af", "93" ], [ "Albania (Shqipëri)", "al", "355" ], [ "Algeria (‫الجزائر‬‎)", "dz", "213" ], [ "American Samoa", "as", "1684" ], [ "Andorra", "ad", "376" ], [ "Angola", "ao", "244" ], [ "Anguilla", "ai", "1264" ], [ "Antigua and Barbuda", "ag", "1268" ], [ "Argentina", "ar", "54" ], [ "Armenia (Հայաստան)", "am", "374" ], [ "Aruba", "aw", "297" ], [ "Australia", "au", "61", 0 ], [ "Austria (Österreich)", "at", "43" ], [ "Azerbaijan (Azərbaycan)", "az", "994" ], [ "Bahamas", "bs", "1242" ], [ "Bahrain (‫البحرين‬‎)", "bh", "973" ], [ "Bangladesh (বাংলাদেশ)", "bd", "880" ], [ "Barbados", "bb", "1246" ], [ "Belarus (Беларусь)", "by", "375" ], [ "Belgium (België)", "be", "32" ], [ "Belize", "bz", "501" ], [ "Benin (Bénin)", "bj", "229" ], [ "Bermuda", "bm", "1441" ], [ "Bhutan (འབྲུག)", "bt", "975" ], [ "Bolivia", "bo", "591" ], [ "Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387" ], [ "Botswana", "bw", "267" ], [ "Brazil (Brasil)", "br", "55" ], [ "British Indian Ocean Territory", "io", "246" ], [ "British Virgin Islands", "vg", "1284" ], [ "Brunei", "bn", "673" ], [ "Bulgaria (България)", "bg", "359" ], [ "Burkina Faso", "bf", "226" ], [ "Burundi (Uburundi)", "bi", "257" ], [ "Cambodia (កម្ពុជា)", "kh", "855" ], [ "Cameroon (Cameroun)", "cm", "237" ], [ "Canada", "ca", "1", 1, [ "204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905" ] ], [ "Cape Verde (Kabu Verdi)", "cv", "238" ], [ "Caribbean Netherlands", "bq", "599", 1 ], [ "Cayman Islands", "ky", "1345" ], [ "Central African Republic (République centrafricaine)", "cf", "236" ], [ "Chad (Tchad)", "td", "235" ], [ "Chile", "cl", "56" ], [ "China (中国)", "cn", "86" ], [ "Christmas Island", "cx", "61", 2 ], [ "Cocos (Keeling) Islands", "cc", "61", 1 ], [ "Colombia", "co", "57" ], [ "Comoros (‫جزر القمر‬‎)", "km", "269" ], [ "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243" ], [ "Congo (Republic) (Congo-Brazzaville)", "cg", "242" ], [ "Cook Islands", "ck", "682" ], [ "Costa Rica", "cr", "506" ], [ "Côte d’Ivoire", "ci", "225" ], [ "Croatia (Hrvatska)", "hr", "385" ], [ "Cuba", "cu", "53" ], [ "Curaçao", "cw", "599", 0 ], [ "Cyprus (Κύπρος)", "cy", "357" ], [ "Czech Republic (Česká republika)", "cz", "420" ], [ "Denmark (Danmark)", "dk", "45" ], [ "Djibouti", "dj", "253" ], [ "Dominica", "dm", "1767" ], [ "Dominican Republic (República Dominicana)", "do", "1", 2, [ "809", "829", "849" ] ], [ "Ecuador", "ec", "593" ], [ "Egypt (‫مصر‬‎)", "eg", "20" ], [ "El Salvador", "sv", "503" ], [ "Equatorial Guinea (Guinea Ecuatorial)", "gq", "240" ], [ "Eritrea", "er", "291" ], [ "Estonia (Eesti)", "ee", "372" ], [ "Ethiopia", "et", "251" ], [ "Falkland Islands (Islas Malvinas)", "fk", "500" ], [ "Faroe Islands (Føroyar)", "fo", "298" ], [ "Fiji", "fj", "679" ], [ "Finland (Suomi)", "fi", "358", 0 ], [ "France", "fr", "33" ], [ "French Guiana (Guyane française)", "gf", "594" ], [ "French Polynesia (Polynésie française)", "pf", "689" ], [ "Gabon", "ga", "241" ], [ "Gambia", "gm", "220" ], [ "Georgia (საქართველო)", "ge", "995" ], [ "Germany (Deutschland)", "de", "49" ], [ "Ghana (Gaana)", "gh", "233" ], [ "Gibraltar", "gi", "350" ], [ "Greece (Ελλάδα)", "gr", "30" ], [ "Greenland (Kalaallit Nunaat)", "gl", "299" ], [ "Grenada", "gd", "1473" ], [ "Guadeloupe", "gp", "590", 0 ], [ "Guam", "gu", "1671" ], [ "Guatemala", "gt", "502" ], [ "Guernsey", "gg", "44", 1 ], [ "Guinea (Guinée)", "gn", "224" ], [ "Guinea-Bissau (Guiné Bissau)", "gw", "245" ], [ "Guyana", "gy", "592" ], [ "Haiti", "ht", "509" ], [ "Honduras", "hn", "504" ], [ "Hong Kong (香港)", "hk", "852" ], [ "Hungary (Magyarország)", "hu", "36" ], [ "Iceland (Ísland)", "is", "354" ], [ "India (भारत)", "in", "91" ], [ "Indonesia", "id", "62" ], [ "Iran (‫ایران‬‎)", "ir", "98" ], [ "Iraq (‫العراق‬‎)", "iq", "964" ], [ "Ireland", "ie", "353" ], [ "Isle of Man", "im", "44", 2 ], [ "Israel (‫ישראל‬‎)", "il", "972" ], [ "Italy (Italia)", "it", "39", 0 ], [ "Jamaica", "jm", "1876" ], [ "Japan (日本)", "jp", "81" ], [ "Jersey", "je", "44", 3 ], [ "Jordan (‫الأردن‬‎)", "jo", "962" ], [ "Kazakhstan (Казахстан)", "kz", "7", 1 ], [ "Kenya", "ke", "254" ], [ "Kiribati", "ki", "686" ], [ "Kosovo", "xk", "383" ], [ "Kuwait (‫الكويت‬‎)", "kw", "965" ], [ "Kyrgyzstan (Кыргызстан)", "kg", "996" ], [ "Laos (ລາວ)", "la", "856" ], [ "Latvia (Latvija)", "lv", "371" ], [ "Lebanon (‫لبنان‬‎)", "lb", "961" ], [ "Lesotho", "ls", "266" ], [ "Liberia", "lr", "231" ], [ "Libya (‫ليبيا‬‎)", "ly", "218" ], [ "Liechtenstein", "li", "423" ], [ "Lithuania (Lietuva)", "lt", "370" ], [ "Luxembourg", "lu", "352" ], [ "Macau (澳門)", "mo", "853" ], [ "Macedonia (FYROM) (Македонија)", "mk", "389" ], [ "Madagascar (Madagasikara)", "mg", "261" ], [ "Malawi", "mw", "265" ], [ "Malaysia", "my", "60" ], [ "Maldives", "mv", "960" ], [ "Mali", "ml", "223" ], [ "Malta", "mt", "356" ], [ "Marshall Islands", "mh", "692" ], [ "Martinique", "mq", "596" ], [ "Mauritania (‫موريتانيا‬‎)", "mr", "222" ], [ "Mauritius (Moris)", "mu", "230" ], [ "Mayotte", "yt", "262", 1 ], [ "Mexico (México)", "mx", "52" ], [ "Micronesia", "fm", "691" ], [ "Moldova (Republica Moldova)", "md", "373" ], [ "Monaco", "mc", "377" ], [ "Mongolia (Монгол)", "mn", "976" ], [ "Montenegro (Crna Gora)", "me", "382" ], [ "Montserrat", "ms", "1664" ], [ "Morocco (‫المغرب‬‎)", "ma", "212", 0 ], [ "Mozambique (Moçambique)", "mz", "258" ], [ "Myanmar (Burma) (မြန်မာ)", "mm", "95" ], [ "Namibia (Namibië)", "na", "264" ], [ "Nauru", "nr", "674" ], [ "Nepal (नेपाल)", "np", "977" ], [ "Netherlands (Nederland)", "nl", "31" ], [ "New Caledonia (Nouvelle-Calédonie)", "nc", "687" ], [ "New Zealand", "nz", "64" ], [ "Nicaragua", "ni", "505" ], [ "Niger (Nijar)", "ne", "227" ], [ "Nigeria", "ng", "234" ], [ "Niue", "nu", "683" ], [ "Norfolk Island", "nf", "672" ], [ "North Korea (조선 민주주의 인민 공화국)", "kp", "850" ], [ "Northern Mariana Islands", "mp", "1670" ], [ "Norway (Norge)", "no", "47", 0 ], [ "Oman (‫عُمان‬‎)", "om", "968" ], [ "Pakistan (‫پاکستان‬‎)", "pk", "92" ], [ "Palau", "pw", "680" ], [ "Palestine (‫فلسطين‬‎)", "ps", "970" ], [ "Panama (Panamá)", "pa", "507" ], [ "Papua New Guinea", "pg", "675" ], [ "Paraguay", "py", "595" ], [ "Peru (Perú)", "pe", "51" ], [ "Philippines", "ph", "63" ], [ "Poland (Polska)", "pl", "48" ], [ "Portugal", "pt", "351" ], [ "Puerto Rico", "pr", "1", 3, [ "787", "939" ] ], [ "Qatar (‫قطر‬‎)", "qa", "974" ], [ "Réunion (La Réunion)", "re", "262", 0 ], [ "Romania (România)", "ro", "40" ], [ "Russia (Россия)", "ru", "7", 0 ], [ "Rwanda", "rw", "250" ], [ "Saint Barthélemy", "bl", "590", 1 ], [ "Saint Helena", "sh", "290" ], [ "Saint Kitts and Nevis", "kn", "1869" ], [ "Saint Lucia", "lc", "1758" ], [ "Saint Martin (Saint-Martin (partie française))", "mf", "590", 2 ], [ "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508" ], [ "Saint Vincent and the Grenadines", "vc", "1784" ], [ "Samoa", "ws", "685" ], [ "San Marino", "sm", "378" ], [ "São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239" ], [ "Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966" ], [ "Senegal (Sénégal)", "sn", "221" ], [ "Serbia (Србија)", "rs", "381" ], [ "Seychelles", "sc", "248" ], [ "Sierra Leone", "sl", "232" ], [ "Singapore", "sg", "65" ], [ "Sint Maarten", "sx", "1721" ], [ "Slovakia (Slovensko)", "sk", "421" ], [ "Slovenia (Slovenija)", "si", "386" ], [ "Solomon Islands", "sb", "677" ], [ "Somalia (Soomaaliya)", "so", "252" ], [ "South Africa", "za", "27" ], [ "South Korea (대한민국)", "kr", "82" ], [ "South Sudan (‫جنوب السودان‬‎)", "ss", "211" ], [ "Spain (España)", "es", "34" ], [ "Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94" ], [ "Sudan (‫السودان‬‎)", "sd", "249" ], [ "Suriname", "sr", "597" ], [ "Svalbard and Jan Mayen", "sj", "47", 1 ], [ "Swaziland", "sz", "268" ], [ "Sweden (Sverige)", "se", "46" ], [ "Switzerland (Schweiz)", "ch", "41" ], [ "Syria (‫سوريا‬‎)", "sy", "963" ], [ "Taiwan (台灣)", "tw", "886" ], [ "Tajikistan", "tj", "992" ], [ "Tanzania", "tz", "255" ], [ "Thailand (ไทย)", "th", "66" ], [ "Timor-Leste", "tl", "670" ], [ "Togo", "tg", "228" ], [ "Tokelau", "tk", "690" ], [ "Tonga", "to", "676" ], [ "Trinidad and Tobago", "tt", "1868" ], [ "Tunisia (‫تونس‬‎)", "tn", "216" ], [ "Turkey (Türkiye)", "tr", "90" ], [ "Turkmenistan", "tm", "993" ], [ "Turks and Caicos Islands", "tc", "1649" ], [ "Tuvalu", "tv", "688" ], [ "U.S. Virgin Islands", "vi", "1340" ], [ "Uganda", "ug", "256" ], [ "Ukraine (Україна)", "ua", "380" ], [ "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971" ], [ "United Kingdom", "gb", "44", 0 ], [ "United States", "us", "1", 0 ], [ "Uruguay", "uy", "598" ], [ "Uzbekistan (Oʻzbekiston)", "uz", "998" ], [ "Vanuatu", "vu", "678" ], [ "Vatican City (Città del Vaticano)", "va", "39", 1 ], [ "Venezuela", "ve", "58" ], [ "Vietnam (Việt Nam)", "vn", "84" ], [ "Wallis and Futuna (Wallis-et-Futuna)", "wf", "681" ], [ "Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1 ], [ "Yemen (‫اليمن‬‎)", "ye", "967" ], [ "Zambia", "zm", "260" ], [ "Zimbabwe", "zw", "263" ], [ "Åland Islands", "ax", "358", 1 ] ];
        $scope.countryShowButton = document.getElementById('country-show-button');
        $scope.newImageIsOk = true

        // Methods
        $scope.fileAdd = fileAdd;
        $scope.getPhotoPath = getPhotoPath;
        $scope.fileRemove = fileRemove;
        $scope.fileUpload = fileUpload;
        $scope.testSpiner = testSpiner;
        // ----
        $scope.cancel = cancel;
        $scope.submit = submit;
        // ----

        var fileForPreview = null;

        init();

        function init() {
            spinnerStart();
            // $mdDateLocaleProvider.formatDate = formatDate;
            // function formatDate (){
            //
            // }



            var today = new Date()

            var maxDate = new Date(
                today.getFullYear()-5,
                today.getMonth(),
                today.getDate()
            )

            $scope.maxDate = maxDate;
            var unWatch = $scope.$watch(function () {
                return $auth.user.id;
            }, function (id) {
                if (id) {
                    unWatch();
                    spinnerStop();
                    getUserData();
                }
            });
        }

        function testSpiner (){
            $scope.spinnerCurtain = true;
            $timeout(function () {
                usSpinnerService.spin('spinnerProfile');
            });
            usSpinnerService.stop('spinnerProfile');
            $scope.spinnerCurtain = false;

        }

        function chooseCountry () {
            console.log('aaaa')
        }

        function showListBox () {
            var countryListBox = document.getElementById('country-list-box');
            if (countryListBox.style.display == 'block') {
                countryListBox.style.display = 'none'; // Скрыть список
            } else {
                countryListBox.style.display = 'block'; // Показать список
                countryListBox.innerHTML = '';
                // Две страны наверх списка
                var countryListContent = '<li class="country-row" phone-code="+7" data-code="ru"><span class="iti-flag ru"></span><span class="country-name">Россия</span><span class="phone-prefix">+7</span></li>';
                countryListContent += '<li class="country-row"  phone-code="+380" data-code="ua"><span class="iti-flag ua"></span><span class="country-name">Украина</span><span class="phone-prefix">+380</span></li>';
                countryListContent += '<li class="country-row"  phone-code="+375" data-code="by"><span class="iti-flag by"></span><span class="country-name">Беларусь</span><span class="phone-prefix">+375</span></li>';
                countryListContent += '<li class="country-row"  phone-code="+7" data-code="kz"><span class="iti-flag kz"></span><span class="country-name">Казахстан</span><span class="phone-prefix">+7</span></li>';
                countryListContent += '<hr>';
                // Формируем строки и заполняем из массива стран
                for (index = 0; index < $scope.allCountries.length; ++index) {
                    countryListContent += '<li class="country-row" ng-click="chooseCountry()" phone-code="' + $scope.allCountries[index][2] + '" data-code="' + $scope.allCountries[index][1] + '"><span class="iti-flag ' + $scope.allCountries[index][1] + '"></span><span class="country-name">' + $scope.allCountries[index][0] + '</span><span class="phone-prefix">+'+$scope.allCountries[index][2]+'</span></li>';
                }
                countryListBox.innerHTML = '<ul>' + countryListContent + '</ul>';

                // Действие при выборе страны из списка
                var countryRows = document.querySelectorAll('.country-row'), index, row, code,phoneCode;
                for (index = 0; index < countryRows.length; index++) {
                    row = countryRows[index];
                    row.addEventListener('click', function (event) {
                        //console.log(this);
                        code = this.getAttribute('data-code');
                        phoneCode = this.getAttribute('phone-code')
                        $scope.countryShowButton.className = 'iti-flag ' + code;
                        var phoneLength =  $scope.phoneCode.length;
                        // console.log(phoneLength)
                        var newPhone = $scope.formData.mobilePhone.slice(phoneLength,$scope.formData.mobilePhone.length)
                        // console.log($scope.formData.mobilePhone)
                        $scope.formData.mobilePhone = newPhone
                        // console.log($scope.formData.mobilePhone)

                        $scope.phoneCode = phoneCode;
                        // console.log($scope.phoneCode)
                        $scope.formData.mobilePhone = phoneCode + $scope.formData.mobilePhone
                        // console.log($scope.formData.mobilePhone)
                        document.getElementById('phone-input').value =  $scope.formData.mobilePhone
                        countryListBox.style.display = 'none';
                    });
                }
            }
        }

        function spinnerStart() {
            $scope.spinnerCurtain = true;
            $timeout(function () {
                usSpinnerService.spin('spinnerProfile');
            });

        }

        function spinnerStop() {
            $scope.spinnerCurtain = false;
            usSpinnerService.stop('spinnerProfile');
        }

        function getCurrentRole(currentRole) {
            var roleNames = Role.getRoles();
            var role = roleNames[currentRole];
            return role;
        }

        function randomStr() {
            var mtime = new Date().getTime();
            var str = '' + mtime;
            return str;
        }

        function getUserData() {
            spinnerStart();
            getUserSettings($auth.user.id).then(function (userSettings) {
                spinnerStop();
                // console.log(userSettings);
                $scope.userSettings = userSettings;


                // console.log($scope.phoneExist)

                var firstName = userSettings.user.firstName || '';
                var lastName = userSettings.user.lastName || '';
                var middleName = userSettings.user.middleName || '';

                var photoPath = userSettings.user.profilePhotoPath || 'images/avatar_placeholder.png';
                photoPath = photoPath + '?random=' + randomStr();

                var role = getCurrentRole(userSettings.currentRole);

                $scope.userData = {
                    photoPath: photoPath,
                    fullName: lastName + ' ' + firstName + ' ' + middleName,
                    role: role
                };

                // var birthDate = new Date();
                var birthDate = null;
                if (userSettings.birthDate) {
                    birthDate = new Date(userSettings.birthDate);
                }

                var phonetemp;
                if(userSettings.mobilePhone !== "None"){
                    phonetemp = userSettings.mobilePhone
                } else {
                    phonetemp = ''
                }

                $scope.formData = {
                    // ---
                    firstName: firstName,
                    lastName: lastName,
                    middleName: middleName,
                    email: userSettings.user.email || '',
                    // ---
                    birthDate: birthDate,
                    mobilePhone: phonetemp,
                    aboutMe: userSettings.user.about || '',
                    formatedBirthDate: formatedDate(birthDate)
                };

                if(userSettings.mobilePhone !== null){
                    $scope.phoneExist = true
                }
                if ($scope.phoneExist == false){
                    $scope.formData.mobilePhone = "+7"
                    // console.log($scope.formData.mobilePhone)
                    document.getElementById('phone-input').value =  $scope.formData.mobilePhone
                }

            });
        }

        function getUserSettings(id) {
            return UserSettingsResource.get({ 'id': id }, function (response) {
                var profile = response;
                return profile;
            }).$promise;
        }

        function fileAdd(target) {
            var files = target.files;
            if (!!files) {
                var file = files[0];
                if (file) {
                    $scope.fileForPreviewKey = true;

                    fileForPreview = file;
                    $scope.$apply();
                    // --
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        var src = event.target.result;
                        $scope.fileForPreviewSrc = src;
                        $scope.$apply();
                    };
                    reader.readAsDataURL(fileForPreview);
                }
            }
        }

        function getPhotoPath() {
            // var image = document.createElement('img');
            // image.addEventListener('load', function() {
            //    console.log(image.width)
            //     console.log(image.height)
            //     if (image.width>500){
            //         $scope.newImageIsOk = false
            //     } else if (image.height>500) {
            //         $scope.newImageIsOk = false
            //     } else {
            //         console.log('Размер Ок')
            //     }
            // });
            // image.src = $scope.fileForPreviewSrc
            if (!!$scope.fileForPreviewSrc) {
                return $scope.fileForPreviewSrc;
            } else {
                if ($scope.userData) {
                    return $scope.userData.photoPath;
                } {
                    return '';
                }
            }

        };

        function fileRemove() {
            $scope.fileForPreviewKey = false;
            $scope.fileForPreviewSrc = '';
            fileForPreview = null;
            var input = document.getElementById("file");
            input.value = null;
        }

        function fileUpload(file, next) {
            spinnerStart();
            Upload.upload({
                // url: lmsConfig.apiUrl + '/account/profile_photo',
                url: '/admin/user/settings/profile_photo',
                file: file
            }).progress(function (evt) {

                // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            }).success(function (data, status, headers, config) {

                spinnerStop();
                next();
            }).error(function (data, status, headers, config) {
                spinnerStop();
                console.log(headers('failure'))
                if (headers('failure') === 'Uploaded file is heavier then 500KB.') {
                    LmsUtils.showSimpleToast('Загруженный файл весит больше 500KB.');
                } else if (headers('failure') === 'Uploaded file is larger then 500x500.') {
                    LmsUtils.showSimpleToast('Загруженный файл по ширине или высоте больше допустимого размера 500x500.');
                } else if (headers('failure') === 'Uploaded file is not a supported picture.') {
                    LmsUtils.showSimpleToast('Загруженный файл не является поддерживаемым изображением. \n Поддерживаемые форматы: jpeg, png');
                } else if (headers('failure') === "Uploaded file's content type is not allowed.") {
                    LmsUtils.showSimpleToast('Тип содержимого загруженного файла не разрешён.');
                }
                // next();
            });
        }

        function updateUserSettings(userSettings) {
            return UserSettingsResource.update({}, userSettings, function (response) {
                // ---
            }).$promise;
        }

        function cancel() {
            fileRemove();
            getUserData();
        }

        function submit() {

            if (fileForPreview) {
                fileUpload(fileForPreview, function () {
                    fileRemove();
                    submitFormData();
                });
            } else {
                submitFormData();
            }
        }

        function submitFormData() {
            var formData = $scope.formData;
            var userSettings = $scope.userSettings;
            // console.log({
            //     formData,
            //     userSettings
            // });
            userSettings.user.firstName = formData.firstName;
            userSettings.user.lastName = formData.lastName;
            userSettings.user.middleName = formData.middleName;
            userSettings.user.email = formData.email;
            // console.log({
            //     formData,
            //     userSettings
            // });
            // ---
            var birthDate = new Date(formData.birthDate);
            userSettings.birthDate = birthDate;
            // ---
            userSettings.mobilePhone = formData.mobilePhone;
            userSettings.user.about = formData.aboutMe;
            // ---
            spinnerStart();
            if ($scope.newImageIsOk) {
                updateUserSettings(userSettings).then(function () {
                    spinnerStop();
                    LmsUtils.showSimpleToast('Успешно!');
                    getUserData();
                    localStorage.removeItem("Meteor.loginToken:/:/rc-server");
                    localStorage.removeItem("Meteor.userId:/:/rc-server");
                    document.location.reload();
                }).catch(function () {
                    spinnerStop();
                    LmsUtils.showSimpleToast('Не удачно!');
                });
            } else {
                LmsUtils.showSimpleToast('Размер загруженного изображения больше 500*500 пикселей');
            }

        }

        function formatedDate(date) {
            var dateString = '';
            var birthDate = new Date(date);
            if (!birthDate) return 'Дата рождения'

            dateString += birthDate.getDate() < 10 ? '0' + birthDate.getDate(): birthDate.getDate();
            dateString += '.';
            dateString += birthDate.getMonth() < 8 ? '0' + (birthDate.getMonth() + 1): (birthDate.getMonth() + 1);
            dateString += '.';
            dateString += birthDate.getFullYear() + ' г.'
            return dateString;
        }
    }
]);

// app.config(function ($mdDateLocaleProvider) {
//     $mdDateLocaleProvider.formatDate = formatDate;
//     // console.log(new Date(date).getMonth()+1)
//     // var ss = new Date(date).getMonth()+1
//
//     function formatDate(date) {
//         var ss = new Date(date).getMonth()+1
//         return date ? new Date(date).getFullYear()+'.'+ ss + "."+new Date(date).getDate() : '';
//     }
// });

'use strict';

angular.module("lmsClientApp").directive('dashboardSidenav', ['lmsConfig', '$state', 'Dialogs', 'Reports', 'UserResource', '$window', '$mdDialog', '$mdMedia', 'DialogsResource', 'Account', 'Users',
    function (lmsConfig, $state, Dialogs, Reports, UserResource, $window, $mdDialog, $mdMedia, DialogsResource, Account, Users) {
    return {
        restrict: 'AE',
        replace: true,
        templateUrl: lmsConfig.modulesPath + 'dashboard/views/_sidenavLeft.html',
        link: function (scope, element, attrs) {

            scope.openStatDialog = function () {
                UserResource.getByRoles({
                    'roles': ['ROLE_STATISTICS_MANAGER'].join(' ')
                }, function (response) {
                    var ownerId,
                        dialog = {
                            name: 'Запрос на статистику',
                            owner: {
                                id: ownerId
                            },
                            participants: [],
                            distrib: false,
                            message: 'Укажите параметры, по которым нужно собрать статистическую информацию. Ваш запрос будет обработан. Ответ будет сформирован и выслан вам в течение 7 дней.'
                        };
                    for (var i in response) {
                        dialog.participants.push(response[i]);
                    }
                    Account.getAccount().then(function(response) {
                        ownerId = response.id;
                        Dialogs.openDialog(null, dialog);
                    });
                });
            };


            scope.openStatDialog = function (){
                Reports.createStatDialog()

            }

            scope.openQuestionOfTheDayDialog = function() {

                Users.getMessage({id: 0}, (function (users) {
                    console.log('a')
                    Dialogs.createDialog(false, users, {dialogTheme:'Вопрос дня'})
                        .then(function (dialog) {
                        console.log(dialog)
                        if (dialog && dialog.id) {
                            console.log(dialog)
                            Dialogs.openDialog(dialog.id);
                        }
                    });
                }))

                // Dialogs.getAvailableUsers(true).then(function (users) {
                //     Dialogs.createDialog(false, users).then(function (dialog) {
                //         if (dialog && dialog.id) {
                //             Dialogs.openDialog(dialog.id);
                //         }
                //     });
                // });
            };

            var defaultLockValue = true;

            if ($window.localStorage.getItem('lmsDashSidenav') !== null) {
                var lmsDashSidenav = JSON.parse($window.localStorage.getItem('lmsDashSidenav'));
                scope.lockSidenavLeft = (lmsDashSidenav.opened !== void 0) ? lmsDashSidenav.opened : defaultLockValue;
            } else {
                scope.lockSidenavLeft = defaultLockValue;
            }

            scope.stateIn = function (name) {
                var states = name.split(",");
                return states.some(function(el) {
                    return $state.includes(el);
                });
            };

            scope.toggleSidenavLeft = function () {
                scope.lockSidenavLeft = !scope.lockSidenavLeft;
            };

            scope.$watch('lockSidenavLeft', function (v) {
                $window.localStorage.setItem('lmsDashSidenav', JSON.stringify({
                    'opened': v
                }));
            });

            scope.$watch(function () {
                return $state.current;
            }, function (v) {
                scope.curPath = v;
            });

            scope.$watch(function() {
                return $mdMedia('gt-md');
            }, function (v) {
                scope.lockSidenavLeft = v;
            });
        }
    };
}]);

'use strict';

app.config(['$stateProvider', 'lmsConfig', function ($stateProvider, lmsConfig) {
    $stateProvider
        .state('dashboard', {
            parent: 'site',
            url: "/",
            // data: {
            //     roles: ['ROLE_STUDENT', 'ROLE_TEACHER']
            // },
            views: {
                'content@': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/default.html",
                    controller: 'DashboardCtrl'
                },
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/_dashBar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/dashboard.html",
                    controller: 'DashboardIndexCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Личный кабинет'
            }
        })
        .state('profile', {
            parent: 'dashboard',
            url: "profile",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/_dashBar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'dashboard/views/profile.html',
                    controller: 'ProfileCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('diagnostic', {
            parent: 'dashboard',
            url: "diagnostic",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "diagnostic/diagnostic-bar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'diagnostic/diagnostic.html',
                    controller: 'Diagnostic'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('integration/auth-redirect', {
            parent: 'dashboard',
            url: "integration/auth-redirect",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "diagnostic/diagnostic-bar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'diagnostic/diagnostic.html',
                    controller: 'Integrationrtc'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('mesh/navigate', {
            parent: 'dashboard',
            url: "mesh/navigate",
            views: {
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'integrationmesh/mesh.html',
                    controller: 'Integrationmesh'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('sections', {
            parent: 'dashboard',
            url: "sections",
            views: {
                // 'dashBar@dashboard': {
                //     templateUrl: lmsConfig.modulesPath + "sectionsAdding/sectionsAdding-bar.html",
                // },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'sectionsAdding/sectionsAdding.html',
                    controller: 'SectionsAdding'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('searchResults', {
            parent: 'dashboard',
            url: "searchResults",
            views: {
                // 'dashBar@dashboard': {
                //     templateUrl: lmsConfig.modulesPath + "searchResults/sectionsAdding-bar.html",
                // },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'searchResults/searchResults.html',
                    controller: 'SearchResults'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль'
            }
        })
        .state('my-profile', {
            parent: 'dashboard',
            url: "my-profile",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/_dashBar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'dashboard/views/myProfile.html',
                    controller: 'MyProfileCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Настройки'
            }
        })
        .state('digital-profile', {
            parent: 'dashboard',
            url: "digital-profile",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "dashboard/views/_dashBar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'dashboard/views/digitalProfile.html',
                    controller: 'DigitalProfileCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Мой цифровой профиль'
            }
        });
}]);

"use strict";

app.controller("MessengerCtrl", [
    "$scope",
    "MessengerResource",
    "Dialogs",
    "$rootScope",
    "lmsConfig",
    "Account",
    "$auth",
    "DialogsResource",
    "$state",
    '$sce',
    '$timeout',
    'usSpinnerService',
    function($scope, MessengerResource, Dialogs, $rootScope, lmsConfig, Account, $auth, DialogsResource, $state, $sce, $timeout, usSpinnerService) {
        $scope.spinnerMessenger = false;
        $scope.errorCase = false;


        // Variables

        // $scope.trustSrc = function(src) {
        //     return $sce.trustAsResourceUrl(src);
        // };

        // $scope.chatUrl = lmsConfig.rocketChatUrl;
        var rcTokenFromLocalStorage = localStorage.getItem("Meteor.loginToken:/:/rc-server");
        var rcUserIdFromLocalStorage = localStorage.getItem("Meteor.userId:/:/rc-server");

        if (rcTokenFromLocalStorage == 'null') {
            rcTokenFromLocalStorage = null;
        }

        if (rcUserIdFromLocalStorage == 'null') {
            rcUserIdFromLocalStorage = null;
        }

        $scope.rcToken = rcTokenFromLocalStorage;
        $scope.rcUserId = rcUserIdFromLocalStorage;

        spinnerShow();

        if (!$scope.rcToken) {
            MessengerResource.query({}, function(response, headers) {
                spinnerHide();

                $scope.rcToken = headers('rctoken');
                $scope.rcUserId = headers('rcuserid');
                localStorage.setItem("Meteor.loginToken:/:/rc-server", $scope.rcToken);
                localStorage.setItem("Meteor.userId:/:/rc-server", $scope.rcUserId);

            }, function (error) {
                spinnerHide();
                $scope.errorCase = true;
                console.log('error', error);
            });

        }
        else {spinnerHide();}

        function spinnerShow() {
            $scope.spinnerMessenger = true;
            $timeout(function () {
                usSpinnerService.spin('spinnerMessenger');
            }, 0);
        }

        function spinnerHide() {
            $scope.spinnerMessenger = false;
            $timeout(function () {
                usSpinnerService.stop('spinnerMessenger');
            }, 0);
        }
    },
]);


"use strict";

app.directive("lmsMessenger", [
    "lmsConfig",
    "$timeout",
    "$interval",
    "$http",
    function (lmsConfig, $timeout, $interval, $http) {
        var linkFn = function (scope, element, attrs) {
            scope.chatUrl = lmsConfig.rocketChatUrl;
            var iframe = element.get(0);

            iframe.onload = function () {
                var iFrameDocument = iframe.contentWindow.document;
                var head = iFrameDocument.head || iFrameDocument.getElementsByTagName('head')[0];
                var css = "[data-id='account'], [data-id='logout'], .sidebar__footer { display: none; } ";
                var style = iFrameDocument.createElement('style');
                style.type = 'text/css';
                if (style.styleSheet) {
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(iFrameDocument.createTextNode(css));
                }
                head.appendChild(style);
            };
        };

        return {
            restrict: "EA",
            replace: true,
            template: '<iframe height="700px" ng-src="{{chatUrl}}" frameborder="0"></iframe>',
            link: linkFn,
        };
    },
]);

'use strict';

angular.module('lmsClientApp')
    .factory('MessengerResource', function ($resource) {
        var rc_api = '/admin/rc-auth'
        return $resource(rc_api, {}, {
            'query': {
                method: 'POST',
                url: rc_api + '/check-user'
            }
        });
    })

'use strict';

app.config(['$stateProvider', 'lmsConfig',
            function ($stateProvider, lmsConfig) {
                $stateProvider
                .state('messenger', {
                    parent: 'dashboard',
                    url: 'messenger',
                    views: {
                        'dashBar@dashboard': {
                            templateUrl: lmsConfig.modulesPath + "messenger/views/_messengerBar.html",
                        },
                        'dashContent@dashboard': {
                            templateUrl: lmsConfig.modulesPath + 'messenger/views/messenger.html',
                            controller: 'MessengerCtrl'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Мессенджер'
                    }
                });
}]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.OrganizerCtrl
 * @description
 * # OrganizerCtrl
 * Controller of the lmsClientApp
 */
app.controller('OrganizerCtrl', [
  '$scope',
  '$auth',
  '$q',
  '$state',
  'Organizer',
  '$filter',
  'VideoConfConfigResource',
  'ModalStack',
  'LmsUtils',
  'Users',
    '$http',
  function (
    $scope,
    $auth,
    $q,
    $state,
    Organizer,
    $filter,
    VideoConfConfigResource,
    ModalStack,
    LmsUtils,
    Users,
      $http
  ) {
    // Variables
    $scope.selectedDate = null;
    $scope.dateStartMonth = new Date().getMonth();
    $scope.dateStartYear = new Date().getYear();
    $scope.currentMonth = null;
    $scope.events = [];
    $scope.direction = 'horizontal';
    $scope.videoConfs = [];
    $scope.deadlines = [];
      $scope.deadlinesRightFormat = [];
    $scope.activeDate = null;
      $scope.clickedDate = null;
      $scope.newDeadlines = []

    // Methods
    $scope.getDateContent = getDateContent;
    $scope.dayClick = dayClick;
    $scope.prevMonth = prevMonth;
    $scope.nextMonth = nextMonth;
    $scope.getDateEvents = getDateEvents;
    $scope.setDirection = setDirection;
    $scope.getVideoConfList = getVideoConfList;
      $scope.getDeadLinesList = getDeadLinesList;
    $scope.addEvent = addEvent;
    $scope.addEvent2 = addEvent2;
    $scope.addEventAll = addEventAll;
    $scope.getDeadLines = getDeadLines;
    $scope.goToEvent = goToEvent;
    $scope.goToVideoConf = goToVideoConf;
    $scope.deleteEvent = deleteEvent;
    $scope.GetSpecificDeadLine = GetSpecificDeadLine;
    $scope.goToLesson = goToLesson;
    $scope.goToDeadLine = goToDeadLine;


    init();

    function init() {
      Users.getProfile().$promise.then(function (user) {
        $scope.user = user.toJSON();
        updateMonthEventsConfs(new Date());
        setActiveDate(new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 999), true);
      });
    } //   if (countVideoConfs > 0) //     content += "<p class='date-content-count'>Конференций: " + countVideoConfs + '</p>'; //   content += '</div>'; //   return content; // } // function getDateContent(date) { //   var content = "<div class='date-content'>"; //   var countEvents = getDateEventsCount(date), countVideoConfs = getDateVideoConfsCount(date); //   if (countEvents > 0) //     content += "<p class='date-content-count'>Событий: " + countEvents + '</p>';

    function getDeadLines(date) {
        console.log($scope.user.id)
        var from = 1593550800000;
        var to = 1596229199999;
        console.log(date)
        console.log(makeMonthPeriodTimestamp(date))
        var monthPeriod = makeMonthPeriodTimestamp(date);
        console.log(monthPeriod)

        $http({
            method: 'GET',
            // url: 'api/lessons/deadline/'+$scope.user.id+'?from='+1593550800000+'&to='+1596229199999
            // url: "http://localhost:3000/api/lessons/deadline/107?from=1593550800000&to=1596229199999"
            url: "/api/lessons/deadline/"+$scope.user.id+"?from="+ monthPeriod.startTime + "&to=" + monthPeriod.endTime
        }).then(
            function successCallback(response) {
                $scope.deadlines = response.data;
                // $scope.deadlinesRightFormat = response.data.map(function (element) {
                //     element.completions = element.completions*1000
                //     return element
                // })
                // console.log( $scope.deadlines);
                console.log($scope.activeDate)
            },

            function errorCallback(response) {
                console.log('Bad Request');
            });
    }

      function GetSpecificDeadLine() {


          $http({
              method: 'GET',
              url: '/api/lessonCompletions/course/'+ 21987 +
                  '/topic/' + 23969 + '/lesson/' + 23970 +
                  '/group/' + 435210
              // url: '/api/lessonCompletions/course/'+ $scope.courseId +
              //     '/topic/' + $state.params.tid + '/lesson/' + $scope.lesson.id +
              //     '/group/' + $scope.groupId
          }).then(
              function successCallback(response) {
                  console.log(response);
              },

              function errorCallback(response) {
                  console.log('Bad Request');
              });
      }

    function goToLesson() {

        // $state.go($scope.pageTo.state.name, $scope.pageTo.state.params);
        var courseLesson = "courseLesson"
        var paramss = {
            courseId: 160395,
            lid: 160397,
            tid: 160396
        }
        $state.go(courseLesson, paramss);

    }


      function getDateContent(date) {
      var content = "<div class='date-content'>"; /**
       * getDateEventsCount(date) return number
       * getDateVideoConfsCount(date) return number
       */
          // $scope.deadlines.forEach(function (element) {
          //     var item = {};
          //     item.completions = element.completions
          //     item.courseId = element.courseId;
          //     item.groupId = element.groupId;
          //     item.lessonId = element.lessonId;
          //     item.lessonName = element.lessonName;
          //     item.topicId = element.topicId;
          //     rightFormatDeadLine.push(item)
          // });
          //
          // rightFormatDeadLine.forEach(function (el) {
          //     el.completions =  el.completions * 1000;
          // })
          //
          // var deadlinecount = 0;
          //
          // rightFormatDeadLine.forEach(function (element) {
          //
          //     if (new Date(element.completions).getDate() == date.getDate()){
          //         // console.log('`````````````````')
          //         deadlinecount++
          //         // $scope.activeDate.deadlines = rightFormatDeadLine
          //         // console.log( $scope.activeDate.deadlines)
          //     }
          // })
          //
          // console.log(deadlinecount)


          var countEvents = getDateEventsCount(date) + getDateVideoConfsCount(date) + getDeadLinesCount(date)
      if (countEvents > 0)
        content += "<p class='date-content-count'>Событий: " + countEvents + '</p>';
      return content;
    }

    function dayClick(date) {

        // console.log( $scope.deadlines)
        $scope.clickedDate = date;
        // $scope.activeDate.clickedDate = date;
        console.log( $scope.activeDate)


        // setActiveDate()
        var fetchEvents = false;

        var rightFormatDeadLine = [];

        $scope.deadlines.forEach(function (element) {
                var item = {};
                item.completions = element.completions
                item.courseId = element.courseId;
                item.groupId = element.groupId;
                item.lessonId = element.lessonId;
                item.lessonName = element.lessonName;
                item.topicId = element.topicId;
                item.lastName = element.lastName;
                item.firstName = element.firstName;
                item.middleName = element.middleName;
                item.profilePhotoPath = element.profilePhotoPath
                rightFormatDeadLine.push(item)
        });

        rightFormatDeadLine.forEach(function (el) {
               el.completions =  el.completions * 1000;
        })
        console.log($scope.activeDate)
        console.log($scope.deadlines)
        console.log(rightFormatDeadLine)

        var countEvents = getDateEventsCount(date) + getDateVideoConfsCount(date) ;
        if (countEvents > 0) {
            fetchEvents = true;
        }
        var deadlineIsOn = false

        console.log($scope.activeDate)
        $scope.activeDate.deadlines = []
        console.log($scope.activeDate)
        // $scope.activeDate.test = 'test';
        rightFormatDeadLine.forEach(function (element) {

                if (new Date(element.completions).getDate() == date.getDate()){
                    // console.log('`````````````````')
                    // console.log(new Date(element.completions).getDate())
                    // console.log(element)
                    // console.log(date.getDate())
                    fetchEvents = true;
                    deadlineIsOn = true;
                    $scope.activeDate.deadlines.push(element)
                    // $scope.activeDate.deadlines = rightFormatDeadLine
                    // console.log('bbbbbbbbbbbbbbbbbb')
                    // console.log( $scope.activeDate.deadlines)
                } else {
                    // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa")
                    // console.log($scope.activeDate.deadlines)
                }
        })
        console.log(fetchEvents)
      setActiveDate(date.setHours(0, 0, 0, 0), date.setHours(23, 59, 59, 999), fetchEvents , deadlineIsOn,date,$scope.activeDate.deadlines);
        addEventAll( $scope.activeDate)
    }
    function prevMonth(date) {
      updateMonthEventsConfs(new Date(date.year, date.month, 0));
      // $scope.activeDate = '';
    }
    function nextMonth(date) {
      updateMonthEventsConfs(new Date(date.year, date.month, 0));
      // $scope.activeDate = '';
    }
    function makeMonthPeriodTimestamp(date) {
      return date
        ? {
          startTime: new Date(date.getFullYear(), date.getMonth(), 1).setHours(0, 0, 0, 0),
          endTime: new Date(date.getFullYear(), date.getMonth() + 1, 0).setHours(23, 59, 59, 999)
        }
        : false;
    }
    function getMonthPeriodEvents(date) {
      var monthPeriod = makeMonthPeriodTimestamp(date);
      if (monthPeriod && monthPeriod.startTime && monthPeriod.endTime) {
        $scope.getDateEvents(monthPeriod.startTime, monthPeriod.endTime, function (response) {
          $scope.events = response;
        });
      }
    }
    function getMonthPeriodVideoConfs(date) {
      var monthPeriod = makeMonthPeriodTimestamp(date);
      if (monthPeriod && monthPeriod.startTime && monthPeriod.endTime) {
        $scope.getVideoConfList(monthPeriod.startTime, monthPeriod.endTime, function (response) {
          $scope.videoConfs = response;
        });
      }
    }
      function getMonthPeriodDeadlines(date) {
        console.log(date)
          var monthPeriod = makeMonthPeriodTimestamp(date);
          if (monthPeriod && monthPeriod.startTime && monthPeriod.endTime) {
              $scope.getVideoConfList(monthPeriod.startTime, monthPeriod.endTime, function (response) {
                  // console.log(response)
                  // $scope.deadlines = response;
                  // console.log('!!!!!!!!!!!!!!!!!!!!!!!!')
              });
          }
      }

    function setDirection(direction) {
      $scope.direction = direction;
      $scope.dayFormat = direction === 'vertical' ? 'EEEE, MMMM d' : 'd';
    }
    function getDateEventsCount(date) {
      if ($scope.events.length > 0) {
        return $scope.events.reduce(
          function (sum, el) {
            var elDate = new Date(el.startTime);
            if (elDate.getDate() === date.getDate() && elDate.getMonth() === date.getMonth()) sum++;
            return sum;
          },
          0
        );
      } else {
        return 0;
      }
    }
    function getDateVideoConfsCount(date) {
      if ($scope.videoConfs.length > 0) {
        return $scope.videoConfs.reduce(
          function (sum, el) {
            var elDate = new Date(el.plannedStartTime);
            if (elDate.getDate() === date.getDate() && elDate.getMonth() === date.getMonth()) sum++;
            return sum;
          },
          0
        );
      } else {
        return 0;
      }
    }

    function getDeadLinesCount(date) {

        var rightFormatDeadLine = [];

        $scope.deadlines.forEach(function (element) {
            var item = {};
            item.completions = element.completions
            item.courseId = element.courseId;
            item.groupId = element.groupId;
            item.lessonId = element.lessonId;
            item.lessonName = element.lessonName;
            item.topicId = element.topicId;
            rightFormatDeadLine.push(item)
        });

        rightFormatDeadLine.forEach(function (el) {
            el.completions =  el.completions * 1000;
        })

        var deadlinecount = 0;

        rightFormatDeadLine.forEach(function (element) {

            if (new Date(element.completions).getDate() == date.getDate()){
                // console.log('`````````````````')
                deadlinecount++
                // $scope.activeDate.deadlines = rightFormatDeadLine
                // console.log( $scope.activeDate.deadlines)
            }
        })

        // console.log(deadlinecount)
        return deadlinecount
    }

    function getVideoConfList(dateFrom, dateTo, callback) {
      callback = callback && angular.isFunction(callback) ? callback : function () { };
      VideoConfConfigResource.getForUser({
        userId: $scope.user.id,
        from: LmsUtils.dateIsTimestamp(dateFrom) ? dateFrom : Date.parse(dateFrom),
        to: LmsUtils.dateIsTimestamp(dateTo) ? dateTo : Date.parse(dateTo)
      }).$promise.then(callback);
    }
    function setActiveDate(dateFrom, dateTo, fetchEvents,deadlineIsOn,date,deadlines) {
      $scope.activeDate = {
        dateFrom: dateFrom,
        dateTo: dateTo,
          deadlines: deadlines
      };
      if (fetchEvents) {
          console.log('ssss')
        $scope.getDateEvents(dateFrom, dateTo, function (response) {
          $scope.activeDate.events = response;
          console.log($scope.activeDate.events)
        });
        $scope.getVideoConfList(dateFrom, dateTo, function (response) {
          $scope.activeDate.videoConfs = response;
        });
        if(deadlineIsOn){
            console.log($scope.activeDate)
            console.log($scope.deadlines)

            // $scope.activeDate.deadlines = $scope.deadlines;
            console.log($scope.activeDate.deadlines)
        }

      }
    }
    function getDateEvents(dF, dT, callback) {
      callback = callback && angular.isFunction(callback) ? callback : function () { };
      Organizer.getDateEvents(dF, dT).then(callback);
    }
      function getDeadLinesList(dF, dT, callback) {
          callback = callback && angular.isFunction(callback) ? callback : function () { };
          Organizer.getDeadLinesList(dF, dT).then(callback);
      }

    function deleteEvent(event) {
      LmsUtils.showConfirmDialog(
        'Вы действительно хотите удалить событие "' + event.name + '"?',
        'Удаление события',
        'Да',
        'Нет'
      ).then(
        function () {
          if (event.id) {
            Organizer.deleteEvent(event.id).then(function (response) {
              LmsUtils.showSimpleToast('Событие удалено');
              $scope.getDateEvents($scope.activeDate.dateFrom, $scope.activeDate.dateTo);
            });
          }
        },
        function () {
          LmsUtils.showSimpleToast('Удаление отменено');
        }
      );
    }
    function addEvent() {
      if ($scope.activeDate && $scope.activeDate.dateFrom && $scope.activeDate.dateTo) {
        Organizer.openDateEvent(null, $scope.activeDate.dateFrom, $scope.activeDate.dateTo);
      } else {
        LmsUtils.showSimpleToast('Не выбрана дата');
      }
    }
      function addEvent2() {
          if ($scope.activeDate && $scope.activeDate.dateFrom && $scope.activeDate.dateTo) {
              Organizer.openDateEvent2(null, $scope.activeDate.dateFrom, $scope.activeDate.dateTo);
          } else {
              LmsUtils.showSimpleToast('Не выбрана дата');
          }
      }
      function addEventAll(activeDate) {
        console.log(activeDate)
          if ($scope.activeDate && $scope.activeDate.dateFrom && $scope.activeDate.dateTo) {
              Organizer.openDateEventAll(null, $scope.activeDate.dateFrom, $scope.activeDate.dateTo,activeDate);
          } else {
              LmsUtils.showSimpleToast('Не выбрана дата');
          }
      }

    function goToEvent(eventId) {
      if (eventId !== void 0) {
        Organizer.openDateEvent(eventId);
      }
    }
    function goToVideoConf(vcId) {
      if (vcId !== void 0) {
        ModalStack.clearStack();
        $state.go('videoConf', { vcId: vcId }, { reload: true });
      }
    }

      function goToDeadLine(deadLineId,deadline) {
        console.log(deadLineId)
          if(deadLineId !== void 0) {
              Organizer.openDateDeadline(deadLineId,deadline);
          }
      }

    function updateActiveDate() {
      if (($scope.activeDate && $scope.activeDate.dateFrom, $scope.activeDate.dateTo)) {
        setActiveDate($scope.activeDate.dateFrom, $scope.activeDate.dateTo, true);
      }
    }
    function updateMonthEventsConfs(date) {
      getMonthPeriodEvents(date);
      getMonthPeriodVideoConfs(date);
        getMonthPeriodDeadlines(date);

        getDeadLines(date);

    }
    $scope.$on('eventUpdated', function () {
      updateActiveDate();
      if ($scope.activeDate && $scope.activeDate.dateFrom) {
        updateMonthEventsConfs(new Date($scope.activeDate.dateFrom));
      }
    });
    $scope.$on('eventDeleted', function () {
      updateActiveDate();
      if ($scope.activeDate && $scope.activeDate.dateFrom) {
        updateMonthEventsConfs(new Date($scope.activeDate.dateFrom));
      }
    });
  }
]);

'use strict';

function DayEventsListCtrl($scope, $mdDialog, Organizer, LmsUtils, VideoConfConfigResource, $state, ModalStack, $auth, dateFrom, dateTo)  {

    // Variables
    $scope.dateFrom = dateFrom;
    $scope.dateTo = dateTo;
    $scope.events = [];
    $scope.videoConfs = [];

    // Methods
    $scope.hide = hide;
    $scope.cancel = cancel;
    $scope.addEvent = addEvent;
    $scope.goToEvent = goToEvent;
    $scope.getDayEvents = getDayEvents;
    $scope.deleteEvent = deleteEvent;
    $scope.getDayVideoConfs = getDayVideoConfs;
    $scope.goToVideoConf = goToVideoConf;

    init();

    function init() {
        $scope.getDayEvents($scope.dateFrom, $scope.dateTo);
        $scope.getDayVideoConfs($scope.dateFrom, $scope.dateTo);
    }

    function addEvent() {
        Organizer.openDateEvent(null, $scope.dateFrom, $scope.dateTo);
    }
    function addEvent2() {
        Organizer.openDateEvent2(null, $scope.dateFrom, $scope.dateTo);
    }
    function addEventAll() {
        Organizer.openDateEventAll(null, $scope.dateFrom, $scope.dateTo);
    }

    function goToEvent(eventId) {
        if(eventId !== void 0) {
            Organizer.openDateEvent(eventId);
        }
    }

    function goToVideoConf(vcId) {
        if(vcId !== void 0) {
            ModalStack.clearStack();
            $state.go("videoConf", {'vcId' : vcId}, {reload : true});
        }
    }

    function goToDeadLine(deadLineId) {
        if(deadLineId !== void 0) {
            Organizer.openDateEvent(deadLineId);
        }
    }

    function hide() {
        $mdDialog.hide();
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function getDayEvents(dF, dT) {
        Organizer.getDateEvents(dF, dT).then(function(response) {
            $scope.events = response;
        });
    }

    function getDayVideoConfs(dF, dT) {
        if($auth.user.id)
            VideoConfConfigResource.getForUser({
                'userId': $auth.user.id,
                'from': LmsUtils.dateIsTimestamp(dF) ? dF : Date.parse(dF),
                'to': LmsUtils.dateIsTimestamp(dT) ? dT : Date.parse(dT)
            }, function(response) {
                $scope.videoConfs = response;
            }) ;
    }

    function deleteEvent(event) {
        if(confirm("Вы действительно хотите удалить событие \"" + event.name + "\"?") && event.id) {
            Organizer.deleteEvent(event.id).then(function(response) {
                LmsUtils.showSimpleToast("Событие удалено");
                $scope.getDayEvents($scope.dateFrom, $scope.dateTo);
            });
        }
    }
}

'use strict';

app.controller('DayEventCtrl', ['$scope', '$mdDialog', 'Organizer', 'LmsUtils', '$auth', 'eventId', 'dateFrom', 'dateTo', function DayEventCtrl($scope, $mdDialog, Organizer, LmsUtils, $auth, eventId, dateFrom, dateTo)  {

    // Variables
    var timeFormat = {
        hour12: false, hour: "2-digit", minute: "2-digit"
    };
    $scope.dateFrom = dateFrom;
    $scope.dateTo = dateTo;
    $scope.event = {};
    $scope.eventEdit = {};
    $scope.editMode = false;

    // Methods
    $scope.hide = hide;
    $scope.cancel = cancel;
    $scope.getDayEvent = getDayEvent;
    $scope.toggleEditMode = toggleEditMode;
    $scope.saveEvent = saveEvent;
    $scope.deleteEvent = deleteEvent;

    init();

    function init() {
        // $scope.eventEdit.user = ($scope.eventEdit.user) ? $scope.eventEdit.user : $auth.user;
        if(eventId)
            $scope.getDayEvent(eventId);
        else {
            if($scope.dateFrom) {
                var startTime = buildDateTime($scope.dateFrom);
                $scope.eventEdit._startDateTime = {
                    date: startTime,
                    time: startTime
                };
            }
            if($scope.dateTo) {
                var endTime = buildDateTime($scope.dateTo);
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                    time: endTime
                };
            }
            $scope.editMode = true;
        }
    }

    function hide() {
        $mdDialog.hide();
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function getDayEvent(eventId) {
        if(eventId !== void 0)
            Organizer.getEvent(eventId).then(function(response) {
                $scope.event = response;
            });
    }

    function toggleEditMode() {
        if($scope.event && $scope.event.id) {
            if(!$scope.editMode) {
                angular.copy($scope.event, $scope.eventEdit);
                var startTime = buildDateTime($scope.event.startTime),
                    endTime = buildDateTime($scope.event.endTime);
                $scope.eventEdit._startDateTime = {
                    date: startTime,
                    time: startTime
                };
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                    time: endTime
                };
            }
            $scope.editMode = !$scope.editMode;
        }
    }

    function buildDateTime(dtTimestamp) {
        var dt = new Date(dtTimestamp);
        dt.toLocaleString('ru-RU', timeFormat);
        return dt;
    }

    function saveEvent() {
        if(!$scope.eventEdit.name || $scope.eventEdit.name === "" || /^\s*&/g.test($scope.eventEdit.name)) {
            LmsUtils.showSimpleToast("Не заполнено Наименование");
            return false;
        }
        if(!$scope.eventEdit._startDateTime || !$scope.eventEdit._startDateTime.date || !$scope.eventEdit._startDateTime.time) {
            LmsUtils.showSimpleToast("Не указано дата/время начала");
            return false;
        }
        if(!$scope.eventEdit._endDateTime || !$scope.eventEdit._endDateTime.date || !$scope.eventEdit._endDateTime.time) {
            LmsUtils.showSimpleToast("Не указано дата/время окончания");
            return false;
        }

        $scope.eventEdit.startTime = new Date($scope.eventEdit._startDateTime.date.getFullYear(), $scope.eventEdit._startDateTime.date.getMonth(), $scope.eventEdit._startDateTime.date.getDate(), $scope.eventEdit._startDateTime.time.getHours(), $scope.eventEdit._startDateTime.time.getMinutes());
        $scope.eventEdit.endTime = new Date($scope.eventEdit._endDateTime.date.getFullYear(), $scope.eventEdit._endDateTime.date.getMonth(), $scope.eventEdit._endDateTime.date.getDate(), $scope.eventEdit._endDateTime.time.getHours(), $scope.eventEdit._endDateTime.time.getMinutes());
        $scope.eventEdit.startTime = Date.parse($scope.eventEdit.startTime);
        $scope.eventEdit.endTime = Date.parse($scope.eventEdit.endTime);

        if($scope.eventEdit.endTime < $scope.eventEdit.startTime) {
            LmsUtils.showSimpleToast("Некорректно задан временной интервал!");
            return;
        }

        if ($scope.eventEdit.user) {
            $scope.eventEdit.user = angular.isObject($scope.eventEdit.user) ? $scope.eventEdit.user : JSON.parse($scope.eventEdit.user);
            $scope.eventEdit.user = ($scope.eventEdit.user.id) ? $scope.eventEdit.user : $auth.user;
        }

        Organizer.saveEvent($scope.eventEdit).then(function(response) {
            $scope.cancel();
        });
    }

    function deleteEvent() {
        if($scope.event.id && confirm("Вы действительно хотите удалить событие \"" + $scope.event.name + "\"?")) {
            Organizer.deleteEvent($scope.event.id).then(function(response) {
                LmsUtils.showSimpleToast("Событие удалено");
                $scope.cancel();
            });
        }
    }
}]);

'use strict';

app.controller('DayEventAllCtrl', ['$scope',
    '$state',
    '$rootScope',
    '$mdDialog',
    'Organizer',
    'LmsUtils',
    '$auth',
    'eventId',
    'dateFrom',
    'dateTo',
    'activeDate', function DayEventCtrl(
        $scope,
        $state,
        $rootScope,
        $mdDialog,
        Organizer,
        LmsUtils,
        $auth,
        eventId,
        dateFrom,
        dateTo,
        activeDate)  {

    // Variables
    var timeFormat = {
        hour12: false, hour: "2-digit", minute: "2-digit"
    };
    $scope.dateFrom = dateFrom;
    $scope.dateTo = dateTo;
    $scope.event = {};
    $scope.eventEdit = {};
    $scope.editMode = false;
    $scope.activeDate = activeDate;
    $scope.deleteTooltipIsOpen = false;
    $scope.tooltipIsShown = false
    $scope.fixedDeadlines = []
    $scope.printedRole = ''


    // Methods
    $scope.hide = hide;
    $scope.cancel = cancel;
    $scope.getDayEvent = getDayEvent;
    $scope.toggleEditMode = toggleEditMode;
    $scope.saveEvent = saveEvent;
    $scope.deleteEvent = deleteEvent;
    $scope.goToEvent = goToEvent;
    $scope.goToLesson = goToLesson;
    $scope.goToVC = goToVC;
    // $scope.showDeleteToolTip = showDeleteToolTip;

    init();

    function init() {
        console.log(activeDate)
        console.log(new Date())
        console.log(activeDate.deadlines)
        // console.log(activeDate.deadlines[0].completions)
        // console.log(activeDate.clickedDate)

        console.log($rootScope)
        console.log($auth.user.userRoles[0])


            switch ($auth.user.userRoles[0]) {
            case "ROLE_LOCAL_ADMIN":
                $scope.printedRole =  "Локальный администратор"
                break;
            case "ROLE_STUDENT":
                $scope.printedRole = "Ученик"
                break;
            case "ROLE_TUTOR":
                $scope.printedRole =  "Тьютор"
                break;
            case "ROLE_ADDITIONAL_EDUCATION_COORDINATOR":
                $scope.printedRole =  "Коодинатор по дополнительному образованию"
                break;
            case "ROLE_LOCATION_COORDINATOR":
                $scope.printedRole =  "Локальный координатор"
                break;
            case "ROLE_PARENT":
                $scope.printedRole =  "Родитель"
                break;
            case "ROLE_COURSE_DEVELOPER":
                $scope.printedRole =  "Разработчик курсов"
                break;
            case "ROLE_DISTANCE_EDUCATION_COORDINATOR":
                $scope.printedRole =  "Координатор дистанционного образования"
                break;
            case "ROLE_ANONYMOUS":
                $scope.printedRole =  "Анонимный пользователь"
                break;
            case "ROLE_METHODOLOGIST":
                $scope.printedRole =  "Методист"
                break;
            case "ROLE_PARTNER":
                $scope.printedRole =  "Родитель"
                break;
            case "ROLE_PROJECT_ACTIVITY_COORDINATOR":
                $scope.printedRole =  "Координатор проектной деятельности"
                break;
            case "ROLE_GUEST":
                $scope.printedRole =  "Гость"
                break;
            case "ROLE_DEPUTY_HEAD_TEACHER":
                $scope.printedRole =  "Заместитель директора по УВР"
                break;
            case "ROLE_ADMIN":
                $scope.printedRole =  "Администратор"
                break;
            case "ROLE_OUT_OF_SCHOOL_ACTIVITY_COORDINATOR":
                $scope.printedRole =  "Кординатор внеурочной деятельности"
                break;
            case "ROLE_SCHOOL_ADMIN":
                $scope.printedRole =  "Школьный администратор"
                break;
            case "ROLE_CONSULTANT":
                $scope.printedRole =  "Консультант"
                break;
            case "ROLE_HEAD_TEACHER":
                $scope.printedRole =  "Директор"
                break;
            case "ROLE_PSYCHOLOGIST":
                $scope.printedRole =  "Психолог"
                break;
            case "ROLE_TEACHER":
                $scope.printedRole =  "Учитель"
                break;

            }




        // if($rootScope.user.roles[0] == 'ROLE_STUDENT'){
        //     $scope.printedRole = "Студент"
        // }

        // if($root.user.roles[0] == 'ROLE_STUDENT'){
        //     $scope.printedRole = "Студент"
        // }

        // $scope.activeDate.modifiedEvents = [];
        // $scope.activeDate.events.forEach(function (el) {
        //         // el.deleteTooltipIsOpen = true
        //         $scope.activeDate.modifiedEvents.push(el)
        // })

        $scope.eventEdit.user = ($scope.eventEdit.user) ? $scope.eventEdit.user : $auth.user;
        if(eventId)
            $scope.getDayEvent(eventId);
        else {
            if($scope.dateFrom) {
                var startTime = buildDateTime($scope.dateFrom);
                $scope.eventEdit._startDateTime = {
                    date: startTime,
                    time: startTime
                };
            }
            if($scope.dateTo) {
                var endTime = buildDateTime($scope.dateTo);
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                    time: endTime
                };
            }
            $scope.editMode = true;
        }
    }

    function hide() {
        $mdDialog.hide();
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function getDayEvent(eventId) {
        if(eventId !== void 0)
            Organizer.getEvent(eventId).then(function(response) {
                $scope.event = response;
            });
    }

    function toggleEditMode() {
        if($scope.event && $scope.event.id) {
            if(!$scope.editMode) {
                angular.copy($scope.event, $scope.eventEdit);
                var startTime = buildDateTime($scope.event.startTime),
                    endTime = buildDateTime($scope.event.endTime);
                $scope.eventEdit._startDateTime = {
                    date: startTime,
                    time: startTime
                };
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                    time: endTime
                };
            }
            $scope.editMode = !$scope.editMode;
        }
    }

    function buildDateTime(dtTimestamp) {
        var dt = new Date(dtTimestamp);
        dt.toLocaleString('ru-RU', timeFormat);
        return dt;
    }

    function saveEvent() {
        if(!$scope.eventEdit.name || $scope.eventEdit.name === "" || /^\s*&/g.test($scope.eventEdit.name)) {
            LmsUtils.showSimpleToast("Не заполнено Наименование");
            return false;
        }
        if(!$scope.eventEdit._startDateTime || !$scope.eventEdit._startDateTime.date || !$scope.eventEdit._startDateTime.time) {
            LmsUtils.showSimpleToast("Не указано дата/время начала");
            return false;
        }
        if(!$scope.eventEdit._endDateTime || !$scope.eventEdit._endDateTime.date || !$scope.eventEdit._endDateTime.time) {
            LmsUtils.showSimpleToast("Не указано дата/время окончания");
            return false;
        }

        $scope.eventEdit.startTime = new Date($scope.eventEdit._startDateTime.date.getFullYear(), $scope.eventEdit._startDateTime.date.getMonth(), $scope.eventEdit._startDateTime.date.getDate(), $scope.eventEdit._startDateTime.time.getHours(), $scope.eventEdit._startDateTime.time.getMinutes());
        $scope.eventEdit.endTime = new Date($scope.eventEdit._endDateTime.date.getFullYear(), $scope.eventEdit._endDateTime.date.getMonth(), $scope.eventEdit._endDateTime.date.getDate(), $scope.eventEdit._endDateTime.time.getHours(), $scope.eventEdit._endDateTime.time.getMinutes());
        $scope.eventEdit.startTime = Date.parse($scope.eventEdit.startTime);
        $scope.eventEdit.endTime = Date.parse($scope.eventEdit.endTime);

        if($scope.eventEdit.endTime < $scope.eventEdit.startTime) {
            LmsUtils.showSimpleToast("Некорректно задан временной интервал!");
            return;
        }

        if ($scope.eventEdit.user) {
            $scope.eventEdit.user = angular.isObject($scope.eventEdit.user) ? $scope.eventEdit.user : JSON.parse($scope.eventEdit.user);
            $scope.eventEdit.user = ($scope.eventEdit.user.id) ? $scope.eventEdit.user : $auth.user;
        }

        Organizer.saveEvent($scope.eventEdit).then(function(response) {
            $scope.cancel();
        });
    }

    // function deleteEvent(eventId) {
    //
    //         Organizer.deleteEvent(eventId).then(function(response) {
    //             LmsUtils.showSimpleToast("Событие удалено");
    //             $scope.cancel();
    //         });
    //
    // }

    function deleteEvent(eventId) {
        if(eventId && confirm("Вы действительно хотите удалить событие \"" + "\"?")) {
            Organizer.deleteEvent(eventId).then(function(response) {
                LmsUtils.showSimpleToast("Событие удалено");
                $scope.cancel();
            });
        }
    }


    function goToEvent(eventId) {
        if (eventId !== void 0) {
            Organizer.openDateEvent(eventId);
        }
    }
    function goToDeadLine(deadLineId,deadline) {
        console.log(deadLineId)
        if(deadLineId !== void 0) {
            Organizer.openDateDeadline(deadLineId,deadline);
        }
    }

    function goToLesson(deadline) {

        // console.log(activeDate)
        // console.log(deadline)
        // $state.go($scope.pageTo.state.name, $scope.pageTo.state.params);
        var courseLesson = "courseLessonTotal"
        var paramss = {
            courseId: deadline.courseId,
            lid: deadline.lessonId,
            tid: deadline.topicId
        }
        console.log(paramss)

        $state.go(courseLesson, paramss);

    }

        function goToVC(VcId) {
            console.log(VcId)
            $scope.vcId=VcId
            console.log('sssssssssssssssssssssssssssssssss')
            console.log($rootScope)
            $rootScope.void = VcId
            console.log($rootScope.void)
        }


        // function showDeleteToolTip (id){
    //     console.log('aaaaaaaaaaaaaaaaaaaaaaaa')
    //     console.log($scope.activeDate.modifiedEvents)
    //     $scope.activeDate.modifiedEvents.forEach(function (element) {
    //             console.log(element.id === id)
    //             // console.log(element.deleteTooltipIsOpen)
    //     })
    //     // $scope.activeDate.modifiedEvents.forEach(function (el) {
    //     //     if (el.id == id){
    //     //         el.deleteTooltipIsOpen = true
    //     //     }
    //     // })
    // }

    // function deleteEvent(event) {
    //     LmsUtils.showConfirmDialog(
    //         'Вы действительно хотите удалить событие "' + event.name + '"?',
    //         'Удаление события',
    //         'Да',
    //         'Нет'
    //     ).then(
    //         function () {
    //             if (event.id) {
    //                 Organizer.deleteEvent(event.id).then(function (response) {
    //                     LmsUtils.showSimpleToast('Событие удалено');
    //                     $scope.getDateEvents($scope.activeDate.dateFrom, $scope.activeDate.dateTo);
    //                 });
    //             }
    //         },
    //         function () {
    //             LmsUtils.showSimpleToast('Удаление отменено');
    //         }
    //     );
    // }

}]);

'use strict';

app.controller('DayEventDeadlineCtrl', ['$scope', '$state', '$mdDialog', 'Organizer', 'LmsUtils', '$auth', 'eventId', 'dateFrom', 'dateTo', function DayEventDeadlineCtrl($scope,$state, $mdDialog, Organizer, LmsUtils, $auth, eventId, dateFrom, dateTo,completions,deadline)  {

    // Variables
    var timeFormat = {
        hour12: false, hour: "2-digit", minute: "2-digit"
    };
    $scope.dateFrom = dateFrom;
    $scope.dateTo = dateTo;
    $scope.event = {};
    $scope.eventEdit = {};
    $scope.editMode = false;
    $scope.eventId=eventId;
    $scope.deadline=deadline;
    $scope.deadlineDate = new Date(deadline.completions*1000)

    // Methods
    $scope.hide = hide;
    $scope.cancel = cancel;
    $scope.getDayEvent = getDayEvent;
    $scope.toggleEditMode = toggleEditMode;
    $scope.saveEvent = saveEvent;
    $scope.deleteEvent = deleteEvent;
    $scope.goToLesson = goToLesson;




    init();

    function init() {
        console.log(eventId)
        console.log(completions)
        console.log(deadline)
        if(eventId)
            $scope.getDayEvent(eventId);
        else {
            if($scope.dateFrom) {
                var startTime = buildDateTime($scope.dateFrom);
                $scope.eventEdit._startDateTime = {
                    date: startTime,
                    time: startTime
                };
            }
            if($scope.dateTo) {
                var endTime = buildDateTime($scope.dateTo);
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                    time: endTime
                };
            }
            $scope.editMode = true;
        }
    }

    function goToLesson(deadline) {

        // $state.go($scope.pageTo.state.name, $scope.pageTo.state.params);
        var courseLesson = "courseLessonTotal"
        var paramss = {
            courseId: deadline.courseId,
            lid: deadline.lessonId,
            tid: deadline.topicId
        }
        $state.go(courseLesson, paramss);

    }

    function hide() {
        $mdDialog.hide();
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function getDayEvent(eventId) {
        if(eventId !== void 0)
            Organizer.getEvent(eventId).then(function(response) {
                $scope.event = response;
            });
    }

    function toggleEditMode() {
        if($scope.event && $scope.event.id) {
            if(!$scope.editMode) {
                angular.copy($scope.event, $scope.eventEdit);
                var startTime = buildDateTime($scope.event.startTime),
                    endTime = buildDateTime($scope.event.endTime);
                $scope.eventEdit._startDateTime = {
                    date: startTime,

                };
                $scope.eventEdit._endDateTime = {
                    date: endTime,
                };
            }
            $scope.editMode = !$scope.editMode;
        }
    }

    function buildDateTime(dtTimestamp) {
        var dt = new Date(dtTimestamp);
        dt.toLocaleString('ru-RU', timeFormat);
        return dt;
    }

    function saveEvent() {
        if(!$scope.eventEdit.name || $scope.eventEdit.name === "" || /^\s*&/g.test($scope.eventEdit.name)) {
            LmsUtils.showSimpleToast("Не заполнено Наименование");
            return false;
        }
        if(!$scope.eventEdit._startDateTime || !$scope.eventEdit._startDateTime.date || !$scope.eventEdit._startDateTime.time) {
            LmsUtils.showSimpleToast("Не указано дата/время начала");
            return false;
        }
        // if(!$scope.eventEdit._endDateTime || !$scope.eventEdit._endDateTime.date || !$scope.eventEdit._endDateTime.time) {
        //     LmsUtils.showSimpleToast("Не указано дата/время окончания");
        //     return false;
        // }

        // $scope.eventEdit.startTime = new Date($scope.eventEdit._startDateTime.date.getFullYear(), $scope.eventEdit._startDateTime.date.getMonth(), $scope.eventEdit._startDateTime.date.getDate(), $scope.eventEdit._startDateTime.time.getHours(), $scope.eventEdit._startDateTime.time.getMinutes());
        // $scope.eventEdit.endTime = new Date($scope.eventEdit._endDateTime.date.getFullYear(), $scope.eventEdit._endDateTime.date.getMonth(), $scope.eventEdit._endDateTime.date.getDate(), $scope.eventEdit._endDateTime.time.getHours(), $scope.eventEdit._endDateTime.time.getMinutes());
        // $scope.eventEdit.startTime = Date.parse($scope.eventEdit.startTime);
        // $scope.eventEdit.endTime = Date.parse($scope.eventEdit.endTime);

        if($scope.eventEdit.endTime < $scope.eventEdit.startTime) {
            LmsUtils.showSimpleToast("Некорректно задан временной интервал!");
            return;
        }

        if ($scope.eventEdit.user) {
            $scope.eventEdit.user = angular.isObject($scope.eventEdit.user) ? $scope.eventEdit.user : JSON.parse($scope.eventEdit.user);
            $scope.eventEdit.user = ($scope.eventEdit.user.id) ? $scope.eventEdit.user : $auth.user;
        }

        Organizer.saveEvent($scope.eventEdit).then(function(response) {
            $scope.cancel();
        });
    }

    function deleteEvent() {
        if($scope.event.id && confirm("Вы действительно хотите удалить событие \"" + $scope.event.name + "\"?")) {
            Organizer.deleteEvent($scope.event.id).then(function(response) {
                LmsUtils.showSimpleToast("Событие удалено");
                $scope.cancel();
            });
        }
    }
}]);

'use strict';

angular.module('lmsClientApp').service('Organizer', [
  'rest',
  'lmsConfig',
  '$q',
  '$mdDialog',
  '$filter',
  '$rootScope',
  'UserEventsResource',
  function(rest, lmsConfig, $q, $mdDialog, $filter, $rootScope, UserEventsResource) {
    // Variables
    var self = this;

    // Methods
    this.openDateEventsList = openDateEventsList;
    this.openDateEvent = openDateEvent;
    this.openDateEvent2 = openDateEvent2;
    this.openDateEventAll = openDateEventAll;
    this.openDateDeadline = openDateDeadline;
    this.getDateEvents = getDateEvents;
    this.getEvent = getEvent;
    this.saveEvent = saveEvent;
    this.deleteEvent = deleteEvent;

    function openDateEventsList(dateFrom, dateTo, flashBack) {
      var _arguments = [dateFrom ? dateFrom : null, dateTo ? dateTo : null];

      $mdDialog.show({
        controller: 'DayEventsListCtrl',
        templateUrl: lmsConfig.modulesPath + 'organizer/views/_showDayEventsList.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          dateFrom: dateFrom,
          dateTo: dateTo
        }
      });
    }

    function getDateEvents(dateFrom, dateTo) {
      return UserEventsResource.query({
        from: isTimestamp(dateFrom) ? dateFrom : Date.parse(dateFrom),
        to: isTimestamp(dateTo) ? dateTo : Date.parse(dateTo)
      }).$promise;
    }

    function getEvent(eventId) {
      if (!eventId) {
        return false;
      } else {
        return UserEventsResource.get({
          id: eventId
        }).$promise;
      }
    }

    function openDateEvent(eventId, dateFrom, dateTo, flashBack) {
      var _eventId, _dateFrom, _dateTo, _arguments;

      _eventId = eventId ? eventId : null;
      _dateFrom = dateFrom ? dateFrom : null;
      _dateTo = dateTo ? dateTo : null;
      _arguments = [_eventId, _dateFrom, _dateTo];

      $mdDialog
        .show({
          controller: 'DayEventCtrl',
          templateUrl: lmsConfig.modulesPath + 'organizer/views/_showDayEvent.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          escapeToClose: true,
          locals: {
            eventId: _eventId,
            dateFrom: _dateFrom,
            dateTo: _dateTo
          }
        })
        .then(function(answer) {});
    }

      function openDateEvent2(eventId, dateFrom, dateTo, flashBack) {
          var _eventId, _dateFrom, _dateTo, _arguments;

          _eventId = eventId ? eventId : null;
          _dateFrom = dateFrom ? dateFrom : null;
          _dateTo = dateTo ? dateTo : null;
          _arguments = [_eventId, _dateFrom, _dateTo];

          $mdDialog
              .show({
                  controller: 'DayEventCtrl',
                  templateUrl: lmsConfig.modulesPath + 'organizer/views/_showDayEvent2.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose: true,
                  escapeToClose: true,
                  locals: {
                      eventId: _eventId,
                      dateFrom: _dateFrom,
                      dateTo: _dateTo
                  }
              })
              .then(function(answer) {});
      }

      function openDateEventAll(eventId, dateFrom, dateTo, activeDate) {
          var _eventId, _dateFrom, _dateTo,_activeDate, _arguments;

          _eventId = eventId ? eventId : null;
          _dateFrom = dateFrom ? dateFrom : null;
          _dateTo = dateTo ? dateTo : null;
          _activeDate = activeDate ? activeDate : null;
          _arguments = [_eventId, _dateFrom, _dateTo];

          $mdDialog
              .show({
                  controller: 'DayEventAllCtrl',
                  templateUrl: lmsConfig.modulesPath + 'organizer/views/_showDayEventAll.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose: true,
                  escapeToClose: true,
                  locals: {
                      eventId: _eventId,
                      dateFrom: _dateFrom,
                      dateTo: _dateTo,
                      activeDate: _activeDate
                  }
              })
              .then(function(answer) {});
      }

      function openDateDeadline(completions,deadline, courseId, groupId, lessonId, lessonName, topicId) {
          var _eventId, _dateFrom, _dateTo,_deadline, _arguments;
          var _completions, _courseId, _groupId, _lessonId, _lessonName, _topicId, _arguments;

          var eventId = 2;
          _eventId = eventId ? eventId : null;
          // _dateFrom = dateFrom ? dateFrom : null;
          // _dateTo = dateTo ? dateTo : null;
          // _arguments = [_eventId, _dateFrom, _dateTo];
            console.log(completions);
          _deadline = deadline ? deadline : null;
          console.log(deadline);
          _completions = completions ? completions : null;
          _courseId = courseId ? courseId : null;
          _groupId = groupId ? groupId : null;
          _lessonId = lessonId ? lessonId : null;
          _lessonName = lessonName ? lessonName : null;
          _topicId = topicId ? topicId : null;
          _arguments = [_eventId, _dateFrom, _dateTo, _completions, _courseId, _groupId, _lessonId, _lessonName, _topicId];


          $mdDialog
              .show({
                  controller: 'DayEventDeadlineCtrl',
                  templateUrl: lmsConfig.modulesPath + 'organizer/views/_showDayDeadline.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose: true,
                  escapeToClose: true,
                  locals: {
                      eventId: _eventId,
                      dateFrom: _dateFrom,
                      dateTo: _dateTo,
                      completions: _completions,
                      courseId: _courseId,
                      groupId: _groupId,
                      lessonId: _lessonId,
                      lessonName: _lessonName,
                      topicId: _topicId,
                      deadline: _deadline
                  }
              })
              .then(function(answer) {});
      }

      function isTimestamp(date) {
      return angular.isNumber(date) && isFinite(date) && date % 1 === 0 && date > 0;
    }

    function saveEvent(event) {
      if (event && event.name && event.startTime && event.endTime) {
        var _saveEventCallback = function() {
          $rootScope.$broadcast('eventUpdated');
        };
        return event.id
          ? UserEventsResource.update(null, event, _saveEventCallback).$promise
          : UserEventsResource.create(null, event, _saveEventCallback).$promise;
      }
    }

    function deleteEvent(eventId) {
      if (eventId !== void 0) {
        return UserEventsResource.delete({ id: eventId }, function() {
          $rootScope.$broadcast('eventDeleted');
        }).$promise;
      }
    }
  }
]);

'use strict';

app.config(['$stateProvider', 'lmsConfig', function ($stateProvider, lmsConfig) {
	$stateProvider
        .state('organizer', {
            parent: 'dashboard',
            url: "organizer",
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "organizer/views/_organizerBar.html",
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "organizer/views/organizer.html",
                    controller: 'OrganizerCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Органайзер'
            }
        });
    }]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.SkillProfileCtrl
 * @description
 * # SkillProfileCtrl
 * Controller of the lmsClientApp
 */
app.controller('SkillProfileCtrl', [
    '$scope',
    'Users',
    'SkillProfile',
    '$sce',
    function ($scope, Users, SkillProfile, $sce) {
        var skillfolioTestUrl = 'http://kb.skillfolio.ru';
        $scope.skillfolioTestUrl = null;
        // ----------
        var skillfolioResultsUrl = 'https://skillfolio.ru/9';
        $scope.skillfolioResultsUrl = null;
        // ----------
        // Выходное тестирование
        var skillfolioOutputTestUrl = 'http://kb-out.skillfolio.ru';
        $scope.skillfolioOutputTestUrl = null;
        // ----------
        var skillfolioOutputResultsUrl = 'http://kb-out.skillfolio.ru';
        $scope.skillfolioOutputResultsUrl = null;
        // ----------
        $scope.loaded = false;
        init();
        // Methods
        function getLocationOrigin() {
            if (!window.location.origin) {
                window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }
            var locationOrigin = window.location.origin; // asi-futurestaff.mob-edu.ru
            return locationOrigin;
        }

        function getToken() {
            try {
                var lsToken = localStorage.getItem('ls.token');
                var token = JSON.parse(lsToken).token;
                return token;
            } catch (error) {
                console.log('Error', error.message);
                return '';
            }
        }

        function getCreateUrl(obg) {
            var url = obg.skillfolioUrl + '?userId=' + obg.userId +
                '&use_xhr_req=true' +
                '&token=' + 'LMS_AUTH@' + obg.token +
                '&cb=' + obg.locationOrigin + '%2Fapi%2Fskillfolio%2Fcreate' +
                '&clear_cache=all';
            return url;
        }

        function getCreateOutUrl(obg) {
            var url = obg.skillfolioUrl + '?userId=' + obg.userId +
                '&use_xhr_req=true' +
                '&token=' + 'LMS_AUTH@' + obg.token +
                '&cb=' + obg.locationOrigin + '%2Fapi%2Fskillfolio%2Fcreate-out' +
                '&clear_cache=all';
            return url;
        }

        function init() {
            Users.getProfile().$promise.then(function (user) {
                $scope.user = user;

                SkillProfile.getUserResults(
                    user.id
                ).then(function (skillProfile) {
                    $scope.loaded = true;
                    // console.log('skillProfile', skillProfile);
                    var type0 = skillProfile.type0;
                    var type1 = skillProfile.type1;
                    // --------
                    var token = getToken();
                    // ----
                    var userId = $scope.user.id;
                    // ----
                    var locationOrigin = getLocationOrigin(); // asi-futurestaff.mob-edu.ru
                    // --------

                    if (!type0 && !type1) {
                        $scope.skillfolioTestUrl = getCreateUrl({
                            skillfolioUrl: skillfolioTestUrl,
                            userId: userId,
                            token: token,
                            locationOrigin: locationOrigin
                        });
                    }

                    if (type0 && !type1) {
                        $scope.skillfolioResultsUrl = getCreateUrl({
                            skillfolioUrl: skillfolioTestUrl,
                            userId: userId,
                            token: token,
                            locationOrigin: locationOrigin
                        });
                        // -----
                        $scope.skillfolioOutputTestUrl = getCreateOutUrl({
                            skillfolioUrl: skillfolioOutputTestUrl,
                            userId: userId,
                            token: token,
                            locationOrigin: locationOrigin
                        });
                    }

                    if (type0 && type1) {
                        $scope.skillfolioResultsUrl = getCreateUrl({
                            skillfolioUrl: skillfolioTestUrl,
                            userId: userId,
                            token: token,
                            locationOrigin: locationOrigin
                        });
                        // -----
                        $scope.skillfolioOutputResultsUrl = getCreateOutUrl({
                            skillfolioUrl: skillfolioOutputTestUrl,
                            userId: userId,
                            token: token,
                            locationOrigin: locationOrigin
                        });
                    }
                });
            });
        }
    }
]);

// // приходим масив
// ищем стипом 0 максимальную дату
// если есть на кнопке слева показать результар
// и показыве выходная диагностика


// ищем с типом 
'use strict';

app.config([
    '$stateProvider',
    'lmsConfig',
    function($stateProvider, lmsConfig) {
        $stateProvider.state('skillProfile', {
            parent: 'dashboard',
            url: 'skillProfile',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath +
                        'skillProfile/views/skillProfileBar.html'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath +
                        'skillProfile/views/skillProfile.html',
                    controller: 'SkillProfileCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Профиль навыков'
            }
        });
    }
]);

'use strict';

angular.module('lmsClientApp').service('SkillProfile', [
    '$q',
    'SkillProfileResource',
    function ($q, SkillProfileResource) {
        // Variables
        var self = this;

        // Public Methods
        self.getUserResults = getUserResults;

        function getListByType(list, typeNum) {
            var newList = list.filter(function (item) {
                if (item.type === typeNum) {
                    return true;
                }
                return false;
            });
            return newList;
        }

        function selectByMaxDate(list) {
            var rezultItem = null;
            var maxCreationDate = 0;
            list.forEach(function (item) {
                if (item.creationDate > maxCreationDate) {
                    rezultItem = item;
                }
            });
            return rezultItem;
        }

        function getUserResults(userId) {
            var d = $q.defer();

            SkillProfileResource.query({
                id: userId
            }, function (testResults) {
                // 0: { id: 6797900, userId: 82229, creationDate: 1570449247289, type: 0 }
                // 1: { id: 6797901, userId: 82229, creationDate: 1580554037289, type: 0 }
                // 2: { id: 6797902, userId: 82229, creationDate: 1580887932689, type: 0 }
                // 3: { id: 6797903, userId: 82229, creationDate: 1581084072189, type: 0 }
                // 4: { id: 6797904, userId: 82229, creationDate: 1581490636789, type: 1 }
                // 5: { id: 6797905, userId: 82229, creationDate: 1581764497389, type: 1 }
                var list = testResults;
                // Фильтруем по типу
                var type0List = getListByType(list, 0);
                // Выбираем максимальную дату
                var type0 = selectByMaxDate(type0List);
                // -----
                var type1List = getListByType(list, 1);
                var type1 = selectByMaxDate(type1List);
                // -----
                d.resolve({
                    type0: type0,
                    type1: type1,
                });
            });
            return d.promise;
        }
    }
]);

'use strict';

angular
    .module('lmsClientApp')
    .factory('SkillProfileResource', function($resource) {
        return $resource(
            '/api/skillfolio/',
            {},
            {
                query: {
                    method: 'GET',
                    url: '/api/skillfolio/user/:id',
                    isArray: true
                }
            }
        );
    });

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.DigitalPortfolioCtrl
 * @description
 * # DigitalPortfolioCtrl
 * Controller of the lmsClientApp
 */
app.controller('DigitalPortfolioCtrl', [
    '$scope',
    'Users',
    '$sce',
    'Upload',
    'lmsConfig',
    'LmsUtils',
    '$http',
    function ($scope, Users, $sce, Upload, lmsConfig, LmsUtils, $http) {
        // Variables
        $scope.uploadDigitalPortfolioFile = uploadDigitalPortfolioFile;
        $scope.uploadDigitalPortfolioCancel = uploadDigitalPortfolioCancel;
        $scope.uploadDigitalPortfolioFire = uploadDigitalPortfolioFire;

        $scope.deleteProfileDocument = deleteProfileDocument;

        $scope.uploadDigitalInternshipFile = uploadDigitalInternshipFile;
        $scope.uploadDigitalInternshipFileCancel = uploadDigitalInternshipFileCancel;
        $scope.uploadDigitalInternshipFileFire = uploadDigitalInternshipFileFire;

        $scope.documentsPORTFOLIO = [];
        $scope.documentsINTERNSHIP = [];
        $scope.documentsCERT = [];

        $scope.digitalPortfolioUrl = '/api/account/digitalPortfolio';
        $scope.digitalInternshipUrl = '/api/account/digitalInternship';

        var now = new Date();
        $scope.digitalPortfolioFileSelected = {
            file: null,
            name: ''
        };

        $scope.internshipFileSelected = {
            file: null,
            name: '',
            date: now
        };

        init();
        // Methods
        function init() {
            Users.getProfile().$promise.then(function (user) {
                // console.log('user', user);
                if (user) {
                    if (user.documents) {
                        var documentsINTERNSHIP = [];
                        var documentsPORTFOLIO = [];
                        var documentsCERT = [];
                        user.documents.forEach(function (document) {
                            var obg = getNameAndUri(document.path);
                            var time = getFileTime(document.date);
                            var item = {
                                id: document.id,
                                uri: obg.uri,
                                fileName: obg.fileName,
                                time: time,
                                name: document.name || obg.fileName
                            };
                            if (document.type === 'PORTFOLIO') {
                                documentsPORTFOLIO.push(item);
                            }
                            if (document.type === 'INTERNSHIP') {
                                documentsINTERNSHIP.push(item);
                            }
                            if (document.type === 'CERT') {
                                documentsCERT.push(item);
                            }
                        });
                        $scope.documentsINTERNSHIP = documentsINTERNSHIP;
                        $scope.documentsPORTFOLIO = documentsPORTFOLIO;
                        $scope.documentsCERT = documentsCERT;
                        // console.log('$scope.documentsINTERNSHIP', $scope.documentsINTERNSHIP);
                        // console.log('$scope.documentsPORTFOLIO', $scope.documentsPORTFOLIO);
                        // console.log('$scope.documentsCERT', $scope.documentsCERT);
                    }
                }
                $scope.user = user;
            });
        }

        /**
         * 
         * @param {*} timestamp 
         * return '02.12.2019 14:33';
         */
        function getFileTime(timestamp) {
            try {
                var date = new Date(timestamp);
                var day = "0" + date.getDate();
                var month = "0" + (1 + date.getMonth());
                var fullYear = date.getFullYear();
                // ----------
                var hours = "0" + date.getHours();
                var minutes = "0" + date.getMinutes();
                var formattedTime = day.substr(-2) + '.' + month.substr(-2) + '.' + fullYear + ' ' + hours.substr(-2) + ':' + minutes.substr(-2);
                return formattedTime;
            } catch (error) {
                return '';
            }
        }

        /**
         * path: /srv/lms/upload/files/000/079/925/fcbdeb295094eee798d7e969c226c934/p.teacher-portfolio-3991c26f-a470-4b02-b05a-da4eb744889c.docx
         */
        function getNameAndUri(path) {
            try {
                var arr = path.split('/');
                var uri = path.replace('/srv/lms', '');
                var fileName = arr[arr.length - 1];
                var data = {
                    uri: uri,
                    fileName: fileName
                }
                // console.log('data', data);
                return data;
            } catch (error) {
                return {
                    uri: '',
                    fileName: ''
                };
            }
        }

        function deleteProfileDocument(id) {
            if (confirm('Вы действительно ходите удалить данный файл? УДАЛИТЬ/ОТМЕНА')) {
                Users.deleteProfileDocument({
                    id: id
                }).$promise.then(function () {
                    LmsUtils.showSimpleToast('Файл успешно удалён');
                    init();
                }).catch(function (error) {
                    LmsUtils.showSimpleToast('Не удалось удалить файл');
                });
            }
        }

        function uploadDigitalPortfolioFile(file) {
            if (!file) {
                return;
            }
            $scope.digitalPortfolioFileSelected.file = file;
        }

        function uploadDigitalPortfolioCancel() {
            $scope.digitalPortfolioFileSelected.file = null;
            $scope.digitalPortfolioFileSelected.name = '';
        }

        function uploadDigitalPortfolioFire() {
            var digitalPortfolioData = $scope.digitalPortfolioFileSelected;

            var formData = new FormData();
            formData.append("file", digitalPortfolioData.file);
            formData.append("name", digitalPortfolioData.name);

            var url = lmsConfig.apiUrl + '/account/digitalPortfolio';

            var request = {
                method: 'POST',
                url: url,
                data: formData,
                headers: {
                    'Content-Type': undefined
                }
            };

            $http(request).success(function (d) {
                LmsUtils.showSimpleToast('Файл успешно загружен');
                init();
                $scope.digitalPortfolioFileSelected.file = null;
                $scope.digitalPortfolioFileSelected.name = '';
            }).error(function (data, status, headers, config) {
                if (headers('failure') === 'Portfolio should be in docx extension') {
                    LmsUtils.showSimpleToast(
                        'Загружаемый файл должен быть в формате .docx'
                    );
                } else {
                    LmsUtils.showSimpleToast(
                        'Ошибка при загрузке файла'
                    );
                }
            });
        }

        function uploadDigitalInternshipFile(file) {
            if (!file) {
                return;
            }
            $scope.internshipFileSelected.file = file;
        }

        function uploadDigitalInternshipFileCancel() {
            $scope.internshipFileSelected.file = null;
            $scope.internshipFileSelected.name = '';
        }

        function uploadDigitalInternshipFileFire() {
            var internshipData = $scope.internshipFileSelected;

            var formData = new FormData();
            formData.append("file", internshipData.file);
            formData.append("name", internshipData.name);
            var data = new Date(internshipData.date).getTime();
            formData.append("date", data);

            var url = lmsConfig.apiUrl + '/account/digitalInternship';

            var request = {
                method: 'POST',
                url: url,
                data: formData,
                headers: {
                    'Content-Type': undefined
                }
            };

            $http(request).success(function () {
                LmsUtils.showSimpleToast('Файл успешно загружен');
                init();
                $scope.internshipFileSelected.file = null;
                $scope.internshipFileSelected.name = '';
            }).error(function (data, status, headers, config) {
                if (headers('failure') === 'Portfolio should be in docx extension') {
                    LmsUtils.showSimpleToast(
                        'Загружаемый файл должен быть в формате .docx'
                    );
                } else {
                    LmsUtils.showSimpleToast(
                        'Ошибка при загрузке файла'
                    );
                }
            });
        }
    }
]);

'use strict';

app.service('StemfordCertificate', function ($q) {
    var self = this;

    function preloadPdfImg() {
        return $q(function (resolve, reject) {
            var logo_url = "/images/certificate.png";
            var img = new Image();
            img.src = logo_url;
            img.onload = function () {
                resolve(img);
            };
        });
    }

    var promCertificateImg = preloadPdfImg();

    self.createPdf = function () {
        promCertificateImg.then(function (img) {
            var doc = new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: 'a4', // 210×297 mm
                putOnlyUsedFonts: true
            })
            doc.addImage(img, 'PNG', 0, 0, 210, 297);
            // ------------
            var user = $auth.user;
            var course = scope.course;
            // console.log({ user, course });
            // ------------
            var cert_id = 123456; // TODO:
            var user_f = user.lastName;
            var user_i_o = user.middleName ? user.firstName + ' ' + user.middleName : user.firstName;
            var program_name = course.name;
            var time_count = 16; // TODO:
            var certificate_data = '01.04.2020'; // TODO:
            // ------------
            doc.setFont("OpenSans-Bold");
            doc.setFontSize(10);
            doc.text('CERT ID:' + cert_id, 105, 91.4, {
                align: 'center',
                maxWidth: 210
            });
            // ------------ 
            doc.setFont("OpenSans-Regular");
            doc.setFontSize(10);
            doc.text('Настоящий сертификат подтверждает, что', 105, 111, {
                align: 'center',
                maxWidth: 210
            });
            // ------------
            doc.setFont("OpenSans-Bold");
            doc.setFontSize(35);
            doc.text(user_f, 105, 130, {
                align: 'center',
                maxWidth: 210
            });
            // ------------
            doc.setFont("OpenSans-Bold");
            doc.setFontSize(35);
            doc.text(user_i_o, 105, 144.3, {
                align: 'center',
                maxWidth: 210
            });
            // ------------
            doc.setFont("OpenSans-Regular");
            doc.setFontSize(10);
            doc.text('Успешно прошёл (прошла) обучение по программе', 105, 157, {
                align: 'center',
                maxWidth: 210
            });
            // ------------
            doc.setFont("OpenSans-Bold");
            doc.setFontSize(10);
            doc.text(program_name, 105, 166.6, {
                align: 'center',
                maxWidth: 144
            });
            // ------------
            doc.setFont("OpenSans-Regular");
            doc.setFontSize(10);
            doc.text('Кол-во часов: ' + time_count, 105, 192.4, {
                align: 'center',
                maxWidth: 210
            });
            // ------------
            doc.setFont("OpenSans-Bold");
            doc.setFontSize(8);
            doc.text('Генеральный директор', 35, 221.5, {
                align: 'left'
            });
            // ------------
            doc.setFont("OpenSans-Regular");
            doc.setFontSize(8);
            doc.text('ООО «Мобильное Электронное Образование»', 35, 225.9, {
                align: 'left'
            });
            // ------------
            doc.setFont("OpenSans-Regular");
            doc.setFontSize(10);
            doc.text('Дата: ' + certificate_data, 35, 238.1, {
                align: 'left'
            });
            // ------------

            doc.save('certificate.pdf');
        });
    };
});

'use strict';

app.config([
    '$stateProvider',
    'lmsConfig',
    function($stateProvider, lmsConfig) {
        $stateProvider.state('digitalPortfolio', {
            parent: 'dashboard',
            url: 'digitalPortfolio',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath +
                        'digitalPortfolio/views/digitalPortfolioBar.html'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath +
                        'digitalPortfolio/views/digitalPortfolio.html',
                    controller: 'DigitalPortfolioCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Цифровое портфолио'
            }
        });
    }
]);

'use strict';

app.controller('DistanceEducationCoordinatorJournalDashBarCtrl', ['$scope', '$state', 'SchoolResource', 'userAccount', 'Breadcrumbs', function ($scope, $state, SchoolResource, userAccount, Breadcrumbs) {
    var bcsParents;
        if (userAccount.userRoles) {
            init(userAccount.userRoles[0]);
          } else {
            var unbindAuthWatcher = $scope.$watch(function () {
              return userAccount.userRoles;
            }, function (currentRole) {
              if (currentRole) {
                unbindAuthWatcher();
                init(currentRole[0]);
              }
            });
          }


    function init(currentRole) {

    $scope.schools = [];
    $scope.selectedSchool = null;
    $scope.entity = $state.current.data.entity;

    bcsParents = Breadcrumbs.getParents(currentRole, $scope.entity.state);
    $scope.territoryParent = bcsParents.territoryParent;
    $scope.schoolParent = bcsParents.schoolParent;

    Breadcrumbs.getNames(currentRole, $scope.entity.title, {
        school: $state.params.schoolId,
        territory: $state.params.territoryId,
        region: $state.params.regionId
    }).then(function (result) {
        $scope.regionName = result.regionName;
        $scope.territoryName = result.territoryName;
        $scope.schoolName = result.schoolName;
    });

    $scope.goToSchool = function () {
        $state.go('schoolJournal', {
            schoolId: $scope.selectedSchool.id
        });
    };

    SchoolResource.getByCoordinator(function (result) {
        $scope.schools = result;
        $scope.schools.forEach(function (school) {
            if (school.id == $state.params.schoolId) {
                $scope.selectedSchool = school;
            }
        });
    });
}
}]);

'use strict';

app.controller('RegionalCoordinatorJournalDashBarCtrl', ['$scope', '$auth', '$state', '$stateParams', 'RegionResource', function ($scope, $auth, $state, $stateParams, RegionResource) {
    var unbindAuthWatcher;

    $scope.regions = [];
    $scope.selectedRegion = null;
    $scope.entity = $state.current.data.entity;

    //для хлебных крошек
    $scope.regionName = $scope.entity.title;

    $scope.goToRegion = function () {
        $state.go('region' + $scope.entity.state, {
            regionId: $scope.selectedRegion.id
        });
    };

    unbindAuthWatcher = $scope.$watch(function () {
        return $auth.user.id;
    }, function (id) {
        if (id) {
            RegionResource.getRegionsByCoordinator(function (result) {
                $scope.regions = result;
                $scope.regions.forEach(function (region) {
                    if (region.id == $stateParams.regionId) {
                        $scope.selectedRegion = region;
                    }
                });
            });
            unbindAuthWatcher();
        }
    });
}]);

'use strict';

app.controller('StudentJournalCourseDetailsDashBarCtrl', ['$scope', '$auth', '$state', 'Account', 'UserGroupResource', 'Breadcrumbs', '$stateParams',
  function ($scope, $auth, $state, Account, UserGroupResource, Breadcrumbs, $stateParams) {

    Account.getAccount().then(function(userAccount) {

      $scope.selectedStudent = null;
      $scope.students = [];
      $scope.entity = $state.current.data.entity;

      var currentRole = userAccount.userRoles[0],
      isStudentOrParent = (currentRole === 'ROLE_STUDENT' || currentRole === 'ROLE_PARENT'),
      bcsParents;

      bcsParents = Breadcrumbs.getParents(currentRole, $scope.entity.state);
      $scope.territoryParent = bcsParents.territoryParent;
      $scope.schoolParent = bcsParents.schoolParent;
      $scope.userGroupParent = bcsParents.userGroupParent;
      $scope.courseParent = bcsParents.courseParent;
      $scope.studentParent = bcsParents.studentParent;
      $scope.detailsParent = bcsParents.detailsParent;

      Breadcrumbs.getNames(currentRole, $scope.entity.title, {
          users: $state.params.studentId,
          course: $state.params.courseId,
          group: $state.params.groupId,
          school: $state.params.schoolId,
          territory: $state.params.territoryId,
          region: $state.params.regionId
      }).then(function (result) {
          $scope.regionName = result.regionName;
          $scope.territoryName = result.territoryName;
          $scope.schoolName = result.schoolName;
          $scope.userGroupName = result.userGroupName;
          $scope.courseName = result.courseName;
          $scope.studentName = result.studentName;
      });

      $scope.goToStudent = function () {
        if ('JournalRoles1' === $stateParams.provider) {
          $state.go('JournalRoles1/schoolJournal/student', {
            studentId: $scope.selectedStudent.id
          });
          return;
        }

        if (isStudentOrParent) {
          $state.go('details' + $scope.entity.state, {
            studentId: $scope.selectedStudent.id
          });
        } else {
          if ('detailsJournalTeacher' === $state.current.name) {
            $state.go('detailsJournalTeacher', {
              studentId: $scope.selectedStudent.id
            });
          }
        }
      };

      if (!isStudentOrParent) {
          UserGroupResource.get({
              id: $state.params.groupId
          }, function (result) {
              $scope.students = result.users.filter(function (user) {
                return user.status === 'ACTIVE';
              });
              $scope.students.forEach(function (student) {
                  if (student.id == $state.params.studentId) {
                      $scope.selectedStudent = student;
                      $auth.user.relatedStudentId = $scope.selectedStudent.id;
                  }
              });
          });
      }
    });
}]);

'use strict';

app.controller('StudentJournalDashBarCtrl', ['$scope', '$state',
  'UserGroupResource',
  'userAccount', 'Breadcrumbs', '$stateParams', '$rootScope',
  function ($scope, $state,
    UserGroupResource,
    userAccount, Breadcrumbs, $stateParams, $rootScope) {

    if (userAccount.userRoles) {
      init(userAccount.userRoles[0]);
    } else {
      var unbindAuthWatcher = $scope.$watch(function () {
        return userAccount.userRoles;
      }, function (currentRole) {
        if (currentRole) {
          unbindAuthWatcher();
          init(currentRole[0]);
        }
      });
    }

    function init(currentRole) {
      var isStudentOrParent = (currentRole === 'ROLE_STUDENT' || currentRole === 'ROLE_PARENT');
      var bcsParents;

      $scope.students = [];
      $scope.selectedStudent = null;
      $scope.entity = $state.current.data.entity;

      bcsParents = Breadcrumbs.getParents(currentRole, $scope.entity.state);
      $scope.territoryParent = bcsParents.territoryParent;
      $scope.schoolParent = bcsParents.schoolParent;
      $scope.userGroupParent = bcsParents.userGroupParent;
      $scope.studentParent = bcsParents.studentParent;
      Breadcrumbs.getNames(currentRole, $scope.entity.title, {
        users: $state.params.studentId,
        group: $state.params.groupId,
        school: $state.params.schoolId,
        territory: $state.params.territoryId,
        region: $state.params.regionId
      }).then(function (result) {
        $scope.regionName = result.regionName;
        $scope.territoryName = result.territoryName;
        $scope.schoolName = result.schoolName;
        $scope.userGroupName = result.userGroupName;
        $scope.studentName = result.studentName;
      });

      $scope.goToStudent = function () {
        if ('JournalRoles1' === $stateParams.provider) {
          $state.go('JournalRoles1/schoolJournal/student', {
            studentId: $scope.selectedStudent.id
          });
          return;
        }
        if (!isStudentOrParent) {
          $state.go('student' + $scope.entity.state, {
            studentId: $scope.selectedStudent.id
          });
        }
      };

      if (!isStudentOrParent) {
        UserGroupResource.get({
          id: $state.params.groupId
        }, function (result) {
          $scope.students = result.users.filter(function (user) {
              return user.status === 'ACTIVE';
          });
          $scope.students.forEach(function (student) {
            if (student.id == $state.params.studentId) {
              $scope.selectedStudent = student;
            }
          });
        });
      }
    }
  }]);

'use strict';

app.controller('TeacherJournalCourseSectionDashBarCtrl', [
    '$scope', '$state', 'Course', 'TopicResource', 'CourseSectionResource', 'UserGroupResource', 'userAccount', 'Breadcrumbs', 'CourseService', '$stateParams',
    function ($scope, $state, Course, TopicResource, CourseSectionResource, UserGroupResource, userAccount, Breadcrumbs, CourseService, $stateParams) {

        $scope.$watch(function () {
            return userAccount.userRoles;
        }, function (currentRole) {
            if (currentRole) {
                init(currentRole[0]);
            }
        });

        function init(currentRole) {
            var isTutor = (currentRole === 'ROLE_TUTOR');
            var isTeacher = (currentRole === 'ROLE_TEACHER');
            var bcsParents;

            $scope.userGroups = [];
            $scope.courses = [];
            $scope.selectedUserGroup = null;
            $scope.selectedCourse = null;
            $scope.entity = $state.current.data.entity;
            $scope.topics;
            $scope.topic;
            $scope.courseId = $state.params.courseId;
            $scope.groupId = $state.params.groupId;
            $scope.studyYear = $state.params.studyYear;
            // console.log({
            //     studyYear1: $scope.studyYear
            // });

            bcsParents = Breadcrumbs.getParents(currentRole, $scope.entity.state);
            $scope.territoryParent = bcsParents.territoryParent;
            $scope.schoolParent = bcsParents.schoolParent;
            $scope.userGroupParent = bcsParents.userGroupParent;
            $scope.courseParent = bcsParents.courseParent;

            Breadcrumbs.getNames(currentRole, $scope.entity.title, {
                course: $state.params.courseId,
                group: $state.params.groupId,
                school: $state.params.schoolId,
                territory: $state.params.territoryId,
                region: $state.params.regionId
            }).then(function (result) {
                $scope.regionName = result.regionName;
                $scope.territoryName = result.territoryName;
                $scope.schoolName = result.schoolName;
                $scope.userGroupName = result.userGroupName;
                $scope.courseName = result.courseName;
            });

            if (isTeacher) {
                CourseSectionResource.getAllByTeacherId({
                    id: userAccount.id,
                    studyYear: $scope.studyYear
                }, function (result) {
                    fillUserGroupsFromCourseSection(result);
                });
            } else if (isTutor) {
                UserGroupResource.getAllForTutor({
                    tutorId: userAccount.id
                }, function (result) {
                    fillUserGroups(result);
                });
                fillCourses();
            } else {
                UserGroupResource.getAllBySchoolForCoordinator({
                    schoolId: $state.params.schoolId
                }, function (result) {
                    fillUserGroups(result);
                });
                fillCourses();
            }

            getTopics();

            $scope.changeState = function (entity) {
                var lessonId;
                if (!entity.folder) {
                    lessonId = entity.id;
                    CourseService.store('lessonId', lessonId);
                } else {
                    var lessons = entity.lessons;
                    sortLessons(lessons);
                    $scope.lessons = lessons;
                    $scope.lesson = lessons[0];
                    lessonId = lessons[0].id;
                    CourseService.store('lessonId', lessonId);
                }
            };
            $scope.changeUserGroup = function () {
                if ('JournalRoles1' === $stateParams.provider) {
                    $state.go('JournalRoles1/schoolJournal', {
                        groupId: $scope.selectedUserGroup.id
                    });
                    return;
                }

                if (isTeacher) {
                    $state.go('courseSection' + $scope.entity.state, {
                        groupId: $scope.selectedUserGroup.id
                    });
                } else {
                    $state.go('userGroup' + $scope.entity.state, {
                        groupId: $scope.selectedUserGroup.id,
                        schoolId: $state.params.schoolId,
                        territoryId: $state.params.territoryId,
                        regionId: $state.params.regionId
                    });
                }
            };

            $scope.changeCourse = function () {
                if ('JournalRoles1' === $stateParams.provider) {
                    $state.go('JournalRoles1/schoolJournal/courseSection', {
                        courseId: $scope.selectedCourse.id
                    });
                    return;
                }

                if (!isTeacher) {
                    $state.go('courseSection' + $scope.entity.state, {
                        courseId: $scope.selectedCourse.id
                    });
                }
            };

            $scope.courseSectionJournalAll = function (data) {
                if ('JournalRoles1' === $stateParams.provider) {
                    var courseId = data.courseId;
                    var groupId = data.groupId;
                    $state.go('JournalRoles1/schoolJournal/courseSection/all', {
                        courseId: courseId,
                        groupId: groupId
                    });
                    return;
                }
                $state.go('courseSectionJournalAll', data);
            };

            $scope.courseSectionJournalAllBack = function (data) {
                if ('JournalRoles1' === $stateParams.provider) {
                    var courseId = data.courseId;
                    var groupId = data.groupId;
                    $state.go('JournalRoles1/schoolJournal/courseSection', {
                        courseId: courseId,
                        groupId: groupId
                    });
                    return;
                }
                $state.go('courseSectionJournal', data);
            };

            $scope.showAll = function () {
                $state.go('courseSectionAll')
            }
        }

        function getTopics() {
            TopicResource.getAllTopicsByCourseId({ 'courseId': $state.params.courseId }, function (res) {
                var topics = res;
                sortTopics(topics);
                $scope.topics = topics;
                $scope.topic = $scope.topics[0];
                var lessons = $scope.topic.lessons;
                sortLessons(lessons);
                $scope.lessons = lessons;
                $scope.lesson = $scope.lessons[0];
                CourseService.store('lessonId', $scope.lesson.id);
            })
        }

        function sortTopics(topics) {
            topics.sort(function (a, b) {
                if (a.number < b.number) {
                    return -1;
                }
                return 1;
            });
        }

        function sortLessons(lessons) {
            lessons.sort(function (a, b) {
                if (a.number < b.number) {
                    return -1;
                }
                return 1;
            });
        }

        function fillUserGroups(userGroups) {
            $scope.userGroups = userGroups;
            $scope.userGroups.forEach(function (group) {
                if (group.id == $state.params.groupId) {
                    $scope.selectedUserGroup = group;
                }
            });
        }

        function fillUserGroupsFromCourseSection(courseSections) {
            $scope.userGroups = [];
            courseSections.forEach(function (courseSection) {
                if (courseSection.course.id == $state.params.courseId) {
                    $scope.selectedCourse = courseSection.course;
                    $scope.userGroups.push(courseSection.userGroup);
                    if (courseSection.userGroup.id == $state.params.groupId) {
                        $scope.selectedUserGroup = courseSection.userGroup;
                    }
                }
            });
        }

        function fillCourses() {
            UserGroupResource.getCourses({
                id: $state.params.groupId
            }, function (result) {
                $scope.courses = result;
                $scope.courses.forEach(function (course) {
                    if (course.id == $state.params.courseId) {
                        $scope.selectedCourse = course;
                    }
                });
            });
        }
    }]);

'use strict';

app.controller('TerritoryCoordinatorJournalDashBarCtrl', ['$scope', '$state', 'TerritoryResource', 'userAccount', function ($scope, $state, TerritoryResource, userAccount) {
    var currentRole = userAccount.userRoles[0],
        isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR' || currentRole === 'ROLE_LOCATION_COORDINATOR'),
        isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
        empty;

    $scope.territories = [];
    $scope.selectedTerritory = null;
    $scope.entity = $state.current.data.entity;

    //для хлебных крошек
    $scope.territoryName = null;
    if (isRegionalCoordinator) {
        $scope.regionName = $scope.entity.title;
        $scope.territoryParent = 'region' + $scope.entity.state;
    } else if (isTerritoryCoordinator) {
        $scope.territoryName = $scope.entity.title;
        $scope.territoryParent = 'dashboard';
    }

    $scope.goToTerritory = function () {
        $state.go('territory' + $scope.entity.state, {
            territoryId: $scope.selectedTerritory.id
        });
    };

    empty = ($scope.entity.state === 'Statistics' ? 'true' : 'false');
    TerritoryResource.getAllByCoordinator({empty: empty}, function (result) {
        $scope.territories = result;
        $scope.territories.forEach(function (territory) {
            if (territory.id == $state.params.territoryId) {
                $scope.selectedTerritory = territory;
                if (isRegionalCoordinator) {
                    $scope.territoryName = $scope.selectedTerritory.name;
                }
            }
        });
    });
}]);

'use strict';

app.controller('TutorJournalUserGroupDashBarCtrl', [
    '$scope',
    '$state',
    'UserGroupResource',
    '$auth',
    'Breadcrumbs',
    '$stateParams',
    'TutorService',

    function ($scope, $state, UserGroupResource, $auth, Breadcrumbs, $stateParams, TutorService) {

    var userAccount;
    var groupId;
    var currentRole;
    var isTutor;
    var bcsParents;
    
    var unbindAuthWatcher = $scope.$watch(function () {
        return $auth.user.userRoles;
    }, function (userRoles) {
        if (userRoles) {
            userAccount = $auth.user;
            init();
            unbindAuthWatcher();
        }
    });


    $scope.courses = [];
    $scope.userGroups = [];
    $scope.selectedCourse = null;
    $scope.selectedUserGroup = null;
    $scope.entity = $state.current.data.entity;



    function init() {
        groupId = $state.params.groupId;
        currentRole = userAccount.userRoles[0];
        isTutor = (currentRole === 'ROLE_TUTOR');

        bcsParents = Breadcrumbs.getParents(currentRole, $scope.entity.state);
        $scope.territoryParent = bcsParents.territoryParent;
        $scope.schoolParent = bcsParents.schoolParent;
        $scope.userGroupParent = bcsParents.userGroupParent;

        Breadcrumbs.getNames(currentRole, $scope.entity.title, {
            group: groupId,
            school: $state.params.schoolId,
            territory: $state.params.territoryId,
            region: $state.params.regionId
        }).then(function (result) {
            $scope.regionName = result.regionName;
            $scope.territoryName = result.territoryName;
            $scope.schoolName = result.schoolName;
            $scope.userGroupName = result.userGroupName;
        });
    
        UserGroupResource.getCourses({
            id: groupId
        }, function (result) {
            $scope.courses = result;
        });
    
        if (isTutor) {
            UserGroupResource.getAllForTutor({
                tutorId: userAccount.id,
                'year': TutorService.get()
            }, setUserGroups);
        } else {
            UserGroupResource.getAllBySchoolForCoordinator({
                schoolId: $state.params.schoolId,
                'year': TutorService.get()
            }, setUserGroups);
        }
    }

    $scope.goToCourseSection = function () {
      if ('JournalRoles1' === $stateParams.provider) {
        $state.go('JournalRoles1/schoolJournal/courseSection', {
          courseId: $scope.selectedCourse.id,
          groupId: groupId,
          schoolId: $state.params.schoolId,
          territoryId: $state.params.territoryId,
          regionId: $state.params.regionId
        });
        return;
      }
      if ($scope.selectedCourse) {
          $state.go('courseSection' + $scope.entity.state, {
              courseId: $scope.selectedCourse.id,
              groupId: groupId,
              schoolId: $state.params.schoolId,
              territoryId: $state.params.territoryId,
              regionId: $state.params.regionId
          });
      }
    };

    $scope.changeUserGroup = function () {
      if ('JournalRoles1' === $stateParams.provider) {
        $state.go('JournalRoles1/schoolJournal', {
            groupId: $scope.selectedUserGroup.id
        });
        return;
      }
      $state.go('userGroup' + $scope.entity.state, {
          groupId: $scope.selectedUserGroup.id
      });
    };

    function setUserGroups(result) {
        $scope.userGroups = result;
        $scope.userGroups.forEach(function (group) {
            if (group.id == groupId) {
                $scope.selectedUserGroup = group;
            }
        });
    }
}]);

'use strict';

app.controller('DistanceEducationCoordinatorJournalCtrl', [
    '$scope',
    '$state',
    'EducationalStructureResource',
    'Dialogs',
    '$stateParams',
    'usSpinnerService',
    'TutorService',

    function ($scope, $state, EducationalStructureResource, Dialogs, $stateParams, usSpinnerService, TutorService) {
        var initialYear = getCurrentYear();

        $scope.onYearChange = onYearChange;

        $scope.ncyBreadcrumbIgnore = true;
        $scope.schoolLevels = [];
        $scope.territoryId = $state.params.territoryId;
        $scope.regionId = $state.params.regionId;
        $scope.schoolId = $state.params.schoolId;


        $scope.goToUserGroupJournal = function(data) {
          if ('JournalRoles1' === $stateParams.provider) {
            $state.go('JournalRoles1/schoolJournal', data);
            return;
          }
          $state.go('userGroupJournal', data);
        }


        init();
        TutorService.set(initialYear);
        spinnerShow();

        EducationalStructureResource.getEducationalTreeBySchool({
            schoolId: $scope.schoolId,
            year: initialYear
        }).$promise.then(function (result) {
            spinnerHide();
            $scope.schoolLevels = result;
            $scope.schoolLevels.forEach(function (level) {
                level.countGroups = 0;
                level.parallels.forEach(function (parallel) {
                    level.countGroups += parallel.learningClasses.length;
                });
            });
        }, function (reason) {
            spinnerHide();
            $state.go('404');
        });



        function onYearChange(selectedYear) {
            spinnerShow();
            EducationalStructureResource.getEducationalTreeBySchool({
                schoolId: $scope.schoolId,
                year: selectedYear
            }).$promise.then(function (result) {
                spinnerHide();
                TutorService.set(selectedYear);
                $scope.schoolLevels = result;
                $scope.schoolLevels.forEach(function (level) {
                    level.countGroups = 0;
                    level.parallels.forEach(function (parallel) {
                        level.countGroups += parallel.learningClasses.length;
                    });
                });
            }, function (reason) {
                spinnerHide();
                $state.go('404');

            });
        }


        function init() {
            $scope.learningYears = getLearningYears();
            $scope.selectedYear = getCurrentYear();
        }

        function getLearningYears() {
            var yearNow = getCurrentYear();
            var years = [yearNow - 1, yearNow, yearNow + 1];

            return years;
        }

        function getCurrentYear() {
            var date = new Date();
            var fullYear = date.getFullYear();
            // ----
            var monthSeptember = 9;
            var monthCurrent = 1 + date.getMonth();
            // ----
            if (monthCurrent < monthSeptember) {
                fullYear = fullYear - 1;
            }
            return fullYear;
        }

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        function spinnerShow() {
           $scope.loaded = false;
            $scope.DistanceEducationCoordinatorJournalCtrlSpinnerShow = true;
            // usSpinnerService.spin('DistanceEducationCoordinatorJournalCtrlSpinner');
        }

        function spinnerHide() {
           $scope.loaded = true;
            $scope.DistanceEducationCoordinatorJournalCtrlSpinnerShow = false;
            // usSpinnerService.stop('DistanceEducationCoordinatorJournalCtrlSpinner');
        }
    }
]);

'use strict';

app.controller('RegionalCoordinatorJournalCtrl', ['$scope', '$state', 'EducationalStructureResource', 'Dialogs', function ($scope, $state, EducationalStructureResource, Dialogs) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.regionId = $state.params.regionId;
    $scope.territories = [];

    EducationalStructureResource.getTerritoriesByRegion({
        regionId: $scope.regionId
    }).$promise.then(function (result) {
        $scope.territories = result;
    }, function (reason) {
        $state.go('404');
    });

    $scope.openDialog = function (user) {
        Dialogs.createIndividualDialog(user);
    };
}]);

'use strict';

app.controller('StudentJournalCtrl', [
  '$scope',
  '$state',
  '$auth',
  'ProgressResource',
  'Course',
  'Dialogs',
  '$stateParams','usSpinnerService','$timeout',
  function($scope, $state, $auth, ProgressResource, Course, Dialogs, $stateParams,usSpinnerService,$timeout) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.courseSections = [];
      $scope.TeacherJournalCtrlSpinnerShow = true;
      $timeout(function () {
          usSpinnerService.spin('TeacherJournalCtrlSpinner');
      });
      // usSpinnerService.spin('TeacherJournalCtrlSpinner');

      $scope.editedData = []
      $scope.itemsForPrint = []
      $scope.subjectFilter = []
      $scope.chosenSubjectFilter = "Все предметы"
      $scope.isStudent = $auth.isInRole('ROLE_STUDENT')
      if ($scope.isStudent) {
          $scope.studentId = $auth.user.id
      }
      else {
        $scope.studentId = $state.params.studentId
      }


      $scope.useSubjectFilter = function () {
          // проверяем задействован ли второй фильтр
          if ($scope.chosenGradeFilter == "Все классы"){
              if ($scope.chosenSubjectFilter !== "Все предметы"){
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      console.log('titleS')
                      return  el.title == $scope.chosenSubjectFilter
                  })

              } else {
                  $scope.itemsForPrint = $scope.editedData
              }
          } else {
              if ($scope.chosenSubjectFilter !== "Все предметы") {
                  console.log($scope.editedData)
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      console.log(el)
                      return el.title == $scope.chosenSubjectFilter
                  }).filter(function (el) {
                      return el.parallel == $scope.chosenGradeFilter
                  })
              }  else {
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      return el.parallel == $scope.chosenGradeFilter
                  })
              }
          }


      }

      $scope.gradeFilter = []
      $scope.chosenGradeFilter = "Все классы"
      $scope.useGradeFilter = function () {
          // проверяем задействован ли второй фильтр
          if ($scope.chosenSubjectFilter == "Все предметы"){
              if ($scope.chosenGradeFilter !== "Все классы"){
                  console.log($scope.editedData)
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      return  el.parallel == $scope.chosenGradeFilter
                  })
              } else {
                  $scope.itemsForPrint = $scope.editedData
              }
          } else {
              if ($scope.chosenGradeFilter !== "Все классы"){
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      return  el.parallel == $scope.chosenGradeFilter
                  }).filter(function (el) {
                      return  el.title == $scope.chosenSubjectFilter
                  })
              } else {
                  $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                      return  el.title == $scope.chosenSubjectFilter
                  })
              }


          }


      }

      $scope.colors = [
          "#475677",
          "#faa026",
          "#b8312e",
          "#41a85f",
          "#662e91",
          "#8c6238",
          "#28314e",
          "#75706c"
      ]



    ProgressResource.getAllForStudent({
      studentId: $scope.studentId
    }).$promise.then(
      function(result) {
        $scope.courseSections = result;
          result.forEach(function (el,index) {
              console.log(el.teacher)
              var a
              if(el.teacher){
                  a = {
                      id: el.id,
                      title: el.title,
                      parallel: el.parallel,
                      topicMark: el.topicMark,
                      teacherName: el.teacher.lastName + " " +
                              el.teacher.firstName.charAt(0)+"."+ " " +
                              el.teacher.middleName.charAt(0)+".",
                      teacher: el.teacher,
                      stat: el.stat
                  }
                  console.log('aa')
              } else {
                  a = {
                      id: el.id,
                      title: el.title,
                      parallel: el.parallel,
                      topicMark: el.topicMark,
                      stat: el.stat
                  }
              }

              if(a){
                  if (index >= $scope.colors.length){
                      a.color  = $scope.colors[0]
                      // if(a.color){
                      //     a.color  = $scope.colors[0]
                      // }
                  } else {
                      a.color = $scope.colors[index]
                  }
              }


              // if (el.teacher.lastName){
              //     a.teacherName = el.teacher.lastName
              // }

              $scope.editedData.push(a)


              if($scope.gradeFilter.indexOf(el.parallel)<0){
                  $scope.gradeFilter.push(el.parallel)
              }
              $scope.gradeFilter.sort(function (a, b) {
                  if (a < b) {
                      return -1;
                  }
                  return 1;
              })

              $scope.subjectFilter.push(el.title)

          })


          $scope.itemsForPrint = $scope.editedData
        console.log(result)

          $timeout(function () {
              usSpinnerService.stop('TeacherJournalCtrlSpinner');
          });
        if ($auth.isInRole('ROLE_STUDENT')) {
          $scope.classParallel = $auth.user.additionalUserInfoDTO.studentGroups[0].classParallel;
        } else if ($auth.isInRole('ROLE_PARENT')) {
          $scope.isParent = true;
        } else {
          $scope.isSchoolStuff = true;
        }
      },
      function(reason) {
        $state.go('404');
      }
    );
    $scope.openDialog = function(user) {
        console.log('openDialog')
      Dialogs.createIndividualDialog(user);
    };
    $scope.detailsJournal = function(data) {
        console.log("detailsJournal")
      if ('JournalRoles1' === $stateParams.provider) {
        $state.go('JournalRoles1/schoolJournal/student/details', {
          courseId: data.courseId
        });
        return;
      }
      data.studentId = $scope.studentId;
      data.groupId = $state.params.groupId;
      $state.go('detailsJournal', data);
    };
  }
]);

'use strict';

angular.module('lmsClientApp').controller('StudentJournalCourseDetailsCtrl', [
    '$scope',
    '$auth',
    '$state',
    'Account',
    'ProgressResource',
    'Course',
    'TopicProgressResource',
    '$mdDialog',
    'lmsConfig',
    'Bookshelf',
    'LessonProgressResource',
    '$stateParams',
    'usSpinnerService',
    '$timeout',
    function (
        $scope,
        $auth,
        $state,
        Account,
        ProgressResource,
        Course,
        TopicProgressResource,
        $mdDialog,
        lmsConfig,
        Bookshelf,
        LessonProgressResource,
        $stateParams,
        usSpinnerService,
        $timeout
    ) {
        var openedTopic = null;

        // Variables
        $scope.ncyBreadcrumbIgnore = true;
        $scope.progresses = null;
        $scope.studentId = null;
        $scope.courseId = $state.params.courseId;
        $scope.groupId = $state.params.groupId;
        $scope.attemptsByLid = [];

        // Methods
        $scope.goCourseLessonTotal = goCourseLessonTotal;
        $scope.goCourseLessonPage = goCourseLessonPage;
        $scope.goCourseTopicTotal = goCourseTopicTotal;
        $scope.goCourseTopicExercise = goCourseTopicExercise;

        getOpenedTopic();
        initStudentJournal();
        update();

        $scope.showConfirm = function (ev, lid) {
            $state.params.lessonId = lid;

            $mdDialog
                .show({
                    controller: dialogCtrl,
                    templateUrl: lmsConfig.modulesPath +
                        'journal/views/_confirmDialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    targetEvent: ev
                })
                .then(function () {
                    LessonProgressResource.addLessonAttempt(
                        {
                            studentId: $scope.studentId,
                            lessonId: lid
                        },
                        {},
                        function (result) {
                            update();
                        }
                    );
                });
        };

        $scope.isReassigned = function (lesson) {
            var quizzesStat = lesson.stat.quizzes,
                _quzzAll = quizzesStat.performed == quizzesStat.all;

            if (lesson.numberAttempt > 1 && !_quzzAll) {
                return true;
            }
            return false;
        };

        $scope.isHidden = function (topicId) {
            if (topicId == openedTopic) {
                return false;
            }
            return true;
        };

        $scope.setOnlineTopicMark = function (tid, mark) {
            if (mark === '') {
                mark = null;
            }
            TopicProgressResource.setOnlineMark(
                {
                    studentId: $scope.studentId,
                    topicId: tid
                },
                { mark: mark },
                function (result) {
                    update();
                }
            );
        };

        $scope.setOnlineLessonMark = function (lid, mark) {
            if (mark === '') {
                mark = null;
            }
            LessonProgressResource.setOnlineMark(
                {
                    studentId: $scope.studentId,
                    lessonId: lid
                },
                { mark: mark },
                function (result) {
                    update();
                }
            );
        };

        function dialogCtrl($scope, $mdDialog) {
            getLeftAttempts($scope);
            $scope.cancel = function () {
                $mdDialog.cancel();
            };
            $scope.confirm = function () {
                $mdDialog.hide();
            };
        }

        function getLeftAttempts($scope) {
            LessonProgressResource.getAvailableAttempts({
                studentId: $scope.studentId,
                lessonId: $state.params.lessonId
            }).$promise.then(function (result) {
                $scope.attempts = result.available;
                return $scope.attempts;
            });
        }

        function getOpenedTopic() {
            var lastBooks = Bookshelf.lastBooks;

            if (lastBooks) {
                lastBooks.then(findOpenedTopic);
            } else {
                Bookshelf.getLastBooks().then(findOpenedTopic);
            }
        }

        function findOpenedTopic(lastBooks) {
            var found;

            lastBooks.some(function (lastBook) {
                if (lastBook.id == $state.params.courseId) {
                    found = lastBook.bookmark.match(/topic\/(\d+)/);
                    if (found.length >= 2) {
                        openedTopic = found[1];
                    }
                    return true;
                }
            });
        }

        function update() {
            ProgressResource.getAllForStudentByCourse({
                courseId: $state.params.courseId,
                studentId: $scope.studentId
            }).$promise.then(
                function (result) {
                    $scope.progresses = result;

                    //заполняем кол-во заданий для топиков
                    $scope.progresses.topics.forEach(function (topic) {
                        topic.quizzesStat = {
                            all: 0,
                            done: 0,
                            required: 0,
                            requiredPerformed: 0
                        };
                        topic.homeStat = {
                            required: 0,
                            performed: 0,
                            done: 0
                        };
                        topic.assignmentsStat = {
                            all: 0,
                            required: 0,
                            performed: 0,
                            done: 0
                        };
                        topic.lessons.forEach(function (lesson) {
                            topic.quizzesStat.all += lesson.stat.quizzes.all;
                            topic.quizzesStat.done += lesson.stat.quizzes.done;
                            topic.quizzesStat.required += lesson.stat.quizzes.required;
                            topic.quizzesStat.requiredPerformed += lesson.stat.quizzes.requiredPerformed;
                            if (lesson.stat.assignmentsHome) {
                                topic.homeStat.required += lesson.stat.assignmentsHome.required;
                                topic.homeStat.performed += lesson.stat.assignmentsHome.performed;
                                topic.homeStat.done += lesson.stat.assignmentsHome.done;
                            }
                            if (lesson.stat.assignmentsOpenTask) {
                                topic.assignmentsStat.required += lesson.stat.assignmentsOpenTask.required;
                                topic.assignmentsStat.performed += lesson.stat.assignmentsOpenTask.performed;
                                topic.assignmentsStat.done += lesson.stat.assignmentsOpenTask.done; //Проверки для отображения правильных подсказок (tooltips) //Проверка выполнения всех назначенных заданий
                                lesson.stat.assignmentsOpenTask.waitingPerformedRequired = false;
                                if (
                                    lesson.stat.assignmentsOpenTask.performed >=
                                    lesson.stat.assignmentsOpenTask.required &&
                                    (lesson.stat.assignmentsOpenTask.performed ==
                                        lesson.stat.assignmentsOpenTask.done ||
                                        lesson.stat.assignmentsOpenTask.performed !=
                                        lesson.stat.assignmentsOpenTask.done) &&
                                    lesson.stat.assignmentsOpenTask.required !=
                                    lesson.stat.assignmentsOpenTask.requiredPerformed
                                ) {
                                    lesson.stat.assignmentsOpenTask.waitingPerformedRequired = true;
                                }
                                //empty - проверка для отображения пустого поля
                                lesson.stat.assignmentsOpenTask.empty = false;
                                if (
                                    lesson.stat.assignmentsOpenTask.required <
                                    1 &&
                                    lesson.stat.assignmentsOpenTask.performed <
                                    1 &&
                                    lesson.stat.assignmentsOpenTask.done < 1
                                ) {
                                    lesson.stat.assignmentsOpenTask.empty = true;
                                }
                            }
                        });
                        topic.assignmentsStat.empty = false;
                        if (
                            topic.assignmentsStat.required < 1 &&
                            topic.assignmentsStat.performed < 1 &&
                            topic.assignmentsStat.done < 1
                        ) {
                            topic.assignmentsStat.empty = true;
                        }
                    });
                },
                function (reason) {
                    $state.go('404');
                }
            );
        }
        function initStudentJournal() {
            if ($state.params.studentId) {
                $auth.user.relatedStudentId = $state.params.studentId;
                $scope.studentId = $auth.user.relatedStudentId ||
                    $state.params.studentId;

            }
            else {
                // Если параметра studentId null и это ученик можем точно быть уверены что открывается журнал владельца аккаунта
                if ($auth.isInRole('ROLE_STUDENT')) {
                    $scope.studentId = $auth.user.id;
                }
            } // Проверяем роль и параллель для выбора отметочного или безотметочного оценивания
            if ($auth.user.id) {
                spinnerShow();
                Course.getCourse($scope.courseId).then(function (course) {
                    $scope.isOlympic = course.courseType.id === 2 || course.courseType.id === 12
                        ? true
                        : false;
                    $scope.classParallel = course.parallel;
                    if (
                        $auth.isInRole('ROLE_STUDENT') ||
                        $auth.isInRole('ROLE_PARENT')
                    ) {
                        $scope.classParallel = $scope.classParallel
                            ? course.parallel
                            : $auth.user.additionalUserInfoDTO.studentGroups[
                                0
                            ].classParallel;
                        $scope.isTeacher = false;
                    } else {
                        $scope.isTeacher = true;
                    }
                    spinnerHide();
                });
            } else {
                // Если сервис $auth не работает, запрашиваем юзера
                spinnerShow();
                Account.getAccount().then(function (user) {
                    Course.getCourse($scope.courseId).then(function (course) {
                        $scope.isOlympic = course.courseType.id === 2 || course.courseType.id === 12
                            ? true
                            : false;
                        $scope.classParallel = course.parallel;
                        if (user.userRoles[0] === 'ROLE_STUDENT') {
                            $scope.classParallel = $scope.classParallel
                                ? $scope.classParallel
                                : user.additionalUserInfoDTO.studentGroups[
                                    0
                                ].classParallel;
                            $scope.isTeacher = false;
                        } else {
                            $scope.isTeacher = true;
                        }
                        spinnerHide();
                    });
                });
            }
        }
        function goCourseLessonTotal(tid, lid, togglePane) {
            if (tid !== void 0 && lid !== void 0) {
                $state.go('courseLessonTotal', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    lid: lid,
                    togglePane: togglePane,
                    studentId: $scope.studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }
        function goCourseTopicExercise(tid) {
            if (tid) {
                $state.go('courseTopicExercise', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    studentId: $scope.studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }
        function goCourseLessonPage(tid, lid, page) {
            page = page || 1;
            if (tid && lid) {
                $state.go('courseLesson', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    lid: lid,
                    page: page,
                    studentId: $scope.studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }
        function goCourseTopicTotal(tid, task, togglePane) {
            if (tid !== void 0) {
                $state.go('courseTopicTotal', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    task: task,
                    togglePane: togglePane,
                    studentId: $scope.studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }

        function spinnerShow() {
            $timeout(function () {
                usSpinnerService.spin('studentJournalCourseDetailsSpinner');
            }, 0);
            $scope.studentJournalCourseDetailsSpinnerShow = true;
        }

        function spinnerHide() {
            $timeout(function () {
                $scope.studentJournalCourseDetailsSpinnerShow = false;
                usSpinnerService.stop('studentJournalCourseDetailsSpinner');
            }, 1000);
        }
    }
]);

'use strict';

angular.module('lmsClientApp').controller('TeacherJournalCtrl', [
    '$scope',
    '$auth',
    '$state',
    'CourseGroupResource',
    'usSpinnerService',
    '$mdDialog',
    'lmsConfig',
    'innopolis',
    function ($scope, $auth,$state, CourseGroupResource, usSpinnerService, $mdDialog, lmsConfig, innopolis) {
        var unbindAuthWatcher;
        var initialYear = 2021;

        $scope.onYearChange = onYearChange;
        $scope.courseGroups = [];
        $scope.data = [
            {
                id: 37,
                title: "Внеурочная деятельность",
                course: [
                    {
                        title: "Задачи по химии",
                        userGroup: [
                            {
                                id: 3688773,
                                title: "10ХимияЗадачи"
                            }

                        ]
                    }
                ]
            },
            {
                id: 27,
                title: "Сборники олимпиадных задач",
                course: [
                    {
                        title: "Сборник олимпиадных заданий по Химии 9-11 класс",
                        userGroup: [
                            {
                                id: 3688721,
                                title: "10ПрофХимия"
                            },
                            {
                                id: 3688723,
                                title: "11ПрофХимия"
                            },
                            {
                                id: 3688719,
                                title: "9ПрофХимия"
                            }

                        ]
                    }
                ]
            },
            {
                id: 30,
                title: "Химия",
                course: [
                    {
                        id: 3688721,
                        title: "Химия 10 класс",
                        userGroup: [
                            {
                                id: 3688691,
                                title: "10-IIА"
                            }

                        ]
                    },
                    {
                        id: 3688721,
                        title: "Химия 11 класс"
                    },
                    {
                        id: 3688721,
                        title: "Химия 9 класс"
                    },
                    {
                        id: 3688721,
                        title: "Химия 8 класс"
                    },
                ]
            }
        ]

        $scope.editedData = []
        $scope.itemsForPrint = []
        $scope.subjectFilter = []
        $scope.chosenSubjectFilter = "Все предметы"
        $scope.useSubjectFilter = function () {
            // проверяем задействован ли второй фильтр
            if ($scope.chosenGradeFilter == "Все классы"){
                if ($scope.chosenSubjectFilter !== "Все предметы"){
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return  el.subject == $scope.chosenSubjectFilter
                    })
                } else {
                    $scope.itemsForPrint = $scope.editedData
                }
            } else {
                if ($scope.chosenSubjectFilter !== "Все предметы") {
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return el.subject == $scope.chosenSubjectFilter
                    }).filter(function (el) {
                        return el.parallel == $scope.chosenGradeFilter
                    })
                }  else {
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return el.parallel == $scope.chosenGradeFilter
                    })
                }
            }


        }

        $scope.gradeFilter = []
        $scope.chosenGradeFilter = "Все классы"
        $scope.useGradeFilter = function () {
            // проверяем задействован ли второй фильтр
            if ($scope.chosenSubjectFilter == "Все предметы"){
                if ($scope.chosenGradeFilter !== "Все классы"){
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return  el.parallel == $scope.chosenGradeFilter
                    })
                } else {
                    $scope.itemsForPrint = $scope.editedData
                }
            } else {
                if ($scope.chosenGradeFilter !== "Все классы"){
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return  el.parallel == $scope.chosenGradeFilter
                    }).filter(function (el) {
                        return  el.subject == $scope.chosenSubjectFilter
                    })
                } else {
                    $scope.itemsForPrint = $scope.editedData.filter(function (el) {
                        return  el.subject == $scope.chosenSubjectFilter
                    })
                }


            }


        }


        $scope.colors = [
                "#475677",
                "#faa026",
                "#b8312e",
                "#41a85f",
                "#662e91",
                "#8c6238",
                "#28314e",
                "#75706c"
        ]

        $scope.editData = function (dataArray) {
            dataArray.forEach(function (el,index) {
                var colourIdx = index % ($scope.colors.length);
                $scope.subjectFilter.push(el.title)
                if (el.course !== undefined){
                    el.course.forEach(function (elem) {
                        if (elem.userGroup !== undefined){
                            elem.userGroup.forEach(function (element) {
                                // иногда паралель указана в курсе а иногда в группе
                                if (elem.parallel !== undefined){
                                    // заменить indexOf на includes
                                    if($scope.gradeFilter.indexOf(elem.parallel)<0){
                                        $scope.gradeFilter.push(elem.parallel)
                                    }
                                    $scope.gradeFilter.sort(function (a, b) {
                                        if (a < b) {
                                            return -1;
                                        }
                                        return 1;
                                    })
                                } else {
                                    if($scope.gradeFilter.indexOf(element.parallel)<0){
                                        $scope.gradeFilter.push(element.parallel)
                                    }
                                    $scope.gradeFilter.sort(function (a, b) {
                                        if (a < b) {
                                            return -1;
                                        }
                                        return 1;
                                    })

                                }

                                // иногда средняя оценка указана, а иногда нет
                                if (element.averageMark !== undefined){
                                    var a = {
                                        subject: el.title,
                                        course: elem.title,
                                        group: element.title,
                                        parallel: elem.parallel,
                                        courseId: elem.id,
                                        groupId: element.id,
                                        averageMark: element.averageMark,
                                        color: $scope.colors[colourIdx],
                                        raw: element.raw
                                    }
                                } else {
                                    var a = {
                                        subject: el.title,
                                        course: elem.title,
                                        group: element.title,
                                        parallel: elem.parallel,
                                        courseId: elem.id,
                                        groupId: element.id,
                                        color: $scope.colors[colourIdx],
                                        raw: element.raw
                                    }
                                }

                                $scope.editedData.push(a)
                            })
                        }
                    })
                }


            })
        }

        $scope.goToGroup = function (courseId, groupId, selectedYear) {
            $state.go('courseSectionJournal', {
                courseId: courseId,
                groupId: groupId,
                studyYear: selectedYear
            });
        }





        spinnerShow();
        $scope.years = (unbindAuthWatcher = $scope.$watch(function () {
            return $auth.user.id;
        }, function (id) {
            if (id) {
                CourseGroupResource.getAllForTeacher({
                    teacherId: id,
                    year: initialYear
                }, function (result) {
                    sortCourseGroups(result);
                    $scope.editData(result)
                    $scope.courseGroups = result;
                    console.log(result)
                    $scope.itemsForPrint = $scope.editedData
                    spinnerHide();
                });
                unbindAuthWatcher();
            }
        }));

        init();




        function onYearChange(selectedYear) {
            console.log(selectedYear)

            spinnerShow();
            CourseGroupResource.getAllForTeacher(
                { teacherId: $auth.user.id,
                    year: selectedYear
                },
                function (result) {
                    sortCourseGroups(result);
                    $scope.editedData = []
                    $scope.editData(result)
                    $scope.courseGroups = result;
                    $scope.itemsForPrint = $scope.editedData
                    spinnerHide();
                }
            );

            // CourseGroupResource.getAllForTeacher(
            //     { teacherId: $auth.user.id },
            //     function (result) {
            //         sortCourseGroups(result);
            //         $scope.courseGroups = result;
            //         spinnerHide();
            //     }
            // );
        }

        function sortCourseGroups(courseGroups) {
            // console.log(courseGroups);
            courseGroups.sort(function (a, b) {
                if (a.title < b.title) {
                    return -1;
                }
                return 1;
            });
            courseGroups.forEach(function (element) {
                element.course.sort(function (a, b) {
                    if (a.title < b.title) {
                        return -1;
                    }
                    return 1;
                });
                element.course.forEach(function (cours) {
                    cours.userGroup.sort(function (a, b) {
                        if (a.title < b.title) {
                            return -1;
                        }
                        return 1;
                    });
                });
            });
        }

        function init() {
            $scope.learningYears = getLearningYears();
            console.log($scope.learningYears);
            $scope.selectedYear = getCurrentYear();
        }

        // function getLearningYears() {
        //     var yearNow = getCurrentYear() + 1;
        //     var years = [initialYear];
        //     var tmpYear = yearNow;
        //
        //     while (tmpYear > years[0]) {
        //         years.splice(1, 0, tmpYear);
        //         tmpYear = tmpYear - 1;
        //     }
        //     return years;
        // }

        function getLearningYears() {
            var yearNow = getCurrentYear();
            var years = [yearNow - 1, yearNow, yearNow + 1];

            return years;
        }

        function getCurrentYear() {
            var date = new Date();
            var fullYear = date.getFullYear();
            // ----
            var monthSeptember = 9;
            var monthCurrent = 1 + date.getMonth();
            // ----
            if (monthCurrent < monthSeptember) {
                fullYear = fullYear - 1;
            }
            return fullYear;
        }

        function spinnerShow() {
            $scope.loaded = false;
            $scope.TeacherJournalCtrlSpinnerShow = true;
            // usSpinnerService.spin('TeacherJournalCtrlSpinner');
        }

        function spinnerHide() {
            $scope.loaded = true;
            $scope.TeacherJournalCtrlSpinnerShow = false;
            // usSpinnerService.stop('TeacherJournalCtrlSpinner');
        }

        $scope.isInnopolisButtonVisible = innopolis
        $scope.showAddClassesDialog = function() {
            $mdDialog.show({
                controller: 'TeacherJournalAddClassDialogCtrl',
                templateUrl: lmsConfig.modulesPath + 'journal/views/_addClassesDialog.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                onRemoving: function (event, removePromise) {
                    $state.reload();
                }
            })
        }
    }
]);

'use strict';

angular.module('lmsClientApp').controller('TeacherJournalCourseSectionCtrl', [
    '$scope',
    '$state',
    'CourseProgressResource',
    'ProgressResource',
    'Dialogs',
    'adaptedProgramList',
    '$stateParams',
    'usSpinnerService',
    '$timeout',
    function(
        $scope,
        $state,
        CourseProgressResource,
        ProgressResource,
        Dialogs,
        adaptedProgramList,
        $stateParams,
        usSpinnerService,
        $timeout
    ) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.courseProgresses = [];
        $scope.regionId = $state.params.regionId;
        $scope.territoryId = $state.params.territoryId;
        $scope.schoolId = $state.params.schoolId;
        $scope.groupId = $state.params.groupId;
        $scope.courseId = $state.params.courseId;
        $scope.studyYear = $state.params.studyYear;
        // console.log({
        //     studyYear2: $scope.studyYear
        // });
        
        // Для вспылвающих подсказок с названием адаптированной программы
        $scope.ADAPTED_PROGRAMS_TITLES = {};
        adaptedProgramList.forEach(function(program) {
            $scope.ADAPTED_PROGRAMS_TITLES[program.id] = program.name;
        });
        $scope.setAttestationMark = function(id, mark) {
            var data;
            if (mark === '') {
                mark = null;
            }
            data = {
                id: id,
                body: { mark: mark }
            };
            usSpinnerService.spin('spinnerTeacherJournal');
            CourseProgressResource.setAttestationMark(
                {
                    id: data.id
                },
                data.body,
                function(result) {
                    getProgresses().then(function() {
                        usSpinnerService.stop('spinnerTeacherJournal');
                    });
                }
            );
        };
        $timeout(
            function() {
                usSpinnerService.spin('spinnerTeacherJournal');
                var sss = getProgresses().then(function() {
                    usSpinnerService.stop('spinnerTeacherJournal');
                });
            },
            0
        );
        function getProgresses() {
            return ProgressResource.getByCourseAndUserGroup({
                courseId: $scope.courseId,
                userGroupId: $scope.groupId
            })
                .$promise.then(function(result) {
                    // Сортируем чтоб не менялись позиции в таблице
                    result.sort(function(a, b) {
                        var fullName1 = a.student.lastName + ' ' + a.student.firstName;
                        var fullName2 = b.student.lastName + ' ' + b.student.firstName;
                        if (fullName1 < fullName2) {
                            return -1;
                        }
                        return 1;
                    });
                    return result;
                })
                .then(function(progresses) {
                    $scope.courseProgresses = progresses.filter(function(progress) {
                        return progress.student.status === 'ACTIVE';
                    });
                })
                .catch(function() {
                    $state.go('404');
                });
        }
        $scope.openDialog = function(user) {
            Dialogs.createIndividualDialog(user);
        };
        $scope.detailsJournalTeacher = function(data) {
            if ('JournalRoles1' === $stateParams.provider) {
                $state.go('JournalRoles1/schoolJournal/student', {
                    studentId: data.studentId,
                    courseId: data.courseId,
                    groupId: data.groupId,
                    schoolId: data.schoolId,
                    territoryId: data.territoryId,
                    regionId: data.regionId
                });
                return;
            }
            $state.go('detailsJournalTeacher', data);
        };
    }
]);

'use strict';

angular.module('lmsClientApp').controller('TeacherJournalCourseSectionAllCtrl', [
    '$scope',
    '$state',
    'CourseProgressResource',
    'CourseService',
    'ProgressResource',
    'TopicProgressResource',
    'Dialogs',
    '$mdDialog',
    'lmsConfig',
    'Bookshelf',
    'LessonProgressResource',
    'adaptedProgramList',
    'usSpinnerService',
    '$stateParams',
    '$timeout',
    function (
        $scope,
        $state,
        CourseProgressResource,
        CourseService,
        ProgressResource,
        TopicProgressResource,
        Dialogs,
        $mdDialog,
        lmsConfig,
        Bookshelf,
        LessonProgressResource,
        adaptedProgramList,
        usSpinnerService,
        $stateParams,
        $timeout
    ) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.courseProgresses = [];
        $scope.regionId = $state.params.regionId;
        $scope.territoryId = $state.params.territoryId;
        $scope.schoolId = $state.params.schoolId;
        $scope.groupId = $state.params.groupId;
        $scope.courseId = $state.params.courseId;
        // Для всплывающих подсказок с названием адаптированной программы
        $scope.ADAPTED_PROGRAMS_TITLES = {};
        adaptedProgramList.forEach(function (program) {
            $scope.ADAPTED_PROGRAMS_TITLES[program.id] = program.name;
        }); //Methods
        $scope.goCourseLessonTotal = goCourseLessonTotal;
        $scope.goCourseTopicTotal = goCourseTopicTotal; //console
        $scope.showConfirm = function (ev, lid) {
            $state.params.lessonId = lid;
            $mdDialog
                .show({
                    controller: dialogCtrl,
                    templateUrl: lmsConfig.modulesPath + 'journal/views/_confirmDialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    targetEvent: ev
                })
                .then(function () {
                    LessonProgressResource.addLessonAttempt(
                        {
                            studentId: $state.params.studentId,
                            lessonId: lid
                        },
                        {},
                        function (result) {
                            update();
                        }
                    );
                });
        };
        $scope.setOnlineLessonMark = function (lid, studentId, mark) {
            if (mark === '') {
                mark = null;
            }
            LessonProgressResource.setOnlineMark(
                {
                    studentId: studentId,
                    lessonId: lid
                },
                { mark: mark },
                function (result) {
                    getProgresses();
                }
            );
        };
        function goCourseLessonTotal(tid, studentId, lid, togglePane) {
            if (tid !== void 0 && lid !== void 0) {
                $state.go('courseLessonTotal', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    lid: lid,
                    togglePane: togglePane,
                    studentId: studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }
        function goCourseTopicTotal(tid, studentId, task, togglePane) {
            if (tid !== void 0) {
                $state.go('courseTopicTotal', {
                    courseId: $state.params.courseId,
                    tid: tid,
                    task: task,
                    togglePane: togglePane,
                    studentId: studentId,
                    groupId: $state.params.groupId,
                    schoolId: $state.params.schoolId,
                    territoryId: $state.params.territoryId,
                    regionId: $state.params.regionId
                });
            }
        }
        function getProgresses() {
            spinnerShow();
            var lessonId;
            // startSpin();
            CourseService.get('lessonId').then(function (result) {
                lessonId = result;
                ProgressResource.getLessonProgressFromTopic({
                    lessonId: lessonId,
                    groupId: $scope.groupId
                }).$promise.then(
                    function (result) {
                        $scope.courseProgresses = result;
                        // stopSpin();
                        spinnerHide();
                    },
                    function (reason) {
                        spinnerHide();
                        $state.go('404');
                    }
                );
            });
        }
        $scope.$watch(
            function () {
                return CourseService.getFast('lessonId');
            },
            function (newVal, oldval) {
                if (newVal !== undefined) {
                    // console.log(newVal);
                    getProgresses();
                }
            }
        );
        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };
        function startSpin() {
            usSpinnerService.spin('spinner-1');
        }
        function stopSpin() {
            usSpinnerService.stop('spinner-1');
        }
        $scope.detailsJournalTeacher = function (data) {
            if ('JournalRoles1' === $stateParams.provider) {
                $state.go('JournalRoles1/schoolJournal/student', {
                    studentId: data.studentId,
                    courseId: data.courseId,
                    groupId: data.groupId,
                    schoolId: data.schoolId,
                    territoryId: data.territoryId,
                    regionId: data.regionId
                });
                return;
            }
            $state.go('detailsJournalTeacher', data);
        };

        function spinnerShow() {
            $timeout(function () {
                usSpinnerService.spin('teacherJournalCourseSectionAllSpinner');
            }, 0);
            $scope.teacherJournalCourseSectionAllSpinnerShow = true;
        }

        function spinnerHide() {
            $timeout(function () {
                $scope.teacherJournalCourseSectionAllSpinnerShow = false;
                usSpinnerService.stop('teacherJournalCourseSectionAllSpinner');
            }, 200);
        }
    }
]);

'use strict';

angular.module('lmsClientApp').controller('TeacherJournalAddClassDialogCtrl', [
    '$auth',
    '$scope',
    '$mdDialog',
    'UserGroupResource',
    'CourseSectionResource',
    function ($auth, $scope, $mdDialog, UserGroupResource, CourseSectionResource) {

        $scope.userGroups = [];
        $scope.sections = [];
        $scope.selectedGroup = null;
        $scope.teacher = $auth.user;
        $scope.successMessage = false;
        $scope.errorMessage = false;

        function spinnerShow() {
            $scope.loaded = false;
            $scope.TeacherJournalCtrlSpinnerShow = true;
        }

        function spinnerHide() {
            $scope.loaded = true;
            $scope.TeacherJournalCtrlSpinnerShow = false;
        }

        init();

        function init() {
            spinnerShow();
            $scope.userGroups = UserGroupResource.getAvailableGroupsInTeachersSchool(
                function(response){
                    spinnerHide();
                    $scope.userGroups = response;
                },
                function(error) {
                    $scope.showErrorMessage();
                });
        };
        
        $scope.selectedGroupChange = function(group) {
            $scope.closeMessage();
            if (group) {
                spinnerShow();
                CourseSectionResource.getAllAvailableForTeacherByGroupId({
                    groupId: group.id
                }, function(response) {
                    spinnerHide();
                    $scope.sections = response;
                },
                function(erroe) {
                    spinnerHide();
                    $scope.showErrorMessage();
                })
            }
            else {
                $scope.sections = [];
            }
        }

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        
        $scope.queryGroup = function (input){
            $scope.closeMessage();
            var inputLength = input.length;

            var arr = $scope.userGroups.filter(function (el){
                return el.name
                       .slice(0,inputLength)
                       .toLocaleLowerCase() === input
                       .slice(0,inputLength)
                       .toLocaleLowerCase()
            });


            return arr;
        };

        $scope.checkSection = function(section, checked) {
            $scope.closeMessage();
            if (checked) {
                section.teacher_id = $scope.teacher.id;
            }
            else {
                section.teacher_id = null;
            }
        }

        $scope.save = function() {
            spinnerShow();
            CourseSectionResource.updateTeacherInSection($scope.sections,
                function(response) {
                    spinnerHide();
                    $scope.showSuccessMessage();
                },
                function(erroe) {
                    spinnerHide();
                    $scope.showErrorMessage();
                });
        }

        $scope.showSuccessMessage = function() {
            $scope.successMessage = true;
        }
        $scope.showErrorMessage = function() {
            $scope.errorMessage = true;
        }
        $scope.closeMessage = function() {
            $scope.errorMessage = false;
            $scope.successMessage = false;
        }
    }
]);

'use strict';

app.controller('TerritoryCoordinatorJournalCtrl', ['$scope', '$state', 'EducationalStructureResource', 'Dialogs', function ($scope, $state, EducationalStructureResource, Dialogs) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.schools = [];
    $scope.territoryId = $state.params.territoryId;
    $scope.regionId = $state.params.regionId;

    EducationalStructureResource.getSchoolsByTerritory({
        territoryId: $scope.territoryId
    }).$promise.then(function (result) {
        $scope.schools = result;
    }, function (reason) {
        $state.go('404');
    });

    $scope.openDialog = function (user) {
        Dialogs.createIndividualDialog(user);
    };
}]);

'use strict';

app.controller('TutorJournalCtrl', [
    '$scope',
    '$auth',
    'UserGroupResource',
    'usSpinnerService',
    'TutorService',

    function ($scope, $auth, UserGroupResource, usSpinnerService,  TutorService) {
        var initialYear = getCurrentYear();
        var unbindAuthWatcher;


        $scope.onYearChange = onYearChange;
        $scope.userGroups = [];



        $scope.years = (unbindAuthWatcher = $scope.$watch(function () {
            return $auth.user.id;
        }, function (id) {
            if (id) {
                spinnerShow();
                UserGroupResource.getAllForTutor({
                    'tutorId': id,
                    'year': initialYear}, function (result) {
                    spinnerHide();
                    TutorService.set(initialYear);
                    $scope.userGroups = result;
                });
                unbindAuthWatcher();
            }
        }));

        init();

        function onYearChange(selectedYear) {
        spinnerShow();
        UserGroupResource.getAllForTutor({
                'tutorId': $auth.user.id,
                'year': selectedYear}, function (result) {
            spinnerHide();
            $scope.userGroups = result;
            TutorService.set(selectedYear);
        });
        }

        function init() {
            $scope.learningYears = getLearningYears();
            $scope.selectedYear = getCurrentYear();
        }

        function getLearningYears() {
            var yearNow = getCurrentYear();
            var years = [yearNow - 1, yearNow, yearNow + 1];

            return years;
        }

        function getCurrentYear() {
            var date = new Date();
            var fullYear = date.getFullYear();
            // ----
            var monthSeptember = 9;
            var monthCurrent = 1 + date.getMonth();
            // ----
            if (monthCurrent < monthSeptember) {
                fullYear = fullYear - 1;
            }
            return fullYear;
        }

        function spinnerShow() {
           $scope.loaded = false;
            $scope.TutorJournalCtrlSpinnerShow = true;
            // usSpinnerService.spin('TutorJournalCtrlSpinner');
        }

        function spinnerHide() {
           $scope.loaded = true;
            $scope.TutorJournalCtrlSpinnerShow = false;
            // usSpinnerService.stop('TutorJournalCtrlSpinner');
        }

}]);

'use strict';

app.controller('TutorJournalUserGroupCtrl', ['$scope', '$state', 'UserGroupResource', 'Dialogs', '$stateParams',
  function ($scope, $state, UserGroupResource, Dialogs, $stateParams) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.regionId = $state.params.regionId;
    $scope.territoryId = $state.params.territoryId;
    $scope.schoolId = $state.params.schoolId;
    $scope.groupId = $state.params.groupId;

    UserGroupResource.getStudents({
        id: $scope.groupId
    }).$promise.then(function (result) {
        $scope.students = result;
    }, function (reason) {
        $state.go('404');
    });

    $scope.openDialog = function (user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.studentJournal = function (data) {
      if ('JournalRoles1' === $stateParams.provider) {
        var studentId = data.studentId;
        var groupId = data.groupId;
        var schoolId = data.schoolId;
        var territoryId = data.territoryId;
        var regionId = data.regionId;
        $state.go('JournalRoles1/schoolJournal/student', {
          studentId: studentId,
          groupId: groupId,
          schoolId: schoolId,
          territoryId: territoryId,
          regionId: regionId
        });
        return;
      }
      $state.go('studentJournal', data);
    };
}]);

"use strict"

angular.module('lmsClientApp')
  .factory('TeacherJournal', function ($q, $timeout) {
    var mem = {};
    var get = function(key) {
        var deferred = $q.defer();

        $timeout(function() {
          deferred.resolve(mem[key])
        }, 200);

        return deferred.promise;
      };
    return {
        store: function(key, value){
            mem[key] = value;
        },
        getFast: function(key){
            return mem[key];
        },        
        get: get
        }
  })

"use strict"

angular.module('lmsClientApp').service('TutorService', function () {
    var year = getCurrentYear();

    this.set = function set(curYear) {
    year = curYear;
    };

    this.get = function get() {
    return year;
    };

    function getCurrentYear() {
        var date = new Date();
        var fullYear = date.getFullYear();
        // ----
        var monthSeptember = 9;
        var monthCurrent = 1 + date.getMonth();
        // ----
        if (monthCurrent < monthSeptember) {
            fullYear = fullYear - 1;
        }
        return fullYear;
    };

  });

"use strict";

app.config([
  "$stateProvider",
  "lmsConfig",
  "lmsEntity",
  function($stateProvider, lmsConfig, lmsEntity) {
    $stateProvider
      .state("regionJournal", {
        parent: "dashboard",
        url: "journal/region/:regionId",
        data: {
          roles: ["ROLE_REGIONAL_COORDINATOR", "ROLE_LOCATION_COORDINATOR"],
          entity: lmsEntity.journal,
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_regionalCoordinatorJournalBar.html",
            controller: "RegionalCoordinatorJournalDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/regionalCoordinatorJournal.html",
            controller: "RegionalCoordinatorJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{regionName}}",
        },
      })
      .state("territoryJournal", {
        parent: "regionJournal",
        url: "/territory/:territoryId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_territoryCoordinatorJournalBar.html",
            controller: "TerritoryCoordinatorJournalDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/territoryCoordinatorJournal.html",
            controller: "TerritoryCoordinatorJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{territoryName}}",
          parent: function($scope) {
            return $scope.territoryParent;
          },
        },
      })
      .state("schoolJournal", {
        parent: "territoryJournal",
        url: "/school/:schoolId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_distanceEducationCoordinatorJournalBar.html",
            controller: "DistanceEducationCoordinatorJournalDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/distanceEducationCoordinatorJournal.html",
            controller: "DistanceEducationCoordinatorJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{schoolName}}",
          parent: function($scope) {
            return $scope.schoolParent;
          },
        },
      })
      .state("tutorJournal", {
        parent: "dashboard",
        url: "journal/group",
        data: {
          roles: ["ROLE_TUTOR"],
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/_tutorJournalBar.html",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/tutorJournal.html",
            controller: "TutorJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "Электронный журнал",
        },
      })
      .state("userGroupJournal", {
        parent: "schoolJournal",
        url: "/:groupId?regionId&territoryId&schoolId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/_tutorJournalGroupBar.html",
            controller: "TutorJournalUserGroupDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/tutorJournalUserGroup.html",
            controller: "TutorJournalUserGroupCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{userGroupName}}",
          parent: function($scope) {},
        },
      })
      .state("teacherJournal", {
        parent: "dashboard",
        url: "journal/courseSection",
        data: {
          roles: ["ROLE_TEACHER", "ROLE_DEPUTY_HEAD_TEACHER"]
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/_teacherJournalBar.html",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/teacherJournal.html",
            controller: "TeacherJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "Электронный журнал"
        },
      })
      .state("detailsJournal", {
        parent: "studentDiary" || "teacherJournal", // Общая страница для дневника и журнала
        url: "/course/:courseId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
            "ROLE_TEACHER",
            "ROLE_STUDENT",
            "ROLE_PARENT"
          ],
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_studentJournalCourseDetailsBar.html",
            controller: "StudentJournalCourseDetailsDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/studentJournalCourseDetails.html",
            controller: "StudentJournalCourseDetailsCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{courseName || studentName}}",
        },
      })
      .state("courseSectionJournal", {
        parent: "teacherJournal",
        url: "/course/:courseId/group/:groupId?regionId&territoryId&schoolId&studyYear",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
            "ROLE_TEACHER"
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_teacherJournalCourseSectionBar.html",
            controller: "TeacherJournalCourseSectionDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/teacherJournalCourseSection.html",
            controller: "TeacherJournalCourseSectionCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{courseName}}",
          parent: function($scope) {
            var parent;
            if ($scope.courseParent) {
                parent = $scope.courseParent;
            }
            if ($scope.managerParent) {
                parent = $scope.managerParent;
            }
            return parent;
          },
        },
      })
      .state("courseSectionJournalAll", {
        parent: "courseSectionJournal",
        url: "/",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
            "ROLE_TEACHER"
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_teacherJournalCourseSectionBarAll.html",
            controller: "TeacherJournalCourseSectionDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/teacherJournalCourseSectionAll.html",
            controller: "TeacherJournalCourseSectionAllCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{courseName}}",
          parent: function($scope) {
            return $scope.courseParent;
          },
        },
      })
      .state("studentDiary", {
        parent: "dashboard",
        url: "diary/courseSection/student/:studentId?groupId",
        data: {
          roles: [
            "ROLE_STUDENT",
            "ROLE_PARENT"
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/_studentJournalBar.html",
            controller: "StudentJournalDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/studentJournal.html",
            controller: "StudentJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "Электронный дневник",
        },
      })
      .state("studentJournal", {
        parent: "dashboard",
        url: "journal/courseSection/student/:studentId?regionId&territoryId&schoolId&groupId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
            "ROLE_STUDENT",
            "ROLE_TEACHER",
            "ROLE_PARENT"
          ],
          entity: lmsEntity.journal,
        },
        resolve: {
          userAccount: function($auth, Account) {
            return $auth.user.id ? $auth.user : Account.getAccount();
          },
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/_studentJournalBar.html",
            controller: "StudentJournalDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/studentJournal.html",
            controller: "StudentJournalCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{studentName}}",
          parent: function($scope) {
            return $scope.studentParent;
          },
        },
      })
      .state("detailsJournalTeacher", {
        parent: "courseSectionJournal",
        url: "/student/:studentId",
        data: {
          roles: [
            "ROLE_REGIONAL_COORDINATOR",
            "ROLE_LOCATION_COORDINATOR",
            "ROLE_TERRITORY_COORDINATOR",
            "ROLE_DISTANCE_EDUCATION_COORDINATOR",
            "ROLE_PSYCHOLOGIST",
            "ROLE_METHODOLOGIST",
            "ROLE_HEAD_TEACHER",
            "ROLE_DEPUTY_HEAD_TEACHER",
            "ROLE_TUTOR",
            "ROLE_TEACHER",
            "ROLE_STUDENT",
            "ROLE_PARENT",
          ],
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: lmsConfig.modulesPath +
              "journal/views/_studentJournalCourseDetailsBar.html",
            controller: "StudentJournalCourseDetailsDashBarCtrl",
          },
          "dashContent@dashboard": {
            templateUrl: lmsConfig.modulesPath + "journal/views/studentJournalCourseDetails.html",
            controller: "StudentJournalCourseDetailsCtrl",
          },
        },
        ncyBreadcrumb: {
          label: "{{studentName}}",
        },
      });
  },
]);

app.run(['$state', '$stateParams',
  function($state, $stateParams) {
  }
]);


// app.controller("diagnostic",[
//     '$scope',function ($scope){
//             console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
//
//         }
// ]
// )
'use strict';

app.controller('Diagnostic', [
    '$scope',
    'Groups',
    'Users',
    'CourseResource',
    'UserGroupResource',
    'ProgressResource',
    'TopicResource',
    'CourseSectionResource',
    '$auth',
    function($scope,Groups,Users,CourseResource,UserGroupResource,ProgressResource,TopicResource,CourseSectionResource,$auth) {

        $scope.testHeatMapData2 = {
            "quiz_result": {
                "quiz_id": "7",
                "student_quiz_result_list": [
                    {
                        "quiz_id": "7",
                        "student_id": 2663,
                        "result": 40,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 1,
                                "result_points": 6,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 2,
                                "result_points": 14,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 2,
                                "result_points": 93,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 29,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 2,
                                "result_points": 14,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 1,
                                "result_points": 69,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 2,
                                "result_points": 93,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 1,
                                "result_points": 0,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 2664,
                        "result": 52,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 1,
                                "result_points": 98,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 1,
                                "result_points": 38,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 1,
                                "result_points": 26,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 6,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 1,
                                "result_points": 5,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 1,
                                "result_points": 89,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 1,
                                "result_points": 66,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 2,
                                "result_points": 87,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 2665,
                        "result": 39,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 2,
                                "result_points": 23,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 1,
                                "result_points": 22,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 2,
                                "result_points": 65,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 15,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 1,
                                "result_points": 64,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 1,
                                "result_points": 35,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 1,
                                "result_points": 5,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 2,
                                "result_points": 80,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1696,
                        "result": 42,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 2,
                                "result_points": 83,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 1,
                                "result_points": 11,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 2,
                                "result_points": 11,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 50,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 1,
                                "result_points": 21,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 2,
                                "result_points": 59,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 2,
                                "result_points": 61,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 2,
                                "result_points": 36,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1785,
                        "result": 62,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 2,
                                "result_points": 67,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 2,
                                "result_points": 80,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 1,
                                "result_points": 8,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 67,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 2,
                                "result_points": 71,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 2,
                                "result_points": 97,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 1,
                                "result_points": 78,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 2,
                                "result_points": 31,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1786,
                        "result": 33,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 2,
                                "result_points": 21,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 1,
                                "result_points": 30,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 2,
                                "result_points": 16,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 51,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 1,
                                "result_points": 77,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 2,
                                "result_points": 3,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 2,
                                "result_points": 32,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 2,
                                "result_points": 33,
                                "is_success": true
                            }
                        ]
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1842,
                        "result": 57,
                        "result_by_questions": [
                            {
                                "question_id": 1358,
                                "attempt_count": 1,
                                "result_points": 67,
                                "is_success": true
                            },
                            {
                                "question_id": 1088,
                                "attempt_count": 1,
                                "result_points": 98,
                                "is_success": true
                            },
                            {
                                "question_id": 1361,
                                "attempt_count": 1,
                                "result_points": 21,
                                "is_success": true
                            },
                            {
                                "question_id": 4856,
                                "attempt_count": 1,
                                "result_points": 31,
                                "is_success": true
                            },
                            {
                                "question_id": 4840,
                                "attempt_count": 2,
                                "result_points": 85,
                                "is_success": true
                            },
                            {
                                "question_id": 4842,
                                "attempt_count": 2,
                                "result_points": 88,
                                "is_success": true
                            },
                            {
                                "question_id": 4874,
                                "attempt_count": 1,
                                "result_points": 27,
                                "is_success": true
                            },
                            {
                                "question_id": 4877,
                                "attempt_count": 1,
                                "result_points": 36,
                                "is_success": true
                            }
                        ]
                    }
                ]
            },
            "user_list": [
                {
                    "id": 2663,
                    "first_name": "Денис",
                    "last_name": "Куштанов",
                    "middle_name": "Марсович"
                },
                {
                    "id": 2664,
                    "first_name": "Анастасия",
                    "last_name": "Лялина",
                    "middle_name": "Сергеевна"
                },
                {
                    "id": 2665,
                    "first_name": "Элина",
                    "last_name": "Мордовец",
                    "middle_name": "Николаевна"
                },
                {
                    "id": 1696,
                    "first_name": "Иван",
                    "last_name": "Ильин",
                    "middle_name": "Алексеевич"
                },
                {
                    "id": 1785,
                    "first_name": "Даниил",
                    "last_name": "Шафиков",
                    "middle_name": "Азатович"
                },
                {
                    "id": 1786,
                    "first_name": "Артем",
                    "last_name": "Бабюк",
                    "middle_name": "Александрович"
                },
                {
                    "id": 1842,
                    "first_name": "Алексей",
                    "last_name": "Айбашев",
                    "middle_name": "Вадимович"
                }
            ],
            "quiz_question_list": [
                {
                    "id": 1358,
                    "name": "Линейная функция. Задание 1",
                    "skill_name": "Применять формулы нахождения скорости, расстояния и время движения",
                    "skill_id": 45
                },
                {
                    "id": 1361,
                    "name": "Линейная функция. Задание 3",
                    "skill_name": "Угловой коэффициент прямой (графика линейной функции)",
                    "skill_id": 9
                },
                {
                    "id": 1088,
                    "name": "Линейная функция Задание 2",
                    "skill_name": "Решать уравнения вида ax = b; a : x = b;  ax + b = c",
                    "skill_id": 24
                },
                {
                    "id": 4842,
                    "name": "В практической плоскости. Поездка на такси",
                    "skill_name": "Составлять  формулу зависимости двух величин по тексту задачи",
                    "skill_id": 40
                },
                {
                    "id": 4874,
                    "name": "Тренируемся. График линейной функции",
                    "skill_name": "Линейная функция и её график",
                    "skill_id": 8
                },
                {
                    "id": 4856,
                    "name": "Тренируемся. Параллельные прямые",
                    "skill_name": "Определять по уравнению взаимное расположение прямых. Условие параллельных прямых",
                    "skill_id": 53
                },
                {
                    "id": 4840,
                    "name": "Решаем тесты. Готовимся к ОГЭ",
                    "skill_name": "Определять по уравнению функции её график. Различать название функции по её уравнению",
                    "skill_id": 19
                },
                {
                    "id": 4877,
                    "name": "Решаем тесты. Готовимся к ВПР. Вариант 2",
                    "skill_name": "Применять условие принадлежности точки с заданными координатами графику функции",
                    "skill_id": 39
                }
            ]
        }

        $scope.userList = $scope.testHeatMapData2.user_list

        $scope.questionsNames = $scope.testHeatMapData2.quiz_question_list

        $scope.studentColors =  $scope.testHeatMapData2.quiz_result.student_quiz_result_list

        $scope.heatmap = false

        $scope.showHeatmap = function () {
            $scope.heatmap = true
            $scope.first = false
        }
        $scope.hideHeatmap = function () {
            $scope.heatmap = false
            $scope.first = true
        }

        $scope.testHeatMapData = {
            "quiz_result": {
                "quiz_id": "7",
                "student_quiz_result_list": [
                    {
                        "quiz_id": "7",
                        "student_id": 2663,
                        "result": 52
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 2664,
                        "result": 21
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 2665,
                        "result": 43
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1696,
                        "result": 41
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1785,
                        "result": 72
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1786,
                        "result": 77
                    },
                    {
                        "quiz_id": "7",
                        "student_id": 1842,
                        "result": 87
                    }
                ]
            },
            "user_list": [
                {
                    "id": 2663,
                    "first_name": "Денис",
                    "last_name": "Куштанов",
                    "middle_name": "Марсович"
                },
                {
                    "id": 2664,
                    "first_name": "Анастасия",
                    "last_name": "Лялина",
                    "middle_name": "Сергеевна"
                },
                {
                    "id": 2665,
                    "first_name": "Элина",
                    "last_name": "Мордовец",
                    "middle_name": "Николаевна"
                },
                {
                    "id": 1696,
                    "first_name": "Иван",
                    "last_name": "Ильин",
                    "middle_name": "Алексеевич"
                },
                {
                    "id": 1785,
                    "first_name": "Даниил",
                    "last_name": "Шафиков",
                    "middle_name": "Азатович"
                },
                {
                    "id": 1786,
                    "first_name": "Артем",
                    "last_name": "Бабюк",
                    "middle_name": "Александрович"
                },
                {
                    "id": 1842,
                    "first_name": "Алексей",
                    "last_name": "Айбашев",
                    "middle_name": "Вадимович"
                }
            ]
        }

        // $scope.userList = []
        $scope.quizData = $scope.testHeatMapData.quiz_result.student_quiz_result_list.map(function (item){
            return item.result
        })


        $scope.setColor = function (num) {
            var x,y,z

            if (num <= 49 ){
                // где 0 красный, а 50 желтый
                x = 255
                y = 255/49*num
                z = 70

            } else {

                var count = num-49

                x = 255-255/50*count
                y = 255
                z = 70
            }
            var colorString = "rgba("+x+","+y+","+z+",0.6)"
            return colorString
        }
        //
        $scope.colorList = $scope.quizData.map(function (el){
            return $scope.setColor(el)
        })

        $scope.createNewWork = false





        $scope.groups = []
        $scope.selectedItem = null
        $scope.coursesItem = null
        $scope.courses = []
        $scope.courses2 = []
        $scope.questionsIdUrl = 'http://10.1.16.110:8090/quiz/9/assignment'
        $scope.questionsId = {
            "id": 10,
            "quiz_id": 9,
            "assigned_user_id": 123,
            "question_ids": [
                1358,
                1357,
                1087,
                1355,
                4848,
                4842,
                4874,
                4880
            ],
            "lesson_id": 1239653,
            "topic_id": null,
            "created_by": 123,
            "created_at": "2020-12-21T10:06:25.070060+03:00",
            "changed_by": 123,
            "changed_at": "2020-12-21T14:57:53.417062+03:00"
        }
        $scope.question1Url = 'http://10.1.16.110:8090/question/1679'
        $scope.question1 = {
            "id": 1679,
            "name": "Рациональные и иррациональные числа. Задание 2",
            "description": "Проверьте себя!",
            "question": "<p>Найдите приближённое значение площади круга радиуса <formula>7</formula> см, <formula>\\pi \\approx 3,1.</formula> Впишите ответ.</p><p>Ответ: [a1]</p>",
            "answers": [
                {
                    "id": 357903,
                    "placeholder": "a1",
                    "number": 1,
                    "answers_options": [
                        {
                            "id": 3391102,
                            "text": "151,9",
                            "is_correct": true,
                            "number": 1
                        }
                    ]
                }
            ],
            "lesson_id": 1239795,
            "lesson_name": 1239696,
            "course_id": 430056,
            "course_name": "Рациональные и иррациональные числа",
            "complexity": 1,
            "number_in_section": 2,
            "section_id": 1240698,
            "type_id": 3,
            "created_by": {
                "id": 3,
                "first_name": "Algebra 8",
                "middle_name": "Administrator",
                "last_name": "None"
            },
            "created_at": "2020-11-26T16:59:35.622074+03:00",
            "changed_by": {
                "id": 3,
                "first_name": "Administrator",
                "middle_name": "Administrator",
                "last_name": "None"
            },
            "changed_at": "2020-11-26T17:01:23.599074+03:00",
            "from_trainer": null
        }
        $scope.questions = []

        // Big fix

        var filterData = [
            {
                "id": 430053,
                "name": "Алгебра 7 класс",
                "topics": [
                    {
                        "id": 1239638,
                        "number": 1,
                        "name": "Выражения",
                        "folder": "1",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239647,
                                "name": "Выражения",
                                "number": 1
                            },
                            {
                                "id": 1239648,
                                "name": "Зависимости.Формулы",
                                "number": 2
                            },
                            {
                                "id": 1239649,
                                "name": "Уравнения с одной переменной",
                                "number": 3
                            },
                            {
                                "id": 1239650,
                                "name": "Решение задач с помощью уравнений",
                                "number": 4
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239639,
                        "number": 2,
                        "name": "Функция",
                        "folder": "2",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239651,
                                "name": "Функции и их графики",
                                "number": 1
                            },
                            {
                                "id": 1239652,
                                "name": "Функция y = kx и её график",
                                "number": 2
                            },
                            {
                                "id": 1239653,
                                "name": "Линейная функция и её график",
                                "number": 3
                            },
                            {
                                "id": 1239654,
                                "name": "Функции у = x², y = x³, y = abc|x|",
                                "number": 4
                            },
                            {
                                "id": 1239655,
                                "name": "Графики функций вокруг нас",
                                "number": 5
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239640,
                        "number": 3,
                        "name": "Тематическая контрольная работа  № 1",
                        "folder": "3",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239656,
                                "name": "Тематическая контрольная работа № 1",
                                "number": 1
                            }
                        ],
                        "subType": 1
                    },
                    {
                        "id": 1239641,
                        "number": 4,
                        "name": "Степень с натуральным показателем",
                        "folder": "4",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239657,
                                "name": "Степень с натуральным показателем",
                                "number": 1
                            },
                            {
                                "id": 1239658,
                                "name": "Свойства степени с натуральным показателем",
                                "number": 2
                            },
                            {
                                "id": 1239659,
                                "name": "Одночлены",
                                "number": 3
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239642,
                        "number": 5,
                        "name": "Тематическая контрольная работа  № 2",
                        "folder": "5",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239660,
                                "name": "Тематическая контрольная работа № 2",
                                "number": 1
                            }
                        ],
                        "subType": 1
                    },
                    {
                        "id": 1239643,
                        "number": 6,
                        "name": "Многочлены",
                        "folder": "6",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239661,
                                "name": "Сумма и разность многочленов",
                                "number": 1
                            },
                            {
                                "id": 1239662,
                                "name": "Произведение одночлена и многочлена",
                                "number": 2
                            },
                            {
                                "id": 1239663,
                                "name": "Произведение многочленов",
                                "number": 3
                            },
                            {
                                "id": 1239664,
                                "name": "Целые выражения",
                                "number": 4
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239644,
                        "number": 7,
                        "name": "Формулы сокращенного умножения",
                        "folder": "7",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239665,
                                "name": "Квадрат суммы и квадрат разности двух выражений",
                                "number": 1
                            },
                            {
                                "id": 1239666,
                                "name": "Разность квадратов",
                                "number": 2
                            },
                            {
                                "id": 1239667,
                                "name": "Сумма и разность кубов",
                                "number": 3
                            },
                            {
                                "id": 1239668,
                                "name": "Преобразование целых выражений",
                                "number": 4
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239645,
                        "number": 8,
                        "name": "Разложение многочлена на множители",
                        "folder": "8",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239669,
                                "name": "Вынесение общего множителя за скобки",
                                "number": 1
                            },
                            {
                                "id": 1239670,
                                "name": "Способ группировки",
                                "number": 2
                            },
                            {
                                "id": 1239671,
                                "name": "Применение нескольких способов разложения на множители",
                                "number": 3
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239646,
                        "number": 9,
                        "name": "Тематическая контрольная работа  № 3",
                        "folder": "9",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239672,
                                "name": "Тематическая контрольная работа № 3",
                                "number": 1
                            }
                        ],
                        "subType": 1
                    },
                    {
                        "id": 1239647,
                        "number": 10,
                        "name": "Алгебраические дроби",
                        "folder": "10",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239673,
                                "name": "Алгебраическая дробь",
                                "number": 1
                            },
                            {
                                "id": 1239674,
                                "name": "Сокращение дробей",
                                "number": 2
                            },
                            {
                                "id": 1239675,
                                "name": "Приведение дробей к общему знаменателю",
                                "number": 3
                            },
                            {
                                "id": 1239676,
                                "name": "Сложение и вычитание алгебраических дробей",
                                "number": 4
                            },
                            {
                                "id": 1239677,
                                "name": "Умножение и деление алгебраических дробей",
                                "number": 5
                            },
                            {
                                "id": 1239678,
                                "name": "Совместные действия над алгебраическим дробями",
                                "number": 6
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239648,
                        "number": 11,
                        "name": "Системы линейных уравнений",
                        "folder": "11",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239679,
                                "name": "Линейное уравнение с двумя переменными и их системы",
                                "number": 1
                            },
                            {
                                "id": 1239680,
                                "name": "Способы решения систем линейных уравнений с двумя переменными",
                                "number": 2
                            },
                            {
                                "id": 1239681,
                                "name": "Решение задач с помощью систем линейных уравнений с двумя переменными",
                                "number": 3
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239649,
                        "number": 12,
                        "name": "Тематическая контрольная работа  № 4",
                        "folder": "12",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239682,
                                "name": "Тематическая контрольная работа № 4",
                                "number": 1
                            }
                        ],
                        "subType": 1
                    },
                    {
                        "id": 1239650,
                        "number": 13,
                        "name": "Введение в комбинаторику",
                        "folder": "13",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239683,
                                "name": "Различные комбинации из n элементов",
                                "number": 1
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239651,
                        "number": 14,
                        "name": "Вероятность и статистика",
                        "folder": "14",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239684,
                                "name": "Случайные события",
                                "number": 1
                            },
                            {
                                "id": 1239685,
                                "name": "Относительная частота случайного события",
                                "number": 2
                            },
                            {
                                "id": 1239686,
                                "name": "Вероятность случайного события",
                                "number": 3
                            },
                            {
                                "id": 1239687,
                                "name": "Статистические характеристики:мода, медиана, размах, среднее арифметическое",
                                "number": 4
                            }
                        ],
                        "subType": null
                    },
                    {
                        "id": 1239652,
                        "number": 15,
                        "name": "Тематическая контрольная работа  № 5",
                        "folder": "15",
                        "courseId": 430053,
                        "lessons": [
                            {
                                "id": 1239688,
                                "name": "Тематическая контрольная работа № 5",
                                "number": 1
                            }
                        ],
                        "subType": 1
                    }
                ]
            },
            {
                "id": 430056,
                "name": "Алгебра 8 класс",
                "topics": [{"id":1239695,"number":1,"name":"Алгебраические дроби","folder":"1","courseId":430056,"lessons":[{"id":1239790,"name":"Сокращение дробей","number":1},{"id":1239791,"name":"Сложение и вычитание алгебраических дробей","number":2},{"id":1239792,"name":"Умножение и деление алгебраических дробей","number":3},{"id":1239793,"name":"Совместные действия над алгебраическим дробями","number":4},{"id":1239794,"name":"Функция y=k/x и её график","number":5}],"subType":null},{"id":1239696,"number":2,"name":"Действительные числа. Арифметический квадратный корень","folder":"2","courseId":430056,"lessons":[{"id":1239795,"name":"Рациональные и иррациональные числа","number":1},{"id":1239796,"name":"Квадратные корни. Арифметический квадратный корень","number":2},{"id":1239797,"name":"Уравнение вида x^2=a","number":3},{"id":1239798,"name":"Функция y=sqrt(x). График функции y=sqrt(x)","number":4}],"subType":null},{"id":1239697,"number":3,"name":"Свойства арифметического квадратного корня","folder":"3","courseId":430056,"lessons":[{"id":1239799,"name":"Квадратный корень из произведения и дроби","number":1},{"id":1239800,"name":"Квадратный корень из степени","number":2},{"id":1239801,"name":"Вынесение множителя из под знака корня","number":3},{"id":1239802,"name":"Внесение множителя под знак корня","number":4},{"id":1239803,"name":"Преобразование выражений содержащих арифметический квадратный корень","number":5},{"id":1239804,"name":"Избавление от иррациональности в знаменателе","number":6}],"subType":null},{"id":1239698,"number":4,"name":"Квадратные уравнения","folder":"4","courseId":430056,"lessons":[{"id":1239805,"name":"Определение квадратного уравнения","number":1},{"id":1239806,"name":"Неполные квадратные уравнения","number":2},{"id":1239807,"name":"Решение квадратных уравнений выделением квадрата двучлена","number":3},{"id":1239808,"name":"Решение квадратных уравнений по формуле","number":4},{"id":1239809,"name":"Теорема Виета","number":5},{"id":1239810,"name":"Решение задач с помошью квадратных уравнений","number":6}],"subType":null},{"id":1239699,"number":5,"name":"Тематическая контрольная работа № 1","folder":"5","courseId":430056,"lessons":[{"id":1239811,"name":"Тематическая контрольная работа № 1","number":1}],"subType":1},{"id":1239700,"number":6,"name":"Рациональные уравнения","folder":"6","courseId":430056,"lessons":[{"id":1239812,"name":"Определение рациональных уравнений","number":1},{"id":1239813,"name":"Решение рациональных уравнений","number":2},{"id":1239814,"name":"Графический способ решения уравнений","number":3},{"id":1239815,"name":"Решение задач с помошью рациональных уравнений","number":4}],"subType":null},{"id":1239701,"number":7,"name":"Числовые неравенства и их свойства","folder":"7","courseId":430056,"lessons":[{"id":1239816,"name":"Свойства числовых неравенств","number":1},{"id":1239817,"name":"Сложение числовых неравенств","number":2},{"id":1239818,"name":"Умножение числовых неравенств","number":3},{"id":1239819,"name":"Числовые промежутки","number":4}],"subType":null},{"id":1239702,"number":8,"name":"Неравенства с одной переменной","folder":"8","courseId":430056,"lessons":[{"id":1239820,"name":"Решение неравенств с одной переменной","number":1},{"id":1239821,"name":"Решение систем неравенств с одной переменной","number":2}],"subType":null},{"id":1239703,"number":9,"name":"Тематическая контрольная работа № 2","folder":"9","courseId":430056,"lessons":[{"id":1239822,"name":"Тематическая контрольная работа № 2","number":1}],"subType":1},{"id":1239704,"number":10,"name":"Степень с целым показателем","folder":"10","courseId":430056,"lessons":[{"id":1239823,"name":"Определение степени с целым отрицательным показателем","number":1},{"id":1239824,"name":"Свойства степени с целым отрицательным показателем","number":2}],"subType":null},{"id":1239705,"number":11,"name":"Стандартный вид числа","folder":"11","courseId":430056,"lessons":[{"id":1239825,"name":"Определение стандартного вида числа","number":1},{"id":1239826,"name":"Выполнение действий над числами в стандартном виде","number":2}],"subType":null},{"id":1239706,"number":12,"name":"Приближённые вычисления","folder":"12","courseId":430056,"lessons":[{"id":1239827,"name":"Приближённые вычисления","number":1},{"id":1239828,"name":"Абсолютная и относительная погрешность","number":2},{"id":1239829,"name":"Действия над приближенными значениями","number":3}],"subType":null},{"id":1239707,"number":13,"name":"Тематическая контрольная работа № 3","folder":"13","courseId":430056,"lessons":[{"id":1239830,"name":"Тематическая контрольная работа № 3","number":1}],"subType":1},{"id":1239708,"number":14,"name":"Статистика, вероятность и комбинаторика","folder":"14","courseId":430056,"lessons":[{"id":1239831,"name":"Статистические характеристики","number":1},{"id":1239832,"name":"Вероятность равновозможных событий","number":2},{"id":1239833,"name":"Перестановки","number":3},{"id":1239834,"name":"Размещения и сочетания","number":4}],"subType":null},{"id":1239709,"number":15,"name":"Тематическая контрольная работа № 4","folder":"15","courseId":430056,"lessons":[{"id":1239835,"name":"Тематическая контрольная работа № 4","number":1}],"subType":1}]
            },
            {
                "id": 430057,
                "name": "Алгебра 9 класс",
                "topics": [{"id":1239710,"number":1,"name":"Квадратичная функция","folder":"1","courseId":430057,"lessons":[{"id":1239836,"name":"Функция f = ax^2, график и свойства","number":1},{"id":1239837,"name":"Функция f = ax^2+n, график и свойства","number":2},{"id":1239838,"name":"Функция f = a(x – m)^2, график и свойства","number":3},{"id":1239839,"name":"Построение параболы по точкам","number":4}],"subType":null},{"id":1239711,"number":2,"name":"Тематическая контрольная работа № 1","folder":"2","courseId":430057,"lessons":[{"id":1239840,"name":"Тематическая контрольная работа № 1","number":1}],"subType":1},{"id":1239712,"number":3,"name":"Квадратный трехчлен","folder":"3","courseId":430057,"lessons":[{"id":1239841,"name":"Квадратный трехчлен и его корни","number":1},{"id":1239842,"name":"Разложение на множители квадратного трехчлена","number":2}],"subType":null},{"id":1239713,"number":4,"name":"Неравенства","folder":"4","courseId":430057,"lessons":[{"id":1239843,"name":"Неравенства второй степени с одной переменной","number":1},{"id":1239844,"name":"Метод интервалов","number":2}],"subType":null},{"id":1239714,"number":5,"name":"Тематическая контрольная работа № 2","folder":"5","courseId":430057,"lessons":[{"id":1239845,"name":"Тематическая контрольная работа № 2","number":1}],"subType":1},{"id":1239715,"number":6,"name":"Функция вида f=x^n","folder":"6","courseId":430057,"lessons":[{"id":1239846,"name":"Вид функции f= x^n","number":1},{"id":1239847,"name":"Четные и нечетные функции","number":2}],"subType":null},{"id":1239716,"number":7,"name":"Корень n-ой степени","folder":"7","courseId":430057,"lessons":[{"id":1239848,"name":"Определение корня n-ой степени","number":1},{"id":1239849,"name":"Свойства корня n-ой степени","number":2},{"id":1239850,"name":"Преобразование выражений, содержащих корень n-ой степени","number":3}],"subType":null},{"id":1239717,"number":8,"name":"Степень с рациональным показателем","folder":"8","courseId":430057,"lessons":[{"id":1239851,"name":"Определение степени с рациональным показателем","number":1},{"id":1239852,"name":"Свойства степени с рациональным показателем","number":2},{"id":1239853,"name":"Преобразование выражений, содержащих степень c рациональным показателем","number":3}],"subType":null},{"id":1239718,"number":9,"name":"Уравнения с одной переменной","folder":"9","courseId":430057,"lessons":[{"id":1239854,"name":"Целое уравнение и его корни","number":1},{"id":1239855,"name":"Уравнения, приводимые к квадратным","number":2}],"subType":null},{"id":1239719,"number":10,"name":"Тематическая контрольная работа № 3","folder":"10","courseId":430057,"lessons":[{"id":1239856,"name":"Тематическая контрольная работа № 3","number":1}],"subType":1},{"id":1239720,"number":11,"name":"Системы уравнений с двумя переменными","folder":"11","courseId":430057,"lessons":[{"id":1239857,"name":"Системы уравнений 2- й степени","number":1},{"id":1239858,"name":"Решение задач с помощью систем уравнений второй степени","number":2}],"subType":null},{"id":1239721,"number":12,"name":"Арифметическая прогрессия","folder":"12","courseId":430057,"lessons":[{"id":1239859,"name":"Последовательности","number":1},{"id":1239860,"name":"Определение арифметической прогрессии. Формула n-го члена арифметической прогрессии","number":2},{"id":1239861,"name":"Формула суммы n первых членов арифметической прогрессии","number":3}],"subType":null},{"id":1239722,"number":13,"name":"Геометрическая прогрессия","folder":"13","courseId":430057,"lessons":[{"id":1239862,"name":"Определение геометрической прогрессии.Формула n-го члена геометрической прогрессии","number":1},{"id":1239863,"name":"Формула суммы n первых членов геометрической прогрессии","number":2}],"subType":null},{"id":1239723,"number":14,"name":"Тематическая контрольная работа № 4","folder":"14","courseId":430057,"lessons":[{"id":1239864,"name":"Тематическая контрольная работа № 4","number":1}],"subType":1},{"id":1239724,"number":15,"name":"Элементы комбинаторики","folder":"15","courseId":430057,"lessons":[{"id":1239865,"name":"Решение комбинаторных задач","number":1},{"id":1239866,"name":"Перестановки","number":2},{"id":1239867,"name":"Размещения","number":3},{"id":1239868,"name":"Сочетания","number":4}],"subType":null},{"id":1239725,"number":16,"name":"Элементы теории вероятностей","folder":"16","courseId":430057,"lessons":[{"id":1239869,"name":"Вероятность случайного события","number":1},{"id":1239870,"name":"Вероятность равновозможных событий","number":2}],"subType":null},{"id":1239726,"number":17,"name":"Статистические исследования","folder":"17","courseId":430057,"lessons":[{"id":1239871,"name":"Статистические характеристики","number":1},{"id":1239872,"name":"Статистические исследования","number":2}],"subType":null},{"id":1239727,"number":18,"name":"Тематическая контрольная работа № 5","folder":"18","courseId":430057,"lessons":[{"id":1239873,"name":"Тематическая контрольная работа № 5","number":1}],"subType":1},{"id":1239728,"number":19,"name":"Тригонометрические функции","folder":"19","courseId":430057,"lessons":[{"id":1239874,"name":"Радианная мера угла","number":1},{"id":1239875,"name":"Определения синуса, косинуса, тангенса, котангенса","number":2}],"subType":null},{"id":1239729,"number":20,"name":"Основные тригонометрические формулы","folder":"20","courseId":430057,"lessons":[{"id":1239876,"name":"Соотношения между тригонометрическими функциями одного и того же угла","number":1}],"subType":null},{"id":1239730,"number":21,"name":"Тригонометрические преобразования","folder":"21","courseId":430057,"lessons":[{"id":1239877,"name":"Преобразование тригонометрических выражений","number":1},{"id":1239878,"name":"Значения синуса, косинуса, тангенса и котангенса некоторых углов","number":2}],"subType":null},{"id":1239731,"number":22,"name":"Тематическая контрольная работа № 6","folder":"22","courseId":430057,"lessons":[{"id":1239879,"name":"Тематическая контрольная работа № 6","number":1}],"subType":1}]
            },
            {
                "id": 430054,
                "name": "Математика 5 класс",
                "topics": [{"id":1239653,"number":1,"name":"Линии и шкалы","folder":"1","courseId":430054,"lessons":[{"id":1239689,"name":"Разнообразный мир линий","number":1},{"id":1239690,"name":"Шкалы и координаты","number":2}],"subType":null},{"id":1239654,"number":2,"name":"Натуральные числа","folder":"2","courseId":430054,"lessons":[{"id":1239691,"name":"Натуральные числа. Сравнение и округление натуральных чисел","number":1},{"id":1239692,"name":"Сложение и вычитание натуральных чисел","number":2},{"id":1239693,"name":"Умножение и деление натуральных чисел. Степень числа","number":3},{"id":1239694,"name":"Порядок выполнения действий","number":4}],"subType":null},{"id":1239655,"number":3,"name":"Уравнения","folder":"3","courseId":430054,"lessons":[{"id":1239695,"name":"Числовые и буквенные выражения. Формулы","number":1},{"id":1239696,"name":"Уравнения","number":2}],"subType":null},{"id":1239656,"number":4,"name":"Задачи на движение","folder":"5","courseId":430054,"lessons":[{"id":1239697,"name":"Совместное движение","number":1},{"id":1239698,"name":"Движение по течению и против течения","number":2}],"subType":null},{"id":1239657,"number":5,"name":"Углы","folder":"6","courseId":430054,"lessons":[{"id":1239699,"name":"Угол. Виды углов","number":1},{"id":1239700,"name":"Измерение углов","number":2}],"subType":null},{"id":1239658,"number":6,"name":"Фигуры на плоскости","folder":"7","courseId":430054,"lessons":[{"id":1239701,"name":"Многоугольник. Треугольник","number":1},{"id":1239702,"name":"Прямоугольник","number":2},{"id":1239703,"name":"Окружность и круг","number":3}],"subType":null},{"id":1239659,"number":7,"name":"Многогранники. Прямоугольный параллелепипед","folder":"8","courseId":430054,"lessons":[{"id":1239704,"name":"Многогранники. Прямоугольный параллелепипед","number":1},{"id":1239705,"name":"Объём прямоугольного параллелепипеда","number":2}],"subType":null},{"id":1239660,"number":8,"name":"Площади и объёмы","folder":"9","courseId":430054,"lessons":[{"id":1239706,"name":"Площади. Площадь прямоугольника","number":1}],"subType":null},{"id":1239661,"number":9,"name":"Что такое дробь","folder":"10","courseId":430054,"lessons":[{"id":1239707,"name":"Доли и обыкновенные дроби","number":1},{"id":1239708,"name":"Сравнение обыкновенных дробей","number":2},{"id":1239709,"name":"Деление и дроби","number":3}],"subType":null},{"id":1239662,"number":10,"name":"Действия с дробями","folder":"11","courseId":430054,"lessons":[{"id":1239710,"name":"Сложение и вычитание дробей с одинаковыми знаменателями","number":1},{"id":1239711,"name":"Смешанные числа","number":2},{"id":1239712,"name":"Сложение и вычитание смешанных чисел","number":3}],"subType":null},{"id":1239663,"number":11,"name":"Решение задач","folder":"12","courseId":430054,"lessons":[{"id":1239713,"name":"Как найти часть от целого?","number":1},{"id":1239714,"name":"Как найти целое по значению части?","number":2},{"id":1239715,"name":"Обобщаем знания по теме «Обыкновенные дроби»","number":3}],"subType":null},{"id":1239664,"number":12,"name":"Десятичные дроби","folder":"13","courseId":430054,"lessons":[{"id":1239716,"name":"Десятичная запись дробных чисел","number":1},{"id":1239717,"name":"Сравнение десятичных дробей","number":2},{"id":1239718,"name":"Сложение и вычитание десятичных дробей","number":3},{"id":1239719,"name":"Умножение и деление десятичных дробей на натуральное число","number":4},{"id":1239720,"name":"Умножение и деление десятичных дробей","number":5},{"id":1239721,"name":"Приближённые значения чисел","number":6},{"id":1239722,"name":"Среднее арифметическое","number":7}],"subType":null},{"id":1239665,"number":13,"name":"Проценты","folder":"14","courseId":430054,"lessons":[{"id":1239723,"name":"Что такое процент","number":1},{"id":1239724,"name":"Задачи на проценты","number":2}],"subType":null},{"id":1239666,"number":14,"name":"Таблицы и диаграммы","folder":"15","courseId":430054,"lessons":[{"id":1239725,"name":"Таблицы","number":1},{"id":1239726,"name":"Диаграммы","number":2}],"subType":null},{"id":1239667,"number":15,"name":"Тематическая контрольная работа № 1","folder":"15","courseId":430054,"lessons":[{"id":1239727,"name":"Тематическая контрольная работа № 1","number":1}],"subType":1},{"id":1239668,"number":16,"name":"Тематическая контрольная работа № 2","folder":"16","courseId":430054,"lessons":[{"id":1239728,"name":"Тематическая контрольная работа № 2","number":1}],"subType":1},{"id":1239669,"number":17,"name":"Тематическая контрольная работа № 3","folder":"18","courseId":430054,"lessons":[{"id":1239729,"name":"Тематическая контрольная работа № 3","number":1}],"subType":1},{"id":1239670,"number":18,"name":"Тематическая контрольная работа № 4","folder":"19","courseId":430054,"lessons":[{"id":1239730,"name":"Тематическая контрольная работа № 4","number":1}],"subType":1}]
            },
            {
                "id": 430055,
                "name": "Математика 6 класс",
                "topics": [{"id":1239671,"number":1,"name":"Прямые на плоскости и в пространстве","folder":"1","courseId":430055,"lessons":[{"id":1239731,"name":"Пересекающиеся прямые","number":1},{"id":1239732,"name":"Параллельные прямые","number":2},{"id":1239733,"name":"Прямые в пространстве","number":3},{"id":1239734,"name":"Расстояние","number":4}],"subType":null},{"id":1239672,"number":2,"name":"Признаки делимости","folder":"2","courseId":430055,"lessons":[{"id":1239735,"name":"Делители и кратные","number":1},{"id":1239736,"name":"Признаки делимости на 2, на 5 и на 10","number":2},{"id":1239737,"name":"Признаки делимости на 3 и на 9","number":3}],"subType":null},{"id":1239673,"number":3,"name":"Разложение на простые множители","folder":"3","courseId":430055,"lessons":[{"id":1239738,"name":"Простые и составные числа","number":1},{"id":1239739,"name":"Разложение на простые множители","number":2}],"subType":null},{"id":1239674,"number":4,"name":"Наибольший общий делитель и наименьшее общее кратное","folder":"4","courseId":430055,"lessons":[{"id":1239740,"name":"Наибольший общий делитель. Взаимно простые числа","number":1},{"id":1239741,"name":"Наименьшее общее кратное","number":2},{"id":1239742,"name":"Решение задач на НОД и НОК","number":3}],"subType":null},{"id":1239675,"number":5,"name":"Основное свойство дроби","folder":"5","courseId":430055,"lessons":[{"id":1239743,"name":"Основное свойство дроби","number":1},{"id":1239744,"name":"Сокращение дробей","number":2}],"subType":null},{"id":1239676,"number":6,"name":"Сравнение дробей","folder":"6","courseId":430055,"lessons":[{"id":1239745,"name":"Приведение дробей к общему знаменателю","number":1},{"id":1239746,"name":"Сравнение дробей","number":2}],"subType":null},{"id":1239677,"number":7,"name":"Сложение и вычитание дробей","folder":"7","courseId":430055,"lessons":[{"id":1239747,"name":"Сложение и вычитание дробей с разными знаменателями","number":1},{"id":1239748,"name":"Сложение и вычитание смешанных чисел","number":2}],"subType":null},{"id":1239678,"number":8,"name":"Умножение дробей","folder":"8","courseId":430055,"lessons":[{"id":1239749,"name":"Умножение дробей","number":1},{"id":1239750,"name":"Нахождение дроби от числа","number":2},{"id":1239751,"name":"Как упростить вычисления","number":3},{"id":1239752,"name":"Взаимно обратные числа","number":4}],"subType":null},{"id":1239679,"number":9,"name":"Деление дробей","folder":"9","courseId":430055,"lessons":[{"id":1239753,"name":"Деление дробей","number":1},{"id":1239754,"name":"Нахождение числа по его дроби","number":2},{"id":1239755,"name":"Дробные выражения","number":3}],"subType":null},{"id":1239680,"number":10,"name":"Отношения и пропорции","folder":"10","courseId":430055,"lessons":[{"id":1239756,"name":"Отношение чисел и величин","number":1},{"id":1239757,"name":"Пропорции","number":2},{"id":1239758,"name":"Масштаб","number":3}],"subType":null},{"id":1239681,"number":11,"name":"Прямые и окружности","folder":"11","courseId":430055,"lessons":[{"id":1239759,"name":"Прямая и окружность","number":1},{"id":1239760,"name":"Две окружности на плоскости","number":2},{"id":1239761,"name":"Круглые тела","number":3}],"subType":null},{"id":1239682,"number":12,"name":"Положительные и отрицательные числа","folder":"12","courseId":430055,"lessons":[{"id":1239762,"name":"Координатная прямая","number":1},{"id":1239763,"name":"Противоположные числа","number":2},{"id":1239764,"name":"Модуль числа","number":3},{"id":1239765,"name":"Сравнение чисел","number":4}],"subType":null},{"id":1239683,"number":13,"name":"Сложение и вычитание чисел","folder":"13","courseId":430055,"lessons":[{"id":1239766,"name":"Сложение чисел","number":1},{"id":1239767,"name":"Вычитание чисел","number":2}],"subType":null},{"id":1239684,"number":14,"name":"Умножение и деление положительных и отрицательных чисел","folder":"14","courseId":430055,"lessons":[{"id":1239768,"name":"Умножение положительных и отрицательных чисел","number":1},{"id":1239769,"name":"Деление положительных и отрицательных чисел","number":2}],"subType":null},{"id":1239685,"number":15,"name":"Рациональные числа","folder":"15","courseId":430055,"lessons":[{"id":1239770,"name":"Рациональные числа","number":1},{"id":1239771,"name":"Свойства действий с рациональными числами","number":2}],"subType":null},{"id":1239686,"number":16,"name":"Симметрия","folder":"16","courseId":430055,"lessons":[{"id":1239772,"name":"Осевая симметрия","number":1},{"id":1239773,"name":"Ось симметрии фигуры","number":2},{"id":1239774,"name":"Центральная симметрия","number":3}],"subType":null},{"id":1239687,"number":17,"name":"Уравнения","folder":"17","courseId":430055,"lessons":[{"id":1239775,"name":"Раскрытие скобок","number":1},{"id":1239776,"name":"Коэффициент","number":2},{"id":1239777,"name":"Подобные слагаемые","number":3},{"id":1239778,"name":"Решение уравнений","number":4}],"subType":null},{"id":1239688,"number":18,"name":"Координаты на плоскости","folder":"18","courseId":430055,"lessons":[{"id":1239779,"name":"Координаты на плоскости","number":1}],"subType":null},{"id":1239689,"number":19,"name":"Многоугольники и многогранники","folder":"19","courseId":430055,"lessons":[{"id":1239780,"name":"Параллелограмм и его виды","number":1},{"id":1239781,"name":"Правильные многоугольники","number":2},{"id":1239782,"name":"Площади","number":3},{"id":1239783,"name":"Призма","number":4},{"id":1239784,"name":"Пирамида","number":5}],"subType":null},{"id":1239690,"number":20,"name":"Комбинаторика","folder":"20","courseId":430055,"lessons":[{"id":1239785,"name":"Решение комбинаторных задач","number":1}],"subType":null},{"id":1239691,"number":21,"name":"Тематическая контрольная работа № 1","folder":"21","courseId":430055,"lessons":[{"id":1239786,"name":"Тематическая контрольная работа № 1","number":1}],"subType":1},{"id":1239692,"number":22,"name":"Тематическая контрольная работа № 2","folder":"22","courseId":430055,"lessons":[{"id":1239787,"name":"Тематическая контрольная работа № 2","number":1}],"subType":1},{"id":1239693,"number":23,"name":"Тематическая контрольная работа № 3","folder":"23","courseId":430055,"lessons":[{"id":1239788,"name":"Тематическая контрольная работа № 3","number":1}],"subType":1},{"id":1239694,"number":24,"name":"Тематическая контрольная работа № 4","folder":"24","courseId":430055,"lessons":[{"id":1239789,"name":"Тематическая контрольная работа № 4","number":1}],"subType":1}]
            }

        ]

        $scope.subjectFilterData = filterData.map(function (el){
            return {
                id: el.id,
                name: el.name
            }
        })
        console.log($scope.subjectFilterData)


        $scope.chosenTopicId = null





        // Big fix end


        $scope.setStudentsListForSend = function (){

        }
        $scope.description
        $scope.setDescription = function (){
            //"Назначен на 7-В выборочно (7 учеников)"
            var str = "Назначен на "
            if ($scope.optionsTwo === 'Выдать всем'){
                str = str + $scope.selectedItemGroups.userGroup.name
            } else {
                str = str + $scope.selectedItemGroups.userGroup.name + "выборочно (" + "1 ученику)"
            }

            $scope.description = str

        }



        $scope.questions.push($scope.question1)

        $scope.first = true

        $scope.tempDiagnostics = [
            {
                name: "Название 1",
                content: "Линейная функция и ее график"
            },
            {
                name: "Название 2",
                content: "Линейная функция и ее график"
            },
            {
                name: "Название 3",
                content: "Линейная функция и ее график"
            }
        ]

        $scope.tempQuestions = []

        $scope.tempQuestion1 = {
            "name": "Рациональные и иррациональные числа. Задание 2",
            "description": "Проверьте себя!",
            "question": "Вычислите 13,2 : 2,2 + 15 · 4 − (7,2 + 2,8). ",
            "answers": [
            {
                "id": 359330,
                "text": "3",
                "is_correct": false,
                "number": 4
            },
            {
                "id": 359329,
                "text": "1",
                "is_correct": false,
                "number": 3
            },
            {
                "id": 359327,
                "text": "-3",
                "is_correct": false,
                "number": 1
            }
        ]
        }
        $scope.tempQuestion2 = {
            "name": "Рациональные и иррациональные числа. Задание 3",
            "description": "Проверьте себя!",
            "question": "Вычислите 13,2 : 2,2 + 15 · 4 − (7,2 + 2,8). ",
            "answers": [
                {
                    "id": 359330,
                    "text": "3",
                    "is_correct": false,
                    "number": 4
                },
                {
                    "id": 359329,
                    "text": "1",
                    "is_correct": false,
                    "number": 3
                },
                {
                    "id": 359327,
                    "text": "-3",
                    "is_correct": false,
                    "number": 1
                }
            ]
        }

        $scope.tempQuestions.push($scope.tempQuestion1)
        $scope.tempQuestions.push($scope.tempQuestion2)

        $scope.newDiagnostic = function (){
            $scope.first = false
            $scope.createNewWork = true
        }
        $scope.studentIframe = false
        $scope.startNewQuiz = function (){
            $scope.setStudentUrl()
            $scope.first = false
            // $scope.studentIframe = true
            // console.log($scope.studentIframe)

        }

        $scope.groupInsteadStudents = true
        $scope.newDiagnosticSend = function (){

            var dataSample = {
                "lesson_id": 1239653,
                "topic_id": 1239639,
                "student_id_list": [123, 456, 789],
                "deadline_date": "2021-12-25T18:00:00Z"
            }
            var studentsList = [1644]
            // if($scope.groupInsteadStudents){
            //     studentsList = $scope.students.map(function (el){
            //         return el.id
            //     })
            //     console.log(studentsList)
            // } else {
            //     // studentsList = selectedItemStudents.id
            //     studentsList = $scope.students.map(function (el){
            //         return el.id
            //     })
            // }
            console.log(studentsList)
            console.log($scope.students)

            $scope.setDescription()

            // var data = {
            //     "lesson_id": $scope.selectedLesson.id,
            //     "topic_id": $scope.selectedTheme.id,
            //     "student_id_list": studentsList,
            //     "deadline_date": "2021-12-25T18:00:00Z"
            // }
            var data = {
                "lesson_id": $scope.selectedLesson.id,
                "description": $scope.description,
                "student_id_list": studentsList,
                "deadline_date": "2021-12-25T18:00:00Z"
            }

            console.log(data)
            UserGroupResource.sendQuizData(data, function (result) {
                console.log(result)
                UserGroupResource.getQuizCreatedBy({
                    id: 123
                    // id: $auth.user.id
                }, function (result) {
                    console.log(result)
                    $scope.diagnosList = result
                })
            })

            // UserGroupResource.getQuizCreatedBy({
            //     id: 123
            //     // id: $auth.user.id
            // }, function (result) {
            //     console.log(result)
            //     $scope.diagnosList = result
            // })

            $scope.first = true
            $scope.createNewWork = false
            console.log('sending is done')
        }
        // UserGroupResource.getQuizData('', function (result) {
        //     console.log(result)
        // })

        $scope.ddd = function (){

            Groups.getAllForVideoConf(
                {
                    id: $scope._dialogId ? $scope._dialogId : 0
                },
                function (response) {
                    $scope.groups = response
                }
            )

        }
        $scope.ddd()


        $scope.selectedItemChange = function (item){
            console.log('qqqqqqqqqqqqqqqqq')
            $scope.selectedItem = item
            console.log(item)
        }

        $scope.courseChosen = true
        $scope.isDisabledTheme = true
        $scope.isDisabledLesson = true
        $scope.selectedCourseChange = function (item){


            $scope.courseChosen = false
            $scope.coursesItem = item
            console.log($scope.coursesItem)
            $scope.topicFilterData = filterData.find(function (el){
                return el.id == $scope.coursesItem.id
            }).topics.map(function (elem){
                return {
                    id: elem.id,
                    name: elem.name
                }
            })
            console.log($scope.topicFilterData)
            // $scope.queryThemePart1()
            $scope.isDisabledTheme = false
        }



        $scope.selectedTheme = null
        $scope.queryThemePart1 = function (){
            TopicResource.getAllTopicsByCourseId({'courseId' : $scope.coursesItem.course.id}, function(response){
                console.log(response)
                $scope.themes = response
                console.log($scope.themes)

            });
        }
        $scope.queryThemePart2 = function (input){
            var inputLength = input.length

            // var arr = $scope.themes.filter(function (el){
            //     return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            // })
            var arr = $scope.topicFilterData.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }


        $scope.selectedThemeChange = function (selectedTheme){
            $scope.selectedTheme = selectedTheme
            console.log(selectedTheme)
            console.log($scope.selectedTheme)
            $scope.lessons = $scope.selectedTheme.lessons
            $scope.lessonFilterData = filterData.find(function (el){
                return el.id == $scope.coursesItem.id
            }).topics.find(function (elem){
                return elem.id == $scope.selectedTheme.id
            }).lessons.map(function (element){
                return {
                    id: element.id,
                    name: element.name
                }
            })

            // console.log($scope.selectedTheme.lessons)
            // console.log($scope.lessons)
            $scope.isDisabledLesson = false
        }


        $scope.queryLesson = function (input){
            var inputLength = input.length

            var arr = $scope.lessonFilterData.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            // var arr = $scope.lessons.filter(function (el){
            //     return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            // })
            return arr
        }

        $scope.studentUrl = 'http://10.2.16.96/chatforstudents/'
        $scope.hash = 'tebe'
        $scope.setStudentUrl = function (){
            console.log('almost done')
            document.getElementById('123333').style.visibility = 'visible'
            document.getElementById('123222').setAttribute("src", 'http://10.2.16.96/chatforstudents/?rad=tebe');
            // document.getElementById('123222').setAttribute("style", 'border: 10px solid red');
        }

        $scope.setStudentUrl2 = function (){
            document.getElementById('123222')
            console.log(document.getElementById('123222'))
            document.getElementById('123222').setAttribute("src", $scope.studentUrl);
        }

        $scope.selectedLesson
        $scope.iframeIsShown = false
        $scope.groupIsShown = false
        $scope.selectedLessonChange = function (selectedLesson){
            $scope.selectedLesson = selectedLesson
            $scope.iframeIsShown = true
            $scope.groupIsShown = true
            console.log('aaaaaaaaaa')
            console.log($scope.groupIsShown)
        }

        $scope.selectedItemGroups
        $scope.studentListShown = false
        $scope.students = []
        $scope.selectedGroupsChange = function (selectedItemGroups){

            $scope.selectedItemGroups = selectedItemGroups
            $scope.students = selectedItemGroups.userGroup.users
            $scope.studentListShown = true
            console.log($scope.selectedItemGroups)
        }
        $scope.querryGroups = function (input) {
            var inputLength = input.length

            var arr = $scope.courses2.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }
        $scope.selectedItemStudents;
        $scope.selectedStudentsChange = function (selectedItemStudents){
            $scope.selectedItemStudents = selectedItemStudents
            console.log(selectedItemStudents)
        }

        $scope.querryStudents = function (input) {
            var inputLength = input.length

            var arr = $scope.students.filter(function (el){
                return el.lastName.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }




        $scope.second = function (){
            console.log('bbb')
            // UserGroupResource.getCourses({
            //     id: $scope.selectedItem.id
            // }, function (result) {
            //     console.log(result)
            //     $scope.courses = result;
            // })
            // UserGroupResource.getCourses({
            //     id: 435198
            // }, function (result) {
            //     console.log(result)
            // })
            // CourseResource.query(function(val) {
            //     $scope.courses = val;
            // });

            // console.log('aaa')
            // console.log($scope.courses)

        }
        $scope.second()


        $scope.selectedItemTopic = null

        $scope.querryTopic = function (input){
            var inputLength = input.length

            var arr = $scope.topics.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })

            return arr
        }

        $scope.third = function (){
            console.log($scope.coursesItem)
            // TopicResource.getAllTopicsByCourseId({'courseId' : coursesItem.id}, function(response){
            //     $scope.topics = response;
            //     console.log(response)
            // });

            TopicResource.getAllTopicsByCourseId({'courseId' : 3}, function(response){
                $scope.topics = response;
                console.log(response)
            });
        }
        $scope.third()


        $scope.querryGroup = function (input){
            var inputLength = input.length

            var arr = $scope.groups.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }

        $scope.querrySubject = function (input){
            var inputLength = input.length


            // var arr = $scope.courses2.filter(function (el){
            //     return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            // })
            var arr = $scope.subjectFilterData.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr

        }


        // $scope.getQuizList = function (){
        //     UserGroupResource.getData({}, function (result) {
        //         console.log(result)
        //     })
        // }
        // $scope.getQuizList()






        $scope.users = []
        $scope.searchUserText = ''
        $scope.querryUser = function (input){
            var inputLength = input.length

            var arr = $scope.users.filter(function (el){
                return el.lastName.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }
        $scope.optionsTwo = 'Выдать всем'
        $scope.isDisabledStudents = true
        $scope.switchOptionsTwo = function (){
            if($scope.optionsTwo === "Выдать всем"){
                $scope.optionsTwo ="Выдать выбранным ученикам"
                $scope.isDisabledStudents = false
            } else if ($scope.optionsTwo === "Выдать выбранным ученикам") {
                $scope.optionsTwo = "Выдать всем"
                $scope.isDisabledStudents = true
            }
            console.log($scope.optionsTwo)
        }

        $scope.diagnosList = []
        if($auth.user.userRoles[0] === "ROLE_TEACHER"){
            UserGroupResource.getQuizCreatedBy({
                id: 123
                // id: $auth.user.id
            }, function (result) {
                console.log(result)
                $scope.diagnosList = result
            })
        } else if ($auth.user.userRoles[0] === "ROLE_STUDENT"){
            UserGroupResource.getQuizAssignedTo({
                id: 123
                // id: $auth.user.id
            }, function (result) {
                console.log(result)
                $scope.diagnosList = result
            })
        }

        $scope.diagnosList2 = []
        if($auth.user.userRoles[0] === "ROLE_TEACHER"){
            UserGroupResource.getQuizCreatedBy({
                id: 123
            }, function (result) {
                console.log(result)
                $scope.diagnosList2 = result
            })
        } else if ($auth.user.userRoles[0] === "ROLE_STUDENT"){
            UserGroupResource.getQuizAssignedTo({
                id: 123
            }, function (result) {
                console.log(result)
                $scope.diagnosList2 = result
            })
        }

        $scope.getCourses = function (){
            CourseSectionResource.getAllByTeacherId({
                // id: 394,
                id: $auth.user.id,
                studyYear: 2021
            }, function (result) {
                console.log()
                $scope.courses2 = result
                console.log(result)
            });
        }
        $scope.getCourses()

    }
]);


'use strict';

app.controller('Integrationrtc', [
    '$scope',
    '$state',
    function($scope,$state) {
        // alert("a")
        var token
        var link

        function processUrl(url) {
            var tokenStart = url.indexOf('token=')
            var tokenEnd = url.indexOf('&link=')
            token = url.substring(tokenStart+6,tokenEnd)
            link = url.substr(tokenEnd+6)
            link = link.replace('%2F%23%2F','/#/')
            link = link.replace('%3A%2F%2F','://')
            link = link.replaceAll('%2F','/')
            console.log(token)
            console.log(link)
            localStorage.setItem('ls.token',generateTokenForLocalStorage(token)   );
        }
        processUrl(window.location.href)


        function generateTokenForLocalStorage(token) {
            var temp = "{\"token\""+":"+"admin:" + token + ",\"expires\":0}"
            return temp
        }

    }
]);


'use strict';

app.controller('Integrationmesh', [
    '$scope',
    '$state','$auth','UserResource',
    function($scope,$state,$auth,UserResource) {
        // alert("a")
        var token
        var link




        // $scope.lessonsList = []
        function step6() {
            UserResource.getLessons({
                num: localStorage.getItem('class_level_id'),
                du: localStorage.getItem('du_id')
            },function (res) {
                    // $scope.lessonsList = res
                    console.log('step6')
                    // $scope.carcassBase = res
                }
                )
        }
        step6()

        $scope.step7 = step7
        function step7(course,topic,lesson) {
            localStorage.setItem('course',course );
            localStorage.setItem('topic',topic );
            localStorage.setItem('lesson',lesson );
            console.log('step7')
            step8()
        }

        $scope.allStudents =[
            {
                id: 1,
                last_name: "Иванов",
                first_name: "Иван",
                middle_name: "Иванович"
            },
            {
                id: 2,
                last_name: "Иванов2",
                first_name: "Иван2",
                middle_name: "Иванович2"
            },
        ]
        function step8() {
            UserResource.getStudents({
                classId: localStorage.getItem('class_id'),
                lessonId: localStorage.getItem('lesson_id')
            },function (res) {
                console.log('step8')
                if (res.length>0){
                    // $scope.allStudents = res
                    // $scope.allStudentsForPrint = $scope.allStudents.map(function (el) {
                    //     return {
                    //         id: el.id,
                    //         last_name: el.last_name,
                    //         first_name: el.first_name,
                    //         middle_name: el.middle_name,
                    //         isChosen: false
                    //     }
                    // })
                    console.log('step9ready')
                    // step9()
                } else {
                    step10(  localStorage.getItem('course'),
                    localStorage.getItem('topic'),
                    localStorage.getItem('lesson'))
                }
            })
        }



        $scope.allStudents =[
            {
                id: 1,
                last_name: "Иванов",
                first_name: "Иван",
                middle_name: "Иванович"
            },
            {
                id: 2,
                last_name: "Иванов2",
                first_name: "Иван2",
                middle_name: "Иванович2"
            },
        ]
        $scope.allStudentsForPrint = $scope.allStudents.map(function (el) {
            return {
                id: el.id,
                last_name: el.last_name,
                first_name: el.first_name,
                middle_name: el.middle_name,
                isChosen: false
            }
        })
        $scope.chosenStudents = []
        $scope.chooseStudents = function (index) {
            $scope.chosenStudents.push( $scope.allStudentsForPrint[index])
            if ($scope.allStudentsForPrint[index].isChosen === true){
                $scope.allStudentsForPrint[index].isChosen === false
            } else {
                $scope.allStudentsForPrint[index].isChosen === true
            }
        }
        $scope.studentsAreShown = true
        $scope.step9 = function () {
            var data
            if ($scope.chosenStudents.length > 0){
                data = $scope.chosenStudents.map(function (el) {
                    return {
                        id: el.id,
                        last_name: el.last_name,
                        first_name: el.first_name,
                        middle_name: el.middle_name,
                    }
                })
                UserResource.postAttach(data,function (res) {
                    step10(localStorage.getItem('course'),
                        localStorage.getItem('topic'),
                        localStorage.getItem('lesson'))
                })
            }
        }
        $scope.step10 = step10
        function step10(course,topic,lesson) {
            $state.go('courseLesson', {
                courseId: course,
                tid: topic,
                lid: lesson,
                coursePath: 'bookshelf'
            });
        }


        $scope.currentLessons =  [
            {
                id	:	1,
                name	:	"Речь письменная и устная. Предложение",
                topic_id	:	1,
                course_id: 1,

            },
            {
                id	:	2,
                name	:	"Предложение и слово",
                topic_id	:	2,
                course_id: 1,

            },
            {
                id	:	3,
                name	:	"Речь",
                topic_id	:	3,
                course_id: 1,

            },
        ]

        $scope.carcassBase = {
            id	:	1,
            name	:	"Азбука 1 класс",
            parallel	:	1,
            topics: [
                {
                    id	:	1,
                    name	:	"Речь",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь",
                            topic_id	:	3,

                        },
                    ]
                },
                {
                    id	:	2,
                    name	:	"Речь 2",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь 2 письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь 2",
                            topic_id	:	3,

                        },
                    ]
                },
                {
                    id	:	3,
                    name	:	"Речь 3",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь 3 письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь 3",
                            topic_id	:	3,

                        },
                    ]
                },
            ]

        }

        $scope.carcassItems =  $scope.carcassBase.topics.map(function (el,indx) {
            if (indx === 0){
                return {
                    isActive: true,
                    id	:	el.id,
                    name	:	el.name,
                    course_id	:	el.course_id,
                    lessons: el.lessons

                }
            } else {
                return {
                    isActive: false,
                    id	:	el.id,
                    name	:	el.name,
                    course_id	:	el.course_id,
                    lessons: el.lessons
                }
            }
        })

        $scope.clickTopic = function (id) {

            $scope.carcassItems.forEach(function (el) {
                if (el.id === id){
                    $scope.currentLessons = el.lessons

                }
            })

            $scope.carcassItems =  $scope.carcassItems.map(function (el,indx) {
                if (el.id === id){
                    return {
                        isActive: true,
                        id	:	el.id,
                        name	:	el.name,
                        course_id	:	el.course_id,
                        lessons: el.lessons

                    }
                } else {
                    return {
                        isActive: false,
                        id	:	el.id,
                        name	:	el.name,
                        course_id	:	el.course_id,
                        lessons: el.lessons
                    }
                }
            })
        }



        $scope.goToLesson3 = function (course,topic,lesson) {

            $state.go('courseLesson', {
                courseId: course,
                tid: topic,
                lid: lesson,
                coursePath: 'bookshelf'
            });
        }

        function processUrl(url) {
            var tokenStart = url.indexOf('token=')
            var tokenEnd = url.indexOf('&link=')
            token = url.substring(tokenStart+6,tokenEnd)
            link = url.substr(tokenEnd+6)
            link = link.replace('%2F%23%2F','/#/')
            link = link.replace('%3A%2F%2F','://')
            link = link.replaceAll('%2F','/')
            console.log(token)
            console.log(link)
            localStorage.setItem('ls.token',generateTokenForLocalStorage(token)   );
        }
        // processUrl(window.location.href)




        function getClientId() {
            var url = '/mesh/clientId'
            UserResource.getClientId(url).then(function (res) {
                localStorage.setItem('client_id',res );
                document.cookie = 'client_id=' + res
            })

        }

        function getAndSetParams() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var class_level_id = urlParams.get('class_level_id')
            var class_id = urlParams.get('class_id')
            var carcass = urlParams.get('carcass')
            localStorage.setItem('class_level_id',class_level_id );
            localStorage.setItem('class_id',class_id );
            localStorage.setItem('carcass',carcass );
            document.cookie = 'class_level_id=' + class_level_id
            document.cookie =  "class_id=" + class_id
            document.cookie = 'carcass=' + carcass
        }

        function redirectFunc() {
            var redirectUrl = "http://10.1.16.102/mash/navigate/?class_level_id="
                + localStorage.getItem('class_level_id')
                + "&class_id=" + localStorage.getItem('class_id')
                + "&carcass=" + localStorage.getItem('carcass')
            var urlBase = "https://school-test.mos.ru/v1/oauth/authorize?client_id="
                + localStorage.getItem('client_id')
                +"&response_type=code&redirect_uri=" + redirectUrl + '&response_mode=query&scope=openid'
            window.location = urlBase
        }

        $scope.currentLessons =  [
            {
                id	:	1,
                name	:	"Речь письменная и устная. Предложение",
                topic_id	:	1,
                course_id: 1,

            },
            {
                id	:	2,
                name	:	"Предложение и слово",
                topic_id	:	2,
                course_id: 1,

            },
            {
                id	:	3,
                name	:	"Речь",
                topic_id	:	3,
                course_id: 1,

            },
        ]

        $scope.carcassBase = {
            id	:	1,
            name	:	"Азбука 1 класс",
            parallel	:	1,
            topics: [
                {
                    id	:	1,
                    name	:	"Речь",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь",
                            topic_id	:	3,

                        },
                    ]
                },
                {
                    id	:	2,
                    name	:	"Речь 2",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь 2 письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь 2",
                            topic_id	:	3,

                        },
                    ]
                },
                {
                    id	:	3,
                    name	:	"Речь 3",
                    course_id	:	1,
                    lessons: [
                        {
                            id	:	1,
                            name	:	"Речь 3 письменная и устная. Предложение",
                            topic_id	:	1,

                        },
                        {
                            id	:	2,
                            name	:	"Предложение и слово",
                            topic_id	:	2,

                        },
                        {
                            id	:	3,
                            name	:	"Речь 3",
                            topic_id	:	3,

                        },
                    ]
                },
            ]

        }

        $scope.carcassItems =  $scope.carcassBase.topics.map(function (el,indx) {
            if (indx === 0){
                return {
                    isActive: true,
                    id	:	el.id,
                    name	:	el.name,
                    course_id	:	el.course_id,
                    lessons: el.lessons

                }
            } else {
                return {
                    isActive: false,
                    id	:	el.id,
                    name	:	el.name,
                    course_id	:	el.course_id,
                    lessons: el.lessons
                }
            }
        })

        $scope.clickTopic = function (id) {

            $scope.carcassItems.forEach(function (el) {
                if (el.id === id){
                    $scope.currentLessons = el.lessons

                }
            })

            $scope.carcassItems =  $scope.carcassItems.map(function (el,indx) {
                if (el.id === id){
                    return {
                        isActive: true,
                        id	:	el.id,
                        name	:	el.name,
                        course_id	:	el.course_id,
                        lessons: el.lessons

                    }
                } else {
                    return {
                        isActive: false,
                        id	:	el.id,
                        name	:	el.name,
                        course_id	:	el.course_id,
                        lessons: el.lessons
                    }
                }
            })
        }

    }
]);

app.config([
    "$stateProvider",
    "u2035",
    function($stateProvider, u2035) {
        if (u2035) {
            $stateProvider.state("u2035", {
                abstract: true,
                parent: "site-without-navbar",
                url: "/2035"
            });
            $stateProvider.state("navigateU2035", {
                parent: "u2035",
                url: "/navigate?:code",
                data: {
                    noLogin: true,
                },
                views: {
                    "content@": {
                        controller: "U2035Ctrl"
                    }
                }
            });
        }
    }
])

'use strict';

app.controller("U2035Ctrl", [
    "$scope",
    "$state",
    "$auth",
    "U2035Service",
    function($scope, $state, $auth, U2035Service) {
        if ($state.params.code) {
            U2035Service.authorize($state.params.code);
        }
        else {
            $auth.signOut();
        }
    }
]);

"use strict";

angular.module("lmsClientApp").factory("U2035Resource", function($resource) {
    return $resource(
        "/u2035/",
        {},
        {
            getOAuth2035RedirectUrl: {
                method: "GET",
                url: "/u2035/redirect",
            },
            oAuth2035Authorize: {
                method: "GET",
                url: "/u2035/authorize?code=:code",
            }
        }
    );
});

"use strict";

angular.module('lmsClientApp').service("U2035Service", [
    "U2035Resource",
    "$window",
    "$state",
    "$auth",
    function(
        U2035Resource,
        $window,
        $state,
        $auth
    ) {
        this.redirectToAuthPage = redirectToAuthPage;
        this.authorize = authorize;

        function redirectToAuthPage() {
            U2035Resource.getOAuth2035RedirectUrl().$promise.then(function (res) {
                $window.location.href = res.url;
            });
        }

        function authorize(code) {
            U2035Resource.oAuth2035Authorize(
                {code: code},
                function(resp) {
                    var lmsToken = resp.token;
                    $auth.setAuthTokens(lmsToken);
                    $state.go("dashboard");
                },
                function(resp) {
                    console.error("Can`t authorize with authcode = " + code);
                    $state.go("login");
                });
        }
    }
]);

app.config([
    "$stateProvider",
    "epos",
    function($stateProvider, epos) {
        if (epos) {
            $stateProvider.state("epos", {
                abstract: true,
                parent: "site-without-navbar",
                url: "/epos"
            });
            $stateProvider.state("navigateEpos", {
                parent: "epos",
                url: "/navigate?uniqueKey&course&topic&lesson",
                data: {
                    noLogin: true,
                },
                views: {
                    "content@": {
                        controller: "EposCtrl"
                    }
                }
            });
        }
    }
])

'use strict';

app.controller("EposCtrl", [
    "$scope",
    "$state",
    "$auth",
    "EposService",
    function($scope, $state, $auth, EposService) {

        var uniqueKey = $state.params.uniqueKey;
        var courseId = $state.params.course;
        var topicId = $state.params.topic;
        var lessonId = $state.params.lesson;

        if (!uniqueKey) {
            $auth.signOut();
        }
        EposService.authorize(uniqueKey).then(
            function() {
                if (lessonId) {
                    EposService.redirectToLesson(courseId, topicId, lessonId);
                }
                else {
                    EposService.redirectToTKR(courseId, topicId);
                }
            },
            function() {
                $auth.signOut();
            }
        );

    }
]);

"use strict";

angular.module("lmsClientApp").factory("EposResource", function($resource) {
    return $resource(
        "/epos/",
        {},
        {
            eposAuthorize: {
                method: "GET",
                url: "/epos/authorize?uniqueKey=:uniqueKey",
            }
        }
    );
});

"use strict";

angular.module('lmsClientApp').service("EposService", [
    "$state",
    "$auth",
    "EposResource",
    "$q",
    "$http",
    function(
        $state,
        $auth,
        EposResource,
        $q,
        $http
    ) {
        var baseUrl = window.location.origin + "/epos/send";

        this.sendZooResult = sendZooResult;
        this.sendTestResult = sendTestResult;
        this.authorize = authorize;
        this.redirectToTKR = redirectToTKR;
        this.redirectToLesson = redirectToLesson;


        function sendZooResult(studentId, taskName, taskID, mark, uniqueKey) {
            var url = baseUrl + '/zoo/result';
            _sendResult(url, studentId, taskName, taskID, mark, uniqueKey);
        }

        function sendTestResult(studentId, taskName, taskID, mark, uniqueKey) {
            var url = baseUrl + '/test/result';
            _sendResult(url, studentId, taskName, taskID, mark, uniqueKey);
        }


        function authorize(uniqueKey) {
            var dfd = $q.defer();
            EposResource.eposAuthorize(
                {uniqueKey: uniqueKey},
                function(resp) {
                    var newUniqueKey = resp.newUniqueKey;
                    var lmsToken = resp.token;
                    $auth.setAuthTokens(lmsToken);
                    _saveNewUniqueKey(newUniqueKey);
                    dfd.resolve();
                },
                function() {
                    console.error("Can`t authorize with authcode = " + uniqueKey);
                    dfd.reject();
                });
            return dfd.promise;
        }

        function redirectToTKR(courseId, topicId) {
            $state.go(
                "courseTopicTotal",
                {
                    courseId: courseId,
                    tid: topicId
                }
            )
        }

        function redirectToLesson(courseId, topicId, lessonId) {
            $state.go(
                "courseLesson",
                {
                    courseId: courseId,
                    tid: topicId,
                    lid: lessonId
                }
            )
        }

        function _prepareData(studentId, taskName, taskID, mark) {
            var data = {
                studentID: studentId,
                taskName: taskName,
                taskID:  taskID,
                mark: mark
            };
            return data;
        }

        function _sendResult(url, studentId, taskName, taskID, mark, uniqueKey) {
            var data = _prepareData(studentId, taskName, taskID, mark);
            var config = {
                params: {uniqueKey: uniqueKey}
            };
            $http.post(url, data, config);
        }

        function _saveNewUniqueKey(newUniqueKey) {
            localStorage.setItem("newUniqueKey", newUniqueKey);
        }
    }
]);


'use strict';

app.controller('SectionsAdding', [
    '$scope',
    'Groups',
    'Users',
    'CourseResource',
    'UserGroupResource',
    'ProgressResource',
    'TopicResource',
    'CourseSectionResource',
    '$auth',
    function($scope,Groups,Users,CourseResource,UserGroupResource,ProgressResource,TopicResource,CourseSectionResource,$auth) {

        // добавление секций


        // прогресс
        $scope.progress = {
            step1: {
                started: true,
                groupIsChosen: false,
                secondQuestionAnswered: false,
                chooseWholeGrade: false,
                isDone: false

            },
            step2: {
                started: false,
                teacherIsChosen: false,
                isDone: false
            },
            step3: {
                started: false,
                courseIsChosen: false,
                isDone: false
            },
            step4: {
                started: false,
                isDone: false
            },
            success: false
        }

        // тестовые данные
        $scope.testGroups = ['11а','10Б',"9A"]
        $scope.testStudents = ["иванов","петров","сидоров"]
        $scope.testTeachers = ['менделеева1','менделеева2','менделеева3']
        $scope.testCourse = ['химия1','химия2','химия3']

        // Продвижение по прогрессу

        // 1 шаг
        $scope.groupChosen = function () {
            $scope.progress.step1.groupIsChosen = true
        }
        $scope.addWholeGrade = function () {
            $scope.progress.step1.secondQuestionAnswered = true
            $scope.progress.step1.chooseWholeGrade = true
            $scope.progress.step1.started = false
            $scope.progress.step2.started = true
            $scope.progress.step1.isDone = true

        }
        $scope.addNotWholeGrade = function () {
            $scope.progress.step1.secondQuestionAnswered = true
            $scope.progress.step1.chooseWholeGrade = false
        }
        $scope.addStudents = function () {

            $scope.progress.step1.started = false
            $scope.progress.step2.started = true
            $scope.progress.step1.isDone = true
        }
        // 2 шаг
        $scope.teacherChosen = function () {
            $scope.progress.step2.started = false
            $scope.progress.step3.started = true
            $scope.progress.step2.isDone = true

        }
        // 3 шаг
        $scope.courseChosen = function () {
            $scope.progress.step3.started = false
            $scope.progress.step4.started = true
            $scope.progress.step3.isDone = true

        }
        // 4 шаг
        $scope.nameChosen = function () {
            $scope.progress.step4.started = false
            $scope.progress.success = true
            $scope.progress.step4.isDone = true
        }

        $scope.sectionsAddingStarted = false
        $scope.startSectionsAdding = function () {
            $scope.sectionsAddingStarted = true
            $scope.sectionList = false
        }
        $scope.endSectionsAdding = function () {
            $scope.sectionsAddingStarted = false
            $scope.sectionList = true
        }


        $scope.gradesAndStudentsFromServer = [
            {
                grade1: [
                    {
                        student1Name: "гусь"
                    }
                ],
                grade2: [
                    {
                        student1Name: "гусь"
                    },
                    {
                        student1Name: "гусь"
                    },
                    {
                        student1Name: "гусь"
                    }
                ],
            }
        ]

       // I Список секций
        $scope.sectionList = true

       // II Добавление секции
       $scope.sectionAdding = false

       // III Редактирование
       // 0. При клике на карточку секции скрывается все и показывается редактор и уходит запрос
       // 1. С сервера приходит список доступных классов со студентами, учителей и курсов
       // 2. С сервара приходит объект текущей секции с выбранными классами и студентами
       // учителями и курсами и названием
       // 3. Создается третий объект, в котором будут находится все доступные классы
       // со студентами, учителями и курсами и названием, а те, что находятся в объекте
       // из пункта 2 в поле isChecked имеют true и находятся в начале списка
       // каждый из них связан через ng-model с полем isChecked

       // 4. При нажатии на кнопку сохранить создается новые объект
       // в него переносится все где где isChecked true и отправляется на сервер
       // показывается сообщение что все ок и появляется кнопка вернуться

        // 5.
        // При клике на grade его студенты уходят в отображаемые

        // 6.
        // Переключение между табами

        // 0
        $scope.sectionEditor  = false
        $scope.openSectionEditor = function (id) {
            $scope.sectionEditor = true
            $scope.sectionList = false
        }
        $scope.closeSectionEditor = function () {
            $scope.sectionEditor  = false
            $scope.sectionList = true
        }

        // 1
        $scope.sectionDataOne = {
             participants: [
                 {
                     name: "11а",
                     students: [
                         {
                             name: "Безкоровайная Полина 1"
                         },
                         {
                             name: "Безкоровайная Полина 2"
                         },
                         {
                             name: "Безкоровайная Полина 3"
                         },
                     ]
                 },
                 {
                     name: "11б",
                     students: [
                         {
                             name: "Безкоровайная Полина 1"
                         },
                         {
                             name: "Безкоровайная Полина 2"
                         },
                         {
                             name: "Безкоровайная Полина 3"
                         },
                         {
                             name: "Безкоровайная Полина 4"
                         },
                         {
                             name: "Безкоровайная Полина 5"
                         },
                         {
                             name: "Безкоровайная Полина 6"
                         },
                     ]
                 },
             ],
            teachers: [
                "менделеева 1",
                "менделеева 2",
                "менделеева 3"
            ],
            courses: [
                "химия 1",
                "химия 2",
                "химия 3"
            ]
        }

        // 2
        $scope.sectionDataTwo = {
            participants: [
                {
                    name: "11а",
                    students: [
                        {
                            name: "Безкоровайная Полина 1",
                        },
                        {
                            name: "Безкоровайная Полина 2",
                        },

                    ]
                },

            ],
            teachers: [
                "менделеева 1",
                "менделеева 2",
                "менделеева 3"
            ],
            courses: [
                "химия 1",
                "химия 2",
                "химия 3"
            ]
        }

        // 3
        // А именно сначала из sectionDataOne переносятся все элементы и им проставляется
        // поле isChosen - false
        $scope.sectionDataThreeExample = {
            participants: [
                {
                    name: "11а",
                    isChosen: true,
                    isActive: true,
                    students: [
                        {
                            name: "Безкоровайная Полина 1",
                            isChosen: true,
                        },
                        {
                            name: "Безкоровайная Полина 2",
                            isChosen: true,
                        },
                        {
                            name: "Безкоровайная Полина 3",
                            isChosen: false,
                        },
                    ]
                },
                {
                    name: "11б",
                    isChosen: false,
                    isActive: false,
                    students: [
                        {
                            name: "Безкоровайная Полина 1",
                            isChosen: false,
                        },
                        {
                            name: "Безкоровайная Полина 2",
                            isChosen: false,
                        },
                        {
                            name: "Безкоровайная Полина 3",
                            isChosen: false,
                        },
                        {
                            name: "Безкоровайная Полина 4",
                            isChosen: false,
                        },
                        {
                            name: "Безкоровайная Полина 5",
                            isChosen: false,
                        },
                        {
                            name: "Безкоровайная Полина 6",
                            isChosen: false,
                        },
                    ]
                },
            ],
            teachers: [
                "менделеева 1",
                "менделеева 2",
                "менделеева 3"
            ],
            courses: [
                "химия 1",
                "химия 2",
                "химия 3"
            ],
            name: ""
        }
        $scope.sectionDataThree = {

        }
        $scope.fillSectionDataThree = function () {
                $scope.sectionDataOne.
                participants.forEach(function (el) {
                    var students = []

                    el.students.forEach(function (elem) {

                        return {
                            name: elem.name
                        }
                    })
                    // var students = el.students.map(function (elem) {
                    //     return {
                    //         name: elem.name
                    //     }
                    // })
                    var a = students.filter(function (element) {
                        return  element.name === "Безкоровайная Полина 2"
                    })
                    if (a.length > 0 ){
                        alert('aa')
                    }
                    $scope.sectionDataThree.participants.push({
                        name: el.name,
                        isChosen: '',
                        students: students
                    })
            })
        }
        // $scope.fillSectionDataThree()

        // 5.
        $scope.clickedGrade = $scope.sectionDataThreeExample.participants[0]
        $scope.printedStudents = $scope.sectionDataThreeExample.participants[0].students
        $scope.clickGrade = function (grade) {
            $scope.sectionDataThreeExample.participants.forEach(function (el) {
                el.isActive = false
            })
            grade.isActive = true
            $scope.printedStudents = grade.students
        }

        // 6.
        $scope.tabs = [
            {
                name: "Участники",
                isActive: true
            },
            {
                name: "Учитель",
                isActive: false
            },
            {
                name: "Курс",
                isActive: false
            }
        ]
        $scope.activeTab = $scope.tabs[0]
        $scope.setActiveTab = function (tab) {
            $scope.tabs.forEach(function (el) {
                el.isActive = false
            })
            tab.isActive = true
            $scope.activeTab = tab

        }





        // Группы
        $scope.getGroups = function (){
            CourseSectionResource.getAllByTeacherId({
                // id: 394,
                id: $auth.user.id,
                studyYear: 2021
            }, function (result) {
                $scope.groups = result
                console.log(result)
            });
        }
        $scope.getGroups()
        $scope.groupsAreChosen = false
        $scope.selectedItemGroups
        $scope.groups
        $scope.selectedGroupsChange = function (selectedItemGroups){

            $scope.selectedItemGroups = selectedItemGroups
            $scope.groupsAreChosen = true
            console.log($scope.selectedItemGroups)
        }
        $scope.querryGroups = function (input) {
            var inputLength = input.length

            var arr = $scope.groups.filter(function (el){
                return el.name.slice(0,inputLength).toLocaleLowerCase() === input.slice(0,inputLength).toLocaleLowerCase()
            })
            return arr
        }










    }
]);

// app.controller("diagnostic",[
//     '$scope',function ($scope){
//             console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
//
//         }
// ]
// )
'use strict';

app.controller('SearchResults', [
    '$scope',
    '$rootScope',
    '$http',
    '$state',
    'UserGroupResource',
    'ProgressResource',
    'TopicResource',
    'CourseSectionResource',
    '$auth',
    function($scope,$rootScope,$http,$state,UserGroupResource,ProgressResource,TopicResource,CourseSectionResource,$auth) {

        console.log($rootScope.searchResults)
        $scope.searchResults = $rootScope.searchResults
        $scope.searchInput = $rootScope.searchInput
        // $rootScope.searchInput = $scope.searchInput
        var request = {
            method: 'GET',
            url: '/api/bookshelf/search?search_text='+$rootScope.searchInput+"&"
                +"per_page="+$scope.perPage+"&page="+$scope.page

        };
        $scope.resultsAreShown = true
        $scope.pages = []
        $scope.totalResults = null
        $scope.perPage = 10
        $scope.page = 1

        $scope.$watch(function () {
            return $rootScope.searchInput
            },
            function() {
                var request2 = {
                    method: 'GET',
                    url: '/api/bookshelf/search?search_text='+$rootScope.searchInput+"&"
                    +"per_page="+$scope.perPage+"&page="+$scope.page

                };

                $http.get(request2.url).success(function (res,status, headers, config) {
                    console.log("bbbb")
                    console.log(res)
                    $scope.searchResults = res
                    if (res.length > 0){
                        $scope.resultsAreShown = true
                    } else {
                        $scope.resultsAreShown = false
                    }
                    console.log(headers('X-Total-Count'))
                    var a = headers('X-Total-Count')
                    var b = Math.ceil(a/10)
                    console.log(a)
                    console.log(b)
                    $scope.pages = new Array(b)
                    $scope.totalResults = a
                    // $scope.pagination.total = headers('X-Total-Count');
                }).error(function (data, status, headers, config) {

                });
            }
        );

        $http.get(request.url).success(function (res,status, headers) {
            console.log(res)
            $scope.searchResults = res
            var a = headers('X-Total-Count')
            var b = Math.ceil(a/10)
            console.log(a)
            console.log(b)
            $scope.pages = new Array(b)
            $scope.totalResults = a
        }).error(function (data, status, headers, config) {

        });

        // $http(request).success(function (res,status, headers) {
        //     console.log(res)
        //     $scope.searchResults = res
        //     var a = headers('X-Total-Count')
        //     var b = Math.ceil(a/10)
        //     console.log(a)
        //     console.log(b)
        //     $scope.pages = new Array(b)
        //     $scope.totalResults = a
        // }).error(function (data, status, headers, config) {
        //
        // });

        $scope.goTopic = function(cid, tid, lid) {
            if (cid !== void 0 && tid !== void 0) {

                if (lid) {
                    $state.go('courseLesson', {
                        courseId: cid,
                        tid: tid,
                        lid: lid,
                        coursePath: 'bookshelf'
                    });
                } else if (tid){
                    $state.go('courseTopic', {
                        courseId: cid,
                        tid: tid,
                        coursePath: 'bookshelf'
                    });
                }  else {
                    $state.go('courseTopic', {
                        courseId: cid,
                        tid: tid,
                        coursePath: 'bookshelf'
                    });
                }
            }
        };



        $scope.goToPage = function (selectedPage) {
            $scope.page = selectedPage
            var newUrl = '/api/bookshelf/search?search_text='+$rootScope.searchInput+"&"
                +"per_page="+$scope.perPage+"&page="+$scope.page
            $http.get(newUrl).success(function (res,status, headers) {
                $scope.searchResults = res

            })
        }

        var scrollStep = 38;

        $scope.paginationToLeft = function () {
            var target = angular.element('#scroll');
            var scroll = target.scrollLeft();
            target.scrollLeft(scroll - scrollStep * 3);
        }

        $scope.paginationToRight = function () {
            var target = angular.element('#scroll');
            var scroll = target.scrollLeft();
            target.scrollLeft(scroll + scrollStep * 3);
        }
    }
]);

"use strict";
app.config([
  "$stateProvider",
  "lmsConfig",
  function ($stateProvider, lmsConfig) {
    var modulesPath = lmsConfig.modulesPath;
    $stateProvider
      .state("JournalRoles1", {
        parent: "dashboard",
        url: "^/journal/school/:schoolId",
        data: {
          entity: ''
        },
        resolve: {
          userAccount: function ($auth, Account) {
            return $auth.user ? $auth.user : Account.getAccount();
          }
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_distanceEducationCoordinatorJournalBar.html",
            controller: "DistanceEducationCoordinatorJournalDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/distanceEducationCoordinatorJournal.html",
            controller: "DistanceEducationCoordinatorJournalCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "Электронный журнал"
        }
      })
      .state("JournalRoles1/schoolJournal", {
        parent: "JournalRoles1",
        url: "^/journal/school/:schoolId/group/:groupId",
        resolve: {
          userAccount: function ($auth, Account) {
            return $auth.user ? $auth.user : Account.getAccount();
          }
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_tutorJournalGroupBar.html",
            controller: "TutorJournalUserGroupDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/tutorJournalUserGroup.html",
            controller: "TutorJournalUserGroupCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "{{userGroupName}}"
        }
      })
      .state("JournalRoles1/schoolJournal/courseSection", {
        parent: "JournalRoles1/schoolJournal",
        url: "^/journal/school/:schoolId/group/:groupId/course/:courseId/territory/:territoryId/region/:regionId",
        resolve: {
          userAccount: function ($auth, Account) {
            return $auth.user ? $auth.user : Account.getAccount();
          }
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_teacherJournalCourseSectionBar.html",
            controller: "TeacherJournalCourseSectionDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/teacherJournalCourseSection.html",
            controller: "TeacherJournalCourseSectionCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "{{courseName}}"
        }
      })
      .state("JournalRoles1/schoolJournal/courseSection/all", {
        parent: "JournalRoles1/schoolJournal/courseSection",
        url: "^/journal/school/:schoolId/group/:groupId/course/:courseId/territory/:territoryId/region/:regionId/all",
        resolve: {
          userAccount: function ($auth, Account) {
            return $auth.user ? $auth.user : Account.getAccount();
          }
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_teacherJournalCourseSectionBarAll.html",
            controller: "TeacherJournalCourseSectionDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/teacherJournalCourseSectionAll.html",
            controller: "TeacherJournalCourseSectionAllCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "{{courseName}}"
        }
      })
      .state("JournalRoles1/schoolJournal/student", {
        parent: "JournalRoles1/schoolJournal",
        url: "^/journal/school/:schoolId/group/:groupId/course/:courseId/territory/:territoryId/region/:regionId/student/:studentId",
        resolve: {
          userAccount: function ($auth, Account) {
            return $auth.user ? $auth.user : Account.getAccount();
          }
        },
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_studentJournalBar.html",
            controller: "StudentJournalDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/studentJournal.html",
            controller: "StudentJournalCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "{{studentName}}"
        }
      })
      .state("JournalRoles1/schoolJournal/student/details", {
        parent: "JournalRoles1/schoolJournal/student",
        url: "^/journal/school/:schoolId/group/:groupId/course/:courseId/territory/:territoryId/region/:regionId/student/:studentId/details",
        views: {
          "dashBar@dashboard": {
            templateUrl: modulesPath + "journal/views/_studentJournalCourseDetailsBar.html",
            controller: "StudentJournalCourseDetailsDashBarCtrl"
          },
          "dashContent@dashboard": {
            templateUrl: modulesPath + "journal/views/studentJournalCourseDetails.html",
            controller: "StudentJournalCourseDetailsCtrl"
          }
        },
        params: {
          provider: 'JournalRoles1'
        },
        ncyBreadcrumb: {
          label: "{{courseName}}"
        }
      });
  }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('LessonProgressResource', function ($resource) {
        return $resource('/api/lessonProgresses/', {}, {
            'addLessonAttempt': {
                method: 'PUT',
                url: '/api/lessonProgresses/lessonId/:lessonId/studentId/:studentId',
            },
            'setOnlineMark': {
                method: 'PUT',
                url: '/api/lessonProgresses/lessonId/:lessonId/studentId/:studentId/onlineLessonMark',
            },
            'getAvailableAttempts': {
                method: 'GET',
                url: '/api/lessonProgresses/lessonId/:lessonId/studentId/:studentId/available',
            }
        })
    });

'use strict';

angular.module('lmsClientApp')
    .factory('ProgressResource', function ($resource) {
        return $resource('/api/progresses/', {}, {
            'getLessonProgress': {
                method: 'GET',
                url: '/api/progresses/course/:courseId/lesson/:lessonId/student/:studentId',
                params: {
                    expand: '@expand',
                    assignment: '@assignment',
                    rubric: '@rubric'
                }
            },
            'getLessonProgressWithoutStudent': {
                method: 'GET',
                url: '/api/progresses/course/:courseId/lesson/:lessonId',
                params: {
                    expand: '@expand',
                    assignment: '@assignment',
                    rubric: '@rubric'
                }
            },
            'getTopicProgress': {
                method: 'GET',
                url: '/api/progresses/course/:courseId/topic/:topicId/student/:studentId',
                params: {
                    expand: '@expand',
                    assignment: '@assignment',
                    rubric: '@rubric'
                }
            },
            'getTopicProgressWithoutStudent': {
                method: 'GET',
                url: '/api/progresses/course/:courseId/topic/:topicId',
                params: {
                    expand: '@expand',
                    assignment: '@assignment',
                    rubric: '@rubric'
                }
            },
            'getAllForStudentByCourse': {
                method: 'GET',
                url: '/journal/progresses/course/:courseId/student/:studentId',
                params: {
                    expand: '@expand',
                    assignment: '@assignment',
                    rubric: '@rubric'
                }
            },
            'getAllForStudent': {
                method: 'GET',
                url: '/journal/progresses/courses/student/:studentId',
                isArray: true
            },
            'getByCourseAndUserGroup': {
                method: 'GET',
                url: '/journal/progresses/courseSections/course/:courseId/userGroup/:userGroupId',
                isArray: true
            },
            'getLessonProgressFromTopic': {
                method: 'GET',
                url: '/api/progresses/lesson/:lessonId/group/:groupId',
                isArray: true
            }
        });
    });

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.QuestionCtrl
 * @description
 * # QuestionCtrl
 * Controller of the lmsClientApp
 */
app.controller('QuestionCtrl', [
    '$scope',
    '$mdDialog',
    'lmsConfig',
    '$breadcrumb',
    '$auth',
    'Quiz',
    'Account',
    'Course',
    '$rootScope',
    '$filter',
    'LmsUtils',
    'CourseResource',
    '$timeout',
    'usSpinnerService',
    '$stateParams',
    'EposService',
    'epos',
    function(
        $scope,
        $mdDialog,
        lmsConfig,
        $breadcrumb,
        $auth,
        Quiz,
        Account,
        Course,
        $rootScope,
        $filter,
        LmsUtils,
        CourseResource,
        $timeout,
        usSpinnerService,
        $stateParams,
        EposService,
        epos
    ) {
        // Variables
        $scope.secondBlockIsOpen = false
        $scope.courseId = null;
        $scope.isSendAnswer = false
        $scope.quizId = null;
        $scope.studentId = null;
        $scope.attempCoefficients = [0, 0, 0.75, 0.9, 1];
        $scope.fromBookshelf = Course.fromBookshelf;
        $scope.unlimited = false;
        $scope.rootSectionInit = false;
        $scope.singleQuestionResults = {};
        $scope.readOnly = true; // По умолчанию при загрузке страницы интерфейс заблокирован. // Methods
        $scope.interimAnswer = true;
        $scope.sendAnswer = sendAnswer; // Отправить ответы //
        $scope.tryAgain = tryAgain; // Попробовать еще раз //
        $scope.selectAttempt = selectAttempt; // Выбор попытки
        $scope.showRightAnswers = showRightAnswers; // Показать правильные ответы
        $scope.save = save; // Сохранить выбранный ответ, не отправляя его
        $scope.selectAttemptsDisabled = false;
        $timeout(init, 0);
        function init() {
            $scope.loaded = false;
            var qqid = ($scope.qqid = $scope.question.imsccId);
            $scope.quiz = $rootScope.quiz;
            if (
                !Quiz.openQueryParams ||
                !Quiz.openQueryParams.courseId ||
                !Quiz.openQueryParams.quizId
            ) {
                return false;
            } else {
                $scope.courseId = Quiz.openQueryParams.courseId;
                $scope.quizId = Quiz.openQueryParams.quizId;
                $scope.studentId = !!Quiz.openQueryParams.studentId ? Quiz.openQueryParams.studentId : $auth.user.id;
            }
            $scope.data = {};
            /**
       * Только для роли студент проверяем доступность попыток
       */ if (
                $auth.isInRole('ROLE_STUDENT') ||
                ($auth.isInRole('ROLE_TEACHER') && !$scope.fromBookshelf)
            ) {
                $scope.singleQuestionResults = $scope.stats.filter(function(stat) {
                    return stat.questionImsccId === qqid;
                })[0];
                $scope.attemptsLeft = $scope.singleQuestionResults.left;
                $scope.unlimited = $scope.singleQuestionResults.unlimited;
                $scope.isAllowed = $scope.singleQuestionResults.allowed;
                $scope.data.allAttempts = $scope.singleQuestionResults.attempts;
                getLastAttemption(qqid, $scope.singleQuestionResults);
                // Позволяем учителю сразу переключаться между попытками ученика
                if ($auth.isInRole('ROLE_TEACHER')) {
                    $scope.quiz.status.quizAnswers[qqid].readOnly = false;
                }
            } else {
                $scope.loaded = true;
            }
        }
        //сохраняем ответ пользователя
        function save(qqid) {
            Quiz.saveQuestionAnswer(
                $scope.courseId,
                $scope.quizId,
                qqid,
                $scope.studentId,
                $scope.interimAnswer,
                $scope.quiz.status.quizAnswers[qqid]
            ).then(function(res) {});
        } /**
         * отправляет на Object вида { questionImsccId: "imsccId ответа" }
         * @param {*} qqid quizQuestionsImsccId
         */
        function sendAnswer(qqid) {
            $scope.isSendAnswer = true;
            $scope.secondBlockIsOpen = true
            if (Object.keys($scope.quiz.status.quizAnswers[qqid]).length === 0) {
                return alert(
                    'Невозможно отправить пустое сообщение. Пожалуйста, выберите или введите ответ.'
                );
            }
            if ($scope.attemptsLeft === 1) {
                var approveLastAttempt = confirm(
                    'Внимание! Это последняя попытка. Отправить ответ?'
                );
                if (!approveLastAttempt) return;
            }
            $scope.loaded = false; // Включаем спинер
            Quiz.answerQuizQuestion(
                $scope.courseId,
                $scope.quizId,
                qqid,
                $scope.quiz.status.quizAnswers[qqid]
            ).then(function(response) {
                // $scope.quiz.status.quizAnswers[qqid].readOnly = true;
                $scope.readOnly = true;
                $scope.answer = (+response[qqid].text).toFixed(); /***/
                Quiz.getQuizStats(
                    $scope.courseId,
                    $scope.quizId,
                    qqid,
                    $scope.studentId
                ).then(function(singleQuestionResults) {
                    if (epos) {
                        Quiz.getQuizProgressForStudent($scope.courseId, $stateParams.tid, $scope.quizId, $scope.studentId)
                        .then(function(quizProgress) {
                            if (quizProgress.percentage != null) {
                                var eposUniqueKey = localStorage.getItem("newUniqueKey");
                                EposService.sendTestResult(
                                    $scope.studentId,
                                    quizProgress.name,
                                    $scope.quizId,
                                    quizProgress.percentage,
                                    eposUniqueKey
                                );
                            }
                        });
                    }
                    singleQuestionResults = singleQuestionResults[0];
                    $scope.attemptsLeft = singleQuestionResults.left;
                    $scope.unlimited = singleQuestionResults.unlimited;
                    $scope.isAllowed = singleQuestionResults.allowed;
                    $scope.data.allAttempts = singleQuestionResults.attempts; // Проверка на последнюю отправленную или сохраненную попытку
                    getLastAttemption(qqid, singleQuestionResults);
                    $scope.loaded = true; // Выключаем спинер
                    $rootScope.$broadcast('quizPassed');
                    $scope.selectAttemptsDisabled = false;
                });
            });
        }
        function selectAttempt() {
            if (
                $scope.data.selectedAttempt === '' &&
                $auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_TEACHER'])
            ) {
                $scope.quiz.status.quizAnswers[$scope.qqid] = {};
                if ($scope.attemptsLeft === 0) {
                    $scope.quiz.status.quizAnswers[$scope.qqid].readOnly = true;
                } else {
                    $scope.quiz.status.quizAnswers[$scope.qqid].readOnly = false;
                }
                $scope.answer = text;
                $rootScope.answers[$scope.qqid] = text;
            } else {
                $scope.quiz.status.quizAnswers[$scope.qqid] = angular.merge(
                    {},
                    $scope.data.allAttempts[$scope.data.selectedAttempt - 1].answers[$scope.qqid]
                );
                $scope.quiz.status.quizAnswers[$scope.qqid].readOnly = true;
                var text = '';
                if ($scope.singleQuestionResults.attempts) {
                    var attemptIndex = $scope.data.selectedAttempt - 1;
                    var attempt = $scope.data.allAttempts[attemptIndex];
                    if (attempt.feedbacks) {
                        attempt.feedbacks[$scope.qqid] = attempt.feedbacks[$scope.qqid] || {};
                        text = attempt.feedbacks[$scope.qqid].question_score.text;
                    }
                    $scope.answer = text;
                    $rootScope.answers[$scope.qqid] = text;
                }
            }
        } /**
         * возвращает правильные ответы по вопросу.
         */
        function getCorrectAnswers() {
            usSpinnerService.spin('spinnerQuizAttempt');
            Quiz.getQuestionAns(
                $scope.courseId,
                $scope.quizId,
                $scope.qqid
            ).then(function(response) {
                $scope.quiz.status.quizAnswers[$scope.qqid] = response;
                $scope.quiz.status.quizAnswers[$scope.qqid].readOnly = true;
                $scope.quiz.status.rightAnswersShown = $scope.quiz.status.rightAnswersShown || {};
                $scope.quiz.status.isFinished = $scope.quiz.status.isFinished || {};
                $scope.quiz.status.isFinished[$scope.qqid] = true;
                $scope.quiz.status.rightAnswersShown[$scope.qqid] = true;
                usSpinnerService.stop('spinnerQuizAttempt');
            });
        }
        /**
         * показывает последний ответ.
         * @param {*} qqid - imsccId вопроса
         */ function getLastAttemption(
            qqid,
            singleQuestionResults
        ) {
            // Проверка на последнюю отправленную или сохраненную попытку
            singleQuestionResults.lastAttempt = singleQuestionResults.attempts[
                singleQuestionResults.attempts.length - 1
            ];
            if (singleQuestionResults.lastAttempt && singleQuestionResults.draftAttempt) {
                if (
                    singleQuestionResults.lastAttempt.date < singleQuestionResults.draftAttempt.date
                ) {
                    $scope.quiz.status.quizAnswers[
                        qqid
                    ] = singleQuestionResults.draftAttempt.answers[qqid];
                    $scope.quiz.status.quizAnswers[qqid].readOnly = false;
                    $scope.readOnly = false;
                } else if (
                    singleQuestionResults.lastAttempt.date > singleQuestionResults.draftAttempt.date
                ) {
                    $rootScope.answers[qqid] = ($scope.quiz.status.quizAnswers[
                        qqid
                    ] = singleQuestionResults.lastAttempt.answers[qqid]);
                    $scope.quiz.status.quizAnswers[qqid].readOnly = true;
                    $scope.readOnly = true;
                }
                $scope.data.selectedAttempt = $scope.data.allAttempts.length.toString();
                $scope.answer = singleQuestionResults.lastAttempt.feedbacks[qqid][
                    'question_score'
                ].text;
                $rootScope.answers[qqid] = $scope.answer;
                $scope.loaded = true;
            } else if (singleQuestionResults.lastAttempt && !singleQuestionResults.draftAttempt) {
                // Если нет ни одной сохраненной попытки
                $scope.quiz.status.quizAnswers[qqid] = singleQuestionResults.lastAttempt.answers
                    ? singleQuestionResults.lastAttempt.answers[qqid]
                    : {}; // Если вдруг ранее был отправлен вопрос без выбора ответа
                $scope.data.selectedAttempt = $scope.data.allAttempts.length.toString();
                $scope.answer = singleQuestionResults.lastAttempt.feedbacks[qqid][
                    'question_score'
                ].text;
                $rootScope.answers[qqid] = $scope.answer;
                $scope.quiz.status.quizAnswers[qqid].readOnly = true;
                $scope.readOnly = true;
                $timeout(
                    function() {
                        $scope.loaded = true;
                    },
                    150
                );
            } else if (!singleQuestionResults.lastAttempt && singleQuestionResults.draftAttempt) {
                // Если нет ни одной отправленной попытки
                $scope.quiz.status.quizAnswers[qqid] = singleQuestionResults.draftAttempt.answers[
                    qqid
                ];
                $scope.checked = true;
                $scope.quiz.status.quizAnswers[qqid].readOnly = false;
                $scope.readOnly = false;
                $timeout(
                    function() {
                        $scope.loaded = true;
                    },
                    150
                );
            } else {
                // Если нет ни отправленных, ни сохраненных попыток нет
                $scope.quiz.status.quizAnswers[qqid] = {};
                $scope.readOnly = false;
                $timeout(
                    function() {
                        $scope.loaded = true;
                    },
                    150
                );
            }
        }
        // Показать правильные ответы answerQuizQuestion
        function showRightAnswers() {
            if ($auth.isInRole('ROLE_STUDENT')) {
                $rootScope.questionAllowed = $scope.isAllowed;
                LmsUtils.showLmsConfirmDialog(
                    'После просмотра правильных ответов прохождение теста будет недоступно',
                    'Показать правильные ответы?',
                    'Да',
                    'Нет'
                ).then(function() {
                    $scope.isAllowed = false;
                    getCorrectAnswers();
                    // Селектбокс с выбором попыток сброс
                    $scope.data.selectedAttempt = '';
                    $scope.answer = '';
                });
            } else {
                getCorrectAnswers();
                // Селектбокс с выбором попыток сброс
                $scope.data.selectedAttempt = '';
                $scope.answer = '';
            }
        }
        // Попробовать еще раз
        function tryAgain(qqid) {
             $scope.secondBlockIsOpen = false
            $scope.quiz.status.quizAnswers[qqid] = {};
            $scope.readOnly = false;
            $scope.selectAttemptsDisabled = true;
        }
    }
]);

'use strict';
app.controller('QuizOneTryCtrl', [
  '$scope',
  '$mdDialog',
  'lmsConfig',
  '$breadcrumb',
  '$auth',
  'Quiz',
  'Account',
  'Course',
  '$rootScope',
  '$filter',
  'LmsUtils',
  'CourseResource',
  '$q',
  'EposService',
  'epos',
  function(
    $scope,
    $mdDialog,
    lmsConfig,
    $breadcrumb,
    $auth,
    Quiz,
    Account,
    Course,
    $rootScope,
    $filter,
    LmsUtils,
    CourseResource,
    $q,
    EposService,
    epos
  ) {
    $scope.loaded = false;
    $scope.rootSectionInit = false;

    init();
    function init() {
      var fromBshelf = Course.fromBookshelf;
      if (!!$rootScope.quiz && !!$rootScope.quiz.status) {
        $rootScope.quiz.status.responseString = {};
      }

      if (
        $auth.isInAnyRole([
          'OP_MANAGE_COURSE_SECTIONS',
          'OP_VIEW_COURSE_SECTIONS',
          'ROLE_PARENT'
        ]) && !fromBshelf
      ) {
        anyRoleInit();
      } else if ($auth.isInRole('ROLE_STUDENT')) {
        studentInit();
      } else if (fromBshelf) {
        fromBookshelf();
      }
    }

    function fromBookshelf() {
      if (!Quiz.openQueryParams || !Quiz.openQueryParams.courseId || !Quiz.openQueryParams.quizId) {
        console.log('Error!');
        return false;
      }
      var courseId = Quiz.openQueryParams.courseId;
      var quizImsccId = Quiz.openQueryParams.quizId;

      $scope.rootSectionInit = false;
      $scope.loaded = false;

      Quiz.getQuiz(courseId, quizImsccId).then(function(quiz) {
        // rootScope
        $rootScope.quiz.status.readOnly = true;
        $rootScope.quiz.status.isFinished = false;
        $rootScope.quiz.status.rightAnswersShown = false;
        $rootScope.quiz.status.responseString = {};
        $rootScope.quiz.status.quizAnswers = {};
        $scope.data = {};
        angular.extend($scope.data, quiz);
        // /rootScope
        $scope.rootSectionInit = true;
        $scope.loaded = true;
      });
    }

    function anyRoleInit() {
      if (!Quiz.openQueryParams || !Quiz.openQueryParams.courseId || !Quiz.openQueryParams.quizId) {
        console.log('Error!');
        return false;
      }
      var courseId = Quiz.openQueryParams.courseId;
      var quizImsccId = Quiz.openQueryParams.quizId;
      var studentId = Quiz.openQueryParams.studentId;
      $scope.rootSectionInit = false;
      $scope.loaded = false;
      Quiz.getQuizProgress(courseId, quizImsccId, studentId).then(function(quiz) {
        // rootScope
        $rootScope.quiz.status.readOnly = true;
        $rootScope.quiz.status.isFinished = false;
        $rootScope.quiz.status.rightAnswersShown = false;
        $rootScope.quiz.status.responseString = {};
        $rootScope.quiz.status.quizAnswers = {};
        $scope.data = {};
        angular.extend($scope.data, quiz);
        // /rootScope
        $scope.rootSectionInit = true;
        $scope.loaded = true;
      });
    }

    function studentInit() {
      if (!Quiz.openQueryParams || !Quiz.openQueryParams.courseId || !Quiz.openQueryParams.quizId) {
        console.log('Error!');
        return false;
      }
      var courseId = Quiz.openQueryParams.courseId;
      var quizImsccId = Quiz.openQueryParams.quizId;
      var studentId = null;
      var questionImsccId = null;

      $scope.answer = '';
      $scope.isSendAnswer = false;
      $scope.isAllowed = false;

      $scope.rootSectionInit = false;
      $scope.loaded = false;
      getStudentIdAndQuestionImsccId(courseId, quizImsccId)
        .then(function(data) {
          $scope.loaded = true;
          studentId = data.studentId;
          questionImsccId = data.questionImsccId;
          ctrStudentRun(studentId, courseId, quizImsccId, questionImsccId);
        })
        .catch(function(e) {
          $scope.loaded = true;
          console.log('Error!', e);
        });
      // Получить studentId и questionImsccId
      function getStudentIdAndQuestionImsccId(courseId, quizImsccId) {
        return $q(function(resolve, reject) {
          // Получем юзера
          var promAccount = Account.getAccount().then(function(account) {
            return account.id;
          }); // Получем все вопросы
          var promQuizList = Quiz.getQuiz(courseId, quizImsccId)
            .then(function(quiz) {
              // rootScope
              $rootScope.quiz.status.readOnly = false;
              $rootScope.quiz.status.isFinished = false;
              $rootScope.quiz.status.rightAnswersShown = false;
              $rootScope.quiz.status.responseString = {};
              $rootScope.quiz.status.quizAnswers = {};
              $scope.data = {};
              angular.extend($scope.data, quiz); // /rootScope
              return quiz.rootSection.questions;
            })
            .then(function(questions) {
              var keys = Object.keys(questions);
              var question = questions[keys[0]];
              return question;
            });
          $q
            .all([promAccount, promQuizList])
            .then(function(res) {
              var studentId = res[0];
              var questionImsccId = res[1].imsccId;
              resolve({
                studentId: studentId,
                questionImsccId: questionImsccId
              });
            })
            .catch(function(e) {
              reject(e);
            });
        });
      }
      function ctrStudentRun(studentId, courseId, quizImsccId, questionImsccId) {
        // Количество попыток вопроса
        $scope.loaded = false;
        getQuestionAttempts(
          studentId,
          courseId,
          quizImsccId,
          questionImsccId
        ).then(function(attempts) {
          $scope.loaded = true;
          if (attempts.length === 0) {
            $scope.isAllowed = true;
            $scope.rootSectionInit = true;
            return;
          }
          // Если выполнена
          $scope.isAllowed = false;
          var attempt = attempts[0];
          var feedbacks = attempt.feedbacks;
          var feedbackQuestion = feedbacks[questionImsccId];
          $scope.answer = +feedbackQuestion['question_score'].text; // rootScope
          $rootScope.quiz.status.readOnly = true;
          $rootScope.quiz.status.isFinished = true;
          $rootScope.quiz.status.rightAnswersShown = true;
          $rootScope.quiz.status.responseString = attempt.feedbacks;
          $rootScope.quiz.status.quizAnswers = attempt.answers;
          // /rootScope
          $scope.rootSectionInit = true;
        });
        // Отправляем ответ
        $scope.sendAnswer = function(quizAnswers) {
          if (Object.keys(quizAnswers).length === 0) {
            return alert('Невозможно отправить пустое сообщение. Пожалуйста, введите ответ.');
          } else {
            var conf = confirm('Вам доступна лишь одна попытка. Отправить?');
            if (!conf) {
              return;
            }
            $scope.loaded = false;
            $scope.isSendAnswer = false;
            sendAnswer(studentId, courseId, quizImsccId, quizAnswers)
              .then(function(resp) {
                $scope.loaded = true;
                $scope.isSendAnswer = true;
                //$scope.answer = +resp[questionImsccId].text;
                $scope.answer = +resp[0].text; // rootScope
                $rootScope.quiz.status.readOnly = true; // /rootScope
                $rootScope.$broadcast('quizPassed');
                if (epos) {
                  var eposUniqueKey = localStorage.getItem("newUniqueKey");
                  EposService.sendTestResult(
                      studentId,
                      $scope.data.title,
                      quizImsccId,
                      $scope.answer,
                      eposUniqueKey
                  );
                }
              })
              .catch(function(e) {
                $scope.loaded = true;
                console.log('Error!', e);
              });
          }
        };
      }
    } // Количество попыток вопроса GET // url: "/api/courses/:id/quizzes/:quizImsccId/questions/:questionImsccId/students/:studentId/attempts/:attempt"
    function getQuestionAttempts(studentId, courseId, quizImsccId, questionImsccId) {
      var promise = CourseResource.getQuestionAttempts({
        id: courseId,
        quizImsccId: quizImsccId,
        questionImsccId: questionImsccId,
        studentId: studentId
      }).$promise;
      return promise;
    }
    // method: 'POST', url: '/api/courses/:id/quizzes/:quizImsccId/students/:studentId'
    function sendAnswer(studentId, courseId, quizImsccId, quizAnswers) {
      return CourseResource.answerQuiz(
        { id: courseId, quizImsccId: quizImsccId, studentId: studentId },
        quizAnswers
      ).$promise;
    }
  }
]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.QuizContainerCtrl
 * @description
 * # QuizContainerCtrl
 * Controller of the lmsClientApp
 */
app.controller('QuizContainerCtrl', [
    '$scope',
    '$mdDialog',
    'lmsConfig',
    '$breadcrumb',
    '$auth',
    'Quiz',
    'Account',
    'Course',
    '$rootScope',
    '$filter',
    'LmsUtils',
    'CourseResource',
    'TestResource',
    'usSpinnerService',
    'QuizProgressResource',
    '$timeout',
    '$state',
    function(
        $scope,
        $mdDialog,
        lmsConfig,
        $breadcrumb,
        $auth,
        Quiz,
        Account,
        Course,
        $rootScope,
        $filter,
        LmsUtils,
        CourseResource,
        TestResource,
        usSpinnerService,
        QuizProgressResource,
        $timeout,
        $state
    ) {
        // Variables
        $scope.courseId = null;
        $scope.quizId = null;
        $scope.studentId = null;
        $scope.attempCoefficients = [0, 0, 0.75, 0.9, 1];
        $scope.fromBookshelf = Course.fromBookshelf;
        $scope.unlimited = false;
        $scope.rootSectionInit = false;
        $rootScope.allQuestions = null;
        $rootScope.questions = [];
        $scope.topicId = $state.params.tid;

        init();

        $timeout(function() {
            usSpinnerService.spin('spinnerQuizsection');
        });

        function init() {
            $scope.quiz = { status: {} };
            if (
                !Quiz.openQueryParams ||
                !Quiz.openQueryParams.courseId ||
                !Quiz.openQueryParams.quizId
            )
                return false;
            $scope.courseId = Quiz.openQueryParams.courseId;
            $scope.quizId = Quiz.openQueryParams.quizId;
            $scope.studentId = Quiz.openQueryParams.studentId;
            $scope.data = {};
            if (
                $auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT']) ||
                ($auth.isInRole('ROLE_TEACHER') && !$scope.fromBookshelf)
            ) {
                Account.getAccount().then(function(account) {
                    var studentId = $scope.studentId
                        ? $scope.studentId
                        : account.id;
                    Quiz.getQuiz(
                        $scope.courseId,
                        $scope.quizId
                    ).then(function(quiz) {
                        $scope.isAllowed = true;
                        $rootScope.allQuestions = Object.keys(
                            quiz.rootSection.questions
                        ).length;
                        $scope.quiz.status.isFinished = false;
                        $scope.quiz.status.rightAnswersShown = false;
                        $scope.quiz.status.responseString = {};
                        $scope.quiz.status.quizAnswers = {};
                        Quiz.getQuizStats(
                            $scope.courseId,
                            $scope.quizId,
                            Object.keys(quiz.rootSection.questions),
                            studentId
                        ).then(function(result) {
                            $scope.data.questionStats = result;
                            var rest = result.map(function(item) {
                                var len, key, value, tmpResultObj;
                                len = item.attempts.length - 1;
                                key = item.questionImsccId;
                                value = item.attempts.length > 0
                                    ? item.attempts[len].feedbacks[
                                          key
                                      ].question_score.text
                                    : -1;
                                tmpResultObj = {};
                                tmpResultObj[key] = value;
                                return tmpResultObj;
                            });

                            $scope.results = rest.reduce(
                                function(sum, item) {
                                    return angular.extend(sum, item);
                                },
                                {}
                            );
                            angular.extend($scope.data, quiz);
                            $scope.rootSectionInit = true;
                            usSpinnerService.stop('spinnerQuizsection');
                        });
                    });
                });
            } else if ($scope.fromBookshelf) {
                Quiz.getQuiz(
                    $scope.courseId,
                    $scope.quizId
                ).then(function(quiz) {
                    $scope.quiz.status.isFinished = false;
                    $scope.quiz.status.rightAnswersShown = false;
                    $scope.quiz.status.responseString = {};
                    $scope.quiz.status.quizAnswers = {};
                    $scope.rootSectionInit = true;
                    $rootScope.allQuestions = Object.keys(
                        quiz.rootSection.questions
                    ).length;
                    usSpinnerService.stop('spinnerQuizsection');
                    angular.extend($scope.data, quiz);
                });
            }
        }
    }
]);

(function () {
  'use strict';
  app.controller('QuizReadyCtrl', [
    '$scope',
    '$mdDialog',
    'lmsConfig',
    '$breadcrumb',
    '$auth',
    'Quiz',
    'Account',
    'Course',
    '$rootScope',
    '$filter',
    'LmsUtils',
    'CourseResource',
    '$q',
    QuizReadyCtrl
  ]);
  function QuizReadyCtrl($scope, $mdDialog, lmsConfig, $breadcrumb, $auth, Quiz, Account, Course, $rootScope, $filter, LmsUtils, CourseResource, $q) {
    // Variables
    $scope.courseId = null;
    $scope.quizId = null;
    $scope.studentId = null;

    $scope.rootSectionInit = false;

    init();

    function init() {
      if (!Quiz.openQueryParams || !Quiz.openQueryParams.courseId || !Quiz.openQueryParams.quizId) {
        return false;
      }
      $scope.data = {};

      var studentId = Quiz.openQueryParams.studentId;
      var courseId = Quiz.openQueryParams.courseId;
      var quizId = Quiz.openQueryParams.quizId;

      // Получаем все квизы
      getQuiz(courseId, quizId).then(function (quiz) {
        // Для каждого вопроса получаем правильный ответ
        $rootScope.quiz.status.quizAnswers = {};
        var quizImsccId = quizId;
        var questions = Object.keys(quiz.rootSection.questions).map(function (key) {
          var question = quiz.rootSection.questions[key];
          var questionImsccId = question.imsccId;
          return selectAttempt(courseId, quizImsccId, questionImsccId, studentId).then(function (attempt) {
            if (attempt) {
              $rootScope.quiz.status.quizAnswers[questionImsccId] = attempt.answers[questionImsccId];
              $rootScope.quiz.status.responseString[questionImsccId] = attempt.feedbacks[questionImsccId];
            }
          });
        });

        var answers = getCorrectAnswers(courseId, quizId).then(function (quizRightAnswers) {
          $rootScope.quiz.status.quizRightAnswers = quizRightAnswers;
        });

        $q.all([answers, $q.all(questions)]).then(function () {
          $scope.rootSectionInit = true;
          var obj = $scope.data.rootSection.questions;
          Object.keys(obj).forEach(function (key) {
            $scope.data.rootSection.questions[key].ready = true;
          });
        });
      });
    }
    // Получить getQuiz
    function getQuiz(courseId, quizId) {
      return Quiz.getQuiz(courseId, quizId).then(function (quiz) {
        // rootScope
        $rootScope.quiz.status.readOnly = true;
        $rootScope.quiz.status.isFinished = true;
        $rootScope.quiz.status.rightAnswersShown = true;
        //  $rootScope.quiz.status.responseString = {};
        //  $rootScope.quiz.status.quizAnswers = {};
        $scope.data = {};
        angular.extend($scope.data, quiz);
        // /rootScope
        return quiz;
      });
    }
    // Получить правильные ответы
    function getCorrectAnswers(courseId, quizId) {
      return Quiz.getCorrectAnswers(courseId, quizId).then(function (response) {
        return response;
      });
    }
    // Получить попытку 1
    function selectAttempt(courseId, quizImsccId, questionImsccId, studentId) {
      return CourseResource.getQuestionAttempts({
        id: courseId,
        quizImsccId: quizImsccId,
        questionImsccId: questionImsccId,
        studentId: studentId,
      }).$promise.then(function (attempts) {
        $scope.loaded = true;
        if (attempts.length === 0) {
          return null;
        }
        var attempt = attempts[0];
        return attempt;
      });
    }
  }
}());

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.QuizOne
 * @description
 * # QuizOneCtrl
 * Controller of the lmsClientApp
 */
app.controller('QuizOneCtrl', [
  '$scope',
  '$mdDialog',
  'lmsConfig',
  '$breadcrumb',
  '$auth',
  'Quiz',
  'Account',
  'Course',
  '$rootScope',
  '$filter',
  'LmsUtils',
  'CourseResource',
  'TestResource',
  function(
    $scope,
    $mdDialog,
    lmsConfig,
    $breadcrumb,
    $auth,
    Quiz,
    Account,
    Course,
    $rootScope,
    $filter,
    LmsUtils,
    CourseResource,
    TestResource
  ) {
    init();
    function init() {
      TestResource.getByUid({ uuid: Quiz.openQueryParams.quizId }).$promise.then(function(result) {
        TestResource.getAllFilePathsTest({ id: result.id }).$promise.then(function(res) {
          $scope.data = res.toJSON();
          $scope.rootSectionInit = true;
        });
      });
    }
  }
]);

/**
 * Created by nlyubich on 25.06.2015.
 */
'use strict';

angular
    .module('lmsClientApp')
    // replace mark in short answer question with text input
    .directive('parseShort', [
        '$compile',
        '$rootScope',
        function($compile, $rootScope) {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    parseShort: '=',
                    parseShortNumerical: '@',
                    readOnly: '='
                },
                link: function(scope, element, attrs) {
                    // Показываем сразу оба варианта
                    if (scope.parseShort.ready) {
                        var parseString = '';
                        var addition = '';
                        // Флажок статуса ответа
                        addition += "<span ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                            scope.parseShort.imsccId +
                            "']['0'].correct]\">&#9632;&nbsp;</span>"; // Ответ учиника
                        addition += '<span class="short-answer-wrap"><span class="answer-for-short"> Ответ: <input disabled type="text"' +
                            'ng-model="$root.quiz.status.quizAnswers[\'' +
                            scope.parseShort.imsccId +
                            "']['0']\"/></span></span>"; // Правильный ответ
                        addition += '<span class="short-answer-wrap"><span class="answer-for-short"> Правильный ответ: <input disabled type="text"' +
                            'ng-model="$root.quiz.status.quizRightAnswers[\'' +
                            scope.parseShort.imsccId +
                            "']['0']\"/></span></span>";
                        if (scope.parseShort.text !== null) {
                            if (scope.parseShort.text.indexOf('[]') < 0) {
                                parseString = '<div>' + scope.parseShort.text + '</div>' + addition;
                            } else {
                                parseString = scope.parseShort.text.replace('[]', addition);
                            }
                        }
                        element.append($compile(parseString)(scope));
                        return;
                    }
                    var questPrefix = scope.parseShortNumerical === 'true' ? 'Ответ: ' : '',
                        numbersOnly = scope.parseShortNumerical === 'true'
                            ? ' numbers-only="numbers-only" '
                            : '',
                        ro = scope.readOnly === true ? ' disabled ' : '';
                    // add correct/incorrect marker
                    var addition = '<span class="short-answer-wrap">' +
                        '<span ng-show="$root.quiz.status.isFinished && $root.quiz.status.responseString[\'' +
                        scope.parseShort.imsccId +
                        "']['0'].correct != undefined\" " +
                        "ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                        scope.parseShort.imsccId +
                        "']['0'].correct]\">" +
                        '&#9632;&nbsp;' +
                        '</span>';
                    // add input with feedback
                    addition += '<span class="answer-for-short">' +
                        questPrefix +
                        '<input type="text"' +
                        numbersOnly +
                        ro +
                        'ng-model="$root.quiz.status.quizAnswers[\'' +
                        scope.parseShort.imsccId +
                        "']['0']\"/>" +
                        '<span ng-show="$root.quiz.status.isFinished" ' +
                        'ng-class="$root.quiz.status.responseString[\'' +
                        scope.parseShort.imsccId +
                        "']['0'].correct ? 'feedback correct' : 'feedback incorrect'\" " +
                        'ng-bind-html="$root.quiz.status.responseString[\'' +
                        scope.parseShort.imsccId +
                        "']['0'].text\"></span></span></span>";
                    if (scope.parseShort.text !== null) {
                        if (scope.parseShort.text.indexOf('[]') < 0) {
                            addition = '<p>' + scope.parseShort.text + '</p>' + addition;
                        } else {
                            addition = scope.parseShort.text.replace('[]', addition);
                        }
                    }
                    element.append($compile(addition)(scope));
                }
            };
        }
    ]) // replace multiple marks in multiple blanks question with text inputs
    .directive('parseMultiple', [
        '$compile',
        '$rootScope',
        function($compile, $rootScope) {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    parseMultiple: '=',
                    readOnly: '='
                },
                link: function(scope, element, attrs) {
                    // Показываем сразу оба варианта
                    if (scope.parseMultiple.ready) {
                        var parseString = '<div>' + scope.parseMultiple.text + '</div>';
                        angular.forEach(scope.parseMultiple.responses, function(value, key) {
                            var addition = ''; // Флажок статуса ответа
                            addition += "<span ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                                scope.parseMultiple.imsccId +
                                "']['" +
                                key +
                                '\'].correct]">■</span>';
                            // Ответ учиника
                            addition += ' <input ng-disabled="true" type="text" ng-model="$root.quiz.status.quizAnswers[\'' +
                                scope.parseMultiple.imsccId +
                                "']['" +
                                key +
                                '\']" />'; // Правильные ответы
                            addition += ' <span>Правильный ответ</span> <input ng-disabled="true" type="text" ng-model="$root.quiz.status.quizRightAnswers[\'' +
                                scope.parseMultiple.imsccId +
                                "']['" +
                                key +
                                '\']" />';
                            parseString = parseString.replace('[' + value.text + ']', addition);
                        });
                        element.append($compile(parseString)(scope));
                        return;
                    }
                    scope.questionText = '<p>' + scope.parseMultiple.text + '</p>';
                    var ro = ' ng-disabled="readOnly || $root.quiz.status.readOnly" ';
                    angular.forEach(scope.parseMultiple.responses, function(value, key) {
                        // correct/incorrect marker
                        var addition = '<span ng-show="$root.quiz.status.isFinished && $root.quiz.status.responseString[\'' +
                            scope.parseMultiple.imsccId +
                            "']['" +
                            key +
                            '\'].correct != undefined" ' +
                            "ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                            scope.parseMultiple.imsccId +
                            "']['" +
                            key +
                            '\'].correct]">' +
                            '&#9632;&nbsp;' +
                            '</span>'; // input with feedback
                        addition += '<input type="text" ' +
                            ro +
                            'ng-model="$root.quiz.status.quizAnswers[\'' +
                            scope.parseMultiple.imsccId +
                            "']['" +
                            key +
                            '\']"/>' +
                            '<span ng-show="$root.quiz.status.isFinished" ' +
                            'ng-class="$root.quiz.status.responseString[\'' +
                            scope.parseMultiple.imsccId +
                            "']['" +
                            key +
                            "'].correct ? 'feedback correct' : 'feedback incorrect'\" " +
                            'ng-bind-html="$root.quiz.status.responseString[\'' +
                            scope.parseMultiple.imsccId +
                            "']['" +
                            key +
                            '\'].text"></span>';
                        scope.questionText = scope.questionText.replace('[' + value.text + ']', addition);
                    });
                    element.append($compile(scope.questionText)(scope.$parent.$parent));
                }
            };
        }
    ])
    // replace marks in multiple dropdown question with dropdown inputs
    .directive('parseDropdown', [
        '$compile',
        '$rootScope',
        function($compile, $rootScope) {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    parseDropdown: '=',
                    readOnly: '='
                },
                link: function(scope, element, attrs) {
                    // Показываем сразу оба варианта
                    if (scope.parseDropdown.ready) {
                        var parseString = '<div>' + scope.parseDropdown.text + '</div>';
                        scope.allDropdowns = [];
                        angular.forEach(scope.parseDropdown.responses, function(value, key) {
                            var addition = '';
                            // Флажок статуса ответа
                            addition = "<span ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                                scope.parseDropdown.imsccId +
                                "']['" +
                                key +
                                '\'].correct]">&#9632;</span>'; // Ответ учиника
                            addition += '<select ng-disabled="true" ng-model="$root.quiz.status.quizAnswers[\'' +
                                scope.parseDropdown.imsccId +
                                "']['" +
                                key +
                                '\']">';
                            addition += '<option selected="selected" value="">[Выбрать]</option>';
                            toList(value.items);
                            angular.forEach(scope.allDropdowns, function(value) {
                                addition += '<option value="' + value.imsccId + '">' + value.text + '</option>';
                            });
                            addition += '</select>';
                            // Правильные ответы
                            addition += ' <span>Правильный ответ</span> <select ng-disabled="true" ng-model="$root.quiz.status.quizRightAnswers[\'' +
                                scope.parseDropdown.imsccId +
                                "']['" +
                                key +
                                '\']">';
                            addition += '<option selected="selected" value="">[Выбрать]</option>';
                            toList(value.items);
                            angular.forEach(scope.allDropdowns, function(value) {
                                addition += '<option value="' + value.imsccId + '">' + value.text + '</option>';
                            });
                            addition += '</select>';
                            parseString = parseString.replace('[' + value.text + ']', addition);
                        });
                        element.append($compile(parseString)(scope));
                        return;
                    }
                    scope.allDropdowns = [];
                    scope.showOptions = function (key) {
                        alert('aaa')
                        scope.syntheticSelectsData[key].optionsAreShown = true
                        console.log($rootScope.quiz.status.quizAnswers)
                        console.log(scope.parseDropdown.responses)
                        // alert($rootScope.quiz.status.quizAnswers)
                    }
                    scope.selectAnswer = function () {
                        alert('selectAnswer')
                    }
                    scope.questionText = '<p>' + scope.parseDropdown.text + '</p>';
                    scope.syntheticSelectsData = []
                    var ro = ' ng-disabled="readOnly || $root.quiz.status.readOnly" ';
                    angular.forEach(scope.parseDropdown.responses, function(value, key) {
                        // correct/incorrect marker
                        var select = '<span ng-show="$root.quiz.status.isFinished && $root.quiz.status.responseString[\'' +
                            scope.parseDropdown.imsccId +
                            "']['" +
                            key +
                            '\'].correct != undefined" ' +
                            "ng-class=\"{true:'correct', false:'incorrect'}[$root.quiz.status.responseString['" +
                            scope.parseDropdown.imsccId +
                            "']['" +
                            key +
                            '\'].correct]">' +
                            '&#9632;&nbsp;' +
                            '</span>'; // select root element
                        scope.syntheticSelectsData.push({
                            optionsAreShown:false,

                        })
                        scope.aaa = function (w) {
                            console.log(w)
                            console.log(scope.syntheticSelectsData)
                            scope.syntheticSelectsData[w].optionsAreShown = true
                        }
                        // scope.syntheticSelectsData.optionsAreShown = false
                        console.log(scope.syntheticSelectsData)
                        var answerModel = "$root.quiz.status.quizAnswers['" +
                            scope.parseDropdown.imsccId +
                            "']['" +
                            key +
                            "']";
                        // select += '<div ng-click="scope.syntheticSelectsData[key].optionsAreShown = true" class="quizOptions" >' ;
                        // select += '<div ng-click="aaa(1)" class="quizOptions" >' ;
                        //
                        // select += '<div ng-if="scope.syntheticSelectsData[key].optionsAreShown" class="quizOptionsContainer">'
                        //
                        select += '<select' + ro + ' ng-model="' + answerModel + '">';
                        select += '<option selected="selected" value="">[Выбрать]</option>';

                        // select += '<ng-select-box' + ro + ' ng-model="' + answerModel + '">';
                        // select += '<ng-optgroup>';
                        // select += '<ng-option selected="selected" value="">[Выбрать]</ng-option>';
                        toList(value.items); //angular.forEach(value.items, function (value, key) { //    select += '<option value="' + value.imsccId + '">' + value.text + '</option>'; //}); // options
                        //Старый метод для map - возможно потребуется, если будет shuffle items
                        var optionList = [];
                        angular.forEach(scope.allDropdowns, function(value) {
                            // Собираем массив для перемешивания
                            optionList.push({
                                value: value.imsccId,
                                text: value.text
                            });
                        });
                        // В allDropdowns перемешиваем option
                        optionList.sort(function(a, b) {
                            return Math.random() - 0.5;
                        });
                        console.log(optionList)
                        console.log(select)
                        console.log(answerModel)
                        optionList.forEach(function(option) {
                            select += '<option value="' + option.value + '">' + option.text + '</option>';
                            var isImg = option.text.indexOf("img")
                            // select += '<div class="quizOption" ng-click="">' + option.text + '</div>'

                            if (isImg >-1){
                                // select += '<option value="' + option.value + '">' + option.text + '</option>';

                            } else {

                                // select += '<option value="' + option.value + '">' + option.text + '</option>';
                            }

                        });
                        console.log(select)
                        // ----------------------------------
                        //   select += '</ng-optgroup>';
                        // select += '</ng-select-box>'; // feedback
                        // select += '</div>' ;
                        select += '</select>';
                        select += '<span ng-show="$root.quiz.status.isFinished" ' +
                            'ng-class="$root.quiz.status.responseString[\'' +
                            scope.parseDropdown.imsccId +
                            "']['" +
                            key +
                            "'].correct ? 'feedback correct' : 'feedback incorrect'\" " +
                            'ng-bind-html="$root.quiz.status.responseString[\'' +
                            scope.parseDropdown.imsccId +
                            "']['" +
                            key +
                            '\'].text"></span>';
                        scope.questionText = scope.questionText.replace('[' + value.text + ']', select);
                    });
                    element.append($compile(scope.questionText)(scope));
                    function compare(a, b) {
                        if (a.number < b.number) return -1;
                        if (a.number > b.number) return 1;
                        return 0;
                    }
                    function toList(currentMapAnswers) {
                        scope.allDropdowns = [];
                        angular.forEach(Object.keys(currentMapAnswers), function(value, key) {
                            scope.allDropdowns.push(currentMapAnswers[value]);
                        });
                        scope.allDropdowns.sort(compare);
                    }
                }
            };
        }
    ]);

/**
 * Created by nlyubich on 24.06.2015.
 */
'use strict';

angular.module('lmsClientApp').directive('quizquestion', [
  'lmsConfig',
  'Quiz',
  function(lmsConfig, Quiz) {
    return {
      restrict: 'E',
      scope: {
        content: '=',
        status: '=',
        stats: '='
      },
      controller: 'QuestionCtrl',
      link: function(scope, element, attrs) {
        scope.question = scope.content;
        if (scope.question.shuffledResponses) {
          scope.question.shuffledResponses.sort(compare);
        }
        var notSupported = [
          'file_upload_question',
          'calculated_question',
          'text_only_question',
          'essay_question'
        ];
        if (notSupported.indexOf(scope.content.type.name) > -1) {
          scope.typeServed = false;
        } else {
          scope.typeServed = true;
          scope.contentUrl = lmsConfig.modulesPath +
            'quiz/views/' +
            scope.content.type.name +
            '.html';
        }
        scope.attempts = lmsConfig.modulesPath + 'quiz/views/_quizAttempt.html';
        /*attrs.$observe("content.type.name", function(v){
                 scope.contentUrl = 'scripts/app/quiz/templates/' + v + '.html';
                 });*/

        function compare(a, b) {
          if (a.number < b.number) return -1;
          if (a.number > b.number) return 1;
          return 0;
        }
      },
      template: '<div ng-include="contentUrl" ng-if="typeServed"></div>' +
        '<div ng-include="attempts"></div>'
    };
  }
]);

/**
 * Created by nlyubich on 24.06.2015.
 */
'use strict';

angular.module('lmsClientApp').directive('question1c', [
  'lmsConfig',
  'Quiz',
  '$compile',
  function(lmsConfig, Quiz) {
    return {
      restrict: 'E',
      scope: {
        content: '='
      },
      link: function(scope, element, attrs, $compile) {
        scope.question = scope.content.text;
        element.append(scope.question);
      },
      template: '<div></div>'
    };
  }
]);

/**
 * Created by nlyubich on 24.06.2015.
 */
'use strict';

angular.module('lmsClientApp').directive('quizsection', [
    '$compile',
    '$rootScope',
    function($compile, $rootScope) {
        return {
            restrict: 'E',
            scope: {
                allData: '=',
                quiz: '=',
                attemption: '=',
                results: '=',
                send: '&'
            },
            template: '<div class="voffset4" class="section" id="{{content.imsccId}}">' +
                '<h3 class="underline">{{content.title}}</h3>' +
                '<div has-role="OP_MANAGE_COURSES"></div>' +
                '</div>',
            link: function(scope, element, attrs) {
                $rootScope.answers = {};
                if (scope.allData.rootSection === void 0)
                    throw new Error('lost quiz data');
                scope.content = scope.allData.rootSection;
                scope.sendAnswer = scope.send();
                scope.stats = scope.allData.questionStats;
                scope.allQuestions = [];
                // $rootScope.answers
                toList();
                scope.someIndex = 0;
                element.append(
                    $compile(
                        '<quizsection ng-repeat="(key, section) in content.children" content="section"/>' +
                            "<div class='quiz-container'>" +
                            '<ul rn-carousel rn-carousel-buffered rn-carousel-indicator rn-carousel-controls  rn-carousel-index="someIndex">' +
                            '  <li ng-repeat="question in allQuestions">' +
                            '   <quizquestion content="question" stats="stats" class="quiz"/>' +
                            '  </li>' +
                            '</ul>' +
                            '<div class="rn-carousel-indicator custom-indicator" flex layout="row" layout-align="center center">' +
                            '<span class="question-step" ng-repeat="slide in allQuestions" ng-class="{' +
                            'active: $index==$parent.someIndex,' +
                            'resultRed: $root.answers[slide.imsccId]>=0 && $root.answers[slide.imsccId]<50,' +
                            'resultBlue: $root.answers[slide.imsccId]>=50 && $root.answers[slide.imsccId]<70,' +
                            'resultYellow: $root.answers[slide.imsccId]>=70 && $root.answers[slide.imsccId]<90,' +
                            'resultGreen: $root.answers[slide.imsccId]>=90}"' +
                            'ng-click="$parent.someIndex = $index">{{$index + 1}}' +
                            '</span>' +
                            '</div>' +
                            '</div>'
                    )(scope)
                );

                function compare(a, b) {
                    if (a.number < b.number) return -1;
                    if (a.number > b.number) return 1;
                    return 0;
                }
                function toList() {
                    scope.allQuestions = [];
                    angular.forEach(
                        Object.keys(scope.content.questions),
                        function(value, key) {
                            scope.allQuestions.push(
                                scope.content.questions[value]
                            );
                        }
                    );
                    scope.allQuestions.sort(compare);
                    $rootScope.answers = scope.results;
                }
            }
        };
    }
]);

/**
 * Created by nlyubich on 24.06.2015.
 */
'use strict';

angular.module('lmsClientApp').directive('squizsection', [
  '$compile',
  function($compile) {
    return {
      restrict: 'E',
      scope: {
        allData: '='
      },
      template: '<div class="voffset4" class="section" id="{{content.imsccId}}">' +
        '<h3 class="underline">{{content.title}}</h3>' +
        '<div has-role="OP_MANAGE_COURSES"></div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.content = scope.allData;
        // scope.sendAnswer = scope.send();

        scope.allQuestions = [];
        toList();
        scope.someIndex = 0;
        element.append(
          $compile(
            '<squizsection ng-repeat="(key, section) in content.children" content="section"/>' +
              "<div class='quiz-container'>" +
              '<ul style="height: 700px" rn-carousel rn-carousel-buffered rn-carousel-indicator rn-carousel-index="someIndex">' +
              '  <li ng-repeat="question in allQuestions">' +
              '   <question1c content="question" class="quiz"></question1c>' +
              '  </li>' +
              '<div class="rn-carousel-controls cntrl">\n' +
              '  <span class="rn-carousel-control rn-carousel-control--prev" style="border: 1px solid #43c5eb; padding-top: 10px; padding-bottom: 10px; border-radius: 3px; padding-left: 3px; padding-right: 3px;" ng-click="prevSlide()" ng-if="carouselIndex > 0 || true">< к предыдущему заданию</span>\n' +
              '  <span class="rn-carousel-control rn-carousel-control--next" style="border: 1px solid #43c5eb; padding-top: 10px; padding-bottom: 10px; border-radius: 3px; padding-left: 3px; padding-right: 3px;" ng-click="nextSlide()" ng-if="carouselIndex < (allQuestions).length - 1 || true">к следующему заданию ></span>\n' +
              '</div>' +
              '</ul>' +
              '<div rn-carousel-indicators ng-if="allQuestions.length > 1" slides="allQuestions" rn-carousel-index="someIndex" ng-click="$parent.index=$index" style="position: absolute; bottom:0;right:50%"></div>' +
              '</div>' +
              '</squizsection>'
          )(scope)
        );
        function compare(a, b) {
          if (a.number < b.number) return -1;
          if (a.number > b.number) return 1;
          return 0;
        }
        function toList() {
          scope.allQuestions = [];
          angular.forEach(Object.keys(scope.content), function(value, key) {
            scope.allQuestions.push(scope.content[value]);
          });
          scope.allQuestions.sort(compare);
        }
      }
    };
  }
]);

/**
 * Created by nlyubich on 24.06.2015.
 */
'use strict';

angular.module('lmsClientApp').directive('tkrsection', [
  '$compile',
  function($compile) {
    return {
      restrict: 'E',
      scope: {
        content: '='
      },
      template: '<div class="voffset4" class="section" id="{{content.imsccId}}">' +
        '<h3 class="underline">{{content.title}}</h3>' +
        '<div has-role="OP_MANAGE_COURSES"></div>' +
        '</div>',
      link: function(scope, element, attrs) {
        scope.isTkr = true;
        if (scope.content === void 0) throw new Error('lost quiz data');
        scope.allQuestions = [];
        toList();
        element.append(
          $compile(
            '<tkrsection ng-repeat="(key, section) in content.children" content="section"/>' +
              '<tkr-question tkr={{isTkr}} ng-repeat="question in allQuestions" content="question" class="quiz"/>'
          )(scope)
        );
        function compare(a, b) {
          if (a.number < b.number) return -1;
          if (a.number > b.number) return 1;
          return 0;
        }
        function toList() {
          scope.allQuestions = [];
          angular.forEach(Object.keys(scope.content.questions), function(value, key) {
            scope.allQuestions.push(scope.content.questions[value]);
          });
          scope.allQuestions.sort(compare);
        }
      }
    };
  }
]);

'use strict';
angular.module('lmsClientApp').directive('tkrQuestion', [
  'lmsConfig',
  function(lmsConfig) {
    return {
      restrict: 'E',
      scope: {
        content: '=',
        tkr: '@'
      },
      link: function(scope, element, attrs) {
        scope.question = scope.content;

        if (scope.question.shuffledResponses) {
          scope.question.shuffledResponses.sort(compare);
        }
        var notSupported = [
          'file_upload_question',
          'calculated_question',
          'text_only_question',
          'essay_question'
        ];
        if (notSupported.indexOf(scope.content.type.name) > -1) {
          scope.typeServed = false;
        } else {
          scope.typeServed = true;
          scope.contentUrl = lmsConfig.modulesPath +
            'quiz/views/' +
            scope.content.type.name +
            '.html';
        }
        /*attrs.$observe("content.type.name", function(v){
                 scope.contentUrl = 'scripts/app/quiz/templates/' + v + '.html';
                 });*/
        function compare(a, b) {
          if (a.number < b.number) return -1;
          if (a.number > b.number) return 1;
          return 0;
        }
      },
      template: '<div ng-include="contentUrl" tkr={{tkr}} ng-if="typeServed"></div>'
    };
  }
]);

'use strict';

angular.module('lmsClientApp')
    // disable ability to enter chars in input. Allow to enter only one comma.
    .directive('numbersOnly', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {
                var commaInText = false;

                // event.type должен быть keypress
                function getChar(event) {
                    if (event.which === null) { // IE
                        if (event.keyCode < 32) return null; // спец. символ
                        return String.fromCharCode(event.keyCode);
                    }

                    if (event.which !== 0 && event.charCode !== 0) { // все кроме IE
                        if (event.which < 32) return null; // спец. символ
                        return String.fromCharCode(event.which); // остальные
                    }
                    return null; // спец. символ
                }

                function checkComma() {
                    if (!element[0].value.match(',')) {
                        commaInText = false;
                    }
                    if (commaInText) {
                        return false;
                    }
                    commaInText = true;
                }

                element.bind('keypress', function(keyEvent) {
                    var keyData = getChar(keyEvent);

                    if (keyData.match(/[^0-9,]/g)) {
                        return false;
                    } else if (keyData === ',') {
                        return checkComma();
                    }
                });
            }
        };
    });

'use strict';

var app = angular.module('lmsClientApp');

app.service('Quiz', [
  '$auth',
  '$state',
  'StatisticActivity',
  'rest',
  '$rootScope',
  '$mdDialog',
  'lmsConfig',
  '$q',
  'ModalStack',
  'CourseResource',
  'QuizProgressResource',
  'QuizResource',
  function(
    $auth,
    $state,
    StatisticActivity,
    rest,
    $rootScope,
    $mdDialog,
    lmsConfig,
    $q,
    ModalStack,
    CourseResource,
    QuizProgressResource,
    QuizResource
  ) {
    // Variables
    var self = this;
    var attempCoefficients = [0, 0, 0.75, 0.9, 1];
    var quizDefaultSettings = {
      _status: {
        responseString: {},
        quizAnswers: {},
        isFinished: false
      }
    };
    this.quiz = angular.copy(quizDefaultSettings);
    this.openQueryParams = null;

    // Methods
    this.getQuiz = getQuiz;
    this.isAvailable = isAvailable;
    this.answerQuiz = answerQuiz;
    this.answerQuizQuestion = answerQuizQuestion;
    this.saveQuestionAnswer = saveQuestionAnswer;
    this.getQuestionAttempt = getQuestionAttempt;
    // this.open = open;
    this.roundPercentage = roundPercentage;
    this.getQuizProgress = getQuizProgress;
    this.getAttempt = getAttempt;
    this.getQuestionAttempts = getQuestionAttempts;
    this.getMaxAttempts = getMaxAttempts;
    this.getAllAttempts = getAllAttempts;
    this.getCorrectAnswers = getCorrectAnswers;
    this.getLastAttempt = getLastAttempt;
    this.getDraftAttempt = getDraftAttempt;
    this.getQuestionAns = getCorrectQuestionAnswers;
    this.getQuizStats = getQuizStats;
    this.getQuizProgressForStudent = getQuizProgressForStudent;

    this.open = function(cid, qid, sid, flashBack) {
      if (cid === void 0 || qid === void 0) return false;

      /*jshint validthis:true */
      this.openQueryParams = {
        courseId: cid,
        quizId: qid,
        studentId: sid
      };

      if (!flashBack) {
        ModalStack.add(this.open, arguments, this);
      }

      $mdDialog.show({
        controller: function($scope, $mdDialog) {
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },
        templateUrl: lmsConfig.modulesPath + 'quiz/views/_showQuizContainer.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true
      });

      StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

    };
    this.open1C = function(qid) {
      if (qid === void 0) return false;

      /*jshint validthis:true */
      this.openQueryParams = {
        quizId: qid
      };
      $mdDialog.show({
        controller: function($scope, $mdDialog) {
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },
        templateUrl: lmsConfig.modulesPath + 'quiz/views/_showQuiz1c.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true
      });

      StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

    };
    this.openOneTry = function(cid, qid, sid, flashBack) {
      if (cid === void 0 || qid === void 0) {
        return false;
      }
      this.openQueryParams = {
        courseId: cid,
        quizId: qid,
        studentId: sid
      };
      if (!flashBack) {
        ModalStack.add(this.open, arguments, this);
      }
      $mdDialog.show({
        controller: function($scope, $mdDialog) {
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },
        templateUrl: lmsConfig.modulesPath + 'quiz/views/_showQuizOneTry.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true
      });

      StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

      // .then(
      //   function(answer) {},
      //   function() {
      //     ModalStack.pop().callLast();
      //   }
      // )
    };

    this.openReady = function(cid, qid, sid) {
      if (cid === void 0 || qid === void 0) {
        console.log('Error: courseId, quizId');
        return false;
      }
      this.openQueryParams = {
        courseId: cid,
        quizId: qid,
        studentId: sid
      };
      $mdDialog.show({
        controller: function($scope, $mdDialog) {
          $scope.hide = function() {
            $mdDialog.hide();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },
        templateUrl: lmsConfig.modulesPath + 'quiz/views/_showQuizReady.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true
      });

      StatisticActivity.sendWatch($state.params.lid, $auth.user.id);

    };

    function getQuiz(cid, qid) {
      if (qid !== void 0 && cid !== void 0) {
        var dfd = $q.defer();
        CourseResource.getQuiz(
          {
            id: cid,
            quizImsccId: qid
          },
          function(response) {
            resetQuiz();
            angular.extend(self.quiz, response);
            angular.extend($rootScope, {
              quiz: {
                status: self.quiz._status
              }
            });
            dfd.resolve(self.quiz);
          }
        );
        return dfd.promise;
      }
    }
    /**
         *
         * @param {*} cid
         * @param {*} qid
         * @param {*} qqid
         * @param {*} sid
         */
    function isAvailable(cid, qid, qqid, sid) {
      return CourseResource.isQuestionAvailable({
        id: cid,
        quizImsccId: qid,
        questionImsccId: qqid,
        studentId: sid
      }).$promise;
    }
    function answerQuiz(cid, qid, data) {
      if (cid !== void 0 && qid !== void 0) {
        return CourseResource.answerQuiz(
          {
            id: cid,
            quizImsccId: qid,
            studentId: $rootScope.user.id
          },
          data,
          function(response) {
            self.quiz._status.responseString = response;
            self.quiz._status.isFinished = true;
          }
        ).$promise;
      }
    }
    /**
         * return Object {0: {correct: boolean, text: "0.00"}, quizImccId: { correct: boolean, text: ""} }
         * @param {*} cid courseId
         * @param {*} qid quizImccId
         * @param {*} qqid quizQuestionImsccId
         * @param {*} data Object { imsccId: answerImsccId}
         */

    function answerQuizQuestion(cid, qid, qqid, data) {
      if (cid !== void 0 && qid !== void 0) {
        return CourseResource.answerQuizQuestion(
          {
            id: cid,
            quizImsccId: qid,
            questionImsccId: qqid,
            studentId: $rootScope.user.id
          },
          data
        ).$promise;
      }
    }
    function roundPercentage(value, attempts) {
      return Math.round(value * attempCoefficients[attempts], 0);
    }

    function getQuizProgressForStudent(courseId, topicId, quizImsccId, studentId) {
      var dfd = $q.defer();
      QuizProgressResource.getAllByCourseIdTopicIdAndStudentIds(
        {
          courseId: courseId,
          topicId: topicId,
          studentsIds: studentId
        },
        function(response) {
          var studentQuizProgress;
          for (var i = 0; i < response.length; i++) {
            if (response[i].imscc == quizImsccId) {
              studentQuizProgress = response[i];
              break;
            }
          }
          dfd.resolve(studentQuizProgress);
        }
      )
      return dfd.promise;
    }

    function getQuizProgress(cid, qid, sid) {
      if (cid !== void 0 && qid !== void 0 && sid !== void 0) {
        var dfd = $q.defer();
        CourseResource.getQuizProgress(
          {
            id: cid,
            quizImsccId: qid,
            studentId: sid
          },
          function(response) {
            angular.extend(self.quiz, response);
            angular.extend($rootScope, {
              quiz: {
                status: self.quiz._status
              }
            });
            dfd.resolve(self.quiz);
          }
        );
        return dfd.promise;
      }
    }
    /**
         * return array of attempts
         * @param {*} cid courseId
         * @param {*} qid quizImccId
         * @param {*} qqid quizQuestionImsccId
         * @param {*} sid studentId
         */
    function getQuestionAttempts(cid, qid, qqid, sid) {
      if (cid !== void 0 && qid !== void 0 && sid !== void 0) {
        var dfd = $q.defer();
        CourseResource.getQuestionAttempts({
          id: cid,
          quizImsccId: qid,
          questionImsccId: qqid,
          studentId: sid
        }).$promise.then(
          function(response) {
            self.quiz._status.responseString[qqid] = response;
            self.quiz._status.quizAnswers[qqid] = response;
            angular.extend($rootScope, {
              quiz: {
                status: self.quiz._status
              }
            });
            dfd.resolve(response);
          },
          function(response) {
            dfd.reject(response);
          }
        );
        return dfd.promise;
      }
    }
    /**
         * return attempt by number
         * @param {*} cid courseId
         * @param {*} qid quizImccId
         * @param {*} qqid quizQuestionImsccId
         * @param {*} sid studentId
         * @param {*} attempt 1-4 number of attempt
         */
    function getQuestionAttempt(cid, qid, qqid, sid, attempt) {
      if (cid !== void 0 && qid !== void 0 && sid !== void 0) {
        return CourseResource.getQuestionAttempt({
          id: cid,
          quizImsccId: qid,
          questionImsccId: qqid,
          studentId: sid,
          attempt: attempt !== void 0 && attempt !== null ? attempt : 1
        }).$promise;
      }
    }

    function getAttempt(cid, qid, sid, attempt) {
      if (cid !== void 0 && qid !== void 0 && sid !== void 0) {
        var dfd = $q.defer();
        CourseResource.getQuizAttempt({
          id: cid,
          quizImsccId: qid,
          studentId: sid,
          attempt: attempt !== void 0 && attempt !== null ? attempt : 1
        }).$promise.then(
          function(response) {
            self.quiz._status.responseString = response.feedbacks;
            self.quiz._status.quizAnswers = response.answers;
            angular.extend($rootScope, {
              quiz: {
                status: self.quiz._status
              }
            });
            dfd.resolve(response);
          },
          function(response) {
            dfd.reject(response);
          }
        );
        return dfd.promise;
      }
    }
    function saveQuestionAnswer(cid, qid, qqid, sid, ian, data) {
      if (cid !== void 0 && qid !== void 0) {
        return CourseResource.saveQuizQuestionDraft(
          {
            id: cid,
            quizImsccId: qid,
            questionImsccId: qqid,
            studentId: sid,
            interimAnswer: ian
          },
          data
        ).$promise;
      }
    }
    function roundPercentage(value, attempts) {
      return Math.round(value * attempCoefficients[attempts], 0);
    }
    function getAllAttempts(cid, qid, sid) {
      if (cid !== void 0 && qid !== void 0 && sid !== void 0) {
        return CourseResource.getQuizAllAttempts({
          id: cid,
          quizImsccId: qid,
          studentId: sid
        }).$promise;
      } else {
        var dfd = $q.defer();
        dfd.reject('courseId !== void 0 && quizId !== void 0 && studentId !== void 0');
        return dfd.promise;
      }
    }

    function getMaxAttempts() {
      return QuizProgressResource.getMaxAttempts().$promise;
    }
    function getCorrectQuestionAnswers(cid, qid, qqid, sid) {
      return CourseResource.isCorrectAnswer({
        id: cid,
        quizImsccId: qid,
        questionImsccId: qqid
      }).$promise;
    }
    function resetQuiz() {
      self.quiz = angular.copy(quizDefaultSettings);
      $rootScope.quiz = {};
    }
    function getLastAttempt(cid, qid, qqid, sid) {
      return CourseResource.isLastAttempt({
        id: cid,
        quizImsccId: qid,
        questionImsccId: qqid,
        studentId: sid
      }).$promise;
    }

    function getDraftAttempt(cid, qid, qqid, sid) {
      return CourseResource.getDraftAttempt({
        id: cid,
        quizImsccId: qid,
        questionImsccId: qqid,
        studentId: sid
      }).$promise;
    }

    function getCorrectAnswers(cid, qid) {
      return QuizResource.getCorrectAnswers({
        courseId: cid,
        quizImsccId: qid
      }).$promise;
    }
    function getQuizStats(courseId, quizImsccId, questionImsccIds, studentId) {
      return QuizResource.getQuizStats({
        courseId: courseId,
        quizImsccId: quizImsccId,
        questionImsccIds: questionImsccIds,
        studentId: studentId
      }).$promise;
    }
  }
]);

'use strict';

angular
  .module('lmsClientApp')
  .factory('QuizProgressResource', function($resource) {
    return $resource(
      '/api/quizProgresses/',
      {},
      {
        getAttempt: {
          method: 'GET',
          url: '/api/quizProgresses/:id/attempts/:attempt'
        },
        getQuiz: {
          method: 'GET',
          url: '/api/quizProgresses/:id/quiz'
        },
        getAllByGroupIdAndCourseIdFromTopic: {
          method: 'GET',
          url: '/api/quizProgresses/group/:groupId/course/:courseId/topic/:topicId',
          transformResponse: function(data) {
            data = angular.fromJson(data);
            return data;
          },
          isArray: true
        },
        getAllByCourseIdTopicIdAndStudentIds: {
          method: 'GET',
          url: '/api/quizProgresses/course/:courseId/topic/:topicId?studentsIds=:studentsIds',
          transformResponse: function(data) {
            data = angular.fromJson(data);
            return data;
          },
          isArray: true
        },
        getAllQuizzStatisticFromTopic: {
          method: 'GET',
          url: '/api/quizProgresses/stat/course/:courseId/topic/:topicId/group/:groupId',
          transformResponse: function(data) {
            data = angular.fromJson(data);
            return data;
          },
          isArray: true
        },
        getMaxAttempts: {
          method: 'GET',
          url: '/api/quizProgresses/maxAttempts',
          isString: true
        },
        getAllQuizStatistic: {
          method: 'GET',
          url: '/api/quizProgresses/stat/:topicId/group/:groupId'
        },
        updateRequireAndHomeAssignmentById: {
          method: 'PUT',
          url: '/api/quizProgresses/:id/require/:require'
        },
        updateGroupRequiresQuiz: {
          method: 'PUT',
          url: '/api/quizProgresses/listRequires'
        }
      }
    );
  })
  .factory('QuizResource', function($resource) {
    return $resource(
      '/api/quizzes/',
      {},
      {
        update: {
          method: 'PUT'
        },
        getCorrectAnswers: {
          method: 'GET',
          url: '/api/courses/:courseId/quizzes/:quizImsccId/correct'
        },
        getQuizStats: {
          method: 'GET',
          url: '/api/courses/:courseId/quizzes/:quizImsccId/questions/:questionImsccIds/students/:studentId/container',
          isArray: true
        },
        deleteById: {
          method: 'DELETE',
          url: '/api/quizzes/:id'
        },
        getQuestionSection: {
          method: 'GET',
          url: '/api/quizzes/:id/questionSection'
        },
        updateQuestion: {
          method: 'PUT',
          url: '/api/quizzes/:id/questions'
        },
        deleteQuestion: {
          method: 'DELETE',
          url: '/api/quizzes/:id/questions/:imsccId'
        }
      }
    );
  })
  .factory('QuestionResource', function($resource) {
    return $resource(
      '/api/quizzes/',
      {},
      {
        updateQuestionUp: {
          method: 'PUT',
          url: '/api/quizzes/question/:id/up'
        },
        updateQuestionDown: {
          method: 'PUT',
          url: '/api/quizzes/question/:id/down'
        }
      }
    );
  });

'use strict';

angular.module('lmsClientApp')
.factory('RegionResource', function ($resource) {
    return $resource('/api/regions/:id', {}, {
        'getRegionsByCoordinator': {
            method: 'GET',
            url: '/api/regions/coordinator',
            isArray: true
        }
    });
});

'use strict';

angular.module('lmsClientApp')
    .factory('RubricProgressResource', function ($resource) {
        return $resource('api/rubricProgresses/', {}, {

            getAll: {
                method: 'GET',
                url: 'api/rubricProgresses/course/:courseId',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                },
                isArray: true
            },
            updateRequireAndHomeAssignmentById: {
                method: 'PUT',
                url: '/api/rubricProgresses/:id/require/:require/home/:home',
                params: {
                    id: '@id',
                    require: '@require',
                    home: '@home'
                }
            },
            getByTopic: {
                method: 'GET',
                url: '/api/rubricProgresses/topics/:topicId',
                isArray: true,
                params: {
                    'studentIds': '@studentIds'
                }
            }
        });
    });

"use strict";

function SupportDialogController($scope, $mdDialog, index, user) {
    $scope.user = user;
    $scope.user.selected = index;
    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
        $scope.user.text = "";
    };
    $scope.answer = function (answer) {
        if (answer === null) {
            $scope.cancel();
        } else {
            $mdDialog.hide(answer);
        }
    };
}

/**
 * @ngdoc controller
 * @name lmsClientApp.BottomBarCtrl
 * @description
 * # BottomBarCtrl
 * Controller of the lmsClientApp
 */
angular.module("lmsClientApp").controller("BottomBarCtrl", [
    "$rootScope",
    "$scope",
    '$http',
    "$timeout",
    "lmsConfig",
    "$mdDialog",
    "$mdMedia",
    "SupportDialog",
    "LmsUtils",
    function ($rootScope, $scope,$http,$timeout, lmsConfig, $mdDialog, $mdMedia, SupportDialog, LmsUtils) {
        $scope.ncyBreadcrumbIgnore = true;

        $scope.status = "  ";
        $scope.customFullscreen = $mdMedia("xs") || $mdMedia("sm");




        // For ChatStart
        $scope.chatIsOpen = false
        $scope.dataFront = {
            1: { id:1, type: "ChatConsultant", text: 'Какой у вас вопрос?', nextId: 11},
            // 2: { id:222, type: "ChatConsultantPicture", url: 'Уточните, что относительно курсов вас интересует?', nextId: 211},
            11: { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

            111: { id:111, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно электронного журнала?', nextId: 1111},
            1111: { id:1111, type: 'v', options: [
                    {
                        text: "Как выставить отметку за урок",
                        nextId: 11111
                    },
                    {
                        text: "Как посмотреть результаты всего класса по уроку?",
                        nextId: 11112
                    },
                    {
                        text: "Как перейти к проверке выполненных заданий из электронного журнала?",
                        nextId: 11113
                    }
                ] },
            11111:  { id:11111, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. В графе 'Отметка' за урок есть возможность выставить отметку вручную с помощью ниспадающего меню. В эту графу можно выставить отметку за работу ученика на онлайн-уроке или иной вид работы. Обратите внимание, что выставленную отметку можно исправить в любое время.", nextId: 111111},
            111111: { id:111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111111},
            1111111: { id:1111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11111111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11112:  { id:11112, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. На странице со списком учеников нажмите кнопку 'Перейти к результатам класса по уроку'. У вас откроется нужная страница.",
                nextId: 111121},
            111121: { id:111121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111211},
            1111211: { id:1111211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11112111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            111121111: { id:111121111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},
            11113:  { id:11113, type: "ChatConsultant", text: "Перейдите в меню “Электронный журнал”, выберите нужную группу. На странице со списком ученик нажмите на ФИО ученика. Далее наведите курсором мыши на ячейку “ЗОО” или “Домашнее задание” и кликните по ячейке. У вас откроется список заданий, назначенных выбранному ученику.\n",
                nextId: 111131},
            111131: { id:111131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111311},
            1111311: { id:1111311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11113111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11113111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            112: { id:112, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно доступа к системе?', nextId: 1121},
            1121: { id:1121, type: 'v', options: [
                    {
                        text: "Как изменить/сбросить свой пароль",
                        nextId: 11211
                    },
                    {
                        text: "Не могу войти в систему, что делать?",
                        nextId: 11212
                    },
                    {
                        text: "Как получить доступ к системе?",
                        nextId: 11213
                    },
                    {
                        text: "Как восстановить доступ?",
                        nextId: 11214
                    }
                ] },
            11211: { id:11211, type: "ChatConsultant", text: 'Чтобы изменить свой пароль, нажмите на кнопку в правом верхнем углу экрана и выберите пункт “Сменить пароль”:', nextId: 112111},
            112111: { id:112111, type: "ChatConsultantPicture", url: "images/chathelp/password.png", nextId: 1121111},
            1121111: { id:1121111, type: "ChatConsultant", text: "В окне 'Смена пароля' в поле 'Новый пароль' укажите свой новый пароль. Не менее 6 знаков. Подтвердите пароль в поле ниже и нажмите 'Сохранить'. Для отмены и закрытия окна нажмите 'Отмена' или крестик в верхнем правом углу окна.\n", nextId: 11211111},
            11211111: { id:11211111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112111111 },
            112111111: { id:112111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1121111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    },
                ] },
            1121111111: { id:1121111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            11212: { id:11212, type: "ChatConsultant", text: 'Сначала проверьте правильность ссылки в адресной строке браузера по которой вы хотите зайти в систему. ',
                nextId: 112121},
            112121: { id:112121, type: "ChatConsultantPicture", url: "images/chathelp/112121.png", nextId: 1121211},
            1121211: { id:1121211, type: "ChatConsultant", text: 'Далее проверьте правильность ввода логина и пароля. Если вы уверены в правильности ссылки, логина и пароля, но не можете войти в систему, напишите в службу поддержки или системному администратору.',
                nextId: 11212111},
            11212111: { id:11212111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112121111},
            112121111: { id:112121111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 112121111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1121211111: { id:1121211111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11213: { id:11213, type: "ChatConsultant", text: 'Для получения логина и пароля от системы обратитесь к вашему администратору школы. Если вы ученик, то обратитесь к своему учителю.',
                nextId: 112131},
            112131: { id:112131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121311},
            1121311: { id:1121311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11213111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11213111: { id:11213111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11214: { id:11214, type: "ChatConsultant", text: 'Если вы потеряли свой логин и пароль от системы МЭО, напишите обращение в техподдержку с помощью кнопки “Помощь” в нижнем правом углу.',
                nextId: 112141},
            112141: { id:112141, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121411},
            1121411: { id:1121411, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11214111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11214111: { id:11214111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            113: { id:113, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1131},
            1131: { id:1131, type: 'v', options: [
                    {
                        text: "Как посмотреть список доступных мне курсов",
                        nextId: 11311
                    },
                    {
                        text: "Я не вижу свои курсы, как мне их подключить",
                        nextId: 11312
                    },
                    {
                        text: "Как посмотреть тематическое планирование курса",
                        nextId: 11313
                    },
                    {
                        text: "Как посмотреть оглавление курса",
                        nextId: 11314
                    },
                    {
                        text: "Как перейти к просмотру задания к занятию",
                        nextId: 11315
                    },
                    {
                        text: "Как посмотреть список всех заданий в уроке",
                        nextId: 11316
                    },
                    {
                        text: "Как выполнить задание с открытым ответом",
                        nextId: 11317
                    }
                ] },
            11311: { id:11311, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. На странице у вас отобразится список доступных вам курсов. Для подключения дополнительных курсов по другим предметам и классам обратитесь к своему администратору школы.',
                nextId: 113111},
            113111: { id:113111, type: "ChatConsultantPicture", url: "images/chathelp/113111.png", nextId: 1131111},
            1131111: { id:1131111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11311111},
            11311111: { id:11311111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113111111: { id:113111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11312: { id:11312, type: "ChatConsultant", text: 'Если в Библиотеке курсов не отображаются нужные вам учебники, то для подключения необходимо обратится к своему учителю или администратору системы.',
                nextId: 113121},
            113121: { id:113121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131211},
            1131211: { id:1131211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11312111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113121111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11313: { id:11313, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на иконку с восклицательным знаком в нижнем правом углу обложки курса. У вас откроется окно с описанием курса и тематическим планом.',
                nextId: 113131},
            113131: { id:113131, type: "ChatConsultantPicture", url: "images/chathelp/113131.png", nextId: 1131311},

            1131311: { id:1131311, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11313111},
            11313111: { id:11313111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113131111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113131111: { id:113131111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11314: { id:11314, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков.',
                nextId: 113141},
            113141: { id:113141, type: "ChatConsultantPicture", url: "images/chathelp/113141.png", nextId: 1131411},

            1131411: { id:1131411, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11314111},
            11314111: { id:11314111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113141111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113141111: { id:113141111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11315: { id:11315, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'.Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков. Нажмите на название занятия. У вас откроется страница с оглавлением занятия. Выберите пункт \'Задание к занятию\'.',
                nextId: 113151},
            113151: { id:113151, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131511},
            1131511: { id:1131511, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11315111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11315111: { id:11315111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11316: { id:11316, type: "ChatConsultant", text: 'Нажмите на кнопку \'Итоговая страница урока\'.',
                nextId: 113161},
            113161: { id:113161, type: "ChatConsultantPicture", url: "images/chathelp/113161.png", nextId: 1131611},

            1131611: { id:1131611, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11316111},
            11316111: { id:11316111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113161111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113161111: { id:113161111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11317: { id:11317, type: "ChatConsultant", text: 'Чтобы выполнить задание с открытым ответом, нужно воспользоваться формой, которая открывается при нажатии на ссылку «Приступить к выполнению». ',
                nextId: 113171},
            113171: { id:113171, type: "ChatConsultantPicture", url: "images/chathelp/113171.png", nextId: 1131711},
            1131711: { id:1131711, type: "ChatConsultant", text: 'Чтобы ответить на задание, нужно ввести свой ответ в поле для ввода ответа. Для прикрепления файла к сообщению, нужно воспользоваться кнопкой «Прикрепить». Для прикрепления голосового сообщения нужно воспользоваться кнопкой «Записать голосовое сообщение». Для прикрепления рисунка нужно воспользоваться кнопкой «Нарисовать», далее с помощью графического редактора нарисовать изображение и сохранить рисунок. При нажатии кнопки «Сохранить» ответ сохраняется, но остаётся доступным только учащемуся. В него можно вносить любые изменения: исправлять текст, прикреплять и удалять файлы. При нажатии кнопки «Отправить», происходит отправка ответа на задание учителю.', nextId: 11317111},
            11317111: { id:11317111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 113171111},
            113171111: { id:113171111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1131711111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1131711111: { id:1131711111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            115: { id:115, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1151},
            1151: { id:1151, type: 'v', options: [
                    {
                        text: "Как назначить домашнее задание ученику?",
                        nextId: 11511
                    },
                    {
                        text: "Как установить срок выполнения заданий по уроку для всех учеников?",
                        nextId: 11512
                    }
                ] },
            11511: { id:11511, type: "ChatConsultant", text: 'Существует две возможности назначения заданий. Во-первых, задание можно назначить для выполнения на уроке. Для этого щелкните на ячейку таблицы и выберите в меню строку «Назначить». Во-вторых, задание можно назначить в качестве домашнего задания. Для этого щелкните по ячейке матрицы и выберите в меню строку «Назначить как ДЗ».\n',
                nextId: 115111},
            115111: { id:115111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151111},
            1151111: { id:1151111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1151111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11511111: { id:11511111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11512: { id:11512, type: "ChatConsultant", text: 'В Матрице назначения заданий можно установить срок выполнения назначенных заданий для всего класса. Для этого нажмите кнопку “Установить срок выполнения заданий”, далее выберите дату и время сдачи заданий и нажмите “Установить”. Установленный срок выполнения заданий отобразиться у всех учащихся в подсистеме “Органайзер и в подсистеме “Индивидуальная образовательная траектория”.',
                nextId: 115121},
            115121: { id:115121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151211},
            1151211: { id:1151211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11512111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11512111: { id:11512111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            118: { id:118, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1181},
            1181: { id:1181, type: 'v', options: [
                    {
                        text: "Как создать конференцию?",
                        nextId: 11811
                    },
                    {
                        text: "Как войти в конференцию/подключить к конференции?",
                        nextId: 11812
                    }
                ] },
            11811: { id:11811, type: "ChatConsultant", text: 'Чтобы создать видеоконференцию, нажмите кнопку «Создать видеоконференцию». После этого откроется форма для создания видеоконференции. В верхней строке введите название видеоконференции, укажите дату и время еѐ проведения, добавьте участников, выбрав их из списка пользователей системы. После этого нажмите кнопку «Создать видеоконференцию».',
                nextId: 118111},
            118111: { id:118111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181111},
            1181111: { id:1181111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11811111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11811111: { id:11811111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11812: { id:11812, type: "ChatConsultant", text: 'Чтобы войти в видеоконференцию, нажмите кнопку «Начать», если конференция не начата и кнопку «Подключиться», если конференция уже началась.\n',
                nextId: 118121},
            118121: { id:118121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181211},
            1181211: { id:1181211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11812111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11812111: { id:11812111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            110: { id:110, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1101},
            1101: { id:1101, type: 'v', options: [
                    {
                        text: "Как изменить фотографию личного профиля?",
                        nextId: 11011
                    },

                ] },
            11011: { id:11011, type: "ChatConsultant", text: 'Нажмите на ФИО в верхнем правом углу системы. ',
                nextId: 110111},
            110111: { id:110111, type: "ChatConsultantPicture", url: "images/chathelp/110111.png", nextId: 1101111},
            1101111: { id:1101111, type: "ChatConsultant", text: ' На странице личного профиля нажмите кнопку “Изменить” рядом с фото. Выберите фото на своем устройстве. Рекомендованный размер фото не менее 500Х500px. Далее нажмите кнопку “Сохранить”, чтобы сохранить внесенные изменения.\n',
                nextId: 11011111},
            11011111: { id:11011111, type: "ChatConsultantPicture", url: "images/chathelp/11011111.png", nextId: 110111111},

            110111111: { id:110111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1101111111},
            1101111111: { id:1101111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11011111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11011111111: { id:11011111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

        }


        $scope.imgUrl = "images/chathelp/password.png"
        $scope.currentIdForStepBack
        // $scope.goToNextId = function (nextId) {
        //     $scope.currentId = nextId
        //     console.log( $scope.currentId)
        //     console.log($scope.dataFront[nextId])
        //     var a = $scope.dataFront[nextId].nextId
        //     $scope.printedChatElements.push($scope.dataFront[nextId])
        //
        //     var b = $scope.dataFront[nextId].nextId
        //     console.log(b)
        //     var c = $scope.dataFront[b]
        //     console.log(c)
        //     // if (c.type == "v"){
        //     //     alert("v")
        //     // } else {
        //     //     $scope.goToNextId(a)
        //     // }
        //     // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
        //     //
        //     // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
        //     //
        //     // }
        //     // $scope.goToNextId($scope.dataFront[nextId].nextId)
        //     $scope.goToNextId(a)
        // }

        $scope.goToNextId = function (nextId) {
            console.log(nextId)
            console.log($scope.dataFront[nextId])

            if ($scope.dataFront[nextId].type == "ChatConsultant"){
                // alert("b")
                $scope.addConsultantMessage(nextId)
            } else if ($scope.dataFront[nextId].type == "v"){
                // alert("a")
                console.log($scope.dataFront[nextId])
                $scope.addBtnGroup(nextId)

            } else if ($scope.dataFront[nextId].type == 'ChatConsultantPicture'){
                $scope.addConsultantMessage(nextId)
            }




            // if ($scope.dataFront[nextId] == undefined){
            //     console.log('nextId')
            // } else {
            //     if ($scope.dataFront[nextId].type == "ChatConsultant"){
            //         // alert("b")
            //         $scope.addConsultantMessage(nextId)
            //     } else if ($scope.dataFront[nextId].type == "v"){
            //         // alert("a")
            //         console.log($scope.dataFront[nextId])
            //         $scope.addBtnGroup(nextId)
            //
            //     } else if ($scope.dataFront[nextId].type == 'ChatConsultantPicture'){
            //         $scope.addConsultantMessage(nextId)
            //     }
            // }
            //


            // if (c.type == "v"){
            //     alert("v")
            // } else {
            //     $scope.goToNextId(a)
            // }
            // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
            //
            // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
            //
            // }
            // $scope.goToNextId($scope.dataFront[nextId].nextId)

        }

        $scope.addConsultantMessage = function (nextId) {
            $scope.printedChatElements.push({type: 'loader'})
            // console.log( $scope.printedChatElements)
            $timeout(function () {
                $scope.updateScroll()
            },100)
            $timeout(function () {
                $scope.printedChatElements =  $scope.printedChatElements.filter(function (el) {
                    return el.type !== 'loader'
                })
                // console.log($scope.printedChatElements)
                $scope.currentIdForStepBack = nextId
                var a = $scope.dataFront[nextId].nextId
                $scope.printedChatElements.push($scope.dataFront[nextId])

                $scope.goToNextId(a)
                $timeout(function () {
                    $scope.updateScroll()
                },100)

            },1500)

        }

        $scope.addBtnGroup = function (nextId) {
            var a = $scope.dataFront[nextId].nextId
            $scope.printedChatElements.push($scope.dataFront[nextId])
            // console.log(a)
            if (a == undefined){
                // console.log(a)
            } else {
                $scope.goToNextId(a)
            }

            setTimeout(function () {
                $scope.updateScroll()
            },500)

        }


        $scope.stepBackBase = function () {

            $scope.stepBack($scope.currentIdForStepBack)
            setTimeout(function () {
                $scope.updateScroll()
            },200)

        }
        $scope.stepBack = function (id1) {
            var id = id1
            console.log(id)
            var stringId = id.toString()
            var a =  stringId.slice(0, -1);
            var b = $scope.dataFront[a]
            console.log(b)
            if (b.type == 'v'){
                // alert('aa')
                if (b.options[0].text == "Да"){
                    $scope.stepBack(a)
                } else {
                    var newStringId = b.id.toString()
                    console.log(newStringId)
                    var c =  newStringId.slice(0, -1);
                    console.log(c)
                    var d = $scope.dataFront[c]
                    console.log(d)
                    $scope.currentIdForStepBack = d.id
                    $scope.printedChatElements.push(d)

                    $scope.printedChatElements.push(b)
                }




            } else {
                $scope.stepBack(a)
            }


        }

        $scope.updateScroll = function () {
            // console.log(document.querySelector('.chat__body').scrollTop)
            // console.log(document.querySelector('.chat__body').scrollHeight)
            document.querySelector('.chat__body').scrollTop = document.querySelector('.chat__body').scrollHeight
        }


        $scope.printedChatElements = [
            { id:1, type: "ChatConsultant", text: 'Относительно какой из подсистем у вас вопрос?', nextId: 11},
            { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

        ]
        $scope.addElementToPrintedElements = function (option) {


            var b = {
                minutes: new Date().getMinutes(),
                hours: new Date().getHours()
            }
            var a =  { type: "ChatVisitor", text: option.text, time: b }
            $scope.printedChatElements.push(a)
        }
        $scope.deleteQuestionBlock = function (id) {
            $scope.printedChatElements =  $scope.printedChatElements.filter(function (el) {
                return el.id !== id
            })
        }



        // $scope.date ={
        //     minutes: new Date().getMinutes(),
        //     hours: new Date().getHours()
        // }
        $scope.pr = function () {
            var aa = new Date().getMinutes()
            if (aa <10){
                var bb = aa.toString()
                var cc = "0"+bb
                $scope.date ={
                    minutes: cc,
                    hours: new Date().getHours()
                }
            } else {
                $scope.date ={
                    minutes: new Date().getMinutes(),
                    hours: new Date().getHours()
                }
            }

            // console.log(aa)

        }
        $scope.pr()


        $scope.expression = "\\frac{5}{4} \\div \\frac{1}{7}";

        $scope.processChoosing = function (option){
            console.log(option)
            var w = {
                method: 'GET',
                url: 'http://a-arsenev.ru/index.php?chatId='+option.nextId,
            };

            $http(w).success(function (res) {
                })


            if (option.nextId == 0){
                $scope.showHelpForm()
            } else {
                console.log(option)
                var a = option.nextId.toString()
                var b = a.slice(0, -1)
                var c = parseInt(b)
                $scope.deleteQuestionBlock(c)
                $scope.addElementToPrintedElements(option)
                $scope.goToNextId(option.nextId)
                // console.log(option.nextId)
                // console.log($scope.dataFront[option.nextId])
                var d = $scope.dataFront[option.nextId]
                // console.log(d)
                // console.log(d.nextId)
                // $scope.goToNextId(d.nextId)
                $scope.updateScroll()
            }


        }



        $scope.switchChatShowind = function () {
            $scope.chatIsOpen = ! $scope.chatIsOpen
        }

        // $scope.goToNextId(1)
        // for chatEnd








        $rootScope.$on("userData", function (event, data) {
            var email = _.cloneDeep(data.email);
            $scope.user = { email: email };
        });

        $scope.showTabDialog = function (ev, i) {
            $mdDialog
                .show({
                    controller: SupportDialogController,
                    templateUrl: lmsConfig.modulesPath + "site/views/_supportModal.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: { index: i, user: $scope.user }
                })
                .then(
                    function (user) {
                        if (user.text !== undefined && user.text.length >= 30) {
                            var text = user.text +
                                "\n" +
                                "Контактная информация:" +
                                "\n" +
                                (user.email ? user.email : "");
                            +"\n" + (user.phone ? user.phone : "");
                            if (user.selected === 0) {
                                SupportDialog.postToSupport(
                                    {
                                        body: text
                                    },
                                    function (res) {
                                        LmsUtils.showSimpleToast("Отправлено");
                                        user.text = "";
                                    },
                                    function (err) {
                                        LmsUtils.showSimpleToast("Не отправлено");
                                    }
                                );
                            } else {
                                SupportDialog.postToMethodalist(
                                    { body: text },
                                    function (res) {
                                        LmsUtils.showSimpleToast("Отправлено");
                                        user.text = "";
                                    },
                                    function (err) {
                                        LmsUtils.showSimpleToast("Не отправлено");
                                    }
                                );
                            }
                        } else {
                            LmsUtils.showSimpleToast("Сообщение должно содержать не менее 30-ти символов");
                        }
                    },
                    function () {
                        LmsUtils.showSimpleToast("Отмена");
                    }
                );
        };

        $scope.showHelpForm = showHelpForm;

        function showHelpForm() {
            // console.log('showHelpForm');
            $mdDialog.show({
                width: 1024,
                controller: ShowHelpFormController,
                templateUrl: lmsConfig.modulesPath + "site/views/_helpForm.html",
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: true
            }).then(function () {
                //
            });
        }
    }
]);

function ShowHelpFormController($scope, $mdDialog, $auth, Role, $http, LmsUtils, API) {

    $scope.$watch(function () {
        return $auth.user.id;
    }, function (id) {
        if (id) {
            init($auth.user);
        }
    });

    function init(user) {
        $scope.formData = {
            support: 'TechnicalSupport', // MethodicalSupport
            email: '',
            phone: '',
            msg: '',
            files: []
        };

        $scope.close = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.hide();
        };

        $scope.getPhotoPath = function () {
            var photoPath = user.profilePhotoPath ? user.profilePhotoPath : 'images/avatar_placeholder.png';
            return photoPath;
        }

        $scope.name1Name2 = function () {
            return user.firstName + ' ' + user.lastName;
        };

        $scope.userRole = function () {
            var roleNames = Role.getRoles();
            var listRoleNames = [];
            user.roles.forEach(function (role) {
                var str = roleNames[role];
                if (str) {
                    listRoleNames.push(str);
                }
            });
            var roleName = listRoleNames.join(' ,');
            return roleName;
        };

        $scope.fileAdd = function (target) {
            var formDataFiles = $scope.formData.files;
            var files = target.files;
            if (!!files) {
                var file = files[0];
                if (file) {
                    formDataFiles.push(file);
                }
            }
            $scope.formData.files = formDataFiles;
            $scope.$apply();
        }

        $scope.deleteFile = function (file) {
            var files = $scope.formData.files;
            var newFiles = files.filter(function (item) {
                if (item === file) {
                    return false;
                }
                return true;
            });
            $scope.formData.files = newFiles;
        }

        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }

        $scope.submit = function () {
            // console.log($scope.formData);
            var scopeFormData = $scope.formData;
            // Проверяем правильность данных
            if (!(!!scopeFormData.email || !!scopeFormData.phone)) {
                LmsUtils.showSimpleToast('Email или телефон, обязательно!');
                return;
            }

            if (!validateEmail(scopeFormData.email)) {
                LmsUtils.showSimpleToast('Email не валидный!');
                return;
            }

            if (!scopeFormData.msg) {
                LmsUtils.showSimpleToast('Сообщение, обязательно!');
                return;
            }

            var formData = new FormData();
            formData.append("support", scopeFormData.support);
            formData.append("email", scopeFormData.email);
            formData.append("phone", scopeFormData.phone);
            formData.append("msg", scopeFormData.msg);

            var files = scopeFormData.files;
            // Проверяем что
            // 1) Кол-во файлов (не более 3)
            if (files.length > 3) {
                LmsUtils.showSimpleToast('Кол-во файлов не более 3 !');
                return;
            }
            // 2) Макс размер одного файла (не более 10 мб)
            var KB = 1024;
            var MB = 1024 * KB;
            var tst = files.some(function (item) {
                // console.log('item.size', item.size);
                if (item.size > 10 * MB) {
                    LmsUtils.showSimpleToast('Макс размер одного файла не более 10 мб !');
                    return true;
                }
                return false;
            });

            if (tst) {
                return;
            }
            // 3) Суммарный размер всех файлов (не более 20 мб)
            var total = 0;
            files.forEach(function (item) {
                total = total + item.size;
            });
            if (total > 20 * MB) {
                LmsUtils.showSimpleToast('Суммарный размер всех файлов не более 20 мб !');
                return;
            }
            // -----

            files.forEach(function (item) {
                formData.append("files[]", item);
            });

            var supportApi = API.supportApi + '/emails/support';

            var request = {
                method: 'POST',
                url: supportApi,
                data: formData,
                headers: {
                    'Content-Type': undefined
                }
            };

            $http(request).success(function () {
                LmsUtils.showSimpleToast('Успешно!');
                $mdDialog.hide();
            }).error(function (data, status, headers, config) {
                LmsUtils.showSimpleToast('Ошибка!');
                $mdDialog.hide();
            });
        };
    }
}

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.DefaultCtrl
 * @description
 * # DefaultCtrl
 * Controller of the lmsClientApp
 */
angular.module('lmsClientApp')
    .controller('DefaultCtrl', ['$scope', '$auth', function ($scope, $auth) {

    }]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmsClientApp
 */
app.controller('MainCtrl', ['StatisticActivity', '$scope', '$mdDialog', '$state', '$auth', '$rootScope', '$mdMedia', 'NotificationsResource',
    '$http',
    function (StatisticActivity, $scope, $mdDialog, $state, $auth, $rootScope, $mdMedia, NotificationsResource,
        $http
    ) {
    $scope.state = $state;
    var rcToken = 'rcToken'

    $scope.logOut = logOut;

    function logOut() {
        var userId = $auth.user.id;
        $auth.signOut().then(StatisticActivity.sendVisitLogout(userId)).catch(function () {});
        localStorage.removeItem(rcToken)

        $auth.signOut().then(function() {}).catch(function() {});
        localStorage.removeItem(rcToken);

        $state.go('login');
    }
    NotificationsResource.getAllPublished(function (result) {
        $scope.notifications = result;
    })
    $scope.$on('userpicChanged', function(e, args) {
        if($rootScope.user.profilePhotoPath !== args.url) {
            $rootScope.user.profilePhotoPath = args.url;
        }
    });

    $scope.$watch(function() {
        return $mdMedia('(min-width: 769px)');
    }, function(v) {
        $rootScope.windowLandscape = v;
    });
}]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.TopBarCtrl
 * @description
 * # TopBarCtrl
 * Controller of the lmsClientApp
 */
app.controller('TopBarCtrl', ['$scope', '$http', '$rootScope','$mdDialog','$timeout', '$state', '$auth', 'UserResource', 'CruduserResource', 'UserSettingsResource', 'Account', 'Role', 'Course', 'LmsUtils', '$location', 'lmsConfig', 'BookshelfResource','Dialogs','ProgressResource', 'Users', 'LmsSystemInfoResource',
    function ($scope,$http, $rootScope,$mdDialog,$timeout, $state, $auth, UserResource, CruduserResource, UserSettingsResource, Account, Role, Course, LmsUtils, $location, lmsConfig, BookshelfResource,Dialogs,ProgressResource, Users, LmsSystemInfoResource) {

        // Variables
        var roleNames = Role.getRoles(),
            originatorEv;
        $scope.ncyBreadcrumbIgnore = true;
        $scope.isParentWithChildren = false;
        $scope.currentRole = null;
        $scope.currentRoleName = null;
        $scope.selectedChild = null;
        $scope.children = [];
        $scope.roles = [];
        $scope.roleViews = {};
        $scope.user = null;
        $scope.lastBooks = [];

        // Methods
        $scope.changeRole = changeRole;
        $scope.selectStudent = selectStudent;
        $scope.changePass = changePass;
        $scope.getLastBooks = getLastBooks;
        $scope.openLastBooksMenu = openLastBooksMenu;
        $scope.goLastBook = goLastBook;
        $scope.goToAdmin = goToAdmin;

        $scope.leftNavGoToPage = leftNavGoToPage;
        $scope.openQuestionOfTheDayDialog = openQuestionOfTheDayDialog;
        $scope.chooseCourseMatrix = chooseCourseMatrix;
        $scope.chooseCourseDialog = chooseCourseDialog
        $scope.goToCourse = goToCourse;

        $scope.$watch(function () {
            return $auth.user.id;
        }, function (id) {
            if (id) {
                init(id);
            }
        });

        /* /clientCode */
        $scope.clientCode = 'NOT_CONFIGURED';
        $rootScope.$watch(
            function () {
                return $rootScope.clientCode;
            },
            function (clientCode) {
                if (clientCode !== null) {
                    $scope.clientCode = clientCode;
                }
            }
        );
        /* /clientCode */

        function init(id) {
            $scope.user = $auth.user;
            $scope.getLastBooks();
            $rootScope.$broadcast('userData', $scope.user);

            $scope.$on("courseBookmarkSaved", function () {
                $scope.getLastBooks();
            });

            Account.getAccount().then(function (res) {
                $scope.user = res;
                $scope.currentRoleName = roleNames[$scope.currentRole];
            });

            $scope.currentRole = $auth.user.userRoles[0];
            Users.getProfile(function (result) {
                var userRoles;
                $rootScope.$broadcast('userData', result);
                $scope.roles = [];
                userRoles = result.roles;

                userRoles.forEach(function (role) {
                    $scope.roles.push(roleNames[role]);
                    if ($scope.currentRole == role) {
                        $scope.currentRoleName = roleNames[role];
                    }
                });
            });

            if ($auth.isInRole('ROLE_PARENT')) {
                UserResource.getChildren({ 'parentId': id }, function (result) {
                    if (result.length > 0) {
                        $scope.isParentWithChildren = true;
                        $scope.children = result;
                        if (!$auth.user.relatedStudentId) {
                            $scope.selectedChild = $scope.children[0];
                            $auth.user.relatedStudentId = $scope.children[0].id;
                        } else {
                            $scope.children.forEach(function (child) {
                                if (child.id == $auth.user.relatedStudentId) {
                                    $scope.selectedChild = child;
                                }
                            });
                        }
                    }
                });
            }
            if ($auth.user.roleViews && $auth.user.roleViews[$auth.user.userRoles[0]]) {
                $auth.user.userRoleTranslate = $auth.user.roleViews[$auth.user.userRoles[0]];
            } else {
                $auth.user.userRoleTranslate = Role.getRoleTranslate($auth.user.userRoles[0]);
            }
        }



        // For ChatStart
        $scope.chatIsOpen = false
        $scope.dataFront = {
            1: { id:1, type: "ChatConsultant", text: 'Какой у вас вопрос?', nextId: 11},
            // 2: { id:222, type: "ChatConsultantPicture", url: 'Уточните, что относительно курсов вас интересует?', nextId: 211},
            11: { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

            111: { id:111, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно электронного журнала?', nextId: 1111},
            1111: { id:1111, type: 'v', options: [
                    {
                        text: "Как выставить отметку за урок",
                        nextId: 11111
                    },
                    {
                        text: "Как посмотреть результаты всего класса по уроку?",
                        nextId: 11112
                    },
                    {
                        text: "Как перейти к проверке выполненных заданий из электронного журнала?",
                        nextId: 11113
                    }
                ] },
            11111:  { id:11111, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. В графе 'Отметка' за урок есть возможность выставить отметку вручную с помощью ниспадающего меню. В эту графу можно выставить отметку за работу ученика на онлайн-уроке или иной вид работы. Обратите внимание, что выставленную отметку можно исправить в любое время.", nextId: 111111},
            111111: { id:111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111111},
            1111111: { id:1111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11111111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11112:  { id:11112, type: "ChatConsultant", text: "Перейдите в меню 'Электронный журнал', выберите нужную группу. На странице со списком учеников нажмите кнопку 'Перейти к результатам класса по уроку'. У вас откроется нужная страница.",
                nextId: 111121},
            111121: { id:111121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111211},
            1111211: { id:1111211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11112111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            111121111: { id:111121111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},
            11113:  { id:11113, type: "ChatConsultant", text: "Перейдите в меню “Электронный журнал”, выберите нужную группу. На странице со списком ученик нажмите на ФИО ученика. Далее наведите курсором мыши на ячейку “ЗОО” или “Домашнее задание” и кликните по ячейке. У вас откроется список заданий, назначенных выбранному ученику.\n",
                nextId: 111131},
            111131: { id:111131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1111311},
            1111311: { id:1111311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11113111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11113111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            112: { id:112, type: "ChatConsultant", text: 'Уточните, что вас интересует относительно доступа к системе?', nextId: 1121},
            1121: { id:1121, type: 'v', options: [
                    {
                        text: "Как изменить/сбросить свой пароль",
                        nextId: 11211
                    },
                    {
                        text: "Не могу войти в систему, что делать?",
                        nextId: 11212
                    },
                    {
                        text: "Как получить доступ к системе?",
                        nextId: 11213
                    },
                    {
                        text: "Как восстановить доступ?",
                        nextId: 11214
                    }
                ] },
            11211: { id:11211, type: "ChatConsultant", text: 'Чтобы изменить свой пароль, нажмите на кнопку в правом верхнем углу экрана и выберите пункт “Сменить пароль”:', nextId: 112111},
            112111: { id:112111, type: "ChatConsultantPicture", url: "images/chathelp/password.png", nextId: 1121111},
            1121111: { id:1121111, type: "ChatConsultant", text: "В окне 'Смена пароля' в поле 'Новый пароль' укажите свой новый пароль. Не менее 6 знаков. Подтвердите пароль в поле ниже и нажмите 'Сохранить'. Для отмены и закрытия окна нажмите 'Отмена' или крестик в верхнем правом углу окна.\n", nextId: 11211111},
            11211111: { id:11211111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112111111 },
            112111111: { id:112111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1121111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    },
                ] },
            1121111111: { id:1121111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            11212: { id:11212, type: "ChatConsultant", text: 'Сначала проверьте правильность ссылки в адресной строке браузера по которой вы хотите зайти в систему. ',
                nextId: 112121},
            112121: { id:112121, type: "ChatConsultantPicture", url: "images/chathelp/112121.png", nextId: 1121211},
            1121211: { id:1121211, type: "ChatConsultant", text: 'Далее проверьте правильность ввода логина и пароля. Если вы уверены в правильности ссылки, логина и пароля, но не можете войти в систему, напишите в службу поддержки или системному администратору.',
                nextId: 11212111},
            11212111: { id:11212111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 112121111},
            112121111: { id:112121111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 112121111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1121211111: { id:1121211111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11213: { id:11213, type: "ChatConsultant", text: 'Для получения логина и пароля от системы обратитесь к вашему администратору школы. Если вы ученик, то обратитесь к своему учителю.',
                nextId: 112131},
            112131: { id:112131, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121311},
            1121311: { id:1121311, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11213111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11213111: { id:11213111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11214: { id:11214, type: "ChatConsultant", text: 'Если вы потеряли свой логин и пароль от системы МЭО, напишите обращение в техподдержку с помощью кнопки “Помощь” в нижнем правом углу.',
                nextId: 112141},
            112141: { id:112141, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1121411},
            1121411: { id:1121411, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11214111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11214111: { id:11214111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},


            113: { id:113, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1131},
            1131: { id:1131, type: 'v', options: [
                    {
                        text: "Как посмотреть список доступных мне курсов",
                        nextId: 11311
                    },
                    {
                        text: "Я не вижу свои курсы, как мне их подключить",
                        nextId: 11312
                    },
                    {
                        text: "Как посмотреть тематическое планирование курса",
                        nextId: 11313
                    },
                    {
                        text: "Как посмотреть оглавление курса",
                        nextId: 11314
                    },
                    {
                        text: "Как перейти к просмотру задания к занятию",
                        nextId: 11315
                    },
                    {
                        text: "Как посмотреть список всех заданий в уроке",
                        nextId: 11316
                    },
                    {
                        text: "Как выполнить задание с открытым ответом",
                        nextId: 11317
                    }
                ] },
            11311: { id:11311, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. На странице у вас отобразится список доступных вам курсов. Для подключения дополнительных курсов по другим предметам и классам обратитесь к своему администратору школы.',
                nextId: 113111},
            113111: { id:113111, type: "ChatConsultantPicture", url: "images/chathelp/113111.png", nextId: 1131111},
            1131111: { id:1131111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11311111},
            11311111: { id:11311111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113111111: { id:113111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11312: { id:11312, type: "ChatConsultant", text: 'Если в Библиотеке курсов не отображаются нужные вам учебники, то для подключения необходимо обратится к своему учителю или администратору системы.',
                nextId: 113121},
            113121: { id:113121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131211},
            1131211: { id:1131211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11312111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113121111: { id:1111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11313: { id:11313, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на иконку с восклицательным знаком в нижнем правом углу обложки курса. У вас откроется окно с описанием курса и тематическим планом.',
                nextId: 113131},
            113131: { id:113131, type: "ChatConsultantPicture", url: "images/chathelp/113131.png", nextId: 1131311},

            1131311: { id:1131311, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11313111},
            11313111: { id:11313111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113131111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113131111: { id:113131111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11314: { id:11314, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'. Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков.',
                nextId: 113141},
            113141: { id:113141, type: "ChatConsultantPicture", url: "images/chathelp/113141.png", nextId: 1131411},

            1131411: { id:1131411, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11314111},
            11314111: { id:11314111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113141111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113141111: { id:113141111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11315: { id:11315, type: "ChatConsultant", text: 'Перейдите в меню \'Библиотека курсов\'.Нажмите на обложку курса. У вас откроется окно со списком занятий и уроков. Нажмите на название занятия. У вас откроется страница с оглавлением занятия. Выберите пункт \'Задание к занятию\'.',
                nextId: 113151},
            113151: { id:113151, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1131511},
            1131511: { id:1131511, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11315111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11315111: { id:11315111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11316: { id:11316, type: "ChatConsultant", text: 'Нажмите на кнопку \'Итоговая страница урока\'.',
                nextId: 113161},
            113161: { id:113161, type: "ChatConsultantPicture", url: "images/chathelp/113161.png", nextId: 1131611},

            1131611: { id:1131611, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 11316111},
            11316111: { id:11316111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 113161111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            113161111: { id:113161111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11317: { id:11317, type: "ChatConsultant", text: 'Чтобы выполнить задание с открытым ответом, нужно воспользоваться формой, которая открывается при нажатии на ссылку «Приступить к выполнению». ',
                nextId: 113171},
            113171: { id:113171, type: "ChatConsultantPicture", url: "images/chathelp/113171.png", nextId: 1131711},
            1131711: { id:1131711, type: "ChatConsultant", text: 'Чтобы ответить на задание, нужно ввести свой ответ в поле для ввода ответа. Для прикрепления файла к сообщению, нужно воспользоваться кнопкой «Прикрепить». Для прикрепления голосового сообщения нужно воспользоваться кнопкой «Записать голосовое сообщение». Для прикрепления рисунка нужно воспользоваться кнопкой «Нарисовать», далее с помощью графического редактора нарисовать изображение и сохранить рисунок. При нажатии кнопки «Сохранить» ответ сохраняется, но остаётся доступным только учащемуся. В него можно вносить любые изменения: исправлять текст, прикреплять и удалять файлы. При нажатии кнопки «Отправить», происходит отправка ответа на задание учителю.', nextId: 11317111},
            11317111: { id:11317111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 113171111},
            113171111: { id:113171111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1131711111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            1131711111: { id:1131711111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            115: { id:115, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1151},
            1151: { id:1151, type: 'v', options: [
                    {
                        text: "Как назначить домашнее задание ученику?",
                        nextId: 11511
                    },
                    {
                        text: "Как установить срок выполнения заданий по уроку для всех учеников?",
                        nextId: 11512
                    }
                ] },
            11511: { id:11511, type: "ChatConsultant", text: 'Существует две возможности назначения заданий. Во-первых, задание можно назначить для выполнения на уроке. Для этого щелкните на ячейку таблицы и выберите в меню строку «Назначить». Во-вторых, задание можно назначить в качестве домашнего задания. Для этого щелкните по ячейке матрицы и выберите в меню строку «Назначить как ДЗ».\n',
                nextId: 115111},
            115111: { id:115111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151111},
            1151111: { id:1151111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 1151111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11511111: { id:11511111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11512: { id:11512, type: "ChatConsultant", text: 'В Матрице назначения заданий можно установить срок выполнения назначенных заданий для всего класса. Для этого нажмите кнопку “Установить срок выполнения заданий”, далее выберите дату и время сдачи заданий и нажмите “Установить”. Установленный срок выполнения заданий отобразиться у всех учащихся в подсистеме “Органайзер и в подсистеме “Индивидуальная образовательная траектория”.',
                nextId: 115121},
            115121: { id:115121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1151211},
            1151211: { id:1151211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11512111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11512111: { id:11512111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            118: { id:118, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1181},
            1181: { id:1181, type: 'v', options: [
                    {
                        text: "Как создать конференцию?",
                        nextId: 11811
                    },
                    {
                        text: "Как войти в конференцию/подключить к конференции?",
                        nextId: 11812
                    }
                ] },
            11811: { id:11811, type: "ChatConsultant", text: 'Чтобы создать видеоконференцию, нажмите кнопку «Создать видеоконференцию». После этого откроется форма для создания видеоконференции. В верхней строке введите название видеоконференции, укажите дату и время еѐ проведения, добавьте участников, выбрав их из списка пользователей системы. После этого нажмите кнопку «Создать видеоконференцию».',
                nextId: 118111},
            118111: { id:118111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181111},
            1181111: { id:1181111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11811111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11811111: { id:11811111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            11812: { id:11812, type: "ChatConsultant", text: 'Чтобы войти в видеоконференцию, нажмите кнопку «Начать», если конференция не начата и кнопку «Подключиться», если конференция уже началась.\n',
                nextId: 118121},
            118121: { id:118121, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1181211},
            1181211: { id:1181211, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11812111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11812111: { id:11812111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

            110: { id:110, type: "ChatConsultant", text: 'Уточните, что вас интересует?', nextId: 1101},
            1101: { id:1101, type: 'v', options: [
                    {
                        text: "Как изменить фотографию личного профиля?",
                        nextId: 11011
                    },

                ] },
            11011: { id:11011, type: "ChatConsultant", text: 'Нажмите на ФИО в верхнем правом углу системы. ',
                nextId: 110111},
            110111: { id:110111, type: "ChatConsultantPicture", url: "images/chathelp/110111.png", nextId: 1101111},
            1101111: { id:1101111, type: "ChatConsultant", text: ' На странице личного профиля нажмите кнопку “Изменить” рядом с фото. Выберите фото на своем устройстве. Рекомендованный размер фото не менее 500Х500px. Далее нажмите кнопку “Сохранить”, чтобы сохранить внесенные изменения.\n',
                nextId: 11011111},
            11011111: { id:11011111, type: "ChatConsultantPicture", url: "images/chathelp/11011111.png", nextId: 110111111},

            110111111: { id:110111111, type: "ChatConsultant", text: 'Нам удалось решить ваш вопрос?', nextId: 1101111111},
            1101111111: { id:1101111111, type: 'v', options: [
                    {
                        text: "Да",
                        nextId: 11011111111
                    },
                    {
                        text: "Нет",
                        nextId: 0
                    }
                ] },
            11011111111: { id:11011111111, type: "ChatConsultant", text: 'Спасибо!', nextId: 9},

        }


        $scope.imgUrl = "images/chathelp/password.png"
        $scope.currentIdForStepBack
        // $scope.goToNextId = function (nextId) {
        //     $scope.currentId = nextId
        //     console.log( $scope.currentId)
        //     console.log($scope.dataFront[nextId])
        //     var a = $scope.dataFront[nextId].nextId
        //     $scope.printedChatElements.push($scope.dataFront[nextId])
        //
        //     var b = $scope.dataFront[nextId].nextId
        //     console.log(b)
        //     var c = $scope.dataFront[b]
        //     console.log(c)
        //     // if (c.type == "v"){
        //     //     alert("v")
        //     // } else {
        //     //     $scope.goToNextId(a)
        //     // }
        //     // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
        //     //
        //     // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
        //     //
        //     // }
        //     // $scope.goToNextId($scope.dataFront[nextId].nextId)
        //     $scope.goToNextId(a)
        // }

        $scope.goToNextId = function (nextId) {
            console.log(nextId)
            console.log($scope.dataFront[nextId])

                if ($scope.dataFront[nextId].type == "ChatConsultant"){
                    // alert("b")
                    $scope.addConsultantMessage(nextId)
                } else if ($scope.dataFront[nextId].type == "v"){
                    // alert("a")
                    console.log($scope.dataFront[nextId])
                    $scope.addBtnGroup(nextId)

                } else if ($scope.dataFront[nextId].type == 'ChatConsultantPicture'){
                    $scope.addConsultantMessage(nextId)
                }




            // if ($scope.dataFront[nextId] == undefined){
            //     console.log('nextId')
            // } else {
            //     if ($scope.dataFront[nextId].type == "ChatConsultant"){
            //         // alert("b")
            //         $scope.addConsultantMessage(nextId)
            //     } else if ($scope.dataFront[nextId].type == "v"){
            //         // alert("a")
            //         console.log($scope.dataFront[nextId])
            //         $scope.addBtnGroup(nextId)
            //
            //     } else if ($scope.dataFront[nextId].type == 'ChatConsultantPicture'){
            //         $scope.addConsultantMessage(nextId)
            //     }
            // }
            //


            // if (c.type == "v"){
            //     alert("v")
            // } else {
            //     $scope.goToNextId(a)
            // }
            // if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "ChatConsultant"){
            //
            // } else if ($scope.dataFront[$scope.dataFront[nextId].nextId].type == "v"){
            //
            // }
            // $scope.goToNextId($scope.dataFront[nextId].nextId)

        }

        $scope.addConsultantMessage = function (nextId) {
            $scope.printedChatElements.push({type: 'loader'})
            console.log( $scope.printedChatElements)
            $timeout(function () {
                $scope.updateScroll()
            },100)
            $timeout(function () {
                $scope.printedChatElements =  $scope.printedChatElements.filter(function (el) {
                    return el.type !== 'loader'
                })
                console.log($scope.printedChatElements)
                $scope.currentIdForStepBack = nextId
                var a = $scope.dataFront[nextId].nextId
                $scope.printedChatElements.push($scope.dataFront[nextId])

                $scope.goToNextId(a)
                $timeout(function () {
                    $scope.updateScroll()
                },100)

            },1500)

        }

        $scope.addBtnGroup = function (nextId) {
            var a = $scope.dataFront[nextId].nextId
            $scope.printedChatElements.push($scope.dataFront[nextId])
            console.log(a)
            if (a == undefined){
                console.log(a)
            } else {
                $scope.goToNextId(a)
            }

            setTimeout(function () {
                $scope.updateScroll()
            },500)

        }


        $scope.stepBackBase = function () {

            $scope.stepBack($scope.currentIdForStepBack)
            setTimeout(function () {
               $scope.updateScroll()
            },200)

        }
        $scope.stepBack = function (id1) {
            var id = id1
            console.log(id)
            var stringId = id.toString()
            var a =  stringId.slice(0, -1);
            var b = $scope.dataFront[a]
            console.log(b)
            if (b.type == 'v'){
                // alert('aa')
                if (b.options[0].text == "Да"){
                    $scope.stepBack(a)
                } else {
                    var newStringId = b.id.toString()
                    console.log(newStringId)
                    var c =  newStringId.slice(0, -1);
                    console.log(c)
                    var d = $scope.dataFront[c]
                    console.log(d)
                    $scope.currentIdForStepBack = d.id
                    $scope.printedChatElements.push(d)

                    $scope.printedChatElements.push(b)
                }




            } else {
                $scope.stepBack(a)
            }


        }

        $scope.updateScroll = function () {
            console.log(document.querySelector('.chat__body').scrollTop)
            console.log(document.querySelector('.chat__body').scrollHeight)
            document.querySelector('.chat__body').scrollTop = document.querySelector('.chat__body').scrollHeight
        }


        $scope.printedChatElements = [
            { id:1, type: "ChatConsultant", text: 'Относительно какой из подсистем у вас вопрос?', nextId: 11},
            { id:11, type: 'v', options: [
                    {
                        text: "Электронный журнал",
                        nextId: 111
                    },
                    {
                        text: "Доступ к системе",
                        nextId: 112
                    },
                    {
                        text: "Библиотека курсов",
                        nextId: 113
                    },
                    {
                        text: "Электронный дневник",
                        nextId: 114
                    },
                    {
                        text: "Матрица назначения заданий",
                        nextId: 115
                    },
                    // {
                    //     text: "Личные сообщения",
                    //     nextId: 116
                    // },
                    // {
                    //     text: "Мессенджер",
                    //     nextId: 117
                    // },
                    {
                        text: "Конференции",
                        nextId: 118
                    },
                    // {
                    //     text: "Органайзер",
                    //     nextId: 119
                    // },
                    {
                        text: "Настройки личного профиля",
                        nextId: 110
                    }
                ] },

        ]
        $scope.addElementToPrintedElements = function (option) {


            var b = {
                minutes: new Date().getMinutes(),
                hours: new Date().getHours()
            }
            var a =  { type: "ChatVisitor", text: option.text, time: b }
            $scope.printedChatElements.push(a)
        }
        $scope.deleteQuestionBlock = function (id) {
            $scope.printedChatElements =  $scope.printedChatElements.filter(function (el) {
                return el.id !== id
            })
        }



        // $scope.date ={
        //     minutes: new Date().getMinutes(),
        //     hours: new Date().getHours()
        // }
        $scope.pr = function () {
            var aa = new Date().getMinutes()
            if (aa <10){
                var bb = aa.toString()
                var cc = "0"+bb
                $scope.date ={
                    minutes: cc,
                    hours: new Date().getHours()
                }
            } else {
                $scope.date ={
                    minutes: new Date().getMinutes(),
                    hours: new Date().getHours()
                }
            }

            console.log(aa)

        }
        $scope.pr()


        $scope.expression = "\\frac{5}{4} \\div \\frac{1}{7}";

        $scope.processChoosing = function (option){

            if (option.nextId == 0){
                    $scope.showHelpForm()
            } else {
                console.log(option)
                var a = option.nextId.toString()
                var b = a.slice(0, -1)
                var c = parseInt(b)
                $scope.deleteQuestionBlock(c)
                $scope.addElementToPrintedElements(option)
                $scope.goToNextId(option.nextId)
                console.log(option.nextId)
                console.log($scope.dataFront[option.nextId])
                var d = $scope.dataFront[option.nextId]
                console.log(d)
                console.log(d.nextId)
                // $scope.goToNextId(d.nextId)
                $scope.updateScroll()
            }


        }



        $scope.switchChatShowind = function () {
            $scope.chatIsOpen = ! $scope.chatIsOpen
        }

        // $scope.goToNextId(1)
        // for chatEnd



        // searchStart

        $scope.getkeys = function (event) {

                if (event.keyCode == 13) {
                    $scope.openSearchResults()
                }
        }

        // document.addEventListener('keydown', function(event) {
        //     if (event.code == 'Enter') {
        //         $scope.openSearchResults()
        //     } else if(event.code == "NumpadEnter"){
        //         $scope.openSearchResults()
        //     }
        // });

        $scope.searchInput = ""
        $scope.searchResults = []
        $scope.openSearchResults = function () {

            $rootScope.searchInput = $scope.searchInput
            console.log($scope.searchInput)
            // var request = {
            //     method: 'GET',
            //     url: '/api/bookshelf/search?search_text='+$scope.searchInput,
            //
            // };
            //
            // $http(request).success(function (res) {
            //     console.log(res)
            //     $scope.searchResults = res
            //     $rootScope.searchResults = res
            // }).error(function (data, status, headers, config) {
            //
            // });

            // UserResource.getSearchResults($scope.searchInput)

            $state.go('searchResults');
        }


        // searchEnd



        // additional chat start



        $scope.showHelpForm = showHelpForm;


        function showHelpForm() {
            // console.log('showHelpForm');
            $mdDialog.show({
                width: 1024,
                controller: ShowHelpFormController,
                templateUrl: lmsConfig.modulesPath + "site/views/_helpForm.html",
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: true
            }).then(function () {
                //
            });
        }


        function ShowHelpFormController($scope, $mdDialog, $auth, Role, $http, LmsUtils, API) {

            $scope.$watch(function () {
                return $auth.user.id;
            }, function (id) {
                if (id) {
                    init($auth.user);
                }
            });

            function init(user) {
                $scope.formData = {
                    support: 'TechnicalSupport', // MethodicalSupport
                    email: '',
                    phone: '',
                    msg: '',
                    files: []
                };

                $scope.close = function () {
                    $mdDialog.hide();
                };
                $scope.cancel = function () {
                    $mdDialog.hide();
                };

                $scope.getPhotoPath = function () {
                    var photoPath = user.profilePhotoPath ? user.profilePhotoPath : 'images/avatar_placeholder.png';
                    return photoPath;
                }

                $scope.name1Name2 = function () {
                    return user.firstName + ' ' + user.lastName;
                };

                $scope.userRole = function () {
                    var roleNames = Role.getRoles();
                    var listRoleNames = [];
                    user.roles.forEach(function (role) {
                        var str = roleNames[role];
                        if (str) {
                            listRoleNames.push(str);
                        }
                    });
                    var roleName = listRoleNames.join(' ,');
                    return roleName;
                };

                $scope.fileAdd = function (target) {
                    var formDataFiles = $scope.formData.files;
                    var files = target.files;
                    if (!!files) {
                        var file = files[0];
                        if (file) {
                            formDataFiles.push(file);
                        }
                    }
                    $scope.formData.files = formDataFiles;
                    $scope.$apply();
                }

                $scope.deleteFile = function (file) {
                    var files = $scope.formData.files;
                    var newFiles = files.filter(function (item) {
                        if (item === file) {
                            return false;
                        }
                        return true;
                    });
                    $scope.formData.files = newFiles;
                }

                function validateEmail(email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                }

                $scope.submit = function () {
                    // console.log($scope.formData);
                    var scopeFormData = $scope.formData;
                    // Проверяем правильность данных
                    if (!(!!scopeFormData.email || !!scopeFormData.phone)) {
                        LmsUtils.showSimpleToast('Email или телефон, обязательно!');
                        return;
                    }

                    if (!validateEmail(scopeFormData.email)) {
                        LmsUtils.showSimpleToast('Email не валидный!');
                        return;
                    }

                    if (!scopeFormData.msg) {
                        LmsUtils.showSimpleToast('Сообщение, обязательно!');
                        return;
                    }

                    var formData = new FormData();
                    formData.append("support", scopeFormData.support);
                    formData.append("email", scopeFormData.email);
                    formData.append("phone", scopeFormData.phone);
                    formData.append("msg", scopeFormData.msg);

                    var files = scopeFormData.files;
                    // Проверяем что
                    // 1) Кол-во файлов (не более 3)
                    if (files.length > 3) {
                        LmsUtils.showSimpleToast('Кол-во файлов не более 3 !');
                        return;
                    }
                    // 2) Макс размер одного файла (не более 10 мб)
                    var KB = 1024;
                    var MB = 1024 * KB;
                    var tst = files.some(function (item) {
                        // console.log('item.size', item.size);
                        if (item.size > 10 * MB) {
                            LmsUtils.showSimpleToast('Макс размер одного файла не более 10 мб !');
                            return true;
                        }
                        return false;
                    });

                    if (tst) {
                        return;
                    }
                    // 3) Суммарный размер всех файлов (не более 20 мб)
                    var total = 0;
                    files.forEach(function (item) {
                        total = total + item.size;
                    });
                    if (total > 20 * MB) {
                        LmsUtils.showSimpleToast('Суммарный размер всех файлов не более 20 мб !');
                        return;
                    }
                    // -----

                    files.forEach(function (item) {
                        formData.append("files[]", item);
                    });

                    var supportApi = API.supportApi + '/emails/support';

                    var request = {
                        method: 'POST',
                        url: supportApi,
                        data: formData,
                        headers: {
                            'Content-Type': undefined
                        }
                    };

                    $http(request).success(function () {
                        LmsUtils.showSimpleToast('Успешно!');
                        $mdDialog.hide();
                    }).error(function (data, status, headers, config) {
                        LmsUtils.showSimpleToast('Ошибка!');
                        $mdDialog.hide();
                    });
                };
            }
        }


        // additional chat end




        function leftNavGoToPage(button) {
            var stateRoles1 = $auth.isInAnyRole([
                'ROLE_DEPUTY_HEAD_TEACHER',
                'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                'ROLE_HEAD_TEACHER'
            ]); // add COORDINATOR -> MASH-373 add ROLE_HEAD_TEACHER MASH-636
            if (button === 'Journal' && stateRoles1) {
                var schoolId;
                SchoolResource.getByCoordinator(function (result) {
                    if (result.length > 0) {
                        schoolId = result[0].id;
                        $state.go('JournalRoles1', {
                            schoolId: schoolId
                        });
                    }
                });
                return;
            }
            if (button === 'dialogs') {
                $state.go(button, {});
            } else if (button === 'Journal' || button === 'Statistics') {
                openJournalOrStatistics(button);
            } else if (button === 'ctp') {
                openCtp(button);
            }
        }


        //



        function openQuestionOfTheDayDialog() {
            Users.getMessage({id: 0}, (function (users) {
                Dialogs.createDialog(false, users, {dialogTheme:'Вопрос дня'}).then(function (dialog) {
                    if (dialog && dialog.id) {
                        Dialogs.openDialog(dialog.id);
                    }
                });
            }))
        }

        function chooseCourseMatrix() {
            var initialYear = 2021;
            CourseGroupResource.getAllForTeacher(
                {
                    teacherId: $auth.user.id,
                    year: initialYear
                },
                function (response) {
                    console.log('sss')
                    var courses = {};
                    for (var cg in response) {
                        for (var c in response[cg].course) {
                            courses[response[cg].course[c].id] = response[
                                cg
                                ].course[c];
                        }
                    }
                    Course.openCourseTopicList(courses, function (cid, tid) {
                        $state.go('courseSectionOpenTaskTable', {
                            courseId: cid,
                            tid: tid
                        });
                    });
                }
            );
        }

        function chooseCourseDialog() {
            if ($auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT'])) {
                $scope.courses = null;
                $scope.childs = null;
                $scope.child = null;
                $scope.sid = null;
                if ($auth.isInRole('ROLE_STUDENT')) {
                    $scope.sid = $auth.user.id;
                    ProgressResource.getAllForStudent(
                        {
                            studentId: $auth.user.id
                        },
                        function (result) {
                            $scope.courses = result;
                            if ($scope.courses.length < 1) {
                                LmsUtils.showSimpleToast(
                                    'Нет доступных курсов'
                                );
                                $scope.cancel();
                            }
                            goToCourse();
                        }
                    );
                } else if ($auth.isInRole('ROLE_PARENT')) {
                    if ($auth.user.relatedStudentId) {
                        $scope.sid = $auth.user.relatedStudentId;
                        ProgressResource.getAllForStudent(
                            {
                                studentId: $auth.user.relatedStudentId
                            },
                            function (result) {
                                $scope.courses = result;
                                if ($scope.courses.length < 1) {
                                    LmsUtils.showSimpleToast(
                                        'Нет доступных курсов'
                                    );
                                    $scope.cancel();
                                }
                                goToCourse();
                            }
                        );
                    } else {
                        LmsUtils.showSimpleToast('Не выбран ребенок!');
                    }
                }
            }
        }
        function goToCourse() {
            Course.openCourseTopicList(
                $scope.courses,
                function (cid, tid) {
                    $state.go('courseSectionOpenTaskTable', {
                        courseId: cid,
                        tid: tid
                    });
                }
            );
        }

        function selectStudent(studentId) {
            sessionStorage.setItem("relatedStudentId", JSON.stringify(studentId));
            $state.reload();
        }

        function changeRole(role) {
            var putRoleResolve = function (result) {
                $auth.loadAccountInfo(true).then(function (result) {
                    $state.go('dashboard', {}, {
                        reload: true
                    });
                });
            };

            for (var prop in roleNames) {
                if (roleNames.hasOwnProperty(prop)) {
                    if (prop !== $scope.currentRole && roleNames[prop] === role) {
                        UserSettingsResource.putRole({ 'role': prop }, {}).$promise.then(putRoleResolve);
                    }
                }
            }
        }

        function changePass() {
            Account.changePassDialog();
        }

        function getLastBooks() {
            BookshelfResource.getLastBooks().$promise.then(function (response) {
                $scope.lastBooks = response;
            });
        }

        function openLastBooksMenu($mdMenu, ev) {
            if ($scope.lastBooks && $scope.lastBooks.length > 0) {
                originatorEv = ev;
                $mdMenu.open(ev);
            } else {
                LmsUtils.showSimpleToast("Нет последних курсов");
            }
        }

        function goLastBook(book) {
            if (book && book.id) {
                if (book.bookmark && book.bookmark !== '' && !(/^\s+$/.test(book.bookmark))) {
                    // Для студента и родителя путь без префикса
                    if ($auth.isInAnyRole(['ROLE_STUDENT', 'ROLE_PARENT'])) {
                        book.bookmark.replace(/^bookshelf\//, "");
                    } else {
                        if (book.bookmark.search(/^bookshelf\//) < 0) {
                            book.bookmark = 'bookshelf/' + book.bookmark;
                        }
                    }
                    $location.url(book.bookmark);
                } else {
                    Course.getDynamicSyllabus(book.id).then(function (response) {
                        if (response && response.length > 0 && response[0].id) {
                            // Для студента и родителя путь без префикса
                            if ($auth.isInRole('ROLE_STUDENT')) {
                                $state.go('courseTopic', { 'courseId': book.id, 'tid': response[0].id });
                            } else if ($auth.isInRole('ROLE_PARENT')) {
                                if ($auth.user.relatedStudentId !== void 0) {
                                    $state.go('courseTopic', { 'courseId': book.id, 'tid': response[0].id, 'studentId': $auth.user.relatedStudentId });
                                } else {
                                    LmsUtils.showSimpleToast("Не выбран ребенок!");
                                }
                            } else {
                                $state.go('courseTopic', { 'courseId': book.id, 'tid': response[0].id, 'coursePath': 'bookshelf' });
                            }
                        }
                    });
                }
            }
        }

        function goToAdmin() {
            window.location.href = lmsConfig.mainDomain + "/index.html";
        }
    }]);

'use strict';

/**
 * @ngdoc controller
 * @name lmsClientApp.LmsConfirmDialogCtrl
 * @description
 * # LmsConfirmDialogCtrl
 * Controller of the lmsClientApp
 */
app.controller('LmsConfirmDialogCtrl', ['$scope', 'options', 'close', function ($scope, options, closeModal) {

    // Variables
    $scope.confirmDialogTitle = options.confirmDialogTitle;
    $scope.confirmDialogText = options.confirmDialogText;
    $scope.confirmDialogOkBtn = options.confirmDialogOkBtn;
    $scope.confirmDialogCancelBtn = options.confirmDialogCancelBtn;

    // Methods
    $scope.confirmOk = confirmOk;
    $scope.confirmCancel = confirmCancel;

    function confirmCancel() {
        closeModal(false);
    }

    function confirmOk() {
        closeModal(true);
    }
}]);

'use strict';

var app = angular.module('lmsClientApp');

app.service('LmsUtils', ['$mdToast', '$mdDialog', '$q', 'ModalService', 'lmsConfig', function($mdToast, $mdDialog, $q, ModalService, lmsConfig) {

    var self = this;

    /* Toasts */
    // Variables
    this.toastPosition = {
        bottom: true,
        top: false,
        left: false,
        right: true
    };

    // Methods
    this.getToastPosition = function() {
        return Object.keys(this.toastPosition)
            .filter(function(pos) { return self.toastPosition[pos]; })
            .join(' ');
    };

    this.showSimpleToast = function(text) {
        $mdToast.show(
            $mdToast.simple()
                .content(text)
                .position(this.getToastPosition())
                .hideDelay(3000)
        );
    };

    this.showActionToast = function(text, btnText) {
        var toast = $mdToast.simple()
            .content(text)
            .action(btnText ? btnText : "OK")
            .highlightAction(false)
            .position(this.getToastPosition());

        $mdToast.show(toast).then(function() {});
    };
    /* End Toasts */

    /* Dialogs */
    this.showAlertDialog = function(text, title) {
        if(!text || text === '' || /^\s+$/.test(text))
            return false;

        $mdDialog.show(
            $mdDialog.alert()
                .parent(angular.element(document.body))
                .clickOutsideToClose(true)
                .title(title ? title : '')
                .textContent(text)
                .ariaLabel('Alert Dialog')
                .ok('OK')
        );
    };

    this.showConfirmDialog = function(text, title, okBtn, cancelBtn) {
        if(!text || text === '' || /^\s+$/.test(text))
            return false;

        var dfd = $q.defer();

        var confirm = $mdDialog.confirm()
            .title(title ? title : '')
            .textContent(text)
            .ariaLabel('Confirm dialog')
            .ok(okBtn ? okBtn : 'Ok')
            .cancel(cancelBtn ? cancelBtn : 'Cancel');
        $mdDialog.show(confirm).then(function() {
            dfd.resolve();
        }, function() {
            dfd.reject();
        });

        return dfd.promise;
    };

    this.showLmsConfirmDialog = function(text, title, okBtn, cancelBtn) {
        var dfd = $q.defer();

        if(text === void 0) {
            dfd.reject('text param undefined');
        } else {
            ModalService.showModal({
                templateUrl: lmsConfig.modulesPath + "site/views/_lmsConfirmDialog.html",
                controller: 'LmsConfirmDialogCtrl',
                inputs: {
                    options: {
                        confirmDialogTitle : title ? title : '',
                        confirmDialogText : text,
                        confirmDialogOkBtn : okBtn ? okBtn : 'Ok',
                        confirmDialogCancelBtn : cancelBtn ? cancelBtn : 'Cancel'
                    }
                }
            }).then(function(modal) {
                modal.close.then(function(result) {
                    if(result === true) {
                        dfd.resolve();
                    } else {
                        dfd.reject();
                    }
                });
            }).catch(function(error) {
                dfd.reject('modal error');
            });
        }

        return dfd.promise;
    };
    /* End Dialogs */

    this.dateIsTimestamp = function(value) {
        return angular.isNumber(value) && isFinite(value) && value % 1 === 0 && value > 0;
    };
}]);

'use strict';

app.filter('roleViewFilter', function(Role) {
    return function(input, roleViews) {
        var result = input,
            roleList = Role.getRoles(),
            rawRoleName = '';
        for (var role in roleList) {
            if (roleList.hasOwnProperty(role)) {
                if (input ===  roleList[role]) {
                    rawRoleName = role;
                }
            }
        }

        for (var roleName in roleViews) {
            if (roleViews.hasOwnProperty(roleName)) {
                if (rawRoleName == roleName) {
                    result = roleViews[roleName];
                }
            }
        }
        return result;
    };
});

'use strict';

angular.module('lmsClientApp')
    .factory('SupportDialog', function ($resource, API) {
        var supportApi = API.supportApi + '/emails';
        return $resource(supportApi, {}, {
            'postToSupport': {
                method: 'POST',
                url: supportApi + '/support',
            },
            'postToMethodalist': {
                method: 'POST',
                url: supportApi + '/method',
            }
        })
    })
'use strict';

angular.module('lmsClientApp')
    .factory('UserResource', function ($resource) {
        return $resource('/api/users/', {}, {
            'getChildren': {
                method: 'GET',
                url: '/api/users/parents/:parentId',
                isArray: true
            },
            'getByRoles': {
                method: 'GET',
                url: '/api/users/authority/:roles',
                isArray: true
            },
            'getById': {
                method: 'GET',
                url: '/api/users/id/:userId'
            },
            'getClientId': {
                method: 'GET',
                url: '/mesh/clientId'
            },
            'getLessons': {
                method: 'GET',
                url: '/theme-frame/vendor/1/parallel/:num/du/:du'
            },
            'getStudents': {
                method: 'GET',
                url: '/mesh/students/class_id/:classId/lesson_id/:lessonId'
            },
            'postAttach': {
                method: 'POST',
                url: '/mesh/attach'
            },
        });
    })
    .factory('Users', function ($resource, API) {
        var newApi = API.clientApi + '/users'
        return $resource(newApi, {}, {
            'getProfile': {
                method: 'GET',
                url: '/api/users/userInfo'
            },
            'deleteProfileDocument': {
                method: 'POST',
                url: '/api/account/deleteDocument/:id'
            },
            'getConference': {
                method: 'GET',
                // url: newApi + '/conference/:id',
                url: '/videoconf/users/:id',
                isArray: true
            },
            'getMessage': {
                method: 'GET',
                url: '/conversation/users/:id',
                isArray: true
            },
            'getAllInConversation': {
                method: 'GET',
                url: newApi + '/conversation/:id',
                isArray: true
            },
            'getAllInConversation2': {
                method: 'GET',
                url: '/conversation/participants/:id',
                isArray: true
            }
        });
    })

'use strict';

app.provider('Role', function() {

  var roles = {};

  return {

    setRoles: function(val) {
        roles = val;
    },

    $get: function() {
        function getRoleTranslate(role) {
            if(roles) {
                return roles[role] ? roles[role] : '';
            }
        }

        function getRoles() {
            if(roles) {
                return roles;
            }
        }

        return {
            getRoleTranslate: getRoleTranslate,
            getRoles: getRoles
        };
    }
  };
});

'use strict';

app.config([
    'RoleProvider',
    function(RoleProvider) {
        RoleProvider.setRoles({
            ROLE_USER: 'Пользователь',
            ROLE_ADMIN: 'Администратор',
            ROLE_LOCAL_ADMIN: 'Локальный администратор',
            ROLE_LOCATION_COORDINATOR: 'Локальный координатор',
            ROLE_SCHOOL_ADMIN: 'Школьный администратор',
            ROLE_TEACHER: 'Учитель',
            ROLE_STUDENT: 'Ученик',
            ROLE_ANONYMOUS: 'Анонимный пользователь',
            ROLE_GUEST: 'Гость',
            ROLE_TUTOR: 'Тьютор',
            ROLE_DEPUTY_HEAD_TEACHER: 'Заместитель директора',
            ROLE_HEAD_TEACHER: 'Директор',
            ROLE_PSYCHOLOGIST: 'Психолог',
            ROLE_PARENT: 'Родитель',
            ROLE_METHODOLOGIST: 'Методист',
            ROLE_REGIONAL_COORDINATOR: 'Региональный координатор',
            ROLE_TERRITORY_COORDINATOR: 'Территориальный координатор',
            ROLE_ADDITIONAL_EDUCATION_COORDINATOR: 'Координатор по дополнительному образованию',
            ROLE_PROJECT_ACTIVITY_COORDINATOR: 'Координатор проектной деятельности',
            ROLE_OUT_OF_SCHOOL_ACTIVITY_COORDINATOR: 'Координатор внеурочной деятельности',
            ROLE_CONSULTANT: 'Консультант',
            ROLE_DISTANCE_EDUCATION_COORDINATOR: 'Координатор дистанционного образования',
            ROLE_STATISTICS_MANAGER: 'Ответственный за сбор статистики',
            ROLE_COURSE_DEVELOPER: 'Разработчик курсов'
        });
    }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('UserGroupResource', function ($resource) {
        return $resource('/api/userGroups/:id', {}, {
            'query': {
                method: 'GET',
                url: '/api/userGroups',
                params: {
                    'page': '@page',
                    'per_page': '@per_page'
                },
                isArray: true
            },
            'getAllBySchoolForCoordinator': {
                method: 'GET',
                url: '/group/userGroups/coordinators/school/:schoolId?studyYear=:year',
                isArray: true
            },
            'getAllForTutor': {
                method: 'GET',
                url: '/api/userGroups/findByTutorId/:tutorId?studyYear=:year',
                isArray: true
            },
            'getStudents': {
                method: 'GET',
                url: '/group/userGroup/:id/studentInfo',
                isArray: true
            },
            'getCourses': {
                method: 'GET',
                url: '/group/userGroup/:id/possibleCourses',
                isArray: true
            },
            'getByCourseIdAndCurrentUserId': {
                method: 'GET',
                url: '/api/userGroups/courses/:courseId',
                isArray: true
            },
            'getBySchoolCourseAndCurrentCoordinatorId': {
                method: 'GET',
                url: '/api/userGroups/schools/:schoolId/courses/:courseId',
                isArray: true
            },
            'getCurrent': {
                method: 'GET',
                url: '/api/userGroups/current',
                isArray: true
            },
            'getForCurrentUser': {
                method: 'GET',
                url: '/api/userGroups/currentUser',
                isArray: true
            },
            'getAvailableGroupsInTeachersSchool': {
                method: 'GET',
                url: '/journal/teacher/group',
                isArray: true
            },
            'getData': {
                method: 'GET',
                // url: 'http://10.1.16.110:8090/quiz/assign',
                url: 'http://10.1.16.102/tests/quiz/6',
                isArray: true
            },
            'getQuizData': {
                method: 'GET',
                url: 'http://10.1.16.102/tests/quiz/9/assignment',
                isArray: true
            },
            'sendQuizData': {
                method: 'POST',
                url: 'http://10.1.16.102/tests/quiz',
                // isArray: true
            },
            'getQuizCreatedBy': {
                method: 'GET',
                url: 'http://10.1.16.102/tests/quiz?created_by=:id',
                isArray: true
            },
            'getQuizAssignedTo': {
                method: 'GET',
                url: 'http://10.1.16.102/tests/quiz?assigned_to=:id',
                isArray: true
            },
        });
    });

'use strict';

//angular.module('lmsClientApp')
//    .factory('UserSettingsResource', ['$resource',function ($resource) {
//        return $resource('/api/userSettings/:id', {}, {
//            'query': {method: 'GET', isArray: true},
//            'update': {
//                method: 'PUT',
//                url: '/api/userSettings',
//            },
//            'putRole': {
//                method: 'PUT',
//                url: '/api/userSettings/role/:role',
//            }
//        });
//    }]);

angular.module('lmsClientApp')
    .factory('UserSettingsResource', ['$resource',function ($resource) {
        return $resource('/admin/user/settings/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'update': {
                method: 'PUT',
                url: '/admin/user/settings/update',
            },
            'putRole': {
                method: 'PUT',
                url: '/api/userSettings/role/:role',
            }
        });
    }]);

'use strict';

app.controller('VideoConfCtrl', [
    '$auth',
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$window',
    'lmsConfig',
    'Conferences',
    'VideoConfResource',
    'VideoConfConfigResource',
    '$stateParams',
    '$timeout',
    '$q',
    'usSpinnerService',
    'Users',
    'Groups',
    '$http',
    function (
        $auth,
        $scope,
        $mdDialog,
        $rootScope,
        $window,
        lmsConfig,
        Conferences,
        VideoConfResource,
        VideoConfConfigResource,
        $stateParams,
        $timeout,
        $q,
        usSpinnerService,
        Users,
        Groups,
        $http
    ) {
        var VIDEO_CONF_PER_PAGE = 15; // Колличество на странице
        var VIDEO_CONF_SORTING_DIRECTION = 'ASC'; // ASC | DESC сортировка
        var VIDEO_CONF_STATUS = "active"

        // Variables
        $scope.videoConfConfigs = [];
        $scope.videoConfPages = null; // null | []
        $scope.videoConfPageNum = null; // null | number
        $scope.records = [];

        // Methods
        $scope.openVideoConfDialog = openVideoConfDialog;
        $scope.openVideoConfDialogClean = openVideoConfDialogClean;
        $scope.openVideoConfRecords = openVideoConfRecords;
        $scope.openVideoConfRecords2 = openVideoConfRecords2;


        $scope.openConfirmDialog = openConfirmDialog;
        $scope.createVideoConf = createVideoConf;
        $scope.openVideoConf = openVideoConf;
        $scope.videoConfPaginationPageClick = videoConfPaginationPageClick;
        $scope.getDataFromReact = getDataFromReact;
        // $scope.addUserNow = addUserNow;
        // $scope.deleteUserNow = deleteUserNow


        init();

        // ---
        $scope.videoConfModProps = {
            videoConfConfigs: [],
            // Создать
            openNewVideoConfDialog: function () {
                openVideoConfDialog();
            },

            // Получить данные из реакта
            getNewDataFromReact: function (data){
                getDataFromReact(data)


            },

            // Отправить данные в реактownerId
            additionalData: {

                owner: $auth.user,
                records: [],
                transferFromOrg: false,
                transferFromOrgData: [],
                addParticipantNow: function(confId,userId){
                    console.log('aaaa')
                    addParticipant(confId,userId)
                },
                deleteParticipantNow: function (confId,userId) {
                    console.log('bbbb')
                    deleteParticipant(confId,userId)
                },
                addGroupNow: function (confId,groupId){
                    console.log('zzzz')
                    console.log(groupId)
                    console.log(confId)
                    addGroup(confId,groupId)
                },
                deleteGroupNow: function (confId,groupId){
                    deleteGroup(confId,groupId)
                },
                editList: function (sorting, status) {
                    console.log('www')
                    editListNow(sorting, status)
                },
                updateVideoConfConfigsNow: function (){
                    updateVideoConfConfigs()
                }
                // addUser: function (userData) {
                //     addUserNow(userData)
                // },
                // deleteUser: function (userData) {
                //     deleteUserNow(userData)
                // }

            },
            users: [],
            groups: [],
            selectedUsers: [],
            selectedGroups: [],
            dateTime: 0,
            duration: 0,
            owner: '',

            // Начать
            createVideoConf: function (videoConfConfig) {
                createVideoConf(videoConfConfig);
            },
            // Подключиться
            openVideoConf: function (videoConfConfig) {
                openVideoConf(videoConfConfig, 'moderator');
            },
            // Просмотр
            openViewVideoConfDialogIsOwner: function (videoConfConfig) {
                var created = !!videoConfConfig.created;
                openVideoConfDialog(videoConfConfig, {
                    readOnly: false,
                    disabledInputs: true
                }, created);
            },
            // Просмотр
            openViewVideoConfDialogIsNotOwner: function (videoConfConfig) {
                openVideoConfDialog(videoConfConfig, {
                    readOnly: false
                });
            },
            // Посмотреть записи
            openVideoConfRecords: function (videoConfConfig) {
                openVideoConfRecords2(videoConfConfig);
            },
            // openVideoConfRecords2: function (videoConfConfig) {
            //     openVideoConfRecords2(videoConfConfig);
            // },

            // Заверщить видеоконференцию
            openCompleteDialog: function (videoConfConfig) {
                openConfirmDialog(videoConfConfig, false);
            },
            // Удалить видеоконференцию
            openDeleteDialog: function (videoConfConfig) {
                openConfirmDialog(videoConfConfig, true);
            },
        };
        // window.setTimeout(function () {
        //     // console.log($scope.videoConfModProps.videoConfConfigs);
        //     console.log(JSON.stringify($scope.videoConfModProps.videoConfConfigs));
        // }, 4000);
        // console.log($scope.videoConfModProps);
        // ---

        function init() {


            if ($rootScope.void){

                var id = $rootScope.void;

                // var url = "/cli/conference/"+id
                var url = "/videoconf/conference/"+id
                $http({
                    method: 'GET',
                    url: url

                }).then(

                    function successCallback(response) {
                        $scope.videoConfModProps.additionalData.transferFromOrg = true
                        $scope.videoConfModProps.additionalData.transferFromOrgData = response.data
                        console.log(response)})

            }

            Users.getConference({
                id: $scope.videoConfConfig ? $scope.videoConfConfig.id : 0
            }).$promise.then(function (result) {
                console.log(result)
                result.forEach(function (el) {
                    $scope.videoConfModProps.users.push(el)
                })
            })


            Groups.getAllForVideoConf(
                {
                    id: $scope._dialogId ? $scope._dialogId : 0
                },
                function (response) {
                    console.log('11111')
                    console.log(response)

                    response.forEach(function (el) {
                        $scope.videoConfModProps.groups.push(el)
                    })
                    // $scope.groups = response;

                }
            )

            // Ждёт айди пользователя и загружает его видеоконференции
            var unbindAuthWatcher = $scope.$watch(
                function () {
                    return $auth.user.id;
                },
                function (userId) {
                    if (userId) {
                        // Загружаем видеоконференции
                        var pageNum = getPageNumOfUrlParams();
                        loadVideoConfsByPage(userId, pageNum).then(function (result) {
                            $scope.videoConfConfigs = result.list;
                            console.log($scope.videoConfModProps)
                            console.log( $scope.videoConfConfigs)
                            createPaginationAndSetUrlParams(result.count, pageNum);
                            videoConfGetStatus(result.list, userId);
                            initPagination();
                            unbindAuthWatcher();
                        }).catch(function () {
                            unbindAuthWatcher();
                        });
                        // -- Кто знает что тут делается дальше напишите комментарий
                        if ($stateParams.vcId !== void 0 && $stateParams.vcId !== '') {
                            VideoConfConfigResource.get(
                                { id: $stateParams.vcId },
                                function (response) {
                                    var options = {
                                        readOnly: response.ownerId !== userId,
                                        disabledInputs: true
                                    };
                                    $timeout(function () {
                                        $scope.openVideoConfDialog(response, options);
                                    });
                                }
                            );
                        }
                        // ------------------------------
                    }
                }
            );
        }

        function openVideoConfDialog(videoConfConfig, options, created) {
            var templateUrl = lmsConfig.modulesPath + 'dialogs/views/newDialog.html';
            if (options && options.readOnly) {
                templateUrl = lmsConfig.modulesPath + 'dialogs/views/newDialogReadOnly.html';
            }

            $mdDialog
                .show({
                    templateUrl: templateUrl,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controller: function (scope, $mdDialog) {
                        var dateTime;
                        scope.isRunning = created;
                        scope.dateTime = {
                            date: null,
                            time: null
                        };
                        scope.minDate = new Date();
                        if (videoConfConfig) {
                            scope.videoConfConfig = videoConfConfig;
                            scope.updateDialog = true;
                            scope.newDialogName = videoConfConfig.name;
                            scope.duration = videoConfConfig.duration;
                            scope.oldUsers = videoConfConfig.participants;
                            dateTime = new Date(
                                videoConfConfig.startDate || videoConfConfig.plannedStartTime
                            );
                            scope.dateTime = {
                                date: dateTime,
                                time: dateTime
                            };
                        }
                        scope.readOnly = options ? options.readOnly : false;
                        scope.disabledInputs = options ? options.disabledInputs : false;
                        scope.isVideoConf = true;
                        scope.videoConfId = videoConfConfig ? videoConfConfig.id : null;
                        scope.elementNames = [
                            'видеоконференции',
                            'Создать видеоконференцию',
                            'Изменить видеоконференцию'
                        ];
                        scope.hide = function (answer) {
                            $mdDialog.hide(answer);
                        };
                        scope.cancel = function (updateUsersList) {
                            // Изменился список юзеров, при закрыити попапа обнавляем список коференций
                            if (!!updateUsersList) {
                                updateVideoConfConfigs();
                            }
                            $mdDialog.cancel();
                        };
                    }
                })
                .then(function (result) {
                    usSpinnerService.spin('spinnerVideoConf');
                    var conf = {
                        id: result.id ? result.id : null,
                        groupsId: result.groupsId,
                        name: result.name,
                        startDate: result.startDate || videoConfConfig.plannedStartTime,
                        usersId: result.usersId,
                        duration: result.duration
                    };
                    if (result.id) {
                        Conferences.update(conf, function () {
                            updateVideoConfConfigs();
                            usSpinnerService.stop('spinnerVideoConf');
                        });
                    } else {
                        Conferences.create({}, result, function (response) {
                            console.log("result")
                            console.log(result)
                            console.log("response")
                            console.log(response)
                            response.participants = result.participants;
                            updateVideoConfConfigs();
                            usSpinnerService.stop('spinnerVideoConf');
                        });
                    }
                });
        }

        function openVideoConfDialogClean() {
            var templateUrl = lmsConfig.modulesPath + 'videoConf/views/dialogs/newVideoConf.html';
            var rpom = $mdDialog.show({
                templateUrl: templateUrl,
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false,
                controller: 'NewVideoConfDialogCtrl'
            });
            rpom.then(function (result) {
                if ('cancel' === result) {
                    //
                }
                if ('submit' === result) {
                    // Обнавляем список коференций
                    updateVideoConfConfigs();
                }
            });
        }

        function openVideoConfRecords(videoConfConfig) {
            $mdDialog.show({
                templateUrl: lmsConfig.modulesPath + 'videoConf/views/videoConfRecords.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                escapeToClose: true,
                controller: function ($scope) {
                    $scope.loadingRecords = true;
                    VideoConfResource.getRecords(
                        {
                            recordId: videoConfConfig.bbbMeetingId
                        },
                        function (result) {
                            $scope.records = result;
                            $scope.loadingRecords = false;
                        }
                    );
                    if (videoConfConfig) {
                        $scope.videoConfConfig = videoConfConfig;
                        $scope.newDialogName = videoConfConfig.name;
                        $scope.duration = videoConfConfig.duration;
                        $scope.numberStart = videoConfConfig.numberStart;
                        $scope.lastStartDuration = videoConfConfig.lastStartDuration;
                        $scope.realFullDuration = videoConfConfig.realFullDuration;
                        if (videoConfConfig.lastStartTime === null) {
                            $scope.lastStartTime = ' — ';
                        } else {
                            $scope.lastStartTime = videoConfConfig.lastStartTime;
                        }
                    }
                    $scope.deleteRecord = function (id) {
                        VideoConfResource.deleteRecord(
                            {
                                recordId: id
                            },
                            function (result) {
                                updateVideoConfConfigs();
                                $scope.loadingRecords = true;
                                VideoConfResource.getRecords(
                                    {
                                        recordId: videoConfConfig.bbbMeetingId
                                    },
                                    function (result) {
                                        $scope.records = result;
                                        $scope.loadingRecords = false;
                                    }
                                );
                            }
                        );
                    };
                }
            });
        }

        function openVideoConfRecords2(videoConfConfig) {

            VideoConfResource.getRecords(
                {
                    recordId: videoConfConfig.bbbMeetingId
                },
                function (result) {
                    $scope.records = result;
                    $scope.videoConfModProps.additionalData.records = result


                    console.log($scope.videoConfModProps.additionalData.records)
                    console.log(  '0000000000000000000')
                    console.log(  result)
                    console.log(   $scope.videoConfModProps.additionalData.records)
                    return 'проверка'
                }
            );

        }


        function openConfirmDialog(videoConfConfig, isDelete) {
            $mdDialog
                .show({
                    templateUrl: lmsConfig.modulesPath + 'videoConf/views/_confirmDialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controller: function ($scope, $mdDialog) {
                        if (isDelete) {
                            $scope.text = 'удалить';
                        } else {
                            $scope.text = 'завершить';
                        }
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.confirm = function () {
                            $mdDialog.hide();
                        };
                    }
                })
                .then(function () {
                    if (isDelete) {
                        VideoConfConfigResource.videoconfDelete(
                            {
                                confId: videoConfConfig.id
                            },
                            function (result) {
                                updateVideoConfConfigs();
                            }
                        );
                    } else {
                        VideoConfResource.delete(
                            {
                                id: videoConfConfig.bbbMeetingId
                            },
                            function (result) {
                                updateVideoConfConfigs();
                            }
                        );
                    }
                });
        }

        function createVideoConf(videoConfConfig) {
            var data = {
                    firstName: $auth.user.firstName,
                    lastName: $auth.user.lastName,
                    meetingId: videoConfConfig.bbbMeetingId,
                    meetingName: videoConfConfig.name,
                    duration: videoConfConfig.duration
                },
                tabWindowId = window.open('about:blank', '_blank');
            VideoConfResource.create({}, data, function (result) {
                tabWindowId.location.href = result.url;
                updateVideoConfConfigs();
            });
        }

        function openVideoConf(videoConfConfig, role) {
            var data = {
                    firstName: $auth.user.firstName,
                    lastName: $auth.user.lastName,
                    meetingId: videoConfConfig.bbbMeetingId,
                    meetingName: videoConfConfig.name,
                    role: role
                },
                tabWindowId = window.open('about:blank', '_blank');
            VideoConfResource.update({}, data, function (result) {
                tabWindowId.location.href = result.url;
            });
        }

        // function videoConfSortedByTime(arr) { //   // Сначало те кторые будут потом кторые прошлые //   var arrNew = []; //   var arrOld = []; //   var timeStamp = new Date().getTime(); //   arr.forEach(function (item) { //     if (item.plannedStartTime <= timeStamp) { //       item.isOld = true; //       arrOld.push(item); //       return; //     arrNew.push(item); //   }); //   arrNew.sort(function (item1, item2) { //     if (item1.plannedStartTime >= item2.plannedStartTime) { //     } //   }); //   arrOld.sort(function (item1, item2) { //     if (item1.plannedStartTime >= item2.plannedStartTime) { //     } //   }); //   return arrNew.concat(arrOld); // }; //     } //       return 1; //     return -1; //       return 1;
        //     return -1;

        function videoConfSortedByTime(arr) {
            var newArr = [].concat(arr);
            newArr.sort(function (item1, item2) {
                if (item1.plannedStartTime >= item2.plannedStartTime) {
                    return -1;
                }
                return 1;
            });
            return newArr;
        }

        // Обработчик клика на пагинации
        function videoConfPaginationPageClick(pageNum) {
            var userId = $auth.user.id;
            if (!userId) {
                console.error('paginationPageClick !userId');
            }
            loadVideoConfsByPage(userId, pageNum).then(function (result) {
                $scope.videoConfConfigs = result.list;
                createPaginationAndSetUrlParams(result.count, pageNum);
                videoConfGetStatus(result.list, userId)
            });
        };

        // Перезагружает видеоконференции для данной страницы
        function updateVideoConfConfigs() {
            var userId = $auth.user.id;
            if (!userId) {
                console.error('paginationPageClick !userId');
            }
            var pageNum = $scope.videoConfPageNum;
            loadVideoConfsByPage(userId, pageNum).then(function (result) {
                $scope.videoConfConfigs = result.list;
                createPaginationAndSetUrlParams(result.count, pageNum);
                videoConfGetStatus(result.list, userId)
            });
        };

        // Создаёт переменные для пагинации и добавляет параметр в урл
        function createPaginationAndSetUrlParams(pagesCount, pageNum) {
            var count = Math.floor(pagesCount / VIDEO_CONF_PER_PAGE);
            if (pagesCount - count * VIDEO_CONF_PER_PAGE > 0) {
                count = count + 1;
            }
            var videoConfPages = new Array(count);

            $scope.videoConfPages = videoConfPages;
            $scope.videoConfPageNum = pageNum;
            // -----------
            var hash = window.location.hash;
            var hashArr = hash.split('?page=');
            window.location.hash = hashArr[0] + '?page=' + pageNum;
        };

        // Возвращает номер страницы если есть в урл строке
        function getPageNumOfUrlParams() {
            var hash = window.location.hash;
            var hashArr = hash.split('?page=');
            if (hashArr.length === 1) {
                return 1;
            } else {
                return +hashArr[1];
            }
        };

        // Пагинация
        var scrollStep = 38;

        $scope.videoConfPaginationToLeft = function () {
            var target = angular.element('#scroll');
            var scroll = target.scrollLeft();
            target.scrollLeft(scroll - scrollStep * 3);
        }

        $scope.videoConfPaginationToRight = function () {
            var target = angular.element('#scroll');
            var scroll = target.scrollLeft();
            target.scrollLeft(scroll + scrollStep * 3);
        }

        function initPagination() {
            var pageNum = getPageNumOfUrlParams();
            if (pageNum > 6) {
                $timeout(function () {
                    var target = angular.element('#scroll');
                    target.scrollLeft(scrollStep * (pageNum - 1));
                }, 0);
            }
        }
        // /Пагинация

        // Получает статус для каждой конференции в цыкле
        function videoConfGetStatus(list, userId) {
            if (!userId) {
                console.error('videoConfGetStatus !userId');
            }
            // ---
            $scope.videoConfModProps.videoConfConfigs = list;
            // ---
            angular.forEach(list, function (videoConfConfig) {
                var date = new Date(videoConfConfig.plannedStartTime);
                videoConfConfig.date = date;
                if (videoConfConfig.ownerId == userId) {
                    videoConfConfig.isOwner = true;
                } else {
                    videoConfConfig.isOwner = false;
                }
                if (!videoConfConfig.loadedStatusFinish) {
                    videoConfConfig.loadingStatus = true;
                    VideoConfResource.getStatus(
                        {
                            id: videoConfConfig.bbbMeetingId
                        },
                        function (result) {
                            videoConfConfig.loadedStatusFinish = true;
                            // Чтоб один раз толко зарпашивать данные
                            if (result.status && result.status == 'notFound') {
                                videoConfConfig.status = 'не начата';
                            } else {
                                videoConfConfig.status = 'онлайн';
                                videoConfConfig.created = true;
                            }
                            videoConfConfig.loadingStatus = false;
                        },
                        function (err) {
                            console.error('VideoConfResource.getStatus');
                            videoConfConfig.loadingStatus = false;
                        }
                    );
                }
            });
            // ---
            $scope.videoConfModProps.videoConfConfigs = list;
            // ---
        }

        // Загружает страницу видео конференций
        function loadVideoConfsByPage(userId, pageNum) {
            if (!userId || !pageNum) {
                console.error('loadVideoConfsByPage, !userId || !pageNum');
            }
            $timeout(function () {
                usSpinnerService.spin('spinnerVideoConf');
            }, 0);
            var dfd = $q.defer();
            VideoConfConfigResource.getForUserWithPagination({
                userId: userId,
                page: pageNum,
                per_page: VIDEO_CONF_PER_PAGE,
                sorting_direction: VIDEO_CONF_SORTING_DIRECTION,
                status: VIDEO_CONF_STATUS
            }).$promise.then(
                function (result) {
                    usSpinnerService.stop('spinnerVideoConf');
                    var list = videoConfSortedByTime(result.list);
                    dfd.resolve({
                        list: list,
                        count: result.count
                    });
                },
                function () {
                    usSpinnerService.stop('spinnerVideoConf');
                    dfd.reject();
                }
            );
            return dfd.promise;
        }

        function addParticipant(confId,userId) {
            Conferences.addParticipant(
                {
                    firstId: confId,
                    secondId: userId
                },
                function (response) {
                    console.log(response)
                }
            );
        }

        function addGroup (confId,groupId){
            console.log('xxxx')
            console.log(groupId)
            console.log(confId)
            Conferences.addGroup(
                {
                    firstId: confId,
                    secondId: groupId
                },
                function (response) {
                    console.log(response)
                }
            );
        }

        function deleteGroup (confId,groupId) {
            Conferences.deleteGroup(
                {
                    firstId: confId,
                    secondId: groupId
                },
                function (response) {
                    console.log(response)
                }
            );
        }


        function deleteParticipant(confId,userId) {
            Conferences.deleteParticipant(
                {
                    id: confId,
                    user_id: userId
                },
                function (response) {
                    console.log(response)
                }
            );
        }


        function getDataFromReact(data) {
            console.log('DATADATADATADATADATADATADATADATADATADATA')
            console.log(data)

            function testReq(data) {
                $http({
                    method: 'POST',
                    url: '/videoconf/create',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: data
                }).then(
                    function successCallback(response) {
                        console.log(response)
                        updateVideoConfConfigs();
                    })
            }
            testReq(data)
        }

        function editListNow(sorting, status) {
            VIDEO_CONF_SORTING_DIRECTION = sorting;
            VIDEO_CONF_STATUS = status;
            updateVideoConfConfigs();
        }


    }
]);

"use strict";
app.controller('NewVideoConfDialogCtrl', [
    '$auth',
    '$scope',
    '$mdDialog',
    '$q',
    '$timeout',
    'usSpinnerService',
    'Users',
    'Groups',
    'Conferences',
    'LmsUtils',
    function (
        $auth,
        $scope,
        $mdDialog,
        $q,
        $timeout,
        usSpinnerService,
        Users,
        Groups,
        Conferences,
        LmsUtils
    ) {
        $scope.newVideoConfProps = {
            users: [],
            groups: [],
            readonlyUsersId: [],
            formData: {
                confName: '',
                startDate: new Date(),
                duration: 60,
                groupsId: [],
                usersId: []
            },
            initFilterUsersOrGroups: 'ALL',
            initFilterRoles: ['ROLE_TEACHER', 'ROLE_STUDENT'],
            submit: function (formData) {
                console.log('formData', formData);
                var ownerId = $scope.newVideoConfProps.currentUser.id;
                var data = {
                    ownerId: ownerId,
                    name: formData.confName,
                    startDate: formData.startDate,
                    duration: formData.duration,
                    groupsId: formData.groupsId,
                    usersId: formData.usersId,
                };
                console.log('data', data);
                submit(data);
            },
            cancel: function () {
                $mdDialog.hide('cancel');
            }
        };

        $scope.newVideoConfDialogSpinner = false;

        init();

        function init() {
            spinnerShow();
            var prom1 = getAuthUser().then(function (user) {
                $scope.newVideoConfProps.readonlyUsersId = [user.id];
                $scope.newVideoConfProps.formData.usersId = [user.id];
                // Для пользователей с ролью "Ученик" или "Учитель" при открытии окна создания ВКС по умолчанию должны быть предустановлены галочки на всех ролях кроме «ученик» и «наблюдатель»
                if (
                    user.roles.indexOf('ROLE_STUDENT') !== -1 ||
                    user.roles.indexOf('ROLE_TEACHER') !== -1
                ) {
                    $scope.newVideoConfProps.initFilterRoles = [
                        // "ROLE_STUDENT",
                        "ROLE_ANONYMOUS",
                        "ROLE_TEACHER",
                        "ROLE_GUEST",
                        "ROLE_TUTOR",
                        "ROLE_ADMIN",
                        "ROLE_DEPUTY_HEAD_TEACHER",
                        "ROLE_HEAD_TEACHER",
                        "ROLE_PSYCHOLOGIST",
                        // "ROLE_PARENT",
                        "ROLE_METHODOLOGIST",
                        "ROLE_REGIONAL_COORDINATOR",
                        "ROLE_TERRITORY_COORDINATOR",
                        "ROLE_ADDITIONAL_EDUCATION_COORDINATOR",
                        "ROLE_PROJECT_ACTIVITY_COORDINATOR",
                        "ROLE_OUT_OF_SCHOOL_ACTIVITY_COORDINATOR",
                        "ROLE_CONSULTANT",
                        "ROLE_DISTANCE_EDUCATION_COORDINATOR",
                        "ROLE_COURSE_DEVELOPER",
                        "ROLE_LOCAL_ADMIN",
                        "ROLE_SCHOOL_ADMIN",
                        "ROLE_LOCATION_COORDINATOR"
                    ];
                }
                // console.log('user', user);
            });

            var prom2 = getUsers().then(function (list) {
                // console.log('list', list);
                $scope.newVideoConfProps.users = list;
            });

            var prom3 = getGroups().then(function (list) {
                // console.log('list', list);
                $scope.newVideoConfProps.groups = list;
            });

            $q.all([prom1, prom2, prom3]).then(function () {
                spinnerHide();
            });
        }
        /**
         * var data = {
                name: $scope.videoConfName,
                startDate: dateTime,
                duration: $scope.videoConfDuration,
                ownerId: ownerId,
                usersId: usersId,
                groupsId: groupsId
           };
         * 
         */
        function submit(data) {
            spinnerShow();
            Conferences.create(data, function (response) {
                spinnerHide();
                $mdDialog.hide('submit');
            }, function (err) {
                spinnerHide();
                console.log(err.statusText);
                LmsUtils.showSimpleToast('Что то пошло не так!');
            });
        }
        /** 
         * Получает текущего пользователя возвращает промис
        */
        function getAuthUser() {
            return $q(function (resolve, reject) {
                var unbindAuthWatcher = $scope.$watch(function () {
                    return $auth.user.id;
                }, function (userId) {
                    if (userId) {
                        var user = {
                            id: $auth.user.id,
                            lastName: $auth.user.lastName,
                            firstName: $auth.user.firstName,
                            middleName: $auth.user.middleName,
                            roles: $auth.user.userRoles
                        };
                        unbindAuthWatcher();
                        resolve(user);
                    }
                });
            });
        }
        /**
         * Закрывает диалог
        */
        function cancel() {
            $mdDialog.hide('cancel');
        }

        function spinnerShow() {
            $timeout(function () {
                usSpinnerService.spin('newVideoConfDialogSpinner');
            }, 0);
            $scope.newVideoConfDialogSpinner = true;
        }

        function spinnerHide() {
            $scope.newVideoConfDialogSpinner = false;
            usSpinnerService.stop('newVideoConfDialogSpinner');
        }
        /** 
         * Получает пользоваетелей для видеоконференции возвращает промис
        */
        function getUsers(confId) {
            var prom = Users.getConference({
                id: confId || 0
            }).$promise;
            return prom;
        }
        /** 
         * Получает группы для видеоконференции возвращает промис
        */
        function getGroups(confId) {
            var prom = Groups.getAllForVideoConf({
                id: confId || 0
            }).$promise;
            return prom;
        }
    }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('VideoConfResource', function ($resource) {
        return $resource('/api/videoConfs/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                url: '/videoconf/bbb',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'create': {
                method: 'POST',
                url: '/videoconf/bbb',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'delete': {
                method: 'DELETE',
                url: '/videoconf/bbb/:id',
                transformResponse: function (data) {
                    return {content: data};
                }
            },
            'getStatus': {
                method: 'GET',
                url: '/videoconf/bbb/:id/status',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getRecords': {
                method: 'GET',
                isArray: true,
                // url: '/api/videoConfs/records/:recordId',
                url: '/videoconf/bbb/records/:recordId',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'deleteRecord': {
                method: 'DELETE',
                url: '/videoconf/bbb/record/:recordId',
                transformResponse: function (data) {
                    return {content: data};
                }
            }
        });
    })
    .factory('Conferences', function ($resource, API) {
        var newApi = API.clientApi + '/conferences'
        return $resource(newApi, {}, {
            create: {
                method: 'POST',
                url: '/videoconf/create'
            },
            update: {
                method: 'PUT',
                url: newApi
            },
            addParticipant: {
                method: 'PUT',
                url: '/videoconf/participant'
            },
            addParticipants: {
                method: 'POST',
                url: newApi + '/participants'
            },
            deleteParticipant: {
                method: 'DELETE',
                url: '/videoconf/participant'
            },
            deleteParticipants: {
                method: 'DELETE',
                url: newApi + '/participants'
            },
            addGroup: {
                method: 'PUT',
                url: '/videoconf/groups'
            },
            deleteGroup: {
                method: 'DELETE',
                url: '/videoconf/groups'
            }
        });
    })

'use strict';

app.config(['$stateProvider', 'lmsConfig', function ($stateProvider, lmsConfig) {
    $stateProvider
        .state('videoConf', {
            parent: 'dashboard',
            url: 'videoConf',
            /*data: {
                roles: ['ROLE_STUDENT', 'ROLE_PARENT']
            },*/
            params: {
                vcId: {
                    value: '',
                    squash: true
                }
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "videoConf/views/_videoConfBar.html"
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "videoConf/views/videoConf.html",
                    controller: 'VideoConfCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Видеоконференции'
            }
        }).state('videoConfMod', {
            parent: 'dashboard',
            url: 'videoConfMod',
            params: {
                vcId: {
                    value: '',
                    squash: true
                }
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "videoConf/views/_videoConfBar.html"
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + "videoConf/views/videoConfModule.html",
                    controller: 'VideoConfCtrl'
                }
            },
            ncyBreadcrumb: {
                label: 'Видеоконференции'
            }
        });
}]);

'use strict';

angular.module('lmsClientApp')
    .factory('VideoConfConfigResource', function ($resource) {
        return $resource('/videoconf/list/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'create': {method: 'POST'},
            'getForUser': {
                method: 'GET',
                url: '/videoconf/list/:userId',
                isArray: true
            },
            'getForUserWithPagination': {
                method: 'GET',
                url: '/videoconf/list/:userId',
                transformResponse: function (data, headers) {
                    var list = angular.fromJson(data);
                    var headers = headers();
                    var count = 0;
                    var count1 = +headers['X-Total-Count'];
                    var count2 = +headers['x-total-count'];
                    var counts = count1 || count2;
                    if (!!counts) {
                        count = counts;
                    }
                    return {
                        list: list,
                        count: count,
                    };
                }
            },
            'updateGroupUser': {
                method: 'PUT',
                url: '/api/videoconfconfigs/groupUsers',
            },
            'getAvailableUsers': {
                method: 'GET',
                url: '/api/videoconfconfigs/availableUsers',
                params: {
                    'plain': '@plain'
                },
                isArray: true
            },
            'videoconfDelete': {
                method: 'DELETE',
                url: '/videoconf/delete/:confId'
            }
        });
    });

'use strict';

app.config([
    '$stateProvider',
    'lmsConfig',
    function($stateProvider, lmsConfig) {
        $stateProvider
            .state('bookshelf', {
                parent: 'dashboard',
                url: 'bookshelf',
                data: {
                    noLogin: true
                },
                views: {
                    'dashBar@dashboard': {
                        template: ''
                    },
                    'dashContent@dashboard': {
                        templateUrl: lmsConfig.modulesPath + 'bookshelf/views/default.html',
                        controller: 'BookshelfCtrl'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Библиотека курсов'
                }
            })
            .state('bookContents', {
                parent: 'bookshelf',
                url: '/books/:courseId',
                views: {
                    'dashBar@dashboard': {
                        template: ''
                    },
                    'dashContent@dashboard': {
                        templateUrl: lmsConfig.modulesPath + 'bookshelf/views/default.html',
                        controller: 'BookshelfCtrl'
                    }
                },
                ncyBreadcrumb: {
                    label: '{{courseName}}'
                }
            })
            .state('openBookshelf', {
                parent: 'dashboard',
                url: 'bookshelf-guest',
                views: {
                    'dashBar@dashboard': {
                        template: ''
                    },
                    'dashContent@dashboard': {
                        templateUrl: lmsConfig.modulesPath + 'bookshelf/views/default.html',
                        controller: 'BookshelfCtrl'
                    }
                },
                ncyBreadcrumb: {
                    label: '{{courseName}}'
                }
            });
    }
]);

'use strict';

app.controller('BookshelfCtrl', [
  '$scope',
  '$mdDialog',
  'lmsConfig',
  'Bookshelf',
  'Account',
  '$state',
  'Course',
  'BookshelfResource',
  'innopolis',
  function($scope,$mdDialog,lmsConfig, Bookshelf, Account, $state, Course, BookshelfResource, innopolis) {
    // Variables
    $scope.courses = null;
    $scope.identifiers = [];
    $scope.bookmarkIsOpen = false;
      $scope.bookmarks = [];
      $scope.addBookMark = addBookMark;
      $scope.lms = lmsConfig.coursesPath;
      // $scope.urlLms = lmsConfig.coursesPath + $scope.courses[0] + "/files/web_resources/thumb.png"

    $scope.switchBookmarkIsOpen = switchBookmarkIsOpen;
    $scope.filter = Bookshelf.shelfFilter;
    $scope.makeQueryArray = makeQueryArray;
    $scope.toggleSidenavRight = toggleSidenavRight;
    $scope.goBookmark2 = goBookmark2;
    $scope.filtersToggled = true;
    $scope.filterPanelState = 'filters-toggled';
    $scope.showBookAnnotate = showBookAnnotate;
    $scope.showTableOfContent = showTableOfContent;
    $scope.showAnatation = showAnatation;
    $scope.goToBookMark = goToBookMark;
    $scope.filterShown = false
    $scope.isInnopolisBuild = innopolis

    init();

    $scope.$watch(
      function() {
        return $scope.courses;
      },
      function(newValue, oldValue) {
        if (newValue !== oldValue) {
          makeQueryArray($scope.filter, $scope.courses);
          $scope.$broadcast('resize');
        }
      }
    );

    function addBookMark (bookmark,as){
        console.log(bookmark);
        $scope.bookmarks.push(bookmark)
        console.log( $scope.bookmarks)

    }

    function switchBookmarkIsOpen (){
        $scope.bookmarkIsOpen = !$scope.bookmarkIsOpen
        console.log( $scope.bookmarkIsOpen)
    }

    function goBookmark2 (){
        if (
            $scope.course.bookmark &&
            $scope.course.bookmark !== "" &&
            !/^\s+$/.test($scope.course.bookmark)
        ) {
            // Для студента и родителя путь без префикса
            if (
                $auth.isInAnyRole(["ROLE_STUDENT", "ROLE_PARENT"])
            ) {
                $scope.course.bookmark.replace(/^bookshelf\//, "");
            } else {
                if (
                    $scope.course.bookmark.search(/^bookshelf\//) < 0
                ) {
                    $scope.course.bookmark = "bookshelf/" +
                        $scope.course.bookmark;
                }
            }
            $location.url($scope.course.bookmark);
        }
    }

        function showTableOfContent (course){

            Bookshelf.openBookContents(course)

        }

       function showAnatation (course) {

            console.log(course)
          $mdDialog.show({
              parent: angular.element(document.body),
              templateUrl: lmsConfig.modulesPath +
                  'bookshelf/views/book_annotate.html',
              hasBackdrop: true,
              clickOutsideToClose: true,
              escapeToClose: true,
              controller: function ($scope) {
                  $scope.course = course;

                  if ($scope.course.withAnnotation) {
                   $scope.iframeUrl = '/' + lmsConfig.coursesPath + $scope.course.id +
                                        '/files/web_resources/annotation.html';
                  }
                  $scope.close = function () {
                      $mdDialog.hide();
                  };
              }
          });
      };


      function showBookAnnotate() {
          $mdDialog.show({
              parent: angular.element(document.body),
              templateUrl: lmsConfig.modulesPath +
                  "bookshelf/views/book_annotate.html",
              hasBackdrop: true,
              clickOutsideToClose: true,
              escapeToClose: true,
              controller: function ($scope, $http) {
                  $scope.course = $scope.course;
                  // console.log("scope.course", scope.course);
                  // Получаем стенфорд урл
                  var promStemfordServerUrl = $http
                      .get("/api/utils/getStemfordServerUrl")
                      .then(
                          function (result) {
                              var stemfordUrl = result.data.serverUrl;
                              return stemfordUrl;
                          },
                          function (err) {
                              console.warn(err);
                          }
                      );

                  promStemfordServerUrl.then(function (stemfordUrl) {
                      // console.log("stemfordUrl", stemfordUrl);
                      if ($scope.course.guid) {
                          var link = createStemfordLink(stemfordUrl);
                          $scope.extLink = link;
                      }
                  });

                  if (scope.course.withAnnotation) {
                      $scope.iframeUrl = "/" +
                          lmsConfig.coursesPath +
                          $scope.course.id +
                          "/files/web_resources/annotation.html";
                      $scope.iframeOnload = function () {
                          // console.log("iframeOnload", this);
                          var $iframe = angular.element(
                              "#book_annotate_iframe"
                          );
                          // console.log("$iframe", $iframe);
                          var $links = $iframe.contents().find("a");
                          // console.log("$links", $links);
                          // Ищем ссылки на стемфорд курс
                          var $stemfordLinks = $links.filter(
                              function (index, element) {
                                  return $(element).text() ===
                                      "Ссылка на курс";
                              }
                          );
                          if ($stemfordLinks.length > 0) {
                              promStemfordServerUrl.then(
                                  function (stemfordUrl) {
                                      // Заменяем ссылку
                                      var link = createStemfordLink(
                                          stemfordUrl
                                      );
                                      $stemfordLinks.each(
                                          function (index, element) {
                                              $(element).attr(
                                                  "href",
                                                  link
                                              );
                                          }
                                      );
                                  }
                              );
                          }
                      };
                  }

                  $scope.close = function () {
                      $mdDialog.hide();
                  };
              }
          });
      }

    function goToBookMark (){
          console.log('sssssssssssssssssss')
        $state.params.courseId = scope.course.id;
        Bookshelf.openBookContents(scope.course);
    }

    function makeQueryArray(query, data) {
      var i, l, identifiers = [];
      if (query == 'classNum') {
        for (i = 0; i < data.length; i++) {
          identifiers.push(data[i].classNum);
        }
        identifiers.sort(function(a, b) {
          return a - b;
        });

        l = identifiers.length;
        while (l--) {
          if (identifiers[l] == identifiers[l - 1]) {
            identifiers.splice(l, 1);
          }
        }
      } else if (query == 'group') {
        for (i = 0; i < data.length; i++) {
          if (data[i].group === void 0) {
            data[i].group = 'Нет группы';
          }
          identifiers.push(data[i].group);
        }
        identifiers.sort();
        l = identifiers.length;
        while (l--) {
          if (identifiers[l] == identifiers[l - 1]) {
            identifiers.splice(l, 1);
          }
        }
      } else {
        throw new Error('Сортировка возможна только по классу или предмету.');
      }
      return ($scope.identifiers = identifiers);
    }

    function excludeParallel(parallel, courses) {
      return courses.filter(
        function(course) {
          return course.classNum !== parallel;
        }
      );
    }

    function init() {

          console.log(window.innerWidth)
        if (window.innerWidth < 600) {
            $scope.filtersToggled = false
            $scope.filterPanelState = 'filters-not-toggled';
        }

      BookshelfResource.query().$promise.then(
        function(response) {

          // $scope.courses = $scope.isInnopolisBuild ? excludeParallel(12, response) : response;
            $scope.courses = response;
            console.log($scope.courses)
            var url = lmsConfig.coursesPath +
                $scope.courses[0].id +
                "/files/web_resources/thumb.png";
            console.log(url)
          $scope.identifiers = makeQueryArray($scope.filter, $scope.courses); // Check state
          if ($state.current.name == 'bookContents' && $state.params.courseId) {
            for (var i in $scope.courses) {
              if ($scope.courses[i].id === +$state.params.courseId) {
                Bookshelf.openBookContents($scope.courses[i]);
                return;
              }
            }
          }
        },
        function() {
          $state.go('openBookshelf');
          return;
        }
      );
    }
    $scope.$watch('filter', function(val) {
      Bookshelf.shelfFilter = val;
      if ($scope.courses) {
        $scope.identifiers = makeQueryArray(val, $scope.courses);
      }
    });
    function changeFilterState(state) {
      Bookshelf.sortType = state;
    }
    function toggleSidenavRight() {
      $scope.filtersToggled === true
        ? ($scope.filtersToggled = false)
        : ($scope.filtersToggled = true);
      if ($scope.filtersToggled === true) {
        $scope.filterPanelState = 'filters-toggled';
      } else {
        $scope.filterPanelState = 'filters-not-toggled';
      }
    }
  }
]);

"use strict";

angular.module("lmsClientApp").directive("book", [
    "$compile",
    "lmsConfig",
    "$mdDialog",
    "rest",
    "$location",
    "$auth",
    "LmsUtils",
    "$state",
    "Bookshelf",
    "$rootScope",
    "$http",
    "$q",
    function (
        $compile,
        lmsConfig,
        $mdDialog,
        rest,
        $location,
        $auth,
        LmsUtils,
        $state,
        Bookshelf,
        $rootScope,
        $http,
        $q
    ) {
        return {
            restrict: "E",
            replace: true,
            // templateUrl: lmsConfig.modulesPath + 'bookshelf/views/book.html',
            template: '<div ng-class="{open: open}">' +
                '<span ng-show="course.bookmark" ng-click="goBookmark()" class="link">' +
                '<img ng-show="!open" class="bookmark-closed"src="images/bookmark-closed.png">' +
                '<img ng-show="open" class="bookmark-open"src="images/bookmark-open.png">' +
                "</span>" +
                '<md-tooltip md-direction="top">{{course.name}}</md-tooltip>' +
                "</div>",
            scope: {
                course: "="
            },
            link: function (scope, element, attrs) {
                var courseAnnotation = "", courseContents = null;
                scope.prefix = lmsConfig.appPrefix;

                scope.open = false;

                scope.$watch(
                    "open",
                    function (val) {
                        var url,
                            books = document.getElementsByClassName("book");
                        if (val) {
                            element.removeClass("book-no-image");
                            element.addClass("book-open");
                            element.css({
                                "background-size": "contain",
                                "background-position": "center",
                                "background-repeat": "no-repeat"
                            });
                            for (var i = 0; i < books.length; i++) {
                                if (
                                    books[i] !==
                                    angular.element(element).context &&
                                    angular
                                        .element(books[i])
                                        .isolateScope().open === true
                                ) {
                                    angular
                                        .element(books[i])
                                        .isolateScope().open = false;
                                    angular
                                        .element(books[i])
                                        .removeClass("book-open");
                                }
                            }
                            if (!$rootScope.$$phase) {
                                scope.$apply();
                            }
                        } else {
                            if (scope.course.withImage) {
                                url = lmsConfig.coursesPath +
                                    scope.course.id +
                                    "/files/web_resources/thumb.png";
                                element.css({
                                    "background-image": "url(" + url + ")",
                                    "background-size": "contain",
                                    "background-position": "center",
                                    "background-repeat": "no-repeat"
                                });
                            } else {
                                element.removeClass("book-open");
                                element.addClass("book-no-image");
                                element.css({
                                    "background-size": "contain",
                                    "background-position": "center"
                                });
                            }
                        }
                    },
                    true
                );

                scope.goBookmark = function () {
                    // Проверяем, есть ли префикс для курса
                    if (
                        scope.course.bookmark &&
                        scope.course.bookmark !== "" &&
                        !/^\s+$/.test(scope.course.bookmark)
                    ) {
                        // Для студента и родителя путь без префикса
                        if (
                            $auth.isInAnyRole(["ROLE_STUDENT", "ROLE_PARENT"])
                        ) {
                            scope.course.bookmark.replace(/^bookshelf\//, "");
                        } else {
                            if (
                                scope.course.bookmark.search(/^bookshelf\//) < 0
                            ) {
                                scope.course.bookmark = "bookshelf/" +
                                    scope.course.bookmark;
                            }
                        }
                        $location.url(scope.course.bookmark);
                    }
                };

                function b64EncodeUnicode(str) {
                    return btoa(
                        encodeURIComponent(
                            str
                        ).replace(
                            /%([0-9A-F]{2})/g,
                            function toSolidBytes(match, p1) {
                                return String.fromCharCode("0x" + p1);
                            }
                        )
                    );
                }

                /**
				 * createStemfordLink
				 * stemfordUrl:   http://nextford.edunano.ru
				 * return:         https://stemford.edunano.ru/integration?base64String
				*/
                function createStemfordLink(stemfordUrl) {
                    var user = $auth.user;
                    // console.log("user", user);
                    var course = scope.course;
                    var data = {
                        email: user.email,
                        app: "nanograd",
                        first_name: user.firstName,
                        last_name: user.lastName,
                        content_id: course.guid
                    };
                    // console.log("data", data);
                    var base64String = b64EncodeUnicode(JSON.stringify(data));
                    var link = stemfordUrl + "/integration?" + base64String;
                    // console.log("link", link);
                    return link;
                }

                function showBookAnnotate() {
                    $mdDialog.show({
                        parent: angular.element(document.body),
                        templateUrl: lmsConfig.modulesPath +
                            "bookshelf/views/book_annotate.html",
                        hasBackdrop: true,
                        clickOutsideToClose: true,
                        escapeToClose: true,
                        controller: function ($scope, $http) {
                            $scope.course = scope.course;
                            // console.log("scope.course", scope.course);
                            // Получаем стенфорд урл
                            var promStemfordServerUrl = $http
                                .get("/api/utils/getStemfordServerUrl")
                                .then(
                                    function (result) {
                                        var stemfordUrl = result.data.serverUrl;
                                        return stemfordUrl;
                                    },
                                    function (err) {
                                        console.warn(err);
                                    }
                                );

                            promStemfordServerUrl.then(function (stemfordUrl) {
                                // console.log("stemfordUrl", stemfordUrl);
                                if (scope.course.guid) {
                                    var link = createStemfordLink(stemfordUrl);
                                    $scope.extLink = link;
                                }
                            });

                            if (scope.course.withAnnotation) {
                                $scope.iframeUrl = "/" +
                                    lmsConfig.coursesPath +
                                    scope.course.id +
                                    "/files/web_resources/annotation.html";
                                $scope.iframeOnload = function () {
                                    // console.log("iframeOnload", this);
                                    var $iframe = angular.element(
                                        "#book_annotate_iframe"
                                    );
                                    // console.log("$iframe", $iframe);
                                    var $links = $iframe.contents().find("a");
                                    // console.log("$links", $links);
                                    // Ищем ссылки на стемфорд курс
                                    var $stemfordLinks = $links.filter(
                                        function (index, element) {
                                            return $(element).text() ===
                                                "Ссылка на курс";
                                        }
                                    );
                                    if ($stemfordLinks.length > 0) {
                                        promStemfordServerUrl.then(
                                            function (stemfordUrl) {
                                                // Заменяем ссылку
                                                var link = createStemfordLink(
                                                    stemfordUrl
                                                );
                                                $stemfordLinks.each(
                                                    function (index, element) {
                                                        $(element).attr(
                                                            "href",
                                                            link
                                                        );
                                                    }
                                                );
                                            }
                                        );
                                    }
                                };
                            }

                            $scope.close = function () {
                                $mdDialog.hide();
                            };
                        }
                    });
                }

                angular.element(element).on("click", function (e) {
                    // Для курса с типом Стемфорд сразу открывается аннтотация
                    if (scope.course.courseType.type === "STEMFORD") {
                        showBookAnnotate();
                        return;
                    }
                    if (
                        e.target.className !== "bookmark-open" &&
                        e.target.className !== "bookmark-closed"
                    ) {
                        if (scope.open) {
                            var elemWidth = this.offsetHeight,
                                clickPos = e.offsetY;

                            if (clickPos > elemWidth / 2) {
                                if (
                                    $state.includes("bookshelf") ||
                                    $state.includes("bookContents")
                                ) {
                                    $state.params.courseId = scope.course.id;
                                    Bookshelf.openBookContents(scope.course);
                                } else if ($state.includes("openBookshelf")) {
                                    Bookshelf.openBookContents(
                                        scope.course,
                                        true
                                    );
                                }
                            } else {
                                showBookAnnotate();
                            }
                        } else {
                            scope.open = !scope.open;
                            if (!$rootScope.$$phase) {
                                scope.$apply();
                            }
                        }
                    }
                });
            }
        };
    }
]);

'use strict';

angular.module('lmsClientApp').directive('bookContainer', [
  function() {
    return {
      link: function(scope, element, attrs) {
        var singleBookshelf = element.children()[1],
          leftButton = element.children()[0],
          rightButton = element.children()[2];

        rightButton.addEventListener('click', function() {
          singleBookshelf.scrollLeft += singleBookshelf.children[0].children[0].offsetWidth;
        });

        leftButton.addEventListener('click', function() {
          singleBookshelf.scrollLeft -= singleBookshelf.children[0].children[0].offsetWidth;
        });
      },
      controller: function($element, $scope) {
        $scope.overWidth = false;

        var checkContainerWidth = function() {
          var container = $element.children()[1].children[0],
            bookshelfWrapper = $element.children()[1];

          if (container.offsetWidth > bookshelfWrapper.offsetWidth) {
            $scope.overWidth = true;
          } else {
            $scope.overWidth = false;
          }
          return $scope.overWidth;
        };
        $scope.$watch(
          function() {
            return $element.children()[1].children[0].children.length;
          },
          function(newValue, oldValue) {
            if (newValue !== oldValue) {
              checkContainerWidth();
            }
          }
        );
        window.addEventListener('resize', function() {
          checkContainerWidth();
        });
      }
    };
  }
]);

'use strict';

angular.module('lmsClientApp').directive('bookFilters', [
  'CourseResource',
  '$rootScope',
  'innopolis',
  function(CourseResource, $rootScope, innopolis) {

    function excludeParallel(parallel, parallels) {
      return parallels.filter(
        function(p) {
          return p !== parallel;
        }
      );
    }

    return {
      restrict: 'E',
      scope: {
        courses: '='
      },
      templateUrl: 'modules/bookshelf/views/book_filters.html',
      link: function(scope, elems, attrs) {
        // Переменные
        // Проверяем наличие сохраненных фильтров в сессии
        scope.courseParallels = JSON.parse(sessionStorage.getItem('parallels'))
          ? JSON.parse(sessionStorage.getItem('parallels'))
          : [];
        scope.courseGroups = JSON.parse(sessionStorage.getItem('groups'))
          ? JSON.parse(sessionStorage.getItem('groups'))
          : [];
        scope.courseTypes = JSON.parse(sessionStorage.getItem('types'))
          ? JSON.parse(sessionStorage.getItem('types'))
          : [];
        scope.limitNumber = 5;
        scope.ifFilters = false;
        // Методы
        scope.toggleList = toggleList;
        scope.toggleSidenavRight = toggleSidenavRight;

        scope.filterBookshelf = filterBookshelf;
        scope.clearFilters = clearFilters; // Получаем значения для фильтров
        CourseResource.getCourseFilters().$promise.then(function(response) {
          // if (innopolis) {
          //   response.parallels = excludeParallel(12, response.parallels);
          // }
          scope.courseFilters = response;
          scope.userCourses = scope.courses;
          // Если в сессии были сохранены какие-либо фильтры - сразу делаем фильтрацию
          if (
            scope.courseParallels.length > 0 ||
            scope.courseGroups.length > 0 ||
            scope.courseTypes.length > 0
          ) {
            filterBookshelf();
          }
          // Проверяем, сохранены ли в сессии значения каждого фильтра. Если нет - создаем их с нуля
          if (scope.courseParallels.length === 0) {
            scope.courseFilters.parallels.forEach(function(parallel) {
              scope.courseParallels.push({
                value: parallel,
                checked: false
              });
            });
          }
          if (scope.courseGroups.length === 0) {
            scope.courseFilters.courseGroups
              .map(function(group) {
                return group.name;
              })
              .sort()
              .forEach(function(group) {
                scope.courseGroups.push({
                  value: group,
                  checked: false
                });
              });
          }
          if (scope.courseTypes.length === 0) {
            scope.courseFilters.courseTypes
              .map(function(type) {
                return type.name;
              })
              .forEach(function(type) {
                scope.courseTypes.push({
                  value: type,
                  checked: false
                });
              });
          }
        });
        function toggleSidenavRight(){
            console.log('ssss')
            $scope.filtersToggled === true
                ? ($scope.filtersToggled = false)
                : ($scope.filtersToggled = true);
            if ($scope.filtersToggled === true) {
                $scope.filterPanelState = 'filters-toggled';
            } else {
                $scope.filterPanelState = 'filters-not-toggled';
            }
        }




        // Показать 5 предметов или все предметы в фильтрах
        function toggleList() {
          return scope.limitNumber === 5
            ? (scope.limitNumber = undefined)
            : (scope.limitNumber = 5);
          scope.limitNumber = 5;
        }
        function clearFilters() {
          scope.courseParallels.forEach(function(parallel) {
            parallel.checked = false;
          });
          scope.courseGroups.forEach(function(group) {
            group.checked = false;
          });
          scope.courseTypes.forEach(function(type) {
            type.checked = false;
          });
          scope.ifFilters = false;
          scope.courses = scope.userCourses;
          scope.$parent.$parent.courses = scope.courses;
          // Удаление выбранных фильтров из сессии
          sessionStorage.removeItem('parallels');
          sessionStorage.removeItem('groups');
          sessionStorage.removeItem('types');
        }
        // При клике по любому чекбоксу - обработка всех фильтров
        function filterBookshelf() {
          scope.ifFilters = false;
          scope.courses = scope.userCourses;
          var checkedCourseParallels = scope.courseParallels
            .filter(function(parallel) {
              return parallel.checked;
            })
            .map(function(parallel) {
              return parallel.value;
            });
          var checkedCourseGroups = scope.courseGroups
            .filter(function(group) {
              return group.checked;
            })
            .map(function(group) {
              return group.value;
            });
          var checkedCourseTypes = scope.courseTypes
            .filter(function(type) {
              return type.checked;
            })
            .map(function(type) {
              return type.value;
            });
          var checkedFilters = {
            classNum: checkedCourseParallels,
            group: checkedCourseGroups,
            courseType: checkedCourseTypes
          };
          for (var key in checkedFilters) {
            if (checkedFilters[key].length > 0) {
              scope.ifFilters = true;
              scope.courses = scope.courses.filter(function(course) {
                if (key === 'courseType') {
                  if (checkedFilters.courseType.indexOf(course.courseType.name) !== -1) {
                    return course;
                  }
                }
                if (checkedFilters[key].indexOf(course[key]) !== -1) {
                  return course;
                }
              });
            }
          }
          scope.$parent.$parent.courses = scope.courses;
          // Сохранение выбранных фильтров в сессии
          sessionStorage.setItem('parallels', JSON.stringify(scope.courseParallels));
          sessionStorage.setItem('groups', JSON.stringify(scope.courseGroups));
          sessionStorage.setItem('types', JSON.stringify(scope.courseTypes));
        }
      }
    };
  }
]);

'use strict';

var app = angular.module('lmsClientApp');

app.service('Bookshelf', [
    'rest',
    'lmsConfig',
    '$q',
    '$mdDialog',
    'CourseResource',
    'LmsUtils',
    'BookshelfResource',
    'TopicResource',
    function(
        rest,
        lmsConfig,
        $q,
        $mdDialog,
        CourseResource,
        LmsUtils,
        BookshelfResource,
        TopicResource
    ) {
        // Variables
        var self = this;
        this.shelfFilter = 'classNum';
        this.lastBooks = void 0;

        // Methods
        this.openBookContents = openBookContents;
        this.getLastBooks = getLastBooks;

        function openBookContents(book, guest) {
            TopicResource.getAllTopicsByCourseId(
                { courseId: book.id },
                function(response) {
                    var tpl = null;
                    if (!!book.courseType) {
                        // Сборник заданий проектно-исследовательского характера
                        if (book.courseType.id === 3) {
                            tpl = 'bookshelf/views/project_research_contents.html';
                        } // Сборник олимпиадных заданий
                        if (book.courseType.id === 2) {
                            tpl = 'bookshelf/views/olympiad_contents.html';
                        }
                        if (book.courseType.id === 12) {
                            tpl = 'bookshelf/views/ran_higs.html';
                        }
                        // Для дошкольных курсов
                        if (book.courseType.id === 4) {
                            tpl = 'bookshelf/views/preschool_contents.html';
                        }
                    }
                    openBookContentsDialog(book, response, tpl);
                }
            );
        }
        function openBookContentsDialog(book, courseData, tpl) {
            var view = 'bookshelf/views/book_contents.html';
            if (tpl) {
                view = tpl;
            }
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: lmsConfig.modulesPath + view,
                clickOutsideToClose: true,
                escapeToClose: true,
                controller: function($scope, $auth, $state, $mdDialog) {
                    $scope.course = book;
                    $scope.topics = courseData;
                    $scope.PROJECT_RESEARCH_CONTENTS = [
                        'Проектное задание',
                        'Задания проектного характера',
                        'Задания исследовательского характера'
                    ];
                    $scope.OLYMPIAD_CONTENTS = ['Задание', 'Разбор задания'];
                    if ($scope.course.courseType.id === 2) {
                        $scope.typeCourse = 'Задание';
                        $scope.typeLesson = 'Разбор';
                    } else {
                        $scope.typeCourse = 'Занятие';
                        $scope.typeLesson = 'Интернет-урок';
                    }
                    $scope.canSeeLinks = function() {
                        return $auth.user &&
                            $auth.userIsAuthenticated() &&
                            $auth.isInAnyRole([
                                'ROLE_ADMIN',
                                'ROLE_SCHOOL_ADMIN',
                                'ROLE_LOCATION_COORDINATOR',
                                'ROLE_LOCAL_ADMIN',
                                'ROLE_STUDENT',
                                'ROLE_PARENT',
                                'ROLE_TEACHER',
                                'ROLE_DISTANCE_EDUCATION_COORDINATOR',
                                'ROLE_TERRITORY_COORDINATOR',
                                'ROLE_REGIONAL_COORDINATOR',
                                'ROLE_PSYCHOLOGIST',
                                'ROLE_METHODOLOGIST',
                                'ROLE_HEAD_TEACHER',
                                'ROLE_DEPUTY_HEAD_TEACHER',
                                'ROLE_COURSE_DEVELOPER',
                                'ROLE_TUTOR'
                            ]);
                    };
                    $scope.close = function() {
                        $mdDialog.cancel();
                    };
                    $scope.goTopic = function(cid, tid, lid) {
                        if (cid !== void 0 && tid !== void 0) {
                            // Для студента и родителя путь без префикса
                            if ($auth.isInRole('ROLE_STUDENT')) {
                                if (lid) {
                                    $state.go('courseLesson', {
                                        courseId: cid,
                                        tid: tid,
                                        lid: lid,
                                        studentId: $auth.user.id
                                    });
                                } else {
                                    $state.go('courseTopic', {
                                        courseId: cid,
                                        tid: tid,
                                        studentId: $auth.user.id
                                    });
                                }
                                return;
                            }
                            if ($auth.isInRole('ROLE_PARENT')) {
                                if ($auth.user.relatedStudentId !== void 0) {
                                    if (lid) {
                                        $state.go('courseLesson', {
                                            courseId: cid,
                                            tid: tid,
                                            lid: lid,
                                            studentId: $auth.user.relatedStudentId
                                        });
                                    } else {
                                        $state.go('courseTopic', {
                                            courseId: cid,
                                            tid: tid,
                                            studentId: $auth.user.relatedStudentId
                                        });
                                    }
                                } else {
                                    LmsUtils.showSimpleToast(
                                        'Не выбран ребенок!'
                                    );
                                }
                                return;
                            }
                            if (lid) {
                                $state.go('courseLesson', {
                                    courseId: cid,
                                    tid: tid,
                                    lid: lid,
                                    coursePath: 'bookshelf'
                                });
                            } else {
                                $state.go('courseTopic', {
                                    courseId: cid,
                                    tid: tid,
                                    coursePath: 'bookshelf'
                                });
                            }
                        }
                    };
                }
            });
        }
        function getLastBooks() {
            /*jshint validthis: true */ this.lastBooks = BookshelfResource.getLastBooks().$promise;
            return this.lastBooks;
        }
    }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('BookshelfResource', function ($resource) {
        return $resource('/api/bookshelf', {}, {
            'query': {method: 'GET', isArray: true},            
            'getLastBooks': {
                method: 'GET', 
                url: '/api/bookshelf/last',
                isArray: true
            }                
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('SchoolResource', function ($resource) {
        return $resource('/api/schools/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByTerritory': {
                method: 'GET',
                url: '/api/schools/territory/:id',
                isArray: true
            },
            'update': { method:'PUT' },
            'getAllschools': {
                method: 'GET',
                url: '/api/schools',
                isArray: true
            },
            'getByCoordinator': {
                method: 'GET',
                url: '/api/schools/coordinator',
                isArray: true
            },
            'getByCourseIdAndCurrentCoordinator': {
                method: 'GET',
                url: '/api/schools/courses/:courseId',
                isArray: true
            },
            'getByTerritoryCourseAndCurrentCoordinator': {
                method: 'GET',
                url: '/api/schools/territory/:territoryId/courses/:courseId',
                isArray: true
            },
            'getCurrentUserSchools': {
                method: 'GET',
                url: '/api/schools/current',
                isArray: true
            },
            'gettUserSchools': {
                method: 'GET',
                url: '/api/schools/user',
                isArray: true
            }
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('LearningClassResource', function ($resource) {
        return $resource('/api/learningClasses/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getBySchool': {
                method: 'GET',
                url: '/api/learningClasses/schools/:id',
                isArray: true
            },
            'getAllClasses': {
                method: 'GET',
                url: '/api/learningClasses',
                isArray: true
            },
            'getLearningClassesBySchoolIdAndLevel': {
                method: 'GET',
                url: '/api/learningClasses/school/:schoolId/level/:level',
                isArray: true,
                params: {
                    'parallel': '@parallel',
                    'teacher': '@teacher',
                    'tutor': '@tutor',
                    'course': '@course',
                    'current_year': '@current_year'
                }
            },
            'getAllRelatedToUser': {
                method: 'GET',
                url: '/api/learningClasses/schoolUser',
                isArray: true,
                params: {
                    'course': '@course'
                }
            }
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('TopicProgressResource', function ($resource) {
        return $resource('/api/topicProgresses/', {}, {
            'setOnlineMark': {
                method: 'PUT',
                url: '/api/topicProgresses/topicId/:topicId/studentId/:studentId/onlineLessonMark',
            }
        });
    });

'use strict';

angular.module('lmsClientApp').factory('TopicResource', function ($resource) {
    return $resource('/api/topics/:id', {}, {
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'getAllTopicsByCourseId': {
        	method: 'GET',
        	url: '/api/topics/course/:courseId',
        	isArray: true
        },
        'getAllTopicsWithLPagesByCourseId': {
        	method: 'GET',
        	url: '/api/topics/lesson_pages/course/:courseId',
        	isArray: true
        },
    });
});
'use strict';

angular.module('lmsClientApp')
    .factory('NotificationsResource', function ($resource) {
        return $resource('/api/notifications/published', {}, {
            'getAllPublished': {
                method: 'GET',
                isArray: true
            }
        });
    });

'use strict';

app.config(['$stateProvider', 'lmsConfig',
            function ($stateProvider, lmsConfig) {
                $stateProvider
                .state('dialogs', {
                    parent: 'dashboard',
                    url: 'dialogs?page',
                    views: {
                        'dashBar@dashboard': {
                            templateUrl: lmsConfig.modulesPath + "dialogs/views/_dialogsBar.html",
                        },
                        'dashContent@dashboard': {
                            templateUrl: lmsConfig.modulesPath + 'dialogs/views/dialogs.html',
                            controller: 'DialogsCtrl'
                        }
                    },
                    ncyBreadcrumb: {
                        label: 'Личные сообщения'
                    }
                });
}]);

'use strict';

app.directive('lmsPaginationDialogs', ['lmsConfig', '$timeout', function (lmsConfig, $timeout) {
    return {
        restrict: 'E',
        replace: true,
        // templateUrl: lmsConfig.modulesPath + 'dialogs/views/_pagination.html',
        template: '<div layout="row" layout-align="center center" ng-if="dialogsTotalPages && dialogsTotalPages > 1" class="dialogs-pagination-container">' +
                '<md-button class="md-fab md-mini lms-button-flex-center" ng-click="scrollPag(\'left\')" ng-show="showArrows">' +
                    '<ng-md-icon icon="keyboard_arrow_left" size="16"></ng-md-icon>' +
                '</md-button>' +
                '<div id="dialogs-pagination-wrap">' +
                    '<div id="dialogs-pagination" layout="row">' +
                        '<md-button class="md-fab md-mini dialogs-pag-el" ng-repeat="i in getPagArray(dialogsTotalPages) track by $index" ng-click="goToPage($index + 1)" ng-class="{true:\'active\'}[currentPage === $index + 1]">' +
                            '{{$index + 1}}' +
                        '</md-button></div></div>' +
                '<md-button class="md-fab md-mini lms-button-flex-center" ng-click="scrollPag(\'right\')" ng-show="showArrows">' +
                    '<ng-md-icon icon="keyboard_arrow_right" size="16"></ng-md-icon>' +
                '</md-button></div>',
        link: function (scope, element, attrs) {
            var paginationLeft = 0;
            scope.showArrows = false;

            scope.getPagArray = function(size) {
                return new Array(size);
            };

            scope.goToPage = function(page) {
                if (scope.filters.dialogs && !scope.filters.distribs) {
                    scope.getDialogs(page, scope.dialogsOffset, false);
                } else if (scope.filters.distribs && !scope.filters.dialogs) {
                    scope.getDialogs(page, scope.dialogsOffset, true);
                } else {
                    scope.getDialogs(page, scope.dialogsOffset);
                }
            };

            scope.scrollPag = function(direction) {
                var dialogsPaginationWrap = document.getElementById('dialogs-pagination-wrap'),
                    dialogsPagination = document.getElementById('dialogs-pagination'),
                    paginationWrapWidth = parseInt(window.getComputedStyle(dialogsPaginationWrap).getPropertyValue("width")),
                    paginationWidth = dialogsPagination.scrollWidth;


                switch (direction) {
                    case 'left':
                        paginationLeft = (paginationLeft + paginationWrapWidth > 0) ? 0 : paginationLeft + paginationWrapWidth;
                        break;
                    case 'right':
                        var tail = paginationWidth - (Math.abs(paginationLeft) + paginationWrapWidth);
                        paginationLeft = (tail > paginationWrapWidth) ? paginationLeft - paginationWrapWidth : paginationLeft - tail - 7;
                        break;
                    default:
                        break;
                }
                angular.element(dialogsPagination).css('left', paginationLeft + "px");

            };

            scope.resetScroll = function() {
                var dialogsPagination = document.getElementById('dialogs-pagination');
                angular.element(dialogsPagination).css('left', '0');
            };

            function checkArrows() {
                var dialogsPaginationWrap = document.getElementById('dialogs-pagination-wrap'),
                    dialogsPagination = document.getElementById('dialogs-pagination');
                if(dialogsPagination && dialogsPaginationWrap)
                    scope.showArrows = dialogsPagination.scrollWidth > parseInt(window.getComputedStyle(dialogsPaginationWrap).getPropertyValue("width"));
            }

            scope.$watch('filters', function(filters) {
                if (filters.dialogs && !filters.distribs) {
                    scope.getDialogs(1, scope.dialogsOffset, false);
                } else if (filters.distribs && !filters.dialogs) {
                    scope.getDialogs(1, scope.dialogsOffset, true);
                } else {
                    if (filters.dialogs !== null || filters.distribs !== null ) {
                        scope.getDialogs(1, scope.dialogsOffset);
                    }
                }
               scope.resetScroll();
            }, true);

            scope.$watch('dialogsTotalPages', function(v) {
                $timeout(function() {
                    if(v)
                        checkArrows();
                });
            });
        }
    };
}]);

'use strict';

var app = angular.module('lmsClientApp');

app.service('Dialogs', [
  'rest',
  'lmsConfig',
  'Users',
  '$mdDialog',
  '$q',
  '$rootScope',
  function(rest, lmsConfig, Users, $mdDialog, $q, $rootScope) {
    var self = this;

    // Dialogs modal window methods
    this.openDialog = openDialog;
    this.createDialog = createDialog;
    this.updateDialog = updateDialog;
    this.createIndividualDialog = createIndividualDialog;

    function openDialog(id, dialog) {
      $mdDialog
        .show({
          hasBackdrop: false,
          focusOnOpen: false,
          templateUrl: lmsConfig.modulesPath + 'dialogs/views/singleDialog.html',
          clickOutsideToClose: true,
          escapeToClose: true,
          controller: function($scope) {
            $scope.id = id;
            $scope.newDialog = dialog;
            if ($scope.id && dialog) {
              $scope.newDialog.id = $scope.id;
            }
            $rootScope.$broadcast('openedDialog');
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
          }
        })
        .finally(function() {
          $rootScope.$broadcast('needDialogsListUpdate');
        });
    }

    function createIndividualDialog(user) {
      var users = [];
      user.noeditable = true;
      users.push(user);
      createDialog(false, users).then(function(dialog) {
        if (dialog && dialog.id) {
          openDialog(dialog.id);
        }
      });
    }

    function createDialog(isDistrib, users, params) {
        console.log('ccc')
      var dfd = $q.defer();
      params = params || {};
      $mdDialog
        .show({
          parent: angular.element('#dialogs'),
          templateUrl: lmsConfig.modulesPath + 'dialogs/views/newDialog.html',
          clickOutsideToClose: true,
          escapeToClose: true,
          controller: function($scope) {
            $scope.isDialog = true;
            if (isDistrib) {
              $scope.isDialog = false;
            }
            $scope.isDistrib = isDistrib;
            $scope.withUsers = users;
            $scope.hide = function(answer) {
              $mdDialog.hide(answer);
            };
            $scope.cancel = function() {
              $mdDialog.cancel();
            };
            for (var paramName in params) {
              $scope[paramName] = params[paramName];
            }
          }
        })
        .then(
          function(answer) {
            dfd.resolve(answer);
          },
          function() {
            dfd.reject();
          }
        );
      return dfd.promise;
    }

    function updateDialog(dialog) {
        console.log('aaaaaaaaaaaaaaaa')
      // Редактировать список участнриков может только создатель
      if ($rootScope.user.id !== dialog.owner.id) {
        return $q(function(resolve, reject) {
            console.log('ccccc')
          Users.getAllInConversation2({ id: dialog.id }, function(conversationUsers) {
              console.log('bbbbb')
              console.log(conversationUsers)
              console.log(dialog)
            $mdDialog
              .show({
                parent: angular.element('#dialogs'),
                templateUrl: lmsConfig.modulesPath + 'dialogs/views/dialogsParticipantList.html',
                clickOutsideToClose: true,
                escapeToClose: true,
                controller: function($scope) {
                  $scope.updateDialog = true;
                  $scope.id = dialog.id;
                  $scope.isDistrib = dialog.isDistribution;
                  $scope.newDialogName = dialog.name;
                  $scope.dialogOwnerId = dialog.owner.id;
                  $scope.oldUsersCount = dialog.participantsCount;
                  $scope.oldUsers = sconversationUsers;
                  $scope.hide = function(answer) {
                    $mdDialog.hide(answer);
                  };
                  $scope.cancel = function() {
                    $mdDialog.cancel();
                    $rootScope.$broadcast('needDialogsListUpdate');
                  };
                  resolve();
                }
              })
              .then(
                function(answer) {
                  resolve(answer);
                },
                function() {
                  reject();
                }
              );
          });
        });
      }
      // ------------
      var conversationUsers;
      var dfd = $q.defer();
      Users.getAllInConversation2({ id: dialog.id }, function(result) {
          console.log('ssssss')
          console.log(result)
        conversationUsers = result[0][0];
          console.log(conversationUsers)
        $mdDialog
          .show({
            parent: angular.element('#dialogs'),
            templateUrl: lmsConfig.modulesPath + 'dialogs/views/newDialog.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            controller: function($scope) {
              var userIds = [];
              $scope.updateDialog = true;
              $scope.id = dialog.id;
              $scope.isDistrib = dialog.isDistribution;
              $scope.newDialogName = dialog.name;
              $scope.dialogOwnerId = dialog.owner.id;
              $scope.oldUsersCount = dialog.participantsCount;
              $scope.oldUsers = conversationUsers;
              $scope.hide = function(answer) {
                $mdDialog.hide(answer);
              };
              $scope.cancel = function() {
                $mdDialog.cancel();
                $rootScope.$broadcast('needDialogsListUpdate');
              };
              dfd.resolve();
            }
          })
          .then(
            function(answer) {
              dfd.resolve(answer);
            },
            function() {
              dfd.reject();
            }
          );
      });
      return dfd.promise;
    }
  }
]);

'use strict';

angular
    .module('lmsClientApp')
    .factory('DialogsResource', function($resource) {
        return $resource(
            '/conversation/:id',
            {},
            {
                query: {
                    method: 'GET',
                    isArray: true
                },
                get: {
                    method: 'GET'
                },
                getRich: {
                    method: 'GET',
                    url: '/conversation/list'
                },
                getUnreadMessages: {
                    method: 'GET',
                    url: '/conversation/unreadMessages'
                },
                update: {
                    method: 'PUT'
                },
                create: {
                    method: 'POST'
                },
                getMessages: {
                    method: 'GET',
                    url: '/conversation/:convId/messages',
                    isArray: true,
                    params: {
                        page: '@page',
                        per_page: '@per_page',
                        sorting_fields: '@sorting_fields',
                        sorting_direction: '@sorting_direction'
                    }
                },
                createMessage: {
                    method: 'POST',
                    url: '/conversation/:convId/message'
                },
                editMessage: {
                    method: 'PUT',
                    url: '/api/conversations/:convId/messageId/:msgId/:draft',
                    params: {
                        fileIds: '@fileIds'
                    }
                },
                getAvailableUsers: {
                    method: 'GET',
                    url: '/api/conversations/availableUsers',
                    isArray: true,
                    params: {
                        plain: '@plain'
                    }
                },
                addParticipants: {
                    method: 'PUT',
                    url: '/api/conversations/:convId/participants'
                },
                getParticipants: {
                    method: 'GET',
                    url: '/api/conversations/:convId/participants',
                    isArray: true,
                    params: {
                        plain: '@plain'
                    }
                }
            }
        );
    })
    .factory('Conversations', function($resource, API) {
        var newApi = API.clientApi + '/conversations';
        return $resource(
            newApi,
            {},
            {
                create: {
                    method: 'POST',
                    url: '/conversation/'
                },
                update: {
                    method: 'PUT',
                    url: '/conversation/'
                    // url: newApi
                },
                addParticipant: {
                    method: 'PUT',
                    url: '/conversation/participant'
                },
                deleteParticipant: {
                    method: 'DELETE',
                    url: '/conversation/participant'
                },
                addGroup: {
                    method: 'PUT',
                    url: '/conversation/group'
                },
                deleteGroup: {
                    method: 'DELETE',
                    url: '/conversation/group'
                }
            }
        );
    });

'use strict';

app.controller('DialogsCtrl', [
    '$scope',
    'Dialogs',
    '$rootScope',
    'lmsConfig',
    'Account',
    '$auth',
    'DialogsResource',
    '$state',
    function($scope, Dialogs, $rootScope, lmsConfig, Account, $auth, DialogsResource, $state) {
        // Variables
        $scope.userId = '';
        $scope.dialogs = [];
        $scope.dialogsTotalPages = null;
        $scope.currentDialog = {};
        $scope.roles = [];
        $scope.showDialogs = false;
        $scope.showDistribs = false;
        $scope.countMembersShort = false;
        $rootScope.updated = false;
        $scope.dialogsOffset = 10;
        $scope.currentPage = null;
        $scope.loaded = false;
        $scope.filters = {
            dialogs: null,
            distribs: null
        };

        // Methods
        $scope.createDialog = Dialogs.createDialog;
        $scope.openDialog = Dialogs.openDialog;
        $scope.countMembersWidthCb = countMembersWidthCb;
        $scope.getDialogs = getDialogs;

        init();

        function init() {
            getUserAccount();
        }

        function countMembersWidthCb(width) {
            $scope.countMembersShort = width < 90;
        }

        function getDialogs(page, offset, filter) {
            $state.go('dialogs', { page: page }, { notify: false });
            $scope.loaded = false;
            DialogsResource.getRich({
                page: page,
                offset: offset,
                isDistribution: filter
            }).$promise.then(
                function(response) {
                    // Чистим список диалогов
                    response.list = response.list || [];
                    $scope.dialogs = []; // Сначала собираем все диалоги с непрочитанными сообщениями в верх страницы
                    response.list.forEach(function(dialog) {
                        if (dialog.unreadMessages > 0) {
                            $scope.dialogs.push(dialog);
                        }
                    });
                    // Затем пушим диалоги без непрочитанных сообщений
                    response.list.forEach(function(dialog) {
                        if (dialog.unreadMessages === 0) {
                            $scope.dialogs.push(dialog);
                        }
                    });
                    $scope.currentPage = page;
                    $scope.dialogsTotalPages = response.totalPages;
                    $scope.loaded = true;
                    $rootScope.$broadcast('dialogsUpdated');
                },
                function() {
                    $scope.loaded = true;
                }
            );
        }
        function getUserAccount() {
            var page = $state.params.page ? +$state.params.page : 1;
            if ($auth.user && $auth.user.id) {
                $scope.userId = $auth.user.id;
                $scope.roles = $auth.user.userRoles;
                getDialogs(page, $scope.dialogsOffset);
            } else {
                Account.getAccount().then(function(response) {
                    $scope.userId = response.id;
                    $scope.roles = response.userRoles;
                    getDialogs(page, $scope.dialogsOffset);
                });
            }
        }
        function dialogFilter() {
            if ($scope.filters.dialogs && $scope.filters.distribs) {
                return false;
            } else if ($scope.filters.distribs) {
                return true;
            } else {
                return null;
            }
        }
        $scope.$on('needDialogsListUpdate', function() {
            var page = $state.params.page ? +$state.params.page : 1;
            getDialogs(page, $scope.dialogsOffset, dialogFilter());
        });
    }
]);

'use strict';

app.controller('singleDialogCtrl', [
    '$scope',
    'Dialogs',
    'Upload',
    '$mdDialog',
    'lmsConfig',
    '$rootScope',
    'LmsUtils',
    'Role',
    'Account',
    'DialogsResource',
    'Conversations',
    '$auth',
    '$http',
    'usSpinnerService',
    '$timeout',
    function (
        $scope,
        Dialogs,
        Upload,
        $mdDialog,
        lmsConfig,
        $rootScope,
        LmsUtils,
        Role,
        Account,
        DialogsResource,
        Conversations,
        $auth,
        $http,
        usSpinnerService,
        $timeout
    ) {
        var nextPage = 2,
            per_page = 10,
            sorting_fields = ['date'],
            sorting_direction = 'desc';
        // Variables
        $scope.dialog = {};
        $scope.participantsCountString;
        $scope.messages = [];
        $scope.message = {};
        $scope.message.files = [];
        $scope.unpublished = [];
        $scope.user = $auth.user;
        $scope.uploadInProgress = false;
        $scope.filesToDelete = [];
        $scope.isLastPage = true;
        $scope.scrollToBottom = true;
        $scope.addFileMobile = false

        // аудио
        $scope.filesToUpload = [];
        $scope.readyToRecording = true
        $scope.recordingIsNow = false
        $scope.recordingIsDone = false
        $scope.startRecording = startRecording;
        $scope.stopRecording = stopRecording;
        $scope.printAudio = printAudio;
        $scope.cancelAudio = cancelAudio;
        $scope.addToUploadList2 = addToUploadList2
        $scope.getFileName = getFileName;
        $scope.getFileName2 = getFileName2;
        $scope.answerFocus = function () {
            $scope.answerHeigh = 130;
        };
        //


        //Methods
        $scope.sendMessage = sendMessage;
        $scope.isFileSupported = isFileSupported;
        $scope.isFlashInstalled = isFlashInstalled;
        $scope.addToUploadList = addToUploadList;
        $scope.removeFromUploadList = removeFromUploadList;
        $scope.addPartisipants = addPartisipants;
        $scope.loadMoreMessages = loadMoreMessages;
        $scope.checkEmptyMessage = checkEmptyMessage;
        $scope.share = share;
        $scope.vk_show = false;
        $scope.vk_groupid;
        $scope.vk_appId;

        $scope.showAudio = showAudio;

        init();

        function init () {
            if (window.innerWidth < 600) {
                $scope.addFileMobile = true
            }
        }


        $http.get('/api/social/vk/applicationId').then(
            function (res) {
                $scope.social = res.data.schoolSocialInfo[0];
                if ($scope.social) {
                    $scope.vk_groupid = $scope.social.groupId;
                }
                $scope.vk_appId = res.data.applicationId;
                $scope.vk_show = $scope.vk_groupid && $scope.vk_appId
                    ? true
                    : false;
                VK.init({
                    apiId: $scope.vk_appId
                });
            },
            function (err) {
                $scope.vk_show = false;
            }
        );

        // Показывать кнопку 'Состав участников'
        $scope.showPartisipants = false;
        // Публикация файла на стене в закрытую группу
        function share(file) {
            VK.Auth.login(
                function (res) {
                    // получение ссылки куда нужно сохранить файл
                    VK.Api.call(
                        'docs.getWallUploadServer',
                        {
                            group_id: $scope.vk_groupid,
                            v: '5.80'
                        },
                        function (data) {
                            if (data.response) {
                                var targetUrl = data.response.upload_url;
                                var url = '/api/social/vk/downloadAndPost';
                                // заливка файла на сервер вк
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: {
                                        incomingUrl: file.path,
                                        targetUrl: targetUrl
                                    },
                                    withCredentials: true
                                }).then(function (res) {
                                    // сохранение файла
                                    VK.Api.call(
                                        'docs.save',
                                        {
                                            file: res.data.file,
                                            v: '5.80',
                                            title: 'file'
                                        },
                                        function (data) {
                                            var attachments = 'doc-' +
                                                $scope.vk_groupid +
                                                '_' +
                                                data.response[0].id;
                                            // публикация поста на стенке с прикрепленным файлом.
                                            VK.Api.call(
                                                'wall.post',
                                                {
                                                    owner_id: '-' +
                                                        $scope.vk_groupid,
                                                    from_group: '0',
                                                    attachments: attachments
                                                },
                                                function (data) {
                                                    if (data.response) {
                                                        console.log(
                                                            data.response
                                                        );
                                                    }
                                                }
                                            );
                                        }
                                    );
                                });
                            }
                        }
                    );
                    // Число - маска прав для работы с группой
                },
                131072
            );
        }

        // Аудио

        function startRecording (){
            console.log('aaaaa');

            $scope.readyToRecording = false
            $scope.recordingIsNow = true

            var constraints = {
                audio: true
            }
            navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream){
                // document.getElementById('audio').srcObject = mediaStream
                // var mediaRecorder = new MediaRecorder(mediaStream);
                if ( document.getElementById('test123')){
                    document.getElementById('test123').remove()
                }


                $scope.mediaRecorder = new MediaRecorder(mediaStream);
                $scope.chunks = [];
                $scope.mediaRecorder.start()
                console.log($scope.mediaRecorder.state)

                $scope.mediaRecorder.ondataavailable = function (e){
                    $scope.chunks.push(e.data)
                }



                // $scope.timer = 0;

                // $scope.timerId = setInterval(function (){
                //     $scope.timer=$scope.timer+1;
                //     console.log($scope.timer)
                // },1000)

                // $scope.timer2 = $timeout(function (){
                //     $scope.timer=$scope.timer+1;
                //     console.log($scope.timer)
                //     $scope.timer2()
                //
                // }, 1000);



                $scope.mediaRecorder.onstop = function (e){

                    var blob = new Blob($scope.chunks, { type: "audio/mp3"})
                    //
                    // var file = new File([blob], getFileName('аудиозапись'), {
                    //     type: 'audio/mp3'
                    // });
                    // var files = [];
                    // files.push(file);
                    // $scope.addToUploadList(files);

                    // $scope.answer();




                    var videoURL = window.URL.createObjectURL(blob)

                    document.getElementById('test123').src = videoURL;
                }




                // var newAudio = document.createElement('audio');
                // newAudio.style.setProperty('display', 'Block');
                // newAudio.style.setProperty('margin', 'auto');
                // newAudio.id = 'test123'
                // newAudio.controls = true;
                // document.getElementById('audio_parent').appendChild(newAudio);
                //
                //
                // setTimeout(function (){
                //     mediaRecorder.stop()
                // },500)



            })


        }

        function stopRecording (){
            console.log('bbbbbbbbb');

            $scope.recordingIsNow = false
            $scope.recordingIsDone = true
            $scope.readyToRecording = true

            // $scope.mediaRecorder

            var newAudio = document.createElement('audio');
            newAudio.style.setProperty('display', 'Block');
            newAudio.style.setProperty('margin', 'auto');
            newAudio.id = 'test123'
            newAudio.controls = true;
            newAudio.setAttribute("ng-if","recordingIsDone")

            document.getElementById('audio_parent').appendChild(newAudio);


            setTimeout(function (){
                $scope.mediaRecorder.stop()
            },500)

            // clearInterval($scope.timerId)

            // this.disabled = true;
            // if (!recorder || !recorder.getBlob()) return;
            // // if(isSafari) {
            // //     recorder.getDataURL(function(dataURL) {
            // //         SaveToDisk(dataURL, getFileName('mp3'));
            // //     });
            // //     return;
            // // }
            // var blob = recorder.getBlob();
            // var file = new File([blob], getFileName('mp3'), {
            //     type: 'audio/mp3'
            // });
            // var files = [];
            // files.push(file);
            // scope.addToUploadList(files);
            // scope.answer();



            // newAudio.src = src;

            // newAudio.controls = stopRecording ? true : false;


            document.getElementById('audio_parent').appendChild(newAudio)

            // URL.createObjectURL(recorder.getBlob()),

            console.log( document.getElementById('audioRecord'));

        }

        function printAudio (){

            var blob = new Blob($scope.chunks, { type: "audio/mp3"})

            var file = new File([blob], getFileName2('mp3'), {
                type: 'audio/mp3'
            });
            var files = [];
            files.push(file);
            $scope.addToUploadList2(files);

            $scope.recordingIsDone = false;

            document.getElementById('test123').remove()

            // var file = new File([blob], getFileName('mp3'), {
            //     type: 'audio/mp3'
            // });
            // var files = [];
            // files.push(file);
            // scope.addToUploadList(files);
            // scope.answer();
        }

        function getFileName2(fileExtension) {
            var d = new Date();
            var year = d.getFullYear();
            var month = d.getMonth();
            var date = d.getDate();
            return 'audio-' +
                year +
                month +
                date +
                '-' +
                getRandomString() +
                '.' +
                fileExtension;
        }

        function getRandomString() {
            if (
                window.crypto &&
                window.crypto.getRandomValues &&
                navigator.userAgent.indexOf('Safari') === -1
            ) {
                var a = window.crypto.getRandomValues(
                    new Uint32Array(3)
                    ),
                    token = '';
                for (var i = 0, l = a.length; i < l; i++) {
                    token += a[i].toString(36);
                }
                return token;
            } else {
                return (Math.random() * new Date().getTime())
                    .toString(36)
                    .replace(/\./g, '');
            }
        }

        function getFileName(filePath) {
            var pathParts = filePath.split("/");
            return pathParts[pathParts.length - 1];
        }

        function cancelAudio (){
            $scope.recordingIsDone = false
            document.getElementById('test123').remove()
        }

        function addToUploadList2(files) {
            if (files === null || files.length === 0) {
                return;
            }
            skipFile: for (var i in files) {
                for (var j in $scope.filesToUpload) {
                    if (files[i].name === $scope.filesToUpload[j].name) {
                        continue skipFile;
                    }
                }
                if (undefined === files[i].type) {
                    continue skipFile;
                }
                if ("application/x-msdownload" === files[i].type) {
                    continue skipFile;
                }
                $scope.filesToUpload.push(files[i]);
                $scope.message.files.push(files[i]);
            }
            $scope.answerFocus();
        }


        //





        function checkEmptyMessage(message) {
            if (
                message.files.length > 0 ||
                (message.text !== null &&
                    message.text !== undefined &&
                    !/^\s*$/g.test(message.text))
            ) {
                return true;
            } else
                return false;
        }

        function sendMessage(isDraft) {
            // Check is message text or files in message exist
            // if (checkEmptyMessage($scope.message)) {
            // Filter spaces
            console.log($scope.message.text)

            if (
                /^\s*$/g.test($scope.message.text) ||
                $scope.message.text === null
            ) {
                $scope.message.text = null;
            }
            if ($scope.message.draft) {
                $scope.files = $scope.draftFiles;
                console.log($scope.draftFiles);
                DialogsResource.editMessage(
                    {
                        convId: $scope.dialog.id,
                        msgId: $scope.message.id,
                        draft: isDraft,
                        fileIds: $scope.filesToDelete
                            .filter(function (val) {
                                return val !== null && val !== undefined;
                            })
                            .join(',')
                    },
                    $scope.message ? $scope.message.text : ''
                ).$promise.then(function (response) {
                    var path = '/api/conversations/' +
                        $scope.dialog.id +
                        '/messages/' +
                        $scope.message.id +
                        '/files';
                    uploadFiles(path);
                    if (!isDraft) {
                        clearMessageForm();
                        getMessages();
                    }
                });
            } else {
                if (isDraft !== void 0 && typeof isDraft === 'boolean') {
                    $scope.message.draft = isDraft;
                }
                $scope.message.date = Date.now();
                if ($scope.newDialog && !$scope.id) {
                    Conversations.create(
                        {
                            name: $scope.newDialog.name,
                            distribution: $scope.newDialog.distrib
                        },
                        function (response) {
                            $scope.dialog = response;
                            $scope.id = $scope.dialog.id;
                            $scope.newDialog = false;
                            $scope.message.draft = isDraft;
                            saveMessage();
                        }
                    );
                } else {
                    $scope.dialog.id = $scope.id;
                    saveMessage();
                }
            } // } else // LmsUtils.showSimpleToast('Сообщение пустое.');
        }

        function removeFromUploadList(fileName) {
            for (var i = 0; i < $scope.message.files.length; i++) {
                if ($scope.message.files[i].name === fileName) {
                    if ($scope.message.files[i].id !== undefined)
                        $scope.filesToDelete.push($scope.message.files[i].id);
                    $scope.message.files.splice(i, 1);
                    break;
                }
            }
        }

        function saveMessage() {
            DialogsResource.createMessage(
                {
                    convId: $scope.dialog.id
                },
                {
                    draft: $scope.message.draft,
                    date: $scope.message.date,
                    text: $scope.message.text,
                    author: {
                        id: $scope.user.id
                    }
                },
                function (response, headers) {
                    uploadFiles(headers().location);
                    if (!$scope.uploadInProgress) {
                        clearMessageForm();
                        getMessages();
                    }
                    if (
                        $scope.dialog.isDistribution &&
                        $scope.dialog.owner.id !== $scope.user.id
                    ) {
                        var newId = headers().location.match(
                            /(?:\/api\/conversations\/)(\d+)/
                        );
                        $scope.cancel();
                        Dialogs.openDialog(newId[1]);
                    }
                }
            );
        }

        function uploadFiles(path) {
            if ($scope.message.files.length > 0) {
                console.log($scope.message.files);
                $scope.uploadInProgress = true;
                files: for (var i in $scope.message.files) {
                    for (var k in $scope.draftFiles) {
                        if ($scope.message.files[i] === $scope.draftFiles[k]) {
                            continue files;
                        }
                    }
                    doUpload($scope.message.files[i], path);
                }
            }
        }

        function doUpload(file, path) {
            var clearedPath = path.match(/(?:api)(\/\S+)(?:\/\d+)(\/\S+\/\d+)/);
            Upload.upload({
                url: lmsConfig.apiUrlPath +
                    clearedPath[1] +
                    clearedPath[2] +
                    '/file',
                file: file
            })
                .progress(function (evt) {
                    file.uploadProgress = parseInt(
                        100.0 * evt.loaded / evt.total
                    );
                })
                .success(function (data, status, headers) {
                    file.uploadSuccessful = true;
                    removeAndReload(file.name);

                    // setTimeout(
                    //     function () {
                    //
                    //     },
                    //     2000
                    // );
                })
                .error(function (data, status, headers) {
                    file.uploadError = true;
                    setTimeout(
                        function () {
                            removeAndReload(file.name);
                        },
                        5000
                    );
                });
        }

        function removeAndReload(fileName) {
            $scope.removeFromUploadList(fileName);
            if ($scope.message.files.length === 0) {
                $scope.uploadInProgress = false;
                if (!$scope.message.draft) {
                    clearMessageForm();
                }
            }
            getMessages();
        }

        function addToUploadList(files) {
            console.log('aa')
            console.log(files)
            if (files === null || files.length === 0) {
                return;
            }
            skipFile: for (var i in files) {
                for (var j in $scope.message.files) {
                    if (files[i].name === $scope.message.files[j].name) {
                        continue skipFile;
                    }
                }
                if (undefined === files[i].type) {
                    continue skipFile;
                }
                if ('application/x-msdownload' === files[i].type) {
                    continue skipFile;
                }
                $scope.message.files.push(files[i]);
                console.log($scope.message.files)
            }
        }

        /**
         * Whether or not HTML5 File API is supported.
         *
         * @returns {Boolean} true if supported or false otherwise
         */
        function isFileSupported() {
            return typeof File !== 'undefined' &&
                typeof FileReader !== 'undefined';
        }

        function isFlashInstalled() {
            var hasFlash = false;
            try {
                var fo = new window.ActiveXObject(
                    'ShockwaveFlash.ShockwaveFlash'
                );
                if (fo) {
                    hasFlash = true;
                }
            } catch (e) {
                if (
                    navigator.mimeTypes &&
                    navigator.mimeTypes['application/x-shockwave-flash'] !==
                    void 0 &&
                    navigator.mimeTypes[
                        'application/x-shockwave-flash'
                    ].enabledPlugin
                ) {
                    hasFlash = true;
                }
            }
            return hasFlash;
        }

        function clearMessageForm() {
            $scope.message = {};
            $scope.message.files = [];
        }

        function getMessages() {
            spinnerShow();
            $scope.scrollToBottom = true;
            DialogsResource.getMessages(
                {
                    convId: $scope.id,
                    page: 1,
                    per_page: per_page,
                    sorting_fields: sorting_fields,
                    sorting_direction: sorting_direction
                },
                function (response, responseHeaders) {
                    var maxPages = Math.ceil(
                        responseHeaders('X-Total-Count') / per_page
                    );
                    if (maxPages < 2) {
                        $scope.isLastPage = true;
                    } else {
                        $scope.isLastPage = false;
                    }
                    $scope.messages = [];
                    $scope.unpublished = [];
                    response.forEach(function (message, i) {
                        message.files.forEach(function (file) {
                            if (
                                file.name === null ||
                                file.name === '' ||
                                !file.name
                            ) {
                                var isAudio = file.path.slice(-3) === "mp3";
                                file.isAudio = isAudio;
                            }
                        });

                        if (message.draft) {
                            $scope.unpublished.push(message);
                        } else {
                            $scope.messages.push(message);
                        }
                    });

                    $scope.draftFiles = [];

                    if ($scope.unpublished.length > 0) {
                        var lastDraft = $scope.unpublished[
                            $scope.unpublished.length - 1
                        ];
                        $scope.message = lastDraft;
                        $scope.message.files = lastDraft.files;
                        $scope.message.files.forEach(function (file) {
                            if (
                                file.name === null ||
                                file.name === '' ||
                                !file.name
                            ) {
                                var name = file.path.substring(
                                    file.path.lastIndexOf('/') + 1
                                );
                                file.name = name;
                            }
                            $scope.draftFiles.push(file);
                        });
                    }
                    spinnerHide();
                }
            );
        }

        function loadMoreMessages() {
            $scope.isLastPage = true;
            $scope.scrollToBottom = false;
            DialogsResource.getMessages(
                {
                    convId: $scope.id,
                    page: nextPage,
                    per_page: per_page,
                    sorting_fields: sorting_fields,
                    sorting_direction: sorting_direction
                },
                function (response, responseHeaders) {
                    var maxPages = Math.ceil(
                        responseHeaders('X-Total-Count') / per_page
                    );
                    response.forEach(function (message) {
                        if (!message.draft) {
                            $scope.messages.push(message);
                        }
                    });
                    if (nextPage < maxPages) {
                        nextPage++;
                        $scope.isLastPage = false;
                    }
                }
            );
        }

        function spinnerShow() {
            $scope.spinnerCurtain = true;
            usSpinnerService.spin('spinnerSingleDialog');
        }

        function spinnerHide() {
            $scope.spinnerCurtain = false;
            usSpinnerService.stop('spinnerSingleDialog');
        }

        function addPartisipants() {
            spinnerShow();
            Dialogs.updateDialog($scope.dialog).then(function () {
                spinnerHide();
            });
        }

        if ($scope.newDialog) {
            var dialog = $scope.newDialog;
            DialogsResource.get({ id: dialog.id }, function (response) {
                $scope.dialog = response;
                $scope.showPartisipants = true;
            });
        } else {
            DialogsResource.get({ id: $scope.id }, function (response) {
                $scope.dialog = response; // Если рассылка то показывем кнопку 'Состав участников' только владельцу
                console.log($scope.dialog.participantsCount)
                if ($scope.dialog.participantsCount == 1){
                    $scope.participantsCountString = 'участник'
                } else if ($scope.dialog.participantsCount >1 && $scope.dialog.participantsCount < 5){
                    $scope.participantsCountString = 'участника'
                } else if ($scope.dialog.participantsCount >4 && $scope.dialog.participantsCount < 21 ){
                    $scope.participantsCountString = 'участников'
                } else if ($scope.dialog.participantsCount >20 && $scope.dialog.participantsCount < 22 ){
                    $scope.participantsCountString = 'участник'
                } else if ($scope.dialog.participantsCount >21 && $scope.dialog.participantsCount < 25 ){
                    $scope.participantsCountString = 'участника'
                } else if ($scope.dialog.participantsCount >24 && $scope.dialog.participantsCount < 31 ){
                    $scope.participantsCountString = 'участников'
                } else if ($scope.dialog.participantsCount >30 && $scope.dialog.participantsCount < 32 ){
                    $scope.participantsCountString = 'участник'
                } else if ($scope.dialog.participantsCount >31 && $scope.dialog.participantsCount < 35 ){
                    $scope.participantsCountString = 'участника'
                } else if ($scope.dialog.participantsCount >34 && $scope.dialog.participantsCount < 41 ){
                    $scope.participantsCountString = 'участников'
                } else if ($scope.dialog.participantsCount >40 && $scope.dialog.participantsCount < 42 ){
                    $scope.participantsCountString = 'участник'
                } else if ($scope.dialog.participantsCount >41 && $scope.dialog.participantsCount < 45 ){
                    $scope.participantsCountString = 'участника'
                } else if ($scope.dialog.participantsCount >44 && $scope.dialog.participantsCount < 51 ){
                    $scope.participantsCountString = 'участников'
                } else if ($scope.dialog.participantsCount >50 && $scope.dialog.participantsCount < 52 ){
                    $scope.participantsCountString = 'участник'
                } else if ($scope.dialog.participantsCount >51 && $scope.dialog.participantsCount < 55 ){
                    $scope.participantsCountString = 'участника'
                } else if ($scope.dialog.participantsCount >54 ){
                    $scope.participantsCountString = 'участников'
                }


                if ($scope.dialog.isDistribution) {
                    $scope.showPartisipants = $scope.dialog.owner.id ===
                        $auth.user.id;
                } else {
                    $scope.showPartisipants = true;
                }
            });
            getMessages();
        }


        function showAudio() {
            $mdDialog
                .show({
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    multiple: true,
                    hasBackdrop: false,
                    template: '<div style=""><audio-record ng-if="show"></audio-record></div>',
                    controller: function ($scope, $mdDialog, $auth) {
                        $scope.hide = function () {
                            $mdDialog.hide();
                        };
                        $scope.cancel = function () {
                            $mdDialog.cancel();
                        };
                        $scope.answer = function (answer) {
                            $mdDialog.hide(answer);
                        };
                        $scope.show = true;
                        $scope.addToUploadList = addToUploadList;
                        $scope.recording = false;
                    }
                })
                .then(function (answer) { }, function () { });
        }

    }
]);

'use strict';

app.controller('addDialogCtrl', [
    '$scope',
    '$q',
    'Dialogs',
    'VideoConfConfigResource',
    '$mdDialog',
    '$rootScope',
    'UserGroupResource',
    '$auth',
    'LmsUtils',
    '$mdMedia',
    'Users',
    'DialogsResource',
    'Conversations',
    'Conferences',
    'Groups',
    'usSpinnerService',
    '$timeout',
    function (
        $scope,
        $q,
        Dialogs,
        VideoConfConfigResource,
        $mdDialog,
        $rootScope,
        UserGroupResource,
        $auth,
        LmsUtils,
        $mdMedia,
        Users,
        DialogsResource,
        Conversations,
        Conferences,
        Groups,
        usSpinnerService,
        $timeout
    ) {
        var unbindAuthWatcher, initPromises = [];

        // Variables
        // $scope.allRoles = ['Родитель','Ученик']
        // $scope.unusedRoles = [ "Учитель", "Координатор"]
        $scope.potentialGroupsCheckboxIsChecked = true;
        $scope.potentialUsersCheckboxIsChecked = true;
        $scope.actualUsersCheckBoxIsChecked = true;
        $scope.actualGroupsCheckBoxIsChecked = true

        $scope.potentialGroups = [1,2,3]
        $scope.displayedPotentialUsers = [1,2,3]


        $scope.user = {};
        $scope.duration = undefined ? '' : $scope.duration;
        $scope.newDialogName = undefined ? '' : $scope.newDialogName;
        $scope._dialogId = undefined ? 0 : $scope.id;
        $scope.groups = [];
        $scope.users = [];
        $scope.shownUsers = [];
        $scope.shownGroups = [];
        $scope.invitedGroups = [];
        $scope.invitedUsers = [];



        $scope.finalUserList = [];
        $scope.roles = [];
        $scope.tempChosenRole = null;
        $scope.modifiedRoles = []
        $scope.usedRoles = []

        $scope.avaibleRoles = [];
        $scope.usersOnly = true;
        $scope.groupsOnly = true;
        $scope.selectedGroupsOnly = true
        $scope.selectedUsersOnly = true
        $scope.allSelected = false;
        $scope.allfilters = false;
        $scope.showUserRoles = false;
        $scope.loaded = false;
        $scope.rolesAreShown = false

        $scope.showButtonSave = true;
        $scope.showButtonCancel = false;
        $scope.showButtonClose = true;
        if ($scope.updateDialog) {
            $scope.showButtonSave = false;
            $scope.showButtonCancel = false;
            $scope.showButtonClose = true;
        }
        //Methods
        $scope.toggle = toggle;
        $scope.addAll = addAll;
        $scope.addDialog = $scope.isVideoConf ? addVideoConf : addDialog;
        // $scope.sumUsers = sumUsers;
        $scope.selectUsers = selectUsers;
        $scope.isInArray = isInArray;
        $scope.checkRole = checkRole;
        $scope.isInRole = isInRole;
        $scope.selectGroup = selectGroup;
        $scope.filterUsers = filterUsers;
        $scope.filterGroups = filterGroups;
        $scope.noOneToTalk = noOneToTalk;
        $scope.cancelOpen = cancelOpen;
        $scope.convertRoles = convertRoles;
        $scope.rolesReducer = rolesReducer;
        $scope.deleteUsedRole = deleteUsedRole;
        $scope.dropFilters = dropFilters
        $scope.showRoles = showRoles;
        $scope.chooseRole = chooseRole


        $scope.updateUsersList = false;


        function showRoles (){
            $scope.modifiedRoles.sort()
            $scope.rolesAreShown = true

        }

        function dropFilters () {
            $scope.searchText = ''
            $scope.avaibleRoles = []
            $scope.usedRoles = []
        }

        function chooseRole (role) {
            $scope.usedRoles.push(role)
            checkRole(role)
            $scope.searchText = ''
            $scope.modifiedRoles = $scope.modifiedRoles.filter(function (el){
                return el !== role
            })
            $scope.rolesAreShown = false
        }


        // $scope.$watch(
        //     function (){
        //         return $scope.tempChosenRole
        //      },
        //     function (){
        //
        //         if ($scope.tempChosenRole !== null){
        //             $scope.usedRoles.push($scope.tempChosenRole)
        //             $scope.modifiedRoles = $scope.modifiedRoles.filter(function (el){
        //                 return el !== $scope.tempChosenRole
        //             })
        //             checkRole($scope.tempChosenRole)
        //             $scope.searchText = ''
        //         }
        //         // if ($scope.tempChosenRole) {
        //         //    console.log($scope.tempChosenRole)
        //         // }
        //     })

        function deleteUsedRole (role) {
            $scope.modifiedRoles.push(role)
            $scope.usedRoles = $scope.usedRoles.filter(function (el){
                return el !== role
            })
            $scope.avaibleRoles = $scope.avaibleRoles.filter(function (el){
                return el !== role
            })

        }

        unbindAuthWatcher = $scope.$watch(
            function () {
                return $auth.user.id;
            },
            function (userId) {
                if (userId) {
                    $scope.user.id = $auth.user.id;
                    $scope.user.lastName = $auth.user.lastName;
                    $scope.user.firstName = $auth.user.firstName;
                    $scope.user.middleName = $auth.user.middleName;
                    $scope.user.userRoles = $auth.user.userRoles;
                    $scope.user.role = $auth.user.userRoles[0];
                    $scope.user.roles = [$scope.user.role];
                    init();
                    unbindAuthWatcher();
                }
            }
        );

        function spinnerShow() {
            $scope.spinnerCurtain = true;
            usSpinnerService.spin('spinnerNewDialog');
        }

        function spinnerHide() {
            $scope.spinnerCurtain = false;
            usSpinnerService.stop('spinnerNewDialog');
        }

        function init() {
            var currentDate, nextHour;

            //студенты в видеоконференциях могут просматривать группы
            if (!$auth.isInRole('ROLE_STUDENT') || $scope.isVideoConf) {
                //пользователи которые не могут просматривать группы
                if (
                    !$auth.isInAnyRole([
                        'ROLE_PARENT',
                        'ROLE_REGIONAL_COORDINATOR',
                        'ROLE_LOCATION_COORDINATOR',
                        'ROLE_TERRITORY_COORDINATOR',
                        'ROLE_METHODOLOGIST'
                    ])
                ) {
                    initGroups();
                }
            } //Выставлять дату на час вперед для новой видеоконференции
            if ($scope.isVideoConf && !$scope.updateDialog) {
                currentDate = new Date();
                nextHour = currentDate.getHours() + 1;
                currentDate.toLocaleString('ru-RU', {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit'
                });
                currentDate.setHours(nextHour, 0, 0, 0);
                $scope.dateTime = {
                    date: currentDate,
                    time: currentDate
                };
                $scope.duration = 60;
            }
            if ($scope.isVideoConf) {
                initPromises.push(
                    Users.getConference({
                        id: $scope.videoConfConfig ? $scope.videoConfConfig.id : 0
                    }).$promise.then(initUsers)
                );
            } else {
                initPromises.push(
                    Users.getMessage({
                        id: $scope._dialogId ? $scope._dialogId : 0
                    }).$promise.then(initUsers)
                ); // initPromises.push(Dialogs.getAvailableUsers(true).then(initUsers));
            }
            if ($scope.withUsers && $scope.withUsers.length > 0) {
                var withUsers = angular.copy($scope.withUsers);
                $scope.selectUsers(withUsers);
            }
            $q.all(initPromises).then(
                function () {
                    $scope.loaded = true;
                },
                function () {
                    $scope.loaded = true;
                }
            );
            if ($scope.updateDialog) {
                $scope.$watch('users', function (availableUsers) {
                    if (availableUsers.length >= 0) {
                        $scope.oldUsers = $scope.oldUsers.map(function (user) {
                            user.selected = true;
                            addRoles(user);
                            return user;
                        }) /*  .filter(function(user) {
                return $scope.dialogOwnerId !== user.id;
              }) */;
                        selectOldUsers($scope.oldUsers);
                    }
                });
            }
            InitCheckButtonAddAll();
            $scope.$watch(
                function () {
                    return $mdMedia('gt-md');
                },
                function (v) {
                    $scope.showUserRoles = v;
                }
            );
            $scope.searchByFirstNameOrLastName = function (item) {
                var searchText = $scope.searchText;
                if (!searchText) {
                    return true;
                }
                searchText = searchText.toLowerCase(); // Если это группа
                if (!!item.name) {
                    var sourceText = item.name.toLowerCase();
                    if (sourceText.indexOf(searchText) !== -1) {
                        return true;
                    }
                    return false;
                }
                // Если это юзер
                if (item.firstName && item.lastName) {
                    var sourceText1 = item.firstName + ' ' + item.lastName;
                    var sourceText2 = item.lastName + ' ' + item.firstName;
                    sourceText1 = sourceText1.toLowerCase();
                    sourceText2 = sourceText2.toLowerCase();
                    if (sourceText1.indexOf(searchText) !== -1) {
                        return true;
                    }
                    if (sourceText2.indexOf(searchText) !== -1) {
                        return true;
                    }
                    return false;
                }
                // -----------------
                return false;
            };

            $scope.addAllFiltered = addAllFiltered;
        }
        function cancelOpen() {
            if ($scope._dialogId !== undefined) {
                Dialogs.openDialog($scope._dialogId);
            }
        }
        function selectOldUsers(oldUsers) {
            oldUsers.forEach(function (user) {
                user.current = false;
                if (user.id === $scope.user.id) {
                    user.current = true;
                } // Проверяем есть ли такой юзер уже в списке
                var key = false;
                $scope.users.some(function (itemUser) {
                    if (itemUser.id === user.id) {
                        key = true;
                        return true;
                    }
                    return false;
                }); // Если нет то пушим
                if (!key) {
                    $scope.users.push(user);
                }
            });
        }
        function initUsers(response) {
            console.log('aaa')
            var checkUser;
            $scope.users = response;
            // Сделан таймаут для того чтоб вотчер на 'users' отработал раньше цыкла в таймауте
            $timeout(function () {
                $scope.users.forEach(function (user) {
                    addRoles(user);
                    if (user.id === $scope.user.id) {
                        user.current = true;
                        user.selected = true;
                        checkUser = true;
                    }
                });
                if (!checkUser) {
                    addRoles($scope.user);
                    $scope.user.current = true;
                    $scope.user.selected = true;
                    $scope.users.push($scope.user);
                }
            }, 100);
        }
        function rolesReducer (prev,curr) {
            return prev+", "+curr
        }
        function convertRoles(role){
            switch (role) {
            case "ROLE_LOCAL_ADMIN":
                return "Локальный администратор"
            case "ROLE_STUDENT":
                return "Ученик"
            case "ROLE_TUTOR":
                return "Тьютор"
            case "ROLE_ADDITIONAL_EDUCATION_COORDINATOR":
                return "Коодинатор по дополнительному образованию\n"
            case "ROLE_LOCATION_COORDINATOR":
                return "Локальный координатор"
            case "ROLE_PARENT":
                return "Родитель"
            case "ROLE_COURSE_DEVELOPER":
                return "Разработчик курсов"
            case "ROLE_DISTANCE_EDUCATION_COORDINATOR":
                return "Координатор дистанционного образования"
            case "ROLE_ANONYMOUS":
                return "Анонимный пользователь"
            case "ROLE_METHODOLOGIST":
                return "Методист"
            case "ROLE_PARTNER":
                return "Родитель"
            case "ROLE_PROJECT_ACTIVITY_COORDINATOR":
                return "Координатор проектной деятельности"
            case "ROLE_GUEST":
                return "Гость"
            case "ROLE_DEPUTY_HEAD_TEACHER":
                return "Заместитель директора по УВР"
            case "ROLE_ADMIN":
                return "Администратор"
            case "ROLE_OUT_OF_SCHOOL_ACTIVITY_COORDINATOR":
                return "Кординатор внеурочной деятельности"
            case "ROLE_SCHOOL_ADMIN":
                return "Школьный администратор"
            case "ROLE_CONSULTANT":
                return "Консультант"
            case "ROLE_HEAD_TEACHER":
                return "Директор"
            case "ROLE_PSYCHOLOGIST":
                return "Психолог"
            case "ROLE_TEACHER":
                return "Учитель"

            }
        }

        function addRoles(user) {
            user.customRoles = [];
            if (user.roles !== void 0) {
                user.roles.forEach(function (role) {
                    user.customRoles.push(role);
                    if ($scope.roles.indexOf(role) === -1) {
                        $scope.roles.push(role);
                    }
                });

            }
            $scope.modifiedRoles = $scope.roles
            if (user.roleViews) {
                for (var i = 0; i < user.roleViews.length; i++) {
                    var idx = user.customRoles.indexOf(user.roleViews[i].authority.name);
                    if (idx !== -1) {
                        user.customRoles[idx] = user.roleViews[i].roleView;
                    }
                }
            }
        }



        function initGroups() {
            var unbindUserWatcher, i;
            if ($scope.isVideoConf) {
                initPromises.push(
                    Groups.getAllForVideoConf(
                        {
                            id: $scope._dialogId ? $scope._dialogId : 0
                        },
                        function (response) {
                            $scope.groups = response;
                            $scope.groups.forEach(function (group) {
                                group.selected = false;
                            });
                            //Выбрать всех пользователей, если это видеоконференция Вопрос дня
                            if ($scope.isQuestionOfTheDay) {
                                unbindUserWatcher = $scope.$watch(
                                    function () {
                                        return $scope.users;
                                    },
                                    function (users) {
                                        if (users.length > 0) {
                                            addAll();
                                            unbindUserWatcher();
                                        }
                                    }
                                );
                            }
                        }
                    )
                );
            } else {
                initPromises.push(
                    Groups.getGroupMessage(
                        {
                            id: $scope._dialogId ? $scope._dialogId : 0
                        },
                        function (response) {

                            $scope.groups = response;
                            $scope.groups.forEach(function (group) {
                                group.selected = false;
                            });
                            //Выбрать всех пользователей, если это Диалог Вопрос дня
                            if ($scope.isQuestionOfTheDay) {
                                unbindUserWatcher = $scope.$watch(
                                    function () {
                                        return $scope.users;
                                    },
                                    function (users) {
                                        if (users.length > 0) {
                                            addAll();
                                            unbindUserWatcher();
                                        }
                                    }
                                );
                            }
                        }
                    )
                );
            }
        } // Считает сколько selected groups или users
        function getSelectedCount(list) {
            var count = 0;
            list.forEach(function (item) {
                if (item.selected) {
                    count = count + 1;
                }
            });
            return count;
        }
        // Проверяте колличество добавленных groups и users
        function checkButtonAddAll() {
            var groupsCount = $scope.groups.length;
            var groupsSelectedLength = getSelectedCount($scope.groups);
            var usersCount = $scope.users.length;
            var usersSelectedLength = getSelectedCount($scope.users);
            if (groupsCount === groupsSelectedLength && usersCount === usersSelectedLength) {
                $scope.allSelected = true;
            } else {
                $scope.allSelected = false;
            }
        }
        // Подиписываемся на изменения коллекций
        function InitCheckButtonAddAll() {
            $scope.$watch('groups', function (newValue, oldValue) {
                checkButtonAddAll();
            });
            $scope.$watch('users', function (newValue, oldValue) {
                checkButtonAddAll();
            });
        }
        function toggle(user) {
            if ($scope.isVideoConf) {
                if (!user.noeditable) {
                    if ($scope.videoConfId) {
                        if (!user.selected) {
                            spinnerShow();
                            Conferences.addParticipant(
                                {
                                    firstId: $scope.videoConfId,
                                    secondId: user.id
                                },
                                function (response) {
                                    user.selected = !user.selected;
                                    checkButtonAddAll();
                                    spinnerHide();
                                }
                            );
                        } else {
                            spinnerShow();
                            Conferences.deleteParticipant(
                                {
                                    id: $scope.videoConfId,
                                    user_id: user.id
                                },
                                function (response) {
                                    user.selected = !user.selected;
                                    checkButtonAddAll();
                                    spinnerHide();
                                }
                            );
                        }
                    } else {
                        user.selected = !user.selected;
                        checkButtonAddAll();
                    }
                    // Изменился список юзеров, ставим флажок чтоб при закрыити попапа обнавился список коференций
                    $scope.updateUsersList = true;
                }
            } else {
                if (!user.noeditable) {
                    if ($scope._dialogId) {
                        if (!user.selected) {
                            spinnerShow();
                            Conversations.addParticipant(
                                {
                                    id: $scope._dialogId,
                                    ids: [user.id]
                                },
                                function (response) {
                                    user.selected = !user.selected;
                                    checkButtonAddAll();
                                    // Для добавления новых получателей в существующий диалог создаем системное сообщение
                                    DialogsResource.createMessage(
                                        {
                                            convId: $scope._dialogId
                                        },
                                        {
                                            draft: false,
                                            date: Date.now(),
                                            text: user.firstName +
                                                ' ' +
                                                user.lastName +
                                                ' ' +
                                                'добавлен(а) в диалог',
                                            author: {
                                                id: $scope.user.id
                                            }
                                        },
                                        function (response, headers) {
                                            if (!$scope.uploadInProgress) {
                                                var nextPage = 2,
                                                    per_page = 10,
                                                    sorting_fields = ['date'],
                                                    sorting_direction = 'desc';
                                                getMessages();
                                            }
                                            //$scope.cancel();
                                            // Dialogs.openDialog($scope._dialogId);
                                            // }
                                            spinnerHide();
                                        }
                                    );
                                }
                            );
                        } else {
                            spinnerShow();
                            Conversations.deleteParticipant(
                                {
                                    id: $scope._dialogId,
                                    user_id: user.id
                                },
                                function (response) {
                                    user.selected = !user.selected;
                                    checkButtonAddAll();
                                    DialogsResource.createMessage(
                                        {
                                            convId: $scope._dialogId
                                        },
                                        {
                                            draft: false,
                                            date: Date.now(),
                                            text: user.firstName +
                                                ' ' +
                                                user.lastName +
                                                ' ' +
                                                'удален(а) из диалога',
                                            author: {
                                                id: $scope.user.id
                                            }
                                        },
                                        function (response, headers) {
                                            if (!$scope.uploadInProgress) {
                                                var nextPage = 2,
                                                    per_page = 10,
                                                    sorting_fields = ['date'],
                                                    sorting_direction = 'desc';
                                                getMessages();
                                            } // $scope.cancel(); // Dialogs.openDialog($scope._dialogId); // }
                                            spinnerHide();
                                        }
                                    );
                                }
                            );
                        }
                    } else {
                        user.selected = !user.selected;
                        checkButtonAddAll();
                    }
                }
            }
        }
        // Для добавления новых получателей в существующий диалог
        function getMessages() {
            var nextPage = 2, per_page = 10, sorting_fields = ['date'], sorting_direction = 'desc';
            $scope.scrollToBottom = true;
            DialogsResource.getMessages(
                {
                    convId: $scope.id,
                    page: 1,
                    per_page: per_page,
                    sorting_fields: sorting_fields,
                    sorting_direction: sorting_direction
                },
                function (response, responseHeaders) {
                    var maxPages = Math.ceil(responseHeaders('X-Total-Count') / per_page);
                    if (maxPages < 2) {
                        $scope.isLastPage = true;
                    } else {
                        $scope.isLastPage = false;
                    }
                    $scope.messages = [];
                    $scope.unpublished = [];
                    response.forEach(function (message, i) {
                        if (message.draft) {
                            $scope.unpublished.push(message);
                        } else {
                            $scope.messages.push(message);
                        }
                    });
                    $scope.draftFiles = [];
                    if ($scope.unpublished.length > 0) {
                        var lastDraft = $scope.unpublished[$scope.unpublished.length - 1];
                        $scope.message = lastDraft;
                        $scope.message.files = lastDraft.files;
                        $scope.message.files.forEach(function (file) {
                            if (file.name === null || file.name === '' || !file.name) {
                                var name = file.path.substring(file.path.lastIndexOf('/') + 1);
                                file.name = name;
                            }
                            $scope.draftFiles.push(file);
                        });
                    }
                }
            );
        }
        function removeCurrentUserFromUsers() {
            var index = -1;
            $scope.users.some(function (user, i) {
                if (user.id == $scope.user.id) {
                    index = i;
                    return true;
                }
            });
            if (index != -1) {
                $scope.users.splice(index, 1);
            }
        }

        $scope.toggleChosenGroups = function () {
            alert('aa')
        }

        function addAll() {
            if ($scope.allSelected) {
                $scope.users.forEach(function (user) {
                    if (user.current) {
                        return;
                    }
                    if (user.selected) {
                        user.selected = false;
                    }
                });
                $scope.groups.forEach(function (group) {
                    if (group.selected) {
                        group.selected = false;
                    }
                });
                $scope.allSelected = false;
            } else {
                $scope.users.forEach(function (user) {
                    if (user.current) {
                        return;
                    }
                    user.selected = true;
                });
                $scope.groups.forEach(function (group) {
                    group.selected = true;
                });
                $scope.allSelected = true;
            }
            if ($scope.id && $scope.updateDialog) {
                if (!$scope.allSelected) {
                    Conversations.deleteParticipant({
                        conversationId: $scope.id
                    });
                } else {
                    var userNames = [];
                    var ids = $scope.users.map(function (user) {
                        userNames.push(user.firstName + ' ' + user.lastName);
                        return user.id;
                    });
                    spinnerShow();
                    Conversations.addParticipant({
                        id: $scope.id,
                        ids: ids
                    }).$promise.then(function () {
                        spinnerHide();
                        // Шлём сообщение что добавили пользователей
                        var messageText = userNames.join(', ') + ' добавлены в диалог.';
                        createMessage({
                            dialogId: $scope.id,
                            authorId: $scope.user.id,
                            text: messageText
                        });
                    }).catch(function () {
                        spinnerHide();
                    });
                }
            }
            if ($scope.isVideoConf) {
                if ($scope.videoConfId) {
                    var ids = $scope.users.map(function (user) {
                        return user.id;
                    });
                    if (!$scope.allSelected) {
                        Conferences.deleteParticipants({ id: $scope.videoConfId });
                    } else {
                        spinnerShow();
                        Conferences.addParticipants({
                            id: $scope.videoConfId,
                            ids: ids
                        }).$promise.then(function () {
                            spinnerHide();
                        }).catch(function () {
                            spinnerHide();
                        });
                    } // Изменился список юзеров, ставим флажок чтоб при закрыити попапа обнавился список коференций
                    $scope.updateUsersList = true;
                }
            }
        }

        function addAllFiltered() {
            $scope.users.forEach(function (user) {
                if (user.current) {
                    return;
                }
                // Если уже выбран пропускаем
                if (user.selected) {
                    return;
                }
                if (isInRole(user)) {
                    user.selected = true;
                }
            });
            // Если редактирование
            if ($scope.id && $scope.updateDialog) {
                spinnerShow();
                // Выбираем всех кто selected
                var ids = [];
                var userNames = [];
                $scope.users.forEach(function (user) {
                    if (user.selected) {
                        ids.push(user.id);
                        userNames.push(user.firstName + ' ' + user.lastName);
                    }
                });
                Conversations.addParticipant({
                    id: $scope.id,
                    ids: ids
                }).$promise.then(function () {
                    // Шлём сообщение что добавили пользователей
                    var messageText = userNames.join(', ') + ' добавлены в диалог.';
                    createMessage({
                        dialogId: $scope.id,
                        authorId: $scope.user.id,
                        text: messageText
                    });
                    spinnerHide();
                }).catch(function () {
                    spinnerHide();
                });
            }
            // Если видео конференция
            if ($scope.isVideoConf) {
                if ($scope.videoConfId) {
                    spinnerShow();
                    var ids = [];
                    $scope.users.forEach(function (user) {
                        if (user.selected) {
                            ids.push(user.id);
                        }
                    });
                    Conferences.addParticipants({
                        id: $scope.videoConfId,
                        ids: ids
                    }).$promise.then(function () {
                        spinnerHide();
                    }).catch(function () {
                        spinnerHide();
                    });
                    // Изменился список юзеров, ставим флажок чтоб при закрыити попапа обнавился список коференций
                    $scope.updateUsersList = true;
                }
            }
            // -------------
        }

        function createMessage(obj) {
            var dialogId = obj.dialogId;
            var authorId = obj.authorId;
            var text = obj.text;
            // Для добавления новых получателей в существующий диалог создаем системное сообщение
            spinnerShow();
            DialogsResource.createMessage({
                convId: dialogId
            }, {
                draft: false,
                date: Date.now(),
                text: text,
                author: {
                    id: authorId
                }
            }, function (response, headers) {
                spinnerHide();
            }
            );
        }

        $scope.filterSelectedGroups = function () {
            if ($scope.selectedUsersOnly && $scope.selectedGroupsOnly ) {
                return true;
            }
            if ($scope.selectedUsersOnly) {
                return false;
            }
            return true;
        }

        function filterGroups() {
            if ($scope.usersOnly && $scope.groupsOnly) {
                return true;
            }
            if ($scope.usersOnly) {
                return false;
            }
            return true;
        }

        function filterUsers() {
            if ($scope.usersOnly && $scope.groupsOnly) {
                return true;
            }
            if ($scope.groupsOnly) {
                return false;
            }
            return true;
        }

        $scope.filterSelectedUsers = function () {
            if ($scope.selectedUsersOnly  && $scope.selectedGroupsOnly ) {
                return true;
            }
            if ($scope.selectedGroupsOnly ) {
                return false;
            }
            return true;
        }

        function addDialog(message) {
            var newUsers = [], clearedUsers, openDialog, dialog;
            if (!$scope.newDialogName || $scope.newDialogName.length < 1) {
                LmsUtils.showSimpleToast('Отсутствует название диалога / рассылки.');
                return;
            }
            $scope.users.forEach(function (user) {
                if (user.selected) {
                    if ($scope.updateDialog) {
                        if (!user.noeditable) {
                            newUsers.push(user);
                        }
                    } else {
                        newUsers.push(user);
                    }
                }
            });
            var addableGroups = $scope.groups
                .filter(function (group) {
                    return group.selected === true;
                })
                .map(function (group) {
                    return group.id;
                });
            var usersForConversation = newUsers.map(function (user) {
                return user.id;
            });
            var dialogName = '';
            if ($scope.dialogTheme) {
                dialogName = $scope.dialogTheme + ' : ' + $scope.newDialogName;
            } else {
                dialogName = $scope.newDialogName;
            }
            if ($scope.id && $scope.updateDialog) {
                Conversations.addParticipant({
                    id: $scope.id,
                    ids: usersForConversation
                })
                    .$promise.then(function () {
                        return Conversations.update({
                            id: $scope.id,
                            distribution: $scope.isDistrib || false,
                            name: dialogName
                        }).$promise;
                    })
                    .then(function () {
                        $rootScope.$broadcast('needDialogsListUpdate');
                        Dialogs.openDialog($scope.id);
                    });
            } else {
                dialog = {
                    name: dialogName,
                    distribution: $scope.isDistrib || false,
                    usersId: usersForConversation,
                    groupsId: addableGroups,
                    creatorRole: $scope.user.role
                };
                openDialog = {
                    name: dialogName,
                    owner: {
                        id: $scope.user.id
                    },
                    participants: newUsers,
                    distrib: $scope.isDistrib || false,
                    message: message || ''
                };
                Conversations.create(dialog, function (response) {
                    // Dialog creating!!! ????
                    var dialogId = response.id;
                    Dialogs.openDialog(dialogId, openDialog);
                });
            }
        }
        function addVideoConf() {
            var finalUsers = [], clearedUsers, dateTime;
            if (!$scope.newDialogName || $scope.newDialogName.length < 1) {
                LmsUtils.showSimpleToast('Отсутствует название видеоконференции.');
                return;
            } else if (!$scope.dateTime.date || $rootScope.invalidDate) {
                LmsUtils.showSimpleToast('Дата некорректна / отсутствует.');
                return;
            } else if (!$scope.dateTime.time) {
                LmsUtils.showSimpleToast('Отсутствует время.');
                return;
            } else if (!$scope.duration) {
                LmsUtils.showSimpleToast('Отсутствует длительность видеоконференции.');
                return;
            } else if ($scope.duration < 60) {
                LmsUtils.showSimpleToast(
                    'Длительность видеоконференции должна быть больше 60 минут.'
                );
                return;
            }
            dateTime = new Date(
                $scope.dateTime.date.getFullYear(),
                $scope.dateTime.date.getMonth(),
                $scope.dateTime.date.getDate(),
                $scope.dateTime.time.getHours(),
                $scope.dateTime.time.getMinutes()
            );
            if (dateTime < new Date()) {
                LmsUtils.showSimpleToast('Указана прошедшая дата.');
                return;
            }
            $scope.users.forEach(function (user) {
                if (user.selected) {
                    finalUsers.push(user);
                }
            }); //     if (group.selected) { //         }); //     } // }); // $scope.groups.forEach(function (group) { //         group.users.forEach(function (user) { //             finalUsers.push(user);
            var addableGroups = $scope.groups
                .filter(function (group) {
                    return group.selected === true;
                })
                .map(function (group) {
                    return group.id;
                });
            // clearedUsers = clearDuplicates(finalUsers);
            var usersForConversation = finalUsers.map(function (user) {
                return user.id;
            }); //finalUsers.push($auth.user); // clearedUsers = clearDuplicates(finalUsers);
            if ($scope.videoConfConfig && $scope.videoConfConfig.ownerId) {
                $scope.videoConfConfig.name = $scope.newDialogName;
                $scope.videoConfConfig.duration = $scope.duration;
                $scope.videoConfConfig.plannedStartTime = dateTime;
                $scope.videoConfConfig.participants = clearedUsers;
                $mdDialog.hide($scope.videoConfConfig);
            } else {
                $mdDialog.hide({
                    name: $scope.newDialogName,
                    startDate: dateTime,
                    duration: $scope.duration,
                    ownerId: $scope.user.id,
                    participants: clearedUsers,
                    usersId: usersForConversation,
                    groupsId: addableGroups
                });
            }
        } //     $scope.users.forEach(function (user) { //         if (user.selected) { //             arr.push(user); //         } //     $scope.groups.forEach(function (group) { //         if (group.selected) { //     }); //     }); //     return clearDuplicates(arr).length; //     var arr = []; //         } // function sumUsers() { // }
        function selectUsers(users) {
            var allSelected = true, additionalUsers = [], waitForUsers;
            waitForUsers = $scope.$watch('users', function (v) {
                if (v && v.length > 0 && users && users.length > 0) {
                    for (var i in v) {
                        for (var j in users) {
                            if (v[i].id === users[j].id) {
                                v[i].selected = true;
                                users[j].selected = true;
                                if (users[j].noeditable) {
                                    v[i].noeditable = true;
                                }
                            }
                        }
                        if (!v[i].selected) {
                            allSelected = false;
                        }
                    }
                    users.forEach(function (user) {
                        if (!user.selected) {
                            user.selected = true;
                            addRoles(user);
                            additionalUsers.push(user);
                        }
                    });
                    additionalUsers = v.concat(additionalUsers);
                    // $scope.users = clearDuplicates(additionalUsers);
                    $scope.users = additionalUsers;
                    $scope.allSelected = allSelected;
                    waitForUsers();
                }
            });
        }
        function isInArray(array, item) {
            var idx = array.indexOf(item);
            if (idx > -1) {
                return true;
            } else {
                return false;
            }
        }
        function checkRole(item) {
            if (isInArray($scope.avaibleRoles, item)) {
                var idx = $scope.avaibleRoles.indexOf(item);
                $scope.avaibleRoles.splice(idx, 1);
            } else {
                $scope.avaibleRoles.push(item);
            }
        }
        function isInRole(user) {
            // Не показываем текущего пользователя в меню добавления удаления пользователя
            if (user.id === $auth.user.id) {
                return false;
            }
            var roles_length = 0;
            if (user.roles !== void 0) {
                user.roles.forEach(function (role) {
                    $scope.avaibleRoles.forEach(function (r) {
                        if (role == r) {
                            roles_length++;
                        }
                    });
                });
            }
            if (roles_length > 0 || $scope.avaibleRoles.length === 0) {
                return true;
            } else
                return false;
        }
        function selectGroup(group, selected, withUsers) {
            group.selected = selected;
            if ($scope._dialogId) {
                spinnerShow();
                if (selected) {
                    Conversations.addGroup(
                        {
                            firstId: $scope._dialogId,
                            secondId: group.id
                        },
                        function (response) {
                            group.selected = true;
                            DialogsResource.createMessage(
                                {
                                    convId: $scope._dialogId
                                },
                                {
                                    draft: false,
                                    date: Date.now(),
                                    text: 'Группа ' +
                                        '«' +
                                        group.name +
                                        '»' +
                                        ' добавлена в диалог',
                                    author: {
                                        id: $scope.user.id
                                    }
                                },
                                function (response, headers) {
                                    if (!$scope.uploadInProgress) {
                                        var nextPage = 2,
                                            per_page = 10,
                                            sorting_fields = ['date'],
                                            sorting_direction = 'desc';
                                        getMessages();
                                        spinnerHide();
                                        //$scope.cancel();
                                        //Dialogs.openDialog($scope._dialogId);
                                    }
                                    // }
                                }
                            );
                        }
                    );
                } else {
                    Conversations.deleteGroup(
                        {
                            id: $scope._dialogId,
                            group_id: group.id
                        },
                        function (response) {
                            group.selected = false;
                            spinnerHide();
                        }
                    );
                }
            }
            // ---------------
            if ($scope.videoConfId) {
                spinnerShow(); //Conferences
                if (selected) {
                    Conferences.addGroup(
                        { firstId: $scope.videoConfId, secondId: group.id },
                        function (response) {
                            group.selected = true;
                            spinnerHide();
                        }
                    );
                } else {
                    Conferences.deleteGroup(
                        { id: $scope.videoConfId, group_id: group.id },
                        function (response) {
                            group.selected = false;
                            spinnerHide();
                        }
                    );
                }
            }
            // Изменился список юзеров, ставим флажок чтоб при закрыити попапа обнавился список коференций
            $scope.updateUsersList = true;
        }
        function noOneToTalk() {
            function selected(el) {
                return el.selected;
            }
            return $scope.users.some(selected);
        }

        /**
         * Возвращает список групп для ui
         */
        function groupList() {
            var groups = $scope.groups;
            return groups;
        }
        $scope.groupList = groupList;

        /**
         * Возвращает список юзеров для ui
         */
        function userListLeft() {

            if (filterUsers()) {
                var users = $scope.users;
                // ---
                var usersFilter = users.filter(function (user) {
                    user.type = 'user';
                    // ----
                    if (user.selected) {
                        return false;
                    }
                    // ----
                    var isShow1 = isInRole(user);
                    if (!isShow1) {
                        return false;
                    }
                    // ----
                    var isShow2 = $scope.searchByFirstNameOrLastName(user);
                    if (!isShow2) {
                        return false;
                    }
                    // ----
                    return true;
                });
                return usersFilter;
            }
            return [];
        }
        /**
         * Возвращает список групп для ui
         */
        function groupListLeft() {
            if (filterGroups()) {
                var groups = $scope.groups;
                // ---
                var filterd = groups.filter(function (item) {
                    item.type = 'group';
                    // ----
                    if (item.selected) {
                        return false;
                    }
                    // ----
                    var isShow2 = $scope.searchByFirstNameOrLastName(item);
                    if (!isShow2) {
                        return false;
                    }
                    // ----
                    return true;
                });
                return filterd;
            }
            return [];
        }
        $scope.listLeft = function () {
            var groups = groupListLeft();
            var users = userListLeft();
            var concat = groups.concat(users);
            return concat;
        };

        /**
        * Возвращает список юзеров для ui
        */
        function userListRight() {
            var users = $scope.users;
            // ---
            var usersFilter = users.filter(function (user) {
                user.type = 'user';
                // ----
                if (!user.selected) {
                    return false;
                }
                return true;
            });
            return usersFilter;
        }
        /**
         * Возвращает список групп для ui
         */
        function groupListRight() {
            var groups = $scope.groups;
            // ---
            var filterd = groups.filter(function (item) {
                item.type = 'group';
                // ----
                if (!item.selected) {
                    return false;
                }
                return true;
            });
            return filterd;
        }
        $scope.listRight = function () {
            var groups = groupListRight();
            var users = userListRight();

            if ($scope.selectedGroupsOnly){
                groups = groupListRight();
                users = []
                if ($scope.selectedUsersOnly){
                    groups = groupListRight();
                    users = userListRight();
                }
            }
            if ($scope.selectedUsersOnly){
                groups = []
                users = userListRight();
                if ($scope.selectedGroupsOnly){
                    groups = groupListRight();
                    users = userListRight();
                }
            }

            var concat = groups.concat(users);
            return concat;
        };
    }
]);

"use strict";

app.controller("DialogsParticipantListCtrl", [
    "$scope",
    "$q",
    "Dialogs",
    "VideoConfConfigResource",
    "$mdDialog",
    "$rootScope",
    "UserGroupResource",
    "$auth",
    "LmsUtils",
    "$mdMedia",
    "Users",
    "DialogsResource",
    "Conversations",
    "Conferences",
    "Groups",
    function(
    $scope,
    $q,
    Dialogs,
    VideoConfConfigResource,
    $mdDialog,
    $rootScope,
    UserGroupResource,
    $auth,
    LmsUtils,
    $mdMedia,
    Users,
    DialogsResource,
    Conversations,
    Conferences,
    Groups
  ) {
        var unbindAuthWatcher, initPromises = [];

    // Variables
        $scope.user = {};
        $scope.duration = undefined ? "" : $scope.duration;
        $scope.newDialogName = undefined ? "" : $scope.newDialogName;
        $scope._dialogId = undefined ? 0 : $scope.id;
        $scope.groups = [];
        $scope.users = $scope.oldUsers;
        $scope.finalUserList = [];
        $scope.roles = [];
        $scope.avaibleRoles = [];
        $scope.usersOnly = false;
        $scope.groupsOnly = false;
        $scope.allSelected = false;
        $scope.allfilters = false;
        $scope.showUserRoles = false;
        $scope.loaded = false;

    //Methods
        $scope.selectUsers = selectUsers;
        $scope.isInArray = isInArray;
        $scope.isInRole = isInRole;
        $scope.cancelOpen =  cancelOpen;

        unbindAuthWatcher = $scope.$watch(
      function() {
          return $auth.user;
      },
      function(user) {
          if (user) {
              $scope.user.id = user.id;
              $scope.user.role = user.userRoles[0];
              init();
              unbindAuthWatcher();
          }
      }
    );

        function init() {
            var currentDate, nextHour;

            //студенты в видеоконференциях могут просматривать группы
            if (!$auth.isInRole("ROLE_STUDENT") || $scope.isVideoConf) {
                //пользователи которые не могут просматривать группы
                if (
                    !$auth.isInAnyRole([
                        "ROLE_PARENT",
                        "ROLE_REGIONAL_COORDINATOR",
                        "ROLE_LOCATION_COORDINATOR",
                        "ROLE_TERRITORY_COORDINATOR",
                        "ROLE_METHODOLOGIST"
                    ])
                ) {
                    initGroups();
                }
            }

            if ($scope.isVideoConf) {
                initUsers($scope.users);
            } else {
                initUsers($scope.users);
            }
            if ($scope.withUsers && $scope.withUsers.length > 0) {
                var withUsers = angular.copy($scope.withUsers);
                $scope.selectUsers(withUsers);
            }
            $q.all(initPromises).then(
                function () {
                    $scope.loaded = true;
                },
                function () {
                    $scope.loaded = true;
                }
            );
            if ($scope.updateDialog) {
                var waitForUsers = $scope.$watch("users", function (availableUsers) {
                    if (availableUsers.length >= 0) {
                        $scope.oldUsers = $scope.oldUsers
                            .map(function (user) {
                                user.selected = true;
                                return user;
                            })
                            .filter(function (user) {
                                return $scope.dialogOwnerId !== user.id;
                            });
                        selectOldUsers($scope.oldUsers);
                    }
                });
            }
            if ($scope.dialogTheme) {
                $scope.newDialogName = $scope.dialogTheme + ": ";
            }
        }
        function selectOldUsers(oldUsers) {
            var idArr = [];
            $scope.users.forEach(function(user) {
                idArr.push(user.id);
            });
            oldUsers.forEach(function(user) {
                if (idArr.indexOf(user.id) === -1) {
                    $scope.users.push(user);
                }
            });
        }

        function cancelOpen(){
            if ($scope._dialogId !== undefined) {
                Dialogs.openDialog($scope._dialogId);
            }
        }

        $scope.searchByFirstNameOrLastName = function (item) {
          var searchText = $scope.searchText;
          if (!searchText) {
            return true;
          }
          searchText = searchText.toLowerCase();
          // Если это группа
          if (!!item.name) {
            var sourceText = item.name.toLowerCase()
            if (sourceText.indexOf(searchText) !== -1) {
              return true;
            }
            return false;
          }
          // Если это юзер
          if (item.firstName && item.lastName) {
            var sourceText1 = item.firstName + ' ' + item.lastName;
            var sourceText2 = item.lastName + ' ' + item.firstName;
            sourceText1 = sourceText1.toLowerCase();
            sourceText2 = sourceText2.toLowerCase();
            if (sourceText1.indexOf(searchText) !== -1) {
              return true;
            }
            if (sourceText2.indexOf(searchText) !== -1) {
              return true;
            }
            return false;
          }
          // -----------------
          return false;
        };

        function initUsers(response) {
            $scope.users = response;
            console.log($scope.users)
            $scope.users.forEach(function(user) {
                user.selected = false;
                addRoles(user);
            });
        }
        function addRoles(user) {
            user.customRoles = [];
            if (user.roles !== void 0) {
                user.roles.forEach(function(role) {
                    user.customRoles.push(role);
                    if ($scope.roles.indexOf(role) === -1) {
                        $scope.roles.push(role);
                    }
                });
            }
            if (user.roleViews) {
                for (var i = 0; i < user.roleViews.length; i++) {
                    var idx = user.customRoles.indexOf(user.roleViews[i].authority.name);
                    if (idx !== -1) {
                        user.customRoles[idx] = user.roleViews[i].roleView;
                    }
                }
            }
        }
        function initGroups() {
            var unbindUserWatcher, i;
            if ($scope.isVideoConf) {
                initPromises.push(
          Groups.getAllForVideoConf(
              {
                  id: $scope._dialogId ? $scope._dialogId : 0
              },
            function(response) {

                $scope.groups = response;
                $scope.groups.forEach(function(group) {
                    group.selected = false;
                }); //Выбрать всех пользователей, если это видеоконференция Вопрос дня
                if ($scope.isQuestionOfTheDay) {
                    unbindUserWatcher = $scope.$watch(
                  function() {
                      return $scope.users;
                  },
                  function(users) {
                      if (users.length > 0) {
                          addAll();
                          unbindUserWatcher();
                      }
                  }
                );
                }
            }
          )
        );
            } else {
                initPromises.push(
          Groups.getGroupMessage(
              {
                  id: $scope._dialogId ? $scope._dialogId : 0
              },
            function(response) {
                console.log(response)
                $scope.groups = response;
                $scope.groups.forEach(function(group) {
                    group.selected = false;
                });
            }
          )
        );
            }
        }
        function selectUsers(users) {
            var allSelected = true, additionalUsers = [], waitForUsers;
            waitForUsers = $scope.$watch("users", function(v) {
                if (v && v.length > 0 && users && users.length > 0) {
                    for (var i in v) {
                        for (var j in users) {
                            if (v[i].id === users[j].id) {
                                v[i].selected = true;
                                users[j].selected = true;
                                if (users[j].noeditable) {
                                    v[i].noeditable = true;
                                }
                            }
                        }
                        if (!v[i].selected) {
                            allSelected = false;
                        }
                    }
                    users.forEach(function(user) {
                        if (!user.selected) {
                            user.selected = true;
                            addRoles(user);
                            additionalUsers.push(user);
                        }
                    });
                    additionalUsers = v.concat(additionalUsers);
                    $scope.users = additionalUsers;
                    $scope.allSelected = allSelected;
                    waitForUsers();
                }
            });
        }
        function isInArray(array, item) {
            var idx = array.indexOf(item);
            if (idx > -1) {
                return true;
            } else {
                return false;
            }
        }
        function isInRole(user) {
            var roles_length = 0;
            if (user.roles !== void 0) {
                user.roles.forEach(function(role) {
                    $scope.avaibleRoles.forEach(function(r) {
                        if (role == r) {
                            roles_length++;
                        }
                    });
                });
            }
            if (roles_length > 0 || $scope.avaibleRoles.length === 0) {
                return true;
            } else
        return false;
        }
        $scope.$watch(
      function() {
          return $mdMedia("gt-md");
      },
      function(v) {
          $scope.showUserRoles = v;
      }
    );
    }
]);

'use strict';

angular.module('lmsClientApp')
    .factory('Groups', function ($resource, API) {
        var newApi = API.clientApi + '/groups'
        return $resource(newApi, {}, {
            'getGroupMessage': {
                method: 'GET',
                url: '/conversation/groups/:id',
                isArray: true
            },
            'getAllForVideoConf': {
                method: 'GET',
                isArray: true,
                url: '/videoconf/groups/:id'
            }
        });
    })

'use strict';

app
.filter('filenameFilter', function() {
    return function(input) {
        var filtered = input.substring(input.lastIndexOf('/')+1);
        return filtered;
    };
}).filter('roleFilter', function(Role) {
    var result;
    return function(input) {
        if(!Role.getRoleTranslate(input)){
            result = input;
        } else result = Role.getRoleTranslate(input);
        return result;
    };
});

'use strict';

angular.module('lmsClientApp').service('Breadcrumbs', ['BreadcrumbsResource', function (BreadcrumbsResource) {
    // Methods
    this.getNames = getNames;
    this.getParents = getParents;

    function getNames(userRole, title, ids) {
        var isRegionalCoordinator = (userRole === 'ROLE_REGIONAL_COORDINATOR'),
            isTerritoryCoordinator = (userRole === 'ROLE_TERRITORY_COORDINATOR'  || userRole === 'ROLE_LOCATION_COORDINATOR'),
            isManager = (userRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR' || userRole === 'ROLE_PSYCHOLOGIST' || userRole === 'ROLE_METHODOLOGIST' || userRole === 'ROLE_HEAD_TEACHER' || userRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
            isStudentOrParent = (userRole === 'ROLE_STUDENT' || userRole === 'ROLE_PARENT');

        return BreadcrumbsResource.get(ids).$promise.then(function (result) {
            var names = {},
                student = null;

            names.regionName = isRegionalCoordinator ? title : result.region;
            names.territoryName = isTerritoryCoordinator ? result.territory : title;
            names.schoolName = isManager ? title : result.school;
            names.userGroupName = result.group;
            if (result.course) {
                //names.courseName = result.course.title + ' ' + result.course.classParallel + ' класс';
                names.courseName = result.course.title; // MASH-681
            }
            if (result.users) {
                student = result.users[ids.users];
                names.studentName = isStudentOrParent ? title : student.firstName + ' ' + student.lastName;
            }
            if (result.topic) {
                names.topic = {
                    name: result.topic.title,
                    number: result.topic.number
                };
            }

            return names;
        });
    }

    function getParents(userRole, state) {
        var isTutor = (userRole === 'ROLE_TUTOR'),
            isTeacher = (userRole === 'ROLE_TEACHER'),
            isManager = (userRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'
              || userRole === 'ROLE_PSYCHOLOGIST'
              || userRole === 'ROLE_METHODOLOGIST'
              || userRole === 'ROLE_HEAD_TEACHER'
              || userRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
            isRegionalCoordinator = (userRole === 'ROLE_REGIONAL_COORDINATOR'),
            isTerritoryCoordinator = (userRole === 'ROLE_TERRITORY_COORDINATOR'  || userRole === 'ROLE_LOCATION_COORDINATOR'),
            isStudentOrParent = (userRole === 'ROLE_STUDENT' || userRole === 'ROLE_PARENT'),
            parents = {};

        parents.territoryParent = isRegionalCoordinator ? 'region' + state : 'region' + state;
        parents.schoolParent = isTerritoryCoordinator ? 'territory' + state : 'dashboard';
        parents.userGroupParent = isTutor ? 'tutor' + state : 'school' + state;
        parents.courseParent = isTeacher ? 'teacher' + state : 'userGroup' + state;
        parents.studentParent = isStudentOrParent ? 'dashboard' : 'userGroup' + state;
        parents.detailsParent = isTeacher ? 'courseSection' + state : 'student' + state;
        parents.managerParent = isManager ? 'schoolJournal' : null;
        return parents;
    }
}]);

'use strict';

angular.module('lmsClientApp')
    .factory('BreadcrumbsResource', function ($resource) {
        return $resource('/api/breadcrumbs/', {}, {
            get: {
                method: 'GET',
                url: '/api/breadcrumbs/',
                params: {
                    'users': '@users',
                    'lesson': '@lesson',
                    'topic': '@topic',
                    'course': '@course',
                    'group': '@group',
                    'school': '@school',
                    'territory': '@territory',
                    'region': '@region'
                }
            }            
        });
    });

'use strict';

app.controller('LevelStatisticsCoursesCourseDashBarCtrl', ['$scope', '$state', 'userAccount', 'SchoolResource', 'Course', 'LearningClassResource', function ($scope, $state, userAccount, SchoolResource, Course, LearningClassResource) {
    var currentRole = userAccount.userRoles[0],
        isDEC = (currentRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'),
        isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR'),
        isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
        isHeadTeacher = (currentRole === 'ROLE_HEAD_TEACHER'),
        isDeputyHeadTeacher = (currentRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
        level = $state.params.levelNum,
        parallel = $state.params.parallelNum,
        schoolId = $state.params.schoolId,
        courseId = $state.params.courseId;

    $scope.entity = $state.current.data.entity;
    $scope.learningClasses = [];
    $scope.selectedLearningClass = null;

    //для хлебных крошек
    $scope.schoolName = null;
    $scope.courseName = null;
    $scope.territoryName = null;
    if (isRegionalCoordinator || isTerritoryCoordinator) {
        if (isRegionalCoordinator) {
            $scope.territoryParent = 'regionStatistics';
            $scope.regionName = $scope.entity.title;
        }
        $scope.schoolParent = 'territoryStatistics';
        SchoolResource.get({'id': schoolId}, function (result) {
            $scope.schoolName = result.name;
            $scope.territoryName = result.territory.name;
        });
    } else if (isDEC || isHeadTeacher || isDeputyHeadTeacher) {
        $scope.schoolName = $scope.entity.title;
        $scope.schoolParent = 'dashboard';
    }
    if (parallel) {
        $scope.levelName = parallel + ' классы';
    } else {
        switch (level) {
        case '1':
            $scope.levelName = 'Начальное';
            break;
        case '2':
            $scope.levelName = 'Основное';
            break;
        case '3':
            $scope.levelName = 'Среднее';
            break;
        }
        $scope.levelName += ' общее';
    }
    if (courseId) {
        Course.getCourse(courseId).then(function (result) {
            $scope.courseName = result.name;
        });
    }
    LearningClassResource.getLearningClassesBySchoolIdAndLevel({
        schoolId: schoolId,
        level: level,
        parallel: parallel,
        course: courseId
    }, function (result) {
        $scope.learningClasses = result;
        $scope.learningClasses.some(function (learningClass) {
            if(learningClass.id == $state.params.learningClassId) {
                $scope.selectedLearningClass = learningClass;
            }
        });
    });

    $scope.goToLearningClass = function () {
        $state.go($state.current.name, {
            learningClassId: $scope.selectedLearningClass ? $scope.selectedLearningClass.id : null
        });
    };
}]);

'use strict';

app.controller('LevelStatisticsDashBarCtrl', ['$scope', '$state', 'userAccount', 'SchoolResource', 'CourseResource', function ($scope, $state, userAccount, SchoolResource, CourseResource) {
    var currentRole = userAccount.userRoles[0],
        isDEC = (currentRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'),
        isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR'),
        isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
        isHeadTeacher = (currentRole === 'ROLE_HEAD_TEACHER'),
        isDeputyHeadTeacher = (currentRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
        level = $state.params.levelNum,
        parallel = $state.params.parallelNum;

    $scope.entity = $state.current.data.entity;
    $scope.showCourseSelect = false;
    $scope.selectedCourse = null;
    $scope.courses = [];

    //для хлебных крошек
    $scope.schoolName = null;
    $scope.territoryName = null;
    if (isRegionalCoordinator || isTerritoryCoordinator) {
        if (isRegionalCoordinator) {
            $scope.territoryParent = 'regionStatistics';
            $scope.regionName = $scope.entity.title;
        }
        $scope.schoolParent = 'territoryStatistics';
        SchoolResource.get({'id': $state.params.schoolId}, function (result) {
            $scope.schoolName = result.name;
            $scope.territoryName = result.territory.name;
        });
    } else if (isDEC || isHeadTeacher || isDeputyHeadTeacher) {
        $scope.schoolName = $scope.entity.title;
        $scope.schoolParent = 'dashboard';
    }
    if (parallel) {
        $scope.levelName = parallel + ' классы';
    } else {
        switch (level) {
        case '1':
            $scope.levelName = 'Начальное';
            break;
        case '2':
            $scope.levelName = 'Основное';
            break;
        case '3':
            $scope.levelName = 'Среднее';
            break;
        }
        $scope.levelName += ' общее';
    }

    if ($state.current.name === 'levelStatisticsTeachers') {
        $scope.showCourseSelect = true;

        CourseResource.getCoursesWithTeacher({
            'schoolId': $state.params.schoolId,
            'level': $state.params.levelNum,
            'parallel': $state.params.parallelNum,
            'withTeacher': true
        }, function (result) {
            $scope.courses = result;
            $scope.courses.forEach(function (course) {
                if (course.id == $state.params.courseId) {
                    $scope.selectedCourse = course;
                }
            });
        });
    }

    $scope.goToCourse = function () {
        $state.go('levelStatisticsTeachers', {
            courseId: $scope.selectedCourse ? $scope.selectedCourse.id : ''
        });
    };
}]);

'use strict';

app.controller('LevelStatisticsStudentsStudentDashBarCtrl', ['$scope', '$state', 'userAccount', 'SchoolResource', 'UserResource', function ($scope, $state, userAccount, SchoolResource, UserResource) {
    var currentRole = userAccount.userRoles[0],
        isDEC = (currentRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'),
        isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR'),
        isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
        isHeadTeacher = (currentRole === 'ROLE_HEAD_TEACHER'),
        isDeputyHeadTeacher = (currentRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
        level = $state.params.levelNum,
        parallel = $state.params.parallelNum,
        schoolId = $state.params.schoolId,
        studentId = $state.params.studentId;

    $scope.entity = $state.current.data.entity;

    //для хлебных крошек
    $scope.schoolName = null;
    $scope.studentName = null;
    $scope.territoryName = null;
    if (isRegionalCoordinator || isTerritoryCoordinator) {
        if (isRegionalCoordinator) {
            $scope.territoryParent = 'regionStatistics';
            $scope.regionName = $scope.entity.title;
        }
        $scope.schoolParent = 'territoryStatistics';
        SchoolResource.get({'id': schoolId}, function (result) {
            $scope.schoolName = result.name;
            $scope.territoryName = result.territory.name;
        });
    } else if (isDEC || isHeadTeacher || isDeputyHeadTeacher) {
        $scope.schoolName = $scope.entity.title;
        $scope.schoolParent = 'dashboard';
    }
    if (parallel) {
        $scope.levelName = parallel + ' классы';
    } else {
        switch (level) {
        case '1':
            $scope.levelName = 'Начальное';
            break;
        case '2':
            $scope.levelName = 'Основное';
            break;
        case '3':
            $scope.levelName = 'Среднее';
            break;
        }
        $scope.levelName += ' общее';
    }
    UserResource.getById({'userId': studentId}, function (result) {
        $scope.studentName = result.firstName + ' ' + (result.middleName ? result.middleName + ' ' : '') + result.lastName;
    });
}]);

'use strict';

app.controller('levelStatisticsTeachersCourseDashBarCtrl', ['$scope', '$state', 'userAccount', 'SchoolResource', 'CourseResource', 'LearningClassResource', 'UserResource', function ($scope, $state, userAccount, SchoolResource, CourseResource, LearningClassResource, UserResource) {
    var currentRole = userAccount.userRoles[0],
        isDEC = (currentRole === 'ROLE_DISTANCE_EDUCATION_COORDINATOR'),
        isRegionalCoordinator = (currentRole === 'ROLE_REGIONAL_COORDINATOR'),
        isTerritoryCoordinator = (currentRole === 'ROLE_TERRITORY_COORDINATOR'),
        isHeadTeacher = (currentRole === 'ROLE_HEAD_TEACHER'),
        isDeputyHeadTeacher = (currentRole === 'ROLE_DEPUTY_HEAD_TEACHER'),
        level = $state.params.levelNum,
        parallel = $state.params.parallelNum,
        schoolId = $state.params.schoolId,
        teacherId = $state.params.teacherId,
        tutorId = $state.params.tutorId;

    $scope.learningClasses = [];
    $scope.courses = [];
    $scope.stateName = $state.current.name;
    $scope.entity = $state.current.data.entity;

    //для хлебных крошек
    $scope.schoolName = null;
    $scope.teacherName = null;
    $scope.territoryName = null;
    if (isRegionalCoordinator || isTerritoryCoordinator) {
        if (isRegionalCoordinator) {
            $scope.territoryParent = 'regionStatistics';
            $scope.regionName = $scope.entity.title;
        }
        $scope.schoolParent = 'territoryStatistics';
        SchoolResource.get({'id': schoolId}, function (result) {
            $scope.schoolName = result.name;
            $scope.territoryName = result.territory.name;
        });
    } else if (isDEC || isHeadTeacher || isDeputyHeadTeacher) {
        $scope.schoolName = $scope.entity.title;
        $scope.schoolParent = 'dashboard';
    }
    if (parallel) {
        $scope.levelName = parallel + ' классы';
    } else {
        switch (level) {
        case '1':
            $scope.levelName = 'Начальное';
            break;
        case '2':
            $scope.levelName = 'Основное';
            break;
        case '3':
            $scope.levelName = 'Среднее';
            break;
        }
        $scope.levelName += ' общее';
    }
    LearningClassResource.getLearningClassesBySchoolIdAndLevel({
        schoolId: schoolId,
        level: level,
        parallel: parallel,
        teacher: teacherId,
        tutor: tutorId,
        current_year: $scope.stateName === 'levelStatisticsTeachersCourse'
    }, function (result) {
        $scope.learningClasses = result;
        $scope.learningClasses.some(function (learningClass) {
            if(learningClass.id == $state.params.learningClassId) {
                $scope.selectedLearningClass = learningClass;
            }
        });
    });

    CourseResource.getCoursesWithTeacher({
        'schoolId': schoolId,
        'level': level,
        'parallel': parallel,
        'teacher': teacherId
    }, function (result) {
        $scope.courses = result;
        $scope.courses.some(function (course) {
            if(course.id == $state.params.courseId) {
                $scope.selectedCourse = course;
            }
        });
    });

    $scope.goToLearningClass = function () {
        $state.go($scope.stateName, {
            learningClassId: $scope.selectedLearningClass ? $scope.selectedLearningClass.id : null
        });
    };

    $scope.goToCourse = function () {
        $state.go($scope.stateName, {
            courseId: $scope.selectedCourse ? $scope.selectedCourse.id : null
        });
    };
}]);

'use strict';

app.controller('MethodologistStatisticsCourseDashBarCtrl', ['$scope', '$state', 'Course', 'LearningClassResource', 'TopicResource', function ($scope, $state, Course, LearningClassResource, TopicResource) {
    $scope.entity = $state.current.data.entity;
    $scope.learningClasses = [];
    $scope.selectedLearningClass = null;

    //для хлебных крошек
    $scope.courseName = null;
    $scope.topicName = null;

    Course.getCourse($state.params.courseId).then(function (result) {
        $scope.courseName = result.name;
    });
    LearningClassResource.getAllRelatedToUser({
        course: $state.params.courseId
    }).$promise.then(function (result) {
        $scope.learningClasses = result;
        $scope.learningClasses.some(function (learningClass) {
            if(learningClass.id == $state.params.learningClassId) {
                $scope.selectedLearningClass = learningClass;
            }
        });
    });

    if ($state.current.name === 'methodologistStatisticsCourseTopic') {
        TopicResource.get({
            id: $state.params.topicId
        }).$promise.then(function (result) {
            if (!$state.params.lessonId) {
                $scope.topicName = 'Занятие ' + result.number + '. ' + result.name;
            } else {
                result.lessons.some(function (lesson) {
                    if (lesson.id == $state.params.lessonId) {
                        $scope.topicName = 'Интернет-урок ' + lesson.number + '. ' + lesson.name;
                        return true;
                    }
                });
            }
        });
    }

    $scope.goToLearningClass = function () {
        $state.go($state.current.name, {
            learningClassId: $scope.selectedLearningClass ? $scope.selectedLearningClass.id : null
        });
    };
}]);

'use strict';

app.controller('MethodologistStatisticsDashBarCtrl', ['$scope', '$state', 'SchoolResource', function ($scope, $state, SchoolResource) {
    $scope.entity = $state.current.data.entity;
    $scope.teachers = [];
    $scope.selectedTeacher = null;
    $scope.schools = [];
    $scope.selectedSchool = null;

    SchoolResource.getByCoordinator().$promise.then(function (result) {
        $scope.schools = result;
        $scope.schools.forEach(function (school) {
            if (school.id == $state.params.schoolId) {
                $scope.selectedSchool = school;
                SchoolResource.get({
                    id: $scope.selectedSchool.id
                }).$promise.then(function (result) {
                    $scope.teachers = result.teachers;
                    $scope.teachers.forEach(function (teacher) {
                        if (teacher.id == $state.params.teacherId) {
                            $scope.selectedTeacher = teacher;
                        }
                    });
                });
            }
        });
    });

    $scope.changeTeacher = function () {
        $state.go('methodologistStatistics', {
            teacherId: $scope.selectedTeacher ? $scope.selectedTeacher.id : null
        });
    };

    $scope.goToSchool = function () {
        $state.go('methodologistStatistics', {
            schoolId: $scope.selectedSchool ? $scope.selectedSchool.id : null
        });
    };
}]);

'use strict';

app.controller('TeacherStatisticsCourseDashBarCtrl', ['$scope', '$state', 'CourseResource', 'LearningClassResource', function ($scope, $state, CourseResource, LearningClassResource) {
    var courseId = $state.params.courseId,
        learningClassId = $state.params.learningClassId;

    $scope.learningClasses = [];
    $scope.courses = [];
    $scope.selectedLearningClass = null;
    $scope.selectedCourse = null;
    $scope.entity = $state.current.data.entity;
    $scope.stateName = $state.current.name;

    //для хлебных крошек
    $scope.courseName = null;

    LearningClassResource.getAllRelatedToUser().$promise.then(function (result) {
        $scope.learningClasses = result;
        $scope.learningClasses.some(function (learningClass) {
            if(learningClass.id == learningClassId) {
                $scope.selectedLearningClass = learningClass;
            }
        });
    });
    CourseResource.getAllRelatedToUser({
        learningClassId: learningClassId
    }).$promise.then(function (result) {
        $scope.courses = result;
        $scope.courses.some(function (course) {
            if(course.id == courseId) {
                $scope.selectedCourse = course;
                $scope.courseName = $scope.selectedCourse.name;
            }
        });
    });

    $scope.goToLearningClass = function () {
        $state.go($scope.stateName, {
            learningClassId: $scope.selectedLearningClass ? $scope.selectedLearningClass.id : null
        });
    };

    $scope.goToCourse = function () {
        $state.go($scope.stateName, {
            courseId: $scope.selectedCourse ? $scope.selectedCourse.id : null
        });
    };
}]);

'use strict';

app.controller('TeacherStatisticsCourseStudentDashBarCtrl', ['$scope', '$state', 'Course', 'UserResource', function ($scope, $state, Course, UserResource) {
    var stateName = $state.current.name;

    $scope.entity = $state.current.data.entity;

    //для хлебных крошек
    $scope.courseName = null;
    $scope.studentName = null;

    Course.getCourse($state.params.courseId).then(function (result) {
        $scope.courseName = result.name;
    });

    UserResource.getById({
        userId: $state.params.studentId
    }).$promise.then(function (result) {
        $scope.studentName = result.firstName + ' ' + result.lastName;
    });

    $scope.goToJournal = function () {
        $state.go('detailsJournal', {
            groupId: $state.params.groupId,
            courseId: $state.params.courseId,
            studentId: $state.params.studentId,
            schoolId: $state.params.schoolId
        });
    };
}]);

'use strict';

app.controller('TeacherStatisticsDashBarCtrl', ['$scope', '$state', function ($scope, $state) {
    $scope.entity = $state.current.data.entity;
}]);

'use strict';

app.controller('levelStatisticsCoursesCourseCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.topics = [];
    $scope.loaded = false;

    $scope.exportToExel = exportToExel;

    StatisticsResource.getTopicsByCourse({
        schoolId: $state.params.schoolId,
        courseId: $state.params.courseId,
        'class': $state.params.learningClassId
    }).$promise.then(function (result) {
        $scope.topics = result ? $filter('orderBy')(result, 'number', false) : [];
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    function exportToExel() {
        exelExport.load(function() {
            var i,
                headerFirstLine,
                table,
                row;

            headerFirstLine = ['Перечень Тематических занятий (ТЗ)', '«5»', '«4»', '«3»', '«2»', '«Не закончили изучать ТЗ»', '«Не приступили к изучению ТЗ»'];
            table=[headerFirstLine];
            for (i = 0; i < $scope.topics.length; i++) {
                row = [];
                row.push('Занятие ' + $scope.topics[i].number + '. ' + $scope.topics[i].title);
                row.push($filter('setDecimal')($scope.topics[i].mark5, 2) + '%');
                row.push($filter('setDecimal')($scope.topics[i].mark4, 2) + '%');
                row.push($filter('setDecimal')($scope.topics[i].mark3, 2) + '%');
                row.push($filter('setDecimal')($scope.topics[i].mark2, 2) + '%');
                row.push($filter('setDecimal')($scope.topics[i].notFinished, 2) + '%');
                row.push($filter('setDecimal')($scope.topics[i].notStarted, 2) + '%');
                table.push(row);
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.1.1.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('LevelStatisticsCoursesCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.courses = [];
    $scope.loaded = false;

    $scope.exportToExel = exportToExel;

    StatisticsResource.getCoursesByLevel({
        schoolId: $state.params.schoolId,
        level: $state.params.levelNum,
        parallel: $state.params.parallelNum
    }).$promise.then(function (result) {
        $scope.courses = result ? $filter('orderBy')(result, 'title', false) : [];
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    function exportToExel() {
        exelExport.load(function() {
            var i,
                headerFirstLine,
                table,
                row;

            headerFirstLine = ['№', 'Название курса', 'Количество учащихся', 'Количество учителей', 'Количество классов', 'Средний балл учащихся по курсу'];
            table=[headerFirstLine];
            for (i = 0; i < $scope.courses.length; i++) {
                row = [];
                row.push(i+1);
                row.push($scope.courses[i].title);
                row.push($scope.courses[i].countStudents);
                row.push($scope.courses[i].countTeachers);
                row.push($scope.courses[i].countClasses);
                row.push($filter('setDecimal')($scope.courses[i].averageCourseMark, 2));

                table.push(row);
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.1.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('LevelStatisticsLearningClassesCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport', 'setDecimalFilter',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport, setDecimalFilter) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.learningClasses = [];
        $scope.loaded = false;

        StatisticsResource.getLearningClassesByLevel({
            schoolId: $state.params.schoolId,
            level: $state.params.levelNum,
            parallel: $state.params.parallelNum
        }).$promise.then(function (result) {
            $scope.learningClasses = result ? $filter('orderBy')(result, 'name', false) : [];
            /*$scope.learningClasses.forEach(function (learningClass) {
                if (learningClass.courses) {
                    learningClass.courses = $filter('orderBy')(result, '???', false);
                }
            });*/
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i, j,
                    headerFirstLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Класс', 'Курсы', 'Кол-во учащихся', 'Средний балл за курс', 'Ф.И.О. и контактные данные учителя', null, 'Ф.И.О. и контактные данные тьютора', null];
                table = [headerFirstLine];
                for (i = 0; i < $scope.learningClasses.length; i++) {
                    for (j = 0; j < $scope.learningClasses[i].courses.length; j++) {
                        row = [];
                        if (j === 0) {
                            row.push(i + 1);
                            row.push($scope.learningClasses[i].name);
                        } else {
                            row.push(null);
                            row.push(null);
                        }
                        row.push($scope.learningClasses[i].courses[j].title + $scope.learningClasses[i].parallel + ' класс');
                        row.push($scope.learningClasses[i].courses[j].countStudents);
                        row.push(setDecimalFilter($scope.learningClasses[i].courses[j].averageCourseMark, 2));
                        if ($scope.learningClasses[i].courses[j].teacher !== void 0) {
                            row.push($scope.learningClasses[i].courses[j].teacher.user.firstName + ' ' +
                                $scope.checkAttr($scope.learningClasses[i].courses[j].teacher.user.middleName) + ' ' +
                                $scope.learningClasses[i].courses[j].teacher.user.lastName + ' ' +
                                $scope.learningClasses[i].courses[j].teacher.user.email + ' ' +
                                $scope.checkAttr($scope.learningClasses[i].courses[j].teacher.user.mobilePhone));
                            row.push(null);
                        } else {
                            row.push(null);
                            row.push(null);
                        }
                        if (j === 0) {
                            if ($scope.learningClasses[i].tutor !== void 0) {
                                row.push($scope.learningClasses[i].tutor.user.firstName + ' ' +
                                    $scope.checkAttr($scope.learningClasses[i].tutor.user.middleName) + ' ' +
                                    $scope.learningClasses[i].tutor.user.lastName + ' ' +
                                    $scope.learningClasses[i].tutor.user.email + ' ' +
                                    $scope.checkAttr($scope.learningClasses[i].tutor.mobilePhone));
                                row.push(null);
                            } else {
                                row.push(null);
                                row.push(null);
                            }
                        } else {
                            row.push(null);
                            row.push(null);
                        }
                        table.push(row);
                    }
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.2.xlsx',
                    ranges: []
                });
            });
        };

    }]);

'use strict';

app.controller('LevelStatisticsMethodologistsCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.methodologists = [];
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getMethodologistsByLevel({
            schoolId: $state.params.schoolId,
            level: $state.params.levelNum,
            parallel: $state.params.parallelNum,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.methodologists = result ? $filter('orderBy')(result, 'user.user.lastName', false) : [];
            $scope.methodologists.forEach(function (methodologist) {
                methodologist.spentTime = methodologist.spentTime ? moment.duration(methodologist.spentTime) : moment.duration(0);
            });
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.checkAttr = function(attr){
        if (attr !== void 0 && attr !== null){
            return attr;
        }else{
            return '';
        }
    };

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var i,
                headerFirstLine,
                headerSecondLine,
                table,
                row;

            headerFirstLine = ['№', 'Ф.И.О. и контактные данные методиста', 'Количество курсов', 'Количество проведенных конференций',
                'Количество личных сообщений', 'Количество входов в систему', 'Количество времени работы в системе', 'Последний вход в систему'];
            table=[headerFirstLine];

            for (i = 0; i < $scope.methodologists.length; i++) {
                row = [];
                row.push(i + 1);
                row.push($scope.methodologists[i].user.user.firstName + ' ' +
                    $scope.checkAttr($scope.methodologists[i].user.user.middleName) + ' ' +
                    $scope.methodologists[i].user.user.lastName + ' ' +
                    $scope.methodologists[i].user.user.email + ' ' + $scope.checkAttr($scope.methodologists[i].user.mobilePhone));
                row.push($scope.methodologists[i].countCourses);
                row.push($scope.methodologists[i].countConferences);
                row.push($scope.methodologists[i].countMessagesToTeacher + '/' + $scope.methodologists[i].countMessagesToKDO);
                row.push($scope.methodologists[i].successfulLoginAttempts ? $scope.methodologists[i].successfulLoginAttempts : 0);
                row.push($scope.methodologists[i].spentTime.hours() + ' ч. ' + $scope.methodologists[i].spentTime.minutes() + ' м.');
                row.push($filter('date')($scope.methodologists[i].lastLogin, 'dd MMM  yyyy'));
                table.push(row);
            }

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.4.xlsx',
                ranges: []
            });
        });
    };

}]);

'use strict';

app.controller('LevelStatisticsParentsCtrl', ['$scope', '$state','$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state,$filter, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.parents = [];
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getParentsByLevel({
            schoolId: $state.params.schoolId,
            level: $state.params.levelNum,
            parallel: $state.params.parallelNum,
            'class': $state.params.learningClassId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.parents = result ? $filter('orderBy')(result, 'user.user.lastName', false) : [];
            $scope.parents.forEach(function (parent) {
                parent.spentTime = parent.spentTime ? moment.duration(parent.spentTime) : moment.duration(0);
            });
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i,
                    headerFirstLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Ф.И.О. и контактные данные родителя', 'Количество детей', 'Количество курсов',
                    'Количество входов в систему','Количество времени работы в системе', 'Последний вход в систему'];
                table = [headerFirstLine];

                for (i = 0; i < $scope.parents.length; i++) {
                    row = [];
                    row.push(i + 1);
                    row.push($scope.parents[i].user.user.firstName + ' ' +
                        $scope.checkAttr($scope.parents[i].user.user.middleName) +
                        $scope.parents[i].user.user.lastName + ' ' +
                        $scope.parents[i].user.user.email + ' ' + $scope.checkAttr($scope.parents[i].user.mobilePhone));
                    row.push($scope.parents[i].countStudents);
                    row.push($scope.parents[i].countCourses);
                    row.push($scope.parents[i].successfulLoginAttempts ? $scope.parents[i].successfulLoginAttempts : 0);
                    row.push($scope.parents[i].spentTime.hours() + ' ч. ' + $scope.parents[i].spentTime.minutes() + ' м.');
                    row.push($filter('date')($scope.parents[i].lastLogin, 'dd MMM  yyyy'));
                    table.push(row);
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.8.xlsx',
                    ranges: []
                });
            });
        };

}]);

'use strict';

app.controller('LevelStatisticsPsychologistsCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.psychologists = [];
        $scope.loaded = false;

        $scope.loadAll = function (startDateTime, endDateTime) {
            StatisticsResource.getPsychologistsByLevel({
                schoolId: $state.params.schoolId,
                level: $state.params.levelNum,
                parallel: $state.params.parallelNum,
                since: startDateTime,
                until: endDateTime
            }).$promise.then(function (result) {
                    $scope.psychologists = result ? $filter('orderBy')(result, 'user.user.lastName', false) : [];
                    $scope.psychologists.forEach(function (psychologist) {
                        psychologist.spentTime = psychologist.spentTime ? moment.duration(psychologist.spentTime) : moment.duration(0);
                    });
                    $scope.loaded = true;
                }, function (reason) {
                    $state.go('404');
                });
        };

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i,
                    headerFirstLine,
                    headerSecondLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Ф.И.О. и контактные данные психолога', 'Количество классов', 'Количество учащихся',
                    'Количество проведенных конференций', 'Количество личных сообщений', 'Количество входов в систему',
                    'Количество времени работы в системе', 'Последний вход в систему'];
                table = [headerFirstLine];

                for (i = 0; i < $scope.psychologists.length; i++) {
                    row = [];
                    row.push(i + 1);
                    row.push($scope.psychologists[i].user.user.firstName + ' ' +
                        $scope.checkAttr($scope.psychologists[i].user.user.middleName) + ' ' +
                        $scope.psychologists[i].user.user.lastName + ' ' +
                        $scope.psychologists[i].user.user.email + ' ' + $scope.checkAttr($scope.psychologists[i].user.mobilePhone));
                    row.push($scope.psychologists[i].countClasses);
                    row.push($scope.psychologists[i].countStudents);
                    row.push($scope.psychologists[i].countConferences);
                    row.push($scope.psychologists[i].countMessagesToStudent + '/' +
                        $scope.psychologists[i].countMessagesToParent + '/' +
                        $scope.psychologists[i].countMessagesToTutor + '/' +
                        $scope.psychologists[i].countMessagesToTeacher + '/' +
                        $scope.psychologists[i].countMessagesToKDO);
                    row.push($scope.psychologists[i].successfulLoginAttempts ? $scope.psychologists[i].successfulLoginAttempts : 0);
                    row.push($scope.psychologists[i].spentTime.hours() + ' ч. ' + $scope.psychologists[i].spentTime.minutes() + ' м.');
                    row.push($filter('date')($scope.psychologists[i].lastLogin, 'dd MMM  yyyy'));
                    table.push(row);
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.6.xlsx',
                    ranges: []
                });
            });
        };
    }]);

'use strict';

app.controller('LevelStatisticsStudentsCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.students = [];
        $scope.loaded = false;

        $scope.loadAll = function (startDateTime, endDateTime) {
            StatisticsResource.getStudentsByLevel({
                schoolId: $state.params.schoolId,
                level: $state.params.levelNum,
                parallel: $state.params.parallelNum,
                'class': $state.params.learningClassId,
                since: startDateTime,
                until: endDateTime
            }).$promise.then(function (result) {
                    $scope.students = result ? $filter('orderBy')(result, 'man.lastName', false) : [];
                    $scope.students.forEach(function (student) {
                        student.spentTime = student.spentTime ? moment.duration(student.spentTime) : moment.duration(0);
                    });
                    $scope.loaded = true;
                }, function (reason) {
                    $state.go('404');
                });
        };

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i, j,
                    headerFirstLine,
                    headerSecondLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Ф.И.О. учащегося', 'Класс', 'Количество курсов', 'Количество входов в систему',
                    'Количество времени работы в системе', 'Последний вход в систему', 'ФИО родителей и контактная информация', null, null];
                table = [headerFirstLine];

                for (i = 0; i < $scope.students.length; i++) {
                    row = [];
                    row.push(i + 1);
                    row.push($scope.students[i].man.firstName + ' ' +
                        $scope.checkAttr($scope.students[i].man.middleName) + ' ' +
                        $scope.students[i].man.lastName);
                    row.push($scope.students[i].className);
                    row.push($scope.students[i].countCourses);
                    row.push($scope.students[i].successfulLoginAttempts ? $scope.students[i].successfulLoginAttempts : 0);
                    row.push($scope.students[i].spentTime.hours() + ' ч. ' + $scope.students[i].spentTime.minutes() + ' м.');
                    row.push($filter('date')($scope.students[i].lastLogin, 'dd MMM  yyyy'));
                    if ($scope.students[i].parents !== void 0) {
                        var dataParents = '';
                        for (j = 0; j < $scope.students[i].parents.length; j++) {
                            dataParents += $scope.checkAttr($scope.students[i].parents[j].user.firstName) + ' ' +
                                $scope.checkAttr($scope.students[i].parents[j].user.middleName) + ' ' +
                                $scope.students[i].parents[j].user.lastName + ' ' + $scope.students[i].parents[j].user.email +
                                $scope.checkAttr($scope.students[i].parents[j].mobilePhone);
                            if (j !== $scope.students[i].parents.length - 1) {
                                dataParents += ', ';
                            }

                        }
                        row.push(dataParents);
                        row.push(null);
                        row.push(null);
                    }
                    table.push(row);
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.7.xlsx',
                    ranges: []
                });
            });
        };

    }]);

'use strict';

app.controller('LevelStatisticsStudentsStudentCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.courses = [];
        $scope.tutor = null;
        $scope.loaded = false;

        $scope.loadAll = function (startDateTime, endDateTime) {
            StatisticsResource.getCoursesForStudent({
                schoolId: $state.params.schoolId,
                studentId: $state.params.studentId,
                since: startDateTime,
                until: endDateTime
            }).$promise.then(function (result) {
                    $scope.courses = result.progresses ? $filter('orderBy')(result.progresses, 'courseName', false) : [];
                    $scope.tutor = result.user;
                    $scope.loaded = true;
                }, function (reason) {
                    $state.go('404');
                });
        };

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i, j,
                    headerFirstLine,
                    headerSecondLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Название курса', 'Кол-во тематических занятий', 'Количество переназначенных ИУ', 'Кол-во заданий  к занятию',
                    'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Cредний балл за задания к занятию',
                    'Средний балл за тесты', 'Cредний балл за ЗОО', 'Cредний балл за ДЗ', 'Кол-во комментариев учащегося в Рабочей тетради',
                    'Ф.И.О. и контактные данные учителя'];
                table = [headerFirstLine];

                for (i = 0; i < $scope.courses.length; i++) {
                    row = [];
                    row.push(i + 1);
                    row.push($scope.courses[i].courseName);
                    row.push($scope.courses[i].allTopics + '/' + $scope.courses[i].performedTopics);
                    row.push($scope.courses[i].reassignment);
                    row.push($scope.courses[i].performedTopicTasks + '/' + $scope.courses[i].doneTopicTasks +
                        '/' + $scope.courses[i].showTopicTasks);
                    row.push($scope.courses[i].allQuizzes + '/' + $scope.courses[i].doneQuizzes);
                    row.push($scope.courses[i].rightFieldAssignments + '/' + $scope.courses[i].performedOpenTasks +
                        '/' + $scope.courses[i].doneOpenTasks);
                    row.push($scope.courses[i].homeAssignments + '/' + $scope.courses[i].performedHomeAssignments +
                        '/' + $scope.courses[i].doneHomeAssignments);
                    row.push($filter('setDecimal')($scope.courses[i].averageTopicMark, 2));
                    row.push($filter('setDecimal')($scope.courses[i].averageTopicAssignmentMark, 2));
                    row.push($filter('setDecimal')($scope.courses[i].averageQuizMark, 2));
                    row.push($filter('setDecimal')($scope.courses[i].averageOpenTaskMark, 2));
                    row.push($filter('setDecimal')($scope.courses[i].averageHomeMark, 2));
                    row.push($scope.courses[i].countComments);
                    if ($scope.courses[i].teacher !== void 0 && $scope.courses[i].teacher !== null) {
                        row.push($scope.courses[i].teacher.user.firstName + ' ' +
                            $scope.checkAttr($scope.courses[i].teacher.user.middleName) + ' ' +
                            $scope.courses[i].teacher.user.lastName + ' ' +
                            $scope.courses[i].teacher.user.email + ' ' + $scope.checkAttr($scope.courses[i].teacher.mobilePhone));
                    }
                    table.push(row);
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.7.1.xlsx',
                    ranges: []
                });
            });
        };
    }]);

'use strict';

app.controller('LevelStatisticsTeachersCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
        $scope.ncyBreadcrumbIgnore = true;
        $scope.teachers = [];
        $scope.loaded = false;

        $scope.loadAll = function (startDateTime, endDateTime) {
            StatisticsResource.getTeachersByLevel({
                schoolId: $state.params.schoolId,
                level: $state.params.levelNum,
                parallel: $state.params.parallelNum,
                course: $state.params.courseId,
                since: startDateTime,
                until: endDateTime
            }).$promise.then(function (result) {
                    $scope.teachers = result ? $filter('orderBy')(result, 'user.user.lastName', false) : [];
                    $scope.teachers.forEach(function (teacher) {
                        teacher.spentTime = teacher.spentTime ? moment.duration(teacher.spentTime) : moment.duration(0);
                        if (teacher.courses) {
                            teacher.courses = $filter('orderBy')(teacher.courses, 'title', false);
                        }
                    });
                    $scope.loaded = true;
                }, function (reason) {
                    $state.go('404');
                });
        };

        $scope.openDialog = function (user) {
            Dialogs.createIndividualDialog(user);
        };

        $scope.checkAttr = function (attr) {
            if (attr !== void 0 && attr !== null) {
                return attr;
            } else {
                return '';
            }
        };

        $scope.exportToExel = function () {
            exelExport.load(function () {
                var i, j,
                    headerFirstLine,
                    table,
                    row;

                headerFirstLine = ['№', 'Ф.И.О. и контактные данные учителя', 'Кол-во курсов', 'Название курса', 'Кол-во классов', 'Кол-во учащихся',
                    'Средний балл по курсу', 'Кол-во заданий к занятию', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Кол-во комментариев учителя в Рабочей тетради',
                    'Кол-во проведенных конференций','Количество входов в систему', 'Количество времени работы в системе', 'Последний вход в систему'];
                table = [headerFirstLine];
                for (i = 0; i < $scope.teachers.length; i++) {
                    for (j = 0; j < $scope.teachers[i].courses.length; j++) {
                        row = [];
                        if (j === 0) {
                            row.push(i + 1);
                            row.push($scope.teachers[i].user.user.firstName + ' ' + $scope.checkAttr($scope.teachers[i].user.user.middleName) +
                            ' ' + $scope.teachers[i].user.user.lastName + ' ' +
                            $scope.teachers[i].user.user.email + ' ' + $scope.checkAttr($scope.teachers[i].user.mobilePhone));
                            row.push($scope.teachers[i].courses.length);
                        } else {
                            row.push(null);
                            row.push(null);
                            row.push(null);
                        }
                        row.push($scope.teachers[i].courses[j].title);
                        row.push($scope.teachers[i].courses[j].countClasses);
                        row.push($scope.teachers[i].courses[j].countStudents);
                        row.push($filter('setDecimal')($scope.teachers[i].courses[j].averageCourseMark, 2));
                        row.push($scope.teachers[i].courses[j].performedTopicTasks + '/' +
                                $scope.teachers[i].courses[j].doneTopicTasks + '/' +
                                $scope.teachers[i].courses[j].showTopicTasks);
                        row.push($scope.teachers[i].courses[j].rightFieldAssignments + '/' +
                            $scope.teachers[i].courses[j].performedOpenTasks + '/' +
                            $scope.teachers[i].courses[j].doneOpenTasks);
                        row.push($scope.teachers[i].courses[j].homeAssignments + '/' +
                            $scope.teachers[i].courses[j].performedHomeAssignments + '/' +
                            $scope.teachers[i].courses[j].doneHomeAssignments);
                        row.push($scope.teachers[i].courses[j].countComments);

                        if (j === 0) {
                            row.push($scope.teachers[i].countConferences);
                            row.push($scope.teachers[i].successfulLoginAttempts ? $scope.teachers[i].successfulLoginAttempts : 0);
                            row.push($scope.teachers[i].spentTime.hours() + ' ч. ' +
                                $scope.teachers[i].spentTime.minutes() + ' м.');
                            row.push($filter('date')($scope.teachers[i].lastLogin, 'dd MMM  yyyy'));
                        } else {
                            row.push(null);
                            row.push(null);
                            row.push(null);
                            row.push(null);
                        }
                        table.push(row);
                    }
                }
                exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                    fileName: 'manager_stat_3.1.3.xlsx',
                    ranges: []
                });
            });
        };
    }]);

'use strict';

app.controller('levelStatisticsTeachersCourseCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $filter, $state, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.teacher = null;
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getStudentsByTeacherAndCourse({
            schoolId: $state.params.schoolId,
            teacherId: $state.params.teacherId,
            courseId: $state.params.courseId,
            level: $state.params.levelNum,
            parallel: $state.params.parallelNum,
            'class' : $state.params.learningClassId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.students = result.students ? $filter('orderBy')(result.students, 'student.lastname', false) : [];
            $scope.teacher = result.teacher;
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    function exportToExel() {
        exelExport.load(function () {
            var i,
                headerFirstLine,
                table;

            headerFirstLine = ['№', 'Ф.И.О. учащегося', 'Название класса', 'Кол-во тематических занятий', 'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во тестов "Проверь себя"', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Средний балл за задания к занятию', 'Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ', 'Кол-во комментариев учителя в рабочей тетради'];
            table=[headerFirstLine];

            for (i = 0; i < $scope.students.length; i++) {
                var row = [];
                row.push(i + 1);
                row.push($scope.students[i].student.firstName + ' ' +
                    ($scope.students[i].student.middleName ? $scope.students[i].student.middleName + ' ' : '') +
                    $scope.students[i].student.lastName);
                row.push($scope.students[i].className);
                row.push($scope.students[i].allTopics + '/' +
                    $scope.students[i].performedTopics);
                row.push($scope.students[i].reassignment);
                row.push($scope.students[i].performedTopicTasks + '/' +
                    $scope.students[i].doneTopicTasks + '/' +
                    $scope.students[i].showTopicTasks);
                row.push($scope.students[i].allQuizzes + '/' +
                    $scope.students[i].doneQuizzes);
                row.push($scope.students[i].rightFieldAssignments + '/' +
                    $scope.students[i].performedOpenTasks + '/' +
                    $scope.students[i].doneOpenTasks);
                row.push($scope.students[i].homeAssignments + '/' +
                    $scope.students[i].performedHomeAssignments + '/' +
                    $scope.students[i].doneHomeAssignments);
                row.push($filter('setDecimal')($scope.students[i].averageTopicMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageTopicAssignmentMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageQuizMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageOpenTaskMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageHomeMark, 2));
                row.push($scope.students[i].countComments);
                table.push(row);
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР 2 для курса',
                fileName: 'manager_stat_3.1.3.1.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('LevelStatisticsTutorsCtrl', ['$scope', '$state','$filter', 'StatisticsResource', 'Dialogs', 'exelExport',
    function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.tutors = [];
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getTutorsByLevel({
            schoolId: $state.params.schoolId,
            level: $state.params.levelNum,
            parallel: $state.params.parallelNum,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.tutors = result ? $filter('orderBy')(result, 'user.user.lastName', false) : [];
            $scope.tutors.forEach(function (tutor) {
                tutor.spentTime = tutor.spentTime ? moment.duration(tutor.spentTime) : moment.duration(0);
            });
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.checkAttr = function(attr){
        if (attr !== void 0 && attr !== null) {
            return attr;
        } else {
            return '';
        }
    };

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var i,
                headerFirstLine,
                headerSecondLine,
                table,
                row;

            headerFirstLine = ['№', 'Ф.И.О. и контактные данные тьютора', 'Количество классов', 'Количество учащихся',
                'Количество проведенных конференций', 'Количество личных сообщений', 'Количество входов в систему',
                'Количество времени работы в системе', 'Последний вход в систему' ];
            table=[headerFirstLine];

            for (i = 0; i < $scope.tutors.length; i++) {
                row = [];
                row.push(i + 1);
                row.push($scope.tutors[i].user.user.firstName + ' ' +
                    $scope.checkAttr($scope.tutors[i].user.user.middleName) + ' ' +
                    $scope.tutors[i].user.user.lastName + ' ' +
                    $scope.tutors[i].user.user.email + ' ' + $scope.checkAttr($scope.tutors[i].user.mobilePhone));
                row.push($scope.tutors[i].countClasses);
                row.push($scope.tutors[i].countStudents);
                row.push($scope.tutors[i].countConferences);
                row.push($scope.tutors[i].countMessages);
                row.push($scope.tutors[i].successfulLoginAttempts ? $scope.tutors[i].successfulLoginAttempts : 0);
                row.push($scope.tutors[i].spentTime.hours() + ' ч. ' + $scope.tutors[i].spentTime.minutes() + ' м.');
                row.push($filter('date')($scope.tutors[i].lastLogin, 'dd MMM  yyyy'));
                table.push(row);
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.5.xlsx',
                ranges: []
            });
        });
    };
}]);

'use strict';

app.controller('LevelStatisticsTutorsTutorCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $state, $filter, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.tutor = null;
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getStudentsForTutor({
            schoolId: $state.params.schoolId,
            level: $state.params.levelNum,
            tutorId: $state.params.tutorId,
            parallel: $state.params.parallelNum,
            course: $state.params.courseId,
            'class': $state.params.learningClassId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.students = result.students ? $filter('orderBy')(result.students, 'man.lastname', false) : [];
            $scope.students.forEach(function (student) {
                if (student.progresses) {
                    student.progresses = $filter('orderBy')(student.progresses, 'courseName', false);
                }
            });
            $scope.tutor = result.user;
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function (user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.checkAttr = function(attr){
        if (attr !== void 0 && attr !== null) {
            return attr;
        } else {
            return '';
        }
    };

    function exportToExel() {
        exelExport.load(function () {
            var i,
                headerFirstLine,
                table,
                row,
                ranges = [],
                counter = 1;

            headerFirstLine = ['№', 'Ф.И.О. учащегося', 'Название класса', 'Кол-во курсов',
                'Название курса', 'Кол-во тематических занятий', 'Кол-во переназначенных ИУ',
                'Кол-во заданий к занятию', 'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Средний балл за задания к занятию', 'Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ', 'Кол-во личных сообщений'];
            table = [headerFirstLine];
            for (var j = 0; j < $scope.students.length; j++) {
                for (i = 0; i < $scope.students[j].progresses.length; i++) {
                    row = [];
                    if (i === 0) {
                        row.push(j + 1);
                        row.push($scope.students[j].man.firstName + ' ' +
                            $scope.checkAttr($scope.students[j].man.middleName) + ' ' +
                            $scope.students[j].man.lastName);
                        row.push($scope.students[j].className);
                        row.push($scope.students[j].progresses.length);
                    } else {
                        for (var k = 0; k < 4; k++) {
                            row.push(null);
                        }
                    }
                    row.push($scope.students[j].progresses[i].courseName);
                    row.push($scope.students[j].progresses[i].allTopics + '/' +
                        $scope.students[j].progresses[i].performedTopics);
                    row.push($scope.students[j].progresses[i].reassignment);
                    row.push($scope.students[j].progresses[i].performedTopicTasks + '/' +
                        $scope.students[j].progresses[i].doneTopicTasks + '/' +
                        $scope.students[j].progresses[i].showTopicTasks);
                    row.push($scope.students[j].progresses[i].allQuizzes + '/' +
                        $scope.students[j].progresses[i].doneQuizzes);
                    row.push($scope.students[j].progresses[i].rightFieldAssignments + '/' +
                        $scope.students[j].progresses[i].performedOpenTasks + '/' +
                        $scope.students[j].progresses[i].doneOpenTasks);
                    row.push($scope.students[j].progresses[i].homeAssignments + '/' +
                        $scope.students[j].progresses[i].performedHomeAssignments + '/' +
                        $scope.students[j].progresses[i].doneHomeAssignments);
                    row.push($filter('setDecimal')($scope.students[j].progresses[i].averageTopicMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].progresses[i].averageTopicAssignmentMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].progresses[i].averageQuizMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].progresses[i].averageOpenTaskMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].progresses[i].averageHomeMark, 2));
                    row.push($scope.students[j].progresses[i].countComments);
                    table.push(row);
                }
                var oldCounter = counter;
                counter = (counter + $scope.students[j].progresses.length) - 1;
                ranges.push({s: {c: 0, r: oldCounter}, e: {c: 0, r: counter}},
                    {s: {c: 1, r: oldCounter}, e: {c: 1, r: counter}},
                    {s: {c: 2, r: oldCounter}, e: {c: 2, r: counter}},
                    {s: {c: 3, r: oldCounter}, e: {c: 3, r: counter}},
                    {s: {c: 19, r: oldCounter}, e: {c: 19, r: counter}});
                counter++;
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.5.1.xlsx',
                ranges: ranges
            });
        });
    }
}]);

'use strict';

app.controller('ManagerStatisticsCtrl', ['$scope', '$state', '$filter', 'StatisticsResource', 'exelExport', function ($scope, $state, $filter, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.levels = [];
    $scope.total = null;
    $scope.loaded = false;

    $scope.exportToExel = exportToExel;

    StatisticsResource.getEducationLevelsBySchool({'schoolId':$state.params.schoolId}).$promise.then(function (result) {
        $scope.levels = result.levels ?  $filter('orderBy')(result.levels, 'number', false) : [];
        $scope.levels.forEach(function (level) {
            if (level.parallels) {
                level.parallels = $filter('orderBy')(level.parallels, 'classParallel', false);
            }
        });
        $scope.total = result.total;
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    function exportToExel() {
        exelExport.load(function() {
            var i, j,
                headerFirstLine,
                headerSecondLine,
                table,
                row;

            headerFirstLine = ['Уровни общего образования', null, 'Количество', null, null, null, null, null,null,null];
            headerSecondLine=[null, null, 'Курсов', 'Классов', 'Учителей', 'Методистов', 'Тьюторов', 'Психологов', 'Учащихся', 'Родителей'];
            table=[headerFirstLine];
            table.push(headerSecondLine);

            for (i = 0; i < $scope.levels.length; i++) {
                if ($scope.levels[i].parallels) {
                    row = [];
                    row.push($scope.levels[i].title);
                    row.push(null);
                    row.push($scope.levels[i].countCourses + ' / ' +
                        $scope.levels[i].countPeopleInCourse);
                    row.push($scope.levels[i].countClasses);
                    row.push($scope.levels[i].countTeachers);
                    row.push($scope.levels[i].countMethodologists);
                    row.push($scope.levels[i].countTutors);
                    row.push($scope.levels[i].countPsychologists);
                    row.push($scope.levels[i].countStudents);
                    row.push($scope.levels[i].countParents);
                    table.push(row);
                    for (j = 0; j < $scope.levels[i].parallels.length; j++) {
                        var classRow = [];
                        classRow.push(null);
                        classRow.push($scope.levels[i].parallels[j].classParallel + ' классы');
                        classRow.push($scope.levels[i].parallels[j].countCourses + ' / ' +
                            $scope.levels[i].parallels[j].countPeopleInCourses);
                        classRow.push($scope.levels[i].parallels[j].countClasses);
                        classRow.push($scope.levels[i].parallels[j].countTeachers);
                        classRow.push($scope.levels[i].parallels[j].countMethodologists);
                        classRow.push($scope.levels[i].parallels[j].countTutors);
                        classRow.push($scope.levels[i].parallels[j].countPsychologists);
                        classRow.push($scope.levels[i].parallels[j].countStudents);
                        classRow.push($scope.levels[i].parallels[j].countParents);
                        table.push(classRow);
                    }
                }
            }
            var totalRow = [];
            totalRow.push('ИТОГО');
            totalRow.push(null);
            totalRow.push($scope.total.courses + ' / ' +
                $scope.total.peopleInCourses);
            totalRow.push($scope.total.classes);
            totalRow.push($scope.total.teachers);
            totalRow.push($scope.total.methodologists);
            totalRow.push($scope.total.tutors);
            totalRow.push($scope.total.psychologists);
            totalRow.push($scope.total.students);
            totalRow.push($scope.total.parents);
            table.push(totalRow);

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика КДО, Директора, Зам.директора по УВР',
                fileName: 'manager_stat_3.1.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('MethodologistStatisticsCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $filter, $state, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.courses = [];
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getStatForMethodologist({
            schoolId: $state.params.schoolId,
            teacherId: $state.params.teacherId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
                $scope.courses = result ? $filter('orderBy')(result, 'courseName', false) : [];
                $scope.loaded = true;
            }, function (reason) {
                $state.go('404');
            });
    };

    $scope.openDialog = function (user) {
        Dialogs.createIndividualDialog(user);
    };

    function exportToExel() {
        exelExport.load(function () {
            var i,
                headerFirstLine,
                table;

            headerFirstLine = ['№', 'Название курса', 'Кол-во классов', 'Кол-во учащихся', 'Кол-во учителей', 'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во тестов "Проверь себя"', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Средний балл за задания к занятию', 'Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ', 'Кол-во комментариев в Рабочей тетради'];
            table=[headerFirstLine];

            for (i = 0; i < $scope.courses.length; i++) {
                var row = [];
                row.push(i + 1);
                row.push($scope.courses[i].courseName);
                row.push($scope.courses[i].countClasses);
                row.push($scope.courses[i].countStudents);
                row.push($scope.courses[i].countTeachers);
                row.push($scope.courses[i].reassignment);
                row.push($scope.courses[i].performedTopicTasks + '/' + $scope.courses[i].doneTopicTasks + '/' + $scope.courses[i].showTopicTasks);
                row.push($scope.courses[i].allQuizzes + '/' + $scope.courses[i].doneQuizzes);
                row.push($scope.courses[i].rightFieldAssignments + '/' + $scope.courses[i].performedOpenTasks + '/' + $scope.courses[i].doneOpenTasks);
                row.push($scope.courses[i].homeAssignments + '/' + $scope.courses[i].performedHomeAssignments + '/' + $scope.courses[i].doneHomeAssignments);
                row.push($filter('setDecimal')($scope.courses[i].averageTopicMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageTopicAssignmentMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageQuizMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageOpenTaskMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageHomeMark, 2));
                row.push($scope.courses[i].countStudentComments + '/' + $scope.courses[i].countTeacherComments);
                table.push(row);
            }
            exelExport.createWorkBook({
                    table: table,
                    worksheetName: 'Статистика методиста 1',
                    fileName: 'methodologist_stat_1.xlsx',
                    ranges: []
                });
        });
    }
}]);

'use strict';

app.controller('MethodologistStatisticsCourseCtrl', ['$scope', '$filter', '$state', 'StatisticsResource','exelExport', function ($scope, $filter, $state, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.topics = [];
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    StatisticsResource.getCourseForMethodologist({
        schoolId: $state.params.schoolId,
        courseId: $state.params.courseId,
        learningClassId: $state.params.learningClassId
    }).$promise.then(function (result) {
        $scope.topics = result ? $filter('orderBy')(result, 'number', false) : [];
        $scope.topics.forEach(function (topic) {
            if (topic.lessons) {
                topic.lessons = $filter('orderBy')(topic.lessons, 'number', false);
            }
        });
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    function exportToExel(){
        exelExport.load(function() {
            var i,
                headerFirstLine,
                table;

            headerFirstLine = ['Перечень Тематических занятий (ТЗ)', '«5»', '«4»', '«3»', '«2»', 'Не закончили изучать ТЗ', 'Не приступили к изучению ТЗ', 'Отметка за Интернет-урок','Отметка за задание к занятию', 'Отметка за тесты «Проверь себя»','Отметка за ЗОО','Отметка за ДЗ'];
            table=[headerFirstLine];
            for (i = 0; i < $scope.topics.length; i++) {
                var row = [];
                row.push('Занятие '+$scope.topics[i].number+'. '+$scope.topics[i].title);
                row.push($filter('setDecimal')($scope.topics[i].mark5, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].mark4, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].mark3, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].mark2, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].notFinished, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].notStarted, 2)+"%");
                row.push($filter('setDecimal')($scope.topics[i].averageLessonMark, 2));
                row.push($filter('setDecimal')($scope.topics[i].averageTopicAssignmentMark, 2));
                row.push($filter('setDecimal')($scope.topics[i].averageQuizMark, 2));
                row.push($filter('setDecimal')($scope.topics[i].averageOpenTaskMark, 2));
                row.push($filter('setDecimal')($scope.topics[i].averageHomeMark, 2));
                table.push(row);
                for (var j = 0; j < $scope.topics[i].lessons.length; j++) {
                    var rowLesson = [];
                    rowLesson.push('Интернет-урок '+$scope.topics[i].lessons[j].number+'. '+$scope.topics[i].lessons[j].title);
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].mark5, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].mark4, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].mark3, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].mark2, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].notFinished, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].notStarted, 2)+"%");
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].averageLessonMark, 2));
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].averageTopicAssignmentMark, 2));
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].averageQuizMark, 2));
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].averageOpenTaskMark, 2));
                    rowLesson.push($filter('setDecimal')($scope.topics[i].lessons[j].averageHomeMark, 2));
                    table.push(rowLesson);
                }
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика методиста 2',
                fileName: 'methodologist_stat_2.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('MethodologistStatisticsCourseTopicCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'exelExport', function ($scope, $filter, $state, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.entities = [];
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    StatisticsResource.getTopicForMethodologist({
        schoolId: $state.params.schoolId,
        topicId: $state.params.topicId,
        lessonId: $state.params.lessonId,
        learningClassId: $state.params.learningClassId
    }).$promise.then(function (result) {
            var topicAssignments,
                assignments,
                quizzes;

            if (result.topicAssignments.length > 0) {
                topicAssignments = {
                    title: 'Задание к занятию',
                    content: result.topicAssignments
                };
                $scope.entities.push(topicAssignments);
            }
            if (result.assignments.length > 0) {
                assignments = {
                    title: 'Задания с открытым ответом',
                    content: result.assignments
                };
                $scope.entities.push(assignments);
            }
            if (result.quizzes.length > 0) {
                quizzes = {
                    title: 'Тесты «Проверь себя»',
                    content: result.quizzes
                };
                $scope.entities.push(quizzes);
            }
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });

    function exportToExel() {
        exelExport.load(function () {
            var i,
                headerFirstLine,
                table;

            headerFirstLine = ['Перечень заданий ИУ', 'Средний балл', '«5»', '«4»', '«3»', '«2»', 'Нет отметки'];
            table = [headerFirstLine];

            for (i = 0; i < $scope.entities.length; i++) {
                var row = [];
                row.push($scope.entities[i].title);
                row.push('');
                row.push('');
                row.push('');
                row.push('');
                row.push('');
                row.push('');
                table.push(row);
                for (var j = 0; j < $scope.entities[i].content.length; j++) {
                    var rowItem = [];
                    rowItem.push($scope.entities[i].content[j].title);
                    if ($scope.entities[i].content[j].averageMark) {
                        rowItem.push($filter('setDecimal')($scope.entities[i].content[j].averageMark, 2) + "%");
                    } else {
                        rowItem.push('');
                    }
                    rowItem.push($filter('setDecimal')($scope.entities[i].content[j].mark5, 2) + "%");
                    rowItem.push($filter('setDecimal')($scope.entities[i].content[j].mark4, 2) + "%");
                    rowItem.push($filter('setDecimal')($scope.entities[i].content[j].mark3, 2) + "%");
                    rowItem.push($filter('setDecimal')($scope.entities[i].content[j].mark2, 2) + "%");
                    rowItem.push($filter('setDecimal')($scope.entities[i].content[j].noMark, 2) + "%");
                    table.push(rowItem);
                }
            }
            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика методиста 3',
                fileName: 'methodologist_stat_3.xlsx',
                ranges: []
            });
        });
    }
}]);

'use strict';

app.controller('PsychologistStatisticsCtrl', ['$scope', '$state', 'StatisticsResource', 'Dialogs', '$filter', 'exelExport', function ($scope, $state, StatisticsResource, Dialogs, $filter, exelExport) {

    // Variables
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.loaded = false;

    // Methods
    $scope.loadAll = loadAll;
    $scope.exportToExel = exportToExel;
    $scope.openDialog = openDialog;

    function loadAll(startDateTime, endDateTime) {
        StatisticsResource.getStatForPsychologist({
            since: startDateTime,
            until: endDateTime,
            courseId: $state.params.courseId,
            classId: $state.params.learningClassId
        }).$promise.then(function (result) {
            $scope.students = $filter('orderBy')(result,'className', false);
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    }

    function openDialog(user) {
        Dialogs.createIndividualDialog(user);
    }

    function exportToExel() {
        exelExport.load(function () {
            var rowNum, j, key,
                header,
                table,
                row,
                pKey,
                parents,
                ranges = [];

            header = ['№', 'Ф.И.О. учащегося', 'Название класса', 'Кол-во курсов', 'Название курса', 'Кол-во тематических занятий',
                'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ',
                'Текущий балл за курс', 'Средний балл за задания к занятию', 'Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ',
                'Кол-во комментариев ученика в Рабочей тетради', 'Ф.И.О. и контактные данные учителя', 'Количество сообщений тьютора',
                'Ф.И.О. и контактные данные родителя', 'Ф.И.О. и контактные данные тьютора'];
            table = [header];

            rowNum = 1;
            for (key in $scope.students) {
                ranges.push({s: {c: 0, r: rowNum}, e: {c: 0, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 1, r: rowNum}, e: {c: 1, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 2, r: rowNum}, e: {c: 2, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 3, r: rowNum}, e: {c: 3, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 18, r: rowNum}, e: {c: 18, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 19, r: rowNum}, e: {c: 19, r: rowNum + $scope.students[key].studentProgresses.length - 1}},
                    {s: {c: 20, r: rowNum}, e: {c: 20, r: rowNum + $scope.students[key].studentProgresses.length - 1}});
                row = [];
                row.push(parseInt(key) + 1);
                row.push($scope.students[key].student.firstName + ' ' +
                    ($scope.students[key].student.middleName ? ($scope.students[key].student.middleName + ' ') : '') +
                    $scope.students[key].student.lastName);
                row.push($scope.students[key].className);
                row.push($scope.students[key].courseCount);

                for (j = 0; j < $scope.students[key].studentProgresses.length; j++) {
                    if (j > 0) {
                        row = [];
                        row.push(null);
                        row.push(null);
                        row.push(null);
                        row.push(null);
                    }
                    row.push($scope.students[key].studentProgresses[j].courseName);
                    row.push($scope.students[key].studentProgresses[j].allTopics + '/' + $scope.students[key].studentProgresses[j].performedTopics);
                    row.push($scope.students[key].studentProgresses[j].reassignment);
                    row.push($scope.students[key].studentProgresses[j].performedTopicTasks + '/' + $scope.students[key].studentProgresses[j].doneTopicTasks + '/' + $scope.students[key].studentProgresses[j].showTopicTasks);
                    row.push($scope.students[key].studentProgresses[j].allQuizzes + '/' + $scope.students[key].studentProgresses[j].doneQuizzes);
                    row.push($scope.students[key].studentProgresses[j].rightFieldAssignments + '/' + $scope.students[key].studentProgresses[j].performedOpenTasks + '/' + $scope.students[key].studentProgresses[j].doneOpenTasks);
                    row.push($scope.students[key].studentProgresses[j].homeAssignments + '/' + $scope.students[key].studentProgresses[j].performedHomeAssignments + '/' + $scope.students[key].studentProgresses[j].doneHomeAssignments);
                    row.push($filter('setDecimal')($scope.students[key].studentProgresses[j].averageTopicMark, 2));
                    row.push($filter('setDecimal')($scope.students[key].studentProgresses[j].averageTopicAssignmentMark, 2));
                    row.push($filter('setDecimal')($scope.students[key].studentProgresses[j].averageQuizMark, 2));
                    row.push($filter('setDecimal')($scope.students[key].studentProgresses[j].averageOpenTaskMark, 2));
                    row.push($filter('setDecimal')($scope.students[key].studentProgresses[j].averageHomeMark, 2));
                    row.push($scope.students[key].studentProgresses[j].countComments);
                    if ($scope.students[key].studentProgresses[j].teacher !== void 0 &&
                        $scope.students[key].studentProgresses[j].teacher !== undefined &&
                        $scope.students[key].studentProgresses[j].teacher !== null) {
                        row.push($scope.students[key].studentProgresses[j].teacher.user.firstName + ' ' + ($scope.students[key].studentProgresses[j].teacher.user.middleName ? $scope.students[key].studentProgresses[j].teacher.user.middleName + ' ' : '') + $scope.students[key].studentProgresses[j].teacher.user.lastName + ', ' + $scope.students[key].studentProgresses[j].teacher.user.email + ($scope.students[key].studentProgresses[j].teacher.mobilePhone ? ', ' + $scope.students[key].studentProgresses[j].teacher.mobilePhone : ''));
                    } else {
                        row.push(null);
                    }
                    if (j > 0) {
                        row.push(null);
                        row.push(null);
                        row.push(null);
                    } else {
                        row.push($scope.students[key].tutorToStudentMessageCount + '/' + $scope.students[key].tutorToParentsMessageCount + '/' + $scope.students[key].tutorToTeacherMessageCount);
                        if ($scope.students[key].parents && $scope.students[key].parents.length > 0) {
                            parents = '';
                            for (pKey in $scope.students[key].parents) {
                                if ($scope.students[key].parents[pKey].user) {
                                    parents += $scope.students[key].parents[pKey].user.firstName + ' ' +
                                        ($scope.students[key].parents[pKey].user.middleName ? ($scope.students[key].parents[pKey].user.middleName + ' ') : '') +
                                        $scope.students[key].parents[pKey].user.lastName + ' ' + $scope.students[key].parents[pKey].user.email + ' ' +
                                        ($scope.students[key].parents[pKey].mobilePhone ? ($scope.students[key].parents[pKey].mobilePhone) : '');
                                }
                            }
                            row.push(parents);
                        } else {
                            row.push('');
                        }
                        if ($scope.students[key].tutor) {
                            row.push($scope.students[key].tutor.user.firstName + ' ' +
                                ($scope.students[key].tutor.user.middleName ? ($scope.students[key].tutor.user.middleName + ' ') : '') +
                                $scope.students[key].tutor.user.lastName + ' ' + $scope.students[key].tutor.user.email + ' ' +
                                ($scope.students[key].tutor.mobilePhone ? ($scope.students[key].tutor.mobilePhone) : ''));
                        } else {
                            row.push('');
                        }
                    }
                    table.push(row);
                    rowNum++;
                }
                if (j > 0) {
                    continue;
                }

                table.push(row);
            }

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика психолога по курсам',
                fileName: 'psychologist_course_stat.xlsx',
                ranges: ranges
            });
        });
    }
}]);

'use strict';

app.controller('RegionStatisticsCtrl', ['$scope', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', '$filter',
                                        function ($scope, $state, StatisticsResource, Dialogs, exelExport, $filter) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.territories = [];
    $scope.regionId = $state.params.regionId;
    $scope.total = null;
    $scope.loaded = false;

    $scope.exportToExel = exportToExel;
    var tableData = {
        table: [['№', 'Название территории', 'Количество', null, null, null, null, null, null, null, null,'Ф.И.О. и контактные данные ТК'],
                [null, null, 'ОО', 'Рук.МО', 'Учителей', 'Методистов', 'Тьюторов', 'Психологов', 'Учащихся', 'Родителей', 'Чел/курсов', null]],
        worksheetName: 'Статистика территориального координатора',
        fileName: 'regional_ccordinators_stat.xlsx',
        ranges: [{e: {c:0, r:1}, s: {c:0, r:0}},
                 {e: {c:1, r:1}, s: {c:1, r:0}},
                 {e: {c:10, r:0}, s: {c:2, r:0}},
                 {e: {c:12, r:1}, s: {c:11, r:0}}]
    };

    StatisticsResource.getTerritoriesByRegion({'regionId': $scope.regionId}).$promise.then(function (result) {
        $scope.territories = result.territories ?  $filter('orderBy')(result.territories, 'title', false) : [];
        $scope.total = result.total;
        countEntities();
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    function countEntities() {
        $scope.total.countSchools = 0;
        $scope.total.countHeadTeachers = 0;
        $scope.total.countDeputyHeadTeachers = 0;
        $scope.total.countKDOs = 0;
        $scope.total.countTeachers = 0;
        $scope.total.countMethodologists = 0;
        $scope.total.countTutors = 0;
        $scope.total.countPsychologists = 0;
        $scope.total.countStudents = 0;
        $scope.total.countParents = 0;
        $scope.territories.forEach(function (territory) {
            $scope.total.countSchools += territory.countSchools;
            $scope.total.countHeadTeachers += territory.countHeadTeachers;
            $scope.total.countDeputyHeadTeachers += territory.countDeputyHeadTeachers;
            $scope.total.countKDOs += territory.countKDOs;
            $scope.total.countTeachers += territory.countTeachers;
            $scope.total.countMethodologists += territory.countMethodologists;
            $scope.total.countTutors += territory.countTutors;
            $scope.total.countPsychologists += territory.countPsychologists;
            $scope.total.countStudents += territory.countStudents;
            $scope.total.countParents += territory.countParents;
        });
    }

    function exportToExel(){
        exelExport.load(function() {
            var i;
            for (i = 0; i < $scope.territories.length; i++) {
                var row = [];
                row.push(i + 1);
                row.push($scope.territories[i].title);
                row.push($scope.territories[i].countSchools);
                row.push($scope.territories[i].countHeadTeachers + '/' +
                         $scope.territories[i].countDeputyHeadTeachers + '/' +
                         $scope.territories[i].countKDOs);
                row.push($scope.territories[i].countTeachers);
                row.push($scope.territories[i].countMethodologists);
                row.push($scope.territories[i].countTutors);
                row.push($scope.territories[i].countPsychologists);
                row.push($scope.territories[i].countStudents);
                row.push($scope.territories[i].countParents);
                row.push($scope.territories[i].countCourses + '/' +
                         $scope.territories[i].countPeopleInCourses);
                if ($scope.territories[i].coordinatorData) {
                    row.push($scope.territories[i].coordinatorData.user.firstName + ' ' +
                            ($scope.territories[i].coordinatorData.user.middleName ? $scope.territories[i].coordinatorData.user.middleName + ' ' : '') +
                             $scope.territories[i].coordinatorData.user.lastName + ' ' +
                             $scope.territories[i].coordinatorData.user.email + ' ' +
                            ($scope.territories[i].coordinatorData.mobilePhone ? $scope.territories[i].coordinatorData.mobilePhone : ''));
                }
                tableData.table.push(row);
            }

            var totalRow = [null, 'ИТОГО'];
            totalRow.push($scope.total.countSchools);
            totalRow.push($scope.total.countHeadTeachers + '/' +
                          $scope.total.countDeputyHeadTeachers + '/' +
                          $scope.total.countKDOs);
            totalRow.push($scope.total.countTeachers);
            totalRow.push($scope.total.countMethodologists);
            totalRow.push($scope.total.countTutors);
            totalRow.push($scope.total.countPsychologists);
            totalRow.push($scope.total.countStudents);
            totalRow.push($scope.total.countParents);
            totalRow.push($scope.total.courses + '/' +
                          $scope.total.peopleInCourses);
            totalRow.push('Всего пользователей');
            totalRow.push($scope.total.users + '/' +
                          $scope.total.roles);
            tableData.table.push(totalRow);

            exelExport.createWorkBook(tableData);
        });
    }
}]);

'use strict';

app.controller('StudentCourseInfoCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $filter, $state, StatisticsResource, Dialogs, exelExport) {
    var stateName = $state.current.name,
        states = {
            teacher: 'teacherStatisticsCourseStudent',
            tutor: 'tutorStatisticsStudent',
            psychologist: 'psychologistStatisticsStudent'
        };

    $scope.ncyBreadcrumbIgnore = true;
    $scope.topics = [];
    $scope.relatedUser = null;
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {
        var conf = {
            progressId: $state.params.progressId,
            since: startDateTime,
            until: endDateTime
        };

        if (stateName === states.teacher) {
            StatisticsResource.getProgressForStudentForTeacher(conf).$promise.then(loadData, errorHandler);
        } else if (stateName === states.tutor) {
            StatisticsResource.getProgressForStudentForTutor(conf).$promise.then(loadData, errorHandler);
        } else if (stateName === states.psychologist) {
            StatisticsResource.getProgressForStudentForPsychologist(conf).$promise.then(loadData, errorHandler);
        }
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var header,
                table,
                relatedUserRow,
                fileName,
                worksheetName;

            relatedUserRow = [];
            if ($scope.relatedUser) {
                relatedUserRow.push($scope.relatedUser.user.firstName + ' ' +
                    ($scope.relatedUser.user.middleName ? ($scope.relatedUser.user.middleName + ' ') : '') +
                    $scope.relatedUser.user.lastName);
                relatedUserRow.push($scope.relatedUser.user.email + ' ' +
                    ($scope.relatedUser.mobilePhone ? ($scope.relatedUser.mobilePhone) : ''));
            }
            table = [relatedUserRow];
            table.push([]);

            header = ['Название Тематического занятия/Интернет-урока', 'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Отметка за Интернет-урок', 'Отметка за задание к занятию','Отметка за тесты', 'Отметка за ЗОО', 'Отметка за ДЗ', 'Кол-во комментариев в Рабочей тетради'];
            table.push(header);

            $scope.topics.forEach(function (topic) {
                table.push(buildRow(topic));
                topic.lessonStat.forEach(function (lesson) {
                    table.push(buildRow(lesson, true));
                });
            });

            if (stateName === states.teacher) {
                worksheetName = 'Статистика учителя по ученику';
                fileName = 'teacher_course_student_stat.xlsx';
            } else if (stateName === states.tutor) {
                worksheetName = 'Статистика тьютора по ученику';
                fileName = 'tutor_stat_student.xlsx';
            } else if (stateName === states.psychologist) {
                worksheetName = 'Статистика психолога по ученику';
                fileName = 'psychologist_course_student_stat.xlsx';
            }

            exelExport.createWorkBook({
                table: table,
                worksheetName: worksheetName,
                fileName: fileName,
                ranges: []
            });
        });
    };

    function loadData(result) {
        if (result.progresses) {
            $scope.topics = $filter('orderBy')(result.progresses, 'number', false);
            $scope.topics.forEach(function(topic) {
                if (topic.lessonStat) {
                    topic.lessonStat = $filter('orderBy')(topic.lessonStat, 'number', false);
                }
            });
        }
        $scope.relatedUser = result.tutor;
        $state.params.groupId = result.userGroupId;
        if (stateName === states.psychologist) {
            $state.params.schoolId = result.schoolId;
        }
        $scope.loaded = true;
    }

    function errorHandler(reason) {
        $state.go('404');
    }

    function buildRow(data, isLesson) {
        var row = [];

        row.push((isLesson ? 'Интернет-урок ' : 'Занятие ') + data.number + '. ' + data.title);
        row.push(data.reassignmentCount);
        row.push(data.performedTopicAssignments + '/' +
            data.assessedTopicAssignments + '/' +
            data.markPublishedTopicAssignments);
        row.push(data.allQuizzes + '/' +
            data.doneQuizzes);
        row.push(data.rightFieldOpenTasks + '/' +
            data.performedOpenTasks + '/' +
            data.assessedOpenTasks);
        row.push(data.homeAssignments + '/' +
            data.performedHomeAssignments + '/' +
            data.assessedHomeAssignments);
        row.push($filter('setDecimal')(data.mark, 2));
        row.push($filter('setDecimal')(data.topicAssignmentMark, 2));
        row.push($filter('setDecimal')(data.averageQuizMark, 2));
        row.push($filter('setDecimal')(data.averageOpenTaskMark, 2));
        row.push($filter('setDecimal')(data.averageHomeAssignmentMark, 2));
        row.push(data.commentCount);

        return row;
    }
}]);

'use strict';

app.controller('TeacherStatisticsCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'exelExport', function ($scope, $filter, $state, StatisticsResource, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.courses = [];
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {
        
        StatisticsResource.getStatForTeacher({
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.courses = result ? $filter('orderBy')(result, 'courseName', false) : [];
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var i,
                header,
                table,
                row;

            header = ['№', 'Название курса', 'Кол-во классов', 'Кол-во учащихся', 'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Средний балл за задания к занятию','Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ', 'Кол-во комментариев в Рабочей тетради'];
            table = [header];

            for (i = 0; i < $scope.courses.length; i++) {
                row = [];
                row.push(i + 1);
                row.push($scope.courses[i].courseName);
                row.push($scope.courses[i].countClasses);
                row.push($scope.courses[i].countStudents);
                row.push($scope.courses[i].reassignment);
                row.push($scope.courses[i].performedTopicTasks + '/' +
                    $scope.courses[i].doneTopicTasks + '/' +
                    $scope.courses[i].showTopicTasks);
                row.push($scope.courses[i].allQuizzes + '/' +
                    $scope.courses[i].doneQuizzes);
                row.push($scope.courses[i].rightFieldAssignments + '/' +
                    $scope.courses[i].performedOpenTasks + '/' +
                    $scope.courses[i].doneOpenTasks);
                row.push($scope.courses[i].homeAssignments + '/' +
                    $scope.courses[i].performedHomeAssignments + '/' +
                    $scope.courses[i].doneHomeAssignments);
                row.push($filter('setDecimal')($scope.courses[i].averageTopicMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageTopicAssignmentMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageQuizMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageOpenTaskMark, 2));
                row.push($filter('setDecimal')($scope.courses[i].averageHomeMark, 2));
                row.push($scope.courses[i].countStudentComments + '/' +
                         $scope.courses[i].countTeacherComments);
                table.push(row);
            }

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика учителя',
                fileName: 'teacher_stat.xlsx',
                ranges: []
            });
        });
    };
}]);

'use strict';

app.controller('TeacherStatisticsCourseCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $filter, $state, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.loaded = false;

    $scope.loadAll = function (startDateTime, endDateTime) {        
        StatisticsResource.getStudentsByCourse({
            courseId: $state.params.courseId,
            'class' : $state.params.learningClassId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.students = result ? $filter('orderBy')(result, 'student.lastname', false) : [];
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var i,
                header,
                table,
                row;

            header = ['№', 'Ф.И.О. учащегося', 'Название класса', 'Кол-во тематических занятий', 'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию', 'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ', 'Текущий балл за курс', 'Средний балл за задания к занятию','Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ', 'Кол-во комментариев в Рабочей тетради', 'Ф.И.О. и контактные данные тьютора'];
            table = [header];

            for (i = 0; i < $scope.students.length; i++) {
                row = [];
                row.push(i + 1);
                row.push($scope.students[i].student.firstName + ' ' +
                    ($scope.students[i].student.middleName ? ($scope.students[i].student.middleName + ' ') : '') +
                    $scope.students[i].student.lastName);
                row.push($scope.students[i].className);
                row.push($scope.students[i].allTopics + '/' +
                    $scope.students[i].performedTopics);
                row.push($scope.students[i].reassignment);
                row.push($scope.students[i].performedTopicTasks + '/' +
                    $scope.students[i].doneTopicTasks + '/' +
                    $scope.students[i].showTopicTasks);
                row.push($scope.students[i].allQuizzes + '/' +
                    $scope.students[i].doneQuizzes);
                row.push($scope.students[i].rightFieldAssignments + '/' +
                    $scope.students[i].performedOpenTasks + '/' +
                    $scope.students[i].doneOpenTasks);
                row.push($scope.students[i].homeAssignments + '/' +
                    $scope.students[i].performedHomeAssignments + '/' +
                    $scope.students[i].doneHomeAssignments);
                row.push($filter('setDecimal')($scope.students[i].averageTopicMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageTopicAssignmentMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageQuizMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageOpenTaskMark, 2));
                row.push($filter('setDecimal')($scope.students[i].averageHomeMark, 2));
                row.push($scope.students[i].countStudentComments + '/' +
                    $scope.students[i].countTeacherComments);
                if ($scope.students[i].man.user) {
                    row.push($scope.students[i].man.user.firstName + ' ' +
                        ($scope.students[i].man.user.middleName ? ($scope.students[i].man.user.middleName + ' ') : '') +
                        $scope.students[i].man.user.lastName + ' ' +
                        $scope.students[i].man.user.email + ' ' +
                        ($scope.students[i].man.mobilePhone ? ($scope.students[i].man.mobilePhone) : ''));
                }
                table.push(row);
            }

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика учителя по курсу',
                fileName: 'teacher_course_stat.xlsx',
                ranges: []
            });
        });
    };
}]);

'use strict';

app.controller('TerritoryStatisticsCtrl', ['$scope', '$filter', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', function ($scope, $filter, $state, StatisticsResource, Dialogs, exelExport) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.schools = [];
    $scope.territoryId = $state.params.territoryId;
    $scope.regionId = $state.params.regionId;
    $scope.total = null;
    $scope.loaded = false;

    StatisticsResource.getSchoolsByTerritory({'territoryId':$scope.territoryId}).$promise.then(function (result) {
        $scope.schools = result.schools ? $filter('orderBy')(result.schools, 'title', false) : [];
        $scope.total = result.total;
        countEntities();
        $scope.loaded = true;
    }, function (reason) {
        $state.go('404');
    });

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    function countEntities() {
        $scope.total.countHeadTeachers = 0;
        $scope.total.countDeputyHeadTeachers = 0;
        $scope.total.countKDOs = 0;
        $scope.total.countTeachers = 0;
        $scope.total.countMethodologists = 0;
        $scope.total.countTutors = 0;
        $scope.total.countPsychologists = 0;
        $scope.total.countStudents = 0;
        $scope.total.countParents = 0;
        $scope.schools.forEach(function (school) {
            $scope.total.countHeadTeachers += school.countHeadTeachers;
            $scope.total.countDeputyHeadTeachers += school.countDeputyHeadTeachers;
            $scope.total.countKDOs += school.countKDOs;
            $scope.total.countTeachers += school.countTeachers;
            $scope.total.countMethodologists += school.countMethodologists;
            $scope.total.countTutors += school.countTutors;
            $scope.total.countPsychologists += school.countPsychologists;
            $scope.total.countStudents += school.countStudents;
            $scope.total.countParents += school.countParents;
        });
    }

    $scope.exportToExel = function () {
        exelExport.load(function() {
            var i, j,
                headerFirstLine,
                headerSecondLine,
                table,
                row;

            headerFirstLine = ['№', 'Название ОО', 'Количество', null, null, null, null, null, null, null,'Ф.И.О. и контактные данные Директора', null, 'Ф.И.О. и контактные данные ТК',null];
            headerSecondLine=[null, null, 'Рук.МО', 'Учителей', 'Методистов', 'Тьюторов', 'Психологов', 'Учащихся', 'Родителей', 'Чел/курсов',null, null,null, null];
            table=[headerFirstLine];
            table.push(headerSecondLine);


            for (i = 0; i < $scope.schools.length; i++) {
                row = [];
                row.push(i + 1);
                row.push($scope.schools[i].title);
                row.push($scope.schools[i].countHeadTeachers + '/' +
                    $scope.schools[i].countDeputyHeadTeachers + '/' +
                    $scope.schools[i].countKDOs);
                row.push($scope.schools[i].countTeachers);
                row.push($scope.schools[i].countMethodologists);
                row.push($scope.schools[i].countTutors);
                row.push($scope.schools[i].countPsychologists);
                row.push($scope.schools[i].countStudents);
                row.push($scope.schools[i].countParents);
                row.push($scope.schools[i].countPeopleInCourses);

                if ($scope.schools[i].headTeacherData) {
                    row.push($scope.schools[i].headTeacherData.user.firstName + ' ' +
                        ($scope.schools[i].headTeacherData.user.middleName ? $scope.schools[i].headTeacherData.user.middleName + ' ' : '') +
                        $scope.schools[i].headTeacherData.user.lastName + ' ' +
                        'e-mail: ' + $scope.schools[i].headTeacherData.user.email +
                        ($scope.schools[i].headTeacherData.mobilePhone ? ' Тел.: ' + $scope.schools[i].headTeacherData.mobilePhone : ''));
                    row.push(null);
                } else {
                    row.push(null);
                    row.push(null);
                }
                if ($scope.schools[i].coordinatorData) {
                    row.push($scope.schools[i].coordinatorData.user.firstName + ' ' +
                             ($scope.schools[i].coordinatorData.user.middleName ? $scope.schools[i].coordinatorData.user.middleName + ' ' : '') +
                             $scope.schools[i].coordinatorData.user.lastName + ' ' +
                            'email: ' + $scope.schools[i].coordinatorData.user.email +
                            ($scope.schools[i].coordinatorData.mobilePhone ? ' Тел.: ' + $scope.schools[i].coordinatorData.mobilePhone : ''));
                    row.push(null);
                } else {
                    row.push(null);
                    row.push(null);
                }
                table.push(row);
            }

            var totalRow = [null, 'ИТОГО'];
            totalRow.push($scope.total.countHeadTeachers + '/' +
                $scope.total.countDeputyHeadTeachers + '/' +
                $scope.total.countKDOs);
            totalRow.push($scope.total.countTeachers);
            totalRow.push($scope.total.countMethodologists);
            totalRow.push($scope.total.countTutors);
            totalRow.push($scope.total.countPsychologists);
            totalRow.push($scope.total.countStudents);
            totalRow.push($scope.total.countParents);
            totalRow.push($scope.total.peopleInCourses);
            totalRow.push("Всего пользователей:");
            totalRow.push(null);
            totalRow.push(null);
            totalRow.push($scope.total.users + '/' + $scope.total.roles);
            table.push(totalRow);

            exelExport.createWorkBook({
                table: table,
                worksheetName: 'Статистика территориального координатора',
                fileName: 'territory_coordinator_stat.xlsx',
                ranges: []
            });
        });
    };
}]);

'use strict';

app.controller('TutorStatisticsCtrl', ['$scope', '$state', 'StatisticsResource', 'Dialogs', 'exelExport', '$filter', function ($scope, $state, StatisticsResource, Dialogs, exelExport, $filter) {
    $scope.ncyBreadcrumbIgnore = true;
    $scope.students = [];
    $scope.loaded = false;
    $scope.exportToExel = exportToExel;

    $scope.loadAll = function (startDateTime, endDateTime) {
        StatisticsResource.getStatForTutor({
            courseId: $state.params.courseId,
            classId : $state.params.learningClassId,
            since: startDateTime,
            until: endDateTime
        }).$promise.then(function (result) {
            $scope.students = result ? $filter('orderBy')(result, 'student.lastname', false) : [];
            $scope.students.forEach(function (student) {
                if (student.studentProgresses) {
                    student.studentProgresses = $filter('orderBy')(student.studentProgresses, 'courseName', false);
                }
            });
            $scope.loaded = true;
        }, function (reason) {
            $state.go('404');
        });
    };

    $scope.openDialog = function(user) {
        Dialogs.createIndividualDialog(user);
    };

    function exportToExel() {
        var tableData = {
            table: [['№', 'Ф.И.О. учащегося', 'Название класса', 'Кол-во курсов',
                           'Название курса', 'Кол-во тематических занятий',
                           'Кол-во переназначенных ИУ', 'Кол-во заданий к занятию',
                           'Кол-во Тестов «Проверь себя»', 'Кол-во ЗОО', 'Кол-во ДЗ',
                           'Текущий балл за курс', 'Средний балл за задания к занятию',
                           'Средний балл за тесты', 'Средний балл за ЗОО', 'Средний балл за ДЗ',
                           'Кол-во комментариев, ученика в Рабочей тетради', 'Ф.И.О. и контактные данные учителя',
                           'Ф.И.О и контактные данные родителя']],
            worksheetName: 'Статистика тьютора',
            fileName: 'tutor_stat.xlsx',
            ranges: []
        };

        exelExport.load(function() {
            var counter = 1;
            for (var j = 0; j < $scope.students.length; j++) {
                for (var i = 0; i < $scope.students[j].studentProgresses.length; i++) {
                    var row = [];
                    if (i === 0) {
                        row.push(j + 1);
                        row.push($scope.students[j].student.firstName + ' ' +
                                 ($scope.students[j].student.middleName ? $scope.students[j].student.middleName + ' ' : '') +
                                 $scope.students[j].student.lastName);
                        row.push($scope.students[j].className);
                        row.push($scope.students[j].courseCount);
                    } else {
                        for (var k = 0; k < 4; k++) {
                            row.push(null);
                        }
                    }
                    row.push($scope.students[j].studentProgresses[i].courseName);
                    row.push($scope.students[j].studentProgresses[i].allTopics + '/' +
                             $scope.students[j].studentProgresses[i].performedTopics);
                    row.push($scope.students[j].studentProgresses[i].reassignment);
                    row.push($scope.students[j].studentProgresses[i].performedTopicTasks + '/' +
                             $scope.students[j].studentProgresses[i].doneTopicTasks + '/' +
                             $scope.students[j].studentProgresses[i].showTopicTasks);
                    row.push($scope.students[j].studentProgresses[i].allQuizzes + '/' +
                             $scope.students[j].studentProgresses[i].doneQuizzes);
                    row.push($scope.students[j].studentProgresses[i].rightFieldAssignments + '/' +
                             $scope.students[j].studentProgresses[i].performedOpenTasks + '/' +
                             $scope.students[j].studentProgresses[i].doneOpenTasks);
                    row.push($scope.students[j].studentProgresses[i].homeAssignments + '/' +
                             $scope.students[j].studentProgresses[i].performedHomeAssignments + '/' +
                             $scope.students[j].studentProgresses[i].doneHomeAssignments);
                    row.push($filter('setDecimal')($scope.students[j].studentProgresses[i].averageTopicMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].studentProgresses[i].averageTopicAssignmentMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].studentProgresses[i].averageQuizMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].studentProgresses[i].averageOpenTaskMark, 2));
                    row.push($filter('setDecimal')($scope.students[j].studentProgresses[i].averageHomeMark, 2));
                    row.push($scope.students[j].studentProgresses[i].countComments);
                    if ($scope.students[j].studentProgresses[i].teacher !== void 0 &&
                        $scope.students[j].studentProgresses[i].teacher !== undefined &&
                        $scope.students[j].studentProgresses[i].teacher !== null) {
                        var teacherContacts = $scope.students[j].studentProgresses[i].teacher.user.email;
                        if ($scope.students[j].studentProgresses[i].teacher.mobilePhone) {
                            teacherContacts += ' ( ' + $scope.students[j].studentProgresses[i].teacher.mobilePhone + ' )';
                        }
                        row.push($scope.students[j].studentProgresses[i].teacher.user.firstName + ' ' +
                            ($scope.students[j].studentProgresses[i].teacher.user.middleName ? $scope.students[j].studentProgresses[i].teacher.user.middleName + ' ' : '') +
                            $scope.students[j].studentProgresses[i].teacher.user.lastName + ' ' + teacherContacts);
                    } else {
                        row.push(null);
                        row.push(null);
                    }
                    if (i === 0) {
                        var stroke = '';
                        for (var z = 0; z < $scope.students[j].parents.length; z++) {
                            stroke = stroke + $scope.students[j].parents[z].user.firstName + ' ' +
                                              ($scope.students[j].parents[z].user.middleName ? $scope.students[j].parents[z].user.middleName + ' ' : '') +
                                              $scope.students[j].parents[z].user.lastName + ' ' +
                                              $scope.students[j].parents[z].user.email;
                            if ($scope.students[j].parents[z].user.mobilePhone) {
                                stroke = stroke + ' ' + $scope.students[j].parents[z].user.mobilePhone + ' ';
                            }
                        }
                        row.push(stroke);
                    } else {
                        row.push(null);
                    }
                    tableData.table.push(row);
                }
                var oldCounter = counter;
                counter = (counter + $scope.students[j].studentProgresses.length) - 1;
                tableData.ranges.push({s:{c: 0, r: oldCounter},e:{c:0, r:counter}},
                                      {s:{c: 1, r: oldCounter},e:{c:1, r:counter}},
                                      {s:{c: 2, r: oldCounter},e:{c:2, r:counter}},
                                      {s:{c: 3, r: oldCounter},e:{c:3, r:counter}},
                                      {s:{c: 19, r: oldCounter},e:{c:19, r:counter}});
                counter++;
            }
            exelExport.createWorkBook(tableData);
        });
    }
}]);

'use strict';

app.directive('lmsStatDateFilter', function () {
    return {
        restrict: 'E',
        replace: true,
        template:   '<div layout="column" class="lms-stat-date-filter">' +
                        '<p>Выбор интервала</p>' +
                        '<div layout="row" layout-align="start center">' +
                            '<span>с</span>' +
                            '<lms-date-time dt-date-time="startDateTime"></lms-date-time>' +
                            '<span class="margin-left">по</span>' +
                            '<lms-date-time dt-date-time="endDateTime"></lms-date-time>' +
                            '<md-button class="lms-volume-btn btn-xs btn-grey" ng-click="callUpdate()">Применить</md-button>' +
                        '</div>' +
                    '</div>',
        scope: {
            updateFn: '&'
        },
        link: function (scope, element, attrs) {
            var currentDate = new Date(),
                startDate = new Date(2014, 8, 1);

            currentDate.toLocaleString('ru-RU', {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit'
            });
            startDate.toLocaleString('ru-RU', {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit'
            });

            scope.startDateTime = {
                date: startDate,
                time: startDate
            };
            scope.endDateTime = {
                date: currentDate,
                time: currentDate
            };

            scope.callUpdate = function () {
                var fullStartDate = new Date(scope.startDateTime.date.getFullYear(), scope.startDateTime.date.getMonth(), scope.startDateTime.date.getDate(), scope.startDateTime.time.getHours(), scope.startDateTime.time.getMinutes()),
                    fullEndDate = new Date(scope.endDateTime.date.getFullYear(), scope.endDateTime.date.getMonth(), scope.endDateTime.date.getDate()+1, scope.endDateTime.time.getHours(), scope.endDateTime.time.getMinutes());

                scope.updateFn()(fullStartDate.getTime(), fullEndDate.getTime());
            };

            scope.callUpdate();
        }
    };
});

'use strict';

angular.module('lmsClientApp')
    .factory('StatisticsResource', function ($resource) {
        return $resource('/api/stat/', {}, {
            'getTerritoriesByRegion': {
                method: 'GET',
                url: '/api/stat/region/:regionId',
                isArray: false
            },
            'getSchoolsByTerritory': {
                method: 'GET',
                url: '/api/stat/territory/:territoryId',
                isArray: false
            },
            'getEducationLevelsBySchool': {
                method: 'GET',
                url: '/api/stat/school/:schoolId',
                isArray: false
            },
            'getTeachersByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/teacher/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel',
                    'course': '@course'
                }
            },
            'getMethodologistsByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/methodologist/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel'
                }
            },
            'getStudentsByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/student/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel',
                    'class': '@class'
                }
            },
            'getCoursesForStudent': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/student/:studentId',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until'
                }
            },
            'getPsychologistsByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/psychologist/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel'
                }
            },
            'getParentsByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/parent/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel',
                    'class': '@class'
                }
            },
            'getTutorsByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/tutor/level/:level',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel'
                }
            },
            'getStudentsForTutor': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/tutor/:tutorId/level/:level',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel',
                    'course': '@course',
                    'class': '@class'
                }
            },
            'getStudentsByTeacherAndCourse': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/teacher/:teacherId/course/:courseId/level/:level',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'parallel': '@parallel',
                    'class': '@class'
                }
            },
            'getLearningClassesByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/class/level/:level',
                isArray: true,
                params: {
                    'parallel': '@parallel'
                }
            },
            'getCoursesByLevel': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/course/level/:level',
                isArray: true,
                params: {
                    'parallel': '@parallel'
                }
            },
            'getTopicsByCourse': {
                method: 'GET',
                url: '/api/stat/school/:schoolId/course/:courseId',
                isArray: true,
                params: {
                    'class': '@class'
                }
            },
            'getStatForTeacher': {
                method: 'GET',
                url: '/api/stat/teacher',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until'
                }
            },
            'getProgressForStudentForTeacher': {
                method: 'GET',
                url: '/api/stat/teacher/progress/:progressId',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until'
                }
            },
            'getStatForTutor': {
                method: 'GET',
                url: '/api/stat/tutor',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'courseId': '@courseId',
                    'class': '@learningClassId'
                }
            },
            'getProgressForStudentForTutor': {
                method: 'GET',
                url: '/api/stat/tutor/courseProgress/:progressId/details',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until'
                }
            },
            'getStudentsByCourse': {
                method: 'GET',
                url: '/api/stat/teacher/course/:courseId/details',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'class': '@learningClassId'
                }
            },
            'getStatForMethodologist': {
                method: 'GET',
                url: '/api/stat/methodologist/school/:schoolId',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'teacherId': '@teacherId'
                }
            },
            'getCourseForMethodologist': {
                method: 'GET',
                url: '/api/stat/methodologist/school/:schoolId/course/:courseId',
                isArray: true,
                params: {
                    'classId': '@learningClassId'
                }
            },
            'getTopicForMethodologist': {
                method: 'GET',
                url: '/api/stat/methodologist/school/:schoolId/topic/:topicId',
                isArray: false,
                params: {
                    'class': '@learningClassId',
                    'lesson': '@lessonId'
                }
            },
            'getStatForPsychologist': {
                method: 'GET',
                url: '/api/stat/psychologist',
                isArray: true,
                params: {
                    'since': '@since',
                    'until': '@until',
                    'classId': '@classId',
                    'courseId': '@courseId'
                }
            },
            'getProgressForStudentForPsychologist': {
                method: 'GET',
                url: '/api/stat/psychologist/courseProgress/:progressId/details',
                isArray: false,
                params: {
                    'since': '@since',
                    'until': '@until'
                }
            }
        });
    });

/* globals XLSX, datenum, saveAs */
'use strict';

var app = angular.module('lmsClientApp');

app.service('exelExport', ['lmsConfig', '$rootScope', function (lmsConfig, $rootScope) {
    //local variables
    var self = this,
        scriptLoaded = false;

    //Private methods
    function Workbook() {
        if(!(this instanceof Workbook)) return new Workbook();
        this.SheetNames = [];
        this.Sheets = {};
    }

    function dataFromArray(data){
        var workSheet = {};
        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
        for(var R = 0; R != data.length; ++R) {
            for(var C = 0; C != data[R].length; ++C) {
                if(range.s.r > R) range.s.r = R;
                if(range.s.c > C) range.s.c = C;
                if(range.e.r < R) range.e.r = R;
                if(range.e.c < C) range.e.c = C;
                var cell = {v: data[R][C] };
                if(cell.v === null) continue;
                var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

                if(typeof cell.v === 'number') cell.t = 'n';
                else if(typeof cell.v === 'boolean') cell.t = 'b';
                else if(cell.v instanceof Date) {
                    cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                    cell.v = datenum(cell.v);
                }
                else cell.t = 's';

                workSheet[cell_ref] = cell;
            }
        }
        if(range.s.c < 10000000) workSheet['!ref'] = XLSX.utils.encode_range(range);
        return workSheet;
    }

    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    //Public methods

    this.createWorkBook = function(data) {
        var workbook = new Workbook(),
            workSheet = dataFromArray(data.table),
            wbout;

        workSheet['!merges'] = data.ranges;
        workbook.SheetNames.push(data.worksheetName);
        workbook.Sheets[data.worksheetName] = workSheet;

        wbout = XLSX.write(workbook, {bookType:'xlsx', bookSST:true, type: 'binary'});
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), data.fileName);
    };

    this.load = function(callBack) {
        if (!scriptLoaded) {
            var script = document.createElement('script');
            if ($rootScope.ENV === 'prod') {
                script.setAttribute('src', 'app/components/libs/jsxlsx/xlsx.core.min.js');
            } else {
                script.setAttribute('src', lmsConfig.bowerPath + 'js-xlsx/dist/xlsx.core.min.js');
            }

            script.setAttribute('type', 'text/javascript');
            document.getElementsByTagName('head')[0].appendChild(script);

            script.onload = function() {
                scriptLoaded = true;
                callBack();
            };
        } else callBack();
    };
}]);

'use strict';

app.config(['$stateProvider', 'lmsConfig', 'lmsEntity', function ($stateProvider, lmsConfig, lmsEntity) {
    $stateProvider
        .state('regionStatistics', {
            parent: 'dashboard',
            url: 'statistics/region/:regionId',
            data: {
                roles: ['ROLE_REGIONAL_COORDINATOR', 'ROLE_LOCATION_COORDINATOR' ],
                entity: lmsEntity.statistics
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'journal/views/_regionalCoordinatorJournalBar.html',
                    controller: 'RegionalCoordinatorJournalDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/regionStatistics.html',
                    controller: 'RegionStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{regionName}}'
            }
        })
        .state('territoryStatistics', {
            parent: 'dashboard',
            url: 'statistics/territory/:territoryId?regionId',
            data: {
                roles: ['ROLE_REGIONAL_COORDINATOR', 'ROLE_LOCATION_COORDINATOR', 'ROLE_TERRITORY_COORDINATOR'],
                entity: lmsEntity.statistics
            },
            resolve: {
                userAccount: function ($auth, Account) {
                    return $auth.user ? $auth.user : Account.getAccount();
                }
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'journal/views/_territoryCoordinatorJournalBar.html',
                    controller: 'TerritoryCoordinatorJournalDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/territoryStatistics.html',
                    controller: 'TerritoryStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{territoryName}}',
                parent: function ($scope) {
                    return $scope.territoryParent;
                }
            }
        })
        .state('schoolStatistics', {
            parent: 'dashboard',
            url: 'statistics/school/:schoolId?regionId&territoryId',
            data: {
                roles: ['ROLE_REGIONAL_COORDINATOR', 'ROLE_LOCATION_COORDINATOR', 'ROLE_TERRITORY_COORDINATOR', 'ROLE_DISTANCE_EDUCATION_COORDINATOR', 'ROLE_HEAD_TEACHER', 'ROLE_DEPUTY_HEAD_TEACHER'],
                entity: lmsEntity.statistics
            },
            resolve: {
                userAccount: function ($auth, Account) {
                    return $auth.user ? $auth.user : Account.getAccount();
                }
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'journal/views/_distanceEducationCoordinatorJournalBar.html',
                    controller: 'DistanceEducationCoordinatorJournalDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/managerStatistics.html',
                    controller: 'ManagerStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{schoolName}}',
                parent: function ($scope) {
                    return $scope.schoolParent;
                }
            }
        })
        .state('levelStatisticsCourses', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/course?parallelNum',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsCourses.html',
                    controller: 'LevelStatisticsCoursesCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsCoursesCourse', {
            parent: 'levelStatisticsCourses',
            url: '/:courseId?learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsCoursesCourseBar.html',
                    controller: 'LevelStatisticsCoursesCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsCoursesCourse.html',
                    controller: 'levelStatisticsCoursesCourseCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{courseName}}'
            }
        })
        .state('levelStatisticsLearningClasses', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/learningClass?parallelNum',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsLearningClasses.html',
                    controller: 'LevelStatisticsLearningClassesCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsTeachers', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/teacher?parallelNum&courseId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsTeachers.html',
                    controller: 'LevelStatisticsTeachersCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsTeachersCourse', {
            parent: 'levelStatisticsTeachers',
            url: '/:teacherId?learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsTeachersCourseBar.html',
                    controller: 'levelStatisticsTeachersCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsTeachersCourse.html',
                    controller: 'levelStatisticsTeachersCourseCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{teacherName}}'
            }
        })
        .state('levelStatisticsMethodologists', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/methodologist?parallelNum',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsMethodologists.html',
                    controller: 'LevelStatisticsMethodologistsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsTutors', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/tutor?parallelNum',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsTutors.html',
                    controller: 'LevelStatisticsTutorsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsTutorsTutor', {
            parent: 'levelStatisticsTutors',
            url: '/:tutorId?courseId&learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsTeachersCourseBar.html',
                    controller: 'levelStatisticsTeachersCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsTutorsTutor.html',
                    controller: 'LevelStatisticsTutorsTutorCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{teacherName}}'
            }
        })
        .state('levelStatisticsPsychologists', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/psychologist?parallelNum',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsPsychologists.html',
                    controller: 'LevelStatisticsPsychologistsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsStudents', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/student?parallelNum&learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsCoursesCourseBar.html',
                    controller: 'LevelStatisticsCoursesCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsStudents.html',
                    controller: 'LevelStatisticsStudentsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('levelStatisticsStudentsStudent', {
            parent: 'levelStatisticsStudents',
            url: '/:studentId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'LevelStatisticsStudentsStudentDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsStudentsStudent.html',
                    controller: 'LevelStatisticsStudentsStudentCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{studentName}}'
            }
        })
        .state('levelStatisticsParents', {
            parent: 'schoolStatistics',
            url: '/level/:levelNum/parent?parallelNum&learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsCoursesCourseBar.html',
                    controller: 'LevelStatisticsCoursesCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/levelStatisticsParents.html',
                    controller: 'LevelStatisticsParentsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{levelName}}'
            }
        })
        .state('teacherStatistics', {
            parent: 'dashboard',
            url: 'teacherStatistics',
            data: {
                roles: ['ROLE_TEACHER'],
                entity: lmsEntity.statistics
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsBar.html',
                    controller: 'TeacherStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/teacherStatistics.html',
                    controller: 'TeacherStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{entity.title}}'
            }
        })
        .state('teacherStatisticsCourse', {
            parent: 'teacherStatistics',
            url: '/:courseId?learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsTeachersCourseBar.html',
                    controller: 'TeacherStatisticsCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/teacherStatisticsCourse.html',
                    controller: 'TeacherStatisticsCourseCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{courseName}}'
            }
        })
        .state('teacherStatisticsCourseStudent', {
            parent: 'teacherStatisticsCourse',
            url: '/:progressId?studentId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_teacherStatisticsCourseStudentBar.html',
                    controller: 'TeacherStatisticsCourseStudentDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/teacherStatisticsCourseStudent.html',
                    controller: 'StudentCourseInfoCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{studentName}}'
            }
        })
        .state('tutorStatistics', {
            parent: 'dashboard',
            url: 'tutorStatistics?learningClassId&courseId',
            data: {
                roles: ['ROLE_TUTOR'],
                entity: lmsEntity.statistics
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsTeachersCourseBar.html',
                    controller: 'TeacherStatisticsCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/tutorStatistics.html',
                    controller: 'TutorStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{entity.title}}'
            }
        })
        .state('tutorStatisticsStudent', {
            parent: 'tutorStatistics',
            url: '/:progressId?studentId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_teacherStatisticsCourseStudentBar.html',
                    controller: 'TeacherStatisticsCourseStudentDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/teacherStatisticsCourseStudent.html',
                    controller: 'StudentCourseInfoCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{studentName}} - {{courseName}}'
            }
        })
        .state('methodologistStatistics', {
            parent: 'dashboard',
            url: 'methodologistStatistics/:schoolId?teacherId',
            data: {
                roles: ['ROLE_METHODOLOGIST'],
                entity: lmsEntity.statistics
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_methodologistStatisticsCourseBar.html',
                    controller: 'MethodologistStatisticsDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/methodologistStatistics.html',
                    controller: 'MethodologistStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{entity.title}}'
            }
        })
        .state('methodologistStatisticsCourse', {
            parent: 'methodologistStatistics',
            url: '/course/:courseId?learningClassId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsCoursesCourseBar.html',
                    controller: 'MethodologistStatisticsCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/methodologistStatisticsCourse.html',
                    controller: 'MethodologistStatisticsCourseCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{courseName}}'
            }
        })
        .state('methodologistStatisticsCourseTopic', {
            parent: 'methodologistStatisticsCourse',
            url: '/topic/:topicId?lessonId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsCoursesCourseBar.html',
                    controller: 'MethodologistStatisticsCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/methodologistStatisticsCourseTopic.html',
                    controller: 'MethodologistStatisticsCourseTopicCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{topicName}}'
            }
        })
        .state('psychologistStatistics', {
            parent: 'dashboard',
            url: 'psychologistStatistics?learningClassId&courseId',
            data: {
                roles: ['ROLE_PSYCHOLOGIST'],
                entity: lmsEntity.statistics
            },
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_levelStatisticsTeachersCourseBar.html',
                    controller: 'TeacherStatisticsCourseDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/psychologistStatistics.html',
                    controller: 'PsychologistStatisticsCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{entity.title}}'
            }
        })
        .state('psychologistStatisticsStudent', {
            parent: 'psychologistStatistics',
            url: '/:progressId?studentId',
            views: {
                'dashBar@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/_teacherStatisticsCourseStudentBar.html',
                    controller: 'TeacherStatisticsCourseStudentDashBarCtrl'
                },
                'dashContent@dashboard': {
                    templateUrl: lmsConfig.modulesPath + 'statistics/views/teacherStatisticsCourseStudent.html',
                    controller: 'StudentCourseInfoCtrl'
                }
            },
            ncyBreadcrumb: {
                label: '{{studentName}} - {{courseName}}'
            }
        });
}]);

'use strict';

angular.module('lmsClientApp')
    .factory('MatrixVariationResource', function ($resource) {
        return $resource('/api/matrix/', {}, {

            getAllStudentsVariationInTopic: {
                method: 'GET',
                url: '/api/matrix/topic/:topicId/group/:groupId/variationForStudents',    
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                },                            
                isArray: true
            },            
            updateUserVariationInTopic: {
                method: 'PUT',
                url: ' /api/matrix/topic/:topicId/user/:userId/variation/:variationId',
            },
            getUniqVariations: {
                method: 'GET',
                url: ' /api/matrix/topic/:topicId',                
                isArray: true
            }
        })
    });

'use strict';

angular.module('lmsClientApp')
    .factory('TerritoryResource', function ($resource, API) {
        var locationApi = API.clientApi + '/locations';
        return $resource('/api/territories/:id', {}, {
            'query': {
                method: 'GET',
                url: locationApi,
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByRegion': {
                method: 'GET',
                url: '/api/territories/region/:id',
                isArray: true
            },
            'getAllByCoordinator': {
                method: 'GET',
                url: '/api/territories/coordinator',
                isArray: true
            }
        });
    });

'use strict';

angular.module('lmsClientApp')
    .factory('UserEventsResource', function ($resource) {
        return $resource('/api/userEvents/:id', {}, {
            'query': {
                method: 'GET',
                url: '/api/userEvents',
                isArray: true,
                params: {
                    'from': '@from',
                    'to': '@to'
                }
            },
            'update': {
                method: 'PUT',
                url: '/api/userEvents'
            },
            'create': {
                method: 'POST',
                url: '/api/userEvents'
            },
            'delete': {
                method: 'DELETE',
                url: '/api/userEvents/:id'
            }
        });
    });

'use strict';

angular.module('lmsClientApp').factory('TestResource', function($resource) {
  return $resource(
    'api/tests/:id',
    {},
    {
      query: { method: 'GET', isArray: true },
      get: {
        method: 'GET',
        transformResponse: function(data) {
          data = angular.fromJson(data);
          return data;
        }
      },
      getByUid: {
        method: 'GET',
        url: '/api/tests/uuid/:uuid'
      },
      update: { method: 'PUT' },
      create: { method: 'POST' },
      getAllFilePathsTest: {
        method: 'GET',
        url: '/api/tests/:id/paths'
        // isArray: true
      }
    }
  );
});

'use strict';

var app = angular.module('lmsClientApp');

app.service('Reports', [
    'lmsConfig',
    '$mdDialog',
    '$q',
    function(lmsConfig, $mdDialog, $q, ReportCtrl) {
        
        this.createStatDialog = createStatDialog;

        function createStatDialog() {
            var dfd = $q.defer();
            $mdDialog
                .show({
                    templateUrl: lmsConfig.modulesPath + 'reports/views/reportsDialog.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    controller: 'ReportCtrl'
                })
            //     .then(
            //         function(answer) {
            //             dfd.resolve(answer);
  
            //         },
            //         function() {
            //             dfd.reject();
            //         }
            //     );
            // return dfd.promise;
        }

}]);
'use strict';

app.controller('ReportCtrl', [
    '$mdDialog',
    '$scope',
    'Groups',
    'Users',
    'ReportsResource',
    'usSpinnerService',
    '$timeout',
    function($mdDialog, $scope, Groups, Users, ReportsResource, usSpinnerService, $timeout) {
        $scope.spinnerReports = false;
        
        $scope.selectedItemGroups = null;
        $scope.selectedItemUsers = null;
        $scope.selectedItemSubjects = null;

        $scope.searchTextGroups = '';
        $scope.searchTextUsers = '';
        $scope.searchTextSubjects = '';

        $scope.groups = [];
        $scope.users = [];
        $scope.schools = [];
        $scope.subjects = [];

        function spinnerShow() {
            $scope.spinnerReports = true;
            $timeout(function () {
                usSpinnerService.spin('spinnerReports');
            }, 0);
        };

        function spinnerHide() {
            $scope.spinnerReports = false;
            $timeout(function () {
                usSpinnerService.stop('spinnerReports');
            }, 100);
        };

        init();

        function init() {
            spinnerShow();
            ReportsResource.getSchools(
                function (response) {
                    spinnerHide();
                    $scope.schools = response
                },
                function(error) {
                    spinnerHide();
                    console.log("error status: " + error.status);
                    console.log("error text: " + error.statusText);
                }
            );
        };

                
        $scope.cancel = function() {
            $mdDialog.cancel();
        };


        $scope.resetSelections1 = function() {
            $scope.selectedItemGroups = null;
            $scope.selectedItemUsers = null;
        };

        function resetAll() {
            $scope.selectedItemGroups = null;
            $scope.selectedItemUsers = null;
            $scope.selectedItemSubjects = null;
    
            $scope.searchTextGroups = '';
            $scope.searchTextUsers = '';
            $scope.searchTextSubjects = '';
    
            $scope.groups = [];
            $scope.users = [];
            $scope.subjects = [];
        }


        $scope.queryGroup = function (input){
            var inputLength = input.length;

            var arr = $scope.groups.filter(function (el){
                return el.name
                       .slice(0,inputLength)
                       .toLocaleLowerCase() === input
                       .slice(0,inputLength)
                       .toLocaleLowerCase()
            });


            return arr;
        };


        $scope.queryUser = function (input){
            var inputLength = input.length;

            var arr = $scope.users.filter(function (el){
                return el.lastName
                       .slice(0,inputLength)
                       .toLocaleLowerCase() === input
                       .slice(0,inputLength)
                       .toLocaleLowerCase()
            });
            return arr;
        }


        $scope.querySubject = function (input){
            var inputLength = input.length;

            var arr = $scope.subjects.filter(function (el){
                return el.name
                       .slice(0,inputLength)
                       .toLocaleLowerCase() === input
                       .slice(0,inputLength)
                       .toLocaleLowerCase()
            });

            return arr;
        }


        $scope.getGroupsAndUsers = function(schoolId) {
            resetAll();

            if (schoolId) {      
                spinnerShow();      
                ReportsResource.getGroupsForSchool(
                    {
                        schoolId: schoolId
                    },
                    function (response) {
                        spinnerHide();
                        $scope.groups = response;
                        
                        for(var i = 0; i < response.length; i++) {
                            $scope.users = $scope.users.concat(response[i].students);
                        }

                        $scope.users = $scope.users.sort(
                            function(user1, user2) {
                                
                                if (user1.lastName !== user2.lastName){
                                    return user1.lastName > user2.lastName ? 1 : -1;
                                }
                    
                                if (user1.firstName !== user2.firstName){
                                    return user1.firstName > user2.firstName ? 1: -1;
                                }
                                
                                if (user1.middleName !== user2.middleName){
                                    return user1.middleName > user2.middleName ? 1 : -1;
                                }                            
                                return 0;
                            }
                        );
                    },
                    function(error) {
                        console.log("error status: " + error.status);
                        console.log("error text: " + error.statusText);
                        spinnerHide();
                    }
                );
            }
        }

        $scope.selectedUserChange = function (user){
            $scope.selectedItemGroups = null;
            $scope.selectedItemUsers = user;

            $scope.subjects = []

            if (user) {
                spinnerShow();
                ReportsResource.getCoursesForStudent(
                    {
                        studentId: user.id
                    },
                    function (response) {
                        spinnerHide();
                        $scope.subjects = response;
                    },
                    function(error) {
                        console.log("error status: " + error.status);
                        console.log("error text: " + error.statusText);
                        spinnerHide();
                    }
                )
            }
        
        };

        $scope.selectedGroupChange = function (group){
            $scope.selectedItemUsers = null;
            $scope.selectedItemGroups = group;
        
            $scope.subjects = []

            if (group) {
                spinnerShow();
                ReportsResource.getCoursesForGroup(
                    {
                        groupId: group.id
                    },
                    function (response) {
                        spinnerHide();
                        $scope.subjects = response;
                    },
                    function(error) {
                        console.log("error status: " + error.status);
                        console.log("error text: " + error.statusText);
                        spinnerHide();
                    }
                )
            }
        
        };


        $scope.createReport = function () {

            var params = {};
            params.course = $scope.selectedItemSubjects ? $scope.selectedItemSubjects.id: "all";
            
            if ($scope.selectedItemGroups) {
                params.groupID = $scope.selectedItemGroups.id;
            }
            else {
                params.studentID = $scope.selectedItemUsers.id;
            }
            
            spinnerShow();
            ReportsResource.getStat(params,function(response, headersGetter) {
                spinnerHide();
                var headers = headersGetter();

                var blob = new Blob([response.data], {type: headers['content-type']});

                var a = document.createElement('a');
                document.body.appendChild(a);
                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = "report.zip";
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            
            },function(error) {
                spinnerHide();
                console.log("error status: " + error.status);
                console.log("error text: " + error.statusText);
            });
        }

    }
])
'use strict';

angular.module('lmsClientApp')
    .factory('ReportsResource', function ($resource) {
        return $resource('/report/journal', {}, {
            'getSchools': {
                method: 'GET',
                url: '/report/journal/school',
                isArray: true
            },

            'getGroupsForSchool': {
                method: 'GET',
                url: '/report/journal/school/:schoolId/allgroups',
                isArray: true
            },

            'getCoursesForStudent': {
                method: 'GET',
                url: '/report/journal/student/:studentId/courses',
                isArray: true
            },

            
            'getCoursesForGroup': {
                method: 'GET',
                url: '/report/journal/group/:groupId/courses',
                isArray: true
            },

            'getStat': {
                method: 'GET',
                url: '/report/journal',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function(data, headersGetter) { 
                    return { 
                        data : data 
                    }
                }
            }

        })
    });
window.LmsProxy = (function(window) {
    var instance;

    return {
        getInstance: function() {
            if (!instance) {
                instance = new LmsProxyInstance();
            }
            return instance;
        }
    };

    function LmsProxyInstance() {
        this.openTask = openTask;
        this.showWiki = showWiki;
        this.openQuizz = openQuizz;
        this.showResource = showResource;
        this.showOlymp = showOlymp;
        this.open1C = open1C;

        var task, quizz;

        function openTask(e, taskId) {
            e.preventDefault();
            if (taskId !== void 0) {
                window.parent.postMessage(
                    {
                        method: 'openTask',
                        params: {
                            id: taskId
                        }
                    },
                    '*'
                );
                task = $.Deferred();
                return task.promise();
            }
        }

        function showWiki(e, url) {
            e.preventDefault();
            if (url !== void 0 && url !== '') {
                url = url.replace(/^(\.\.\/){2}/gim, '');
                callWiki(url);
            }
        }
        function open1C(e, taskId) {
            e.preventDefault();
            if (taskId !== void 0) {
                window.parent.postMessage(
                    {
                        method: 'open1C',
                        params: {
                            id: taskId
                        }
                    },
                    '*'
                );
                task = $.Deferred();
                return task.promise();
            }
        }
        function callWiki(url) {
            window.parent.postMessage(
                {
                    method: 'showWiki',
                    params: {
                        url: url
                    }
                },
                '*'
            );
        }

        function openQuizz(e, quizzId) {
            e.preventDefault();
            if (quizzId !== void 0) {
                window.parent.postMessage(
                    {
                        method: 'openQuizz',
                        params: {
                            id: quizzId
                        }
                    },
                    '*'
                );
                quizz = $.Deferred();
                return quizz.promise();
            }
        }

        function showResource(e, url) {
            e.preventDefault();
            if (url !== void 0 && url !== '') {
                var pathArray = window.location.pathname.split('/');
                var newPathname = '';
                for (var i = 0; i < pathArray.length - 1; i++) {
                    newPathname += pathArray[i];
                    newPathname += '/';
                }
                newPathname = newPathname.replace(
                    /^(.*\/)(web_resources\/.*)/gim,
                    '$2'
                );
                url = newPathname + url;

                callWiki(url);
            }
        }
        function showOlymp(e, url) {
            e.preventDefault();
            if (url !== void 0 && url !== '') {
                callWiki(url);
            }
        }
    }
})(window);

!function(a,b){"undefined"!=typeof module&&module.exports?module.exports=b(require("react"),require("react-dom"),require("angular")):"function"==typeof define&&define.amd?define(["react","react-dom","angular"],function(c,d,angular){return a.ngReact=b(c,d,angular)}):a.ngReact=b(a.React,a.ReactDOM,a.angular)}(this,function(React,a,angular){"use strict";function b(a,b){if(angular.isFunction(a))return a;if(!a)throw new Error("ReactComponent name attribute must be specified");var c;try{c=b.get(a)}catch(d){}if(!c)try{c=a.split(".").reduce(function(a,b){return a[b]},window)}catch(d){}if(!c)throw Error("Cannot find react component "+a);return c}function c(a,b){if(a.wrappedInApply)return a;var c=function(){var c=arguments,d=b.$root.$$phase;return"$apply"===d||"$digest"===d?a.apply(null,c):b.$apply(function(){return a.apply(null,c)})};return c.wrappedInApply=!0,c}function d(a,b,d){return Object.keys(a||{}).reduce(function(e,f){var g=a[f],h=(d||{})[f]||{};return e[f]=angular.isFunction(g)&&h.wrapApply!==!1?c(g,b):g,e},{})}function e(a,b,c,d){var e=angular.isFunction(b.$watchCollection),f=angular.isFunction(b.$watchGroup),g=[];c.forEach(function(c){var h=i(c),j=k(a,c);"collection"===j&&e?b.$watchCollection(h,d):"reference"===j&&f?g.push(h):b.$watch(h,d,"reference"!==j)}),g.length&&b.$watchGroup(g,d)}function f(b,c,d,e){d.$evalAsync(function(){a.render(React.createElement(b,c),e[0])})}function g(a){return Array.isArray(a)?a[0]:a}function h(a){return Array.isArray(a)?a[1]:{}}function i(a){return Array.isArray(a)?a[0]:a}function j(a,b){var c=Object.keys(a).filter(function(a){return a.toLowerCase()===b.toLowerCase()})[0];return a[c]}function k(a,b){var c=Array.isArray(b)&&angular.isObject(b[1])&&b[1].watchDepth;return c||a}var l=function(c){return{restrict:"E",replace:!0,link:function(g,h,i){var j=b(i.name,c),k=function(){var a=g.$eval(i.props),b=d(a,g);f(j,b,g,h)};i.props?e(i.watchDepth,g,[i.props],k):k(),g.$on("$destroy",function(){i.onScopeDestroy?g.$eval(i.onScopeDestroy,{unmountComponent:a.unmountComponentAtNode.bind(this,h[0])}):a.unmountComponentAtNode(h[0])})}}},m=function(c){return function(i,k,l,m){var n={restrict:"E",replace:!0,link:function(l,n,o){var p=b(i,c),q=k||Object.keys(p.propTypes||{});if(!q.length){var r=[];angular.forEach(o.$attr,function(a,b){r.push(b)}),q=r}var s=function(){var a={},b={};q.forEach(function(c){var d=g(c);a[d]=l.$eval(j(o,d)),b[d]=h(c)}),a=d(a,l,b),a=angular.extend({},a,m),f(p,a,l,n)},t=q.map(function(a){return Array.isArray(a)?[o[g(a)],h(a)]:o[a]});e(o.watchDepth,l,t,s),s(),l.$on("$destroy",function(){o.onScopeDestroy?l.$eval(o.onScopeDestroy,{unmountComponent:a.unmountComponentAtNode.bind(this,n[0])}):a.unmountComponentAtNode(n[0])})}};return angular.extend(n,l)}};return angular.module("react",[]).directive("reactComponent",["$injector",l]).factory("reactDirective",["$injector",m])});
"use strict";

app.value('NewVideoConf', window.meoLib.NewVideoConf);
app.value('VideoConfList', window.meoLib.VideoConfList);
app.value('DrawImg', window.meoLib.DrawImg);
